// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AccountingExportExportGcfAccountingData, AccountingExportExportGcfAccountingErrors, AccountingExportExportGcfAccountingResponses, AdminCheckEmailAvailableData, AdminCheckEmailAvailableErrors, AdminCheckEmailAvailableResponses, AdminCompanySecurityExportCompanySecurityAuditData, AdminCompanySecurityExportCompanySecurityAuditErrors, AdminCompanySecurityExportCompanySecurityAuditResponses, AdminCompanySecurityResetCompanySsoSessionsData, AdminCompanySecurityResetCompanySsoSessionsResponses, AdminCompanySsoCheckCompanyDomainVerificationData, AdminCompanySsoCheckCompanyDomainVerificationResponses, AdminCompanySsoConfigureCompanySsoConnectionData, AdminCompanySsoConfigureCompanySsoConnectionErrors, AdminCompanySsoConfigureCompanySsoConnectionResponses, AdminCompanySsoGetCompanySsoConfigData, AdminCompanySsoGetCompanySsoConfigResponses, AdminCompanySsoGetCompanySsoConnectionData, AdminCompanySsoGetCompanySsoConnectionResponses, AdminCompanySsoGetCompanySsoLockReadinessData, AdminCompanySsoGetCompanySsoLockReadinessResponses, AdminCompanySsoGetCompanySsoTestConnectionData, AdminCompanySsoGetCompanySsoTestConnectionErrors, AdminCompanySsoGetCompanySsoTestConnectionResponses, AdminCompanySsoRotateCompanyScimTokenData, AdminCompanySsoRotateCompanyScimTokenResponses, AdminCompanySsoStartCompanyDomainVerificationData, AdminCompanySsoStartCompanyDomainVerificationResponses, AdminCompanySsoStartCompanySsoTestConnectionData, AdminCompanySsoStartCompanySsoTestConnectionErrors, AdminCompanySsoStartCompanySsoTestConnectionResponses, AdminCompanySsoUpdateCompanyScimSettingsData, AdminCompanySsoUpdateCompanyScimSettingsErrors, AdminCompanySsoUpdateCompanyScimSettingsResponses, AdminCompanySsoUpdateCompanySsoPolicyData, AdminCompanySsoUpdateCompanySsoPolicyErrors, AdminCompanySsoUpdateCompanySsoPolicyResponses, AiGivingGetMyAiGivingLimitData, AiGivingGetMyAiGivingLimitResponses, AiGivingSetMyAiGivingLimitData, AiGivingSetMyAiGivingLimitErrors, AiGivingSetMyAiGivingLimitResponses, ApiCreatePaymentSessionFromUrlData, ApiCreatePaymentSessionFromUrlErrors, ApiCreatePaymentSessionFromUrlResponses, ApiTestFlightData, ApiTestFlightResponses, AppGetMinimumVersionData, AppGetMinimumVersionErrors, AppGetMinimumVersionResponses, AssistantCancelAssistantTurnData, AssistantCancelAssistantTurnErrors, AssistantCancelAssistantTurnResponses, AssistantConfirmAssistantEscalationData, AssistantConfirmAssistantEscalationErrors, AssistantConfirmAssistantEscalationResponses, AssistantCreateAssistantConversationData, AssistantCreateAssistantConversationErrors, AssistantCreateAssistantConversationResponses, AssistantDeleteAssistantConversationData, AssistantDeleteAssistantConversationErrors, AssistantDeleteAssistantConversationResponses, AssistantGetAssistantConfigData, AssistantGetAssistantConfigResponses, AssistantGetAssistantConsentData, AssistantGetAssistantConsentResponses, AssistantGetAssistantConversationData, AssistantGetAssistantConversationErrors, AssistantGetAssistantConversationResponses, AssistantGetAssistantEscalationAdminData, AssistantGetAssistantEscalationAdminErrors, AssistantGetAssistantEscalationAdminResponses, AssistantGetAssistantSuperadminConfigData, AssistantGetAssistantSuperadminConfigResponses, AssistantGetAssistantUsageAdminData, AssistantGetAssistantUsageAdminErrors, AssistantGetAssistantUsageAdminResponses, AssistantListAssistantConversationsData, AssistantListAssistantConversationsErrors, AssistantListAssistantConversationsResponses, AssistantListAssistantEscalationsAdminData, AssistantListAssistantEscalationsAdminErrors, AssistantListAssistantEscalationsAdminResponses, AssistantListAssistantFeedbackAdminData, AssistantListAssistantFeedbackAdminErrors, AssistantListAssistantFeedbackAdminResponses, AssistantListAssistantTurnEventsAdminData, AssistantListAssistantTurnEventsAdminErrors, AssistantListAssistantTurnEventsAdminResponses, AssistantListAssistantTurnsAdminData, AssistantListAssistantTurnsAdminErrors, AssistantListAssistantTurnsAdminResponses, AssistantListAssistantTurnToolCallsAdminData, AssistantListAssistantTurnToolCallsAdminErrors, AssistantListAssistantTurnToolCallsAdminResponses, AssistantProposeAssistantEscalationData, AssistantProposeAssistantEscalationErrors, AssistantProposeAssistantEscalationResponses, AssistantRecordAssistantConsentData, AssistantRecordAssistantConsentErrors, AssistantRecordAssistantConsentResponses, AssistantResolveAssistantEscalationAdminData, AssistantResolveAssistantEscalationAdminErrors, AssistantResolveAssistantEscalationAdminResponses, AssistantSendAssistantMessageData, AssistantSendAssistantMessageErrors, AssistantSendAssistantMessageResponses, AssistantStreamAssistantTurnData, AssistantStreamAssistantTurnErrors, AssistantStreamAssistantTurnResponses, AssistantSubmitAssistantFeedbackData, AssistantSubmitAssistantFeedbackErrors, AssistantSubmitAssistantFeedbackResponses, AssistantUpdateAssistantSuperadminConfigData, AssistantUpdateAssistantSuperadminConfigErrors, AssistantUpdateAssistantSuperadminConfigResponses, BirthdayGiftsCancelBirthdayGiftData, BirthdayGiftsCancelBirthdayGiftErrors, BirthdayGiftsCancelBirthdayGiftResponses, BirthdayGiftsCreateBirthdayGiftData, BirthdayGiftsCreateBirthdayGiftErrors, BirthdayGiftsCreateBirthdayGiftResponses, BirthdayGiftsGetBirthdayGiftData, BirthdayGiftsGetBirthdayGiftErrors, BirthdayGiftsGetBirthdayGiftResponses, BirthdayGiftsListBirthdayGiftsData, BirthdayGiftsListBirthdayGiftsResponses, BirthdayGiftsUpdateBirthdayGiftData, BirthdayGiftsUpdateBirthdayGiftErrors, BirthdayGiftsUpdateBirthdayGiftResponses, BoardDirectorAcknowledgeBoardRecordData, BoardDirectorAcknowledgeBoardRecordErrors, BoardDirectorAcknowledgeBoardRecordResponses, BoardDirectorCreateBoardDirectorAnnotationData, BoardDirectorCreateBoardDirectorAnnotationErrors, BoardDirectorCreateBoardDirectorAnnotationResponses, BoardDirectorDeleteBoardDirectorAnnotationData, BoardDirectorDeleteBoardDirectorAnnotationErrors, BoardDirectorDeleteBoardDirectorAnnotationResponses, BoardDirectorGetBoardAboutData, BoardDirectorGetBoardAboutErrors, BoardDirectorGetBoardAboutResponses, BoardDirectorGetBoardCompensationDocumentDownloadForDirectorData, BoardDirectorGetBoardCompensationDocumentDownloadForDirectorErrors, BoardDirectorGetBoardCompensationDocumentDownloadForDirectorResponses, BoardDirectorGetBoardDirectorAttentionCompletedData, BoardDirectorGetBoardDirectorAttentionCompletedErrors, BoardDirectorGetBoardDirectorAttentionCompletedResponses, BoardDirectorGetBoardDirectorAttentionData, BoardDirectorGetBoardDirectorAttentionErrors, BoardDirectorGetBoardDirectorAttentionResponses, BoardDirectorGetBoardDirectorConsentData, BoardDirectorGetBoardDirectorConsentErrors, BoardDirectorGetBoardDirectorConsentResponses, BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlData, BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlErrors, BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlResponses, BoardDirectorGetBoardDirectorMeData, BoardDirectorGetBoardDirectorMeetingCalendarData, BoardDirectorGetBoardDirectorMeetingCalendarErrors, BoardDirectorGetBoardDirectorMeetingCalendarResponses, BoardDirectorGetBoardDirectorMeetingData, BoardDirectorGetBoardDirectorMeetingErrors, BoardDirectorGetBoardDirectorMeetingRecordData, BoardDirectorGetBoardDirectorMeetingRecordErrors, BoardDirectorGetBoardDirectorMeetingRecordResponses, BoardDirectorGetBoardDirectorMeetingResponses, BoardDirectorGetBoardDirectorMeResponses, BoardDirectorGetBoardDirectorPacketData, BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlData, BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlErrors, BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlResponses, BoardDirectorGetBoardDirectorPacketErrors, BoardDirectorGetBoardDirectorPacketResponses, BoardDirectorGetBoardDirectorRecordData, BoardDirectorGetBoardDirectorRecordErrors, BoardDirectorGetBoardDirectorRecordResponses, BoardDirectorGetBoardReturnCopyForDirectorData, BoardDirectorGetBoardReturnCopyForDirectorErrors, BoardDirectorGetBoardReturnCopyForDirectorResponses, BoardDirectorGetBoardSelfAssessmentResultsForDirectorData, BoardDirectorGetBoardSelfAssessmentResultsForDirectorErrors, BoardDirectorGetBoardSelfAssessmentResultsForDirectorResponses, BoardDirectorGetOwnBoardCoiQuestionnaireData, BoardDirectorGetOwnBoardCoiQuestionnaireErrors, BoardDirectorGetOwnBoardCoiQuestionnaireResponses, BoardDirectorGetOwnBoardCoiResponseChangesData, BoardDirectorGetOwnBoardCoiResponseChangesErrors, BoardDirectorGetOwnBoardCoiResponseChangesResponses, BoardDirectorGetOwnBoardCoiResponseData, BoardDirectorGetOwnBoardCoiResponseDocumentData, BoardDirectorGetOwnBoardCoiResponseDocumentErrors, BoardDirectorGetOwnBoardCoiResponseDocumentResponses, BoardDirectorGetOwnBoardCoiResponseErrors, BoardDirectorGetOwnBoardCoiResponseResponses, BoardDirectorGetOwnBoardGettingStartedData, BoardDirectorGetOwnBoardGettingStartedErrors, BoardDirectorGetOwnBoardGettingStartedResponses, BoardDirectorGetOwnBoardSelfAssessmentQuestionsData, BoardDirectorGetOwnBoardSelfAssessmentQuestionsErrors, BoardDirectorGetOwnBoardSelfAssessmentQuestionsResponses, BoardDirectorListBoardDirectorAnnotationsData, BoardDirectorListBoardDirectorAnnotationsErrors, BoardDirectorListBoardDirectorAnnotationsResponses, BoardDirectorListBoardDirectorConsentsData, BoardDirectorListBoardDirectorConsentsErrors, BoardDirectorListBoardDirectorConsentsResponses, BoardDirectorListBoardDirectorMeetingsData, BoardDirectorListBoardDirectorMeetingsErrors, BoardDirectorListBoardDirectorMeetingsResponses, BoardDirectorListBoardDirectorRecordsData, BoardDirectorListBoardDirectorRecordsErrors, BoardDirectorListBoardDirectorRecordsResponses, BoardDirectorListBoardDirectorUpcomingMeetingsData, BoardDirectorListBoardDirectorUpcomingMeetingsResponses, BoardDirectorListOwnBoardCoiCyclesData, BoardDirectorListOwnBoardCoiCyclesErrors, BoardDirectorListOwnBoardCoiCyclesResponses, BoardDirectorListOwnBoardConflictDisclosuresData, BoardDirectorListOwnBoardConflictDisclosuresErrors, BoardDirectorListOwnBoardConflictDisclosuresResponses, BoardDirectorListOwnBoardSelfAssessmentsData, BoardDirectorListOwnBoardSelfAssessmentsErrors, BoardDirectorListOwnBoardSelfAssessmentsResponses, BoardDirectorMarkOwnBoardGettingStartedStepData, BoardDirectorMarkOwnBoardGettingStartedStepErrors, BoardDirectorMarkOwnBoardGettingStartedStepResponses, BoardDirectorOpenBoardReturnCopyForDirectorData, BoardDirectorOpenBoardReturnCopyForDirectorErrors, BoardDirectorOpenBoardReturnCopyForDirectorResponses, BoardDirectorOrgAcknowledgeBoardRecordData, BoardDirectorOrgAcknowledgeBoardRecordErrors, BoardDirectorOrgAcknowledgeBoardRecordResponses, BoardDirectorOrgClaimBoardSeatData, BoardDirectorOrgClaimBoardSeatErrors, BoardDirectorOrgClaimBoardSeatResponses, BoardDirectorOrgCompleteBoardSeatMoveData, BoardDirectorOrgCompleteBoardSeatMoveErrors, BoardDirectorOrgCompleteBoardSeatMoveResponses, BoardDirectorOrgCreateBoardDirectorAnnotationData, BoardDirectorOrgCreateBoardDirectorAnnotationErrors, BoardDirectorOrgCreateBoardDirectorAnnotationResponses, BoardDirectorOrgDeleteBoardDirectorAnnotationData, BoardDirectorOrgDeleteBoardDirectorAnnotationErrors, BoardDirectorOrgDeleteBoardDirectorAnnotationResponses, BoardDirectorOrgGetBoardAboutData, BoardDirectorOrgGetBoardAboutErrors, BoardDirectorOrgGetBoardAboutResponses, BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorData, BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorErrors, BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorResponses, BoardDirectorOrgGetBoardDirectorAttentionCompletedData, BoardDirectorOrgGetBoardDirectorAttentionCompletedErrors, BoardDirectorOrgGetBoardDirectorAttentionCompletedResponses, BoardDirectorOrgGetBoardDirectorAttentionData, BoardDirectorOrgGetBoardDirectorAttentionErrors, BoardDirectorOrgGetBoardDirectorAttentionResponses, BoardDirectorOrgGetBoardDirectorConsentData, BoardDirectorOrgGetBoardDirectorConsentErrors, BoardDirectorOrgGetBoardDirectorConsentResponses, BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlData, BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlErrors, BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlResponses, BoardDirectorOrgGetBoardDirectorMeData, BoardDirectorOrgGetBoardDirectorMeetingCalendarData, BoardDirectorOrgGetBoardDirectorMeetingCalendarErrors, BoardDirectorOrgGetBoardDirectorMeetingCalendarResponses, BoardDirectorOrgGetBoardDirectorMeetingData, BoardDirectorOrgGetBoardDirectorMeetingErrors, BoardDirectorOrgGetBoardDirectorMeetingRecordData, BoardDirectorOrgGetBoardDirectorMeetingRecordErrors, BoardDirectorOrgGetBoardDirectorMeetingRecordResponses, BoardDirectorOrgGetBoardDirectorMeetingResponses, BoardDirectorOrgGetBoardDirectorMeResponses, BoardDirectorOrgGetBoardDirectorPacketData, BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlData, BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlErrors, BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlResponses, BoardDirectorOrgGetBoardDirectorPacketErrors, BoardDirectorOrgGetBoardDirectorPacketResponses, BoardDirectorOrgGetBoardDirectorRecordData, BoardDirectorOrgGetBoardDirectorRecordErrors, BoardDirectorOrgGetBoardDirectorRecordResponses, BoardDirectorOrgGetBoardReturnCopyForDirectorData, BoardDirectorOrgGetBoardReturnCopyForDirectorErrors, BoardDirectorOrgGetBoardReturnCopyForDirectorResponses, BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorData, BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorErrors, BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorResponses, BoardDirectorOrgGetOwnBoardCoiQuestionnaireData, BoardDirectorOrgGetOwnBoardCoiQuestionnaireErrors, BoardDirectorOrgGetOwnBoardCoiQuestionnaireResponses, BoardDirectorOrgGetOwnBoardCoiResponseChangesData, BoardDirectorOrgGetOwnBoardCoiResponseChangesErrors, BoardDirectorOrgGetOwnBoardCoiResponseChangesResponses, BoardDirectorOrgGetOwnBoardCoiResponseData, BoardDirectorOrgGetOwnBoardCoiResponseDocumentData, BoardDirectorOrgGetOwnBoardCoiResponseDocumentErrors, BoardDirectorOrgGetOwnBoardCoiResponseDocumentResponses, BoardDirectorOrgGetOwnBoardCoiResponseErrors, BoardDirectorOrgGetOwnBoardCoiResponseResponses, BoardDirectorOrgGetOwnBoardGettingStartedData, BoardDirectorOrgGetOwnBoardGettingStartedErrors, BoardDirectorOrgGetOwnBoardGettingStartedResponses, BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsData, BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsErrors, BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsResponses, BoardDirectorOrgListBoardDirectorAnnotationsData, BoardDirectorOrgListBoardDirectorAnnotationsErrors, BoardDirectorOrgListBoardDirectorAnnotationsResponses, BoardDirectorOrgListBoardDirectorConsentsData, BoardDirectorOrgListBoardDirectorConsentsErrors, BoardDirectorOrgListBoardDirectorConsentsResponses, BoardDirectorOrgListBoardDirectorMeetingsData, BoardDirectorOrgListBoardDirectorMeetingsErrors, BoardDirectorOrgListBoardDirectorMeetingsResponses, BoardDirectorOrgListBoardDirectorRecordsData, BoardDirectorOrgListBoardDirectorRecordsErrors, BoardDirectorOrgListBoardDirectorRecordsResponses, BoardDirectorOrgListBoardDirectorUpcomingMeetingsData, BoardDirectorOrgListBoardDirectorUpcomingMeetingsResponses, BoardDirectorOrgListOwnBoardCoiCyclesData, BoardDirectorOrgListOwnBoardCoiCyclesErrors, BoardDirectorOrgListOwnBoardCoiCyclesResponses, BoardDirectorOrgListOwnBoardConflictDisclosuresData, BoardDirectorOrgListOwnBoardConflictDisclosuresErrors, BoardDirectorOrgListOwnBoardConflictDisclosuresResponses, BoardDirectorOrgListOwnBoardSelfAssessmentsData, BoardDirectorOrgListOwnBoardSelfAssessmentsErrors, BoardDirectorOrgListOwnBoardSelfAssessmentsResponses, BoardDirectorOrgMarkOwnBoardGettingStartedStepData, BoardDirectorOrgMarkOwnBoardGettingStartedStepErrors, BoardDirectorOrgMarkOwnBoardGettingStartedStepResponses, BoardDirectorOrgOpenBoardReturnCopyForDirectorData, BoardDirectorOrgOpenBoardReturnCopyForDirectorErrors, BoardDirectorOrgOpenBoardReturnCopyForDirectorResponses, BoardDirectorOrgPreviewBoardInvitationData, BoardDirectorOrgPreviewBoardInvitationErrors, BoardDirectorOrgPreviewBoardInvitationResponses, BoardDirectorOrgPreviewBoardSeatMoveData, BoardDirectorOrgPreviewBoardSeatMoveErrors, BoardDirectorOrgPreviewBoardSeatMoveResponses, BoardDirectorOrgRecordBoardDirectorAttendanceIntentData, BoardDirectorOrgRecordBoardDirectorAttendanceIntentErrors, BoardDirectorOrgRecordBoardDirectorAttendanceIntentResponses, BoardDirectorOrgRecordOwnBoardConflictDisclosureData, BoardDirectorOrgRecordOwnBoardConflictDisclosureErrors, BoardDirectorOrgRecordOwnBoardConflictDisclosureResponses, BoardDirectorOrgRequestBoardSeatClaimCodeData, BoardDirectorOrgRequestBoardSeatClaimCodeErrors, BoardDirectorOrgRequestBoardSeatClaimCodeResponses, BoardDirectorOrgRequestBoardSeatMoveCodeData, BoardDirectorOrgRequestBoardSeatMoveCodeErrors, BoardDirectorOrgRequestBoardSeatMoveCodeResponses, BoardDirectorOrgRevokeBoardWrittenConsentSignatureData, BoardDirectorOrgRevokeBoardWrittenConsentSignatureErrors, BoardDirectorOrgRevokeBoardWrittenConsentSignatureResponses, BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersData, BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersErrors, BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersResponses, BoardDirectorOrgSignBoardMinutesData, BoardDirectorOrgSignBoardMinutesErrors, BoardDirectorOrgSignBoardMinutesResponses, BoardDirectorOrgSignBoardMinutesToApproveData, BoardDirectorOrgSignBoardMinutesToApproveErrors, BoardDirectorOrgSignBoardMinutesToApproveResponses, BoardDirectorOrgSignBoardWrittenConsentData, BoardDirectorOrgSignBoardWrittenConsentErrors, BoardDirectorOrgSignBoardWrittenConsentResponses, BoardDirectorOrgStartBoardSeatMoveData, BoardDirectorOrgStartBoardSeatMoveErrors, BoardDirectorOrgStartBoardSeatMoveResponses, BoardDirectorOrgSubmitOwnBoardCoiResponseData, BoardDirectorOrgSubmitOwnBoardCoiResponseErrors, BoardDirectorOrgSubmitOwnBoardCoiResponseResponses, BoardDirectorRecordBoardDirectorAttendanceIntentData, BoardDirectorRecordBoardDirectorAttendanceIntentErrors, BoardDirectorRecordBoardDirectorAttendanceIntentResponses, BoardDirectorRecordOwnBoardConflictDisclosureData, BoardDirectorRecordOwnBoardConflictDisclosureErrors, BoardDirectorRecordOwnBoardConflictDisclosureResponses, BoardDirectorRevokeBoardWrittenConsentSignatureData, BoardDirectorRevokeBoardWrittenConsentSignatureErrors, BoardDirectorRevokeBoardWrittenConsentSignatureResponses, BoardDirectorSaveOwnBoardSelfAssessmentAnswersData, BoardDirectorSaveOwnBoardSelfAssessmentAnswersErrors, BoardDirectorSaveOwnBoardSelfAssessmentAnswersResponses, BoardDirectorSignBoardMinutesData, BoardDirectorSignBoardMinutesErrors, BoardDirectorSignBoardMinutesResponses, BoardDirectorSignBoardMinutesToApproveData, BoardDirectorSignBoardMinutesToApproveErrors, BoardDirectorSignBoardMinutesToApproveResponses, BoardDirectorSignBoardWrittenConsentData, BoardDirectorSignBoardWrittenConsentErrors, BoardDirectorSignBoardWrittenConsentResponses, BoardDirectorStartBoardSeatMoveData, BoardDirectorStartBoardSeatMoveErrors, BoardDirectorStartBoardSeatMoveResponses, BoardDirectorSubmitOwnBoardCoiResponseData, BoardDirectorSubmitOwnBoardCoiResponseErrors, BoardDirectorSubmitOwnBoardCoiResponseResponses, BooksActivateBooksData, BooksActivateBooksErrors, BooksActivateBooksResponses, BooksGetBooksData, BooksGetBooksErrors, BooksGetBooksResponses, CampaignsAcceptCampaignLayerInviteData, CampaignsAcceptCampaignLayerInviteErrors, CampaignsAcceptCampaignLayerInviteResponses, CampaignsApproveCampaignJoinRequestData, CampaignsApproveCampaignJoinRequestErrors, CampaignsApproveCampaignJoinRequestResponses, CampaignsApproveCampaignLayerRequestData, CampaignsApproveCampaignLayerRequestErrors, CampaignsApproveCampaignLayerRequestResponses, CampaignsAttachCampaignLayerData, CampaignsAttachCampaignLayerErrors, CampaignsAttachCampaignLayerResponses, CampaignsCreateCampaignJoinInviteData, CampaignsCreateCampaignJoinInviteErrors, CampaignsCreateCampaignJoinInviteResponses, CampaignsCreateCampaignTeamData, CampaignsCreateCampaignTeamErrors, CampaignsCreateCampaignTeamResponses, CampaignsDeclineCampaignJoinRequestData, CampaignsDeclineCampaignJoinRequestErrors, CampaignsDeclineCampaignJoinRequestResponses, CampaignsDeclineCampaignLayerInviteData, CampaignsDeclineCampaignLayerInviteErrors, CampaignsDeclineCampaignLayerInviteResponses, CampaignsDeclineCampaignLayerRequestData, CampaignsDeclineCampaignLayerRequestErrors, CampaignsDeclineCampaignLayerRequestResponses, CampaignsEnableCampaignData, CampaignsEnableCampaignErrors, CampaignsEnableCampaignResponses, CampaignsGetCampaignLayerParentData, CampaignsGetCampaignLayerParentErrors, CampaignsGetCampaignLayerParentResponses, CampaignsGetCampaignLayerStructureData, CampaignsGetCampaignLayerStructureErrors, CampaignsGetCampaignLayerStructureResponses, CampaignsGetCampaignOverviewData, CampaignsGetCampaignOverviewErrors, CampaignsGetCampaignOverviewResponses, CampaignsGetOwnCampaignLayerRequestData, CampaignsGetOwnCampaignLayerRequestErrors, CampaignsGetOwnCampaignLayerRequestResponses, CampaignsJoinCampaignParentData, CampaignsJoinCampaignParentErrors, CampaignsJoinCampaignParentResponses, CampaignsLeaveCampaignLayerData, CampaignsLeaveCampaignLayerErrors, CampaignsLeaveCampaignLayerResponses, CampaignsListCampaignJoinInvitesData, CampaignsListCampaignJoinInvitesErrors, CampaignsListCampaignJoinInvitesResponses, CampaignsListCampaignJoinRequestsData, CampaignsListCampaignJoinRequestsErrors, CampaignsListCampaignJoinRequestsResponses, CampaignsListCampaignLayerBoardData, CampaignsListCampaignLayerBoardErrors, CampaignsListCampaignLayerBoardResponses, CampaignsListCampaignLayerCandidatesData, CampaignsListCampaignLayerCandidatesErrors, CampaignsListCampaignLayerCandidatesResponses, CampaignsListCampaignLayerRequestsData, CampaignsListCampaignLayerRequestsErrors, CampaignsListCampaignLayerRequestsResponses, CampaignsListCampaignLayersData, CampaignsListCampaignLayersErrors, CampaignsListCampaignLayersResponses, CampaignsListCampaignScheduleData, CampaignsListCampaignScheduleErrors, CampaignsListCampaignScheduleResponses, CampaignsListCampaignStructureLayersData, CampaignsListCampaignStructureLayersErrors, CampaignsListCampaignStructureLayersResponses, CampaignsListReceivedCampaignLayerInvitesData, CampaignsListReceivedCampaignLayerInvitesErrors, CampaignsListReceivedCampaignLayerInvitesResponses, CampaignsListSentCampaignLayerInvitesData, CampaignsListSentCampaignLayerInvitesErrors, CampaignsListSentCampaignLayerInvitesResponses, CampaignsMoveCampaignLayerData, CampaignsMoveCampaignLayerErrors, CampaignsMoveCampaignLayerResponses, CampaignsPreviewCampaignJoinParentData, CampaignsPreviewCampaignJoinParentErrors, CampaignsPreviewCampaignJoinParentResponses, CampaignsRemoveCampaignLayerData, CampaignsRemoveCampaignLayerErrors, CampaignsRemoveCampaignLayerResponses, CampaignsRevokeCampaignJoinInviteData, CampaignsRevokeCampaignJoinInviteErrors, CampaignsRevokeCampaignJoinInviteResponses, CampaignsRevokeCampaignLayerInviteData, CampaignsRevokeCampaignLayerInviteErrors, CampaignsRevokeCampaignLayerInviteResponses, CampaignsSendCampaignLayerInviteData, CampaignsSendCampaignLayerInviteErrors, CampaignsSendCampaignLayerInviteResponses, CampaignsSetUpCampaignSeasonData, CampaignsSetUpCampaignSeasonErrors, CampaignsSetUpCampaignSeasonResponses, CampaignsUpdateCampaignData, CampaignsUpdateCampaignErrors, CampaignsUpdateCampaignResponses, CampaignsUpdateCampaignSupporterData, CampaignsUpdateCampaignSupporterErrors, CampaignsUpdateCampaignSupporterResponses, CampaignsUpdateCampaignTeamData, CampaignsUpdateCampaignTeamErrors, CampaignsUpdateCampaignTeamResponses, CampaignsWithdrawCampaignLayerRequestData, CampaignsWithdrawCampaignLayerRequestErrors, CampaignsWithdrawCampaignLayerRequestResponses, CauseTagsCreateCauseTagData, CauseTagsCreateCauseTagErrors, CauseTagsCreateCauseTagResponses, CauseTagsDeleteCauseTagData, CauseTagsDeleteCauseTagErrors, CauseTagsDeleteCauseTagResponses, CauseTagsGetAllCauseTagsData, CauseTagsGetAllCauseTagsResponses, CauseTagsUpdateCauseTagData, CauseTagsUpdateCauseTagErrors, CauseTagsUpdateCauseTagResponses, CelebrityCharitiesCreateCelebrityCharityData, CelebrityCharitiesCreateCelebrityCharityErrors, CelebrityCharitiesCreateCelebrityCharityResponses, CelebrityCharitiesDeleteCelebrityCharityData, CelebrityCharitiesDeleteCelebrityCharityErrors, CelebrityCharitiesDeleteCelebrityCharityResponses, CelebrityCharitiesGetCelebrityCharitiesData, CelebrityCharitiesGetCelebrityCharitiesErrors, CelebrityCharitiesGetCelebrityCharitiesResponses, CelebrityCharitiesGetCelebrityCharityData, CelebrityCharitiesGetCelebrityCharityErrors, CelebrityCharitiesGetCelebrityCharityResponses, CelebrityCharitiesUpdateCelebrityCharityData, CelebrityCharitiesUpdateCelebrityCharityErrors, CelebrityCharitiesUpdateCelebrityCharityResponses, CelebrityCharitiesUploadCelebrityCharityPosterData, CelebrityCharitiesUploadCelebrityCharityPosterErrors, CelebrityCharitiesUploadCelebrityCharityPosterResponses, ChampionsResolveChampionLandingData, ChampionsResolveChampionLandingErrors, ChampionsResolveChampionLandingResponses, ChampionsResolveChampionNativeData, ChampionsResolveChampionNativeErrors, ChampionsResolveChampionNativeResponses, CharitiesAddCauseTagToCharityData, CharitiesAddCauseTagToCharityErrors, CharitiesAddCauseTagToCharityResponses, CharitiesCreateCharityData, CharitiesCreateCharityErrors, CharitiesCreateCharityResponses, CharitiesGetCauseTagsForCharityData, CharitiesGetCauseTagsForCharityErrors, CharitiesGetCauseTagsForCharityResponses, CharitiesGetCharitiesByCauseTagData, CharitiesGetCharitiesByCauseTagErrors, CharitiesGetCharitiesByCauseTagResponses, CharitiesGetCharitiesData, CharitiesGetCharitiesErrors, CharitiesGetCharitiesResponses, CharitiesGetCharityData, CharitiesGetCharityDomainCoverageData, CharitiesGetCharityDomainCoverageResponses, CharitiesGetCharityErrors, CharitiesGetCharityResponses, CharitiesGetFollowsChampionedCharitiesData, CharitiesGetFollowsChampionedCharitiesErrors, CharitiesGetFollowsChampionedCharitiesResponses, CharitiesGetFollowsDonatedCharitiesData, CharitiesGetFollowsDonatedCharitiesErrors, CharitiesGetFollowsDonatedCharitiesResponses, CharitiesGetSuggestedCharitiesData, CharitiesGetSuggestedCharitiesResponses, CharitiesLookupCharityByDomainData, CharitiesLookupCharityByDomainErrors, CharitiesLookupCharityByDomainResponses, CharitiesRemoveCauseTagFromCharityData, CharitiesRemoveCauseTagFromCharityErrors, CharitiesRemoveCauseTagFromCharityResponses, CharitiesUpdateCharityData, CharitiesUpdateCharityErrors, CharitiesUpdateCharityResponses, CharitiesUploadCharityProfilePictureData, CharitiesUploadCharityProfilePictureErrors, CharitiesUploadCharityProfilePictureResponses, CharityAdminAcceptCharityInviteData, CharityAdminAcceptCharityInviteErrors, CharityAdminAcceptCharityInviteResponses, CharityAdminAcceptCharityTermsData, CharityAdminAcceptCharityTermsErrors, CharityAdminAcceptCharityTermsResponses, CharityAdminAddCharityAdminData, CharityAdminAddCharityAdminErrors, CharityAdminAddCharityAdminResponses, CharityAdminAddCrmDonorTagData, CharityAdminAddCrmDonorTagErrors, CharityAdminAddCrmDonorTagResponses, CharityAdminClearCharityDisplayNameData, CharityAdminClearCharityDisplayNameErrors, CharityAdminClearCharityDisplayNameResponses, CharityAdminConfirmVerificationUploadData, CharityAdminConfirmVerificationUploadErrors, CharityAdminConfirmVerificationUploadResponses, CharityAdminCreateCharityInviteData, CharityAdminCreateCharityInviteErrors, CharityAdminCreateCharityInviteResponses, CharityAdminCreateCrmDonorNoteData, CharityAdminCreateCrmDonorNoteErrors, CharityAdminCreateCrmDonorNoteResponses, CharityAdminCreateCrmImportedContactData, CharityAdminCreateCrmImportedContactErrors, CharityAdminCreateCrmImportedContactResponses, CharityAdminDeleteCrmDonorNoteData, CharityAdminDeleteCrmDonorNoteErrors, CharityAdminDeleteCrmDonorNoteResponses, CharityAdminDeleteCrmImportedContactData, CharityAdminDeleteCrmImportedContactErrors, CharityAdminDeleteCrmImportedContactResponses, CharityAdminElectCharityCheckData, CharityAdminElectCharityCheckErrors, CharityAdminElectCharityCheckResponses, CharityAdminExportCrmAnalyticsCsvData, CharityAdminExportCrmAnalyticsCsvErrors, CharityAdminExportCrmAnalyticsCsvResponses, CharityAdminExportCrmDonorsCsvData, CharityAdminExportCrmDonorsCsvErrors, CharityAdminExportCrmDonorsCsvResponses, CharityAdminExportCrmImportedContactsCsvData, CharityAdminExportCrmImportedContactsCsvErrors, CharityAdminExportCrmImportedContactsCsvResponses, CharityAdminExportSection321StatementWorkbookData, CharityAdminExportSection321StatementWorkbookErrors, CharityAdminExportSection321StatementWorkbookResponses, CharityAdminGetCharityCheckAddressData, CharityAdminGetCharityCheckAddressErrors, CharityAdminGetCharityCheckAddressResponses, CharityAdminGetCharityFollowerCountData, CharityAdminGetCharityFollowerCountErrors, CharityAdminGetCharityFollowerCountResponses, CharityAdminGetCharityPaymentProfileData, CharityAdminGetCharityPaymentProfileErrors, CharityAdminGetCharityPaymentProfileResponses, CharityAdminGetCharityProfileData, CharityAdminGetCharityProfileErrors, CharityAdminGetCharityProfileResponses, CharityAdminGetCharityTermsAcceptanceStateData, CharityAdminGetCharityTermsAcceptanceStateErrors, CharityAdminGetCharityTermsAcceptanceStateResponses, CharityAdminGetCharityTermsData, CharityAdminGetCharityTermsErrors, CharityAdminGetCharityTermsForClaimData, CharityAdminGetCharityTermsForClaimErrors, CharityAdminGetCharityTermsForClaimResponses, CharityAdminGetCharityTermsResponses, CharityAdminGetCrmAnalyticsSummaryData, CharityAdminGetCrmAnalyticsSummaryErrors, CharityAdminGetCrmAnalyticsSummaryResponses, CharityAdminGetCrmDonorData, CharityAdminGetCrmDonorErrors, CharityAdminGetCrmDonorResponses, CharityAdminGetCrmRetentionData, CharityAdminGetCrmRetentionErrors, CharityAdminGetCrmRetentionResponses, CharityAdminGetSection321ConsentingDonorsData, CharityAdminGetSection321ConsentingDonorsErrors, CharityAdminGetSection321ConsentingDonorsResponses, CharityAdminGetSection321DashboardData, CharityAdminGetSection321DashboardErrors, CharityAdminGetSection321DashboardResponses, CharityAdminGetSection321FundraiserDetailData, CharityAdminGetSection321FundraiserDetailErrors, CharityAdminGetSection321FundraiserDetailResponses, CharityAdminGetSection321GrantDetailData, CharityAdminGetSection321GrantDetailErrors, CharityAdminGetSection321GrantDetailResponses, CharityAdminGetSection321StatementData, CharityAdminGetSection321StatementErrors, CharityAdminGetSection321StatementResponses, CharityAdminListCharityAdminsData, CharityAdminListCharityAdminsErrors, CharityAdminListCharityAdminsResponses, CharityAdminListCharityInvitesData, CharityAdminListCharityInvitesErrors, CharityAdminListCharityInvitesResponses, CharityAdminListCharityPaymentEventsData, CharityAdminListCharityPaymentEventsErrors, CharityAdminListCharityPaymentEventsResponses, CharityAdminListCharityRemovalRequestsData, CharityAdminListCharityRemovalRequestsErrors, CharityAdminListCharityRemovalRequestsResponses, CharityAdminListCrmDonorsData, CharityAdminListCrmDonorsErrors, CharityAdminListCrmDonorsResponses, CharityAdminListCrmImportedContactsData, CharityAdminListCrmImportedContactsErrors, CharityAdminListCrmImportedContactsResponses, CharityAdminListMyCharityClaimsData, CharityAdminListMyCharityClaimsResponses, CharityAdminListMyMembershipsData, CharityAdminListMyMembershipsResponses, CharityAdminListMyVerificationDocumentsData, CharityAdminListMyVerificationDocumentsErrors, CharityAdminListMyVerificationDocumentsResponses, CharityAdminListSection321FundraisersData, CharityAdminListSection321FundraisersErrors, CharityAdminListSection321FundraisersResponses, CharityAdminListSection321GrantsData, CharityAdminListSection321GrantsErrors, CharityAdminListSection321GrantsResponses, CharityAdminObjectToFundraiserMessageData, CharityAdminObjectToFundraiserMessageErrors, CharityAdminObjectToFundraiserMessageResponses, CharityAdminProfilePageGetCharityPageData, CharityAdminProfilePageGetCharityPageErrors, CharityAdminProfilePageGetCharityPageResponses, CharityAdminProfilePageReplaceCharityPageData, CharityAdminProfilePageReplaceCharityPageErrors, CharityAdminProfilePageReplaceCharityPageResponses, CharityAdminProfilePageUploadCharityPageImageData, CharityAdminProfilePageUploadCharityPageImageErrors, CharityAdminProfilePageUploadCharityPageImageResponses, CharityAdminRemoveCharityAdminData, CharityAdminRemoveCharityAdminErrors, CharityAdminRemoveCharityAdminResponses, CharityAdminRemoveCrmDonorTagData, CharityAdminRemoveCrmDonorTagErrors, CharityAdminRemoveCrmDonorTagResponses, CharityAdminRequestCharityRemovalData, CharityAdminRequestCharityRemovalErrors, CharityAdminRequestCharityRemovalResponses, CharityAdminRequestVerificationUploadUrlData, CharityAdminRequestVerificationUploadUrlErrors, CharityAdminRequestVerificationUploadUrlResponses, CharityAdminRevokeCharityInviteData, CharityAdminRevokeCharityInviteErrors, CharityAdminRevokeCharityInviteResponses, CharityAdminSetCharityDisplayNameData, CharityAdminSetCharityDisplayNameErrors, CharityAdminSetCharityDisplayNameResponses, CharityAdminSubmitCharityAchData, CharityAdminSubmitCharityAchErrors, CharityAdminSubmitCharityAchResponses, CharityAdminSubmitCharityClaimData, CharityAdminSubmitCharityClaimErrors, CharityAdminSubmitCharityClaimResponses, CharityAdminUpdateCharityAdminRoleData, CharityAdminUpdateCharityAdminRoleErrors, CharityAdminUpdateCharityAdminRoleResponses, CharityAdminUpdateCharityProfileData, CharityAdminUpdateCharityProfileErrors, CharityAdminUpdateCharityProfileResponses, CharityAdminUpdateCrmDonorNoteData, CharityAdminUpdateCrmDonorNoteErrors, CharityAdminUpdateCrmDonorNoteResponses, CharityAdminUpdateCrmImportedContactData, CharityAdminUpdateCrmImportedContactErrors, CharityAdminUpdateCrmImportedContactResponses, CharityAdminUploadCharityProfileLogoData, CharityAdminUploadCharityProfileLogoErrors, CharityAdminUploadCharityProfileLogoResponses, CharityAdminWithdrawCharityDisplayNameRequestData, CharityAdminWithdrawCharityDisplayNameRequestErrors, CharityAdminWithdrawCharityDisplayNameRequestResponses, CharityAlternativesCreateCharityAlternativeRecommendationData, CharityAlternativesCreateCharityAlternativeRecommendationErrors, CharityAlternativesCreateCharityAlternativeRecommendationResponses, CharityBoardAddBoardCommitteeMemberData, CharityBoardAddBoardCommitteeMemberErrors, CharityBoardAddBoardCommitteeMemberResponses, CharityBoardAddBoardCommitteeSuggestionItemsData, CharityBoardAddBoardCommitteeSuggestionItemsErrors, CharityBoardAddBoardCommitteeSuggestionItemsResponses, CharityBoardAddBoardConsentCompensationDecisionData, CharityBoardAddBoardConsentCompensationDecisionErrors, CharityBoardAddBoardConsentCompensationDecisionResponses, CharityBoardAddBoardMemberToBoardData, CharityBoardAddBoardMemberToBoardErrors, CharityBoardAddBoardMemberToBoardResponses, CharityBoardAddBoardMotionCompensationDecisionData, CharityBoardAddBoardMotionCompensationDecisionErrors, CharityBoardAddBoardMotionCompensationDecisionResponses, CharityBoardAddBoardTermSuggestionItemsData, CharityBoardAddBoardTermSuggestionItemsErrors, CharityBoardAddBoardTermSuggestionItemsResponses, CharityBoardAdoptBoardCalendarSettingsData, CharityBoardAdoptBoardCalendarSettingsErrors, CharityBoardAdoptBoardCalendarSettingsResponses, CharityBoardAdoptBoardOfficerDutiesData, CharityBoardAdoptBoardOfficerDutiesErrors, CharityBoardAdoptBoardOfficerDutiesResponses, CharityBoardAdoptBoardRetentionPolicyData, CharityBoardAdoptBoardRetentionPolicyErrors, CharityBoardAdoptBoardRetentionPolicyResponses, CharityBoardApplyBoardAgendaTemplateData, CharityBoardApplyBoardAgendaTemplateErrors, CharityBoardApplyBoardAgendaTemplateResponses, CharityBoardApplyBoardCalendarSettingsData, CharityBoardApplyBoardCalendarSettingsErrors, CharityBoardApplyBoardCalendarSettingsResponses, CharityBoardApproveBoardMinutesData, CharityBoardApproveBoardMinutesErrors, CharityBoardApproveBoardMinutesResponses, CharityBoardApproveBoardRecordData, CharityBoardApproveBoardRecordErrors, CharityBoardApproveBoardRecordResponses, CharityBoardAskBoardMinutesApprovalSignaturesData, CharityBoardAskBoardMinutesApprovalSignaturesErrors, CharityBoardAskBoardMinutesApprovalSignaturesResponses, CharityBoardCancelBoardCoiCycleData, CharityBoardCancelBoardCoiCycleErrors, CharityBoardCancelBoardCoiCycleResponses, CharityBoardCancelBoardMeetingData, CharityBoardCancelBoardMeetingErrors, CharityBoardCancelBoardMeetingResponses, CharityBoardCancelBoardSelfAssessmentData, CharityBoardCancelBoardSelfAssessmentErrors, CharityBoardCancelBoardSelfAssessmentResponses, CharityBoardCheckBoardImportInboxFileData, CharityBoardCheckBoardImportInboxFileErrors, CharityBoardCheckBoardImportInboxFileResponses, CharityBoardCheckBoardProposalFileData, CharityBoardCheckBoardProposalFileErrors, CharityBoardCheckBoardProposalFileResponses, CharityBoardChooseBoardMemberBuddyData, CharityBoardChooseBoardMemberBuddyErrors, CharityBoardChooseBoardMemberBuddyResponses, CharityBoardCirculateBoardWrittenConsentData, CharityBoardCirculateBoardWrittenConsentErrors, CharityBoardCirculateBoardWrittenConsentResponses, CharityBoardCloseBoardCoiCycleData, CharityBoardCloseBoardCoiCycleErrors, CharityBoardCloseBoardCoiCycleResponses, CharityBoardCloseBoardImportBatchData, CharityBoardCloseBoardImportBatchErrors, CharityBoardCloseBoardImportBatchResponses, CharityBoardCloseBoardMemberGettingStartedData, CharityBoardCloseBoardMemberGettingStartedErrors, CharityBoardCloseBoardMemberGettingStartedResponses, CharityBoardCloseBoardSelfAssessmentData, CharityBoardCloseBoardSelfAssessmentErrors, CharityBoardCloseBoardSelfAssessmentResponses, CharityBoardConfirmBoardCompensationDocumentData, CharityBoardConfirmBoardCompensationDocumentErrors, CharityBoardConfirmBoardCompensationDocumentResponses, CharityBoardConfirmBoardDocumentData, CharityBoardConfirmBoardDocumentErrors, CharityBoardConfirmBoardDocumentResponses, CharityBoardConfirmBoardPastRecordBatchData, CharityBoardConfirmBoardPastRecordBatchErrors, CharityBoardConfirmBoardPastRecordBatchResponses, CharityBoardConfirmBoardReturnCopyData, CharityBoardConfirmBoardReturnCopyErrors, CharityBoardConfirmBoardReturnCopyResponses, CharityBoardCorrectBoardCommitteeDissolutionData, CharityBoardCorrectBoardCommitteeDissolutionErrors, CharityBoardCorrectBoardCommitteeDissolutionResponses, CharityBoardCreateBoardAgendaItemData, CharityBoardCreateBoardAgendaItemErrors, CharityBoardCreateBoardAgendaItemResponses, CharityBoardCreateBoardCommitteeData, CharityBoardCreateBoardCommitteeErrors, CharityBoardCreateBoardCommitteeResponses, CharityBoardCreateBoardDirectorClassData, CharityBoardCreateBoardDirectorClassErrors, CharityBoardCreateBoardDirectorClassResponses, CharityBoardCreateBoardMeetingData, CharityBoardCreateBoardMeetingErrors, CharityBoardCreateBoardMeetingResponses, CharityBoardCreateBoardMeetingSegmentData, CharityBoardCreateBoardMeetingSegmentErrors, CharityBoardCreateBoardMeetingSegmentResponses, CharityBoardCreateBoardMemberData, CharityBoardCreateBoardMemberErrors, CharityBoardCreateBoardMemberResponses, CharityBoardCreateBoardMinutesApprovalConsentData, CharityBoardCreateBoardMinutesApprovalConsentErrors, CharityBoardCreateBoardMinutesApprovalConsentResponses, CharityBoardCreateBoardMotionData, CharityBoardCreateBoardMotionErrors, CharityBoardCreateBoardMotionResponses, CharityBoardCreateBoardOfficerTitleData, CharityBoardCreateBoardOfficerTitleErrors, CharityBoardCreateBoardOfficerTitleResponses, CharityBoardCreateBoardPacketData, CharityBoardCreateBoardPacketErrors, CharityBoardCreateBoardPacketItemData, CharityBoardCreateBoardPacketItemErrors, CharityBoardCreateBoardPacketItemResponses, CharityBoardCreateBoardPacketResponses, CharityBoardCreateBoardRecordDraftData, CharityBoardCreateBoardRecordDraftErrors, CharityBoardCreateBoardRecordDraftResponses, CharityBoardCreateBoardWrittenConsentData, CharityBoardCreateBoardWrittenConsentErrors, CharityBoardCreateBoardWrittenConsentResponses, CharityBoardDeleteBoardAgendaItemData, CharityBoardDeleteBoardAgendaItemErrors, CharityBoardDeleteBoardAgendaItemResponses, CharityBoardDeleteBoardConflictLinkData, CharityBoardDeleteBoardConflictLinkErrors, CharityBoardDeleteBoardConflictLinkResponses, CharityBoardDeleteBoardImportFileUploadData, CharityBoardDeleteBoardImportFileUploadErrors, CharityBoardDeleteBoardImportFileUploadResponses, CharityBoardDeleteBoardImportRecordFileUploadData, CharityBoardDeleteBoardImportRecordFileUploadErrors, CharityBoardDeleteBoardImportRecordFileUploadResponses, CharityBoardDeleteBoardMeetingSegmentData, CharityBoardDeleteBoardMeetingSegmentErrors, CharityBoardDeleteBoardMeetingSegmentResponses, CharityBoardDeleteBoardMotionData, CharityBoardDeleteBoardMotionErrors, CharityBoardDeleteBoardMotionResponses, CharityBoardDeleteBoardPacketItemData, CharityBoardDeleteBoardPacketItemErrors, CharityBoardDeleteBoardPacketItemResponses, CharityBoardDeleteBoardRecordChainData, CharityBoardDeleteBoardRecordChainErrors, CharityBoardDeleteBoardRecordChainResponses, CharityBoardDeleteBoardRecordData, CharityBoardDeleteBoardRecordErrors, CharityBoardDeleteBoardRecordResponses, CharityBoardDiscardBoardMemberProposalData, CharityBoardDiscardBoardMemberProposalErrors, CharityBoardDiscardBoardMemberProposalResponses, CharityBoardDiscardBoardPacketData, CharityBoardDiscardBoardPacketErrors, CharityBoardDiscardBoardPacketResponses, CharityBoardDiscardBoardPastRecordBatchData, CharityBoardDiscardBoardPastRecordBatchErrors, CharityBoardDiscardBoardPastRecordBatchResponses, CharityBoardDiscardBoardRecordDraftData, CharityBoardDiscardBoardRecordDraftErrors, CharityBoardDiscardBoardRecordDraftResponses, CharityBoardDismissBoardCommitteeSuggestionData, CharityBoardDismissBoardCommitteeSuggestionErrors, CharityBoardDismissBoardCommitteeSuggestionResponses, CharityBoardDismissBoardTermSuggestionData, CharityBoardDismissBoardTermSuggestionErrors, CharityBoardDismissBoardTermSuggestionResponses, CharityBoardDissolveBoardCommitteeData, CharityBoardDissolveBoardCommitteeErrors, CharityBoardDissolveBoardCommitteeResponses, CharityBoardDistributeBoardPacketData, CharityBoardDistributeBoardPacketErrors, CharityBoardDistributeBoardPacketResponses, CharityBoardEmailBoardReturnAgainData, CharityBoardEmailBoardReturnAgainErrors, CharityBoardEmailBoardReturnAgainResponses, CharityBoardEndBoardCommitteeMemberData, CharityBoardEndBoardCommitteeMemberErrors, CharityBoardEndBoardCommitteeMemberResponses, CharityBoardExportBoardMinuteBookData, CharityBoardExportBoardMinuteBookDocumentData, CharityBoardExportBoardMinuteBookDocumentErrors, CharityBoardExportBoardMinuteBookDocumentResponses, CharityBoardExportBoardMinuteBookErrors, CharityBoardExportBoardMinuteBookResponses, CharityBoardGetBoardCalendarSettingsData, CharityBoardGetBoardCalendarSettingsErrors, CharityBoardGetBoardCalendarSettingsResponses, CharityBoardGetBoardCoiCycleData, CharityBoardGetBoardCoiCycleDocumentData, CharityBoardGetBoardCoiCycleDocumentErrors, CharityBoardGetBoardCoiCycleDocumentResponses, CharityBoardGetBoardCoiCycleErrors, CharityBoardGetBoardCoiCycleResponses, CharityBoardGetBoardCoiPaperFormData, CharityBoardGetBoardCoiPaperFormErrors, CharityBoardGetBoardCoiPaperFormResponses, CharityBoardGetBoardCoiPersonQuestionnaireData, CharityBoardGetBoardCoiPersonQuestionnaireErrors, CharityBoardGetBoardCoiPersonQuestionnaireResponses, CharityBoardGetBoardCoiQuestionnaireData, CharityBoardGetBoardCoiQuestionnaireErrors, CharityBoardGetBoardCoiQuestionnaireResponses, CharityBoardGetBoardCoiResponseChangesData, CharityBoardGetBoardCoiResponseChangesErrors, CharityBoardGetBoardCoiResponseChangesResponses, CharityBoardGetBoardCoiResponseData, CharityBoardGetBoardCoiResponseDocumentData, CharityBoardGetBoardCoiResponseDocumentErrors, CharityBoardGetBoardCoiResponseDocumentResponses, CharityBoardGetBoardCoiResponseErrors, CharityBoardGetBoardCoiResponseResponses, CharityBoardGetBoardCommitteeData, CharityBoardGetBoardCommitteeErrors, CharityBoardGetBoardCommitteeResponses, CharityBoardGetBoardCommitteeSuggestionsData, CharityBoardGetBoardCommitteeSuggestionsErrors, CharityBoardGetBoardCommitteeSuggestionsResponses, CharityBoardGetBoardCompensationDecisionData, CharityBoardGetBoardCompensationDecisionDocumentDownloadData, CharityBoardGetBoardCompensationDecisionDocumentDownloadErrors, CharityBoardGetBoardCompensationDecisionDocumentDownloadResponses, CharityBoardGetBoardCompensationDecisionErrors, CharityBoardGetBoardCompensationDecisionResponses, CharityBoardGetBoardCompensationDocumentDownloadData, CharityBoardGetBoardCompensationDocumentDownloadErrors, CharityBoardGetBoardCompensationDocumentDownloadResponses, CharityBoardGetBoardConsentTemplateData, CharityBoardGetBoardConsentTemplateErrors, CharityBoardGetBoardConsentTemplateResponses, CharityBoardGetBoardDirectorAccessPolicyData, CharityBoardGetBoardDirectorAccessPolicyErrors, CharityBoardGetBoardDirectorAccessPolicyResponses, CharityBoardGetBoardDocumentDownloadUrlData, CharityBoardGetBoardDocumentDownloadUrlErrors, CharityBoardGetBoardDocumentDownloadUrlResponses, CharityBoardGetBoardFilingGovernanceFeedData, CharityBoardGetBoardFilingGovernanceFeedErrors, CharityBoardGetBoardFilingGovernanceFeedResponses, CharityBoardGetBoardForm990Data, CharityBoardGetBoardForm990Errors, CharityBoardGetBoardForm990Responses, CharityBoardGetBoardGettingStartedListData, CharityBoardGetBoardGettingStartedListErrors, CharityBoardGetBoardGettingStartedListResponses, CharityBoardGetBoardGoverningDocumentTemplateData, CharityBoardGetBoardGoverningDocumentTemplateErrors, CharityBoardGetBoardGoverningDocumentTemplateResponses, CharityBoardGetBoardImportBatchData, CharityBoardGetBoardImportBatchErrors, CharityBoardGetBoardImportBatchResponses, CharityBoardGetBoardImportInboxFileUrlData, CharityBoardGetBoardImportInboxFileUrlErrors, CharityBoardGetBoardImportInboxFileUrlResponses, CharityBoardGetBoardInMeetingRecordData, CharityBoardGetBoardInMeetingRecordErrors, CharityBoardGetBoardInMeetingRecordResponses, CharityBoardGetBoardLegalHoldReportData, CharityBoardGetBoardLegalHoldReportErrors, CharityBoardGetBoardLegalHoldReportResponses, CharityBoardGetBoardMeetingCalendarData, CharityBoardGetBoardMeetingCalendarErrors, CharityBoardGetBoardMeetingCalendarResponses, CharityBoardGetBoardMeetingData, CharityBoardGetBoardMeetingErrors, CharityBoardGetBoardMeetingInvitationsData, CharityBoardGetBoardMeetingInvitationsErrors, CharityBoardGetBoardMeetingInvitationsResponses, CharityBoardGetBoardMeetingPresidingData, CharityBoardGetBoardMeetingPresidingErrors, CharityBoardGetBoardMeetingPresidingResponses, CharityBoardGetBoardMeetingResponses, CharityBoardGetBoardMemberData, CharityBoardGetBoardMemberErrors, CharityBoardGetBoardMemberGettingStartedData, CharityBoardGetBoardMemberGettingStartedErrors, CharityBoardGetBoardMemberGettingStartedResponses, CharityBoardGetBoardMemberResponses, CharityBoardGetBoardMinutesApprovalConsentFormData, CharityBoardGetBoardMinutesApprovalConsentFormErrors, CharityBoardGetBoardMinutesApprovalConsentFormResponses, CharityBoardGetBoardMinutesData, CharityBoardGetBoardMinutesErrors, CharityBoardGetBoardMinutesResponses, CharityBoardGetBoardOfficerDutiesData, CharityBoardGetBoardOfficerDutiesErrors, CharityBoardGetBoardOfficerDutiesResponses, CharityBoardGetBoardOfficerStatementData, CharityBoardGetBoardOfficerStatementErrors, CharityBoardGetBoardOfficerStatementResponses, CharityBoardGetBoardPacketData, CharityBoardGetBoardPacketErrors, CharityBoardGetBoardPacketResponses, CharityBoardGetBoardPastRecordBatchData, CharityBoardGetBoardPastRecordBatchErrors, CharityBoardGetBoardPastRecordBatchResponses, CharityBoardGetBoardProposalFileUrlData, CharityBoardGetBoardProposalFileUrlErrors, CharityBoardGetBoardProposalFileUrlResponses, CharityBoardGetBoardRecordData, CharityBoardGetBoardRecordErrors, CharityBoardGetBoardRecordFileUrlData, CharityBoardGetBoardRecordFileUrlErrors, CharityBoardGetBoardRecordFileUrlResponses, CharityBoardGetBoardRecordResponses, CharityBoardGetBoardReturnCopyUrlData, CharityBoardGetBoardReturnCopyUrlErrors, CharityBoardGetBoardReturnCopyUrlResponses, CharityBoardGetBoardReturnDistributionData, CharityBoardGetBoardReturnDistributionErrors, CharityBoardGetBoardReturnDistributionResponses, CharityBoardGetBoardScheduleODraftData, CharityBoardGetBoardScheduleODraftErrors, CharityBoardGetBoardScheduleODraftResponses, CharityBoardGetBoardSelfAssessmentData, CharityBoardGetBoardSelfAssessmentErrors, CharityBoardGetBoardSelfAssessmentInstrumentData, CharityBoardGetBoardSelfAssessmentInstrumentErrors, CharityBoardGetBoardSelfAssessmentInstrumentResponses, CharityBoardGetBoardSelfAssessmentQuestionsData, CharityBoardGetBoardSelfAssessmentQuestionsErrors, CharityBoardGetBoardSelfAssessmentQuestionsResponses, CharityBoardGetBoardSelfAssessmentResponses, CharityBoardGetBoardSelfAssessmentResultsData, CharityBoardGetBoardSelfAssessmentResultsErrors, CharityBoardGetBoardSelfAssessmentResultsResponses, CharityBoardGetBoardTermSuggestionsData, CharityBoardGetBoardTermSuggestionsErrors, CharityBoardGetBoardTermSuggestionsResponses, CharityBoardGetBoardToDoData, CharityBoardGetBoardToDoErrors, CharityBoardGetBoardToDoResponses, CharityBoardGetBoardWrittenConsentData, CharityBoardGetBoardWrittenConsentErrors, CharityBoardGetBoardWrittenConsentResponses, CharityBoardImportBoardRecordData, CharityBoardImportBoardRecordErrors, CharityBoardImportBoardRecordResponses, CharityBoardIssueBoardCompensationDocumentUploadUrlData, CharityBoardIssueBoardCompensationDocumentUploadUrlErrors, CharityBoardIssueBoardCompensationDocumentUploadUrlResponses, CharityBoardIssueBoardDocumentUploadUrlData, CharityBoardIssueBoardDocumentUploadUrlErrors, CharityBoardIssueBoardDocumentUploadUrlResponses, CharityBoardIssueBoardImportFileUploadUrlData, CharityBoardIssueBoardImportFileUploadUrlErrors, CharityBoardIssueBoardImportFileUploadUrlResponses, CharityBoardIssueBoardImportInboxUploadUrlData, CharityBoardIssueBoardImportInboxUploadUrlErrors, CharityBoardIssueBoardImportInboxUploadUrlResponses, CharityBoardIssueBoardImportRecordFileUploadUrlData, CharityBoardIssueBoardImportRecordFileUploadUrlErrors, CharityBoardIssueBoardImportRecordFileUploadUrlResponses, CharityBoardIssueBoardProposalFileUploadUrlData, CharityBoardIssueBoardProposalFileUploadUrlErrors, CharityBoardIssueBoardProposalFileUploadUrlResponses, CharityBoardIssueBoardReturnCopyUploadUrlData, CharityBoardIssueBoardReturnCopyUploadUrlErrors, CharityBoardIssueBoardReturnCopyUploadUrlResponses, CharityBoardLeaveOutBoardPastRecordData, CharityBoardLeaveOutBoardPastRecordErrors, CharityBoardLeaveOutBoardPastRecordResponses, CharityBoardLinkBoardCommitteeCharterData, CharityBoardLinkBoardCommitteeCharterErrors, CharityBoardLinkBoardCommitteeCharterResponses, CharityBoardLinkBoardReturnReviewData, CharityBoardLinkBoardReturnReviewErrors, CharityBoardLinkBoardReturnReviewResponses, CharityBoardLinkBoardSelfAssessmentPrioritiesData, CharityBoardLinkBoardSelfAssessmentPrioritiesErrors, CharityBoardLinkBoardSelfAssessmentPrioritiesResponses, CharityBoardListBoardAgendaItemsData, CharityBoardListBoardAgendaItemsErrors, CharityBoardListBoardAgendaItemsResponses, CharityBoardListBoardAgendaTemplatesData, CharityBoardListBoardAgendaTemplatesErrors, CharityBoardListBoardAgendaTemplatesResponses, CharityBoardListBoardApprovableMinutesData, CharityBoardListBoardApprovableMinutesErrors, CharityBoardListBoardApprovableMinutesResponses, CharityBoardListBoardAttendanceIntentsData, CharityBoardListBoardAttendanceIntentsErrors, CharityBoardListBoardAttendanceIntentsResponses, CharityBoardListBoardCalendarConnectionsData, CharityBoardListBoardCalendarConnectionsErrors, CharityBoardListBoardCalendarConnectionsResponses, CharityBoardListBoardCalendarSendersData, CharityBoardListBoardCalendarSendersErrors, CharityBoardListBoardCalendarSendersResponses, CharityBoardListBoardCarryForwardItemsData, CharityBoardListBoardCarryForwardItemsErrors, CharityBoardListBoardCarryForwardItemsResponses, CharityBoardListBoardCarryForwardMotionsData, CharityBoardListBoardCarryForwardMotionsErrors, CharityBoardListBoardCarryForwardMotionsResponses, CharityBoardListBoardCoiCyclesData, CharityBoardListBoardCoiCyclesErrors, CharityBoardListBoardCoiCyclesResponses, CharityBoardListBoardCoiQuestionnairesData, CharityBoardListBoardCoiQuestionnairesErrors, CharityBoardListBoardCoiQuestionnairesResponses, CharityBoardListBoardCommitteesData, CharityBoardListBoardCommitteesErrors, CharityBoardListBoardCommitteeSourcesData, CharityBoardListBoardCommitteeSourcesErrors, CharityBoardListBoardCommitteeSourcesResponses, CharityBoardListBoardCommitteesResponses, CharityBoardListBoardCompensationDecisionsData, CharityBoardListBoardCompensationDecisionsErrors, CharityBoardListBoardCompensationDecisionsResponses, CharityBoardListBoardConflictLinksData, CharityBoardListBoardConflictLinksErrors, CharityBoardListBoardConflictLinksResponses, CharityBoardListBoardConflictRegisterData, CharityBoardListBoardConflictRegisterErrors, CharityBoardListBoardConflictRegisterResponses, CharityBoardListBoardConflictSuggestionsData, CharityBoardListBoardConflictSuggestionsErrors, CharityBoardListBoardConflictSuggestionsResponses, CharityBoardListBoardConsentCompensationDecisionsData, CharityBoardListBoardConsentCompensationDecisionsErrors, CharityBoardListBoardConsentCompensationDecisionsResponses, CharityBoardListBoardConsentTemplatesData, CharityBoardListBoardConsentTemplatesErrors, CharityBoardListBoardConsentTemplatesResponses, CharityBoardListBoardContemporaneityData, CharityBoardListBoardContemporaneityErrors, CharityBoardListBoardContemporaneityResponses, CharityBoardListBoardDirectorClassesData, CharityBoardListBoardDirectorClassesErrors, CharityBoardListBoardDirectorClassesResponses, CharityBoardListBoardDocumentsData, CharityBoardListBoardDocumentsErrors, CharityBoardListBoardDocumentsResponses, CharityBoardListBoardEngagementData, CharityBoardListBoardEngagementErrors, CharityBoardListBoardEngagementResponses, CharityBoardListBoardGettingStartedStepsData, CharityBoardListBoardGettingStartedStepsErrors, CharityBoardListBoardGettingStartedStepsResponses, CharityBoardListBoardGovernanceParametersData, CharityBoardListBoardGovernanceParametersErrors, CharityBoardListBoardGovernanceParametersResponses, CharityBoardListBoardGoverningDocumentsData, CharityBoardListBoardGoverningDocumentsErrors, CharityBoardListBoardGoverningDocumentsResponses, CharityBoardListBoardGoverningDocumentTemplatesData, CharityBoardListBoardGoverningDocumentTemplatesErrors, CharityBoardListBoardGoverningDocumentTemplatesResponses, CharityBoardListBoardImportBatchesData, CharityBoardListBoardImportBatchesErrors, CharityBoardListBoardImportBatchesResponses, CharityBoardListBoardImportBatchRecordsData, CharityBoardListBoardImportBatchRecordsErrors, CharityBoardListBoardImportBatchRecordsResponses, CharityBoardListBoardImportInboxData, CharityBoardListBoardImportInboxErrors, CharityBoardListBoardImportInboxResponses, CharityBoardListBoardLegalHoldsData, CharityBoardListBoardLegalHoldsErrors, CharityBoardListBoardLegalHoldsResponses, CharityBoardListBoardMeetingAttendanceData, CharityBoardListBoardMeetingAttendanceErrors, CharityBoardListBoardMeetingAttendanceResponses, CharityBoardListBoardMeetingCompensationDecisionsData, CharityBoardListBoardMeetingCompensationDecisionsErrors, CharityBoardListBoardMeetingCompensationDecisionsResponses, CharityBoardListBoardMeetingEventsData, CharityBoardListBoardMeetingEventsErrors, CharityBoardListBoardMeetingEventsResponses, CharityBoardListBoardMeetingsData, CharityBoardListBoardMeetingSegmentsData, CharityBoardListBoardMeetingSegmentsErrors, CharityBoardListBoardMeetingSegmentsResponses, CharityBoardListBoardMeetingsErrors, CharityBoardListBoardMeetingsResponses, CharityBoardListBoardMemberHistoryData, CharityBoardListBoardMemberHistoryErrors, CharityBoardListBoardMemberHistoryResponses, CharityBoardListBoardMemberProposalsData, CharityBoardListBoardMemberProposalsErrors, CharityBoardListBoardMemberProposalsResponses, CharityBoardListBoardMembersData, CharityBoardListBoardMembersErrors, CharityBoardListBoardMembersResponses, CharityBoardListBoardMotionsData, CharityBoardListBoardMotionsErrors, CharityBoardListBoardMotionsResponses, CharityBoardListBoardOfficerTitlesData, CharityBoardListBoardOfficerTitlesErrors, CharityBoardListBoardOfficerTitlesResponses, CharityBoardListBoardPacketCommentsData, CharityBoardListBoardPacketCommentsErrors, CharityBoardListBoardPacketCommentsResponses, CharityBoardListBoardPacketDistributionsData, CharityBoardListBoardPacketDistributionsErrors, CharityBoardListBoardPacketDistributionsResponses, CharityBoardListBoardPacketsData, CharityBoardListBoardPacketsErrors, CharityBoardListBoardPacketsResponses, CharityBoardListBoardPastRecordBatchesData, CharityBoardListBoardPastRecordBatchesErrors, CharityBoardListBoardPastRecordBatchesResponses, CharityBoardListBoardRecordAcknowledgmentsData, CharityBoardListBoardRecordAcknowledgmentsErrors, CharityBoardListBoardRecordAcknowledgmentsResponses, CharityBoardListBoardRecordEventsData, CharityBoardListBoardRecordEventsErrors, CharityBoardListBoardRecordEventsResponses, CharityBoardListBoardRecordsData, CharityBoardListBoardRecordsErrors, CharityBoardListBoardRecordsResponses, CharityBoardListBoardRetentionPoliciesData, CharityBoardListBoardRetentionPoliciesErrors, CharityBoardListBoardRetentionPoliciesResponses, CharityBoardListBoardReturnDistributionsData, CharityBoardListBoardReturnDistributionsErrors, CharityBoardListBoardReturnDistributionsResponses, CharityBoardListBoardReturnReviewCandidatesData, CharityBoardListBoardReturnReviewCandidatesErrors, CharityBoardListBoardReturnReviewCandidatesResponses, CharityBoardListBoardSelfAssessmentInstrumentsData, CharityBoardListBoardSelfAssessmentInstrumentsErrors, CharityBoardListBoardSelfAssessmentInstrumentsResponses, CharityBoardListBoardSelfAssessmentsData, CharityBoardListBoardSelfAssessmentsErrors, CharityBoardListBoardSelfAssessmentsResponses, CharityBoardListBoardWrittenConsentsData, CharityBoardListBoardWrittenConsentsErrors, CharityBoardListBoardWrittenConsentsResponses, CharityBoardMarkBoardMemberGettingStartedStepData, CharityBoardMarkBoardMemberGettingStartedStepErrors, CharityBoardMarkBoardMemberGettingStartedStepResponses, CharityBoardMarkBoardPastRecordConfidentialityData, CharityBoardMarkBoardPastRecordConfidentialityErrors, CharityBoardMarkBoardPastRecordConfidentialityResponses, CharityBoardMarkBoardSelfAssessmentPaperHandInData, CharityBoardMarkBoardSelfAssessmentPaperHandInErrors, CharityBoardMarkBoardSelfAssessmentPaperHandInResponses, CharityBoardMintBoardAccessLinkData, CharityBoardMintBoardAccessLinkErrors, CharityBoardMintBoardAccessLinkResponses, CharityBoardMoveBoardCalendarMeetingsData, CharityBoardMoveBoardCalendarMeetingsErrors, CharityBoardMoveBoardCalendarMeetingsResponses, CharityBoardMoveBoardMeetingInvitationsData, CharityBoardMoveBoardMeetingInvitationsErrors, CharityBoardMoveBoardMeetingInvitationsResponses, CharityBoardOpenBoardCoiCycleData, CharityBoardOpenBoardCoiCycleErrors, CharityBoardOpenBoardCoiCycleResponses, CharityBoardOpenBoardFilingReceiptData, CharityBoardOpenBoardFilingReceiptErrors, CharityBoardOpenBoardFilingReceiptResponses, CharityBoardOpenBoardImportBatchData, CharityBoardOpenBoardImportBatchErrors, CharityBoardOpenBoardImportBatchResponses, CharityBoardOpenBoardSelfAssessmentData, CharityBoardOpenBoardSelfAssessmentErrors, CharityBoardOpenBoardSelfAssessmentResponses, CharityBoardPlaceBoardLegalHoldData, CharityBoardPlaceBoardLegalHoldErrors, CharityBoardPlaceBoardLegalHoldResponses, CharityBoardPreviewBoardReturnRecipientsData, CharityBoardPreviewBoardReturnRecipientsErrors, CharityBoardPreviewBoardReturnRecipientsResponses, CharityBoardProvideBoardReturnData, CharityBoardProvideBoardReturnErrors, CharityBoardProvideBoardReturnResponses, CharityBoardPublishBoardPacketData, CharityBoardPublishBoardPacketErrors, CharityBoardPublishBoardPacketResponses, CharityBoardRecordBoardAttendanceIntentOnBehalfData, CharityBoardRecordBoardAttendanceIntentOnBehalfErrors, CharityBoardRecordBoardAttendanceIntentOnBehalfResponses, CharityBoardRecordBoardCoiPaperResponseData, CharityBoardRecordBoardCoiPaperResponseErrors, CharityBoardRecordBoardCoiPaperResponseResponses, CharityBoardRecordBoardCommitteeRuleData, CharityBoardRecordBoardCommitteeRuleErrors, CharityBoardRecordBoardCommitteeRuleResponses, CharityBoardRecordBoardCompensationIndexEntryData, CharityBoardRecordBoardCompensationIndexEntryErrors, CharityBoardRecordBoardCompensationIndexEntryResponses, CharityBoardRecordBoardConflictDisclosureData, CharityBoardRecordBoardConflictDisclosureErrors, CharityBoardRecordBoardConflictDisclosureResponses, CharityBoardRecordBoardConflictLinkData, CharityBoardRecordBoardConflictLinkErrors, CharityBoardRecordBoardConflictLinkResponses, CharityBoardRecordBoardConsentRevocationData, CharityBoardRecordBoardConsentRevocationErrors, CharityBoardRecordBoardConsentRevocationResponses, CharityBoardRecordBoardConsentSignatureData, CharityBoardRecordBoardConsentSignatureErrors, CharityBoardRecordBoardConsentSignatureResponses, CharityBoardRecordBoardDirectorsToldData, CharityBoardRecordBoardDirectorsToldErrors, CharityBoardRecordBoardDirectorsToldResponses, CharityBoardRecordBoardGovernanceParameterData, CharityBoardRecordBoardGovernanceParameterErrors, CharityBoardRecordBoardGovernanceParameterResponses, CharityBoardRecordBoardMeetingAttendanceData, CharityBoardRecordBoardMeetingAttendanceErrors, CharityBoardRecordBoardMeetingAttendanceResponses, CharityBoardRecordBoardMeetingPresidingData, CharityBoardRecordBoardMeetingPresidingErrors, CharityBoardRecordBoardMeetingPresidingResponses, CharityBoardRecordBoardMemberTermData, CharityBoardRecordBoardMemberTermErrors, CharityBoardRecordBoardMemberTermResponses, CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfData, CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfErrors, CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfResponses, CharityBoardRecordBoardMinutesApprovalVoteData, CharityBoardRecordBoardMinutesApprovalVoteErrors, CharityBoardRecordBoardMinutesApprovalVoteResponses, CharityBoardRecordBoardMotionRecusalData, CharityBoardRecordBoardMotionRecusalErrors, CharityBoardRecordBoardMotionRecusalResponses, CharityBoardRecordBoardMotionVoteData, CharityBoardRecordBoardMotionVoteErrors, CharityBoardRecordBoardMotionVoteResponses, CharityBoardRecordBoardPacketSharedCommentData, CharityBoardRecordBoardPacketSharedCommentErrors, CharityBoardRecordBoardPacketSharedCommentResponses, CharityBoardRecordBoardPaperAcknowledgmentsData, CharityBoardRecordBoardPaperAcknowledgmentsErrors, CharityBoardRecordBoardPaperAcknowledgmentsResponses, CharityBoardRecordBoardReturnPrintedCopyData, CharityBoardRecordBoardReturnPrintedCopyErrors, CharityBoardRecordBoardReturnPrintedCopyResponses, CharityBoardRecordBoardRosterResultData, CharityBoardRecordBoardRosterResultErrors, CharityBoardRecordBoardRosterResultResponses, CharityBoardRecordBoardSegmentParticipantData, CharityBoardRecordBoardSegmentParticipantErrors, CharityBoardRecordBoardSegmentParticipantResponses, CharityBoardRecordBoardSelfAssessmentPaperSheetData, CharityBoardRecordBoardSelfAssessmentPaperSheetErrors, CharityBoardRecordBoardSelfAssessmentPaperSheetResponses, CharityBoardRecordHistoricalBoardMemberData, CharityBoardRecordHistoricalBoardMemberErrors, CharityBoardRecordHistoricalBoardMemberResponses, CharityBoardRefreshBoardFilingSnapshotData, CharityBoardRefreshBoardFilingSnapshotErrors, CharityBoardRefreshBoardFilingSnapshotResponses, CharityBoardReinviteBoardMeetingInviteeData, CharityBoardReinviteBoardMeetingInviteeErrors, CharityBoardReinviteBoardMeetingInviteeResponses, CharityBoardReleaseBoardLegalHoldData, CharityBoardReleaseBoardLegalHoldErrors, CharityBoardReleaseBoardLegalHoldResponses, CharityBoardReleaseBoardMemberAccountData, CharityBoardReleaseBoardMemberAccountErrors, CharityBoardReleaseBoardMemberAccountResponses, CharityBoardRemindBoardCoiCycleRecipientsData, CharityBoardRemindBoardCoiCycleRecipientsErrors, CharityBoardRemindBoardCoiCycleRecipientsResponses, CharityBoardRemindBoardSelfAssessmentRecipientsData, CharityBoardRemindBoardSelfAssessmentRecipientsErrors, CharityBoardRemindBoardSelfAssessmentRecipientsResponses, CharityBoardRemoveBoardCompensationDocumentData, CharityBoardRemoveBoardCompensationDocumentErrors, CharityBoardRemoveBoardCompensationDocumentResponses, CharityBoardRemoveBoardCompensationIndexEntryData, CharityBoardRemoveBoardCompensationIndexEntryErrors, CharityBoardRemoveBoardCompensationIndexEntryResponses, CharityBoardRemoveBoardConsentCompensationDecisionData, CharityBoardRemoveBoardConsentCompensationDecisionErrors, CharityBoardRemoveBoardConsentCompensationDecisionResponses, CharityBoardRemoveBoardImportInboxFileData, CharityBoardRemoveBoardImportInboxFileErrors, CharityBoardRemoveBoardImportInboxFileResponses, CharityBoardRemoveBoardMemberData, CharityBoardRemoveBoardMemberErrors, CharityBoardRemoveBoardMemberResponses, CharityBoardRemoveBoardMemberTermData, CharityBoardRemoveBoardMemberTermErrors, CharityBoardRemoveBoardMemberTermResponses, CharityBoardRemoveBoardMotionCompensationDecisionData, CharityBoardRemoveBoardMotionCompensationDecisionErrors, CharityBoardRemoveBoardMotionCompensationDecisionResponses, CharityBoardRemoveBoardMotionRecusalData, CharityBoardRemoveBoardMotionRecusalErrors, CharityBoardRemoveBoardMotionRecusalResponses, CharityBoardRemoveBoardSegmentParticipantData, CharityBoardRemoveBoardSegmentParticipantErrors, CharityBoardRemoveBoardSegmentParticipantResponses, CharityBoardReorderBoardAgendaData, CharityBoardReorderBoardAgendaErrors, CharityBoardReorderBoardAgendaResponses, CharityBoardReorderBoardMeetingSegmentsData, CharityBoardReorderBoardMeetingSegmentsErrors, CharityBoardReorderBoardMeetingSegmentsResponses, CharityBoardReorderBoardPacketItemsData, CharityBoardReorderBoardPacketItemsErrors, CharityBoardReorderBoardPacketItemsResponses, CharityBoardReplaceBoardConsentCompensationDecisionData, CharityBoardReplaceBoardConsentCompensationDecisionErrors, CharityBoardReplaceBoardConsentCompensationDecisionResponses, CharityBoardReplaceBoardMotionCompensationDecisionData, CharityBoardReplaceBoardMotionCompensationDecisionErrors, CharityBoardReplaceBoardMotionCompensationDecisionResponses, CharityBoardRestoreBoardCommitteeSuggestionData, CharityBoardRestoreBoardCommitteeSuggestionErrors, CharityBoardRestoreBoardCommitteeSuggestionResponses, CharityBoardRestoreBoardTermSuggestionData, CharityBoardRestoreBoardTermSuggestionErrors, CharityBoardRestoreBoardTermSuggestionResponses, CharityBoardRetireBoardDirectorClassData, CharityBoardRetireBoardDirectorClassErrors, CharityBoardRetireBoardDirectorClassResponses, CharityBoardRetireBoardOfficerTitleData, CharityBoardRetireBoardOfficerTitleErrors, CharityBoardRetireBoardOfficerTitleResponses, CharityBoardReviseBoardWrittenConsentData, CharityBoardReviseBoardWrittenConsentErrors, CharityBoardReviseBoardWrittenConsentResponses, CharityBoardSaveBoardGettingStartedListData, CharityBoardSaveBoardGettingStartedListErrors, CharityBoardSaveBoardGettingStartedListResponses, CharityBoardSaveBoardMemberGettingStartedData, CharityBoardSaveBoardMemberGettingStartedErrors, CharityBoardSaveBoardMemberGettingStartedResponses, CharityBoardScheduleRestoredBoardMeetingData, CharityBoardScheduleRestoredBoardMeetingErrors, CharityBoardScheduleRestoredBoardMeetingResponses, CharityBoardSendBoardCoiCycleRequestsData, CharityBoardSendBoardCoiCycleRequestsErrors, CharityBoardSendBoardCoiCycleRequestsResponses, CharityBoardSendBoardMeetingInvitationsData, CharityBoardSendBoardMeetingInvitationsErrors, CharityBoardSendBoardMeetingInvitationsResponses, CharityBoardSendBoardMinutesReminderData, CharityBoardSendBoardMinutesReminderErrors, CharityBoardSendBoardMinutesReminderResponses, CharityBoardSendBoardSelfAssessmentRequestsData, CharityBoardSendBoardSelfAssessmentRequestsErrors, CharityBoardSendBoardSelfAssessmentRequestsResponses, CharityBoardSetBoardCommitteeConfirmationData, CharityBoardSetBoardCommitteeConfirmationErrors, CharityBoardSetBoardCommitteeConfirmationResponses, CharityBoardSignBoardMinutesOnBehalfData, CharityBoardSignBoardMinutesOnBehalfErrors, CharityBoardSignBoardMinutesOnBehalfResponses, CharityBoardStartBoardMemberGettingStartedData, CharityBoardStartBoardMemberGettingStartedErrors, CharityBoardStartBoardMemberGettingStartedResponses, CharityBoardSubmitBoardRecordData, CharityBoardSubmitBoardRecordErrors, CharityBoardSubmitBoardRecordResponses, CharityBoardUnlinkBoardReturnReviewData, CharityBoardUnlinkBoardReturnReviewErrors, CharityBoardUnlinkBoardReturnReviewResponses, CharityBoardUnmarkBoardSelfAssessmentPaperHandInData, CharityBoardUnmarkBoardSelfAssessmentPaperHandInErrors, CharityBoardUnmarkBoardSelfAssessmentPaperHandInResponses, CharityBoardUpdateBoardAgendaItemData, CharityBoardUpdateBoardAgendaItemErrors, CharityBoardUpdateBoardAgendaItemResponses, CharityBoardUpdateBoardCoiCycleData, CharityBoardUpdateBoardCoiCycleErrors, CharityBoardUpdateBoardCoiCycleResponses, CharityBoardUpdateBoardCommitteeData, CharityBoardUpdateBoardCommitteeErrors, CharityBoardUpdateBoardCommitteeMemberData, CharityBoardUpdateBoardCommitteeMemberErrors, CharityBoardUpdateBoardCommitteeMemberResponses, CharityBoardUpdateBoardCommitteeResponses, CharityBoardUpdateBoardCompensationDecisionData, CharityBoardUpdateBoardCompensationDecisionErrors, CharityBoardUpdateBoardCompensationDecisionResponses, CharityBoardUpdateBoardDirectorClassData, CharityBoardUpdateBoardDirectorClassErrors, CharityBoardUpdateBoardDirectorClassResponses, CharityBoardUpdateBoardImportBatchData, CharityBoardUpdateBoardImportBatchErrors, CharityBoardUpdateBoardImportBatchResponses, CharityBoardUpdateBoardMeetingData, CharityBoardUpdateBoardMeetingErrors, CharityBoardUpdateBoardMeetingResponses, CharityBoardUpdateBoardMeetingSegmentData, CharityBoardUpdateBoardMeetingSegmentErrors, CharityBoardUpdateBoardMeetingSegmentResponses, CharityBoardUpdateBoardMemberData, CharityBoardUpdateBoardMemberErrors, CharityBoardUpdateBoardMemberResponses, CharityBoardUpdateBoardMemberTermData, CharityBoardUpdateBoardMemberTermErrors, CharityBoardUpdateBoardMemberTermResponses, CharityBoardUpdateBoardMotionData, CharityBoardUpdateBoardMotionErrors, CharityBoardUpdateBoardMotionResponses, CharityBoardUpdateBoardOfficerTitleData, CharityBoardUpdateBoardOfficerTitleErrors, CharityBoardUpdateBoardOfficerTitleResponses, CharityBoardUpdateBoardRecordDraftData, CharityBoardUpdateBoardRecordDraftErrors, CharityBoardUpdateBoardRecordDraftResponses, CharityBoardUpdateBoardWrittenConsentData, CharityBoardUpdateBoardWrittenConsentErrors, CharityBoardUpdateBoardWrittenConsentResponses, CharityBoardWithdrawBoardMinutesApprovalSignaturesData, CharityBoardWithdrawBoardMinutesApprovalSignaturesErrors, CharityBoardWithdrawBoardMinutesApprovalSignaturesResponses, CharityBoardWithdrawBoardMotionData, CharityBoardWithdrawBoardMotionErrors, CharityBoardWithdrawBoardMotionResponses, CharityBoardWithdrawBoardReturnData, CharityBoardWithdrawBoardReturnErrors, CharityBoardWithdrawBoardReturnResponses, CharityBoardWithdrawBoardWrittenConsentData, CharityBoardWithdrawBoardWrittenConsentErrors, CharityBoardWithdrawBoardWrittenConsentResponses, CharityBoardWriteBoardMinutesDraftData, CharityBoardWriteBoardMinutesDraftErrors, CharityBoardWriteBoardMinutesDraftResponses, CharityCollectionsAddCharityToCollectionData, CharityCollectionsAddCharityToCollectionErrors, CharityCollectionsAddCharityToCollectionResponses, CharityCollectionsCreateCharityCollectionData, CharityCollectionsCreateCharityCollectionDonationData, CharityCollectionsCreateCharityCollectionDonationErrors, CharityCollectionsCreateCharityCollectionDonationResponses, CharityCollectionsCreateCharityCollectionErrors, CharityCollectionsCreateCharityCollectionResponses, CharityCollectionsCreateUnauthenticatedCharityCollectionDonationData, CharityCollectionsCreateUnauthenticatedCharityCollectionDonationErrors, CharityCollectionsCreateUnauthenticatedCharityCollectionDonationResponses, CharityCollectionsDeleteCharityCollectionData, CharityCollectionsDeleteCharityCollectionErrors, CharityCollectionsDeleteCharityCollectionResponses, CharityCollectionsDiscoverCharityCollectionsData, CharityCollectionsDiscoverCharityCollectionsErrors, CharityCollectionsDiscoverCharityCollectionsResponses, CharityCollectionsGetCharityCollectionData, CharityCollectionsGetCharityCollectionErrors, CharityCollectionsGetCharityCollectionPostsData, CharityCollectionsGetCharityCollectionPostsErrors, CharityCollectionsGetCharityCollectionPostsResponses, CharityCollectionsGetCharityCollectionResponses, CharityCollectionsGetOwnCharityCollectionData, CharityCollectionsGetOwnCharityCollectionErrors, CharityCollectionsGetOwnCharityCollectionResponses, CharityCollectionsGetSuperAdminRecentCollectionsData, CharityCollectionsGetSuperAdminRecentCollectionsErrors, CharityCollectionsGetSuperAdminRecentCollectionsResponses, CharityCollectionsListUserCharityCollectionsData, CharityCollectionsListUserCharityCollectionsErrors, CharityCollectionsListUserCharityCollectionsResponses, CharityCollectionsRelistCharityCollectionData, CharityCollectionsRelistCharityCollectionErrors, CharityCollectionsRelistCharityCollectionResponses, CharityCollectionsRemoveCharityFromCollectionData, CharityCollectionsRemoveCharityFromCollectionErrors, CharityCollectionsRemoveCharityFromCollectionResponses, CharityCollectionsSetCharityCollectionVisibilityData, CharityCollectionsSetCharityCollectionVisibilityErrors, CharityCollectionsSetCharityCollectionVisibilityResponses, CharityCollectionsUnlistCharityCollectionData, CharityCollectionsUnlistCharityCollectionErrors, CharityCollectionsUnlistCharityCollectionResponses, CharityCollectionsUpdateCharityCollectionData, CharityCollectionsUpdateCharityCollectionErrors, CharityCollectionsUpdateCharityCollectionResponses, CharityCollectionsUploadCharityCollectionPictureData, CharityCollectionsUploadCharityCollectionPictureErrors, CharityCollectionsUploadCharityCollectionPictureResponses, CharityComplianceAddComplianceEarlierRenewalCycleData, CharityComplianceAddComplianceEarlierRenewalCycleErrors, CharityComplianceAddComplianceEarlierRenewalCycleResponses, CharityComplianceAddComplianceObligationAttachmentData, CharityComplianceAddComplianceObligationAttachmentErrors, CharityComplianceAddComplianceObligationAttachmentResponses, CharityComplianceAddComplianceOrganizationFilingAttachmentData, CharityComplianceAddComplianceOrganizationFilingAttachmentErrors, CharityComplianceAddComplianceOrganizationFilingAttachmentResponses, CharityComplianceAddComplianceOrganizationFilingCycleData, CharityComplianceAddComplianceOrganizationFilingCycleErrors, CharityComplianceAddComplianceOrganizationFilingCycleResponses, CharityComplianceAddComplianceOrganizationFilingData, CharityComplianceAddComplianceOrganizationFilingErrors, CharityComplianceAddComplianceOrganizationFilingResponses, CharityComplianceAddComplianceRenewalAttachmentData, CharityComplianceAddComplianceRenewalAttachmentErrors, CharityComplianceAddComplianceRenewalAttachmentResponses, CharityComplianceAmendComplianceRegistrationImportData, CharityComplianceAmendComplianceRegistrationImportErrors, CharityComplianceAmendComplianceRegistrationImportResponses, CharityComplianceAnswerComplianceFormItemData, CharityComplianceAnswerComplianceFormItemErrors, CharityComplianceAnswerComplianceFormItemResponses, CharityComplianceAnswerComplianceSubmissionEvidenceData, CharityComplianceAnswerComplianceSubmissionEvidenceErrors, CharityComplianceAnswerComplianceSubmissionEvidenceResponses, CharityComplianceAskAboutComplianceReviewItemData, CharityComplianceAskAboutComplianceReviewItemErrors, CharityComplianceAskAboutComplianceReviewItemResponses, CharityComplianceAssembleCompliancePacketData, CharityComplianceAssembleCompliancePacketErrors, CharityComplianceAssembleCompliancePacketResponses, CharityComplianceAttachComplianceChecklistDocumentData, CharityComplianceAttachComplianceChecklistDocumentErrors, CharityComplianceAttachComplianceChecklistDocumentResponses, CharityComplianceAttachComplianceFilingCaseDocumentData, CharityComplianceAttachComplianceFilingCaseDocumentErrors, CharityComplianceAttachComplianceFilingCaseDocumentResponses, CharityComplianceAttachComplianceObligationFiledCopyData, CharityComplianceAttachComplianceObligationFiledCopyErrors, CharityComplianceAttachComplianceObligationFiledCopyResponses, CharityComplianceAttachComplianceOrganizationFilingFiledCopyData, CharityComplianceAttachComplianceOrganizationFilingFiledCopyErrors, CharityComplianceAttachComplianceOrganizationFilingFiledCopyResponses, CharityComplianceAttachComplianceRenewalFiledCopyData, CharityComplianceAttachComplianceRenewalFiledCopyErrors, CharityComplianceAttachComplianceRenewalFiledCopyResponses, CharityComplianceAuthorizeComplianceSubmissionData, CharityComplianceAuthorizeComplianceSubmissionErrors, CharityComplianceAuthorizeComplianceSubmissionResponses, CharityComplianceCancelComplianceSigningRequestData, CharityComplianceCancelComplianceSigningRequestErrors, CharityComplianceCancelComplianceSigningRequestResponses, CharityComplianceConfirmComplianceArtifactData, CharityComplianceConfirmComplianceArtifactErrors, CharityComplianceConfirmComplianceArtifactResponses, CharityComplianceConfirmComplianceCandidateData, CharityComplianceConfirmComplianceCandidateErrors, CharityComplianceConfirmComplianceCandidateResponses, CharityComplianceCreateComplianceFilingDocumentData, CharityComplianceCreateComplianceFilingDocumentErrors, CharityComplianceCreateComplianceFilingDocumentResponses, CharityComplianceCreateComplianceFilingGroupData, CharityComplianceCreateComplianceFilingGroupErrors, CharityComplianceCreateComplianceFilingGroupResponses, CharityComplianceDeclineComplianceSigningRequestData, CharityComplianceDeclineComplianceSigningRequestErrors, CharityComplianceDeclineComplianceSigningRequestResponses, CharityComplianceDeleteComplianceArtifactData, CharityComplianceDeleteComplianceArtifactErrors, CharityComplianceDeleteComplianceArtifactResponses, CharityComplianceDismissComplianceCandidateData, CharityComplianceDismissComplianceCandidateErrors, CharityComplianceDismissComplianceCandidateResponses, CharityComplianceDispatchComplianceSubmissionData, CharityComplianceDispatchComplianceSubmissionErrors, CharityComplianceDispatchComplianceSubmissionResponses, CharityComplianceExtendComplianceSigningRequestData, CharityComplianceExtendComplianceSigningRequestErrors, CharityComplianceExtendComplianceSigningRequestResponses, CharityComplianceGenerateComplianceProposalRevisionData, CharityComplianceGenerateComplianceProposalRevisionErrors, CharityComplianceGenerateComplianceProposalRevisionResponses, CharityComplianceGetComplianceAiSettingData, CharityComplianceGetComplianceAiSettingErrors, CharityComplianceGetComplianceAiSettingResponses, CharityComplianceGetComplianceArtifactDownloadData, CharityComplianceGetComplianceArtifactDownloadErrors, CharityComplianceGetComplianceArtifactDownloadResponses, CharityComplianceGetComplianceDeskAuthorizationData, CharityComplianceGetComplianceDeskAuthorizationErrors, CharityComplianceGetComplianceDeskAuthorizationResponses, CharityComplianceGetComplianceFilingCaseChecklistData, CharityComplianceGetComplianceFilingCaseChecklistErrors, CharityComplianceGetComplianceFilingCaseChecklistResponses, CharityComplianceGetComplianceFilingCaseData, CharityComplianceGetComplianceFilingCaseErrors, CharityComplianceGetComplianceFilingCaseResponses, CharityComplianceGetComplianceFilingDocumentData, CharityComplianceGetComplianceFilingDocumentErrors, CharityComplianceGetComplianceFilingDocumentResponses, CharityComplianceGetComplianceFilingDocumentSigningPlacesData, CharityComplianceGetComplianceFilingDocumentSigningPlacesErrors, CharityComplianceGetComplianceFilingDocumentSigningPlacesResponses, CharityComplianceGetComplianceFilingDocumentVersionDownloadData, CharityComplianceGetComplianceFilingDocumentVersionDownloadErrors, CharityComplianceGetComplianceFilingDocumentVersionDownloadResponses, CharityComplianceGetComplianceFilingDocumentVersionRenditionData, CharityComplianceGetComplianceFilingDocumentVersionRenditionErrors, CharityComplianceGetComplianceFilingDocumentVersionRenditionResponses, CharityComplianceGetComplianceFormPagePreviewData, CharityComplianceGetComplianceFormPagePreviewErrors, CharityComplianceGetComplianceFormPagePreviewResponses, CharityComplianceGetComplianceFormPreparationData, CharityComplianceGetComplianceFormPreparationErrors, CharityComplianceGetComplianceFormPreparationResponses, CharityComplianceGetComplianceObligationData, CharityComplianceGetComplianceObligationErrors, CharityComplianceGetComplianceObligationResponses, CharityComplianceGetComplianceObligationRuleChangeData, CharityComplianceGetComplianceObligationRuleChangeErrors, CharityComplianceGetComplianceObligationRuleChangeResponses, CharityComplianceGetComplianceOrganizationFilingData, CharityComplianceGetComplianceOrganizationFilingErrors, CharityComplianceGetComplianceOrganizationFilingResponses, CharityComplianceGetCompliancePacketChecklistData, CharityComplianceGetCompliancePacketChecklistErrors, CharityComplianceGetCompliancePacketChecklistResponses, CharityComplianceGetCompliancePacketData, CharityComplianceGetCompliancePacketErrors, CharityComplianceGetCompliancePacketRenderData, CharityComplianceGetCompliancePacketRenderErrors, CharityComplianceGetCompliancePacketRenderResponses, CharityComplianceGetCompliancePacketResponses, CharityComplianceGetComplianceProfileData, CharityComplianceGetComplianceProfileErrors, CharityComplianceGetComplianceProfileResponses, CharityComplianceGetComplianceProposalData, CharityComplianceGetComplianceProposalErrors, CharityComplianceGetComplianceProposalResponses, CharityComplianceGetComplianceProposalReviewData, CharityComplianceGetComplianceProposalReviewErrors, CharityComplianceGetComplianceProposalReviewResponses, CharityComplianceGetComplianceProposalRevisionData, CharityComplianceGetComplianceProposalRevisionErrors, CharityComplianceGetComplianceProposalRevisionResponses, CharityComplianceGetComplianceRenewalCycleData, CharityComplianceGetComplianceRenewalCycleErrors, CharityComplianceGetComplianceRenewalCycleResponses, CharityComplianceGetComplianceSigningEvidenceData, CharityComplianceGetComplianceSigningEvidenceErrors, CharityComplianceGetComplianceSigningEvidenceResponses, CharityComplianceGetComplianceSigningExportData, CharityComplianceGetComplianceSigningExportErrors, CharityComplianceGetComplianceSigningExportResponses, CharityComplianceGetComplianceSigningRecordLinesData, CharityComplianceGetComplianceSigningRecordLinesErrors, CharityComplianceGetComplianceSigningRecordLinesResponses, CharityComplianceGetComplianceSigningRequestData, CharityComplianceGetComplianceSigningRequestErrors, CharityComplianceGetComplianceSigningRequestResponses, CharityComplianceGetComplianceSigningSettingData, CharityComplianceGetComplianceSigningSettingErrors, CharityComplianceGetComplianceSigningSettingResponses, CharityComplianceGetComplianceSubmissionData, CharityComplianceGetComplianceSubmissionErrors, CharityComplianceGetComplianceSubmissionPackageData, CharityComplianceGetComplianceSubmissionPackageErrors, CharityComplianceGetComplianceSubmissionPackageResponses, CharityComplianceGetComplianceSubmissionResponses, CharityComplianceGetComplianceVendorData, CharityComplianceGetComplianceVendorErrors, CharityComplianceGetComplianceVendorResponses, CharityComplianceHandComplianceFilingToDeskData, CharityComplianceHandComplianceFilingToDeskErrors, CharityComplianceHandComplianceFilingToDeskResponses, CharityComplianceImportComplianceRegistrationData, CharityComplianceImportComplianceRegistrationErrors, CharityComplianceImportComplianceRegistrationResponses, CharityComplianceIssueComplianceArtifactUploadUrlData, CharityComplianceIssueComplianceArtifactUploadUrlErrors, CharityComplianceIssueComplianceArtifactUploadUrlResponses, CharityComplianceIssueComplianceSigningRequestData, CharityComplianceIssueComplianceSigningRequestErrors, CharityComplianceIssueComplianceSigningRequestResponses, CharityComplianceLinkComplianceVendorFilingData, CharityComplianceLinkComplianceVendorFilingErrors, CharityComplianceLinkComplianceVendorFilingResponses, CharityComplianceListComplianceArtifactsData, CharityComplianceListComplianceArtifactsErrors, CharityComplianceListComplianceArtifactsResponses, CharityComplianceListComplianceCandidatesData, CharityComplianceListComplianceCandidatesErrors, CharityComplianceListComplianceCandidatesResponses, CharityComplianceListComplianceFilingCasesData, CharityComplianceListComplianceFilingCasesErrors, CharityComplianceListComplianceFilingCasesResponses, CharityComplianceListComplianceFilingDocumentsData, CharityComplianceListComplianceFilingDocumentsErrors, CharityComplianceListComplianceFilingDocumentsResponses, CharityComplianceListComplianceFilingGroupsData, CharityComplianceListComplianceFilingGroupsErrors, CharityComplianceListComplianceFilingGroupsResponses, CharityComplianceListComplianceFilingOptionsData, CharityComplianceListComplianceFilingOptionsErrors, CharityComplianceListComplianceFilingOptionsResponses, CharityComplianceListComplianceFormAdaptersData, CharityComplianceListComplianceFormAdaptersErrors, CharityComplianceListComplianceFormAdaptersResponses, CharityComplianceListComplianceFormPreparationsData, CharityComplianceListComplianceFormPreparationsErrors, CharityComplianceListComplianceFormPreparationsResponses, CharityComplianceListComplianceObligationArtifactsData, CharityComplianceListComplianceObligationArtifactsErrors, CharityComplianceListComplianceObligationArtifactsResponses, CharityComplianceListComplianceObligationsData, CharityComplianceListComplianceObligationsErrors, CharityComplianceListComplianceObligationsResponses, CharityComplianceListComplianceOccurrencesData, CharityComplianceListComplianceOccurrencesErrors, CharityComplianceListComplianceOccurrencesResponses, CharityComplianceListComplianceOrganizationFilingsData, CharityComplianceListComplianceOrganizationFilingsErrors, CharityComplianceListComplianceOrganizationFilingsResponses, CharityComplianceListCompliancePacketsData, CharityComplianceListCompliancePacketsErrors, CharityComplianceListCompliancePacketsResponses, CharityComplianceListComplianceProfileParametersData, CharityComplianceListComplianceProfileParametersErrors, CharityComplianceListComplianceProfileParametersResponses, CharityComplianceListComplianceProfileReviewFlagsData, CharityComplianceListComplianceProfileReviewFlagsErrors, CharityComplianceListComplianceProfileReviewFlagsResponses, CharityComplianceListComplianceProfileSuggestionsData, CharityComplianceListComplianceProfileSuggestionsErrors, CharityComplianceListComplianceProfileSuggestionsResponses, CharityComplianceListComplianceProposalItemsData, CharityComplianceListComplianceProposalItemsErrors, CharityComplianceListComplianceProposalItemsResponses, CharityComplianceListComplianceProposalResultsData, CharityComplianceListComplianceProposalResultsErrors, CharityComplianceListComplianceProposalResultsResponses, CharityComplianceListComplianceRegistrationImportAmendmentsData, CharityComplianceListComplianceRegistrationImportAmendmentsErrors, CharityComplianceListComplianceRegistrationImportAmendmentsResponses, CharityComplianceListComplianceRegistrationImportsData, CharityComplianceListComplianceRegistrationImportsErrors, CharityComplianceListComplianceRegistrationImportsResponses, CharityComplianceListComplianceRenewalCyclesData, CharityComplianceListComplianceRenewalCyclesErrors, CharityComplianceListComplianceRenewalCyclesResponses, CharityComplianceListComplianceReviewAsksData, CharityComplianceListComplianceReviewAsksErrors, CharityComplianceListComplianceReviewAsksResponses, CharityComplianceListComplianceSigningPeopleData, CharityComplianceListComplianceSigningPeopleErrors, CharityComplianceListComplianceSigningPeopleResponses, CharityComplianceListComplianceSigningRequestsData, CharityComplianceListComplianceSigningRequestsErrors, CharityComplianceListComplianceSigningRequestsResponses, CharityComplianceListComplianceSubmissionFollowThroughData, CharityComplianceListComplianceSubmissionFollowThroughErrors, CharityComplianceListComplianceSubmissionFollowThroughResponses, CharityComplianceListComplianceVendorsData, CharityComplianceListComplianceVendorsErrors, CharityComplianceListComplianceVendorsResponses, CharityComplianceMintComplianceFormVersionData, CharityComplianceMintComplianceFormVersionErrors, CharityComplianceMintComplianceFormVersionResponses, CharityComplianceMoveComplianceFilingGroupData, CharityComplianceMoveComplianceFilingGroupErrors, CharityComplianceMoveComplianceFilingGroupResponses, CharityComplianceMoveComplianceFilingToGroupData, CharityComplianceMoveComplianceFilingToGroupErrors, CharityComplianceMoveComplianceFilingToGroupResponses, CharityComplianceOpenComplianceFilingCaseData, CharityComplianceOpenComplianceFilingCaseErrors, CharityComplianceOpenComplianceFilingCaseResponses, CharityComplianceReconcileComplianceSubmissionAttemptData, CharityComplianceReconcileComplianceSubmissionAttemptErrors, CharityComplianceReconcileComplianceSubmissionAttemptResponses, CharityComplianceRecordComplianceChecklistActData, CharityComplianceRecordComplianceChecklistActErrors, CharityComplianceRecordComplianceChecklistActResponses, CharityComplianceRecordComplianceExecutedCopyData, CharityComplianceRecordComplianceExecutedCopyErrors, CharityComplianceRecordComplianceExecutedCopyResponses, CharityComplianceRecordComplianceFilingData, CharityComplianceRecordComplianceFilingErrors, CharityComplianceRecordComplianceFilingResponses, CharityComplianceRecordComplianceOrganizationFilingFiledData, CharityComplianceRecordComplianceOrganizationFilingFiledErrors, CharityComplianceRecordComplianceOrganizationFilingFiledResponses, CharityComplianceRecordComplianceOrganizationFilingSentData, CharityComplianceRecordComplianceOrganizationFilingSentErrors, CharityComplianceRecordComplianceOrganizationFilingSentResponses, CharityComplianceRecordComplianceProfileParameterData, CharityComplianceRecordComplianceProfileParameterErrors, CharityComplianceRecordComplianceProfileParameterResponses, CharityComplianceRecordComplianceProposalReviewData, CharityComplianceRecordComplianceProposalReviewErrors, CharityComplianceRecordComplianceProposalReviewResponses, CharityComplianceRecordComplianceRegistrationDateData, CharityComplianceRecordComplianceRegistrationDateErrors, CharityComplianceRecordComplianceRegistrationDateResponses, CharityComplianceRecordComplianceRenewalFilingData, CharityComplianceRecordComplianceRenewalFilingErrors, CharityComplianceRecordComplianceRenewalFilingResponses, CharityComplianceRecordComplianceRenewalSubmissionData, CharityComplianceRecordComplianceRenewalSubmissionErrors, CharityComplianceRecordComplianceRenewalSubmissionResponses, CharityComplianceRecordComplianceSubmissionData, CharityComplianceRecordComplianceSubmissionErrors, CharityComplianceRecordComplianceSubmissionEvidenceData, CharityComplianceRecordComplianceSubmissionEvidenceErrors, CharityComplianceRecordComplianceSubmissionEvidenceResponses, CharityComplianceRecordComplianceSubmissionHandoffData, CharityComplianceRecordComplianceSubmissionHandoffErrors, CharityComplianceRecordComplianceSubmissionHandoffResponses, CharityComplianceRecordComplianceSubmissionResponses, CharityComplianceRecordComplianceVendorData, CharityComplianceRecordComplianceVendorErrors, CharityComplianceRecordComplianceVendorResponses, CharityComplianceRecordComplianceWindowClosedData, CharityComplianceRecordComplianceWindowClosedErrors, CharityComplianceRecordComplianceWindowClosedResponses, CharityComplianceRegisterComplianceFilingDocumentVersionData, CharityComplianceRegisterComplianceFilingDocumentVersionErrors, CharityComplianceRegisterComplianceFilingDocumentVersionResponses, CharityComplianceRemoveComplianceFilingGroupData, CharityComplianceRemoveComplianceFilingGroupErrors, CharityComplianceRemoveComplianceFilingGroupResponses, CharityComplianceRemoveComplianceSigningIdentityData, CharityComplianceRemoveComplianceSigningIdentityErrors, CharityComplianceRemoveComplianceSigningIdentityResponses, CharityComplianceRenameComplianceFilingGroupData, CharityComplianceRenameComplianceFilingGroupErrors, CharityComplianceRenameComplianceFilingGroupResponses, CharityComplianceRepinComplianceObligationData, CharityComplianceRepinComplianceObligationErrors, CharityComplianceRepinComplianceObligationResponses, CharityComplianceResolveComplianceProfileReviewFlagData, CharityComplianceResolveComplianceProfileReviewFlagErrors, CharityComplianceResolveComplianceProfileReviewFlagResponses, CharityComplianceResolveComplianceProfileSuggestionData, CharityComplianceResolveComplianceProfileSuggestionErrors, CharityComplianceResolveComplianceProfileSuggestionResponses, CharityComplianceResumeComplianceDeskData, CharityComplianceResumeComplianceDeskErrors, CharityComplianceResumeComplianceDeskResponses, CharityComplianceResumeTrackingComplianceObligationData, CharityComplianceResumeTrackingComplianceObligationErrors, CharityComplianceResumeTrackingComplianceObligationResponses, CharityComplianceRetireComplianceOrganizationFilingData, CharityComplianceRetireComplianceOrganizationFilingErrors, CharityComplianceRetireComplianceOrganizationFilingResponses, CharityComplianceReviseComplianceSigningRequestData, CharityComplianceReviseComplianceSigningRequestErrors, CharityComplianceReviseComplianceSigningRequestResponses, CharityComplianceRevokeComplianceDeskAuthorizationData, CharityComplianceRevokeComplianceDeskAuthorizationErrors, CharityComplianceRevokeComplianceDeskAuthorizationResponses, CharityComplianceRevokeComplianceSubmissionAuthorizationData, CharityComplianceRevokeComplianceSubmissionAuthorizationErrors, CharityComplianceRevokeComplianceSubmissionAuthorizationResponses, CharityComplianceRunComplianceDerivationData, CharityComplianceRunComplianceDerivationErrors, CharityComplianceRunComplianceDerivationResponses, CharityComplianceSetComplianceAiSettingData, CharityComplianceSetComplianceAiSettingErrors, CharityComplianceSetComplianceAiSettingResponses, CharityComplianceSetComplianceSigningSettingData, CharityComplianceSetComplianceSigningSettingErrors, CharityComplianceSetComplianceSigningSettingResponses, CharityComplianceSignComplianceSigningRequestData, CharityComplianceSignComplianceSigningRequestErrors, CharityComplianceSignComplianceSigningRequestResponses, CharityComplianceStartComplianceFormPreparationData, CharityComplianceStartComplianceFormPreparationErrors, CharityComplianceStartComplianceFormPreparationResponses, CharityComplianceStopTrackingComplianceObligationData, CharityComplianceStopTrackingComplianceObligationErrors, CharityComplianceStopTrackingComplianceObligationResponses, CharityComplianceSwitchComplianceOrganizationFilingData, CharityComplianceSwitchComplianceOrganizationFilingErrors, CharityComplianceSwitchComplianceOrganizationFilingResponses, CharityComplianceTakeComplianceFilingFromDeskData, CharityComplianceTakeComplianceFilingFromDeskErrors, CharityComplianceTakeComplianceFilingFromDeskResponses, CharityComplianceUnlinkComplianceVendorFilingData, CharityComplianceUnlinkComplianceVendorFilingErrors, CharityComplianceUnlinkComplianceVendorFilingResponses, CharityComplianceUpdateComplianceOrganizationFilingData, CharityComplianceUpdateComplianceOrganizationFilingErrors, CharityComplianceUpdateComplianceOrganizationFilingResponses, CharityComplianceWithdrawComplianceFilingCaseData, CharityComplianceWithdrawComplianceFilingCaseErrors, CharityComplianceWithdrawComplianceFilingCaseResponses, CharityComplianceWithdrawComplianceReviewAskData, CharityComplianceWithdrawComplianceReviewAskErrors, CharityComplianceWithdrawComplianceReviewAskResponses, CharityComplianceWithdrawComplianceSignatureData, CharityComplianceWithdrawComplianceSignatureErrors, CharityComplianceWithdrawComplianceSignatureResponses, CharityEnrollmentConfirmOpeningBalanceFieldData, CharityEnrollmentConfirmOpeningBalanceFieldErrors, CharityEnrollmentConfirmOpeningBalanceFieldResponses, CharityEnrollmentCreateEnrollmentDraftData, CharityEnrollmentCreateEnrollmentDraftErrors, CharityEnrollmentCreateEnrollmentDraftResponses, CharityEnrollmentGetEnrollmentData, CharityEnrollmentGetEnrollmentErrors, CharityEnrollmentGetEnrollmentResponses, CharityEnrollmentListEnrollmentsData, CharityEnrollmentListEnrollmentsErrors, CharityEnrollmentListEnrollmentsResponses, CharityEnrollmentListMappingRowsData, CharityEnrollmentListMappingRowsErrors, CharityEnrollmentListMappingRowsResponses, CharityEnrollmentListOnboardingRecordsData, CharityEnrollmentListOnboardingRecordsErrors, CharityEnrollmentListOnboardingRecordsResponses, CharityEnrollmentListOpeningBalanceFieldsData, CharityEnrollmentListOpeningBalanceFieldsErrors, CharityEnrollmentListOpeningBalanceFieldsResponses, CharityEnrollmentRecordBackfillChoiceData, CharityEnrollmentRecordBackfillChoiceErrors, CharityEnrollmentRecordBackfillChoiceResponses, CharityEnrollmentResolveMappingRowData, CharityEnrollmentResolveMappingRowErrors, CharityEnrollmentResolveMappingRowResponses, CharityEnrollmentSeedOpeningBalanceFieldsData, CharityEnrollmentSeedOpeningBalanceFieldsErrors, CharityEnrollmentSeedOpeningBalanceFieldsResponses, CharityEnrollmentStartImportRunData, CharityEnrollmentStartImportRunErrors, CharityEnrollmentStartImportRunResponses, CharityEnrollmentSubmitEnrollmentData, CharityEnrollmentSubmitEnrollmentErrors, CharityEnrollmentSubmitEnrollmentResponses, CharityEnrollmentUpdateEnrollmentDraftData, CharityEnrollmentUpdateEnrollmentDraftErrors, CharityEnrollmentUpdateEnrollmentDraftResponses, CharityEnrollmentUpsertEntityMapsData, CharityEnrollmentUpsertEntityMapsErrors, CharityEnrollmentUpsertEntityMapsResponses, CharityEnrollmentWithdrawEnrollmentData, CharityEnrollmentWithdrawEnrollmentErrors, CharityEnrollmentWithdrawEnrollmentResponses, CompaniesActivateCompanyData, CompaniesActivateCompanyErrors, CompaniesActivateCompanyResponses, CompaniesApproveCompanyJoinRequestData, CompaniesApproveCompanyJoinRequestErrors, CompaniesApproveCompanyJoinRequestResponses, CompaniesApproveCompanyJoinRequestWithChoiceData, CompaniesApproveCompanyJoinRequestWithChoiceErrors, CompaniesApproveCompanyJoinRequestWithChoiceResponses, CompaniesApproveDonationMatchData, CompaniesApproveDonationMatchErrors, CompaniesApproveDonationMatchResponses, CompaniesChangeCompanyAdminRoleData, CompaniesChangeCompanyAdminRoleErrors, CompaniesChangeCompanyAdminRoleResponses, CompaniesChangeCompanyChampionHandleData, CompaniesChangeCompanyChampionHandleErrors, CompaniesChangeCompanyChampionHandleResponses, CompaniesCreateCompanyAdminData, CompaniesCreateCompanyAdminErrors, CompaniesCreateCompanyAdminResponses, CompaniesCreateCompanyCardData, CompaniesCreateCompanyCardErrors, CompaniesCreateCompanyCardResponses, CompaniesCreateCompanyCardV2Data, CompaniesCreateCompanyCardV2Errors, CompaniesCreateCompanyCardV2Responses, CompaniesCreateCompanyData, CompaniesCreateCompanyEmployeeInvitesData, CompaniesCreateCompanyEmployeeInvitesErrors, CompaniesCreateCompanyEmployeeInvitesResponses, CompaniesCreateCompanyErrors, CompaniesCreateCompanyFundraiserData, CompaniesCreateCompanyFundraiserErrors, CompaniesCreateCompanyFundraiserResponses, CompaniesCreateCompanyJoinRequestData, CompaniesCreateCompanyJoinRequestErrors, CompaniesCreateCompanyJoinRequestResponses, CompaniesCreateCompanyOccasionProgramData, CompaniesCreateCompanyOccasionProgramErrors, CompaniesCreateCompanyOccasionProgramResponses, CompaniesCreateCompanyResponses, CompaniesDeactivateCompanyData, CompaniesDeactivateCompanyResponses, CompaniesDeleteCompanyCardData, CompaniesDeleteCompanyCardErrors, CompaniesDeleteCompanyCardResponses, CompaniesDepositFundsCompanyData, CompaniesDepositFundsCompanyErrors, CompaniesDepositFundsCompanyResponses, CompaniesDownloadCompanyChampionQrData, CompaniesDownloadCompanyChampionQrErrors, CompaniesDownloadCompanyChampionQrResponses, CompaniesEnableCompanyProductData, CompaniesEnableCompanyProductErrors, CompaniesEnableCompanyProductResponses, CompaniesExportCompanyImpactCsvData, CompaniesExportCompanyImpactCsvResponses, CompaniesExportCompanyTaxLinesCsvData, CompaniesExportCompanyTaxLinesCsvErrors, CompaniesExportCompanyTaxLinesCsvResponses, CompaniesExportCompanyTransactionsCsvData, CompaniesExportCompanyTransactionsCsvErrors, CompaniesExportCompanyTransactionsCsvResponses, CompaniesGetCompanyAdminData, CompaniesGetCompanyAdminResponses, CompaniesGetCompanyAdminsData, CompaniesGetCompanyAdminsErrors, CompaniesGetCompanyAdminsResponses, CompaniesGetCompanyAuthPolicyData, CompaniesGetCompanyAuthPolicyResponses, CompaniesGetCompanyCardsData, CompaniesGetCompanyCardsResponses, CompaniesGetCompanyCardsV2Data, CompaniesGetCompanyCardsV2Responses, CompaniesGetCompanyChampionData, CompaniesGetCompanyChampionHandleSuggestionData, CompaniesGetCompanyChampionHandleSuggestionResponses, CompaniesGetCompanyChampionResponses, CompaniesGetCompanyDashboardData, CompaniesGetCompanyDashboardErrors, CompaniesGetCompanyDashboardResponses, CompaniesGetCompanyData, CompaniesGetCompanyDonationAmountData, CompaniesGetCompanyDonationAmountErrors, CompaniesGetCompanyDonationAmountResponses, CompaniesGetCompanyDonationVolumeData, CompaniesGetCompanyDonationVolumeResponses, CompaniesGetCompanyEmployeeInviteCountsData, CompaniesGetCompanyEmployeeInviteCountsResponses, CompaniesGetCompanyEmployeesData, CompaniesGetCompanyEmployeesErrors, CompaniesGetCompanyEmployeesResponses, CompaniesGetCompanyFundraiserReportData, CompaniesGetCompanyFundraiserReportErrors, CompaniesGetCompanyFundraiserReportResponses, CompaniesGetCompanyGiftCardBatchData, CompaniesGetCompanyGiftCardBatchErrors, CompaniesGetCompanyGiftCardBatchResponses, CompaniesGetCompanyGivingPublicationData, CompaniesGetCompanyGivingPublicationResponses, CompaniesGetCompanyMatchUtilizationData, CompaniesGetCompanyMatchUtilizationResponses, CompaniesGetCompanyOccasionPreflightData, CompaniesGetCompanyOccasionPreflightErrors, CompaniesGetCompanyOccasionPreflightResponses, CompaniesGetCompanyQrDesignData, CompaniesGetCompanyQrDesignResponses, CompaniesGetCompanyResponses, CompaniesGetCompanyTopCharitiesData, CompaniesGetCompanyTopCharitiesErrors, CompaniesGetCompanyTopCharitiesResponses, CompaniesGetCompanyWalletData, CompaniesGetCompanyWalletResponses, CompaniesGetMyCompanyData, CompaniesGetMyCompanyResponses, CompaniesGetPublicCompanyData, CompaniesGetPublicCompanyErrors, CompaniesGetPublicCompanyResponses, CompaniesGetPublicCompanyStatisticsData, CompaniesGetPublicCompanyStatisticsErrors, CompaniesGetPublicCompanyStatisticsResponses, CompaniesGetUserLocationData, CompaniesGetUserLocationErrors, CompaniesGetUserLocationResponses, CompaniesImportCompanyEmployeeOccasionDatesData, CompaniesImportCompanyEmployeeOccasionDatesErrors, CompaniesImportCompanyEmployeeOccasionDatesResponses, CompaniesListCompanyEmployeeInvitesData, CompaniesListCompanyEmployeeInvitesErrors, CompaniesListCompanyEmployeeInvitesResponses, CompaniesListCompanyFundraisersData, CompaniesListCompanyFundraisersResponses, CompaniesListCompanyGiftCardBatchesData, CompaniesListCompanyGiftCardBatchesErrors, CompaniesListCompanyGiftCardBatchesResponses, CompaniesListCompanyGiftCardsData, CompaniesListCompanyGiftCardsErrors, CompaniesListCompanyGiftCardsResponses, CompaniesListCompanyJoinRequestsData, CompaniesListCompanyJoinRequestsErrors, CompaniesListCompanyJoinRequestsResponses, CompaniesListCompanyModuleChoicesData, CompaniesListCompanyModuleChoicesErrors, CompaniesListCompanyModuleChoicesResponses, CompaniesListCompanyOccasionExecutionsData, CompaniesListCompanyOccasionExecutionsErrors, CompaniesListCompanyOccasionExecutionsResponses, CompaniesListCompanyOccasionProgramsData, CompaniesListCompanyOccasionProgramsErrors, CompaniesListCompanyOccasionProgramsResponses, CompaniesPauseCompanyOccasionProgramData, CompaniesPauseCompanyOccasionProgramErrors, CompaniesPauseCompanyOccasionProgramResponses, CompaniesQuoteCompanyDepositData, CompaniesQuoteCompanyDepositErrors, CompaniesQuoteCompanyDepositResponses, CompaniesQuoteCompanyDonationData, CompaniesQuoteCompanyDonationErrors, CompaniesQuoteCompanyDonationResponses, CompaniesRejectCompanyJoinRequestData, CompaniesRejectCompanyJoinRequestErrors, CompaniesRejectCompanyJoinRequestResponses, CompaniesRejectDonationMatchData, CompaniesRejectDonationMatchErrors, CompaniesRejectDonationMatchResponses, CompaniesRemoveAdminFromCompanyData, CompaniesRemoveAdminFromCompanyErrors, CompaniesRemoveAdminFromCompanyResponses, CompaniesRemoveEmployeesFromCompanyData, CompaniesRemoveEmployeesFromCompanyErrors, CompaniesRemoveEmployeesFromCompanyResponses, CompaniesResendCompanyEmployeeInviteData, CompaniesResendCompanyEmployeeInviteErrors, CompaniesResendCompanyEmployeeInviteResponses, CompaniesResolveCompanyOnboardingRouteData, CompaniesResolveCompanyOnboardingRouteResponses, CompaniesResumeCompanyOccasionProgramData, CompaniesResumeCompanyOccasionProgramErrors, CompaniesResumeCompanyOccasionProgramResponses, CompaniesSaveCompanyGivingPublicationData, CompaniesSaveCompanyGivingPublicationErrors, CompaniesSaveCompanyGivingPublicationResponses, CompaniesSaveCompanyQrDesignData, CompaniesSaveCompanyQrDesignErrors, CompaniesSaveCompanyQrDesignResponses, CompaniesSendCompanyGiftCardBatchData, CompaniesSendCompanyGiftCardBatchErrors, CompaniesSendCompanyGiftCardBatchResponses, CompaniesSendCompanyGiftCardData, CompaniesSendCompanyGiftCardErrors, CompaniesSendCompanyGiftCardResponses, CompaniesSetCompanyChampionCharityData, CompaniesSetCompanyChampionCharityErrors, CompaniesSetCompanyChampionCharityResponses, CompaniesSetCompanyEmployeeOccasionDatesData, CompaniesSetCompanyEmployeeOccasionDatesErrors, CompaniesSetCompanyEmployeeOccasionDatesResponses, CompaniesUpdateCompanyAccountInfoData, CompaniesUpdateCompanyAccountInfoErrors, CompaniesUpdateCompanyAccountInfoResponses, CompaniesUpdateCompanyActivityFeedVisibilityData, CompaniesUpdateCompanyActivityFeedVisibilityErrors, CompaniesUpdateCompanyActivityFeedVisibilityResponses, CompaniesUpdateCompanyAdminNameData, CompaniesUpdateCompanyAdminNameErrors, CompaniesUpdateCompanyAdminNameResponses, CompaniesUpdateCompanyAdminRoleData, CompaniesUpdateCompanyAdminRoleErrors, CompaniesUpdateCompanyAdminRoleResponses, CompaniesUpdateCompanyAuthPolicyData, CompaniesUpdateCompanyAuthPolicyErrors, CompaniesUpdateCompanyAuthPolicyResponses, CompaniesUpdateCompanyCustomerIdData, CompaniesUpdateCompanyCustomerIdErrors, CompaniesUpdateCompanyCustomerIdResponses, CompaniesUpdateCompanyMatchPolicyData, CompaniesUpdateCompanyMatchPolicyErrors, CompaniesUpdateCompanyMatchPolicyResponses, CompaniesUpdateCompanyOccasionProgramData, CompaniesUpdateCompanyOccasionProgramErrors, CompaniesUpdateCompanyOccasionProgramResponses, CompaniesUpdateCompanyPaymentMethodData, CompaniesUpdateCompanyPaymentMethodErrors, CompaniesUpdateCompanyPaymentMethodResponses, CompaniesUpdateCompanyPublicAmountsData, CompaniesUpdateCompanyPublicAmountsErrors, CompaniesUpdateCompanyPublicAmountsResponses, CompaniesUpdateCompanyVisibilityData, CompaniesUpdateCompanyVisibilityErrors, CompaniesUpdateCompanyVisibilityResponses, CompaniesUploadCompanyCoverPictureData, CompaniesUploadCompanyCoverPictureErrors, CompaniesUploadCompanyCoverPictureResponses, CompaniesUploadCompanyProfilePictureData, CompaniesUploadCompanyProfilePictureErrors, CompaniesUploadCompanyProfilePictureResponses, CompanyAdminProfilePageGetCompanyPageData, CompanyAdminProfilePageGetCompanyPageResponses, CompanyAdminProfilePageReplaceCompanyPageData, CompanyAdminProfilePageReplaceCompanyPageErrors, CompanyAdminProfilePageReplaceCompanyPageResponses, CompanyAdminProfilePageUploadCompanyPageImageData, CompanyAdminProfilePageUploadCompanyPageImageErrors, CompanyAdminProfilePageUploadCompanyPageImageResponses, ConnectDashboardInvitesCreateDashboardInviteData, ConnectDashboardInvitesCreateDashboardInviteErrors, ConnectDashboardInvitesCreateDashboardInviteResponses, ConnectPartnerApplicationsCreatePartnerApplicationData, ConnectPartnerApplicationsCreatePartnerApplicationErrors, ConnectPartnerApplicationsCreatePartnerApplicationResponses, ConnectPartnerApplicationsDecidePartnerApplicationData, ConnectPartnerApplicationsDecidePartnerApplicationErrors, ConnectPartnerApplicationsDecidePartnerApplicationResponses, ConnectPartnerApplicationsGetPartnerApplicationData, ConnectPartnerApplicationsGetPartnerApplicationErrors, ConnectPartnerApplicationsGetPartnerApplicationResponses, ConnectPartnerApplicationsListPartnerApplicationsData, ConnectPartnerApplicationsListPartnerApplicationsErrors, ConnectPartnerApplicationsListPartnerApplicationsResponses, ConnectPartnerApplicationsProvisionPartnerApplicationData, ConnectPartnerApplicationsProvisionPartnerApplicationErrors, ConnectPartnerApplicationsProvisionPartnerApplicationResponses, ConnectPartnerApplicationsUpdatePartnerApplicationData, ConnectPartnerApplicationsUpdatePartnerApplicationErrors, ConnectPartnerApplicationsUpdatePartnerApplicationResponses, ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionData, ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionErrors, ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionResponses, ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionData, ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionErrors, ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionResponses, ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsData, ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsErrors, ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsResponses, ConnectPartnerPromotionsDecidePartnerPromotionReviewData, ConnectPartnerPromotionsDecidePartnerPromotionReviewErrors, ConnectPartnerPromotionsDecidePartnerPromotionReviewResponses, ConnectPartnerPromotionsGetPartnerPromotionReviewData, ConnectPartnerPromotionsGetPartnerPromotionReviewErrors, ConnectPartnerPromotionsGetPartnerPromotionReviewResponses, ConnectPartnerPromotionsListPartnerPromotionReviewsData, ConnectPartnerPromotionsListPartnerPromotionReviewsErrors, ConnectPartnerPromotionsListPartnerPromotionReviewsResponses, ConnectPartnerPromotionsOpenPartnerPromotionReviewData, ConnectPartnerPromotionsOpenPartnerPromotionReviewErrors, ConnectPartnerPromotionsOpenPartnerPromotionReviewResponses, ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemData, ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemErrors, ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemResponses, ContentCategoriesCreateContentCategoryData, ContentCategoriesCreateContentCategoryErrors, ContentCategoriesCreateContentCategoryResponses, ContentCategoriesDeleteContentCategoryData, ContentCategoriesDeleteContentCategoryErrors, ContentCategoriesDeleteContentCategoryResponses, ContentCategoriesDeleteFeaturedItemImageData, ContentCategoriesDeleteFeaturedItemImageErrors, ContentCategoriesDeleteFeaturedItemImageResponses, ContentCategoriesDeleteFeaturedItemOverrideData, ContentCategoriesDeleteFeaturedItemOverrideErrors, ContentCategoriesDeleteFeaturedItemOverrideResponses, ContentCategoriesGetCauseTagsCuratedContentItemsData, ContentCategoriesGetCauseTagsCuratedContentItemsResponses, ContentCategoriesGetCelebrityCharitiesCuratedContentItemsData, ContentCategoriesGetCelebrityCharitiesCuratedContentItemsResponses, ContentCategoriesGetCharitiesCuratedContentItemsData, ContentCategoriesGetCharitiesCuratedContentItemsResponses, ContentCategoriesGetContentCategoriesData, ContentCategoriesGetContentCategoriesErrors, ContentCategoriesGetContentCategoriesResponses, ContentCategoriesGetContentCategoryItemsData, ContentCategoriesGetContentCategoryItemsErrors, ContentCategoriesGetContentCategoryItemsResponses, ContentCategoriesGetEtfsCuratedContentItemsData, ContentCategoriesGetEtfsCuratedContentItemsResponses, ContentCategoriesGetFeaturedContentItemsData, ContentCategoriesGetFeaturedContentItemsResponses, ContentCategoriesGetFundraisersCuratedContentItemsData, ContentCategoriesGetFundraisersCuratedContentItemsResponses, ContentCategoriesUpdateCategoryItemsData, ContentCategoriesUpdateCategoryItemsErrors, ContentCategoriesUpdateCategoryItemsResponses, ContentCategoriesUploadFeaturedItemImageData, ContentCategoriesUploadFeaturedItemImageErrors, ContentCategoriesUploadFeaturedItemImageResponses, ContentCategoriesUpsertFeaturedItemOverrideData, ContentCategoriesUpsertFeaturedItemOverrideErrors, ContentCategoriesUpsertFeaturedItemOverrideResponses, DafTransfersCancelDafTransferIntentData, DafTransfersCancelDafTransferIntentErrors, DafTransfersCancelDafTransferIntentResponses, DafTransfersCreateDafTransferIntentData, DafTransfersCreateDafTransferIntentErrors, DafTransfersCreateDafTransferIntentResponses, DafTransfersGetDafTransferTrackerData, DafTransfersGetDafTransferTrackerErrors, DafTransfersGetDafTransferTrackerResponses, DafTransfersListDafTransferIntentsData, DafTransfersListDafTransferIntentsErrors, DafTransfersListDafTransferIntentsResponses, DisclaimersBundleDisclaimerData, DisclaimersBundleDisclaimerErrors, DisclaimersBundleDisclaimerResponses, DisclaimersDisclaimerVersionsData, DisclaimersDisclaimerVersionsResponses, DisclaimersGetDisclaimerDetailData, DisclaimersGetDisclaimerDetailErrors, DisclaimersGetDisclaimerDetailResponses, DisclaimersListDisclaimersData, DisclaimersListDisclaimersErrors, DisclaimersListDisclaimersResponses, DisclaimersPatchDisclaimerDraftAtSuperAdminData, DisclaimersPatchDisclaimerDraftAtSuperAdminErrors, DisclaimersPatchDisclaimerDraftAtSuperAdminResponses, DisclaimersPatchDisclaimerDraftData, DisclaimersPatchDisclaimerDraftErrors, DisclaimersPatchDisclaimerDraftResponses, DisclaimersPublishDisclaimerAtSuperAdminData, DisclaimersPublishDisclaimerAtSuperAdminErrors, DisclaimersPublishDisclaimerAtSuperAdminResponses, DisclaimersPublishDisclaimerData, DisclaimersPublishDisclaimerErrors, DisclaimersPublishDisclaimerResponses, DisclaimersResolveDisclaimerData, DisclaimersResolveDisclaimerErrors, DisclaimersResolveDisclaimerResponses, DisclaimersSetDisclaimerEffectiveAtSuperAdminData, DisclaimersSetDisclaimerEffectiveAtSuperAdminErrors, DisclaimersSetDisclaimerEffectiveAtSuperAdminResponses, DisclaimersSetDisclaimerEffectiveData, DisclaimersSetDisclaimerEffectiveErrors, DisclaimersSetDisclaimerEffectiveResponses, DonationMatchesApproveCompanyMatchData, DonationMatchesApproveCompanyMatchErrors, DonationMatchesApproveCompanyMatchResponses, DonationMatchesApproveGroupCompanyMatchesData, DonationMatchesApproveGroupCompanyMatchesErrors, DonationMatchesApproveGroupCompanyMatchesResponses, DonationMatchesApproveGroupedCompanyMatchesData, DonationMatchesApproveGroupedCompanyMatchesErrors, DonationMatchesApproveGroupedCompanyMatchesResponses, DonationMatchesApproveMatchRequestData, DonationMatchesApproveMatchRequestErrors, DonationMatchesApproveMatchRequestResponses, DonationMatchesCheckCompanyMatchAllowedAmountData, DonationMatchesCheckCompanyMatchAllowedAmountErrors, DonationMatchesCheckCompanyMatchAllowedAmountResponses, DonationMatchesCheckGroupedMatchesAllowedAmountData, DonationMatchesCheckGroupedMatchesAllowedAmountErrors, DonationMatchesCheckGroupedMatchesAllowedAmountResponses, DonationMatchesCheckMatchRequestAllowedAmountData, DonationMatchesCheckMatchRequestAllowedAmountErrors, DonationMatchesCheckMatchRequestAllowedAmountResponses, DonationMatchesCreateUserMatchData, DonationMatchesCreateUserMatchErrors, DonationMatchesCreateUserMatchResponses, DonationMatchesGetDonationMatchesData, DonationMatchesGetDonationMatchesErrors, DonationMatchesGetDonationMatchesResponses, DonationMatchesGetMatchPaymentDisclosureData, DonationMatchesGetMatchPaymentDisclosureErrors, DonationMatchesGetMatchPaymentDisclosureResponses, DonationMatchesGetMatchRequestInboxData, DonationMatchesGetMatchRequestInboxResponses, DonationMatchesGetMyMatchesData, DonationMatchesGetMyMatchesResponses, DonationMatchesGetPendingGroupCompanyMatchesData, DonationMatchesGetPendingGroupCompanyMatchesErrors, DonationMatchesGetPendingGroupCompanyMatchesResponses, DonationMatchesGetPendingMatchesGroupedData, DonationMatchesGetPendingMatchesGroupedResponses, DonationMatchesQuoteCompanyMatchPaymentData, DonationMatchesQuoteCompanyMatchPaymentErrors, DonationMatchesQuoteCompanyMatchPaymentResponses, DonationMatchesRejectCompanyMatchData, DonationMatchesRejectCompanyMatchErrors, DonationMatchesRejectCompanyMatchResponses, DonationMatchesRejectGroupCompanyMatchesData, DonationMatchesRejectGroupCompanyMatchesErrors, DonationMatchesRejectGroupCompanyMatchesResponses, DonationMatchesRejectGroupedCompanyMatchesData, DonationMatchesRejectGroupedCompanyMatchesErrors, DonationMatchesRejectGroupedCompanyMatchesResponses, DonationMatchesRejectMatchRequestData, DonationMatchesRejectMatchRequestErrors, DonationMatchesRejectMatchRequestResponses, DonationsClaimDonationData, DonationsClaimDonationErrors, DonationsClaimDonationResponses, DonationsCreateCharityDonationData, DonationsCreateCharityDonationErrors, DonationsCreateCharityDonationResponses, DonationsCreateCharityRecurringDonationData, DonationsCreateCharityRecurringDonationErrors, DonationsCreateCharityRecurringDonationResponses, DonationsCreateEtfDonationData, DonationsCreateEtfDonationErrors, DonationsCreateEtfDonationResponses, DonationsCreateEtfRecurringDonationData, DonationsCreateEtfRecurringDonationErrors, DonationsCreateEtfRecurringDonationResponses, DonationsCreateExternalDonationData, DonationsCreateExternalDonationErrors, DonationsCreateExternalDonationResponses, DonationsCreateFundraiserDonationData, DonationsCreateFundraiserDonationErrors, DonationsCreateFundraiserDonationResponses, DonationsCreateUnauthenticatedDonationData, DonationsCreateUnauthenticatedDonationErrors, DonationsCreateUnauthenticatedDonationResponses, DonationsCreateUnauthenticatedEtfDonationData, DonationsCreateUnauthenticatedEtfDonationErrors, DonationsCreateUnauthenticatedEtfDonationResponses, DonationsCreateUnauthenticatedFundraiserDonationData, DonationsCreateUnauthenticatedFundraiserDonationErrors, DonationsCreateUnauthenticatedFundraiserDonationResponses, DonationsDownloadStatsReportData, DonationsDownloadStatsReportErrors, DonationsDownloadStatsReportResponses, DonationsGenerateCompanyStatsReportData, DonationsGenerateCompanyStatsReportErrors, DonationsGenerateCompanyStatsReportResponses, DonationsGenerateUserStatsReportData, DonationsGenerateUserStatsReportErrors, DonationsGenerateUserStatsReportResponses, DonationsGetDonationGrantConfirmationData, DonationsGetDonationGrantConfirmationErrors, DonationsGetDonationGrantConfirmationResponses, DonationsGetDonationJourneyData, DonationsGetDonationJourneyErrors, DonationsGetDonationJourneyResponses, DonationsGetDonationReceiptData, DonationsGetDonationReceiptErrors, DonationsGetDonationReceiptResponses, DonationsGetUserCompanyDonationsData, DonationsGetUserCompanyDonationsResponses, DonationsGetUserDonationsData, DonationsGetUserDonationsResponses, DonationsListCompanyStatsReportsData, DonationsListCompanyStatsReportsResponses, DonationsListUserStatsReportsData, DonationsListUserStatsReportsResponses, DonationsResendDonationGrantConfirmationData, DonationsResendDonationGrantConfirmationErrors, DonationsResendDonationGrantConfirmationResponses, DonationsResendDonationReceiptData, DonationsResendDonationReceiptErrors, DonationsResendDonationReceiptResponses, DonationsResolveDonationLinkData, DonationsResolveDonationLinkErrors, DonationsResolveDonationLinkResponses, DonationsRetryFailedReportGenerationsData, DonationsRetryFailedReportGenerationsResponses, EtfsAddCharityToEtfData, EtfsAddCharityToEtfErrors, EtfsAddCharityToEtfResponses, EtfsCreateEtfData, EtfsCreateEtfErrors, EtfsCreateEtfResponses, EtfsDeleteEtfData, EtfsDeleteEtfErrors, EtfsDeleteEtfResponses, EtfsGetEtfData, EtfsGetEtfErrors, EtfsGetEtfResponses, EtfsGetEtfsData, EtfsGetEtfsErrors, EtfsGetEtfsResponses, EtfsRemoveCharityFromEtfData, EtfsRemoveCharityFromEtfErrors, EtfsRemoveCharityFromEtfResponses, EtfsUpdateEtfData, EtfsUpdateEtfErrors, EtfsUpdateEtfResponses, EtfsUploadEtfProfilePictureData, EtfsUploadEtfProfilePictureErrors, EtfsUploadEtfProfilePictureResponses, FeesGetFeesData, FeesGetFeesResponses, FeesGetProcessorFeesData, FeesGetProcessorFeesResponses, FeesUpdateFeeData, FeesUpdateFeeErrors, FeesUpdateFeeResponses, FollowsFollowCharityData, FollowsFollowCharityErrors, FollowsFollowCharityResponses, FollowsFollowCompanyEmployeesData, FollowsFollowCompanyEmployeesResponses, FollowsFollowUserData, FollowsFollowUserErrors, FollowsFollowUserResponses, FollowsGetFollowedCharitiesData, FollowsGetFollowedCharitiesErrors, FollowsGetFollowedCharitiesResponses, FollowsGetUserFollowsData, FollowsGetUserFollowsErrors, FollowsGetUserFollowsResponses, FollowsSyncUserFacebookContactsData, FollowsSyncUserFacebookContactsErrors, FollowsSyncUserFacebookContactsResponses, FollowsSyncUserPhoneContactsData, FollowsSyncUserPhoneContactsErrors, FollowsSyncUserPhoneContactsResponses, FollowsUnfollowCharityData, FollowsUnfollowCharityErrors, FollowsUnfollowCharityResponses, FollowsUnfollowUserData, FollowsUnfollowUserErrors, FollowsUnfollowUserResponses, FundraiserMatchOfferRequestsAcceptMatchOfferRequestData, FundraiserMatchOfferRequestsAcceptMatchOfferRequestErrors, FundraiserMatchOfferRequestsAcceptMatchOfferRequestResponses, FundraiserMatchOfferRequestsCreateFundraiserMatchOfferData, FundraiserMatchOfferRequestsCreateFundraiserMatchOfferErrors, FundraiserMatchOfferRequestsCreateFundraiserMatchOfferResponses, FundraiserMatchOfferRequestsCreateMatchOfferRequestData, FundraiserMatchOfferRequestsCreateMatchOfferRequestErrors, FundraiserMatchOfferRequestsCreateMatchOfferRequestResponses, FundraiserMatchOfferRequestsDeclineMatchOfferRequestData, FundraiserMatchOfferRequestsDeclineMatchOfferRequestErrors, FundraiserMatchOfferRequestsDeclineMatchOfferRequestResponses, FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsData, FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsErrors, FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsResponses, FundraiserMatchOfferRequestsListOwnMatchOfferRequestsData, FundraiserMatchOfferRequestsListOwnMatchOfferRequestsErrors, FundraiserMatchOfferRequestsListOwnMatchOfferRequestsResponses, FundraiserMatchOfferRequestsWithdrawMatchOfferRequestData, FundraiserMatchOfferRequestsWithdrawMatchOfferRequestErrors, FundraiserMatchOfferRequestsWithdrawMatchOfferRequestResponses, FundraisersAcceptFundraiserMembershipData, FundraisersAcceptFundraiserMembershipErrors, FundraisersAcceptFundraiserMembershipResponses, FundraisersAddCharityToFundraiserData, FundraisersAddCharityToFundraiserErrors, FundraisersAddCharityToFundraiserResponses, FundraisersAddCollectionToFundraiserData, FundraisersAddCollectionToFundraiserErrors, FundraisersAddCollectionToFundraiserResponses, FundraisersAddEtfToFundraiserData, FundraisersAddEtfToFundraiserErrors, FundraisersAddEtfToFundraiserResponses, FundraisersAdminDeactivateFundraiserData, FundraisersAdminDeactivateFundraiserErrors, FundraisersAdminDeactivateFundraiserResponses, FundraisersAdminReinstateFundraiserData, FundraisersAdminReinstateFundraiserErrors, FundraisersAdminReinstateFundraiserResponses, FundraisersCloseFundraiserData, FundraisersCloseFundraiserErrors, FundraisersCloseFundraiserResponses, FundraisersCreateFundraiserData, FundraisersCreateFundraiserErrors, FundraisersCreateFundraiserResponses, FundraisersDeclineOrLeaveFundraiserMembershipData, FundraisersDeclineOrLeaveFundraiserMembershipErrors, FundraisersDeclineOrLeaveFundraiserMembershipResponses, FundraisersDeleteFundraiserData, FundraisersDeleteFundraiserErrors, FundraisersDeleteFundraiserResponses, FundraisersGetFundraiserData, FundraisersGetFundraiserErrors, FundraisersGetFundraiserInvitationData, FundraisersGetFundraiserInvitationErrors, FundraisersGetFundraiserInvitationResponses, FundraisersGetFundraiserInvitationsData, FundraisersGetFundraiserInvitationsErrors, FundraisersGetFundraiserInvitationsResponses, FundraisersGetFundraiserMembersData, FundraisersGetFundraiserMembersErrors, FundraisersGetFundraiserMembersResponses, FundraisersGetFundraiserResponses, FundraisersGetFundraisersData, FundraisersGetFundraisersErrors, FundraisersGetFundraisersResponses, FundraisersGetOwnFundraiserData, FundraisersGetOwnFundraiserErrors, FundraisersGetOwnFundraiserResponses, FundraisersGetOwnFundraisersData, FundraisersGetOwnFundraisersErrors, FundraisersGetOwnFundraisersResponses, FundraisersGetStartedByFriendsData, FundraisersGetStartedByFriendsErrors, FundraisersGetStartedByFriendsResponses, FundraisersGetSuperAdminFundraiserDonationsData, FundraisersGetSuperAdminFundraiserDonationsErrors, FundraisersGetSuperAdminFundraiserDonationsResponses, FundraisersGetSuperAdminFundraisersData, FundraisersGetSuperAdminFundraisersErrors, FundraisersGetSuperAdminFundraisersResponses, FundraisersGetSupportedByFriendsData, FundraisersGetSupportedByFriendsErrors, FundraisersGetSupportedByFriendsResponses, FundraisersInviteFundraiserMemberData, FundraisersInviteFundraiserMemberErrors, FundraisersInviteFundraiserMemberResponses, FundraisersPublishFundraiserData, FundraisersPublishFundraiserErrors, FundraisersPublishFundraiserResponses, FundraisersReactivateFundraiserData, FundraisersReactivateFundraiserErrors, FundraisersReactivateFundraiserResponses, FundraisersRemoveCharityFromFundraiserData, FundraisersRemoveCharityFromFundraiserErrors, FundraisersRemoveCharityFromFundraiserResponses, FundraisersRemoveCollectionFromFundraiserData, FundraisersRemoveCollectionFromFundraiserErrors, FundraisersRemoveCollectionFromFundraiserResponses, FundraisersRemoveEtfFromFundraiserData, FundraisersRemoveEtfFromFundraiserErrors, FundraisersRemoveEtfFromFundraiserResponses, FundraisersRemoveFundraiserMemberData, FundraisersRemoveFundraiserMemberErrors, FundraisersRemoveFundraiserMemberResponses, FundraisersReopenFundraiserData, FundraisersReopenFundraiserErrors, FundraisersReopenFundraiserResponses, FundraisersTransferFundraiserOwnershipData, FundraisersTransferFundraiserOwnershipErrors, FundraisersTransferFundraiserOwnershipResponses, FundraisersUpdateFundraiserData, FundraisersUpdateFundraiserErrors, FundraisersUpdateFundraiserResponses, FundraisersUploadFundraiserPictureData, FundraisersUploadFundraiserPictureErrors, FundraisersUploadFundraiserPictureResponses, GameAwardGameTreatsData, GameAwardGameTreatsErrors, GameAwardGameTreatsResponses, GameCatchGameDogData, GameCatchGameDogResponses, GameClaimGameObjectData, GameClaimGameObjectErrors, GameClaimGameObjectResponses, GameClaimGameSurpriseData, GameClaimGameSurpriseErrors, GameClaimGameSurpriseResponses, GameCreateGameProfileData, GameCreateGameProfileErrors, GameCreateGameProfileResponses, GameEarnGameCoinsData, GameEarnGameCoinsErrors, GameEarnGameCoinsResponses, GameGetGameCatalogData, GameGetGameCatalogResponses, GameGetGameCharityFoundationData, GameGetGameCharityFoundationErrors, GameGetGameCharityFoundationResponses, GameGetGameCoinsData, GameGetGameCoinsErrors, GameGetGameCoinsResponses, GameGetGameConfigData, GameGetGameConfigResponses, GameGetGameDogStatusData, GameGetGameDogStatusResponses, GameGetGameFoundationData, GameGetGameFoundationResponses, GameGetGameMapEntitiesData, GameGetGameMapEntitiesErrors, GameGetGameMapEntitiesResponses, GameGetGamePendingGiftsData, GameGetGamePendingGiftsErrors, GameGetGamePendingGiftsResponses, GameGetGameProfileData, GameGetGameProfileResponses, GameGetGameScrapbookData, GameGetGameScrapbookErrors, GameGetGameScrapbookResponses, GameGetGameTreatsData, GameGetGameTreatsResponses, GameGetUserGameFoundationData, GameGetUserGameFoundationErrors, GameGetUserGameFoundationResponses, GamePutGameFoundationData, GamePutGameFoundationErrors, GamePutGameFoundationResponses, GameRemoveCharityFoundationReactionData, GameRemoveCharityFoundationReactionErrors, GameRemoveCharityFoundationReactionResponses, GameRemoveUserFoundationReactionData, GameRemoveUserFoundationReactionErrors, GameRemoveUserFoundationReactionResponses, GameSearchGameCitiesData, GameSearchGameCitiesErrors, GameSearchGameCitiesResponses, GameSetCharityFoundationReactionData, GameSetCharityFoundationReactionErrors, GameSetCharityFoundationReactionResponses, GameSetGameRescueVisitorData, GameSetGameRescueVisitorErrors, GameSetGameRescueVisitorResponses, GameSetUserFoundationReactionData, GameSetUserFoundationReactionErrors, GameSetUserFoundationReactionResponses, GiftCardsClaimGiftCardData, GiftCardsClaimGiftCardErrors, GiftCardsClaimGiftCardResponses, GiftCardsListGiftCardsSuperAdminData, GiftCardsListGiftCardsSuperAdminErrors, GiftCardsListGiftCardsSuperAdminResponses, GiftCardsListMyGiftCardsData, GiftCardsListMyGiftCardsErrors, GiftCardsListMyGiftCardsResponses, GiftCardsManualIssueGiftCardData, GiftCardsManualIssueGiftCardErrors, GiftCardsManualIssueGiftCardResponses, GiftCardsPreviewGiftCardClaimData, GiftCardsPreviewGiftCardClaimErrors, GiftCardsPreviewGiftCardClaimResponses, GiftCardsPreviewGiftCardData, GiftCardsPreviewGiftCardErrors, GiftCardsPreviewGiftCardResponses, GiftCardsPurchaseGiftCardAuthenticatedData, GiftCardsPurchaseGiftCardAuthenticatedErrors, GiftCardsPurchaseGiftCardAuthenticatedResponses, GiftCardsPurchaseGiftCardData, GiftCardsPurchaseGiftCardErrors, GiftCardsPurchaseGiftCardResponses, GiftCardsRedeemGiftCardData, GiftCardsRedeemGiftCardErrors, GiftCardsRedeemGiftCardResponses, GiftCardsReissueFailedBatchDeliveriesData, GiftCardsReissueFailedBatchDeliveriesErrors, GiftCardsReissueFailedBatchDeliveriesResponses, GiftCardsReissueGiftCardData, GiftCardsReissueGiftCardErrors, GiftCardsReissueGiftCardResponses, GiftCardsSendGiftCardFromWalletData, GiftCardsSendGiftCardFromWalletErrors, GiftCardsSendGiftCardFromWalletResponses, GiftCardsVoidGiftCardData, GiftCardsVoidGiftCardErrors, GiftCardsVoidGiftCardResponses, GivingPacketListGivingPacketReportsData, GivingPacketListGivingPacketReportsErrors, GivingPacketListGivingPacketReportsResponses, GivingPacketRequestGivingPacketData, GivingPacketRequestGivingPacketErrors, GivingPacketRequestGivingPacketResponses, GrantsGetGrantData, GrantsGetGrantErrors, GrantsGetGrantResponses, GrantsGetGrantsByCharityData, GrantsGetGrantsByCharityErrors, GrantsGetGrantsByCharityResponses, GrantsGetGrantsData, GrantsGetGrantsErrors, GrantsGetGrantsResponses, GrantsGetSuperAdminGrantDonationsData, GrantsGetSuperAdminGrantDonationsErrors, GrantsGetSuperAdminGrantDonationsResponses, GrantsGetSuperAdminGrantsData, GrantsGetSuperAdminGrantsErrors, GrantsGetSuperAdminGrantsResponses, GrantsMarkGrantReturnedData, GrantsMarkGrantReturnedErrors, GrantsMarkGrantReturnedResponses, GrantsMarkGrantSentData, GrantsMarkGrantSentErrors, GrantsMarkGrantSentResponses, GrantsMintCohortData, GrantsMintCohortErrors, GrantsMintCohortResponses, GrantsUnmintGrantData, GrantsUnmintGrantErrors, GrantsUnmintGrantResponses, GrantsUpdateGrantData, GrantsUpdateGrantErrors, GrantsUpdateGrantResponses, GroupsAcceptGroupInviteByTokenData, GroupsAcceptGroupInviteByTokenErrors, GroupsAcceptGroupInviteByTokenResponses, GroupsAcceptGroupInviteData, GroupsAcceptGroupInviteErrors, GroupsAcceptGroupInviteResponses, GroupsAcceptGroupOwnershipTransferData, GroupsAcceptGroupOwnershipTransferErrors, GroupsAcceptGroupOwnershipTransferResponses, GroupsApproveGroupDonationRequestData, GroupsApproveGroupDonationRequestErrors, GroupsApproveGroupDonationRequestResponses, GroupsApproveGroupJoinRequestData, GroupsApproveGroupJoinRequestErrors, GroupsApproveGroupJoinRequestResponses, GroupsApproveGuardianMembershipData, GroupsApproveGuardianMembershipErrors, GroupsApproveGuardianMembershipResponses, GroupsCancelGroupRecurringContributionData, GroupsCancelGroupRecurringContributionErrors, GroupsCancelGroupRecurringContributionResponses, GroupsContributeToGroupData, GroupsContributeToGroupErrors, GroupsContributeToGroupResponses, GroupsCreateGroupData, GroupsCreateGroupDonationRequestData, GroupsCreateGroupDonationRequestErrors, GroupsCreateGroupDonationRequestResponses, GroupsCreateGroupErrors, GroupsCreateGroupFundraiserData, GroupsCreateGroupFundraiserErrors, GroupsCreateGroupFundraiserResponses, GroupsCreateGroupRecurringContributionData, GroupsCreateGroupRecurringContributionErrors, GroupsCreateGroupRecurringContributionResponses, GroupsCreateGroupResponses, GroupsDeleteGroupData, GroupsDeleteGroupErrors, GroupsDeleteGroupInviteData, GroupsDeleteGroupInviteErrors, GroupsDeleteGroupInviteResponses, GroupsDeleteGroupResponses, GroupsDiscoverGroupsData, GroupsDiscoverGroupsErrors, GroupsDiscoverGroupsResponses, GroupsDonateFromGroupData, GroupsDonateFromGroupErrors, GroupsDonateFromGroupResponses, GroupsFollowGroupData, GroupsFollowGroupErrors, GroupsFollowGroupResponses, GroupsGetGroupActivityData, GroupsGetGroupActivityErrors, GroupsGetGroupActivityResponses, GroupsGetGroupByHandleData, GroupsGetGroupByHandleErrors, GroupsGetGroupByHandleResponses, GroupsGetGroupData, GroupsGetGroupErrors, GroupsGetGroupOwnershipTransferData, GroupsGetGroupOwnershipTransferErrors, GroupsGetGroupOwnershipTransferResponses, GroupsGetGroupResponses, GroupsGetGroupWalletData, GroupsGetGroupWalletErrors, GroupsGetGroupWalletResponses, GroupsGetMyGroupContributionData, GroupsGetMyGroupContributionErrors, GroupsGetMyGroupContributionResponses, GroupsGetMyGroupStatsData, GroupsGetMyGroupStatsErrors, GroupsGetMyGroupStatsResponses, GroupsInviteGroupMemberData, GroupsInviteGroupMemberErrors, GroupsInviteGroupMemberResponses, GroupsLeaveGroupData, GroupsLeaveGroupErrors, GroupsLeaveGroupResponses, GroupsListGroupDonationRequestsData, GroupsListGroupDonationRequestsErrors, GroupsListGroupDonationRequestsResponses, GroupsListGroupJoinRequestsData, GroupsListGroupJoinRequestsErrors, GroupsListGroupJoinRequestsResponses, GroupsListGroupMembersData, GroupsListGroupMembersErrors, GroupsListGroupMembersResponses, GroupsListGuardianApprovalsData, GroupsListGuardianApprovalsErrors, GroupsListGuardianApprovalsResponses, GroupsListGuardianMinorsData, GroupsListGuardianMinorsErrors, GroupsListGuardianMinorsResponses, GroupsListMyGroupInvitationsData, GroupsListMyGroupInvitationsErrors, GroupsListMyGroupInvitationsResponses, GroupsListMyGroupsData, GroupsListMyGroupsErrors, GroupsListMyGroupsResponses, GroupsOfferGroupOwnershipTransferData, GroupsOfferGroupOwnershipTransferErrors, GroupsOfferGroupOwnershipTransferResponses, GroupsPublishGroupData, GroupsPublishGroupErrors, GroupsPublishGroupResponses, GroupsRejectGroupDonationRequestData, GroupsRejectGroupDonationRequestErrors, GroupsRejectGroupDonationRequestResponses, GroupsRejectGroupJoinRequestData, GroupsRejectGroupJoinRequestErrors, GroupsRejectGroupJoinRequestResponses, GroupsRejectGuardianMembershipData, GroupsRejectGuardianMembershipErrors, GroupsRejectGuardianMembershipResponses, GroupsRequestToJoinGroupData, GroupsRequestToJoinGroupErrors, GroupsRequestToJoinGroupResponses, GroupsRevokeGroupOwnershipTransferData, GroupsRevokeGroupOwnershipTransferErrors, GroupsRevokeGroupOwnershipTransferResponses, GroupsUnfollowGroupData, GroupsUnfollowGroupErrors, GroupsUnfollowGroupResponses, GroupsUpdateGroupData, GroupsUpdateGroupErrors, GroupsUpdateGroupMatchSettingData, GroupsUpdateGroupMatchSettingErrors, GroupsUpdateGroupMatchSettingResponses, GroupsUpdateGroupMemberData, GroupsUpdateGroupMemberErrors, GroupsUpdateGroupMemberResponses, GroupsUpdateGroupResponses, GroupsUpdateGuardianMinorSettingsData, GroupsUpdateGuardianMinorSettingsErrors, GroupsUpdateGuardianMinorSettingsResponses, GroupsUploadGroupPictureData, GroupsUploadGroupPictureErrors, GroupsUploadGroupPictureResponses, ImportedReceiptsConfirmImportedReceiptData, ImportedReceiptsConfirmImportedReceiptErrors, ImportedReceiptsConfirmImportedReceiptResponses, ImportedReceiptsDeleteImportedDonationData, ImportedReceiptsDeleteImportedDonationErrors, ImportedReceiptsDeleteImportedDonationResponses, ImportedReceiptsDeleteImportedReceiptData, ImportedReceiptsDeleteImportedReceiptErrors, ImportedReceiptsDeleteImportedReceiptResponses, ImportedReceiptsExportImportedDonationsCsvData, ImportedReceiptsExportImportedDonationsCsvErrors, ImportedReceiptsExportImportedDonationsCsvResponses, ImportedReceiptsGetImportedReceiptData, ImportedReceiptsGetImportedReceiptErrors, ImportedReceiptsGetImportedReceiptResponses, ImportedReceiptsListImportedDonationsData, ImportedReceiptsListImportedDonationsErrors, ImportedReceiptsListImportedDonationsResponses, ImportedReceiptsListImportedReceiptsData, ImportedReceiptsListImportedReceiptsErrors, ImportedReceiptsListImportedReceiptsResponses, ImportedReceiptsRegisterImportedReceiptData, ImportedReceiptsRegisterImportedReceiptErrors, ImportedReceiptsRegisterImportedReceiptResponses, ImportedReceiptsRequestImportedReceiptUploadUrlData, ImportedReceiptsRequestImportedReceiptUploadUrlErrors, ImportedReceiptsRequestImportedReceiptUploadUrlResponses, MatchOffersCancelMatchOfferData, MatchOffersCancelMatchOfferErrors, MatchOffersCancelMatchOfferResponses, MatchOffersCreateMatchOfferData, MatchOffersCreateMatchOfferErrors, MatchOffersCreateMatchOfferResponses, MatchOffersGetMyMatchOfferData, MatchOffersGetMyMatchOfferErrors, MatchOffersGetMyMatchOfferResponses, MatchOffersListCharityMatchOffersData, MatchOffersListCharityMatchOffersErrors, MatchOffersListCharityMatchOffersResponses, MatchOffersListMyMatchOffersData, MatchOffersListMyMatchOffersErrors, MatchOffersListMyMatchOffersResponses, MatchOffersRedirectMatchClaimData, MatchOffersRedirectMatchClaimErrors, MatchOffersRedirectMatchClaimResponses, NotificationsGetNotificationsData, NotificationsGetNotificationsErrors, NotificationsGetNotificationsResponses, NotificationsGetUnreadCountData, NotificationsGetUnreadCountResponses, NotificationsMarkAllNotificationsReadData, NotificationsMarkAllNotificationsReadResponses, NotificationsMarkNotificationReadData, NotificationsMarkNotificationReadErrors, NotificationsMarkNotificationReadResponses, NotificationsRegisterDeviceTokenData, NotificationsRegisterDeviceTokenErrors, NotificationsRegisterDeviceTokenResponses, NotificationsUnregisterDeviceTokenData, NotificationsUnregisterDeviceTokenErrors, NotificationsUnregisterDeviceTokenResponses, OrganizerMessagesGetOrganizerMessageUnsubscribeData, OrganizerMessagesGetOrganizerMessageUnsubscribeErrors, OrganizerMessagesGetOrganizerMessageUnsubscribeResponses, OrganizerMessagesPostOrganizerMessageUnsubscribeData, OrganizerMessagesPostOrganizerMessageUnsubscribeErrors, OrganizerMessagesPostOrganizerMessageUnsubscribeResponses, OrgBoardOrgAddBoardCommitteeMemberData, OrgBoardOrgAddBoardCommitteeMemberErrors, OrgBoardOrgAddBoardCommitteeMemberResponses, OrgBoardOrgAddBoardCommitteeSuggestionItemsData, OrgBoardOrgAddBoardCommitteeSuggestionItemsErrors, OrgBoardOrgAddBoardCommitteeSuggestionItemsResponses, OrgBoardOrgAddBoardConsentCompensationDecisionData, OrgBoardOrgAddBoardConsentCompensationDecisionErrors, OrgBoardOrgAddBoardConsentCompensationDecisionResponses, OrgBoardOrgAddBoardMemberToBoardData, OrgBoardOrgAddBoardMemberToBoardErrors, OrgBoardOrgAddBoardMemberToBoardResponses, OrgBoardOrgAddBoardMotionCompensationDecisionData, OrgBoardOrgAddBoardMotionCompensationDecisionErrors, OrgBoardOrgAddBoardMotionCompensationDecisionResponses, OrgBoardOrgAddBoardTermSuggestionItemsData, OrgBoardOrgAddBoardTermSuggestionItemsErrors, OrgBoardOrgAddBoardTermSuggestionItemsResponses, OrgBoardOrgAdoptBoardCalendarSettingsData, OrgBoardOrgAdoptBoardCalendarSettingsErrors, OrgBoardOrgAdoptBoardCalendarSettingsResponses, OrgBoardOrgAdoptBoardOfficerDutiesData, OrgBoardOrgAdoptBoardOfficerDutiesErrors, OrgBoardOrgAdoptBoardOfficerDutiesResponses, OrgBoardOrgAdoptBoardRetentionPolicyData, OrgBoardOrgAdoptBoardRetentionPolicyErrors, OrgBoardOrgAdoptBoardRetentionPolicyResponses, OrgBoardOrgApplyBoardAgendaTemplateData, OrgBoardOrgApplyBoardAgendaTemplateErrors, OrgBoardOrgApplyBoardAgendaTemplateResponses, OrgBoardOrgApplyBoardCalendarSettingsData, OrgBoardOrgApplyBoardCalendarSettingsErrors, OrgBoardOrgApplyBoardCalendarSettingsResponses, OrgBoardOrgApproveBoardMinutesData, OrgBoardOrgApproveBoardMinutesErrors, OrgBoardOrgApproveBoardMinutesResponses, OrgBoardOrgApproveBoardRecordData, OrgBoardOrgApproveBoardRecordErrors, OrgBoardOrgApproveBoardRecordResponses, OrgBoardOrgAskBoardMinutesApprovalSignaturesData, OrgBoardOrgAskBoardMinutesApprovalSignaturesErrors, OrgBoardOrgAskBoardMinutesApprovalSignaturesResponses, OrgBoardOrgCancelBoardCoiCycleData, OrgBoardOrgCancelBoardCoiCycleErrors, OrgBoardOrgCancelBoardCoiCycleResponses, OrgBoardOrgCancelBoardMeetingData, OrgBoardOrgCancelBoardMeetingErrors, OrgBoardOrgCancelBoardMeetingResponses, OrgBoardOrgCancelBoardSelfAssessmentData, OrgBoardOrgCancelBoardSelfAssessmentErrors, OrgBoardOrgCancelBoardSelfAssessmentResponses, OrgBoardOrgCheckBoardImportInboxFileData, OrgBoardOrgCheckBoardImportInboxFileErrors, OrgBoardOrgCheckBoardImportInboxFileResponses, OrgBoardOrgCheckBoardProposalFileData, OrgBoardOrgCheckBoardProposalFileErrors, OrgBoardOrgCheckBoardProposalFileResponses, OrgBoardOrgChooseBoardMemberBuddyData, OrgBoardOrgChooseBoardMemberBuddyErrors, OrgBoardOrgChooseBoardMemberBuddyResponses, OrgBoardOrgCirculateBoardWrittenConsentData, OrgBoardOrgCirculateBoardWrittenConsentErrors, OrgBoardOrgCirculateBoardWrittenConsentResponses, OrgBoardOrgCloseBoardCoiCycleData, OrgBoardOrgCloseBoardCoiCycleErrors, OrgBoardOrgCloseBoardCoiCycleResponses, OrgBoardOrgCloseBoardImportBatchData, OrgBoardOrgCloseBoardImportBatchErrors, OrgBoardOrgCloseBoardImportBatchResponses, OrgBoardOrgCloseBoardMemberGettingStartedData, OrgBoardOrgCloseBoardMemberGettingStartedErrors, OrgBoardOrgCloseBoardMemberGettingStartedResponses, OrgBoardOrgCloseBoardSelfAssessmentData, OrgBoardOrgCloseBoardSelfAssessmentErrors, OrgBoardOrgCloseBoardSelfAssessmentResponses, OrgBoardOrgConfirmBoardCompensationDocumentData, OrgBoardOrgConfirmBoardCompensationDocumentErrors, OrgBoardOrgConfirmBoardCompensationDocumentResponses, OrgBoardOrgConfirmBoardDocumentData, OrgBoardOrgConfirmBoardDocumentErrors, OrgBoardOrgConfirmBoardDocumentResponses, OrgBoardOrgConfirmBoardPastRecordBatchData, OrgBoardOrgConfirmBoardPastRecordBatchErrors, OrgBoardOrgConfirmBoardPastRecordBatchResponses, OrgBoardOrgConfirmBoardReturnCopyData, OrgBoardOrgConfirmBoardReturnCopyErrors, OrgBoardOrgConfirmBoardReturnCopyResponses, OrgBoardOrgCorrectBoardCommitteeDissolutionData, OrgBoardOrgCorrectBoardCommitteeDissolutionErrors, OrgBoardOrgCorrectBoardCommitteeDissolutionResponses, OrgBoardOrgCreateBoardAgendaItemData, OrgBoardOrgCreateBoardAgendaItemErrors, OrgBoardOrgCreateBoardAgendaItemResponses, OrgBoardOrgCreateBoardCommitteeData, OrgBoardOrgCreateBoardCommitteeErrors, OrgBoardOrgCreateBoardCommitteeResponses, OrgBoardOrgCreateBoardDirectorClassData, OrgBoardOrgCreateBoardDirectorClassErrors, OrgBoardOrgCreateBoardDirectorClassResponses, OrgBoardOrgCreateBoardMeetingData, OrgBoardOrgCreateBoardMeetingErrors, OrgBoardOrgCreateBoardMeetingResponses, OrgBoardOrgCreateBoardMeetingSegmentData, OrgBoardOrgCreateBoardMeetingSegmentErrors, OrgBoardOrgCreateBoardMeetingSegmentResponses, OrgBoardOrgCreateBoardMemberData, OrgBoardOrgCreateBoardMemberErrors, OrgBoardOrgCreateBoardMemberResponses, OrgBoardOrgCreateBoardMinutesApprovalConsentData, OrgBoardOrgCreateBoardMinutesApprovalConsentErrors, OrgBoardOrgCreateBoardMinutesApprovalConsentResponses, OrgBoardOrgCreateBoardMotionData, OrgBoardOrgCreateBoardMotionErrors, OrgBoardOrgCreateBoardMotionResponses, OrgBoardOrgCreateBoardOfficerTitleData, OrgBoardOrgCreateBoardOfficerTitleErrors, OrgBoardOrgCreateBoardOfficerTitleResponses, OrgBoardOrgCreateBoardPacketData, OrgBoardOrgCreateBoardPacketErrors, OrgBoardOrgCreateBoardPacketItemData, OrgBoardOrgCreateBoardPacketItemErrors, OrgBoardOrgCreateBoardPacketItemResponses, OrgBoardOrgCreateBoardPacketResponses, OrgBoardOrgCreateBoardRecordDraftData, OrgBoardOrgCreateBoardRecordDraftErrors, OrgBoardOrgCreateBoardRecordDraftResponses, OrgBoardOrgCreateBoardWrittenConsentData, OrgBoardOrgCreateBoardWrittenConsentErrors, OrgBoardOrgCreateBoardWrittenConsentResponses, OrgBoardOrgDeleteBoardAgendaItemData, OrgBoardOrgDeleteBoardAgendaItemErrors, OrgBoardOrgDeleteBoardAgendaItemResponses, OrgBoardOrgDeleteBoardConflictLinkData, OrgBoardOrgDeleteBoardConflictLinkErrors, OrgBoardOrgDeleteBoardConflictLinkResponses, OrgBoardOrgDeleteBoardImportFileUploadData, OrgBoardOrgDeleteBoardImportFileUploadErrors, OrgBoardOrgDeleteBoardImportFileUploadResponses, OrgBoardOrgDeleteBoardImportRecordFileUploadData, OrgBoardOrgDeleteBoardImportRecordFileUploadErrors, OrgBoardOrgDeleteBoardImportRecordFileUploadResponses, OrgBoardOrgDeleteBoardMeetingSegmentData, OrgBoardOrgDeleteBoardMeetingSegmentErrors, OrgBoardOrgDeleteBoardMeetingSegmentResponses, OrgBoardOrgDeleteBoardMotionData, OrgBoardOrgDeleteBoardMotionErrors, OrgBoardOrgDeleteBoardMotionResponses, OrgBoardOrgDeleteBoardPacketItemData, OrgBoardOrgDeleteBoardPacketItemErrors, OrgBoardOrgDeleteBoardPacketItemResponses, OrgBoardOrgDeleteBoardRecordChainData, OrgBoardOrgDeleteBoardRecordChainErrors, OrgBoardOrgDeleteBoardRecordChainResponses, OrgBoardOrgDeleteBoardRecordData, OrgBoardOrgDeleteBoardRecordErrors, OrgBoardOrgDeleteBoardRecordResponses, OrgBoardOrgDiscardBoardMemberProposalData, OrgBoardOrgDiscardBoardMemberProposalErrors, OrgBoardOrgDiscardBoardMemberProposalResponses, OrgBoardOrgDiscardBoardPacketData, OrgBoardOrgDiscardBoardPacketErrors, OrgBoardOrgDiscardBoardPacketResponses, OrgBoardOrgDiscardBoardPastRecordBatchData, OrgBoardOrgDiscardBoardPastRecordBatchErrors, OrgBoardOrgDiscardBoardPastRecordBatchResponses, OrgBoardOrgDiscardBoardRecordDraftData, OrgBoardOrgDiscardBoardRecordDraftErrors, OrgBoardOrgDiscardBoardRecordDraftResponses, OrgBoardOrgDismissBoardCommitteeSuggestionData, OrgBoardOrgDismissBoardCommitteeSuggestionErrors, OrgBoardOrgDismissBoardCommitteeSuggestionResponses, OrgBoardOrgDismissBoardTermSuggestionData, OrgBoardOrgDismissBoardTermSuggestionErrors, OrgBoardOrgDismissBoardTermSuggestionResponses, OrgBoardOrgDissolveBoardCommitteeData, OrgBoardOrgDissolveBoardCommitteeErrors, OrgBoardOrgDissolveBoardCommitteeResponses, OrgBoardOrgDistributeBoardPacketData, OrgBoardOrgDistributeBoardPacketErrors, OrgBoardOrgDistributeBoardPacketResponses, OrgBoardOrgEmailBoardReturnAgainData, OrgBoardOrgEmailBoardReturnAgainErrors, OrgBoardOrgEmailBoardReturnAgainResponses, OrgBoardOrgEndBoardCommitteeMemberData, OrgBoardOrgEndBoardCommitteeMemberErrors, OrgBoardOrgEndBoardCommitteeMemberResponses, OrgBoardOrgExportBoardMinuteBookData, OrgBoardOrgExportBoardMinuteBookDocumentData, OrgBoardOrgExportBoardMinuteBookDocumentErrors, OrgBoardOrgExportBoardMinuteBookDocumentResponses, OrgBoardOrgExportBoardMinuteBookErrors, OrgBoardOrgExportBoardMinuteBookResponses, OrgBoardOrgGetBoardCalendarSettingsData, OrgBoardOrgGetBoardCalendarSettingsErrors, OrgBoardOrgGetBoardCalendarSettingsResponses, OrgBoardOrgGetBoardCoiCycleData, OrgBoardOrgGetBoardCoiCycleDocumentData, OrgBoardOrgGetBoardCoiCycleDocumentErrors, OrgBoardOrgGetBoardCoiCycleDocumentResponses, OrgBoardOrgGetBoardCoiCycleErrors, OrgBoardOrgGetBoardCoiCycleResponses, OrgBoardOrgGetBoardCoiPaperFormData, OrgBoardOrgGetBoardCoiPaperFormErrors, OrgBoardOrgGetBoardCoiPaperFormResponses, OrgBoardOrgGetBoardCoiPersonQuestionnaireData, OrgBoardOrgGetBoardCoiPersonQuestionnaireErrors, OrgBoardOrgGetBoardCoiPersonQuestionnaireResponses, OrgBoardOrgGetBoardCoiQuestionnaireData, OrgBoardOrgGetBoardCoiQuestionnaireErrors, OrgBoardOrgGetBoardCoiQuestionnaireResponses, OrgBoardOrgGetBoardCoiResponseChangesData, OrgBoardOrgGetBoardCoiResponseChangesErrors, OrgBoardOrgGetBoardCoiResponseChangesResponses, OrgBoardOrgGetBoardCoiResponseData, OrgBoardOrgGetBoardCoiResponseDocumentData, OrgBoardOrgGetBoardCoiResponseDocumentErrors, OrgBoardOrgGetBoardCoiResponseDocumentResponses, OrgBoardOrgGetBoardCoiResponseErrors, OrgBoardOrgGetBoardCoiResponseResponses, OrgBoardOrgGetBoardCommitteeData, OrgBoardOrgGetBoardCommitteeErrors, OrgBoardOrgGetBoardCommitteeResponses, OrgBoardOrgGetBoardCommitteeSuggestionsData, OrgBoardOrgGetBoardCommitteeSuggestionsErrors, OrgBoardOrgGetBoardCommitteeSuggestionsResponses, OrgBoardOrgGetBoardCompensationDecisionData, OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadData, OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadErrors, OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadResponses, OrgBoardOrgGetBoardCompensationDecisionErrors, OrgBoardOrgGetBoardCompensationDecisionResponses, OrgBoardOrgGetBoardCompensationDocumentDownloadData, OrgBoardOrgGetBoardCompensationDocumentDownloadErrors, OrgBoardOrgGetBoardCompensationDocumentDownloadResponses, OrgBoardOrgGetBoardConsentTemplateData, OrgBoardOrgGetBoardConsentTemplateErrors, OrgBoardOrgGetBoardConsentTemplateResponses, OrgBoardOrgGetBoardDirectorAccessPolicyData, OrgBoardOrgGetBoardDirectorAccessPolicyErrors, OrgBoardOrgGetBoardDirectorAccessPolicyResponses, OrgBoardOrgGetBoardDocumentDownloadUrlData, OrgBoardOrgGetBoardDocumentDownloadUrlErrors, OrgBoardOrgGetBoardDocumentDownloadUrlResponses, OrgBoardOrgGetBoardFilingGovernanceFeedData, OrgBoardOrgGetBoardFilingGovernanceFeedErrors, OrgBoardOrgGetBoardFilingGovernanceFeedResponses, OrgBoardOrgGetBoardForm990Data, OrgBoardOrgGetBoardForm990Errors, OrgBoardOrgGetBoardForm990Responses, OrgBoardOrgGetBoardGettingStartedListData, OrgBoardOrgGetBoardGettingStartedListErrors, OrgBoardOrgGetBoardGettingStartedListResponses, OrgBoardOrgGetBoardGoverningDocumentTemplateData, OrgBoardOrgGetBoardGoverningDocumentTemplateErrors, OrgBoardOrgGetBoardGoverningDocumentTemplateResponses, OrgBoardOrgGetBoardImportBatchData, OrgBoardOrgGetBoardImportBatchErrors, OrgBoardOrgGetBoardImportBatchResponses, OrgBoardOrgGetBoardImportInboxFileUrlData, OrgBoardOrgGetBoardImportInboxFileUrlErrors, OrgBoardOrgGetBoardImportInboxFileUrlResponses, OrgBoardOrgGetBoardInMeetingRecordData, OrgBoardOrgGetBoardInMeetingRecordErrors, OrgBoardOrgGetBoardInMeetingRecordResponses, OrgBoardOrgGetBoardLegalHoldReportData, OrgBoardOrgGetBoardLegalHoldReportErrors, OrgBoardOrgGetBoardLegalHoldReportResponses, OrgBoardOrgGetBoardMeetingCalendarData, OrgBoardOrgGetBoardMeetingCalendarErrors, OrgBoardOrgGetBoardMeetingCalendarResponses, OrgBoardOrgGetBoardMeetingData, OrgBoardOrgGetBoardMeetingErrors, OrgBoardOrgGetBoardMeetingInvitationsData, OrgBoardOrgGetBoardMeetingInvitationsErrors, OrgBoardOrgGetBoardMeetingInvitationsResponses, OrgBoardOrgGetBoardMeetingPresidingData, OrgBoardOrgGetBoardMeetingPresidingErrors, OrgBoardOrgGetBoardMeetingPresidingResponses, OrgBoardOrgGetBoardMeetingResponses, OrgBoardOrgGetBoardMemberData, OrgBoardOrgGetBoardMemberErrors, OrgBoardOrgGetBoardMemberGettingStartedData, OrgBoardOrgGetBoardMemberGettingStartedErrors, OrgBoardOrgGetBoardMemberGettingStartedResponses, OrgBoardOrgGetBoardMemberResponses, OrgBoardOrgGetBoardMinutesApprovalConsentFormData, OrgBoardOrgGetBoardMinutesApprovalConsentFormErrors, OrgBoardOrgGetBoardMinutesApprovalConsentFormResponses, OrgBoardOrgGetBoardMinutesData, OrgBoardOrgGetBoardMinutesErrors, OrgBoardOrgGetBoardMinutesResponses, OrgBoardOrgGetBoardOfficerDutiesData, OrgBoardOrgGetBoardOfficerDutiesErrors, OrgBoardOrgGetBoardOfficerDutiesResponses, OrgBoardOrgGetBoardOfficerStatementData, OrgBoardOrgGetBoardOfficerStatementErrors, OrgBoardOrgGetBoardOfficerStatementResponses, OrgBoardOrgGetBoardPacketData, OrgBoardOrgGetBoardPacketErrors, OrgBoardOrgGetBoardPacketResponses, OrgBoardOrgGetBoardPastRecordBatchData, OrgBoardOrgGetBoardPastRecordBatchErrors, OrgBoardOrgGetBoardPastRecordBatchResponses, OrgBoardOrgGetBoardProposalFileUrlData, OrgBoardOrgGetBoardProposalFileUrlErrors, OrgBoardOrgGetBoardProposalFileUrlResponses, OrgBoardOrgGetBoardRecordData, OrgBoardOrgGetBoardRecordErrors, OrgBoardOrgGetBoardRecordFileUrlData, OrgBoardOrgGetBoardRecordFileUrlErrors, OrgBoardOrgGetBoardRecordFileUrlResponses, OrgBoardOrgGetBoardRecordResponses, OrgBoardOrgGetBoardReturnCopyUrlData, OrgBoardOrgGetBoardReturnCopyUrlErrors, OrgBoardOrgGetBoardReturnCopyUrlResponses, OrgBoardOrgGetBoardReturnDistributionData, OrgBoardOrgGetBoardReturnDistributionErrors, OrgBoardOrgGetBoardReturnDistributionResponses, OrgBoardOrgGetBoardScheduleODraftData, OrgBoardOrgGetBoardScheduleODraftErrors, OrgBoardOrgGetBoardScheduleODraftResponses, OrgBoardOrgGetBoardSelfAssessmentData, OrgBoardOrgGetBoardSelfAssessmentErrors, OrgBoardOrgGetBoardSelfAssessmentInstrumentData, OrgBoardOrgGetBoardSelfAssessmentInstrumentErrors, OrgBoardOrgGetBoardSelfAssessmentInstrumentResponses, OrgBoardOrgGetBoardSelfAssessmentQuestionsData, OrgBoardOrgGetBoardSelfAssessmentQuestionsErrors, OrgBoardOrgGetBoardSelfAssessmentQuestionsResponses, OrgBoardOrgGetBoardSelfAssessmentResponses, OrgBoardOrgGetBoardSelfAssessmentResultsData, OrgBoardOrgGetBoardSelfAssessmentResultsErrors, OrgBoardOrgGetBoardSelfAssessmentResultsResponses, OrgBoardOrgGetBoardTermSuggestionsData, OrgBoardOrgGetBoardTermSuggestionsErrors, OrgBoardOrgGetBoardTermSuggestionsResponses, OrgBoardOrgGetBoardToDoData, OrgBoardOrgGetBoardToDoErrors, OrgBoardOrgGetBoardToDoResponses, OrgBoardOrgGetBoardWrittenConsentData, OrgBoardOrgGetBoardWrittenConsentErrors, OrgBoardOrgGetBoardWrittenConsentResponses, OrgBoardOrgImportBoardRecordData, OrgBoardOrgImportBoardRecordErrors, OrgBoardOrgImportBoardRecordResponses, OrgBoardOrgIssueBoardCompensationDocumentUploadUrlData, OrgBoardOrgIssueBoardCompensationDocumentUploadUrlErrors, OrgBoardOrgIssueBoardCompensationDocumentUploadUrlResponses, OrgBoardOrgIssueBoardDocumentUploadUrlData, OrgBoardOrgIssueBoardDocumentUploadUrlErrors, OrgBoardOrgIssueBoardDocumentUploadUrlResponses, OrgBoardOrgIssueBoardImportFileUploadUrlData, OrgBoardOrgIssueBoardImportFileUploadUrlErrors, OrgBoardOrgIssueBoardImportFileUploadUrlResponses, OrgBoardOrgIssueBoardImportInboxUploadUrlData, OrgBoardOrgIssueBoardImportInboxUploadUrlErrors, OrgBoardOrgIssueBoardImportInboxUploadUrlResponses, OrgBoardOrgIssueBoardImportRecordFileUploadUrlData, OrgBoardOrgIssueBoardImportRecordFileUploadUrlErrors, OrgBoardOrgIssueBoardImportRecordFileUploadUrlResponses, OrgBoardOrgIssueBoardProposalFileUploadUrlData, OrgBoardOrgIssueBoardProposalFileUploadUrlErrors, OrgBoardOrgIssueBoardProposalFileUploadUrlResponses, OrgBoardOrgIssueBoardReturnCopyUploadUrlData, OrgBoardOrgIssueBoardReturnCopyUploadUrlErrors, OrgBoardOrgIssueBoardReturnCopyUploadUrlResponses, OrgBoardOrgLeaveOutBoardPastRecordData, OrgBoardOrgLeaveOutBoardPastRecordErrors, OrgBoardOrgLeaveOutBoardPastRecordResponses, OrgBoardOrgLinkBoardCommitteeCharterData, OrgBoardOrgLinkBoardCommitteeCharterErrors, OrgBoardOrgLinkBoardCommitteeCharterResponses, OrgBoardOrgLinkBoardReturnReviewData, OrgBoardOrgLinkBoardReturnReviewErrors, OrgBoardOrgLinkBoardReturnReviewResponses, OrgBoardOrgLinkBoardSelfAssessmentPrioritiesData, OrgBoardOrgLinkBoardSelfAssessmentPrioritiesErrors, OrgBoardOrgLinkBoardSelfAssessmentPrioritiesResponses, OrgBoardOrgListBoardAgendaItemsData, OrgBoardOrgListBoardAgendaItemsErrors, OrgBoardOrgListBoardAgendaItemsResponses, OrgBoardOrgListBoardAgendaTemplatesData, OrgBoardOrgListBoardAgendaTemplatesErrors, OrgBoardOrgListBoardAgendaTemplatesResponses, OrgBoardOrgListBoardApprovableMinutesData, OrgBoardOrgListBoardApprovableMinutesErrors, OrgBoardOrgListBoardApprovableMinutesResponses, OrgBoardOrgListBoardAttendanceIntentsData, OrgBoardOrgListBoardAttendanceIntentsErrors, OrgBoardOrgListBoardAttendanceIntentsResponses, OrgBoardOrgListBoardCalendarConnectionsData, OrgBoardOrgListBoardCalendarConnectionsErrors, OrgBoardOrgListBoardCalendarConnectionsResponses, OrgBoardOrgListBoardCalendarSendersData, OrgBoardOrgListBoardCalendarSendersErrors, OrgBoardOrgListBoardCalendarSendersResponses, OrgBoardOrgListBoardCarryForwardItemsData, OrgBoardOrgListBoardCarryForwardItemsErrors, OrgBoardOrgListBoardCarryForwardItemsResponses, OrgBoardOrgListBoardCarryForwardMotionsData, OrgBoardOrgListBoardCarryForwardMotionsErrors, OrgBoardOrgListBoardCarryForwardMotionsResponses, OrgBoardOrgListBoardCoiCyclesData, OrgBoardOrgListBoardCoiCyclesErrors, OrgBoardOrgListBoardCoiCyclesResponses, OrgBoardOrgListBoardCoiQuestionnairesData, OrgBoardOrgListBoardCoiQuestionnairesErrors, OrgBoardOrgListBoardCoiQuestionnairesResponses, OrgBoardOrgListBoardCommitteesData, OrgBoardOrgListBoardCommitteesErrors, OrgBoardOrgListBoardCommitteeSourcesData, OrgBoardOrgListBoardCommitteeSourcesErrors, OrgBoardOrgListBoardCommitteeSourcesResponses, OrgBoardOrgListBoardCommitteesResponses, OrgBoardOrgListBoardCompensationDecisionsData, OrgBoardOrgListBoardCompensationDecisionsErrors, OrgBoardOrgListBoardCompensationDecisionsResponses, OrgBoardOrgListBoardConflictLinksData, OrgBoardOrgListBoardConflictLinksErrors, OrgBoardOrgListBoardConflictLinksResponses, OrgBoardOrgListBoardConflictRegisterData, OrgBoardOrgListBoardConflictRegisterErrors, OrgBoardOrgListBoardConflictRegisterResponses, OrgBoardOrgListBoardConflictSuggestionsData, OrgBoardOrgListBoardConflictSuggestionsErrors, OrgBoardOrgListBoardConflictSuggestionsResponses, OrgBoardOrgListBoardConsentCompensationDecisionsData, OrgBoardOrgListBoardConsentCompensationDecisionsErrors, OrgBoardOrgListBoardConsentCompensationDecisionsResponses, OrgBoardOrgListBoardConsentTemplatesData, OrgBoardOrgListBoardConsentTemplatesErrors, OrgBoardOrgListBoardConsentTemplatesResponses, OrgBoardOrgListBoardContemporaneityData, OrgBoardOrgListBoardContemporaneityErrors, OrgBoardOrgListBoardContemporaneityResponses, OrgBoardOrgListBoardDirectorClassesData, OrgBoardOrgListBoardDirectorClassesErrors, OrgBoardOrgListBoardDirectorClassesResponses, OrgBoardOrgListBoardDocumentsData, OrgBoardOrgListBoardDocumentsErrors, OrgBoardOrgListBoardDocumentsResponses, OrgBoardOrgListBoardEngagementData, OrgBoardOrgListBoardEngagementErrors, OrgBoardOrgListBoardEngagementResponses, OrgBoardOrgListBoardGettingStartedStepsData, OrgBoardOrgListBoardGettingStartedStepsErrors, OrgBoardOrgListBoardGettingStartedStepsResponses, OrgBoardOrgListBoardGovernanceParametersData, OrgBoardOrgListBoardGovernanceParametersErrors, OrgBoardOrgListBoardGovernanceParametersResponses, OrgBoardOrgListBoardGoverningDocumentsData, OrgBoardOrgListBoardGoverningDocumentsErrors, OrgBoardOrgListBoardGoverningDocumentsResponses, OrgBoardOrgListBoardGoverningDocumentTemplatesData, OrgBoardOrgListBoardGoverningDocumentTemplatesErrors, OrgBoardOrgListBoardGoverningDocumentTemplatesResponses, OrgBoardOrgListBoardImportBatchesData, OrgBoardOrgListBoardImportBatchesErrors, OrgBoardOrgListBoardImportBatchesResponses, OrgBoardOrgListBoardImportBatchRecordsData, OrgBoardOrgListBoardImportBatchRecordsErrors, OrgBoardOrgListBoardImportBatchRecordsResponses, OrgBoardOrgListBoardImportInboxData, OrgBoardOrgListBoardImportInboxErrors, OrgBoardOrgListBoardImportInboxResponses, OrgBoardOrgListBoardLegalHoldsData, OrgBoardOrgListBoardLegalHoldsErrors, OrgBoardOrgListBoardLegalHoldsResponses, OrgBoardOrgListBoardMeetingAttendanceData, OrgBoardOrgListBoardMeetingAttendanceErrors, OrgBoardOrgListBoardMeetingAttendanceResponses, OrgBoardOrgListBoardMeetingCompensationDecisionsData, OrgBoardOrgListBoardMeetingCompensationDecisionsErrors, OrgBoardOrgListBoardMeetingCompensationDecisionsResponses, OrgBoardOrgListBoardMeetingEventsData, OrgBoardOrgListBoardMeetingEventsErrors, OrgBoardOrgListBoardMeetingEventsResponses, OrgBoardOrgListBoardMeetingsData, OrgBoardOrgListBoardMeetingSegmentsData, OrgBoardOrgListBoardMeetingSegmentsErrors, OrgBoardOrgListBoardMeetingSegmentsResponses, OrgBoardOrgListBoardMeetingsErrors, OrgBoardOrgListBoardMeetingsResponses, OrgBoardOrgListBoardMemberHistoryData, OrgBoardOrgListBoardMemberHistoryErrors, OrgBoardOrgListBoardMemberHistoryResponses, OrgBoardOrgListBoardMemberProposalsData, OrgBoardOrgListBoardMemberProposalsErrors, OrgBoardOrgListBoardMemberProposalsResponses, OrgBoardOrgListBoardMembersData, OrgBoardOrgListBoardMembersErrors, OrgBoardOrgListBoardMembersResponses, OrgBoardOrgListBoardMotionsData, OrgBoardOrgListBoardMotionsErrors, OrgBoardOrgListBoardMotionsResponses, OrgBoardOrgListBoardOfficerTitlesData, OrgBoardOrgListBoardOfficerTitlesErrors, OrgBoardOrgListBoardOfficerTitlesResponses, OrgBoardOrgListBoardPacketCommentsData, OrgBoardOrgListBoardPacketCommentsErrors, OrgBoardOrgListBoardPacketCommentsResponses, OrgBoardOrgListBoardPacketDistributionsData, OrgBoardOrgListBoardPacketDistributionsErrors, OrgBoardOrgListBoardPacketDistributionsResponses, OrgBoardOrgListBoardPacketsData, OrgBoardOrgListBoardPacketsErrors, OrgBoardOrgListBoardPacketsResponses, OrgBoardOrgListBoardPastRecordBatchesData, OrgBoardOrgListBoardPastRecordBatchesErrors, OrgBoardOrgListBoardPastRecordBatchesResponses, OrgBoardOrgListBoardRecordAcknowledgmentsData, OrgBoardOrgListBoardRecordAcknowledgmentsErrors, OrgBoardOrgListBoardRecordAcknowledgmentsResponses, OrgBoardOrgListBoardRecordEventsData, OrgBoardOrgListBoardRecordEventsErrors, OrgBoardOrgListBoardRecordEventsResponses, OrgBoardOrgListBoardRecordsData, OrgBoardOrgListBoardRecordsErrors, OrgBoardOrgListBoardRecordsResponses, OrgBoardOrgListBoardRetentionPoliciesData, OrgBoardOrgListBoardRetentionPoliciesErrors, OrgBoardOrgListBoardRetentionPoliciesResponses, OrgBoardOrgListBoardReturnDistributionsData, OrgBoardOrgListBoardReturnDistributionsErrors, OrgBoardOrgListBoardReturnDistributionsResponses, OrgBoardOrgListBoardReturnReviewCandidatesData, OrgBoardOrgListBoardReturnReviewCandidatesErrors, OrgBoardOrgListBoardReturnReviewCandidatesResponses, OrgBoardOrgListBoardSelfAssessmentInstrumentsData, OrgBoardOrgListBoardSelfAssessmentInstrumentsErrors, OrgBoardOrgListBoardSelfAssessmentInstrumentsResponses, OrgBoardOrgListBoardSelfAssessmentsData, OrgBoardOrgListBoardSelfAssessmentsErrors, OrgBoardOrgListBoardSelfAssessmentsResponses, OrgBoardOrgListBoardWrittenConsentsData, OrgBoardOrgListBoardWrittenConsentsErrors, OrgBoardOrgListBoardWrittenConsentsResponses, OrgBoardOrgMarkBoardMemberGettingStartedStepData, OrgBoardOrgMarkBoardMemberGettingStartedStepErrors, OrgBoardOrgMarkBoardMemberGettingStartedStepResponses, OrgBoardOrgMarkBoardPastRecordConfidentialityData, OrgBoardOrgMarkBoardPastRecordConfidentialityErrors, OrgBoardOrgMarkBoardPastRecordConfidentialityResponses, OrgBoardOrgMarkBoardSelfAssessmentPaperHandInData, OrgBoardOrgMarkBoardSelfAssessmentPaperHandInErrors, OrgBoardOrgMarkBoardSelfAssessmentPaperHandInResponses, OrgBoardOrgMintBoardAccessLinkData, OrgBoardOrgMintBoardAccessLinkErrors, OrgBoardOrgMintBoardAccessLinkResponses, OrgBoardOrgMoveBoardCalendarMeetingsData, OrgBoardOrgMoveBoardCalendarMeetingsErrors, OrgBoardOrgMoveBoardCalendarMeetingsResponses, OrgBoardOrgMoveBoardMeetingInvitationsData, OrgBoardOrgMoveBoardMeetingInvitationsErrors, OrgBoardOrgMoveBoardMeetingInvitationsResponses, OrgBoardOrgOpenBoardCoiCycleData, OrgBoardOrgOpenBoardCoiCycleErrors, OrgBoardOrgOpenBoardCoiCycleResponses, OrgBoardOrgOpenBoardFilingReceiptData, OrgBoardOrgOpenBoardFilingReceiptErrors, OrgBoardOrgOpenBoardFilingReceiptResponses, OrgBoardOrgOpenBoardImportBatchData, OrgBoardOrgOpenBoardImportBatchErrors, OrgBoardOrgOpenBoardImportBatchResponses, OrgBoardOrgOpenBoardSelfAssessmentData, OrgBoardOrgOpenBoardSelfAssessmentErrors, OrgBoardOrgOpenBoardSelfAssessmentResponses, OrgBoardOrgPlaceBoardLegalHoldData, OrgBoardOrgPlaceBoardLegalHoldErrors, OrgBoardOrgPlaceBoardLegalHoldResponses, OrgBoardOrgPreviewBoardReturnRecipientsData, OrgBoardOrgPreviewBoardReturnRecipientsErrors, OrgBoardOrgPreviewBoardReturnRecipientsResponses, OrgBoardOrgProvideBoardReturnData, OrgBoardOrgProvideBoardReturnErrors, OrgBoardOrgProvideBoardReturnResponses, OrgBoardOrgPublishBoardPacketData, OrgBoardOrgPublishBoardPacketErrors, OrgBoardOrgPublishBoardPacketResponses, OrgBoardOrgRecordBoardAttendanceIntentOnBehalfData, OrgBoardOrgRecordBoardAttendanceIntentOnBehalfErrors, OrgBoardOrgRecordBoardAttendanceIntentOnBehalfResponses, OrgBoardOrgRecordBoardCoiPaperResponseData, OrgBoardOrgRecordBoardCoiPaperResponseErrors, OrgBoardOrgRecordBoardCoiPaperResponseResponses, OrgBoardOrgRecordBoardCommitteeRuleData, OrgBoardOrgRecordBoardCommitteeRuleErrors, OrgBoardOrgRecordBoardCommitteeRuleResponses, OrgBoardOrgRecordBoardCompensationIndexEntryData, OrgBoardOrgRecordBoardCompensationIndexEntryErrors, OrgBoardOrgRecordBoardCompensationIndexEntryResponses, OrgBoardOrgRecordBoardConflictDisclosureData, OrgBoardOrgRecordBoardConflictDisclosureErrors, OrgBoardOrgRecordBoardConflictDisclosureResponses, OrgBoardOrgRecordBoardConflictLinkData, OrgBoardOrgRecordBoardConflictLinkErrors, OrgBoardOrgRecordBoardConflictLinkResponses, OrgBoardOrgRecordBoardConsentRevocationData, OrgBoardOrgRecordBoardConsentRevocationErrors, OrgBoardOrgRecordBoardConsentRevocationResponses, OrgBoardOrgRecordBoardConsentSignatureData, OrgBoardOrgRecordBoardConsentSignatureErrors, OrgBoardOrgRecordBoardConsentSignatureResponses, OrgBoardOrgRecordBoardDirectorsToldData, OrgBoardOrgRecordBoardDirectorsToldErrors, OrgBoardOrgRecordBoardDirectorsToldResponses, OrgBoardOrgRecordBoardGovernanceParameterData, OrgBoardOrgRecordBoardGovernanceParameterErrors, OrgBoardOrgRecordBoardGovernanceParameterResponses, OrgBoardOrgRecordBoardMeetingAttendanceData, OrgBoardOrgRecordBoardMeetingAttendanceErrors, OrgBoardOrgRecordBoardMeetingAttendanceResponses, OrgBoardOrgRecordBoardMeetingPresidingData, OrgBoardOrgRecordBoardMeetingPresidingErrors, OrgBoardOrgRecordBoardMeetingPresidingResponses, OrgBoardOrgRecordBoardMemberTermData, OrgBoardOrgRecordBoardMemberTermErrors, OrgBoardOrgRecordBoardMemberTermResponses, OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfData, OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfErrors, OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfResponses, OrgBoardOrgRecordBoardMinutesApprovalVoteData, OrgBoardOrgRecordBoardMinutesApprovalVoteErrors, OrgBoardOrgRecordBoardMinutesApprovalVoteResponses, OrgBoardOrgRecordBoardMotionRecusalData, OrgBoardOrgRecordBoardMotionRecusalErrors, OrgBoardOrgRecordBoardMotionRecusalResponses, OrgBoardOrgRecordBoardMotionVoteData, OrgBoardOrgRecordBoardMotionVoteErrors, OrgBoardOrgRecordBoardMotionVoteResponses, OrgBoardOrgRecordBoardPacketSharedCommentData, OrgBoardOrgRecordBoardPacketSharedCommentErrors, OrgBoardOrgRecordBoardPacketSharedCommentResponses, OrgBoardOrgRecordBoardPaperAcknowledgmentsData, OrgBoardOrgRecordBoardPaperAcknowledgmentsErrors, OrgBoardOrgRecordBoardPaperAcknowledgmentsResponses, OrgBoardOrgRecordBoardReturnPrintedCopyData, OrgBoardOrgRecordBoardReturnPrintedCopyErrors, OrgBoardOrgRecordBoardReturnPrintedCopyResponses, OrgBoardOrgRecordBoardRosterResultData, OrgBoardOrgRecordBoardRosterResultErrors, OrgBoardOrgRecordBoardRosterResultResponses, OrgBoardOrgRecordBoardSegmentParticipantData, OrgBoardOrgRecordBoardSegmentParticipantErrors, OrgBoardOrgRecordBoardSegmentParticipantResponses, OrgBoardOrgRecordBoardSelfAssessmentPaperSheetData, OrgBoardOrgRecordBoardSelfAssessmentPaperSheetErrors, OrgBoardOrgRecordBoardSelfAssessmentPaperSheetResponses, OrgBoardOrgRecordHistoricalBoardMemberData, OrgBoardOrgRecordHistoricalBoardMemberErrors, OrgBoardOrgRecordHistoricalBoardMemberResponses, OrgBoardOrgRefreshBoardFilingSnapshotData, OrgBoardOrgRefreshBoardFilingSnapshotErrors, OrgBoardOrgRefreshBoardFilingSnapshotResponses, OrgBoardOrgReinviteBoardMeetingInviteeData, OrgBoardOrgReinviteBoardMeetingInviteeErrors, OrgBoardOrgReinviteBoardMeetingInviteeResponses, OrgBoardOrgReleaseBoardLegalHoldData, OrgBoardOrgReleaseBoardLegalHoldErrors, OrgBoardOrgReleaseBoardLegalHoldResponses, OrgBoardOrgReleaseBoardMemberAccountData, OrgBoardOrgReleaseBoardMemberAccountErrors, OrgBoardOrgReleaseBoardMemberAccountResponses, OrgBoardOrgRemindBoardCoiCycleRecipientsData, OrgBoardOrgRemindBoardCoiCycleRecipientsErrors, OrgBoardOrgRemindBoardCoiCycleRecipientsResponses, OrgBoardOrgRemindBoardSelfAssessmentRecipientsData, OrgBoardOrgRemindBoardSelfAssessmentRecipientsErrors, OrgBoardOrgRemindBoardSelfAssessmentRecipientsResponses, OrgBoardOrgRemoveBoardCompensationDocumentData, OrgBoardOrgRemoveBoardCompensationDocumentErrors, OrgBoardOrgRemoveBoardCompensationDocumentResponses, OrgBoardOrgRemoveBoardCompensationIndexEntryData, OrgBoardOrgRemoveBoardCompensationIndexEntryErrors, OrgBoardOrgRemoveBoardCompensationIndexEntryResponses, OrgBoardOrgRemoveBoardConsentCompensationDecisionData, OrgBoardOrgRemoveBoardConsentCompensationDecisionErrors, OrgBoardOrgRemoveBoardConsentCompensationDecisionResponses, OrgBoardOrgRemoveBoardImportInboxFileData, OrgBoardOrgRemoveBoardImportInboxFileErrors, OrgBoardOrgRemoveBoardImportInboxFileResponses, OrgBoardOrgRemoveBoardMemberData, OrgBoardOrgRemoveBoardMemberErrors, OrgBoardOrgRemoveBoardMemberResponses, OrgBoardOrgRemoveBoardMemberTermData, OrgBoardOrgRemoveBoardMemberTermErrors, OrgBoardOrgRemoveBoardMemberTermResponses, OrgBoardOrgRemoveBoardMotionCompensationDecisionData, OrgBoardOrgRemoveBoardMotionCompensationDecisionErrors, OrgBoardOrgRemoveBoardMotionCompensationDecisionResponses, OrgBoardOrgRemoveBoardMotionRecusalData, OrgBoardOrgRemoveBoardMotionRecusalErrors, OrgBoardOrgRemoveBoardMotionRecusalResponses, OrgBoardOrgRemoveBoardSegmentParticipantData, OrgBoardOrgRemoveBoardSegmentParticipantErrors, OrgBoardOrgRemoveBoardSegmentParticipantResponses, OrgBoardOrgReorderBoardAgendaData, OrgBoardOrgReorderBoardAgendaErrors, OrgBoardOrgReorderBoardAgendaResponses, OrgBoardOrgReorderBoardMeetingSegmentsData, OrgBoardOrgReorderBoardMeetingSegmentsErrors, OrgBoardOrgReorderBoardMeetingSegmentsResponses, OrgBoardOrgReorderBoardPacketItemsData, OrgBoardOrgReorderBoardPacketItemsErrors, OrgBoardOrgReorderBoardPacketItemsResponses, OrgBoardOrgReplaceBoardConsentCompensationDecisionData, OrgBoardOrgReplaceBoardConsentCompensationDecisionErrors, OrgBoardOrgReplaceBoardConsentCompensationDecisionResponses, OrgBoardOrgReplaceBoardMotionCompensationDecisionData, OrgBoardOrgReplaceBoardMotionCompensationDecisionErrors, OrgBoardOrgReplaceBoardMotionCompensationDecisionResponses, OrgBoardOrgRestoreBoardCommitteeSuggestionData, OrgBoardOrgRestoreBoardCommitteeSuggestionErrors, OrgBoardOrgRestoreBoardCommitteeSuggestionResponses, OrgBoardOrgRestoreBoardTermSuggestionData, OrgBoardOrgRestoreBoardTermSuggestionErrors, OrgBoardOrgRestoreBoardTermSuggestionResponses, OrgBoardOrgRetireBoardDirectorClassData, OrgBoardOrgRetireBoardDirectorClassErrors, OrgBoardOrgRetireBoardDirectorClassResponses, OrgBoardOrgRetireBoardOfficerTitleData, OrgBoardOrgRetireBoardOfficerTitleErrors, OrgBoardOrgRetireBoardOfficerTitleResponses, OrgBoardOrgReviseBoardWrittenConsentData, OrgBoardOrgReviseBoardWrittenConsentErrors, OrgBoardOrgReviseBoardWrittenConsentResponses, OrgBoardOrgSaveBoardGettingStartedListData, OrgBoardOrgSaveBoardGettingStartedListErrors, OrgBoardOrgSaveBoardGettingStartedListResponses, OrgBoardOrgSaveBoardMemberGettingStartedData, OrgBoardOrgSaveBoardMemberGettingStartedErrors, OrgBoardOrgSaveBoardMemberGettingStartedResponses, OrgBoardOrgScheduleRestoredBoardMeetingData, OrgBoardOrgScheduleRestoredBoardMeetingErrors, OrgBoardOrgScheduleRestoredBoardMeetingResponses, OrgBoardOrgSendBoardCoiCycleRequestsData, OrgBoardOrgSendBoardCoiCycleRequestsErrors, OrgBoardOrgSendBoardCoiCycleRequestsResponses, OrgBoardOrgSendBoardMeetingInvitationsData, OrgBoardOrgSendBoardMeetingInvitationsErrors, OrgBoardOrgSendBoardMeetingInvitationsResponses, OrgBoardOrgSendBoardMinutesReminderData, OrgBoardOrgSendBoardMinutesReminderErrors, OrgBoardOrgSendBoardMinutesReminderResponses, OrgBoardOrgSendBoardSelfAssessmentRequestsData, OrgBoardOrgSendBoardSelfAssessmentRequestsErrors, OrgBoardOrgSendBoardSelfAssessmentRequestsResponses, OrgBoardOrgSetBoardCommitteeConfirmationData, OrgBoardOrgSetBoardCommitteeConfirmationErrors, OrgBoardOrgSetBoardCommitteeConfirmationResponses, OrgBoardOrgSignBoardMinutesOnBehalfData, OrgBoardOrgSignBoardMinutesOnBehalfErrors, OrgBoardOrgSignBoardMinutesOnBehalfResponses, OrgBoardOrgStartBoardMemberGettingStartedData, OrgBoardOrgStartBoardMemberGettingStartedErrors, OrgBoardOrgStartBoardMemberGettingStartedResponses, OrgBoardOrgSubmitBoardRecordData, OrgBoardOrgSubmitBoardRecordErrors, OrgBoardOrgSubmitBoardRecordResponses, OrgBoardOrgUnlinkBoardReturnReviewData, OrgBoardOrgUnlinkBoardReturnReviewErrors, OrgBoardOrgUnlinkBoardReturnReviewResponses, OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInData, OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInErrors, OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInResponses, OrgBoardOrgUpdateBoardAgendaItemData, OrgBoardOrgUpdateBoardAgendaItemErrors, OrgBoardOrgUpdateBoardAgendaItemResponses, OrgBoardOrgUpdateBoardCoiCycleData, OrgBoardOrgUpdateBoardCoiCycleErrors, OrgBoardOrgUpdateBoardCoiCycleResponses, OrgBoardOrgUpdateBoardCommitteeData, OrgBoardOrgUpdateBoardCommitteeErrors, OrgBoardOrgUpdateBoardCommitteeMemberData, OrgBoardOrgUpdateBoardCommitteeMemberErrors, OrgBoardOrgUpdateBoardCommitteeMemberResponses, OrgBoardOrgUpdateBoardCommitteeResponses, OrgBoardOrgUpdateBoardCompensationDecisionData, OrgBoardOrgUpdateBoardCompensationDecisionErrors, OrgBoardOrgUpdateBoardCompensationDecisionResponses, OrgBoardOrgUpdateBoardDirectorClassData, OrgBoardOrgUpdateBoardDirectorClassErrors, OrgBoardOrgUpdateBoardDirectorClassResponses, OrgBoardOrgUpdateBoardImportBatchData, OrgBoardOrgUpdateBoardImportBatchErrors, OrgBoardOrgUpdateBoardImportBatchResponses, OrgBoardOrgUpdateBoardMeetingData, OrgBoardOrgUpdateBoardMeetingErrors, OrgBoardOrgUpdateBoardMeetingResponses, OrgBoardOrgUpdateBoardMeetingSegmentData, OrgBoardOrgUpdateBoardMeetingSegmentErrors, OrgBoardOrgUpdateBoardMeetingSegmentResponses, OrgBoardOrgUpdateBoardMemberData, OrgBoardOrgUpdateBoardMemberErrors, OrgBoardOrgUpdateBoardMemberResponses, OrgBoardOrgUpdateBoardMemberTermData, OrgBoardOrgUpdateBoardMemberTermErrors, OrgBoardOrgUpdateBoardMemberTermResponses, OrgBoardOrgUpdateBoardMotionData, OrgBoardOrgUpdateBoardMotionErrors, OrgBoardOrgUpdateBoardMotionResponses, OrgBoardOrgUpdateBoardOfficerTitleData, OrgBoardOrgUpdateBoardOfficerTitleErrors, OrgBoardOrgUpdateBoardOfficerTitleResponses, OrgBoardOrgUpdateBoardRecordDraftData, OrgBoardOrgUpdateBoardRecordDraftErrors, OrgBoardOrgUpdateBoardRecordDraftResponses, OrgBoardOrgUpdateBoardWrittenConsentData, OrgBoardOrgUpdateBoardWrittenConsentErrors, OrgBoardOrgUpdateBoardWrittenConsentResponses, OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesData, OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesErrors, OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesResponses, OrgBoardOrgWithdrawBoardMotionData, OrgBoardOrgWithdrawBoardMotionErrors, OrgBoardOrgWithdrawBoardMotionResponses, OrgBoardOrgWithdrawBoardReturnData, OrgBoardOrgWithdrawBoardReturnErrors, OrgBoardOrgWithdrawBoardReturnResponses, OrgBoardOrgWithdrawBoardWrittenConsentData, OrgBoardOrgWithdrawBoardWrittenConsentErrors, OrgBoardOrgWithdrawBoardWrittenConsentResponses, OrgBoardOrgWriteBoardMinutesDraftData, OrgBoardOrgWriteBoardMinutesDraftErrors, OrgBoardOrgWriteBoardMinutesDraftResponses, OrgBrandUseOrgCollateralItemAsSocialImageData, OrgBrandUseOrgCollateralItemAsSocialImageErrors, OrgBrandUseOrgCollateralItemAsSocialImageResponses, OrgComplianceOrgAddComplianceEarlierRenewalCycleData, OrgComplianceOrgAddComplianceEarlierRenewalCycleErrors, OrgComplianceOrgAddComplianceEarlierRenewalCycleResponses, OrgComplianceOrgAddComplianceObligationAttachmentData, OrgComplianceOrgAddComplianceObligationAttachmentErrors, OrgComplianceOrgAddComplianceObligationAttachmentResponses, OrgComplianceOrgAddComplianceOrganizationFilingAttachmentData, OrgComplianceOrgAddComplianceOrganizationFilingAttachmentErrors, OrgComplianceOrgAddComplianceOrganizationFilingAttachmentResponses, OrgComplianceOrgAddComplianceOrganizationFilingCycleData, OrgComplianceOrgAddComplianceOrganizationFilingCycleErrors, OrgComplianceOrgAddComplianceOrganizationFilingCycleResponses, OrgComplianceOrgAddComplianceOrganizationFilingData, OrgComplianceOrgAddComplianceOrganizationFilingErrors, OrgComplianceOrgAddComplianceOrganizationFilingResponses, OrgComplianceOrgAddComplianceRenewalAttachmentData, OrgComplianceOrgAddComplianceRenewalAttachmentErrors, OrgComplianceOrgAddComplianceRenewalAttachmentResponses, OrgComplianceOrgAmendComplianceRegistrationImportData, OrgComplianceOrgAmendComplianceRegistrationImportErrors, OrgComplianceOrgAmendComplianceRegistrationImportResponses, OrgComplianceOrgAnswerComplianceFormItemData, OrgComplianceOrgAnswerComplianceFormItemErrors, OrgComplianceOrgAnswerComplianceFormItemResponses, OrgComplianceOrgAnswerComplianceSubmissionEvidenceData, OrgComplianceOrgAnswerComplianceSubmissionEvidenceErrors, OrgComplianceOrgAnswerComplianceSubmissionEvidenceResponses, OrgComplianceOrgAskAboutComplianceReviewItemData, OrgComplianceOrgAskAboutComplianceReviewItemErrors, OrgComplianceOrgAskAboutComplianceReviewItemResponses, OrgComplianceOrgAssembleCompliancePacketData, OrgComplianceOrgAssembleCompliancePacketErrors, OrgComplianceOrgAssembleCompliancePacketResponses, OrgComplianceOrgAttachComplianceChecklistDocumentData, OrgComplianceOrgAttachComplianceChecklistDocumentErrors, OrgComplianceOrgAttachComplianceChecklistDocumentResponses, OrgComplianceOrgAttachComplianceFilingCaseDocumentData, OrgComplianceOrgAttachComplianceFilingCaseDocumentErrors, OrgComplianceOrgAttachComplianceFilingCaseDocumentResponses, OrgComplianceOrgAttachComplianceObligationFiledCopyData, OrgComplianceOrgAttachComplianceObligationFiledCopyErrors, OrgComplianceOrgAttachComplianceObligationFiledCopyResponses, OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyData, OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyErrors, OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyResponses, OrgComplianceOrgAttachComplianceRenewalFiledCopyData, OrgComplianceOrgAttachComplianceRenewalFiledCopyErrors, OrgComplianceOrgAttachComplianceRenewalFiledCopyResponses, OrgComplianceOrgAuthorizeComplianceSubmissionData, OrgComplianceOrgAuthorizeComplianceSubmissionErrors, OrgComplianceOrgAuthorizeComplianceSubmissionResponses, OrgComplianceOrgCancelComplianceSigningRequestData, OrgComplianceOrgCancelComplianceSigningRequestErrors, OrgComplianceOrgCancelComplianceSigningRequestResponses, OrgComplianceOrgConfirmComplianceArtifactData, OrgComplianceOrgConfirmComplianceArtifactErrors, OrgComplianceOrgConfirmComplianceArtifactResponses, OrgComplianceOrgConfirmComplianceCandidateData, OrgComplianceOrgConfirmComplianceCandidateErrors, OrgComplianceOrgConfirmComplianceCandidateResponses, OrgComplianceOrgCreateComplianceFilingDocumentData, OrgComplianceOrgCreateComplianceFilingDocumentErrors, OrgComplianceOrgCreateComplianceFilingDocumentResponses, OrgComplianceOrgCreateComplianceFilingGroupData, OrgComplianceOrgCreateComplianceFilingGroupErrors, OrgComplianceOrgCreateComplianceFilingGroupResponses, OrgComplianceOrgDeclineComplianceSigningRequestData, OrgComplianceOrgDeclineComplianceSigningRequestErrors, OrgComplianceOrgDeclineComplianceSigningRequestResponses, OrgComplianceOrgDeleteComplianceArtifactData, OrgComplianceOrgDeleteComplianceArtifactErrors, OrgComplianceOrgDeleteComplianceArtifactResponses, OrgComplianceOrgDismissComplianceCandidateData, OrgComplianceOrgDismissComplianceCandidateErrors, OrgComplianceOrgDismissComplianceCandidateResponses, OrgComplianceOrgDispatchComplianceSubmissionData, OrgComplianceOrgDispatchComplianceSubmissionErrors, OrgComplianceOrgDispatchComplianceSubmissionResponses, OrgComplianceOrgExtendComplianceSigningRequestData, OrgComplianceOrgExtendComplianceSigningRequestErrors, OrgComplianceOrgExtendComplianceSigningRequestResponses, OrgComplianceOrgGenerateComplianceProposalRevisionData, OrgComplianceOrgGenerateComplianceProposalRevisionErrors, OrgComplianceOrgGenerateComplianceProposalRevisionResponses, OrgComplianceOrgGetComplianceAiSettingData, OrgComplianceOrgGetComplianceAiSettingErrors, OrgComplianceOrgGetComplianceAiSettingResponses, OrgComplianceOrgGetComplianceArtifactDownloadData, OrgComplianceOrgGetComplianceArtifactDownloadErrors, OrgComplianceOrgGetComplianceArtifactDownloadResponses, OrgComplianceOrgGetComplianceDeskAuthorizationData, OrgComplianceOrgGetComplianceDeskAuthorizationErrors, OrgComplianceOrgGetComplianceDeskAuthorizationResponses, OrgComplianceOrgGetComplianceFilingCaseChecklistData, OrgComplianceOrgGetComplianceFilingCaseChecklistErrors, OrgComplianceOrgGetComplianceFilingCaseChecklistResponses, OrgComplianceOrgGetComplianceFilingCaseData, OrgComplianceOrgGetComplianceFilingCaseErrors, OrgComplianceOrgGetComplianceFilingCaseResponses, OrgComplianceOrgGetComplianceFilingDocumentData, OrgComplianceOrgGetComplianceFilingDocumentErrors, OrgComplianceOrgGetComplianceFilingDocumentResponses, OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesData, OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesErrors, OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesResponses, OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadData, OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadErrors, OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadResponses, OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionData, OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionErrors, OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionResponses, OrgComplianceOrgGetComplianceFormPagePreviewData, OrgComplianceOrgGetComplianceFormPagePreviewErrors, OrgComplianceOrgGetComplianceFormPagePreviewResponses, OrgComplianceOrgGetComplianceFormPreparationData, OrgComplianceOrgGetComplianceFormPreparationErrors, OrgComplianceOrgGetComplianceFormPreparationResponses, OrgComplianceOrgGetComplianceObligationData, OrgComplianceOrgGetComplianceObligationErrors, OrgComplianceOrgGetComplianceObligationResponses, OrgComplianceOrgGetComplianceObligationRuleChangeData, OrgComplianceOrgGetComplianceObligationRuleChangeErrors, OrgComplianceOrgGetComplianceObligationRuleChangeResponses, OrgComplianceOrgGetComplianceOrganizationFilingData, OrgComplianceOrgGetComplianceOrganizationFilingErrors, OrgComplianceOrgGetComplianceOrganizationFilingResponses, OrgComplianceOrgGetCompliancePacketChecklistData, OrgComplianceOrgGetCompliancePacketChecklistErrors, OrgComplianceOrgGetCompliancePacketChecklistResponses, OrgComplianceOrgGetCompliancePacketData, OrgComplianceOrgGetCompliancePacketErrors, OrgComplianceOrgGetCompliancePacketRenderData, OrgComplianceOrgGetCompliancePacketRenderErrors, OrgComplianceOrgGetCompliancePacketRenderResponses, OrgComplianceOrgGetCompliancePacketResponses, OrgComplianceOrgGetComplianceProfileData, OrgComplianceOrgGetComplianceProfileErrors, OrgComplianceOrgGetComplianceProfileResponses, OrgComplianceOrgGetComplianceProposalData, OrgComplianceOrgGetComplianceProposalErrors, OrgComplianceOrgGetComplianceProposalResponses, OrgComplianceOrgGetComplianceProposalReviewData, OrgComplianceOrgGetComplianceProposalReviewErrors, OrgComplianceOrgGetComplianceProposalReviewResponses, OrgComplianceOrgGetComplianceProposalRevisionData, OrgComplianceOrgGetComplianceProposalRevisionErrors, OrgComplianceOrgGetComplianceProposalRevisionResponses, OrgComplianceOrgGetComplianceRenewalCycleData, OrgComplianceOrgGetComplianceRenewalCycleErrors, OrgComplianceOrgGetComplianceRenewalCycleResponses, OrgComplianceOrgGetComplianceSigningEvidenceData, OrgComplianceOrgGetComplianceSigningEvidenceErrors, OrgComplianceOrgGetComplianceSigningEvidenceResponses, OrgComplianceOrgGetComplianceSigningExportData, OrgComplianceOrgGetComplianceSigningExportErrors, OrgComplianceOrgGetComplianceSigningExportResponses, OrgComplianceOrgGetComplianceSigningRecordLinesData, OrgComplianceOrgGetComplianceSigningRecordLinesErrors, OrgComplianceOrgGetComplianceSigningRecordLinesResponses, OrgComplianceOrgGetComplianceSigningRequestData, OrgComplianceOrgGetComplianceSigningRequestErrors, OrgComplianceOrgGetComplianceSigningRequestResponses, OrgComplianceOrgGetComplianceSigningSettingData, OrgComplianceOrgGetComplianceSigningSettingErrors, OrgComplianceOrgGetComplianceSigningSettingResponses, OrgComplianceOrgGetComplianceSubmissionData, OrgComplianceOrgGetComplianceSubmissionErrors, OrgComplianceOrgGetComplianceSubmissionPackageData, OrgComplianceOrgGetComplianceSubmissionPackageErrors, OrgComplianceOrgGetComplianceSubmissionPackageResponses, OrgComplianceOrgGetComplianceSubmissionResponses, OrgComplianceOrgGetComplianceVendorData, OrgComplianceOrgGetComplianceVendorErrors, OrgComplianceOrgGetComplianceVendorResponses, OrgComplianceOrgHandComplianceFilingToDeskData, OrgComplianceOrgHandComplianceFilingToDeskErrors, OrgComplianceOrgHandComplianceFilingToDeskResponses, OrgComplianceOrgImportComplianceRegistrationData, OrgComplianceOrgImportComplianceRegistrationErrors, OrgComplianceOrgImportComplianceRegistrationResponses, OrgComplianceOrgIssueComplianceArtifactUploadUrlData, OrgComplianceOrgIssueComplianceArtifactUploadUrlErrors, OrgComplianceOrgIssueComplianceArtifactUploadUrlResponses, OrgComplianceOrgIssueComplianceSigningRequestData, OrgComplianceOrgIssueComplianceSigningRequestErrors, OrgComplianceOrgIssueComplianceSigningRequestResponses, OrgComplianceOrgLinkComplianceVendorFilingData, OrgComplianceOrgLinkComplianceVendorFilingErrors, OrgComplianceOrgLinkComplianceVendorFilingResponses, OrgComplianceOrgListComplianceArtifactsData, OrgComplianceOrgListComplianceArtifactsErrors, OrgComplianceOrgListComplianceArtifactsResponses, OrgComplianceOrgListComplianceCandidatesData, OrgComplianceOrgListComplianceCandidatesErrors, OrgComplianceOrgListComplianceCandidatesResponses, OrgComplianceOrgListComplianceFilingCasesData, OrgComplianceOrgListComplianceFilingCasesErrors, OrgComplianceOrgListComplianceFilingCasesResponses, OrgComplianceOrgListComplianceFilingDocumentsData, OrgComplianceOrgListComplianceFilingDocumentsErrors, OrgComplianceOrgListComplianceFilingDocumentsResponses, OrgComplianceOrgListComplianceFilingGroupsData, OrgComplianceOrgListComplianceFilingGroupsErrors, OrgComplianceOrgListComplianceFilingGroupsResponses, OrgComplianceOrgListComplianceFilingOptionsData, OrgComplianceOrgListComplianceFilingOptionsErrors, OrgComplianceOrgListComplianceFilingOptionsResponses, OrgComplianceOrgListComplianceFormAdaptersData, OrgComplianceOrgListComplianceFormAdaptersErrors, OrgComplianceOrgListComplianceFormAdaptersResponses, OrgComplianceOrgListComplianceFormPreparationsData, OrgComplianceOrgListComplianceFormPreparationsErrors, OrgComplianceOrgListComplianceFormPreparationsResponses, OrgComplianceOrgListComplianceObligationArtifactsData, OrgComplianceOrgListComplianceObligationArtifactsErrors, OrgComplianceOrgListComplianceObligationArtifactsResponses, OrgComplianceOrgListComplianceObligationsData, OrgComplianceOrgListComplianceObligationsErrors, OrgComplianceOrgListComplianceObligationsResponses, OrgComplianceOrgListComplianceOccurrencesData, OrgComplianceOrgListComplianceOccurrencesErrors, OrgComplianceOrgListComplianceOccurrencesResponses, OrgComplianceOrgListComplianceOrganizationFilingsData, OrgComplianceOrgListComplianceOrganizationFilingsErrors, OrgComplianceOrgListComplianceOrganizationFilingsResponses, OrgComplianceOrgListCompliancePacketsData, OrgComplianceOrgListCompliancePacketsErrors, OrgComplianceOrgListCompliancePacketsResponses, OrgComplianceOrgListComplianceProfileParametersData, OrgComplianceOrgListComplianceProfileParametersErrors, OrgComplianceOrgListComplianceProfileParametersResponses, OrgComplianceOrgListComplianceProfileReviewFlagsData, OrgComplianceOrgListComplianceProfileReviewFlagsErrors, OrgComplianceOrgListComplianceProfileReviewFlagsResponses, OrgComplianceOrgListComplianceProfileSuggestionsData, OrgComplianceOrgListComplianceProfileSuggestionsErrors, OrgComplianceOrgListComplianceProfileSuggestionsResponses, OrgComplianceOrgListComplianceProposalItemsData, OrgComplianceOrgListComplianceProposalItemsErrors, OrgComplianceOrgListComplianceProposalItemsResponses, OrgComplianceOrgListComplianceProposalResultsData, OrgComplianceOrgListComplianceProposalResultsErrors, OrgComplianceOrgListComplianceProposalResultsResponses, OrgComplianceOrgListComplianceRegistrationImportAmendmentsData, OrgComplianceOrgListComplianceRegistrationImportAmendmentsErrors, OrgComplianceOrgListComplianceRegistrationImportAmendmentsResponses, OrgComplianceOrgListComplianceRegistrationImportsData, OrgComplianceOrgListComplianceRegistrationImportsErrors, OrgComplianceOrgListComplianceRegistrationImportsResponses, OrgComplianceOrgListComplianceRenewalCyclesData, OrgComplianceOrgListComplianceRenewalCyclesErrors, OrgComplianceOrgListComplianceRenewalCyclesResponses, OrgComplianceOrgListComplianceReviewAsksData, OrgComplianceOrgListComplianceReviewAsksErrors, OrgComplianceOrgListComplianceReviewAsksResponses, OrgComplianceOrgListComplianceSigningPeopleData, OrgComplianceOrgListComplianceSigningPeopleErrors, OrgComplianceOrgListComplianceSigningPeopleResponses, OrgComplianceOrgListComplianceSigningRequestsData, OrgComplianceOrgListComplianceSigningRequestsErrors, OrgComplianceOrgListComplianceSigningRequestsResponses, OrgComplianceOrgListComplianceSubmissionFollowThroughData, OrgComplianceOrgListComplianceSubmissionFollowThroughErrors, OrgComplianceOrgListComplianceSubmissionFollowThroughResponses, OrgComplianceOrgListComplianceVendorsData, OrgComplianceOrgListComplianceVendorsErrors, OrgComplianceOrgListComplianceVendorsResponses, OrgComplianceOrgMintComplianceFormVersionData, OrgComplianceOrgMintComplianceFormVersionErrors, OrgComplianceOrgMintComplianceFormVersionResponses, OrgComplianceOrgMoveComplianceFilingGroupData, OrgComplianceOrgMoveComplianceFilingGroupErrors, OrgComplianceOrgMoveComplianceFilingGroupResponses, OrgComplianceOrgMoveComplianceFilingToGroupData, OrgComplianceOrgMoveComplianceFilingToGroupErrors, OrgComplianceOrgMoveComplianceFilingToGroupResponses, OrgComplianceOrgOpenComplianceFilingCaseData, OrgComplianceOrgOpenComplianceFilingCaseErrors, OrgComplianceOrgOpenComplianceFilingCaseResponses, OrgComplianceOrgReconcileComplianceSubmissionAttemptData, OrgComplianceOrgReconcileComplianceSubmissionAttemptErrors, OrgComplianceOrgReconcileComplianceSubmissionAttemptResponses, OrgComplianceOrgRecordComplianceChecklistActData, OrgComplianceOrgRecordComplianceChecklistActErrors, OrgComplianceOrgRecordComplianceChecklistActResponses, OrgComplianceOrgRecordComplianceExecutedCopyData, OrgComplianceOrgRecordComplianceExecutedCopyErrors, OrgComplianceOrgRecordComplianceExecutedCopyResponses, OrgComplianceOrgRecordComplianceFilingData, OrgComplianceOrgRecordComplianceFilingErrors, OrgComplianceOrgRecordComplianceFilingResponses, OrgComplianceOrgRecordComplianceOrganizationFilingFiledData, OrgComplianceOrgRecordComplianceOrganizationFilingFiledErrors, OrgComplianceOrgRecordComplianceOrganizationFilingFiledResponses, OrgComplianceOrgRecordComplianceOrganizationFilingSentData, OrgComplianceOrgRecordComplianceOrganizationFilingSentErrors, OrgComplianceOrgRecordComplianceOrganizationFilingSentResponses, OrgComplianceOrgRecordComplianceProfileParameterData, OrgComplianceOrgRecordComplianceProfileParameterErrors, OrgComplianceOrgRecordComplianceProfileParameterResponses, OrgComplianceOrgRecordComplianceProposalReviewData, OrgComplianceOrgRecordComplianceProposalReviewErrors, OrgComplianceOrgRecordComplianceProposalReviewResponses, OrgComplianceOrgRecordComplianceRegistrationDateData, OrgComplianceOrgRecordComplianceRegistrationDateErrors, OrgComplianceOrgRecordComplianceRegistrationDateResponses, OrgComplianceOrgRecordComplianceRenewalFilingData, OrgComplianceOrgRecordComplianceRenewalFilingErrors, OrgComplianceOrgRecordComplianceRenewalFilingResponses, OrgComplianceOrgRecordComplianceRenewalSubmissionData, OrgComplianceOrgRecordComplianceRenewalSubmissionErrors, OrgComplianceOrgRecordComplianceRenewalSubmissionResponses, OrgComplianceOrgRecordComplianceSubmissionData, OrgComplianceOrgRecordComplianceSubmissionErrors, OrgComplianceOrgRecordComplianceSubmissionEvidenceData, OrgComplianceOrgRecordComplianceSubmissionEvidenceErrors, OrgComplianceOrgRecordComplianceSubmissionEvidenceResponses, OrgComplianceOrgRecordComplianceSubmissionHandoffData, OrgComplianceOrgRecordComplianceSubmissionHandoffErrors, OrgComplianceOrgRecordComplianceSubmissionHandoffResponses, OrgComplianceOrgRecordComplianceSubmissionResponses, OrgComplianceOrgRecordComplianceVendorData, OrgComplianceOrgRecordComplianceVendorErrors, OrgComplianceOrgRecordComplianceVendorResponses, OrgComplianceOrgRecordComplianceWindowClosedData, OrgComplianceOrgRecordComplianceWindowClosedErrors, OrgComplianceOrgRecordComplianceWindowClosedResponses, OrgComplianceOrgRegisterComplianceFilingDocumentVersionData, OrgComplianceOrgRegisterComplianceFilingDocumentVersionErrors, OrgComplianceOrgRegisterComplianceFilingDocumentVersionResponses, OrgComplianceOrgRemoveComplianceFilingGroupData, OrgComplianceOrgRemoveComplianceFilingGroupErrors, OrgComplianceOrgRemoveComplianceFilingGroupResponses, OrgComplianceOrgRemoveComplianceSigningIdentityData, OrgComplianceOrgRemoveComplianceSigningIdentityErrors, OrgComplianceOrgRemoveComplianceSigningIdentityResponses, OrgComplianceOrgRenameComplianceFilingGroupData, OrgComplianceOrgRenameComplianceFilingGroupErrors, OrgComplianceOrgRenameComplianceFilingGroupResponses, OrgComplianceOrgRepinComplianceObligationData, OrgComplianceOrgRepinComplianceObligationErrors, OrgComplianceOrgRepinComplianceObligationResponses, OrgComplianceOrgResolveComplianceProfileReviewFlagData, OrgComplianceOrgResolveComplianceProfileReviewFlagErrors, OrgComplianceOrgResolveComplianceProfileReviewFlagResponses, OrgComplianceOrgResolveComplianceProfileSuggestionData, OrgComplianceOrgResolveComplianceProfileSuggestionErrors, OrgComplianceOrgResolveComplianceProfileSuggestionResponses, OrgComplianceOrgResumeComplianceDeskData, OrgComplianceOrgResumeComplianceDeskErrors, OrgComplianceOrgResumeComplianceDeskResponses, OrgComplianceOrgResumeTrackingComplianceObligationData, OrgComplianceOrgResumeTrackingComplianceObligationErrors, OrgComplianceOrgResumeTrackingComplianceObligationResponses, OrgComplianceOrgRetireComplianceOrganizationFilingData, OrgComplianceOrgRetireComplianceOrganizationFilingErrors, OrgComplianceOrgRetireComplianceOrganizationFilingResponses, OrgComplianceOrgReviseComplianceSigningRequestData, OrgComplianceOrgReviseComplianceSigningRequestErrors, OrgComplianceOrgReviseComplianceSigningRequestResponses, OrgComplianceOrgRevokeComplianceDeskAuthorizationData, OrgComplianceOrgRevokeComplianceDeskAuthorizationErrors, OrgComplianceOrgRevokeComplianceDeskAuthorizationResponses, OrgComplianceOrgRevokeComplianceSubmissionAuthorizationData, OrgComplianceOrgRevokeComplianceSubmissionAuthorizationErrors, OrgComplianceOrgRevokeComplianceSubmissionAuthorizationResponses, OrgComplianceOrgRunComplianceDerivationData, OrgComplianceOrgRunComplianceDerivationErrors, OrgComplianceOrgRunComplianceDerivationResponses, OrgComplianceOrgSetComplianceAiSettingData, OrgComplianceOrgSetComplianceAiSettingErrors, OrgComplianceOrgSetComplianceAiSettingResponses, OrgComplianceOrgSetComplianceSigningSettingData, OrgComplianceOrgSetComplianceSigningSettingErrors, OrgComplianceOrgSetComplianceSigningSettingResponses, OrgComplianceOrgSignComplianceSigningRequestData, OrgComplianceOrgSignComplianceSigningRequestErrors, OrgComplianceOrgSignComplianceSigningRequestResponses, OrgComplianceOrgStartComplianceFormPreparationData, OrgComplianceOrgStartComplianceFormPreparationErrors, OrgComplianceOrgStartComplianceFormPreparationResponses, OrgComplianceOrgStopTrackingComplianceObligationData, OrgComplianceOrgStopTrackingComplianceObligationErrors, OrgComplianceOrgStopTrackingComplianceObligationResponses, OrgComplianceOrgSwitchComplianceOrganizationFilingData, OrgComplianceOrgSwitchComplianceOrganizationFilingErrors, OrgComplianceOrgSwitchComplianceOrganizationFilingResponses, OrgComplianceOrgTakeComplianceFilingFromDeskData, OrgComplianceOrgTakeComplianceFilingFromDeskErrors, OrgComplianceOrgTakeComplianceFilingFromDeskResponses, OrgComplianceOrgUnlinkComplianceVendorFilingData, OrgComplianceOrgUnlinkComplianceVendorFilingErrors, OrgComplianceOrgUnlinkComplianceVendorFilingResponses, OrgComplianceOrgUpdateComplianceOrganizationFilingData, OrgComplianceOrgUpdateComplianceOrganizationFilingErrors, OrgComplianceOrgUpdateComplianceOrganizationFilingResponses, OrgComplianceOrgWithdrawComplianceFilingCaseData, OrgComplianceOrgWithdrawComplianceFilingCaseErrors, OrgComplianceOrgWithdrawComplianceFilingCaseResponses, OrgComplianceOrgWithdrawComplianceReviewAskData, OrgComplianceOrgWithdrawComplianceReviewAskErrors, OrgComplianceOrgWithdrawComplianceReviewAskResponses, OrgComplianceOrgWithdrawComplianceSignatureData, OrgComplianceOrgWithdrawComplianceSignatureErrors, OrgComplianceOrgWithdrawComplianceSignatureResponses, OrgConfirmationRequestsConfirmOrgConfirmationRequestData, OrgConfirmationRequestsConfirmOrgConfirmationRequestErrors, OrgConfirmationRequestsConfirmOrgConfirmationRequestResponses, OrgConfirmationRequestsDeclineOrgConfirmationRequestData, OrgConfirmationRequestsDeclineOrgConfirmationRequestErrors, OrgConfirmationRequestsDeclineOrgConfirmationRequestResponses, OrgConfirmationRequestsGetOrgConfirmationRequestData, OrgConfirmationRequestsGetOrgConfirmationRequestErrors, OrgConfirmationRequestsGetOrgConfirmationRequestResponses, OrgConfirmationRequestsGetOrgMoneyFloorsData, OrgConfirmationRequestsGetOrgMoneyFloorsErrors, OrgConfirmationRequestsGetOrgMoneyFloorsResponses, OrgConfirmationRequestsListOrgConfirmationRequestsData, OrgConfirmationRequestsListOrgConfirmationRequestsErrors, OrgConfirmationRequestsListOrgConfirmationRequestsResponses, OrgConfirmationRequestsSaveOrgMoneyFloorData, OrgConfirmationRequestsSaveOrgMoneyFloorErrors, OrgConfirmationRequestsSaveOrgMoneyFloorResponses, OrgConsoleAcceptOrgAssistantConsentData, OrgConsoleAcceptOrgAssistantConsentErrors, OrgConsoleAcceptOrgAssistantConsentResponses, OrgConsoleAcceptOrgInviteData, OrgConsoleAcceptOrgInviteErrors, OrgConsoleAcceptOrgInviteResponses, OrgConsoleAcceptOrgModuleTermsData, OrgConsoleAcceptOrgModuleTermsErrors, OrgConsoleAcceptOrgModuleTermsResponses, OrgConsoleApproveOrgAccessRequestData, OrgConsoleApproveOrgAccessRequestErrors, OrgConsoleApproveOrgAccessRequestResponses, OrgConsoleChangeOrgMemberRoleData, OrgConsoleChangeOrgMemberRoleErrors, OrgConsoleChangeOrgMemberRoleResponses, OrgConsoleCreateOrgAccessRequestData, OrgConsoleCreateOrgAccessRequestErrors, OrgConsoleCreateOrgAccessRequestResponses, OrgConsoleCreateOrgInviteData, OrgConsoleCreateOrgInviteErrors, OrgConsoleCreateOrgInviteResponses, OrgConsoleDeactivateOrgData, OrgConsoleDeactivateOrgErrors, OrgConsoleDeactivateOrgResponses, OrgConsoleDenyOrgAccessRequestData, OrgConsoleDenyOrgAccessRequestErrors, OrgConsoleDenyOrgAccessRequestResponses, OrgConsoleGetOrgAccessCatalogData, OrgConsoleGetOrgAccessCatalogErrors, OrgConsoleGetOrgAccessCatalogResponses, OrgConsoleGetOrgAccessSettingsData, OrgConsoleGetOrgAccessSettingsErrors, OrgConsoleGetOrgAccessSettingsResponses, OrgConsoleGetOrgAdminPreferencesData, OrgConsoleGetOrgAdminPreferencesErrors, OrgConsoleGetOrgAdminPreferencesResponses, OrgConsoleGetOrgAssistantConsentData, OrgConsoleGetOrgAssistantConsentErrors, OrgConsoleGetOrgAssistantConsentResponses, OrgConsoleGetOrgMeasurementConfigData, OrgConsoleGetOrgMeasurementConfigErrors, OrgConsoleGetOrgMeasurementConfigResponses, OrgConsoleGetOrgModuleTermsData, OrgConsoleGetOrgModuleTermsErrors, OrgConsoleGetOrgModuleTermsResponses, OrgConsoleGetOrgSelfAccessData, OrgConsoleGetOrgSelfAccessErrors, OrgConsoleGetOrgSelfAccessResponses, OrgConsoleListOrgAccessEventsData, OrgConsoleListOrgAccessEventsErrors, OrgConsoleListOrgAccessEventsResponses, OrgConsoleListOrgAccessRequestsData, OrgConsoleListOrgAccessRequestsErrors, OrgConsoleListOrgAccessRequestsResponses, OrgConsoleListOrgConnectedAiData, OrgConsoleListOrgConnectedAiErrors, OrgConsoleListOrgConnectedAiResponses, OrgConsoleListOrgConsoleMembersData, OrgConsoleListOrgConsoleMembersErrors, OrgConsoleListOrgConsoleMembersResponses, OrgConsoleListOrgInvitesData, OrgConsoleListOrgInvitesErrors, OrgConsoleListOrgInvitesResponses, OrgConsoleRemoveOrgMemberData, OrgConsoleRemoveOrgMemberErrors, OrgConsoleRemoveOrgMemberModuleAccessData, OrgConsoleRemoveOrgMemberModuleAccessErrors, OrgConsoleRemoveOrgMemberModuleAccessResponses, OrgConsoleRemoveOrgMemberResponses, OrgConsoleRevokeOrgAssistantConsentData, OrgConsoleRevokeOrgAssistantConsentErrors, OrgConsoleRevokeOrgAssistantConsentResponses, OrgConsoleRevokeOrgConnectedAiData, OrgConsoleRevokeOrgConnectedAiErrors, OrgConsoleRevokeOrgConnectedAiResponses, OrgConsoleRevokeOrgInviteData, OrgConsoleRevokeOrgInviteErrors, OrgConsoleRevokeOrgInviteResponses, OrgConsoleUpdateOrgAccessSettingsData, OrgConsoleUpdateOrgAccessSettingsErrors, OrgConsoleUpdateOrgAccessSettingsResponses, OrgConsoleUpdateOrgAdminPreferencesData, OrgConsoleUpdateOrgAdminPreferencesErrors, OrgConsoleUpdateOrgAdminPreferencesResponses, OrgConsoleUpdateOrgMeasurementConfigData, OrgConsoleUpdateOrgMeasurementConfigErrors, OrgConsoleUpdateOrgMeasurementConfigResponses, OrgConsoleUpdateOrgMemberAccessData, OrgConsoleUpdateOrgMemberAccessErrors, OrgConsoleUpdateOrgMemberAccessResponses, OrgFundraisersCloseOrgFundraiserData, OrgFundraisersCloseOrgFundraiserErrors, OrgFundraisersCloseOrgFundraiserResponses, OrgFundraisersCreateOrgFundraiserData, OrgFundraisersCreateOrgFundraiserErrors, OrgFundraisersCreateOrgFundraiserResponses, OrgFundraisersDeactivateOrgFundraiserData, OrgFundraisersDeactivateOrgFundraiserErrors, OrgFundraisersDeactivateOrgFundraiserResponses, OrgFundraisersDeleteOrgFundraiserData, OrgFundraisersDeleteOrgFundraiserErrors, OrgFundraisersDeleteOrgFundraiserResponses, OrgFundraisersDownloadOrgFundraiserShareKitGraphicsData, OrgFundraisersDownloadOrgFundraiserShareKitGraphicsErrors, OrgFundraisersDownloadOrgFundraiserShareKitGraphicsResponses, OrgFundraisersGetOrgFundraiserData, OrgFundraisersGetOrgFundraiserErrors, OrgFundraisersGetOrgFundraiserResponses, OrgFundraisersGetOrgFundraiserShareData, OrgFundraisersGetOrgFundraiserShareErrors, OrgFundraisersGetOrgFundraiserShareKitData, OrgFundraisersGetOrgFundraiserShareKitErrors, OrgFundraisersGetOrgFundraiserShareKitResponses, OrgFundraisersGetOrgFundraiserShareResponses, OrgFundraisersListOrgFundraiserDonorMessagesData, OrgFundraisersListOrgFundraiserDonorMessagesErrors, OrgFundraisersListOrgFundraiserDonorMessagesResponses, OrgFundraisersListOrgFundraiserDonorsData, OrgFundraisersListOrgFundraiserDonorsErrors, OrgFundraisersListOrgFundraiserDonorsResponses, OrgFundraisersListOrgFundraisersData, OrgFundraisersListOrgFundraisersErrors, OrgFundraisersListOrgFundraisersResponses, OrgFundraisersListOrgSupporterFundraisersData, OrgFundraisersListOrgSupporterFundraisersErrors, OrgFundraisersListOrgSupporterFundraisersResponses, OrgFundraisersPublishOrgFundraiserData, OrgFundraisersPublishOrgFundraiserErrors, OrgFundraisersPublishOrgFundraiserResponses, OrgFundraisersPutOrgFundraiserDesignationsData, OrgFundraisersPutOrgFundraiserDesignationsErrors, OrgFundraisersPutOrgFundraiserDesignationsResponses, OrgFundraisersReactivateOrgFundraiserData, OrgFundraisersReactivateOrgFundraiserErrors, OrgFundraisersReactivateOrgFundraiserResponses, OrgFundraisersRenderOrgFundraiserShareQrData, OrgFundraisersRenderOrgFundraiserShareQrErrors, OrgFundraisersRenderOrgFundraiserShareQrResponses, OrgFundraisersRenderSuppliedOrgFundraiserShareQrData, OrgFundraisersRenderSuppliedOrgFundraiserShareQrErrors, OrgFundraisersRenderSuppliedOrgFundraiserShareQrResponses, OrgFundraisersReopenOrgFundraiserData, OrgFundraisersReopenOrgFundraiserErrors, OrgFundraisersReopenOrgFundraiserResponses, OrgFundraisersSendOrgFundraiserDonorMessageData, OrgFundraisersSendOrgFundraiserDonorMessageErrors, OrgFundraisersSendOrgFundraiserDonorMessageResponses, OrgFundraisersUpdateOrgFundraiserData, OrgFundraisersUpdateOrgFundraiserErrors, OrgFundraisersUpdateOrgFundraiserResponses, OrgIntegrationsAbandonOrgIntegrationPendingData, OrgIntegrationsAbandonOrgIntegrationPendingErrors, OrgIntegrationsAbandonOrgIntegrationPendingResponses, OrgIntegrationsCompleteOrgIntegrationOauthAccountsData, OrgIntegrationsCompleteOrgIntegrationOauthAccountsErrors, OrgIntegrationsCompleteOrgIntegrationOauthAccountsResponses, OrgIntegrationsCompleteOrgIntegrationOauthData, OrgIntegrationsCompleteOrgIntegrationOauthErrors, OrgIntegrationsCompleteOrgIntegrationOauthResponses, OrgIntegrationsDisconnectOrgIntegrationData, OrgIntegrationsDisconnectOrgIntegrationErrors, OrgIntegrationsDisconnectOrgIntegrationResponses, OrgIntegrationsGetOrgIntegrationData, OrgIntegrationsGetOrgIntegrationErrors, OrgIntegrationsGetOrgIntegrationPendingData, OrgIntegrationsGetOrgIntegrationPendingErrors, OrgIntegrationsGetOrgIntegrationPendingResponses, OrgIntegrationsGetOrgIntegrationResponses, OrgIntegrationsListOrgIntegrationOfferedProvidersData, OrgIntegrationsListOrgIntegrationOfferedProvidersErrors, OrgIntegrationsListOrgIntegrationOfferedProvidersResponses, OrgIntegrationsListOrgIntegrationsData, OrgIntegrationsListOrgIntegrationsErrors, OrgIntegrationsListOrgIntegrationsResponses, OrgIntegrationsSelectOrgIntegrationPendingData, OrgIntegrationsSelectOrgIntegrationPendingErrors, OrgIntegrationsSelectOrgIntegrationPendingResponses, OrgIntegrationsStartOrgIntegrationOauthData, OrgIntegrationsStartOrgIntegrationOauthErrors, OrgIntegrationsStartOrgIntegrationOauthResponses, OrgQrDesignGetOrgQrDesignData, OrgQrDesignGetOrgQrDesignErrors, OrgQrDesignGetOrgQrDesignResponses, OrgQrDesignRenderOrgPublicQrData, OrgQrDesignRenderOrgPublicQrErrors, OrgQrDesignRenderOrgPublicQrResponses, OrgQrDesignRenderSuppliedOrgPublicQrData, OrgQrDesignRenderSuppliedOrgPublicQrErrors, OrgQrDesignRenderSuppliedOrgPublicQrResponses, OrgQrDesignUpdateOrgQrDesignData, OrgQrDesignUpdateOrgQrDesignErrors, OrgQrDesignUpdateOrgQrDesignResponses, OrgSocialCancelOrgSocialPostData, OrgSocialCancelOrgSocialPostErrors, OrgSocialCancelOrgSocialPostResponses, OrgSocialCreateOrgSocialPostData, OrgSocialCreateOrgSocialPostErrors, OrgSocialCreateOrgSocialPostResponses, OrgSocialDeleteOrgSocialPostData, OrgSocialDeleteOrgSocialPostErrors, OrgSocialDeleteOrgSocialPostResponses, OrgSocialGetOrgSocialPostData, OrgSocialGetOrgSocialPostErrors, OrgSocialGetOrgSocialPostResponses, OrgSocialListOrgSocialPostsData, OrgSocialListOrgSocialPostsErrors, OrgSocialListOrgSocialPostsResponses, OrgSocialPublishOrgSocialPostData, OrgSocialPublishOrgSocialPostErrors, OrgSocialPublishOrgSocialPostResponses, OrgSocialRetryOrgSocialVariantData, OrgSocialRetryOrgSocialVariantErrors, OrgSocialRetryOrgSocialVariantResponses, OrgSocialUpdateOrgSocialPostData, OrgSocialUpdateOrgSocialPostErrors, OrgSocialUpdateOrgSocialPostResponses, OrgSocialUploadOrgSocialImageData, OrgSocialUploadOrgSocialImageErrors, OrgSocialUploadOrgSocialImageResponses, P2pCheckCampaignJoinData, P2pCheckCampaignJoinErrors, P2pCheckCampaignJoinResponses, P2pGetActivityData, P2pGetActivityErrors, P2pGetActivityResponses, P2pGetCampaignP2pData, P2pGetCampaignP2pErrors, P2pGetCampaignP2pResponses, P2pGetLeaderboardData, P2pGetLeaderboardErrors, P2pGetLeaderboardResponses, P2pGetMyCampaignJoinRequestData, P2pGetMyCampaignJoinRequestErrors, P2pGetMyCampaignJoinRequestResponses, P2pGetSupporterData, P2pGetSupporterErrors, P2pGetSupporterResponses, P2pGetTeamData, P2pGetTeamErrors, P2pGetTeamResponses, P2pJoinCampaignData, P2pJoinCampaignErrors, P2pJoinCampaignResponses, P2pListGiveOptionsData, P2pListGiveOptionsErrors, P2pListGiveOptionsResponses, P2pListTeamsData, P2pListTeamsErrors, P2pListTeamsResponses, P2pRequestToJoinCampaignData, P2pRequestToJoinCampaignErrors, P2pRequestToJoinCampaignResponses, P2pUpdateSupporterData, P2pUpdateSupporterErrors, P2pUpdateSupporterResponses, P2pWithdrawMyCampaignJoinRequestData, P2pWithdrawMyCampaignJoinRequestErrors, P2pWithdrawMyCampaignJoinRequestResponses, PasskeysDeleteMyPasskeyData, PasskeysDeleteMyPasskeyErrors, PasskeysDeleteMyPasskeyResponses, PasskeysFinishPasskeyReauthenticationData, PasskeysFinishPasskeyReauthenticationErrors, PasskeysFinishPasskeyReauthenticationResponses, PasskeysFinishPasskeyRegistrationData, PasskeysFinishPasskeyRegistrationErrors, PasskeysFinishPasskeyRegistrationResponses, PasskeysListMyPasskeysData, PasskeysListMyPasskeysResponses, PasskeysRenameMyPasskeyData, PasskeysRenameMyPasskeyErrors, PasskeysRenameMyPasskeyResponses, PasskeysStartPasskeyReauthenticationData, PasskeysStartPasskeyReauthenticationResponses, PasskeysStartPasskeyRegistrationData, PasskeysStartPasskeyRegistrationResponses, PaymentsGetPaymentReconciliationData, PaymentsGetPaymentReconciliationErrors, PaymentsGetPaymentReconciliationResponses, PaymentsGetPaymentsConfigData, PaymentsGetPaymentsConfigResponses, PaymentsListReconcileReviewChargeIntentsData, PaymentsListReconcileReviewChargeIntentsResponses, PledgesAcceptAttestationData, PledgesAcceptAttestationErrors, PledgesAcceptAttestationResponses, PledgesCancelGuestPledgeData, PledgesCancelGuestPledgeErrors, PledgesCancelGuestPledgeResponses, PledgesCancelPledgeData, PledgesCancelPledgeErrors, PledgesCancelPledgeResponses, PledgesChooseGuestPledgeAmountData, PledgesChooseGuestPledgeAmountErrors, PledgesChooseGuestPledgeAmountResponses, PledgesChoosePledgeAmountData, PledgesChoosePledgeAmountErrors, PledgesChoosePledgeAmountResponses, PledgesClearPledgeTemplateData, PledgesClearPledgeTemplateErrors, PledgesClearPledgeTemplateResponses, PledgesCreateGuestOfferPledgeData, PledgesCreateGuestOfferPledgeErrors, PledgesCreateGuestOfferPledgeResponses, PledgesCreateGuestPledgeData, PledgesCreateGuestPledgeErrors, PledgesCreateGuestPledgeResponses, PledgesCreatePledgeCampaignData, PledgesCreatePledgeCampaignErrors, PledgesCreatePledgeCampaignResponses, PledgesCreatePledgeData, PledgesCreatePledgeErrors, PledgesCreatePledgeResponses, PledgesGetGuestPledgeData, PledgesGetGuestPledgeErrors, PledgesGetGuestPledgeResponses, PledgesGetPledgeCampaignData, PledgesGetPledgeCampaignErrors, PledgesGetPledgeCampaignResponses, PledgesGetPledgeOfferData, PledgesGetPledgeOfferErrors, PledgesGetPledgeOfferResponses, PledgesGetPledgeProjectedTotalData, PledgesGetPledgeProjectedTotalErrors, PledgesGetPledgeProjectedTotalResponses, PledgesGetPledgesLiveData, PledgesGetPledgesLiveErrors, PledgesGetPledgesLiveResponses, PledgesGetPledgeTemplateData, PledgesGetPledgeTemplateErrors, PledgesGetPledgeTemplateResponses, PledgesListFundraiserPledgeOffersData, PledgesListFundraiserPledgeOffersErrors, PledgesListFundraiserPledgeOffersResponses, PledgesListOwnPledgesData, PledgesListOwnPledgesResponses, PledgesObjectToGuestPledgeData, PledgesObjectToGuestPledgeErrors, PledgesObjectToGuestPledgeResponses, PledgesObjectToPledgeData, PledgesObjectToPledgeErrors, PledgesObjectToPledgeResponses, PledgesPreviewPledgeOfferRuleData, PledgesPreviewPledgeOfferRuleErrors, PledgesPreviewPledgeOfferRuleResponses, PledgesSetPledgeTemplateData, PledgesSetPledgeTemplateErrors, PledgesSetPledgeTemplateResponses, PledgesSubmitAttestationData, PledgesSubmitAttestationErrors, PledgesSubmitAttestationResponses, PostsCommentPostData, PostsCommentPostErrors, PostsCommentPostResponses, PostsDeleteCommentData, PostsDeleteCommentErrors, PostsDeleteCommentResponses, PostsGetCharityPostsData, PostsGetCharityPostsErrors, PostsGetCharityPostsResponses, PostsGetCommentLikesData, PostsGetCommentLikesErrors, PostsGetCommentLikesResponses, PostsGetEtfPostsData, PostsGetEtfPostsErrors, PostsGetEtfPostsResponses, PostsGetFollowsPostsData, PostsGetFollowsPostsErrors, PostsGetFollowsPostsResponses, PostsGetFundraiserPostsData, PostsGetFundraiserPostsErrors, PostsGetFundraiserPostsResponses, PostsGetMyPostsData, PostsGetMyPostsErrors, PostsGetMyPostsResponses, PostsGetPostCommentsData, PostsGetPostCommentsErrors, PostsGetPostCommentsResponses, PostsGetPostData, PostsGetPostErrors, PostsGetPostLikesData, PostsGetPostLikesErrors, PostsGetPostLikesResponses, PostsGetPostResponses, PostsGetSuperAdminRecentPublicPostsData, PostsGetSuperAdminRecentPublicPostsErrors, PostsGetSuperAdminRecentPublicPostsResponses, PostsGetUsersPublicPostsData, PostsGetUsersPublicPostsErrors, PostsGetUsersPublicPostsResponses, PostsHideCommentData, PostsHideCommentErrors, PostsHideCommentResponses, PostsHidePostData, PostsHidePostErrors, PostsHidePostResponses, PostsLikeCommentData, PostsLikeCommentErrors, PostsLikeCommentResponses, PostsLikePostData, PostsLikePostErrors, PostsLikePostResponses, PostsReportPostData, PostsReportPostErrors, PostsReportPostResponses, PostsUnhideCommentData, PostsUnhideCommentErrors, PostsUnhideCommentResponses, PostsUnhidePostData, PostsUnhidePostErrors, PostsUnhidePostResponses, PostsUnlikeCommentData, PostsUnlikeCommentErrors, PostsUnlikeCommentResponses, PostsUnlikePostData, PostsUnlikePostErrors, PostsUnlikePostResponses, PostsUpdatePostMessageData, PostsUpdatePostMessageErrors, PostsUpdatePostMessageResponses, PostsUpdatePostVisibilityData, PostsUpdatePostVisibilityErrors, PostsUpdatePostVisibilityResponses, ProfilePagesGetConsumerPageData, ProfilePagesGetConsumerPageErrors, ProfilePagesGetConsumerPageResponses, ProfilePagesPublicGetPublicProfilePageData, ProfilePagesPublicGetPublicProfilePageErrors, ProfilePagesPublicGetPublicProfilePageResponses, ProfilePagesReplaceConsumerPageData, ProfilePagesReplaceConsumerPageErrors, ProfilePagesReplaceConsumerPageResponses, ProfilePagesUploadConsumerPageImageData, ProfilePagesUploadConsumerPageImageErrors, ProfilePagesUploadConsumerPageImageResponses, ProfileReportsReportProfileBlockData, ProfileReportsReportProfileBlockErrors, ProfileReportsReportProfileBlockResponses, ProfileReportsReportUserProfileData, ProfileReportsReportUserProfileErrors, ProfileReportsReportUserProfileResponses, ReceiptFinePrintGetReceiptFinePrintDetailData, ReceiptFinePrintGetReceiptFinePrintDetailErrors, ReceiptFinePrintGetReceiptFinePrintDetailResponses, ReceiptFinePrintListReceiptFinePrintData, ReceiptFinePrintListReceiptFinePrintResponses, ReceiptFinePrintSetReceiptFinePrintEffectiveData, ReceiptFinePrintSetReceiptFinePrintEffectiveErrors, ReceiptFinePrintSetReceiptFinePrintEffectiveResponses, SearchGetSearchFeedData, SearchGetSearchFeedErrors, SearchGetSearchFeedResponses, ShareKitDownloadMyShareKitGraphicsData, ShareKitDownloadMyShareKitGraphicsErrors, ShareKitDownloadMyShareKitGraphicsResponses, ShareKitGetMyShareKitData, ShareKitGetMyShareKitErrors, ShareKitGetMyShareKitResponses, ShareKitRenderMyShareKitQrData, ShareKitRenderMyShareKitQrErrors, ShareKitRenderMyShareKitQrResponses, StepsCompetitionsAdminCancelAdminStepsCompetitionData, StepsCompetitionsAdminCancelAdminStepsCompetitionErrors, StepsCompetitionsAdminCancelAdminStepsCompetitionResponses, StepsCompetitionsAdminCreateAdminStepsCompetitionData, StepsCompetitionsAdminCreateAdminStepsCompetitionErrors, StepsCompetitionsAdminCreateAdminStepsCompetitionResponses, StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryData, StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryErrors, StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryResponses, StepsCompetitionsAdminGetAdminStepsCompetitionData, StepsCompetitionsAdminGetAdminStepsCompetitionErrors, StepsCompetitionsAdminGetAdminStepsCompetitionResponses, StepsCompetitionsAdminGetStepsSponsorDpaData, StepsCompetitionsAdminGetStepsSponsorDpaResponses, StepsCompetitionsAdminListAdminStepsCompetitionEntriesData, StepsCompetitionsAdminListAdminStepsCompetitionEntriesErrors, StepsCompetitionsAdminListAdminStepsCompetitionEntriesResponses, StepsCompetitionsAdminListAdminStepsCompetitionsData, StepsCompetitionsAdminListAdminStepsCompetitionsErrors, StepsCompetitionsAdminListAdminStepsCompetitionsResponses, StepsCompetitionsAdminPublishAdminStepsCompetitionData, StepsCompetitionsAdminPublishAdminStepsCompetitionErrors, StepsCompetitionsAdminPublishAdminStepsCompetitionResponses, StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryData, StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryErrors, StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryResponses, StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionData, StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionErrors, StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionResponses, StepsCompetitionsAdminUpdateAdminStepsCompetitionData, StepsCompetitionsAdminUpdateAdminStepsCompetitionErrors, StepsCompetitionsAdminUpdateAdminStepsCompetitionResponses, StepsCompetitionsGetCompanyPublicStepsCompetitionsData, StepsCompetitionsGetCompanyPublicStepsCompetitionsErrors, StepsCompetitionsGetCompanyPublicStepsCompetitionsResponses, StepsCompetitionsGetStepsCompetitionData, StepsCompetitionsGetStepsCompetitionErrors, StepsCompetitionsGetStepsCompetitionLeaderboardData, StepsCompetitionsGetStepsCompetitionLeaderboardErrors, StepsCompetitionsGetStepsCompetitionLeaderboardResponses, StepsCompetitionsGetStepsCompetitionResponses, StepsCompetitionsJoinStepsCompetitionData, StepsCompetitionsJoinStepsCompetitionErrors, StepsCompetitionsJoinStepsCompetitionResponses, StepsCompetitionsListStepsCompetitionsData, StepsCompetitionsListStepsCompetitionsErrors, StepsCompetitionsListStepsCompetitionsResponses, StepsCompetitionsRestateMyStepsData, StepsCompetitionsRestateMyStepsErrors, StepsCompetitionsRestateMyStepsResponses, StepsCompetitionsUpdateMyStepsEntryData, StepsCompetitionsUpdateMyStepsEntryErrors, StepsCompetitionsUpdateMyStepsEntryResponses, StepsCompetitionsWithdrawFromStepsCompetitionData, StepsCompetitionsWithdrawFromStepsCompetitionErrors, StepsCompetitionsWithdrawFromStepsCompetitionResponses, StepUpMintStepUpFromReauthData, StepUpMintStepUpFromReauthErrors, StepUpMintStepUpFromReauthResponses, SuperAdminChampionOpsFileChampionReportData, SuperAdminChampionOpsFileChampionReportErrors, SuperAdminChampionOpsFileChampionReportResponses, SuperAdminChampionOpsInspectChampionByHandleData, SuperAdminChampionOpsInspectChampionByHandleErrors, SuperAdminChampionOpsInspectChampionByHandleResponses, SuperAdminChampionOpsInspectChampionData, SuperAdminChampionOpsInspectChampionErrors, SuperAdminChampionOpsInspectChampionResponses, SuperAdminChampionOpsListChampionsData, SuperAdminChampionOpsListChampionsErrors, SuperAdminChampionOpsListChampionsResponses, SuperAdminChampionOpsReclaimChampionHandleData, SuperAdminChampionOpsReclaimChampionHandleErrors, SuperAdminChampionOpsReclaimChampionHandleResponses, SuperAdminCharityClaimsApproveCharityClaimData, SuperAdminCharityClaimsApproveCharityClaimErrors, SuperAdminCharityClaimsApproveCharityClaimResponses, SuperAdminCharityClaimsApproveCharityClaimTransferData, SuperAdminCharityClaimsApproveCharityClaimTransferErrors, SuperAdminCharityClaimsApproveCharityClaimTransferResponses, SuperAdminCharityClaimsGetCharityClaimDetailData, SuperAdminCharityClaimsGetCharityClaimDetailErrors, SuperAdminCharityClaimsGetCharityClaimDetailResponses, SuperAdminCharityClaimsListPendingCharityClaimsData, SuperAdminCharityClaimsListPendingCharityClaimsErrors, SuperAdminCharityClaimsListPendingCharityClaimsResponses, SuperAdminCharityClaimsRejectCharityClaimData, SuperAdminCharityClaimsRejectCharityClaimErrors, SuperAdminCharityClaimsRejectCharityClaimResponses, SuperAdminCharityConsentOpsGetCharityAuditTrailData, SuperAdminCharityConsentOpsGetCharityAuditTrailErrors, SuperAdminCharityConsentOpsGetCharityAuditTrailResponses, SuperAdminCharityConsentOpsGetClaimVelocityReportData, SuperAdminCharityConsentOpsGetClaimVelocityReportResponses, SuperAdminCharityConsentOpsListCharityConsentStatesData, SuperAdminCharityConsentOpsListCharityConsentStatesErrors, SuperAdminCharityConsentOpsListCharityConsentStatesResponses, SuperAdminCharityDisplayNamesApproveCharityDisplayNameData, SuperAdminCharityDisplayNamesApproveCharityDisplayNameErrors, SuperAdminCharityDisplayNamesApproveCharityDisplayNameResponses, SuperAdminCharityDisplayNamesEndCharityDisplayNameData, SuperAdminCharityDisplayNamesEndCharityDisplayNameErrors, SuperAdminCharityDisplayNamesEndCharityDisplayNameResponses, SuperAdminCharityDisplayNamesListCharityDisplayNamesData, SuperAdminCharityDisplayNamesListCharityDisplayNamesErrors, SuperAdminCharityDisplayNamesListCharityDisplayNamesResponses, SuperAdminCharityDisplayNamesRejectCharityDisplayNameData, SuperAdminCharityDisplayNamesRejectCharityDisplayNameErrors, SuperAdminCharityDisplayNamesRejectCharityDisplayNameResponses, SuperAdminCharityInstantClaimAllowCharityInstantClaimData, SuperAdminCharityInstantClaimAllowCharityInstantClaimErrors, SuperAdminCharityInstantClaimAllowCharityInstantClaimResponses, SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesData, SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesErrors, SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesResponses, SuperAdminCharityInstantClaimRevokeCharityInstantClaimData, SuperAdminCharityInstantClaimRevokeCharityInstantClaimErrors, SuperAdminCharityInstantClaimRevokeCharityInstantClaimResponses, SuperAdminCharityOnboardingTestGetCharityOnboardingTestData, SuperAdminCharityOnboardingTestGetCharityOnboardingTestResponses, SuperAdminCharityOnboardingTestResetCharityOnboardingTestData, SuperAdminCharityOnboardingTestResetCharityOnboardingTestErrors, SuperAdminCharityOnboardingTestResetCharityOnboardingTestResponses, SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagData, SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagErrors, SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagResponses, SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailData, SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailErrors, SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailResponses, SuperAdminCharityPayeeFlagsListCharityPayeeFlagsData, SuperAdminCharityPayeeFlagsListCharityPayeeFlagsResponses, SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagData, SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagErrors, SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagResponses, SuperAdminCharityRemovalsCancelCharityRemovalData, SuperAdminCharityRemovalsCancelCharityRemovalErrors, SuperAdminCharityRemovalsCancelCharityRemovalResponses, SuperAdminCharityRemovalsGetCharityRemovalDetailData, SuperAdminCharityRemovalsGetCharityRemovalDetailErrors, SuperAdminCharityRemovalsGetCharityRemovalDetailResponses, SuperAdminCharityRemovalsListCharityRemovalQueueData, SuperAdminCharityRemovalsListCharityRemovalQueueResponses, SuperAdminCharityRemovalsProcessCharityRemovalData, SuperAdminCharityRemovalsProcessCharityRemovalErrors, SuperAdminCharityRemovalsProcessCharityRemovalResponses, SuperAdminCharityRemovalsVerifyCharityRemovalIdentityData, SuperAdminCharityRemovalsVerifyCharityRemovalIdentityErrors, SuperAdminCharityRemovalsVerifyCharityRemovalIdentityResponses, SuperAdminContentReportsListContentReportsData, SuperAdminContentReportsListContentReportsErrors, SuperAdminContentReportsListContentReportsResponses, SuperAdminDafTransfersAppendDafTransferArrivalNoteData, SuperAdminDafTransfersAppendDafTransferArrivalNoteErrors, SuperAdminDafTransfersAppendDafTransferArrivalNoteResponses, SuperAdminDafTransfersAppendDafTransferEventData, SuperAdminDafTransfersAppendDafTransferEventErrors, SuperAdminDafTransfersAppendDafTransferEventResponses, SuperAdminDafTransfersCloseDafTransferIntentData, SuperAdminDafTransfersCloseDafTransferIntentErrors, SuperAdminDafTransfersCloseDafTransferIntentResponses, SuperAdminDafTransfersCreditDafTransferArrivalData, SuperAdminDafTransfersCreditDafTransferArrivalErrors, SuperAdminDafTransfersCreditDafTransferArrivalResponses, SuperAdminDafTransfersGetDafTransferArrivalData, SuperAdminDafTransfersGetDafTransferArrivalErrors, SuperAdminDafTransfersGetDafTransferArrivalResponses, SuperAdminDafTransfersLinkDafTransferArrivalData, SuperAdminDafTransfersLinkDafTransferArrivalErrors, SuperAdminDafTransfersLinkDafTransferArrivalResponses, SuperAdminDafTransfersListDafTransferArrivalAgingData, SuperAdminDafTransfersListDafTransferArrivalAgingErrors, SuperAdminDafTransfersListDafTransferArrivalAgingResponses, SuperAdminDafTransfersListDafTransferArrivalCandidatesData, SuperAdminDafTransfersListDafTransferArrivalCandidatesErrors, SuperAdminDafTransfersListDafTransferArrivalCandidatesResponses, SuperAdminDafTransfersListDafTransferArrivalNotesData, SuperAdminDafTransfersListDafTransferArrivalNotesErrors, SuperAdminDafTransfersListDafTransferArrivalNotesResponses, SuperAdminDafTransfersListDafTransferArrivalsData, SuperAdminDafTransfersListDafTransferArrivalsErrors, SuperAdminDafTransfersListDafTransferArrivalsResponses, SuperAdminDafTransfersListDafTransferIntentAgingData, SuperAdminDafTransfersListDafTransferIntentAgingErrors, SuperAdminDafTransfersListDafTransferIntentAgingResponses, SuperAdminDafTransfersRegisterDafTransferArrivalData, SuperAdminDafTransfersRegisterDafTransferArrivalErrors, SuperAdminDafTransfersRegisterDafTransferArrivalResponses, SuperAdminDafTransfersRegisterDafTransferIntentData, SuperAdminDafTransfersRegisterDafTransferIntentErrors, SuperAdminDafTransfersRegisterDafTransferIntentResponses, SuperAdminDafTransfersRevokeDafTransferArrivalLinkData, SuperAdminDafTransfersRevokeDafTransferArrivalLinkErrors, SuperAdminDafTransfersRevokeDafTransferArrivalLinkResponses, SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameData, SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameErrors, SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameResponses, SuperAdminDisbursementApprovalsListDisbursementApprovalsData, SuperAdminDisbursementApprovalsListDisbursementApprovalsErrors, SuperAdminDisbursementApprovalsListDisbursementApprovalsResponses, SuperAdminDisbursementApprovalsRecordDisbursementApprovalData, SuperAdminDisbursementApprovalsRecordDisbursementApprovalErrors, SuperAdminDisbursementApprovalsRecordDisbursementApprovalResponses, SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationData, SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationErrors, SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationResponses, SuperAdminDisbursementApprovalsRevokeDisbursementApprovalData, SuperAdminDisbursementApprovalsRevokeDisbursementApprovalErrors, SuperAdminDisbursementApprovalsRevokeDisbursementApprovalResponses, SuperAdminDonationOpsClearDonationDisbursementHoldData, SuperAdminDonationOpsClearDonationDisbursementHoldErrors, SuperAdminDonationOpsClearDonationDisbursementHoldResponses, SuperAdminDonationOpsCorrectUserBirthDateData, SuperAdminDonationOpsCorrectUserBirthDateErrors, SuperAdminDonationOpsCorrectUserBirthDateResponses, SuperAdminDonationOpsCreateExternalDonationOnBehalfData, SuperAdminDonationOpsCreateExternalDonationOnBehalfErrors, SuperAdminDonationOpsCreateExternalDonationOnBehalfResponses, SuperAdminDonationOpsGetClaimConversionData, SuperAdminDonationOpsGetClaimConversionErrors, SuperAdminDonationOpsGetClaimConversionResponses, SuperAdminDonationOpsGetEmployerLinkageData, SuperAdminDonationOpsGetEmployerLinkageErrors, SuperAdminDonationOpsGetEmployerLinkageResponses, SuperAdminDonationOpsGetPaymentMethodReportData, SuperAdminDonationOpsGetPaymentMethodReportErrors, SuperAdminDonationOpsGetPaymentMethodReportResponses, SuperAdminDonationOpsGetUserProfileData, SuperAdminDonationOpsGetUserProfileErrors, SuperAdminDonationOpsGetUserProfileResponses, SuperAdminDonationOpsLinkCompanyAttestedData, SuperAdminDonationOpsLinkCompanyAttestedErrors, SuperAdminDonationOpsLinkCompanyAttestedResponses, SuperAdminDonationOpsListUserDonationsData, SuperAdminDonationOpsListUserDonationsErrors, SuperAdminDonationOpsListUserDonationsResponses, SuperAdminDonationOpsReAdviseConnectDonationIntentData, SuperAdminDonationOpsReAdviseConnectDonationIntentErrors, SuperAdminDonationOpsReAdviseConnectDonationIntentResponses, SuperAdminDonationOpsSearchUserByEmailData, SuperAdminDonationOpsSearchUserByEmailErrors, SuperAdminDonationOpsSearchUserByEmailResponses, SuperAdminDonationOpsSearchUsersByNameData, SuperAdminDonationOpsSearchUsersByNameErrors, SuperAdminDonationOpsSearchUsersByNameResponses, SuperAdminDonationOpsSetDonationDisbursementHoldData, SuperAdminDonationOpsSetDonationDisbursementHoldErrors, SuperAdminDonationOpsSetDonationDisbursementHoldResponses, SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentData, SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentErrors, SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentResponses, SuperAdminEntityEnrollmentsOperatorGetEnrollmentData, SuperAdminEntityEnrollmentsOperatorGetEnrollmentErrors, SuperAdminEntityEnrollmentsOperatorGetEnrollmentResponses, SuperAdminEntityEnrollmentsOperatorListEnrollmentsData, SuperAdminEntityEnrollmentsOperatorListEnrollmentsErrors, SuperAdminEntityEnrollmentsOperatorListEnrollmentsResponses, SuperAdminEntityEnrollmentsOperatorRedriveProvisionData, SuperAdminEntityEnrollmentsOperatorRedriveProvisionErrors, SuperAdminEntityEnrollmentsOperatorRedriveProvisionResponses, SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyData, SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyErrors, SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyResponses, SuperAdminEntityEnrollmentsOperatorRejectEnrollmentData, SuperAdminEntityEnrollmentsOperatorRejectEnrollmentErrors, SuperAdminEntityEnrollmentsOperatorRejectEnrollmentResponses, SuperAdminEntityEnrollmentsOperatorStartImportRunData, SuperAdminEntityEnrollmentsOperatorStartImportRunErrors, SuperAdminEntityEnrollmentsOperatorStartImportRunResponses, SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsData, SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsErrors, SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsResponses, SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionData, SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionErrors, SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionResponses, SuperAdminGrantsOpsAttestGroupExemptionCureData, SuperAdminGrantsOpsAttestGroupExemptionCureErrors, SuperAdminGrantsOpsAttestGroupExemptionCureResponses, SuperAdminGrantsOpsGetCharityBucketData, SuperAdminGrantsOpsGetCharityBucketErrors, SuperAdminGrantsOpsGetCharityBucketResponses, SuperAdminGrantsOpsGetCohortData, SuperAdminGrantsOpsGetCohortErrors, SuperAdminGrantsOpsGetCohortResponses, SuperAdminGrantsOpsGetDonationTrailData, SuperAdminGrantsOpsGetDonationTrailErrors, SuperAdminGrantsOpsGetDonationTrailResponses, SuperAdminGrantsOpsGetEligibilityEvidenceData, SuperAdminGrantsOpsGetEligibilityEvidenceErrors, SuperAdminGrantsOpsGetEligibilityEvidenceResponses, SuperAdminGrantsOpsGetOpsStripData, SuperAdminGrantsOpsGetOpsStripResponses, SuperAdminGrantsOpsListCharityBucketsData, SuperAdminGrantsOpsListCharityBucketsErrors, SuperAdminGrantsOpsListCharityBucketsResponses, SuperAdminGrantsOpsListCohortsData, SuperAdminGrantsOpsListCohortsErrors, SuperAdminGrantsOpsListCohortsResponses, SuperAdminGrantsOpsListGroupExemptionCuresData, SuperAdminGrantsOpsListGroupExemptionCuresErrors, SuperAdminGrantsOpsListGroupExemptionCuresResponses, SuperAdminGrantsOpsRecordGroupRulingLetterData, SuperAdminGrantsOpsRecordGroupRulingLetterErrors, SuperAdminGrantsOpsRecordGroupRulingLetterResponses, SuperAdminGrantsOpsRecordIneligibilityAlternateData, SuperAdminGrantsOpsRecordIneligibilityAlternateErrors, SuperAdminGrantsOpsRecordIneligibilityAlternateResponses, SuperAdminGrantsOpsRecordIneligibilityDeterminationData, SuperAdminGrantsOpsRecordIneligibilityDeterminationErrors, SuperAdminGrantsOpsRecordIneligibilityDeterminationResponses, SuperAdminGrantsOpsRecordIneligibilityNoticeData, SuperAdminGrantsOpsRecordIneligibilityNoticeErrors, SuperAdminGrantsOpsRecordIneligibilityNoticeResponses, SuperAdminGrantsOpsRevokeGroupExemptionCureData, SuperAdminGrantsOpsRevokeGroupExemptionCureErrors, SuperAdminGrantsOpsRevokeGroupExemptionCureResponses, SuperAdminGrantsOpsSearchDonationsData, SuperAdminGrantsOpsSearchDonationsErrors, SuperAdminGrantsOpsSearchDonationsResponses, SuperAdminGrantsOpsWithdrawGroupRulingLetterData, SuperAdminGrantsOpsWithdrawGroupRulingLetterErrors, SuperAdminGrantsOpsWithdrawGroupRulingLetterResponses, SuperAdminGroupOpsEvacuateGroupFundsData, SuperAdminGroupOpsEvacuateGroupFundsErrors, SuperAdminGroupOpsEvacuateGroupFundsResponses, SuperAdminGroupOpsGetGroupsForModerationData, SuperAdminGroupOpsGetGroupsForModerationErrors, SuperAdminGroupOpsGetGroupsForModerationResponses, SuperAdminGroupOpsModerateGroupData, SuperAdminGroupOpsModerateGroupErrors, SuperAdminGroupOpsModerateGroupResponses, SuperAdminGroupOpsRelistGroupData, SuperAdminGroupOpsRelistGroupErrors, SuperAdminGroupOpsRelistGroupResponses, SuperAdminGroupOpsUnlistGroupData, SuperAdminGroupOpsUnlistGroupErrors, SuperAdminGroupOpsUnlistGroupResponses, SuperAdminMatchOffersGetMatchOfferDetailData, SuperAdminMatchOffersGetMatchOfferDetailErrors, SuperAdminMatchOffersGetMatchOfferDetailResponses, SuperAdminMatchOffersListMatchOfferClaimsData, SuperAdminMatchOffersListMatchOfferClaimsErrors, SuperAdminMatchOffersListMatchOfferClaimsResponses, SuperAdminMatchOffersListMatchOffersData, SuperAdminMatchOffersListMatchOffersErrors, SuperAdminMatchOffersListMatchOffersResponses, SuperAdminMatchOffersRedirectMatchClaimAdminData, SuperAdminMatchOffersRedirectMatchClaimAdminErrors, SuperAdminMatchOffersRedirectMatchClaimAdminResponses, SuperAdminMatchOffersResumeMatchOfferData, SuperAdminMatchOffersResumeMatchOfferErrors, SuperAdminMatchOffersResumeMatchOfferLegData, SuperAdminMatchOffersResumeMatchOfferLegErrors, SuperAdminMatchOffersResumeMatchOfferLegResponses, SuperAdminMatchOffersResumeMatchOfferResponses, SuperAdminMatchOffersSuspendMatchOfferData, SuperAdminMatchOffersSuspendMatchOfferErrors, SuperAdminMatchOffersSuspendMatchOfferLegData, SuperAdminMatchOffersSuspendMatchOfferLegErrors, SuperAdminMatchOffersSuspendMatchOfferLegResponses, SuperAdminMatchOffersSuspendMatchOfferResponses, SuperAdminMatchOffersVoidMatchOfferData, SuperAdminMatchOffersVoidMatchOfferErrors, SuperAdminMatchOffersVoidMatchOfferResponses, SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmData, SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmErrors, SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmResponses, SuperAdminOperatorDashboardGetOperatorQueueData, SuperAdminOperatorDashboardGetOperatorQueueErrors, SuperAdminOperatorDashboardGetOperatorQueueResponses, SuperAdminOperatorDashboardGetOperatorStatsData, SuperAdminOperatorDashboardGetOperatorStatsErrors, SuperAdminOperatorDashboardGetOperatorStatsResponses, SuperAdminOperatorDashboardGetTelemetryEventSummaryData, SuperAdminOperatorDashboardGetTelemetryEventSummaryErrors, SuperAdminOperatorDashboardGetTelemetryEventSummaryResponses, SuperAdminPlatformGrantFactsGetPlatformGrantFactsData, SuperAdminPlatformGrantFactsGetPlatformGrantFactsErrors, SuperAdminPlatformGrantFactsGetPlatformGrantFactsResponses, SuperAdminPledgesAcceptCampaignData, SuperAdminPledgesAcceptCampaignErrors, SuperAdminPledgesAcceptCampaignResponses, SuperAdminPledgesApprovePublishReviewData, SuperAdminPledgesApprovePublishReviewErrors, SuperAdminPledgesApprovePublishReviewResponses, SuperAdminPledgesCancelPledgeData, SuperAdminPledgesCancelPledgeErrors, SuperAdminPledgesCancelPledgeResponses, SuperAdminPledgesDismissObjectionData, SuperAdminPledgesDismissObjectionErrors, SuperAdminPledgesDismissObjectionResponses, SuperAdminPledgesGetReviewCampaignDetailData, SuperAdminPledgesGetReviewCampaignDetailErrors, SuperAdminPledgesGetReviewCampaignDetailResponses, SuperAdminPledgesListHeldPledgesData, SuperAdminPledgesListHeldPledgesErrors, SuperAdminPledgesListHeldPledgesResponses, SuperAdminPledgesListPublishReviewCampaignsData, SuperAdminPledgesListPublishReviewCampaignsErrors, SuperAdminPledgesListPublishReviewCampaignsResponses, SuperAdminPledgesListReviewCampaignsData, SuperAdminPledgesListReviewCampaignsErrors, SuperAdminPledgesListReviewCampaignsResponses, SuperAdminPledgesPartialSettlePledgeData, SuperAdminPledgesPartialSettlePledgeErrors, SuperAdminPledgesPartialSettlePledgeResponses, SuperAdminPledgesRejectPublishReviewData, SuperAdminPledgesRejectPublishReviewErrors, SuperAdminPledgesRejectPublishReviewResponses, SuperAdminPledgesResolveHeldPledgeData, SuperAdminPledgesResolveHeldPledgeErrors, SuperAdminPledgesResolveHeldPledgeResponses, SuperAdminPledgesVoidCampaignData, SuperAdminPledgesVoidCampaignErrors, SuperAdminPledgesVoidCampaignResponses, SuperAdminProfileBlocksListProfileBlocksForModerationData, SuperAdminProfileBlocksListProfileBlocksForModerationErrors, SuperAdminProfileBlocksListProfileBlocksForModerationResponses, SuperAdminProfileBlocksRelistProfileBlockData, SuperAdminProfileBlocksRelistProfileBlockErrors, SuperAdminProfileBlocksRelistProfileBlockResponses, SuperAdminProfileBlocksUnlistProfileBlockData, SuperAdminProfileBlocksUnlistProfileBlockErrors, SuperAdminProfileBlocksUnlistProfileBlockResponses, SurveysGetCharityRecommendationsData, SurveysGetCharityRecommendationsResponses, SurveysGetSavedRecommendationsData, SurveysGetSavedRecommendationsResponses, SurveysSubmitSurveyAnswerData, SurveysSubmitSurveyAnswerErrors, SurveysSubmitSurveyAnswerResponses, TelemetryEventsRecordTelemetryEventData, TelemetryEventsRecordTelemetryEventErrors, TelemetryEventsRecordTelemetryEventResponses, TermsGetCurrentTermsData, TermsGetCurrentTermsResponses, TermsGetLatestTermsData, TermsGetLatestTermsErrors, TermsGetLatestTermsResponses, TermsGetNotificationStatusData, TermsGetNotificationStatusErrors, TermsGetNotificationStatusResponses, TermsGetRecentNotificationsData, TermsGetRecentNotificationsErrors, TermsGetRecentNotificationsResponses, TermsGetTermsDetailData, TermsGetTermsDetailErrors, TermsGetTermsDetailResponses, TermsGetTermsNotifyAudienceCountData, TermsGetTermsNotifyAudienceCountErrors, TermsGetTermsNotifyAudienceCountResponses, TermsGetTermsNotifyPreviewData, TermsGetTermsNotifyPreviewErrors, TermsGetTermsNotifyPreviewResponses, TermsGetTermsVersionData, TermsGetTermsVersionErrors, TermsGetTermsVersionResponses, TermsListTermsData, TermsListTermsErrors, TermsListTermsResponses, TermsNotifyTermsAtSuperAdminData, TermsNotifyTermsAtSuperAdminErrors, TermsNotifyTermsAtSuperAdminResponses, TermsNotifyTermsData, TermsNotifyTermsErrors, TermsNotifyTermsResponses, TermsPatchTermsSummaryAtSuperAdminData, TermsPatchTermsSummaryAtSuperAdminErrors, TermsPatchTermsSummaryAtSuperAdminResponses, TermsPatchTermsSummaryData, TermsPatchTermsSummaryErrors, TermsPatchTermsSummaryResponses, TermsPostTermsNotifyTestAtSuperAdminData, TermsPostTermsNotifyTestAtSuperAdminErrors, TermsPostTermsNotifyTestAtSuperAdminResponses, TermsPostTermsNotifyTestData, TermsPostTermsNotifyTestErrors, TermsPostTermsNotifyTestResponses, TermsPublishTermsAtSuperAdminData, TermsPublishTermsAtSuperAdminErrors, TermsPublishTermsAtSuperAdminResponses, TermsPublishTermsData, TermsPublishTermsErrors, TermsPublishTermsResponses, TermsRetryFailedBatchesAtSuperAdminData, TermsRetryFailedBatchesAtSuperAdminErrors, TermsRetryFailedBatchesAtSuperAdminResponses, TermsRetryFailedBatchesData, TermsRetryFailedBatchesErrors, TermsRetryFailedBatchesResponses, UsersActivateMyRecurringDonationData, UsersActivateMyRecurringDonationErrors, UsersActivateMyRecurringDonationResponses, UsersBlockUserData, UsersBlockUserErrors, UsersBlockUserResponses, UsersCancelMyRecurringDonationData, UsersCancelMyRecurringDonationErrors, UsersCancelMyRecurringDonationResponses, UsersCheckEmailAvailableData, UsersCheckEmailAvailableErrors, UsersCheckEmailAvailableResponses, UsersCheckPhoneAvailableData, UsersCheckPhoneAvailableErrors, UsersCheckPhoneAvailableResponses, UsersCheckUsernameAvailableData, UsersCheckUsernameAvailableErrors, UsersCheckUsernameAvailableResponses, UsersCheckWorkEmailData, UsersCheckWorkEmailErrors, UsersCheckWorkEmailResponses, UsersConfirmUserEmailData, UsersConfirmUserEmailErrors, UsersConfirmUserEmailResponses, UsersCreateUserCardData, UsersCreateUserCardErrors, UsersCreateUserCardResponses, UsersCreateUserCardV2Data, UsersCreateUserCardV2Errors, UsersCreateUserCardV2Responses, UsersCreateUserData, UsersCreateUserErrors, UsersCreateUserResponses, UsersDeleteMyConnectedAppData, UsersDeleteMyConnectedAppErrors, UsersDeleteMyConnectedAppResponses, UsersDeleteUserCardData, UsersDeleteUserCardErrors, UsersDeleteUserCardResponses, UsersDeleteUserData, UsersDeleteUserErrors, UsersDeleteUserResponses, UsersDepositFundsData, UsersDepositFundsErrors, UsersDepositFundsResponses, UsersDownloadMyChampionQrData, UsersDownloadMyChampionQrErrors, UsersDownloadMyChampionQrResponses, UserSecurityCancelMyFactorResetData, UserSecurityCancelMyFactorResetResponses, UserSecurityConfirmMySsoLinkData, UserSecurityConfirmMySsoLinkErrors, UserSecurityConfirmMySsoLinkResponses, UserSecurityGetMySecurityData, UserSecurityGetMySecurityResponses, UserSecurityMintMyRecoveryCodesData, UserSecurityMintMyRecoveryCodesResponses, UserSecurityOptInToMySmsNoticesData, UserSecurityOptInToMySmsNoticesErrors, UserSecurityOptInToMySmsNoticesResponses, UserSecurityOptOutOfMySmsNoticesData, UserSecurityOptOutOfMySmsNoticesResponses, UserSecurityReEnableMySmsNoticesData, UserSecurityReEnableMySmsNoticesResponses, UserSecurityRegenerateMyRecoveryCodesData, UserSecurityRegenerateMyRecoveryCodesResponses, UserSecuritySignOutEverywhereData, UserSecuritySignOutEverywhereResponses, UserSecurityStartMySsoLinkData, UserSecurityStartMySsoLinkErrors, UserSecurityStartMySsoLinkResponses, UserSecuritySyncMyFactorsData, UserSecuritySyncMyFactorsResponses, UsersGetMeData, UsersGetMeResponses, UsersGetMyChampionData, UsersGetMyChampionResponses, UsersGetMyConnectedAppsData, UsersGetMyConnectedAppsResponses, UsersGetMyGivingProfileData, UsersGetMyGivingProfileResponses, UsersGetMyMembershipsData, UsersGetMyMembershipsResponses, UsersGetMyQrDesignData, UsersGetMyQrDesignResponses, UsersGetMyRecurringDonationsData, UsersGetMyRecurringDonationsResponses, UsersGetUpcomingBirthdaysData, UsersGetUpcomingBirthdaysResponses, UsersGetUserCardsData, UsersGetUserCardsResponses, UsersGetUserCardsV2Data, UsersGetUserCardsV2Responses, UsersGetUserChampionedCharityDonatedAmountData, UsersGetUserChampionedCharityDonatedAmountResponses, UsersGetUserData, UsersGetUserErrors, UsersGetUserImpactData, UsersGetUserImpactMethodologyData, UsersGetUserImpactMethodologyResponses, UsersGetUserImpactResponses, UsersGetUserPrivateStatisticsData, UsersGetUserPrivateStatisticsResponses, UsersGetUserResponses, UsersGetUsersData, UsersGetUsersErrors, UsersGetUsersResponses, UsersGetUserStatisticsData, UsersGetUserStatisticsErrors, UsersGetUserStatisticsResponses, UsersGetUserWalletData, UsersGetUserWalletResponses, UsersGraduateUserData, UsersGraduateUserErrors, UsersGraduateUserResponses, UsersLinkCompanyData, UsersLinkCompanyErrors, UsersLinkCompanyResponses, UsersListBlockedUsersData, UsersListBlockedUsersErrors, UsersListBlockedUsersResponses, UsersListStuckUserDeletionsData, UsersListStuckUserDeletionsResponses, UsersMintMyShareRefData, UsersMintMyShareRefErrors, UsersMintMyShareRefResponses, UsersRetryFailedUserDeletionsData, UsersRetryFailedUserDeletionsResponses, UsersSaveMyQrDesignData, UsersSaveMyQrDesignErrors, UsersSaveMyQrDesignResponses, UsersSendEmailVerificationData, UsersSendEmailVerificationErrors, UsersSendEmailVerificationResponses, UsersSetMyChampionCharityData, UsersSetMyChampionCharityErrors, UsersSetMyChampionCharityResponses, UsersSetMyChampionTargetData, UsersSetMyChampionTargetErrors, UsersSetMyChampionTargetResponses, UsersUnblockUserData, UsersUnblockUserErrors, UsersUnblockUserResponses, UsersUnlinkCompanyData, UsersUnlinkCompanyResponses, UsersUpdateBirthdayVisibilityData, UsersUpdateBirthdayVisibilityErrors, UsersUpdateBirthdayVisibilityResponses, UsersUpdateMyGivingProfileData, UsersUpdateMyGivingProfileErrors, UsersUpdateMyGivingProfileResponses, UsersUpdateMyRecurringDonationData, UsersUpdateMyRecurringDonationErrors, UsersUpdateMyRecurringDonationResponses, UsersUpdateUserByIdData, UsersUpdateUserByIdErrors, UsersUpdateUserByIdResponses, UsersUpdateUserChampionedCharityData, UsersUpdateUserChampionedCharityErrors, UsersUpdateUserChampionedCharityResponses, UsersUpdateUserCustomerIdData, UsersUpdateUserCustomerIdErrors, UsersUpdateUserCustomerIdResponses, UsersUpdateUserData, UsersUpdateUserErrors, UsersUpdateUserFacebookIdData, UsersUpdateUserFacebookIdErrors, UsersUpdateUserFacebookIdResponses, UsersUpdateUserPaymentMethodData, UsersUpdateUserPaymentMethodErrors, UsersUpdateUserPaymentMethodResponses, UsersUpdateUserPreferencesData, UsersUpdateUserPreferencesErrors, UsersUpdateUserPreferencesResponses, UsersUpdateUserResponses, UsersUploadUserProfilePictureData, UsersUploadUserProfilePictureErrors, UsersUploadUserProfilePictureResponses, UsersVerifyAccessData, UsersVerifyAccessResponses, UsersVerifyWorkEmailData, UsersVerifyWorkEmailErrors, UsersVerifyWorkEmailResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Test Flight
 */
export const apiTestFlight = <ThrowOnError extends boolean = false>(options?: Options<ApiTestFlightData, ThrowOnError>): RequestResult<ApiTestFlightResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ApiTestFlightResponses, unknown, ThrowOnError>({ url: '/', ...options });

/**
 * Activate Company
 */
export const companiesActivateCompany = <ThrowOnError extends boolean = false>(options: Options<CompaniesActivateCompanyData, ThrowOnError>): RequestResult<CompaniesActivateCompanyResponses, CompaniesActivateCompanyErrors, ThrowOnError> => (options.client ?? client).post<CompaniesActivateCompanyResponses, CompaniesActivateCompanyErrors, ThrowOnError>({ url: '/admin/companies/{company_id}/activate', ...options });

/**
 * Get Company
 */
export const companiesGetCompany = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyData, ThrowOnError>): RequestResult<CompaniesGetCompanyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyResponses, unknown, ThrowOnError>({ url: '/admin/company', ...options });

/**
 * Create Company
 */
export const companiesCreateCompany = <ThrowOnError extends boolean = false>(options: Options<CompaniesCreateCompanyData, ThrowOnError>): RequestResult<CompaniesCreateCompanyResponses, CompaniesCreateCompanyErrors, ThrowOnError> => (options.client ?? client).post<CompaniesCreateCompanyResponses, CompaniesCreateCompanyErrors, ThrowOnError>({
    url: '/admin/company',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Company Account Info
 */
export const companiesUpdateCompanyAccountInfo = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyAccountInfoData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyAccountInfoResponses, CompaniesUpdateCompanyAccountInfoErrors, ThrowOnError> => (options.client ?? client).put<CompaniesUpdateCompanyAccountInfoResponses, CompaniesUpdateCompanyAccountInfoErrors, ThrowOnError>({
    url: '/admin/company',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Admins
 */
export const companiesGetCompanyAdmins = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyAdminsData, ThrowOnError>): RequestResult<CompaniesGetCompanyAdminsResponses, CompaniesGetCompanyAdminsErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyAdminsResponses, CompaniesGetCompanyAdminsErrors, ThrowOnError>({ url: '/admin/company/admins', ...options });

/**
 * Create Company Admin
 */
export const companiesCreateCompanyAdmin = <ThrowOnError extends boolean = false>(options: Options<CompaniesCreateCompanyAdminData, ThrowOnError>): RequestResult<CompaniesCreateCompanyAdminResponses, CompaniesCreateCompanyAdminErrors, ThrowOnError> => (options.client ?? client).post<CompaniesCreateCompanyAdminResponses, CompaniesCreateCompanyAdminErrors, ThrowOnError>({
    url: '/admin/company/admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Admin From Company
 */
export const companiesRemoveAdminFromCompany = <ThrowOnError extends boolean = false>(options: Options<CompaniesRemoveAdminFromCompanyData, ThrowOnError>): RequestResult<CompaniesRemoveAdminFromCompanyResponses, CompaniesRemoveAdminFromCompanyErrors, ThrowOnError> => (options.client ?? client).delete<CompaniesRemoveAdminFromCompanyResponses, CompaniesRemoveAdminFromCompanyErrors, ThrowOnError>({ url: '/admin/company/admins/{target_user_id}', ...options });

/**
 * Update Company Admin Name
 */
export const companiesUpdateCompanyAdminName = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyAdminNameData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyAdminNameResponses, CompaniesUpdateCompanyAdminNameErrors, ThrowOnError> => (options.client ?? client).put<CompaniesUpdateCompanyAdminNameResponses, CompaniesUpdateCompanyAdminNameErrors, ThrowOnError>({
    url: '/admin/company/admins/{target_user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Company Admin Role
 */
export const companiesUpdateCompanyAdminRole = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyAdminRoleData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyAdminRoleResponses, CompaniesUpdateCompanyAdminRoleErrors, ThrowOnError> => (options.client ?? client).put<CompaniesUpdateCompanyAdminRoleResponses, CompaniesUpdateCompanyAdminRoleErrors, ThrowOnError>({
    url: '/admin/company/admins/{target_user_id}/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Company Admin Role
 *
 * OM-57 (D-CPO-64) — change an admin's role with a choice, nothing pre-checked:
 * `{"role": "Owner"}` makes them a Global Admin (no `modules`); `{"role": "Member",
 * "modules": [{"module", "role"}]}` makes a Global Admin a regular admin holding exactly
 * those apps, at least one, with nothing kept implicitly. Refused with `ROLE_CHANGE_*` 422s
 * before any write; a target already a regular admin is a 409 unless this is a retry.
 *
 * A NEW route beside `PUT …/role`, which keeps today's behaviour through the window (a
 * demoted Global Admin keeps the three predecessor apps at Member): an old backend answers
 * this one 404 and changes nothing. Global Admin only (`company_admin:edit`, the role
 * edit's gate); the last Global Admin cannot be demoted (the role edit's 400). The same
 * writer as `POST /org/{org_ref}/members/{target_user_id}/role-change`.
 */
export const companiesChangeCompanyAdminRole = <ThrowOnError extends boolean = false>(options: Options<CompaniesChangeCompanyAdminRoleData, ThrowOnError>): RequestResult<CompaniesChangeCompanyAdminRoleResponses, CompaniesChangeCompanyAdminRoleErrors, ThrowOnError> => (options.client ?? client).post<CompaniesChangeCompanyAdminRoleResponses, CompaniesChangeCompanyAdminRoleErrors, ThrowOnError>({
    url: '/admin/company/admins/{target_user_id}/role-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Champion
 *
 * CQ2-BE1: the company's champion (get-or-create) — immutable slug + current
 * handle. Separate from the user surface; does NOT touch GET /admin/company /
 * CompanyDetailedOut.
 */
export const companiesGetCompanyChampion = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyChampionData, ThrowOnError>): RequestResult<CompaniesGetCompanyChampionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyChampionResponses, unknown, ThrowOnError>({ url: '/admin/company/champion', ...options });

/**
 * Set Company Champion Charity
 *
 * CQ2-BE1: the NEW company-admin championed-charity setter. Sets the
 * company's `championed_charity_id` (read by the resolver) and ensures a company
 * champion is minted, via the shared `ChampionService` helper. Owner =
 * (company, user.admin_company), router-injected — never spread from the body.
 * Deliberately a NEW route: the user route + UseDetailedOut stay untouched.
 */
export const companiesSetCompanyChampionCharity = <ThrowOnError extends boolean = false>(options: Options<CompaniesSetCompanyChampionCharityData, ThrowOnError>): RequestResult<CompaniesSetCompanyChampionCharityResponses, CompaniesSetCompanyChampionCharityErrors, ThrowOnError> => (options.client ?? client).put<CompaniesSetCompanyChampionCharityResponses, CompaniesSetCompanyChampionCharityErrors, ThrowOnError>({
    url: '/admin/company/champion/championed_charity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Company Champion Handle
 *
 * CQ2-BE1: change the company champion's handle. Retires the current handle
 * (permanent-redirect) and mints the new one; reserved-word/charset validated,
 * never-recycle enforced, rate-limited.
 */
export const companiesChangeCompanyChampionHandle = <ThrowOnError extends boolean = false>(options: Options<CompaniesChangeCompanyChampionHandleData, ThrowOnError>): RequestResult<CompaniesChangeCompanyChampionHandleResponses, CompaniesChangeCompanyChampionHandleErrors, ThrowOnError> => (options.client ?? client).put<CompaniesChangeCompanyChampionHandleResponses, CompaniesChangeCompanyChampionHandleErrors, ThrowOnError>({
    url: '/admin/company/champion/handle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Champion Handle Suggestion
 *
 * CQ2-BE3: preview an admin-confirmable, brand-derived handle suggestion for
 * the company champion. Derives a candidate from the company's name (falling
 * back to its domain) and reports whether it is available against the
 * never-recycle store + reserved words. COMMITS NOTHING — the admin confirms by
 * claiming the suggested handle via PUT /admin/company/champion/handle. The
 * mint default is NOT changed: a brand handle is opt-in via this suggest→confirm
 * flow, never silently auto-claimed. Owner = (company, user.admin_company),
 * router-injected — never spread from the body.
 */
export const companiesGetCompanyChampionHandleSuggestion = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyChampionHandleSuggestionData, ThrowOnError>): RequestResult<CompaniesGetCompanyChampionHandleSuggestionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyChampionHandleSuggestionResponses, unknown, ThrowOnError>({ url: '/admin/company/champion/handle/suggestion', ...options });

/**
 * Download Company Champion Qr
 *
 * CQ2-BE2b: render + download the company's OWN champion QR in
 * `{format}` ∈ {svg, png, pdf}. The company-admin analogue of
 * `download_my_champion_qr`: owner = (company, user.admin_company),
 * router-injected — never request-supplied. All three formats derive from the
 * one hand-built SVG. Gated dark by `CHAMPION_GIVE_HOST_ENABLED` (404 off);
 * per-IP rate limit FAILS CLOSED and runs BEFORE the render. With
 * `QR_ENTITY_LOGO_ENABLED` on, a design that chose the entity logo draws the
 * company's own stored logo (CQ3-BE6); off, the Givmo mark, as before.
 */
export const companiesDownloadCompanyChampionQr = <ThrowOnError extends boolean = false>(options: Options<CompaniesDownloadCompanyChampionQrData, ThrowOnError>): RequestResult<CompaniesDownloadCompanyChampionQrResponses, CompaniesDownloadCompanyChampionQrErrors, ThrowOnError> => (options.client ?? client).get<CompaniesDownloadCompanyChampionQrResponses, CompaniesDownloadCompanyChampionQrErrors, ThrowOnError>({ url: '/admin/company/champion/qr.{format}', ...options });

/**
 * Upload Company Cover Picture
 */
export const companiesUploadCompanyCoverPicture = <ThrowOnError extends boolean = false>(options: Options<CompaniesUploadCompanyCoverPictureData, ThrowOnError>): RequestResult<CompaniesUploadCompanyCoverPictureResponses, CompaniesUploadCompanyCoverPictureErrors, ThrowOnError> => (options.client ?? client).post<CompaniesUploadCompanyCoverPictureResponses, CompaniesUploadCompanyCoverPictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/admin/company/cover_picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Update Company Customer Id
 */
export const companiesUpdateCompanyCustomerId = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyCustomerIdData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyCustomerIdResponses, CompaniesUpdateCompanyCustomerIdErrors, ThrowOnError> => (options.client ?? client).put<CompaniesUpdateCompanyCustomerIdResponses, CompaniesUpdateCompanyCustomerIdErrors, ThrowOnError>({
    url: '/admin/company/customer_id',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Dashboard
 */
export const companiesGetCompanyDashboard = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyDashboardData, ThrowOnError>): RequestResult<CompaniesGetCompanyDashboardResponses, CompaniesGetCompanyDashboardErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyDashboardResponses, CompaniesGetCompanyDashboardErrors, ThrowOnError>({ url: '/admin/company/dashboard', ...options });

/**
 * Get Company Donation Volume
 *
 * The company's matched-donation volume bucketed monthly (Jan → current
 * month, ET), current year vs prior year — its own endpoint so the heavier
 * group-by doesn't block the dashboard's first paint.
 */
export const companiesGetCompanyDonationVolume = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyDonationVolumeData, ThrowOnError>): RequestResult<CompaniesGetCompanyDonationVolumeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyDonationVolumeResponses, unknown, ThrowOnError>({ url: '/admin/company/dashboard/donation-volume', ...options });

/**
 * Get Company Top Charities
 *
 * The company's most contributed-to charities this year (matched union),
 * ranked by total contributed — its own endpoint for the same reason.
 */
export const companiesGetCompanyTopCharities = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyTopCharitiesData, ThrowOnError>): RequestResult<CompaniesGetCompanyTopCharitiesResponses, CompaniesGetCompanyTopCharitiesErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyTopCharitiesResponses, CompaniesGetCompanyTopCharitiesErrors, ThrowOnError>({ url: '/admin/company/dashboard/top-charities', ...options });

/**
 * Deactivate Company
 *
 * Deactivate the caller's company.
 *
 * OM-9 (D-CPO-32): once `ORG_DEACTIVATION_ENABLED` is on this is an ALIAS of
 * `POST /org/{org_ref}/deactivate` — the same service, the same act (every
 * administrator's standing ends, sessions revoked, the org plane emptied, the
 * `company.status` dual-write applied), the same `company:deactivate` authority —
 * keeping the wire the employer portal and folder 35 of the e2e suite call today:
 * 204, no body. While the flag is off it is byte-identical to the legacy status
 * flip.
 */
export const companiesDeactivateCompany = <ThrowOnError extends boolean = false>(options?: Options<CompaniesDeactivateCompanyData, ThrowOnError>): RequestResult<CompaniesDeactivateCompanyResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CompaniesDeactivateCompanyResponses, unknown, ThrowOnError>({ url: '/admin/company/deactivate', ...options });

/**
 * Quote Company Donation
 *
 * CAM-BE13 (D-CAM-40): what a company-funded gift of `amount` would charge,
 * covered and not, priced by the resolution the gift itself uses (the stored
 * card's brand, the company's own cover-fees setting, its platform rate) — a saved
 * company card (`Credit Card` + `card_id`) or the company wallet (`Wallet`). The
 * same for every recipient. Member or Owner, like the gift. Moves no money.
 */
export const companiesQuoteCompanyDonation = <ThrowOnError extends boolean = false>(options: Options<CompaniesQuoteCompanyDonationData, ThrowOnError>): RequestResult<CompaniesQuoteCompanyDonationResponses, CompaniesQuoteCompanyDonationErrors, ThrowOnError> => (options.client ?? client).get<CompaniesQuoteCompanyDonationResponses, CompaniesQuoteCompanyDonationErrors, ThrowOnError>({ url: '/admin/company/donations/quote', ...options });

/**
 * Get Company Donation Amount
 */
export const companiesGetCompanyDonationAmount = <ThrowOnError extends boolean = false>(options: Options<CompaniesGetCompanyDonationAmountData, ThrowOnError>): RequestResult<CompaniesGetCompanyDonationAmountResponses, CompaniesGetCompanyDonationAmountErrors, ThrowOnError> => (options.client ?? client).get<CompaniesGetCompanyDonationAmountResponses, CompaniesGetCompanyDonationAmountErrors, ThrowOnError>({ url: '/admin/company/donations/{donation_id}/allowed_amount', ...options });

/**
 * Approve Donation Match
 */
export const companiesApproveDonationMatch = <ThrowOnError extends boolean = false>(options: Options<CompaniesApproveDonationMatchData, ThrowOnError>): RequestResult<CompaniesApproveDonationMatchResponses, CompaniesApproveDonationMatchErrors, ThrowOnError> => (options.client ?? client).post<CompaniesApproveDonationMatchResponses, CompaniesApproveDonationMatchErrors, ThrowOnError>({
    url: '/admin/company/donations/{donation_id}/match',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject Donation Match
 */
export const companiesRejectDonationMatch = <ThrowOnError extends boolean = false>(options: Options<CompaniesRejectDonationMatchData, ThrowOnError>): RequestResult<CompaniesRejectDonationMatchResponses, CompaniesRejectDonationMatchErrors, ThrowOnError> => (options.client ?? client).post<CompaniesRejectDonationMatchResponses, CompaniesRejectDonationMatchErrors, ThrowOnError>({ url: '/admin/company/donations/{donation_id}/match/reject', ...options });

/**
 * Remove Employees From Company
 */
export const companiesRemoveEmployeesFromCompany = <ThrowOnError extends boolean = false>(options?: Options<CompaniesRemoveEmployeesFromCompanyData, ThrowOnError>): RequestResult<CompaniesRemoveEmployeesFromCompanyResponses, CompaniesRemoveEmployeesFromCompanyErrors, ThrowOnError> => (options?.client ?? client).delete<CompaniesRemoveEmployeesFromCompanyResponses, CompaniesRemoveEmployeesFromCompanyErrors, ThrowOnError>({ url: '/admin/company/employees', ...options });

/**
 * Get Company Employees
 */
export const companiesGetCompanyEmployees = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyEmployeesData, ThrowOnError>): RequestResult<CompaniesGetCompanyEmployeesResponses, CompaniesGetCompanyEmployeesErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyEmployeesResponses, CompaniesGetCompanyEmployeesErrors, ThrowOnError>({ url: '/admin/company/employees', ...options });

/**
 * Import Company Employee Occasion Dates
 *
 * **Company admin only** (`company:send_gift_cards`): mass-import
 * employer-entered occasion dates from an uploaded CSV.
 *
 * Header required: `work_email,birthday,hire_date`. `birthday` is `MM-DD` with NO
 * YEAR (a value carrying one is REFUSED rather than truncated — the employer must
 * not believe Givmo stored a birth year it deliberately does not keep); `hire_date`
 * is `YYYY-MM-DD`. A blank cell leaves that date alone; the literal `-` clears it.
 *
 * Every row is echoed with its own outcome (`created` / `updated` / `unchanged` /
 * `unmatched` / `invalid`, with a reason). `unchanged` covers both a row that asked
 * for nothing (all cells blank) and a row that asked for exactly what is already
 * stored — so re-running the same HR export reports no-ops rather than phantom
 * updates. Unmatched and invalid rows do NOT fail the request: re-uploading an HR
 * export that spans several employers, or that has a few malformed lines, is the
 * normal case, and discarding the good rows with the bad would make the feature
 * unusable on real HR data. Matching is by `work_email` against THIS company's
 * roster only. Structural problems (wrong header, no data rows, too many rows) are
 * 400 — the caller cannot have meant those.
 *
 * **Applied per row, not atomically.** Each applied row commits on its own, so a
 * request that dies mid-file leaves the rows it already applied in place and the
 * rest untouched — there is no rollback of the whole upload. Re-upload the same
 * file to converge: every write is idempotent, so rows already applied come back
 * as `unchanged`. A 2xx response's counts describe what was applied, not an
 * all-or-nothing outcome.
 */
export const companiesImportCompanyEmployeeOccasionDates = <ThrowOnError extends boolean = false>(options: Options<CompaniesImportCompanyEmployeeOccasionDatesData, ThrowOnError>): RequestResult<CompaniesImportCompanyEmployeeOccasionDatesResponses, CompaniesImportCompanyEmployeeOccasionDatesErrors, ThrowOnError> => (options.client ?? client).post<CompaniesImportCompanyEmployeeOccasionDatesResponses, CompaniesImportCompanyEmployeeOccasionDatesErrors, ThrowOnError>({
    url: '/admin/company/employees/occasion-dates/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Company Employee Occasion Dates
 *
 * **Company admin only** (`company:send_gift_cards`): set or clear ONE roster
 * employee's employer-entered occasion dates.
 *
 * ★ These columns are the ONLY date source any occasion program reads. The consumer
 * profile birthday is never consulted and is never a fallback (D-EP-27).
 *
 * The birthday is MONTH + DAY only — there is no year to supply, because none is
 * stored: a gift needs no age, and a date of birth encodes age, which is a protected
 * characteristic in employment. Absent-vs-null: an absent key is untouched, an
 * explicit `null` clears. The month/day pair must be set or cleared together. Flag
 * off -> 404; an employee not on this company's roster -> 404; a malformed date ->
 * 422 (uniformly — the calendar check and the Field bounds return the same status).
 *
 * The two 404s are told apart by `error_code`: the roster miss carries
 * `EMPLOYEE_NOT_ON_ROSTER`, the flag-off route 404 carries none. That asymmetry is
 * the contract — a client reads the code rather than the English message.
 */
export const companiesSetCompanyEmployeeOccasionDates = <ThrowOnError extends boolean = false>(options: Options<CompaniesSetCompanyEmployeeOccasionDatesData, ThrowOnError>): RequestResult<CompaniesSetCompanyEmployeeOccasionDatesResponses, CompaniesSetCompanyEmployeeOccasionDatesErrors, ThrowOnError> => (options.client ?? client).put<CompaniesSetCompanyEmployeeOccasionDatesResponses, CompaniesSetCompanyEmployeeOccasionDatesErrors, ThrowOnError>({
    url: '/admin/company/employees/{employee_user_id}/occasion-dates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Company Fundraisers
 *
 * **Company admin only** (`company:manage_fundraisers`, Member-level): the
 * fundraisers OWNED by the acting admin's company (all statuses — a management
 * view). Flag off → 404; a non-admin / a caller without the permission → 403.
 */
export const companiesListCompanyFundraisers = <ThrowOnError extends boolean = false>(options?: Options<CompaniesListCompanyFundraisersData, ThrowOnError>): RequestResult<CompaniesListCompanyFundraisersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesListCompanyFundraisersResponses, unknown, ThrowOnError>({ url: '/admin/company/fundraisers', ...options });

/**
 * Create Company Fundraiser
 *
 * **Company admin only** (`company:manage_fundraisers`, Member-level): create a
 * fundraiser OWNED by the acting admin's company (D-EP-9 = Path B). REUSES the
 * existing fundraiser creation lifecycle unmodified — same `FundraiserCreate` body,
 * same DRAFT + item-split + cardinality cap — only stamping `owner_company_id`
 * (router-injected from `user.admin_company`, never the body). The acting admin
 * remains the fundraiser's `creator_user_id` / OWNER member of record. The response
 * is the private owner shape `POST /fundraisers` answers (CAM-BE12), carrying the
 * `owner_company` byline, and the org contact offer while
 * `FUNDRAISER_ORG_CONTACT_ENABLED` is on. Flag off → 404; a non-admin / a caller
 * without the permission → 403. NOT a money route (fundraiser CRUD touches no
 * wallet).
 */
export const companiesCreateCompanyFundraiser = <ThrowOnError extends boolean = false>(options: Options<CompaniesCreateCompanyFundraiserData, ThrowOnError>): RequestResult<CompaniesCreateCompanyFundraiserResponses, CompaniesCreateCompanyFundraiserErrors, ThrowOnError> => (options.client ?? client).post<CompaniesCreateCompanyFundraiserResponses, CompaniesCreateCompanyFundraiserErrors, ThrowOnError>({
    url: '/admin/company/fundraisers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Company Gift Cards
 *
 * **Company admin only** (`company:send_gift_cards`, Member-level): the gift
 * cards this company has sent (COMPANY_CARD + COMPANY_WALLET), newest-first by
 * default, with per-card status. Flag off → 404; a non-admin / a caller without
 * the permission → 403. The response maps each card to `CompanyGiftCardOut` and
 * NEVER carries a plaintext code / `code_hash` / the recipient's account id (mirrors
 * the consumer sent-list privacy scoping, GC2-BE3).
 */
export const companiesListCompanyGiftCards = <ThrowOnError extends boolean = false>(options?: Options<CompaniesListCompanyGiftCardsData, ThrowOnError>): RequestResult<CompaniesListCompanyGiftCardsResponses, CompaniesListCompanyGiftCardsErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesListCompanyGiftCardsResponses, CompaniesListCompanyGiftCardsErrors, ThrowOnError>({ url: '/admin/company/gift-cards', ...options });

/**
 * Send Company Gift Card
 *
 * **Company admin only** (`company:send_gift_cards`, Member-level, D-EP-5):
 * send a company-funded gift card to a roster employee (EP-BE2 v1 — a SINGLE
 * recipient). `funding_source` selects COMPANY_CARD (charges the company's Shift4
 * customer; a company-named Variant-A receipt lands with the acting admin) or
 * COMPANY_WALLET (debits the company wallet; receipt-less). Floors ($15–$1,000) +
 * the employer per-company velocity cap (D-EP-6) bind; the recipient employee
 * never gets a receipt. Flag off → 404; a non-admin / a caller without the
 * permission → 403; a floor violation → 422 (a body-schema bound); an off-roster
 * recipient → 400. The response is privacy-scoped (`CompanyGiftCardOut`) and
 * NEVER carries the plaintext code.
 */
export const companiesSendCompanyGiftCard = <ThrowOnError extends boolean = false>(options: Options<CompaniesSendCompanyGiftCardData, ThrowOnError>): RequestResult<CompaniesSendCompanyGiftCardResponses, CompaniesSendCompanyGiftCardErrors, ThrowOnError> => (options.client ?? client).post<CompaniesSendCompanyGiftCardResponses, CompaniesSendCompanyGiftCardErrors, ThrowOnError>({
    url: '/admin/company/gift-cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Company Gift Card Batches
 *
 * **Company admin only** (`company:send_gift_cards`): the bulk-gift batches this
 * company has created, newest-first by default. Flag off → 404; a non-admin → 403.
 * Each batch maps to `CompanyGiftCardBatchOut` (summary only — no charge/idempotency
 * internals) and carries its DERIVED per-status `delivery_counts` (EP-WEB-B8), so a
 * list-only client can spot failed deliveries without a detail call per batch.
 */
export const companiesListCompanyGiftCardBatches = <ThrowOnError extends boolean = false>(options?: Options<CompaniesListCompanyGiftCardBatchesData, ThrowOnError>): RequestResult<CompaniesListCompanyGiftCardBatchesResponses, CompaniesListCompanyGiftCardBatchesErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesListCompanyGiftCardBatchesResponses, CompaniesListCompanyGiftCardBatchesErrors, ThrowOnError>({ url: '/admin/company/gift-cards/batches', ...options });

/**
 * Send Company Gift Card Batch
 *
 * **Company admin only** (`company:send_gift_cards`, Member-level): bulk-send N
 * company-funded gift cards of a uniform `denomination` to roster employees (EP-BE3).
 * ALL-OR-NOTHING — every recipient is validated against the company roster BEFORE any
 * money moves, then ONE COMPANY_CARD charge (or ONE COMPANY_WALLET withdraw) for the
 * batch total mints all N cards; delivery is async per card. Flag off → 404; a
 * non-admin / a caller without the permission → 403; an off-roster recipient set →
 * 422 with a per-entry `invalid_recipients` list; the per-batch count cap or the
 * employer velocity cap → 429/400. The response is the batch summary
 * (`CompanyGiftCardBatchOut`) and NEVER carries a plaintext code.
 */
export const companiesSendCompanyGiftCardBatch = <ThrowOnError extends boolean = false>(options: Options<CompaniesSendCompanyGiftCardBatchData, ThrowOnError>): RequestResult<CompaniesSendCompanyGiftCardBatchResponses, CompaniesSendCompanyGiftCardBatchErrors, ThrowOnError> => (options.client ?? client).post<CompaniesSendCompanyGiftCardBatchResponses, CompaniesSendCompanyGiftCardBatchErrors, ThrowOnError>({
    url: '/admin/company/gift-cards/batches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Gift Card Batch
 *
 * **Company admin only** (`company:send_gift_cards`): a batch's detail — the
 * summary + the DERIVED per-status delivery counts + every card (reusing
 * `CompanyGiftCardOut`, which carries `delivery_status`). Flag off → 404; a
 * non-admin → 403; a missing / not-this-company's batch → 404 (cross-company
 * isolation). NEVER carries a plaintext code / `code_hash` / the recipient's account
 * id.
 */
export const companiesGetCompanyGiftCardBatch = <ThrowOnError extends boolean = false>(options: Options<CompaniesGetCompanyGiftCardBatchData, ThrowOnError>): RequestResult<CompaniesGetCompanyGiftCardBatchResponses, CompaniesGetCompanyGiftCardBatchErrors, ThrowOnError> => (options.client ?? client).get<CompaniesGetCompanyGiftCardBatchResponses, CompaniesGetCompanyGiftCardBatchErrors, ThrowOnError>({ url: '/admin/company/gift-cards/batches/{batch_id}', ...options });

/**
 * Get Company Giving Publication
 *
 * CW-BE6: what this company currently publishes about its giving.
 *
 * Returns the unpublished zero-state (default modules, `published=false`,
 * `widget_id=null`) when the company has never saved — the screen is always
 * reachable and a read never writes a row.
 */
export const companiesGetCompanyGivingPublication = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyGivingPublicationData, ThrowOnError>): RequestResult<CompaniesGetCompanyGivingPublicationResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyGivingPublicationResponses, unknown, ThrowOnError>({ url: '/admin/company/giving-publication', ...options });

/**
 * Save Company Giving Publication
 *
 * CW-BE6: publish / unpublish and choose which blocks are disclosed.
 *
 * A whole-state PUT, not a PATCH: this is a consent screen, so an Owner
 * submitting it restates exactly what may be shown. The company is
 * router-injected from `user.admin_company` — never spread from the body.
 */
export const companiesSaveCompanyGivingPublication = <ThrowOnError extends boolean = false>(options: Options<CompaniesSaveCompanyGivingPublicationData, ThrowOnError>): RequestResult<CompaniesSaveCompanyGivingPublicationResponses, CompaniesSaveCompanyGivingPublicationErrors, ThrowOnError> => (options.client ?? client).put<CompaniesSaveCompanyGivingPublicationResponses, CompaniesSaveCompanyGivingPublicationErrors, ThrowOnError>({
    url: '/admin/company/giving-publication',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Company Impact Csv
 *
 * EP-WEB-B5: every charity the company contributed to this ET year to date,
 * ranked by total — UNCAPPED.
 *
 * The dashboard card's read is hard-bounded to `limit <= 50`, so a client-assembled
 * file would silently be a top-50 while a company can support more. This one takes
 * no limit, so it can honestly be titled "charities supported". Matched-union
 * basis, so the CSV and the dashboard card agree.
 */
export const companiesExportCompanyImpactCsv = <ThrowOnError extends boolean = false>(options?: Options<CompaniesExportCompanyImpactCsvData, ThrowOnError>): RequestResult<CompaniesExportCompanyImpactCsvResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesExportCompanyImpactCsvResponses, unknown, ThrowOnError>({ url: '/admin/company/impact.csv', ...options });

/**
 * List Company Employee Invites
 *
 * EP-WEB-B7: the company's invites, newest-first with INVITED first, optionally
 * filtered to one status.
 *
 * The response is the standard paginated envelope plus a `counts` key carrying
 * per-status totals computed over ALL invites — deliberately independent of this
 * page and this filter, because a count derived from the returned rows would
 * understate the totals exactly when a summary row matters.
 */
export const companiesListCompanyEmployeeInvites = <ThrowOnError extends boolean = false>(options?: Options<CompaniesListCompanyEmployeeInvitesData, ThrowOnError>): RequestResult<CompaniesListCompanyEmployeeInvitesResponses, CompaniesListCompanyEmployeeInvitesErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesListCompanyEmployeeInvitesResponses, CompaniesListCompanyEmployeeInvitesErrors, ThrowOnError>({ url: '/admin/company/invites', ...options });

/**
 * Create Company Employee Invites
 *
 * EP-WEB-B7: bulk-invite email addresses to enrol as employees.
 *
 * Dedupes against BOTH the roster and existing live invites, and partitions the
 * result into `created` / `already_invited` / `already_enrolled` so the portal can
 * tell the admin exactly what happened. Re-pasting an overlapping spreadsheet is a
 * normal 201, not an error — and an address that already holds a live invite is
 * NOT re-emailed here (resend is its own cooldown-guarded route), so a re-paste
 * cannot mail-bomb anyone.
 *
 * An invite records that the company ASKED someone. It grants no membership and
 * shortcuts no work-email verification — the invitee still enrols through the
 * normal OTP flow.
 */
export const companiesCreateCompanyEmployeeInvites = <ThrowOnError extends boolean = false>(options: Options<CompaniesCreateCompanyEmployeeInvitesData, ThrowOnError>): RequestResult<CompaniesCreateCompanyEmployeeInvitesResponses, CompaniesCreateCompanyEmployeeInvitesErrors, ThrowOnError> => (options.client ?? client).post<CompaniesCreateCompanyEmployeeInvitesResponses, CompaniesCreateCompanyEmployeeInvitesErrors, ThrowOnError>({
    url: '/admin/company/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Employee Invite Counts
 *
 * EP-WEB-B7: the per-status invite counts on their own.
 *
 * The list route above carries the same counts as a top-level sibling of the
 * pagination envelope, but a sibling key is not reliably reachable: the web
 * api-client middleware unwraps the envelope and drops everything beside it, so a
 * portal that wants only the summary would otherwise have to page the ENTIRE
 * invite list to add the rows up. This returns a PLAIN object — no pagination
 * envelope and no `data` wrapper — precisely so there is nothing for that
 * unwrapping to strip.
 *
 * Counts come from the SAME service helper the list uses, so the two routes can
 * never disagree, and like the list's they span ALL invites rather than a page.
 */
export const companiesGetCompanyEmployeeInviteCounts = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyEmployeeInviteCountsData, ThrowOnError>): RequestResult<CompaniesGetCompanyEmployeeInviteCountsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyEmployeeInviteCountsResponses, unknown, ThrowOnError>({ url: '/admin/company/invites/counts', ...options });

/**
 * Resend Company Employee Invite
 *
 * EP-WEB-B7: re-send one invite's email.
 *
 * Only a pending (`INVITED`) invite can be resent, and a per-invite cooldown
 * measured from that invite's own `sent_at` stops a repeated click from
 * mail-bombing the invitee (400 inside the window). A missing invite and another
 * company's invite both return the same 404, so ids are not enumerable across
 * companies.
 */
export const companiesResendCompanyEmployeeInvite = <ThrowOnError extends boolean = false>(options: Options<CompaniesResendCompanyEmployeeInviteData, ThrowOnError>): RequestResult<CompaniesResendCompanyEmployeeInviteResponses, CompaniesResendCompanyEmployeeInviteErrors, ThrowOnError> => (options.client ?? client).post<CompaniesResendCompanyEmployeeInviteResponses, CompaniesResendCompanyEmployeeInviteErrors, ThrowOnError>({ url: '/admin/company/invites/{invite_id}/resend', ...options });

/**
 * List Company Join Requests
 *
 * The Owner inbox — the company's join requests (PENDING first, paginated),
 * each enriched with the requester's identity. Owner-only (the service's
 * `company_admin:add` gate 403s a Member).
 */
export const companiesListCompanyJoinRequests = <ThrowOnError extends boolean = false>(options?: Options<CompaniesListCompanyJoinRequestsData, ThrowOnError>): RequestResult<CompaniesListCompanyJoinRequestsResponses, CompaniesListCompanyJoinRequestsErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesListCompanyJoinRequestsResponses, CompaniesListCompanyJoinRequestsErrors, ThrowOnError>({ url: '/admin/company/join-requests', ...options });

/**
 * Create Company Join Request
 *
 * File a PENDING request to join the company that owns the caller's verified
 * work-email domain (an Owner adjudicates — never auto-approved). Idempotent — an
 * existing PENDING request for this caller + company is returned unchanged. The
 * caller's Givmo user is provisioned inline when absent (the join half of the
 * create-or-join funnel).
 */
export const companiesCreateCompanyJoinRequest = <ThrowOnError extends boolean = false>(options: Options<CompaniesCreateCompanyJoinRequestData, ThrowOnError>): RequestResult<CompaniesCreateCompanyJoinRequestResponses, CompaniesCreateCompanyJoinRequestErrors, ThrowOnError> => (options.client ?? client).post<CompaniesCreateCompanyJoinRequestResponses, CompaniesCreateCompanyJoinRequestErrors, ThrowOnError>({
    url: '/admin/company/join-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve Company Join Request With Choice
 *
 * OM-57 (D-CPO-64) — approve one join request with the Global Admin's choice, nothing
 * pre-checked: `{"role": "Owner"}` makes the requester a Global Admin (no `modules`);
 * `{"role": "Member", "modules": [{"module", "role"}]}` a regular admin holding exactly
 * those apps, at least one. Nothing else grants: not the requester's `requested_app` note,
 * not the legacy `requested_product`. Refused with `JOIN_APPROVAL_*` 422s before any write.
 *
 * A NEW route, never a field on `/approve`: an old backend would drop `modules`
 * (`extra='ignore'`) and approve with its legacy grant, so a new screen meeting an old
 * backend gets this route's 404 and grants nothing. Same gates as `/approve`: the
 * join-or-create flag, a company admin, and (in the service) `company_admin:add`, the Global
 * Admin tier.
 */
export const companiesApproveCompanyJoinRequestWithChoice = <ThrowOnError extends boolean = false>(options: Options<CompaniesApproveCompanyJoinRequestWithChoiceData, ThrowOnError>): RequestResult<CompaniesApproveCompanyJoinRequestWithChoiceResponses, CompaniesApproveCompanyJoinRequestWithChoiceErrors, ThrowOnError> => (options.client ?? client).post<CompaniesApproveCompanyJoinRequestWithChoiceResponses, CompaniesApproveCompanyJoinRequestWithChoiceErrors, ThrowOnError>({
    url: '/admin/company/join-requests/{request_id}/approval',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve Company Join Request
 *
 * Approve one join request — the OWNER assigns the base role (Owner|Member).
 * Installs the requester as a company admin (+ the EP-SUITE1 dual-write mirror +
 * the requested product grant) atomically and idempotently.
 */
export const companiesApproveCompanyJoinRequest = <ThrowOnError extends boolean = false>(options: Options<CompaniesApproveCompanyJoinRequestData, ThrowOnError>): RequestResult<CompaniesApproveCompanyJoinRequestResponses, CompaniesApproveCompanyJoinRequestErrors, ThrowOnError> => (options.client ?? client).post<CompaniesApproveCompanyJoinRequestResponses, CompaniesApproveCompanyJoinRequestErrors, ThrowOnError>({
    url: '/admin/company/join-requests/{request_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject Company Join Request
 *
 * Reject one join request (optional Owner note). Owner-only.
 */
export const companiesRejectCompanyJoinRequest = <ThrowOnError extends boolean = false>(options: Options<CompaniesRejectCompanyJoinRequestData, ThrowOnError>): RequestResult<CompaniesRejectCompanyJoinRequestResponses, CompaniesRejectCompanyJoinRequestErrors, ThrowOnError> => (options.client ?? client).post<CompaniesRejectCompanyJoinRequestResponses, CompaniesRejectCompanyJoinRequestErrors, ThrowOnError>({
    url: '/admin/company/join-requests/{request_id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Location
 */
export const companiesGetUserLocation = <ThrowOnError extends boolean = false>(options: Options<CompaniesGetUserLocationData, ThrowOnError>): RequestResult<CompaniesGetUserLocationResponses, CompaniesGetUserLocationErrors, ThrowOnError> => (options.client ?? client).get<CompaniesGetUserLocationResponses, CompaniesGetUserLocationErrors, ThrowOnError>({ url: '/admin/company/location', ...options });

/**
 * Get Company Match Utilization
 *
 * EP-WEB-B2: how much of the company's match budget is claimed this year.
 *
 * Read-only aggregation — no money moves. The numerator is the BUDGET-ENFORCEMENT
 * basis (approved matches only, the same tz-naive year the approval gate reads), NOT
 * the dashboard's ET-windowed `matched_ytd`, so this figure can never disagree with
 * the check that actually blocks an approval. `basis` names which denominator was
 * used (`aggregate_cap` | `per_employee_product` | `none`); `ratio` is null whenever
 * there is no denominator to divide by — a client must render an empty state, never
 * 0%. Its own endpoint (not a dashboard field) so the heavier approved-match scan
 * doesn't block the dashboard's first paint, matching the donation-volume and
 * top-charities reads.
 */
export const companiesGetCompanyMatchUtilization = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyMatchUtilizationData, ThrowOnError>): RequestResult<CompaniesGetCompanyMatchUtilizationResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyMatchUtilizationResponses, unknown, ThrowOnError>({ url: '/admin/company/match-utilization', ...options });

/**
 * Update Company Match Policy
 */
export const companiesUpdateCompanyMatchPolicy = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyMatchPolicyData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyMatchPolicyResponses, CompaniesUpdateCompanyMatchPolicyErrors, ThrowOnError> => (options.client ?? client).put<CompaniesUpdateCompanyMatchPolicyResponses, CompaniesUpdateCompanyMatchPolicyErrors, ThrowOnError>({
    url: '/admin/company/match_policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve Group Company Matches
 */
export const donationMatchesApproveGroupCompanyMatches = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesApproveGroupCompanyMatchesData, ThrowOnError>): RequestResult<DonationMatchesApproveGroupCompanyMatchesResponses, DonationMatchesApproveGroupCompanyMatchesErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesApproveGroupCompanyMatchesResponses, DonationMatchesApproveGroupCompanyMatchesErrors, ThrowOnError>({
    url: '/admin/company/matches/group/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Pending Group Company Matches
 */
export const donationMatchesGetPendingGroupCompanyMatches = <ThrowOnError extends boolean = false>(options?: Options<DonationMatchesGetPendingGroupCompanyMatchesData, ThrowOnError>): RequestResult<DonationMatchesGetPendingGroupCompanyMatchesResponses, DonationMatchesGetPendingGroupCompanyMatchesErrors, ThrowOnError> => (options?.client ?? client).get<DonationMatchesGetPendingGroupCompanyMatchesResponses, DonationMatchesGetPendingGroupCompanyMatchesErrors, ThrowOnError>({ url: '/admin/company/matches/group/pending', ...options });

/**
 * Reject Group Company Matches
 */
export const donationMatchesRejectGroupCompanyMatches = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesRejectGroupCompanyMatchesData, ThrowOnError>): RequestResult<DonationMatchesRejectGroupCompanyMatchesResponses, DonationMatchesRejectGroupCompanyMatchesErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesRejectGroupCompanyMatchesResponses, DonationMatchesRejectGroupCompanyMatchesErrors, ThrowOnError>({
    url: '/admin/company/matches/group/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Grouped Matches Allowed Amount
 */
export const donationMatchesCheckGroupedMatchesAllowedAmount = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesCheckGroupedMatchesAllowedAmountData, ThrowOnError>): RequestResult<DonationMatchesCheckGroupedMatchesAllowedAmountResponses, DonationMatchesCheckGroupedMatchesAllowedAmountErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesCheckGroupedMatchesAllowedAmountResponses, DonationMatchesCheckGroupedMatchesAllowedAmountErrors, ThrowOnError>({
    url: '/admin/company/matches/grouped/allowed_amount',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve Grouped Company Matches
 */
export const donationMatchesApproveGroupedCompanyMatches = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesApproveGroupedCompanyMatchesData, ThrowOnError>): RequestResult<DonationMatchesApproveGroupedCompanyMatchesResponses, DonationMatchesApproveGroupedCompanyMatchesErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesApproveGroupedCompanyMatchesResponses, DonationMatchesApproveGroupedCompanyMatchesErrors, ThrowOnError>({
    url: '/admin/company/matches/grouped/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject Grouped Company Matches
 */
export const donationMatchesRejectGroupedCompanyMatches = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesRejectGroupedCompanyMatchesData, ThrowOnError>): RequestResult<DonationMatchesRejectGroupedCompanyMatchesResponses, DonationMatchesRejectGroupedCompanyMatchesErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesRejectGroupedCompanyMatchesResponses, DonationMatchesRejectGroupedCompanyMatchesErrors, ThrowOnError>({
    url: '/admin/company/matches/grouped/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Match Request Inbox
 *
 * Every pending match request of the admin's company, one row per request,
 * newest first, each naming its ``kind`` (``ordinary`` or ``group``).
 */
export const donationMatchesGetMatchRequestInbox = <ThrowOnError extends boolean = false>(options?: Options<DonationMatchesGetMatchRequestInboxData, ThrowOnError>): RequestResult<DonationMatchesGetMatchRequestInboxResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DonationMatchesGetMatchRequestInboxResponses, unknown, ThrowOnError>({ url: '/admin/company/matches/inbox', ...options });

/**
 * Check Match Request Allowed Amount
 */
export const donationMatchesCheckMatchRequestAllowedAmount = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesCheckMatchRequestAllowedAmountData, ThrowOnError>): RequestResult<DonationMatchesCheckMatchRequestAllowedAmountResponses, DonationMatchesCheckMatchRequestAllowedAmountErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesCheckMatchRequestAllowedAmountResponses, DonationMatchesCheckMatchRequestAllowedAmountErrors, ThrowOnError>({
    url: '/admin/company/matches/inbox/{request_id}/allowed_amount',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve Match Request
 *
 * Approve one inbox row; returns the company donations booked, one per match.
 */
export const donationMatchesApproveMatchRequest = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesApproveMatchRequestData, ThrowOnError>): RequestResult<DonationMatchesApproveMatchRequestResponses, DonationMatchesApproveMatchRequestErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesApproveMatchRequestResponses, DonationMatchesApproveMatchRequestErrors, ThrowOnError>({
    url: '/admin/company/matches/inbox/{request_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject Match Request
 */
export const donationMatchesRejectMatchRequest = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesRejectMatchRequestData, ThrowOnError>): RequestResult<DonationMatchesRejectMatchRequestResponses, DonationMatchesRejectMatchRequestErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesRejectMatchRequestResponses, DonationMatchesRejectMatchRequestErrors, ThrowOnError>({
    url: '/admin/company/matches/inbox/{request_id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Pending Matches Grouped
 *
 * Return the admin's pending match inbox grouped by ``post_id``.
 *
 * Non-grouped donations route to the per-donation endpoints; grouped
 * donations collapse to a single group whose ``match_ids`` covers every
 * sub-donation (route to the grouped batch endpoints below).
 */
export const donationMatchesGetPendingMatchesGrouped = <ThrowOnError extends boolean = false>(options?: Options<DonationMatchesGetPendingMatchesGroupedData, ThrowOnError>): RequestResult<DonationMatchesGetPendingMatchesGroupedResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DonationMatchesGetPendingMatchesGroupedResponses, unknown, ThrowOnError>({ url: '/admin/company/matches/pending', ...options });

/**
 * Quote Company Match Payment
 *
 * CAM-BE13 (D-CAM-40): what paying these approval units would charge, covered
 * and not, priced by the resolution the approvals themselves use (the stored
 * card's brand, the company's own cover-fees setting, its platform rate): the
 * totals, then each unit as its own approval charges it. A single or grouped
 * approval sends its one unit at the budget-capped amount, and Approve all every
 * unit at what approving them all in request order matches for it (EP-BE19's
 * `approvable`); its totals stay an upper bound, because a budget that moves while
 * the batch runs caps a leg again. A read that moves no money, so it claims no
 * idempotency key; POST only to carry the list.
 */
export const donationMatchesQuoteCompanyMatchPayment = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesQuoteCompanyMatchPaymentData, ThrowOnError>): RequestResult<DonationMatchesQuoteCompanyMatchPaymentResponses, DonationMatchesQuoteCompanyMatchPaymentErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesQuoteCompanyMatchPaymentResponses, DonationMatchesQuoteCompanyMatchPaymentErrors, ThrowOnError>({
    url: '/admin/company/matches/quote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Company Match Allowed Amount
 */
export const donationMatchesCheckCompanyMatchAllowedAmount = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesCheckCompanyMatchAllowedAmountData, ThrowOnError>): RequestResult<DonationMatchesCheckCompanyMatchAllowedAmountResponses, DonationMatchesCheckCompanyMatchAllowedAmountErrors, ThrowOnError> => (options.client ?? client).get<DonationMatchesCheckCompanyMatchAllowedAmountResponses, DonationMatchesCheckCompanyMatchAllowedAmountErrors, ThrowOnError>({ url: '/admin/company/matches/{match_id}/allowed_amount', ...options });

/**
 * Approve Company Match
 */
export const donationMatchesApproveCompanyMatch = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesApproveCompanyMatchData, ThrowOnError>): RequestResult<DonationMatchesApproveCompanyMatchResponses, DonationMatchesApproveCompanyMatchErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesApproveCompanyMatchResponses, DonationMatchesApproveCompanyMatchErrors, ThrowOnError>({
    url: '/admin/company/matches/{match_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Match Payment Disclosure
 *
 * CAM-X3 — the donor disclosure an approver must be shown before paying this
 * match on ``funding`` (``card`` / ``wallet``): the company-payer body for the
 * match's target (charity → ``DONATE_CONFIRMATION``; ETF or collection →
 * ``CAUSE_ETF``; fundraiser → ``DONATE_CONFIRMATION`` by fundraiser id), derived
 * from the server's own records. Echo its ``id`` / ``content_hash`` on the approve
 * as ``shown_disclaimer_version_id`` / ``shown_disclaimer_content_hash``.
 *
 * Keyed by any of the request's match ids (a grouped request's legs share one
 * target; an inbox row's ``request_id`` is one of them). 404 when the match is not
 * this company's or nothing resolves. Same ``ETag`` / ``If-None-Match`` → 304 and
 * ``DisclaimerResolveOut`` shape as ``GET /disclaimers/resolve``.
 */
export const donationMatchesGetMatchPaymentDisclosure = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesGetMatchPaymentDisclosureData, ThrowOnError>): RequestResult<DonationMatchesGetMatchPaymentDisclosureResponses, DonationMatchesGetMatchPaymentDisclosureErrors, ThrowOnError> => (options.client ?? client).get<DonationMatchesGetMatchPaymentDisclosureResponses, DonationMatchesGetMatchPaymentDisclosureErrors, ThrowOnError>({ url: '/admin/company/matches/{match_id}/disclosure', ...options });

/**
 * Reject Company Match
 */
export const donationMatchesRejectCompanyMatch = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesRejectCompanyMatchData, ThrowOnError>): RequestResult<DonationMatchesRejectCompanyMatchResponses, DonationMatchesRejectCompanyMatchErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesRejectCompanyMatchResponses, DonationMatchesRejectCompanyMatchErrors, ThrowOnError>({ url: '/admin/company/matches/{match_id}/reject', ...options });

/**
 * Get Company Admin
 *
 * The caller's own company-admin record.
 *
 * EP-SUITE3 additions (`permissions`, `is_global_admin`, `product_access`) are
 * stamped onto the entity here rather than computed in `UserService`, because
 * they are a PROJECTION of the authorization seam rather than user state — the
 * same reason `admin_company_role` is stamped by `get_company_role`. They let a
 * client gate controls on what the caller may DO instead of inferring it from
 * the role string, which stopped being a sound inference once two Members of one
 * company could hold different permissions.
 *
 * Each `product_access` entry carries BOTH halves of the resolver's orthogonal
 * pair (see `ProductAccess`): `has_access` — does this admin hold the module —
 * and `enabled_for_company` — has the organization switched it on. Serializing
 * only the first collapses "you hold this, but the org turned it off" into an
 * ordinary link, so the console cannot render the state a Global Admin has to
 * see in order to know to flip it back. The org-level answer is resolved on
 * every path already; the wire name is the company instance's and matches what
 * the members roster serializes (`CompanyMemberProductAccessOut`) — the org
 * console renames the same fact to `enabled_for_org` at ITS projection.
 *
 * Deliberately NOT behind `COMPANY_CONSOLE_ENABLED`: the fields describe the
 * permissions the caller holds RIGHT NOW, which under default data are exactly
 * today's role set. Gating them would hide accurate information for no gain.
 *
 * OM-14 PR-BE1 (T5.4) adds the SAME three additive facts the org self read
 * carries, spelled into this projection so the company class — which reads its
 * standing here — gets them without a second observer: `capabilities` (the
 * class-independent capability names the caller satisfies), a top-level
 * `pending_access_requests` (OMITTED at zero authority), and per-module
 * `access_request` / `pending_access_requests` inside `product_access` (omitted
 * when they do not apply). They are computed by the org console service from the
 * resolution above — one computation, two standing reads. The route serializes
 * the model ITSELF so the omission idiom survives (`response_model_exclude_none`
 * would also drop this route's long-standing nulls, which is not additive).
 */
export const companiesGetCompanyAdmin = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyAdminData, ThrowOnError>): RequestResult<CompaniesGetCompanyAdminResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyAdminResponses, unknown, ThrowOnError>({ url: '/admin/company/me', ...options });

/**
 * List Company Module Choices
 *
 * OM-57 (D-CPO-64) — the apps a Global Admin may give in this company, for the role
 * change's and the join approval's pickers: every app the company's profile carries (the
 * class catalog, released, offered to this company), each `{module, on, roles}`. `on` is
 * the company's own switch; the server refuses only an unavailable app, never an off one.
 * The SAME availability rule as both doors' `*_MODULE_UNAVAILABLE` refusals, so the picker
 * never offers what the server refuses. No label: the web's `productLabel` names each app.
 * Global Admin only (`company_admin:edit`).
 */
export const companiesListCompanyModuleChoices = <ThrowOnError extends boolean = false>(options?: Options<CompaniesListCompanyModuleChoicesData, ThrowOnError>): RequestResult<CompaniesListCompanyModuleChoicesResponses, CompaniesListCompanyModuleChoicesErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesListCompanyModuleChoicesResponses, CompaniesListCompanyModuleChoicesErrors, ThrowOnError>({ url: '/admin/company/module-choices', ...options });

/**
 * List Company Occasion Programs
 *
 * **Company admin only** (`company:send_gift_cards`): the company's occasion
 * programs (all statuses — a management view), ACTIVE first.
 *
 * A program is a RULE, so the response carries no employee data and in particular
 * no employee's date: the portal renders "on each employee's birthday", never a
 * list of birthdays.
 */
export const companiesListCompanyOccasionPrograms = <ThrowOnError extends boolean = false>(options?: Options<CompaniesListCompanyOccasionProgramsData, ThrowOnError>): RequestResult<CompaniesListCompanyOccasionProgramsResponses, CompaniesListCompanyOccasionProgramsErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesListCompanyOccasionProgramsResponses, CompaniesListCompanyOccasionProgramsErrors, ThrowOnError>({ url: '/admin/company/occasion-programs', ...options });

/**
 * Create Company Occasion Program
 *
 * **Company admin only** (`company:send_gift_cards`, Member-level): author one
 * standing occasion rule (EP-BE8).
 *
 * A COMPANY_CARD program requires a saved `card_id` at authoring — no admin is
 * present when it charges, so "pick a card later" has no later. At most ONE ACTIVE
 * program per occasion type per company (409 otherwise): two live birthday rules
 * would silently double-spend on every birthday. Flag off -> 404; a non-admin /
 * a caller without the permission -> 403; a denomination outside $15-$1,000 -> 422
 * (a body-schema bound).
 */
export const companiesCreateCompanyOccasionProgram = <ThrowOnError extends boolean = false>(options: Options<CompaniesCreateCompanyOccasionProgramData, ThrowOnError>): RequestResult<CompaniesCreateCompanyOccasionProgramResponses, CompaniesCreateCompanyOccasionProgramErrors, ThrowOnError> => (options.client ?? client).post<CompaniesCreateCompanyOccasionProgramResponses, CompaniesCreateCompanyOccasionProgramErrors, ThrowOnError>({
    url: '/admin/company/occasion-programs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Occasion Preflight
 *
 * **Company admin only** (`company:send_gift_cards`): upcoming-occasion funding
 * health, so the portal can warn BEFORE an occasion day fails.
 *
 * Per ACTIVE program: how many occasions fall in the horizon, what they will cost,
 * and whether the funding source can cover it (wallet available balance, or a saved
 * card's presence). Plus the count of executions currently HELD — money the company
 * still owes its employees, which the portal must not hide.
 *
 * A PURE READ: no lock, no reservation, no money. `sufficient` is therefore
 * ADVISORY — the real gate is the executor's own available-balance check under the
 * wallet row lock at spend time, and the shared employer velocity window can be
 * spent by an attended send in between.
 */
export const companiesGetCompanyOccasionPreflight = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyOccasionPreflightData, ThrowOnError>): RequestResult<CompaniesGetCompanyOccasionPreflightResponses, CompaniesGetCompanyOccasionPreflightErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyOccasionPreflightResponses, CompaniesGetCompanyOccasionPreflightErrors, ThrowOnError>({ url: '/admin/company/occasion-programs/preflight', ...options });

/**
 * Update Company Occasion Program
 *
 * **Company admin only** (`company:send_gift_cards`): edit a program's
 * denomination, message, saved card, or receipt designee.
 *
 * PATCH absent-vs-null: an absent key is untouched, an explicit `null` clears the
 * value. The occasion TYPE and the funding SOURCE are deliberately not editable —
 * both change what the program fundamentally is (and funding changes the money rail
 * and the receipt disposition), so switching either means authoring a new program.
 * A card-funded program's card cannot be cleared (pause it instead). An edit never
 * reaches an occurrence already executed: that fence is terminal. Flag off -> 404;
 * a missing / another company's program -> 404.
 */
export const companiesUpdateCompanyOccasionProgram = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyOccasionProgramData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyOccasionProgramResponses, CompaniesUpdateCompanyOccasionProgramErrors, ThrowOnError> => (options.client ?? client).patch<CompaniesUpdateCompanyOccasionProgramResponses, CompaniesUpdateCompanyOccasionProgramErrors, ThrowOnError>({
    url: '/admin/company/occasion-programs/{program_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Company Occasion Executions
 *
 * **Company admin only** (`company:send_gift_cards`): one program's executions —
 * the HELD-state surface.
 *
 * An admin must be able to see that today's gifts did not go out and why, because
 * the money either moved or is still owed; a HELD row carries its typed
 * `held_reason` and is retried by every subsequent sweep.
 *
 * DELIVERY-ONLY (D-EP-17): rows carry `gift_card_id` / `batch_id` so the portal can
 * join to the existing delivery report, and carry NO redemption state — whether an
 * employee has spent their gift is not the employer's business, exactly as the
 * employer sent-list already establishes.
 */
export const companiesListCompanyOccasionExecutions = <ThrowOnError extends boolean = false>(options: Options<CompaniesListCompanyOccasionExecutionsData, ThrowOnError>): RequestResult<CompaniesListCompanyOccasionExecutionsResponses, CompaniesListCompanyOccasionExecutionsErrors, ThrowOnError> => (options.client ?? client).get<CompaniesListCompanyOccasionExecutionsResponses, CompaniesListCompanyOccasionExecutionsErrors, ThrowOnError>({ url: '/admin/company/occasion-programs/{program_id}/executions', ...options });

/**
 * Pause Company Occasion Program
 *
 * **Company admin only** (`company:send_gift_cards`): stop the daily sweep
 * considering this program. Idempotent, so a double-click is safe.
 *
 * Pausing stops FUTURE occasions. It does not cancel money already owed: HELD
 * executions from earlier occasions stay HELD and stay visible, because the
 * employer still owes those gifts.
 */
export const companiesPauseCompanyOccasionProgram = <ThrowOnError extends boolean = false>(options: Options<CompaniesPauseCompanyOccasionProgramData, ThrowOnError>): RequestResult<CompaniesPauseCompanyOccasionProgramResponses, CompaniesPauseCompanyOccasionProgramErrors, ThrowOnError> => (options.client ?? client).post<CompaniesPauseCompanyOccasionProgramResponses, CompaniesPauseCompanyOccasionProgramErrors, ThrowOnError>({ url: '/admin/company/occasion-programs/{program_id}/pause', ...options });

/**
 * Resume Company Occasion Program
 *
 * **Company admin only** (`company:send_gift_cards`): return the program to the
 * daily sweep. 409 when another ACTIVE program already covers that occasion.
 *
 * Resuming does not back-fill occasions that passed while paused — a pause is a
 * real stop, not a deferral.
 */
export const companiesResumeCompanyOccasionProgram = <ThrowOnError extends boolean = false>(options: Options<CompaniesResumeCompanyOccasionProgramData, ThrowOnError>): RequestResult<CompaniesResumeCompanyOccasionProgramResponses, CompaniesResumeCompanyOccasionProgramErrors, ThrowOnError> => (options.client ?? client).post<CompaniesResumeCompanyOccasionProgramResponses, CompaniesResumeCompanyOccasionProgramErrors, ThrowOnError>({ url: '/admin/company/occasion-programs/{program_id}/resume', ...options });

/**
 * Get Company Page
 *
 * The company's OWNER view of its page (``profile:read``).
 */
export const companyAdminProfilePageGetCompanyPage = <ThrowOnError extends boolean = false>(options?: Options<CompanyAdminProfilePageGetCompanyPageData, ThrowOnError>): RequestResult<CompanyAdminProfilePageGetCompanyPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompanyAdminProfilePageGetCompanyPageResponses, unknown, ThrowOnError>({ url: '/admin/company/page', ...options });

/**
 * Replace Company Page
 *
 * The id-preserving full-list replace (``profile:write``; the company must be
 * ACTIVE).
 */
export const companyAdminProfilePageReplaceCompanyPage = <ThrowOnError extends boolean = false>(options: Options<CompanyAdminProfilePageReplaceCompanyPageData, ThrowOnError>): RequestResult<CompanyAdminProfilePageReplaceCompanyPageResponses, CompanyAdminProfilePageReplaceCompanyPageErrors, ThrowOnError> => (options.client ?? client).put<CompanyAdminProfilePageReplaceCompanyPageResponses, CompanyAdminProfilePageReplaceCompanyPageErrors, ThrowOnError>({
    url: '/admin/company/page',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Company Page Image
 *
 * Upload one page image under ``company/{company_id}/page/…``.
 */
export const companyAdminProfilePageUploadCompanyPageImage = <ThrowOnError extends boolean = false>(options: Options<CompanyAdminProfilePageUploadCompanyPageImageData, ThrowOnError>): RequestResult<CompanyAdminProfilePageUploadCompanyPageImageResponses, CompanyAdminProfilePageUploadCompanyPageImageErrors, ThrowOnError> => (options.client ?? client).post<CompanyAdminProfilePageUploadCompanyPageImageResponses, CompanyAdminProfilePageUploadCompanyPageImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/admin/company/page/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Update Company Payment Method
 */
export const companiesUpdateCompanyPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyPaymentMethodData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyPaymentMethodResponses, CompaniesUpdateCompanyPaymentMethodErrors, ThrowOnError> => (options.client ?? client).put<CompaniesUpdateCompanyPaymentMethodResponses, CompaniesUpdateCompanyPaymentMethodErrors, ThrowOnError>({
    url: '/admin/company/payment_method',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable Company Product
 *
 * An Owner enables an additional Givmo product on their OWN company
 * membership (the first non-`employer` grant writer; BMC's business portal
 * consumes this). Idempotent. Owner-only (the service's `company:edit` gate).
 */
export const companiesEnableCompanyProduct = <ThrowOnError extends boolean = false>(options: Options<CompaniesEnableCompanyProductData, ThrowOnError>): RequestResult<CompaniesEnableCompanyProductResponses, CompaniesEnableCompanyProductErrors, ThrowOnError> => (options.client ?? client).post<CompaniesEnableCompanyProductResponses, CompaniesEnableCompanyProductErrors, ThrowOnError>({
    url: '/admin/company/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Company Profile Picture
 */
export const companiesUploadCompanyProfilePicture = <ThrowOnError extends boolean = false>(options: Options<CompaniesUploadCompanyProfilePictureData, ThrowOnError>): RequestResult<CompaniesUploadCompanyProfilePictureResponses, CompaniesUploadCompanyProfilePictureErrors, ThrowOnError> => (options.client ?? client).post<CompaniesUploadCompanyProfilePictureResponses, CompaniesUploadCompanyProfilePictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/admin/company/profile_picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Company Qr Design
 *
 * CQ1-BE1: the company's saved QR design spec, or DEFAULT_GIVMO_PRESET when
 * none is saved. Separate from the user surface; does NOT touch
 * GET /admin/company / CompanyDetailedOut.
 */
export const companiesGetCompanyQrDesign = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyQrDesignData, ThrowOnError>): RequestResult<CompaniesGetCompanyQrDesignResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyQrDesignResponses, unknown, ThrowOnError>({ url: '/admin/company/qr-design', ...options });

/**
 * Save Company Qr Design
 *
 * CQ1-BE1: upsert the company's QR design spec (validated by `QrDesignSpec`)
 * and return the stored spec. owner = (company, user.admin_company),
 * router-injected — never spread from the body.
 */
export const companiesSaveCompanyQrDesign = <ThrowOnError extends boolean = false>(options: Options<CompaniesSaveCompanyQrDesignData, ThrowOnError>): RequestResult<CompaniesSaveCompanyQrDesignResponses, CompaniesSaveCompanyQrDesignErrors, ThrowOnError> => (options.client ?? client).put<CompaniesSaveCompanyQrDesignResponses, CompaniesSaveCompanyQrDesignErrors, ThrowOnError>({
    url: '/admin/company/qr-design',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Fundraiser Report
 */
export const companiesGetCompanyFundraiserReport = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyFundraiserReportData, ThrowOnError>): RequestResult<CompaniesGetCompanyFundraiserReportResponses, CompaniesGetCompanyFundraiserReportErrors, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyFundraiserReportResponses, CompaniesGetCompanyFundraiserReportErrors, ThrowOnError>({ url: '/admin/company/raised-through-fundraisers', ...options });

/**
 * Resolve Company Onboarding Route
 *
 * Resolve the onboarding branch for a signed-in caller (create / request
 * access / already-member / enable-product / blocked). The caller's VERIFIED
 * email is read from the Firebase ID token (`request.state.idp_user`), NEVER the
 * body; an unverified/absent email is a 403 (a verified work email is required
 * to resolve). For a request-access branch the response carries the target
 * company's display name + per-request signed logo ONLY — never its roster.
 */
export const companiesResolveCompanyOnboardingRoute = <ThrowOnError extends boolean = false>(options?: Options<CompaniesResolveCompanyOnboardingRouteData, ThrowOnError>): RequestResult<CompaniesResolveCompanyOnboardingRouteResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CompaniesResolveCompanyOnboardingRouteResponses, unknown, ThrowOnError>({ url: '/admin/company/resolve', ...options });

/**
 * Export Company Security Audit
 *
 * AS-BE20 — "who changed what, when" for this employer's security posture.
 *
 * Four columns, and the header IS the contract (plan §5): `occurred_at`,
 * `event_type`, `actor_role`, `detail`. **PII-safe by construction** — no
 * identifier, no name, no address, no code can reach the grid, because the stored
 * row's every exportable value is a CHECK-constrained closed set and `detail` is
 * validated against one more before the insert
 * (`app/domain/entities/security_audit_entities.py`).
 *
 * Both dates are OPTIONAL and default to the whole retained window. A start
 * reaching past the retention floor is CLAMPED to it rather than served as an
 * empty prefix, and the effective window is reported in the response headers so
 * the clamp is visible — `employer_sso.md` §11's rule that a silent clamp is the
 * same dishonesty as a silent accept, applied to a read. An inverted range is
 * rejected, never swapped (the company transactions export's convention).
 *
 * `X-Givmo-Audit-Retention-Days` is THE retention statement on the wire. It is
 * served on every successful export so the artifact carries its own bound rather
 * than depending on the reader having found the documentation.
 */
export const adminCompanySecurityExportCompanySecurityAudit = <ThrowOnError extends boolean = false>(options?: Options<AdminCompanySecurityExportCompanySecurityAuditData, ThrowOnError>): RequestResult<AdminCompanySecurityExportCompanySecurityAuditResponses, AdminCompanySecurityExportCompanySecurityAuditErrors, ThrowOnError> => (options?.client ?? client).get<AdminCompanySecurityExportCompanySecurityAuditResponses, AdminCompanySecurityExportCompanySecurityAuditErrors, ThrowOnError>({ url: '/admin/company/security/audit-export', ...options });

/**
 * Reset Company Sso Sessions
 *
 * AS-BE19 — end every live session across this employer's roster.
 *
 * The employer's blunt incident control: something happened, sign everybody out.
 * Under an SSO tier the freshness rule then forces each employee back through
 * the company's IdP; at L0 it is a workforce-wide sign-out and nothing more.
 *
 * **It touches sessions and NOTHING else** — no factor is unenrolled, no
 * provider unlinked, no recovery code spent, no lock claim written or cleared,
 * no employment ended. That boundary is plan §3.1 applied to the one employer
 * act that reaches into every employee's session at once. Since AS-BE55
 * (D-AS-32, D-AS-37) "sessions" includes the delegated credentials that outlive
 * them: each employee's AI connections and Connect partner links, and every AI
 * connection bound to the company; the person reconnects afterwards.
 *
 * Takes NO body. The act has no parameters, and giving it one (a subset of
 * employees, an "except me") would turn a blunt control into a targeting tool.
 * POST rather than DELETE because nothing is removed: the sessions expire, the
 * accounts do not.
 */
export const adminCompanySecurityResetCompanySsoSessions = <ThrowOnError extends boolean = false>(options?: Options<AdminCompanySecurityResetCompanySsoSessionsData, ThrowOnError>): RequestResult<AdminCompanySecurityResetCompanySsoSessionsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AdminCompanySecurityResetCompanySsoSessionsResponses, unknown, ThrowOnError>({ url: '/admin/company/security/reset-sso-sessions', ...options });

/**
 * Update Company Activity Feed Visibility
 */
export const companiesUpdateCompanyActivityFeedVisibility = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyActivityFeedVisibilityData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyActivityFeedVisibilityResponses, CompaniesUpdateCompanyActivityFeedVisibilityErrors, ThrowOnError> => (options.client ?? client).put<CompaniesUpdateCompanyActivityFeedVisibilityResponses, CompaniesUpdateCompanyActivityFeedVisibilityErrors, ThrowOnError>({
    url: '/admin/company/settings/activity_feed/visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Auth Policy
 *
 * AS-BE11 — read this company's stored employee authentication policy.
 *
 * THE ADMIN TAB'S REVEAL PROBE. It rides the SAME
 * `_require_employer_auth_policy_enabled` dependency as the PUT, so it 404s
 * while the surface is dark — and that is the point: `200 ⇒ show the Security
 * tab, 404 ⇒ hide it` is the only dark signal the web side has. The policy
 * fields on `GET /admin/company` cannot serve it, because AS-BE10 deliberately
 * serves those REGARDLESS of the flag (a key that appears and disappears under
 * a flip is the brittleness the frozen-client rules exist to avoid), so they
 * read the same zero-state dark or live and tell a client nothing.
 *
 * READ-GATED LIKE ITS SIBLING READS, not like the PUT. Any company admin —
 * Owner or Member — may read it, matching `GET /admin/company`'s inline
 * `user.admin_company` check; only the WRITE is Owner-only via
 * `@has_company_permission("company:edit")` on the service. A Member who can
 * see the tab but gets a 403 on save is the correct, legible split, and it is
 * the one the rest of the company-settings surface already uses.
 *
 * The company is router-injected from `user.admin_company` and never spread
 * from the request, so an admin can only ever read their own.
 *
 * AS-BE49: an Owner also reads `employees_without_second_factor` while the link
 * requirement is live — the heads-up count before saving Required.
 */
export const companiesGetCompanyAuthPolicy = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyAuthPolicyData, ThrowOnError>): RequestResult<CompaniesGetCompanyAuthPolicyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyAuthPolicyResponses, unknown, ThrowOnError>({ url: '/admin/company/settings/auth-policy', ...options });

/**
 * Update Company Auth Policy
 *
 * AS-BE10: set this company's employee authentication policy.
 *
 * Owner-only — `company:edit` is enforced by `@has_company_permission` on the
 * service method, so a Member company admin gets a 403 (the same split every
 * other company-settings write uses). The company is router-injected from
 * `user.admin_company` and never spread from the body, so an Owner can only
 * ever name their own company.
 *
 * A whole-state PUT: both the tier and the grace window are required, and
 * `extra="forbid"` refuses any key this backend cannot honor yet — a tier it
 * cannot enforce must be a 422, never a 200 that silently drops it.
 */
export const companiesUpdateCompanyAuthPolicy = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyAuthPolicyData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyAuthPolicyResponses, CompaniesUpdateCompanyAuthPolicyErrors, ThrowOnError> => (options.client ?? client).put<CompaniesUpdateCompanyAuthPolicyResponses, CompaniesUpdateCompanyAuthPolicyErrors, ThrowOnError>({
    url: '/admin/company/settings/auth-policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Company Public Amounts
 *
 * EP-MNT16 (D-EP-51) — the company profile's dollar amounts: who may see the
 * dollar figures (`public_amounts_audience`), and whether each gift the company makes
 * directly may show its amount (`public_direct_gift_amounts`). Stated whole, both
 * required; `company:edit_visibility`, the Company visibility card's one string.
 * Answers `CompanyDetailedOut`, whose additive fields echo both.
 */
export const companiesUpdateCompanyPublicAmounts = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyPublicAmountsData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyPublicAmountsResponses, CompaniesUpdateCompanyPublicAmountsErrors, ThrowOnError> => (options.client ?? client).put<CompaniesUpdateCompanyPublicAmountsResponses, CompaniesUpdateCompanyPublicAmountsErrors, ThrowOnError>({
    url: '/admin/company/settings/public_amounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Sso Config
 *
 * Read the whole SSO section of the admin Security tab.
 *
 * **Also the section's dark-reveal probe**, exactly as
 * `GET /admin/company/settings/auth-policy` is for the MFA section: it rides the
 * router's flag gate, so `200 ⇒ show the SSO section, 404 ⇒ hide it` is the only
 * signal the web side needs. Nothing in the response is a secret — the
 * verification token is published in public DNS by design, and the broker's API
 * key and URL never leave the adapter.
 */
export const adminCompanySsoGetCompanySsoConfig = <ThrowOnError extends boolean = false>(options?: Options<AdminCompanySsoGetCompanySsoConfigData, ThrowOnError>): RequestResult<AdminCompanySsoGetCompanySsoConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminCompanySsoGetCompanySsoConfigResponses, unknown, ThrowOnError>({ url: '/admin/company/settings/sso', ...options });

/**
 * Get Company Sso Connection
 *
 * AS-WEB25 — read back the two values the employer's IT admin pastes into
 * their own identity provider (the SP entity ID and the ACS URL), from the
 * broker's connection record, whenever a connection exists.
 *
 * The same `SsoConnectionOut` the PUT above answers, so a client can hold the
 * two interchangeably. The values are present exactly when the broker holds a
 * primary connection and ABSENT otherwise — `response_model_exclude_none`, so
 * "no connection" is `{"configured": false}` and never a null a client could
 * render as a value.
 *
 * **Not part of the section's read**, and that is the point: `GET …/sso` is the
 * dark-reveal probe and makes no broker call, so a broker outage cannot hide
 * the tab. This read asks the broker, and its failure is the typed
 * `SSO_BROKER_UNAVAILABLE` the writes use, which the screen shows in place of
 * the values alone.
 *
 * Read-gated like `GET …/sso` — any company admin, Owner or Member: the values
 * are not a secret, and the section that renders them is already theirs to
 * see.
 */
export const adminCompanySsoGetCompanySsoConnection = <ThrowOnError extends boolean = false>(options?: Options<AdminCompanySsoGetCompanySsoConnectionData, ThrowOnError>): RequestResult<AdminCompanySsoGetCompanySsoConnectionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminCompanySsoGetCompanySsoConnectionResponses, unknown, ThrowOnError>({ url: '/admin/company/settings/sso/connection', ...options });

/**
 * Configure Company Sso Connection
 *
 * Create or update the employer's SAML connection through the broker seam.
 *
 * Returns the two values their IT admin must paste into their own identity
 * provider, plus the NameID setup guidance — which is not decoration: a
 * persistent/pairwise NameID is refused by the broker before the assertion ever
 * reaches us, and an admin who has not been told that will debug it in the wrong
 * system (plan §4).
 *
 * ⚠ **Pasted metadata XML is not accepted.** The field is absent from
 * `SsoConnectionIn` and the model forbids extras, so sending it is a 422 naming
 * the key; the seam refuses it independently and the service turns that into a
 * typed `SSO_METADATA_XML_UNSUPPORTED` telling the admin to supply a URL. The
 * broker's API-key-authenticated parse endpoint takes a URL only, and writing
 * our own SAML-metadata parser to fill that gap is refused — it would decide
 * which certificate and entity id we trust.
 *
 * Requires a verified domain: the organization's `domains` list is the broker's
 * own login-time and SCIM-time gate, not a label.
 */
export const adminCompanySsoConfigureCompanySsoConnection = <ThrowOnError extends boolean = false>(options: Options<AdminCompanySsoConfigureCompanySsoConnectionData, ThrowOnError>): RequestResult<AdminCompanySsoConfigureCompanySsoConnectionResponses, AdminCompanySsoConfigureCompanySsoConnectionErrors, ThrowOnError> => (options.client ?? client).put<AdminCompanySsoConfigureCompanySsoConnectionResponses, AdminCompanySsoConfigureCompanySsoConnectionErrors, ThrowOnError>({
    url: '/admin/company/settings/sso/connection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Company Domain Verification
 *
 * Mint the DNS TXT token and return the record the Owner must publish.
 *
 * Takes no body: the domain is the company's OWN stored `company.domain`, and
 * accepting one from a caller would be letting them choose which domain a
 * successful check proves.
 *
 * Re-running mints a NEW token and clears any existing verification — an
 * employer starting verification is re-proving the domain, and a stale stamp
 * must not keep an SSO tier alive against a proof being replaced. The screen
 * avoids needing that by rendering the existing token from the GET above.
 */
export const adminCompanySsoStartCompanyDomainVerification = <ThrowOnError extends boolean = false>(options?: Options<AdminCompanySsoStartCompanyDomainVerificationData, ThrowOnError>): RequestResult<AdminCompanySsoStartCompanyDomainVerificationResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AdminCompanySsoStartCompanyDomainVerificationResponses, unknown, ThrowOnError>({ url: '/admin/company/settings/sso/domain-verification', ...options });

/**
 * Check Company Domain Verification
 *
 * Resolve the TXT record; on an exact match, stamp `domain_verified_at`.
 *
 * A POST rather than a GET because it WRITES on success — and because it makes
 * an outbound network call, which is not something a cache or a prefetch should
 * be free to trigger.
 *
 * Re-runnable by design: DNS propagates on its own schedule and a negative
 * answer can be cached, so the Owner's remedy for "not yet" is to press it
 * again. A failure is a typed 400 whose message distinguishes "we looked and it
 * is not there" from "we could not look" — the two have opposite remedies.
 */
export const adminCompanySsoCheckCompanyDomainVerification = <ThrowOnError extends boolean = false>(options?: Options<AdminCompanySsoCheckCompanyDomainVerificationData, ThrowOnError>): RequestResult<AdminCompanySsoCheckCompanyDomainVerificationResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AdminCompanySsoCheckCompanyDomainVerificationResponses, unknown, ThrowOnError>({ url: '/admin/company/settings/sso/domain-verification/check', ...options });

/**
 * Get Company Sso Lock Readiness
 *
 * AS-BE15 (f) — the counts AS-WEB6's L4 flip ceremony must show before an
 * Owner can confirm: how many employees the lock would catch, how many have no
 * work identity connected, and how many are on builds with no lock UX.
 *
 * Counts only, never a roster — see `SsoLockReadinessOut`. Readable at any
 * tier, because its whole job is to be read BEFORE the flip; at an
 * already-locked company it reads as a live who-is-affected report instead.
 *
 * `company:read` like the section's other GET, not Owner-only like the writes:
 * it is part of a screen a Member can already see, and hiding the warning while
 * showing the control would be the wrong half to gate.
 */
export const adminCompanySsoGetCompanySsoLockReadiness = <ThrowOnError extends boolean = false>(options?: Options<AdminCompanySsoGetCompanySsoLockReadinessData, ThrowOnError>): RequestResult<AdminCompanySsoGetCompanySsoLockReadinessResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminCompanySsoGetCompanySsoLockReadinessResponses, unknown, ThrowOnError>({ url: '/admin/company/settings/sso/lock-readiness', ...options });

/**
 * Update Company Sso Policy
 *
 * Set the employer's SSO tier and assertion-freshness window.
 *
 * A whole-state PUT (both fields required), matching
 * `PUT /admin/company/settings/auth-policy`: the Security screen renders both
 * controls and an Owner submitting it is stating the whole policy.
 *
 * Two guards with deliberately different shapes, both documented on the service:
 * an UNAVAILABLE tier is **REFUSED** — today `signin_lock` wherever
 * `EMPLOYER_SSO_SIGNIN_LOCK_ENABLED` is dark, since telling an Owner their
 * company is locked when it is not is the dishonest claim the mission bar
 * forbids, and this is a fact about the deployment they cannot fix — while a
 * tier above `none` without a verified domain or a connection is **CLAMPED** to
 * `none`, because that one they CAN fix and should not lose a settings form
 * over. The clamp is reported, not silent — the response is
 * the full config, so the screen shows what was actually stored beside
 * `can_enable_sso: false`.
 */
export const adminCompanySsoUpdateCompanySsoPolicy = <ThrowOnError extends boolean = false>(options: Options<AdminCompanySsoUpdateCompanySsoPolicyData, ThrowOnError>): RequestResult<AdminCompanySsoUpdateCompanySsoPolicyResponses, AdminCompanySsoUpdateCompanySsoPolicyErrors, ThrowOnError> => (options.client ?? client).put<AdminCompanySsoUpdateCompanySsoPolicyResponses, AdminCompanySsoUpdateCompanySsoPolicyErrors, ThrowOnError>({
    url: '/admin/company/settings/sso/policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Company Scim Settings
 *
 * AS-BE18b — turn the employer's SCIM directory sync on or off.
 *
 * **THE WRITER of the per-employer switch `org_sso_config.scim_enabled`** (the
 * org-keyed row is the ONLY store since OM-1), which until this item had none:
 * §15's reconciliation shipped armed-but-fed-nothing precisely because the seam
 * exposed no directory provisioning, so every company read OFF.
 *
 * Enabling ensures a broker-side directory exists (reading first — the create
 * is additive and a second one would strand the employer's configuration) and,
 * when that directory has no token yet, mints one and returns it **show-once**.
 * Disabling stops the reconciliation and nothing else: the directory, its base
 * URL and its token all persist, so re-enabling costs the employer no
 * re-configuration.
 *
 * Owner-only via `@has_company_permission("company:edit")` on the service, like
 * every other write here. Gated twice — the router's `EMPLOYER_SSO_ENABLED` and
 * this route's `EMPLOYER_SCIM_ENABLED` — because what it arms is a sweep that
 * DELETES `company_employee` rows.
 */
export const adminCompanySsoUpdateCompanyScimSettings = <ThrowOnError extends boolean = false>(options: Options<AdminCompanySsoUpdateCompanyScimSettingsData, ThrowOnError>): RequestResult<AdminCompanySsoUpdateCompanyScimSettingsResponses, AdminCompanySsoUpdateCompanyScimSettingsErrors, ThrowOnError> => (options.client ?? client).put<AdminCompanySsoUpdateCompanyScimSettingsResponses, AdminCompanySsoUpdateCompanyScimSettingsErrors, ThrowOnError>({
    url: '/admin/company/settings/sso/scim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate Company Scim Token
 *
 * AS-BE18b — mint a replacement bearer token for the employer's directory.
 *
 * Takes no body: the directory is resolved from the caller's own company
 * through the broker, so there is nothing for a caller to name and no way to
 * aim this at another employer's directory.
 *
 * A POST rather than a PUT because it is not idempotent in the way that
 * matters — each call mints a NEW value and **immediately invalidates the
 * previous one**, so a retried request is a second rotation, not a repeat of
 * the first.
 *
 * ⚠ **Available whether or not sync is enabled.** The token authenticates the
 * employer's identity provider to the broker regardless of whether we are
 * reading the directory, so an Owner who suspects it is compromised must be
 * able to replace it without first turning a sync back on. It refuses only when
 * there is no directory at all.
 */
export const adminCompanySsoRotateCompanyScimToken = <ThrowOnError extends boolean = false>(options?: Options<AdminCompanySsoRotateCompanyScimTokenData, ThrowOnError>): RequestResult<AdminCompanySsoRotateCompanyScimTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AdminCompanySsoRotateCompanyScimTokenResponses, unknown, ThrowOnError>({ url: '/admin/company/settings/sso/scim/rotate-token', ...options });

/**
 * Start Company Sso Test Connection
 *
 * Start a REAL SP-initiated login for the Owner's own browser.
 *
 * **Test-connection is ours** (plan §5 AS-BE17): rather than the broker's
 * built-in test mode, which needs an admin session and a container we do not
 * deploy, this starts the same ceremony an employee's sign-in starts and reads
 * what comes back. It exercises the exact path employees will take.
 *
 * It produces NOTHING: no credential, no `sso_subject` binding, no
 * `last_sso_assertion_at` stamp. The flow is tombstoned with a handoff
 * fingerprint no code can produce, and both mint paths refuse this purpose
 * independently.
 *
 * Requires a verified domain and a configured connection, but deliberately NOT a
 * tier — an Owner tests before choosing one.
 */
export const adminCompanySsoStartCompanySsoTestConnection = <ThrowOnError extends boolean = false>(options: Options<AdminCompanySsoStartCompanySsoTestConnectionData, ThrowOnError>): RequestResult<AdminCompanySsoStartCompanySsoTestConnectionResponses, AdminCompanySsoStartCompanySsoTestConnectionErrors, ThrowOnError> => (options.client ?? client).post<AdminCompanySsoStartCompanySsoTestConnectionResponses, AdminCompanySsoStartCompanySsoTestConnectionErrors, ThrowOnError>({
    url: '/admin/company/settings/sso/test-connection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Sso Test Connection
 *
 * Report what the test asserted, in terms an IT admin can act on.
 *
 * The Owner's screen polls this after starting a test. Five outcomes, with the
 * three failures kept separate because each has a different fix — the
 * Entra pairwise-identifier case in particular must render as a specific
 * configuration instruction, never a generic failure (plan §4).
 *
 * A `test_id` belonging to another company answers the same not-found as one
 * that does not exist, so this cannot be used to probe for other employers'
 * ceremonies.
 *
 * Owner-gated rather than read-gated like the other GET here: this returns the
 * NameID an identity provider asserted for a real person at the company, which
 * is a narrower thing than the configuration state a Member may see.
 */
export const adminCompanySsoGetCompanySsoTestConnection = <ThrowOnError extends boolean = false>(options: Options<AdminCompanySsoGetCompanySsoTestConnectionData, ThrowOnError>): RequestResult<AdminCompanySsoGetCompanySsoTestConnectionResponses, AdminCompanySsoGetCompanySsoTestConnectionErrors, ThrowOnError> => (options.client ?? client).get<AdminCompanySsoGetCompanySsoTestConnectionResponses, AdminCompanySsoGetCompanySsoTestConnectionErrors, ThrowOnError>({ url: '/admin/company/settings/sso/test-connection/{test_id}', ...options });

/**
 * Update Company Visibility
 */
export const companiesUpdateCompanyVisibility = <ThrowOnError extends boolean = false>(options: Options<CompaniesUpdateCompanyVisibilityData, ThrowOnError>): RequestResult<CompaniesUpdateCompanyVisibilityResponses, CompaniesUpdateCompanyVisibilityErrors, ThrowOnError> => (options.client ?? client).put<CompaniesUpdateCompanyVisibilityResponses, CompaniesUpdateCompanyVisibilityErrors, ThrowOnError>({
    url: '/admin/company/settings/visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Admin Steps Competitions
 *
 * List the company's competitions (§2.4). DRAFTs included. Read permission
 * (Owner or Member).
 */
export const stepsCompetitionsAdminListAdminStepsCompetitions = <ThrowOnError extends boolean = false>(options?: Options<StepsCompetitionsAdminListAdminStepsCompetitionsData, ThrowOnError>): RequestResult<StepsCompetitionsAdminListAdminStepsCompetitionsResponses, StepsCompetitionsAdminListAdminStepsCompetitionsErrors, ThrowOnError> => (options?.client ?? client).get<StepsCompetitionsAdminListAdminStepsCompetitionsResponses, StepsCompetitionsAdminListAdminStepsCompetitionsErrors, ThrowOnError>({ url: '/admin/company/steps-competitions', ...options });

/**
 * Create Admin Steps Competition
 *
 * Create a DRAFT competition (§2.4). Manage permission (Owner).
 */
export const stepsCompetitionsAdminCreateAdminStepsCompetition = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsAdminCreateAdminStepsCompetitionData, ThrowOnError>): RequestResult<StepsCompetitionsAdminCreateAdminStepsCompetitionResponses, StepsCompetitionsAdminCreateAdminStepsCompetitionErrors, ThrowOnError> => (options.client ?? client).post<StepsCompetitionsAdminCreateAdminStepsCompetitionResponses, StepsCompetitionsAdminCreateAdminStepsCompetitionErrors, ThrowOnError>({
    url: '/admin/company/steps-competitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Steps Sponsor Dpa
 *
 * The CURRENT effective Steps Competition Company Sponsor &
 * Consumer-Health-Data Processing Addendum plus whether this company has
 * accepted it (SC-GO2 / GC packet 2026-07-06 §C). Read permission (Owner or
 * Member). The client reads this BEFORE submitting a create, to decide whether
 * to render the click-through; the same shape also rides the create's 422
 * ``context.sponsor_dpa``, so one decoder serves both.
 */
export const stepsCompetitionsAdminGetStepsSponsorDpa = <ThrowOnError extends boolean = false>(options?: Options<StepsCompetitionsAdminGetStepsSponsorDpaData, ThrowOnError>): RequestResult<StepsCompetitionsAdminGetStepsSponsorDpaResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StepsCompetitionsAdminGetStepsSponsorDpaResponses, unknown, ThrowOnError>({ url: '/admin/company/steps-competitions/sponsor-dpa', ...options });

/**
 * Get Admin Steps Competition
 *
 * Admin detail (§2.4) with the company-wallet money context (held/available)
 * for the publish UI. Read permission.
 */
export const stepsCompetitionsAdminGetAdminStepsCompetition = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsAdminGetAdminStepsCompetitionData, ThrowOnError>): RequestResult<StepsCompetitionsAdminGetAdminStepsCompetitionResponses, StepsCompetitionsAdminGetAdminStepsCompetitionErrors, ThrowOnError> => (options.client ?? client).get<StepsCompetitionsAdminGetAdminStepsCompetitionResponses, StepsCompetitionsAdminGetAdminStepsCompetitionErrors, ThrowOnError>({ url: '/admin/company/steps-competitions/{steps_competition_id}', ...options });

/**
 * Update Admin Steps Competition
 *
 * Edit a DRAFT competition (§2.4). Manage permission. The prize is immutable.
 */
export const stepsCompetitionsAdminUpdateAdminStepsCompetition = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsAdminUpdateAdminStepsCompetitionData, ThrowOnError>): RequestResult<StepsCompetitionsAdminUpdateAdminStepsCompetitionResponses, StepsCompetitionsAdminUpdateAdminStepsCompetitionErrors, ThrowOnError> => (options.client ?? client).put<StepsCompetitionsAdminUpdateAdminStepsCompetitionResponses, StepsCompetitionsAdminUpdateAdminStepsCompetitionErrors, ThrowOnError>({
    url: '/admin/company/steps-competitions/{steps_competition_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Admin Steps Competition
 *
 * Cancel = release the prize hold (§1.2). Manage permission. Idempotent.
 */
export const stepsCompetitionsAdminCancelAdminStepsCompetition = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsAdminCancelAdminStepsCompetitionData, ThrowOnError>): RequestResult<StepsCompetitionsAdminCancelAdminStepsCompetitionResponses, StepsCompetitionsAdminCancelAdminStepsCompetitionErrors, ThrowOnError> => (options.client ?? client).post<StepsCompetitionsAdminCancelAdminStepsCompetitionResponses, StepsCompetitionsAdminCancelAdminStepsCompetitionErrors, ThrowOnError>({ url: '/admin/company/steps-competitions/{steps_competition_id}/cancel', ...options });

/**
 * List Admin Steps Competition Entries
 *
 * List the competition's entries with TRUE identities + flagged-day counts
 * (§1.4/§1.6). Read permission.
 */
export const stepsCompetitionsAdminListAdminStepsCompetitionEntries = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsAdminListAdminStepsCompetitionEntriesData, ThrowOnError>): RequestResult<StepsCompetitionsAdminListAdminStepsCompetitionEntriesResponses, StepsCompetitionsAdminListAdminStepsCompetitionEntriesErrors, ThrowOnError> => (options.client ?? client).get<StepsCompetitionsAdminListAdminStepsCompetitionEntriesResponses, StepsCompetitionsAdminListAdminStepsCompetitionEntriesErrors, ThrowOnError>({ url: '/admin/company/steps-competitions/{steps_competition_id}/entries', ...options });

/**
 * Disqualify Admin Steps Competition Entry
 *
 * Disqualify an entrant (§1.6). Manage permission. Idempotent.
 */
export const stepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntry = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryData, ThrowOnError>): RequestResult<StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryResponses, StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryErrors, ThrowOnError> => (options.client ?? client).post<StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryResponses, StepsCompetitionsAdminDisqualifyAdminStepsCompetitionEntryErrors, ThrowOnError>({ url: '/admin/company/steps-competitions/{steps_competition_id}/entries/{entry_id}/disqualify', ...options });

/**
 * Reinstate Admin Steps Competition Entry
 *
 * Reinstate a disqualified entrant (§1.6). Manage permission. Idempotent.
 */
export const stepsCompetitionsAdminReinstateAdminStepsCompetitionEntry = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryData, ThrowOnError>): RequestResult<StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryResponses, StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryErrors, ThrowOnError> => (options.client ?? client).post<StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryResponses, StepsCompetitionsAdminReinstateAdminStepsCompetitionEntryErrors, ThrowOnError>({ url: '/admin/company/steps-competitions/{steps_competition_id}/entries/{entry_id}/reinstate', ...options });

/**
 * Publish Admin Steps Competition
 *
 * Publish = place the prize hold (§2.6). Manage permission. 409
 * (DEPOSIT_FUNDS_REQUIRED) when the wallet's available_balance is short — the
 * client routes into the CAM deposit flow. Idempotent.
 */
export const stepsCompetitionsAdminPublishAdminStepsCompetition = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsAdminPublishAdminStepsCompetitionData, ThrowOnError>): RequestResult<StepsCompetitionsAdminPublishAdminStepsCompetitionResponses, StepsCompetitionsAdminPublishAdminStepsCompetitionErrors, ThrowOnError> => (options.client ?? client).post<StepsCompetitionsAdminPublishAdminStepsCompetitionResponses, StepsCompetitionsAdminPublishAdminStepsCompetitionErrors, ThrowOnError>({ url: '/admin/company/steps-competitions/{steps_competition_id}/publish', ...options });

/**
 * Retry Payout Admin Steps Competition
 *
 * Retry a stalled payout (§2.6). Manage permission. Re-enters the SAME fenced
 * finalize flow the cron uses; only a PAYOUT_PENDING competition is retryable
 * (409 otherwise). If the winner's charity is now available the competition
 * FINALIZEs and the prize is paid; if still unavailable it stays PAYOUT_PENDING.
 * Returns the competition's post-retry state (the client reads ``status`` to know
 * which).
 */
export const stepsCompetitionsAdminRetryPayoutAdminStepsCompetition = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionData, ThrowOnError>): RequestResult<StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionResponses, StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionErrors, ThrowOnError> => (options.client ?? client).post<StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionResponses, StepsCompetitionsAdminRetryPayoutAdminStepsCompetitionErrors, ThrowOnError>({ url: '/admin/company/steps-competitions/{steps_competition_id}/retry-payout', ...options });

/**
 * Export Company Tax Lines Csv
 *
 * EP-WEB-B4: the company's Variant-A (CWA) deductible tax lines for `year`.
 *
 * These are the SAME lines the annual-report PDF renders — the export calls the
 * identical assembly rather than reimplementing it, because a company holding a PDF
 * and a CSV that disagreed about its deduction is a tax problem, not a display bug.
 * Amounts are refund-netted (R3/D13); a fully-reversed charge is absent, because a
 * fully refunded charge is not a contribution.
 */
export const companiesExportCompanyTaxLinesCsv = <ThrowOnError extends boolean = false>(options: Options<CompaniesExportCompanyTaxLinesCsvData, ThrowOnError>): RequestResult<CompaniesExportCompanyTaxLinesCsvResponses, CompaniesExportCompanyTaxLinesCsvErrors, ThrowOnError> => (options.client ?? client).get<CompaniesExportCompanyTaxLinesCsvResponses, CompaniesExportCompanyTaxLinesCsvErrors, ThrowOnError>({ url: '/admin/company/tax-lines.csv', ...options });

/**
 * Export Company Transactions Csv
 *
 * EP-WEB-B3: the company's money events over `[from, to]` (inclusive ET days) —
 * deposits, match charges, direct gives, gift-card purchases, and wallet-funded
 * spends, one row each.
 *
 * There was no company transaction ledger before this: the wallet read returns
 * balances only, and the dashboard activity feed mixes two windows by design. Each
 * row names its own `amount_basis` because the sources do not share a money column
 * (card-funded = GROSS charged, wallet-funded = entered/face), so a reader can
 * never silently sum across bases. Refunds are NOT netted — that is the tax
 * export's job, and the two are different artifacts on purpose. An inverted or
 * over-long window is rejected, never clamped.
 */
export const companiesExportCompanyTransactionsCsv = <ThrowOnError extends boolean = false>(options: Options<CompaniesExportCompanyTransactionsCsvData, ThrowOnError>): RequestResult<CompaniesExportCompanyTransactionsCsvResponses, CompaniesExportCompanyTransactionsCsvErrors, ThrowOnError> => (options.client ?? client).get<CompaniesExportCompanyTransactionsCsvResponses, CompaniesExportCompanyTransactionsCsvErrors, ThrowOnError>({ url: '/admin/company/transactions.csv', ...options });

/**
 * Get Company Wallet
 */
export const companiesGetCompanyWallet = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyWalletData, ThrowOnError>): RequestResult<CompaniesGetCompanyWalletResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyWalletResponses, unknown, ThrowOnError>({ url: '/admin/company/wallet', ...options });

/**
 * Get Company Cards
 */
export const companiesGetCompanyCards = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyCardsData, ThrowOnError>): RequestResult<CompaniesGetCompanyCardsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyCardsResponses, unknown, ThrowOnError>({ url: '/admin/company/wallet/cards', ...options });

/**
 * Create Company Card
 */
export const companiesCreateCompanyCard = <ThrowOnError extends boolean = false>(options?: Options<CompaniesCreateCompanyCardData, ThrowOnError>): RequestResult<CompaniesCreateCompanyCardResponses, CompaniesCreateCompanyCardErrors, ThrowOnError> => (options?.client ?? client).post<CompaniesCreateCompanyCardResponses, CompaniesCreateCompanyCardErrors, ThrowOnError>({
    url: '/admin/company/wallet/cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete Company Card
 */
export const companiesDeleteCompanyCard = <ThrowOnError extends boolean = false>(options: Options<CompaniesDeleteCompanyCardData, ThrowOnError>): RequestResult<CompaniesDeleteCompanyCardResponses, CompaniesDeleteCompanyCardErrors, ThrowOnError> => (options.client ?? client).delete<CompaniesDeleteCompanyCardResponses, CompaniesDeleteCompanyCardErrors, ThrowOnError>({ url: '/admin/company/wallet/cards/{card_id}', ...options });

/**
 * Deposit Funds Company
 */
export const companiesDepositFundsCompany = <ThrowOnError extends boolean = false>(options: Options<CompaniesDepositFundsCompanyData, ThrowOnError>): RequestResult<CompaniesDepositFundsCompanyResponses, CompaniesDepositFundsCompanyErrors, ThrowOnError> => (options.client ?? client).post<CompaniesDepositFundsCompanyResponses, CompaniesDepositFundsCompanyErrors, ThrowOnError>({
    url: '/admin/company/wallet/deposit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Quote Company Deposit
 *
 * CAM-BE11 review F1(a): what a saved-card deposit of `amount` would charge and
 * credit, covered and not, priced by the resolution the deposit itself uses (the
 * stored card's brand, the company's own cover-fees setting). Owner-only, like the
 * deposit. Moves no money.
 */
export const companiesQuoteCompanyDeposit = <ThrowOnError extends boolean = false>(options: Options<CompaniesQuoteCompanyDepositData, ThrowOnError>): RequestResult<CompaniesQuoteCompanyDepositResponses, CompaniesQuoteCompanyDepositErrors, ThrowOnError> => (options.client ?? client).get<CompaniesQuoteCompanyDepositResponses, CompaniesQuoteCompanyDepositErrors, ThrowOnError>({ url: '/admin/company/wallet/deposit/quote', ...options });

/**
 * Publish Disclaimer
 *
 * Create a DRAFT disclaimer. Publisher-gated (TERMS_PUBLISHERS_WHITE_LIST,
 * enforced at the service layer).
 */
export const disclaimersPublishDisclaimer = <ThrowOnError extends boolean = false>(options: Options<DisclaimersPublishDisclaimerData, ThrowOnError>): RequestResult<DisclaimersPublishDisclaimerResponses, DisclaimersPublishDisclaimerErrors, ThrowOnError> => (options.client ?? client).post<DisclaimersPublishDisclaimerResponses, DisclaimersPublishDisclaimerErrors, ThrowOnError>({
    url: '/admin/disclaimers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Patch Disclaimer Draft
 *
 * Update a DRAFT document's content. Immutable once LIVE (409).
 */
export const disclaimersPatchDisclaimerDraft = <ThrowOnError extends boolean = false>(options: Options<DisclaimersPatchDisclaimerDraftData, ThrowOnError>): RequestResult<DisclaimersPatchDisclaimerDraftResponses, DisclaimersPatchDisclaimerDraftErrors, ThrowOnError> => (options.client ?? client).patch<DisclaimersPatchDisclaimerDraftResponses, DisclaimersPatchDisclaimerDraftErrors, ThrowOnError>({
    url: '/admin/disclaimers/{document_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Disclaimer Effective
 *
 * Flip a DRAFT document LIVE. Requires a non-empty sign-off.
 */
export const disclaimersSetDisclaimerEffective = <ThrowOnError extends boolean = false>(options: Options<DisclaimersSetDisclaimerEffectiveData, ThrowOnError>): RequestResult<DisclaimersSetDisclaimerEffectiveResponses, DisclaimersSetDisclaimerEffectiveErrors, ThrowOnError> => (options.client ?? client).post<DisclaimersSetDisclaimerEffectiveResponses, DisclaimersSetDisclaimerEffectiveErrors, ThrowOnError>({
    url: '/admin/disclaimers/{document_id}/set-effective',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Reconcile Review Charge Intents
 *
 * Super-admin read of the durable NEEDS_REVIEW queue (recon/05 §6): the
 * charge-intents the corrective pass could not auto-complete, each carrying its
 * machine ``review_reason``. The minimal reviewable surface — resolution is a
 * separate operator action (out of slice-1 scope).
 */
export const paymentsListReconcileReviewChargeIntents = <ThrowOnError extends boolean = false>(options?: Options<PaymentsListReconcileReviewChargeIntentsData, ThrowOnError>): RequestResult<PaymentsListReconcileReviewChargeIntentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PaymentsListReconcileReviewChargeIntentsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/payments/reconcile-review',
    ...options
});

/**
 * Set Receipt Fine Print Effective
 *
 * Flip a DRAFT receipt-fine-print document LIVE. Publisher-gated
 * (TERMS_PUBLISHERS_WHITE_LIST, enforced at the service layer). Requires a
 * non-empty sign-off.
 */
export const receiptFinePrintSetReceiptFinePrintEffective = <ThrowOnError extends boolean = false>(options: Options<ReceiptFinePrintSetReceiptFinePrintEffectiveData, ThrowOnError>): RequestResult<ReceiptFinePrintSetReceiptFinePrintEffectiveResponses, ReceiptFinePrintSetReceiptFinePrintEffectiveErrors, ThrowOnError> => (options.client ?? client).post<ReceiptFinePrintSetReceiptFinePrintEffectiveResponses, ReceiptFinePrintSetReceiptFinePrintEffectiveErrors, ThrowOnError>({
    url: '/admin/receipt-fine-print/{document_id}/set-effective',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish Terms
 */
export const termsPublishTerms = <ThrowOnError extends boolean = false>(options: Options<TermsPublishTermsData, ThrowOnError>): RequestResult<TermsPublishTermsResponses, TermsPublishTermsErrors, ThrowOnError> => (options.client ?? client).post<TermsPublishTermsResponses, TermsPublishTermsErrors, ThrowOnError>({
    url: '/admin/terms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Notify Terms
 *
 * Plan §3.5. Cloud Tasks fan-out notify. Requires Idempotency-Key
 * header (UUIDv4). Auth, rate-limit, env gate, and kill switch are all
 * enforced at the service layer.
 */
export const termsNotifyTerms = <ThrowOnError extends boolean = false>(options: Options<TermsNotifyTermsData, ThrowOnError>): RequestResult<TermsNotifyTermsResponses, TermsNotifyTermsErrors, ThrowOnError> => (options.client ?? client).post<TermsNotifyTermsResponses, TermsNotifyTermsErrors, ThrowOnError>({ url: '/admin/terms/{document_id}/notify', ...options });

/**
 * Retry Failed Batches
 *
 * Plan §3.10 (v7). Re-enqueue all status='failed' batches for this
 * document. In-flight (pending/in_progress) batches are untouched.
 */
export const termsRetryFailedBatches = <ThrowOnError extends boolean = false>(options: Options<TermsRetryFailedBatchesData, ThrowOnError>): RequestResult<TermsRetryFailedBatchesResponses, TermsRetryFailedBatchesErrors, ThrowOnError> => (options.client ?? client).post<TermsRetryFailedBatchesResponses, TermsRetryFailedBatchesErrors, ThrowOnError>({ url: '/admin/terms/{document_id}/notify/retry-failed-batches', ...options });

/**
 * Post Terms Notify Test
 *
 * Plan §3.11. Send the rendered email to the caller's own email only.
 */
export const termsPostTermsNotifyTest = <ThrowOnError extends boolean = false>(options: Options<TermsPostTermsNotifyTestData, ThrowOnError>): RequestResult<TermsPostTermsNotifyTestResponses, TermsPostTermsNotifyTestErrors, ThrowOnError> => (options.client ?? client).post<TermsPostTermsNotifyTestResponses, TermsPostTermsNotifyTestErrors, ThrowOnError>({ url: '/admin/terms/{document_id}/notify/test', ...options });

/**
 * Patch Terms Summary
 *
 * Plan §3.1. Update summary_of_changes and/or effective_at on a
 * not-yet-notified document. Auth, 14-day gate, bleach sanitization, and
 * post-notify lock are all enforced at the service layer.
 */
export const termsPatchTermsSummary = <ThrowOnError extends boolean = false>(options: Options<TermsPatchTermsSummaryData, ThrowOnError>): RequestResult<TermsPatchTermsSummaryResponses, TermsPatchTermsSummaryErrors, ThrowOnError> => (options.client ?? client).patch<TermsPatchTermsSummaryResponses, TermsPatchTermsSummaryErrors, ThrowOnError>({
    url: '/admin/terms/{document_id}/summary',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Email Available
 */
export const adminCheckEmailAvailable = <ThrowOnError extends boolean = false>(options: Options<AdminCheckEmailAvailableData, ThrowOnError>): RequestResult<AdminCheckEmailAvailableResponses, AdminCheckEmailAvailableErrors, ThrowOnError> => (options.client ?? client).get<AdminCheckEmailAvailableResponses, AdminCheckEmailAvailableErrors, ThrowOnError>({ url: '/admin/users/email_available', ...options });

/**
 * Get Minimum Version
 */
export const appGetMinimumVersion = <ThrowOnError extends boolean = false>(options?: Options<AppGetMinimumVersionData, ThrowOnError>): RequestResult<AppGetMinimumVersionResponses, AppGetMinimumVersionErrors, ThrowOnError> => (options?.client ?? client).get<AppGetMinimumVersionResponses, AppGetMinimumVersionErrors, ThrowOnError>({ url: '/app/minimum-version', ...options });

/**
 * Create Payment Session From Url
 */
export const apiCreatePaymentSessionFromUrl = <ThrowOnError extends boolean = false>(options: Options<ApiCreatePaymentSessionFromUrlData, ThrowOnError>): RequestResult<ApiCreatePaymentSessionFromUrlResponses, ApiCreatePaymentSessionFromUrlErrors, ThrowOnError> => (options.client ?? client).get<ApiCreatePaymentSessionFromUrlResponses, ApiCreatePaymentSessionFromUrlErrors, ThrowOnError>({ url: '/apple/payment_session_from_url', ...options });

/**
 * Get Assistant Config
 *
 * Runtime config + kill switch for the assistant (combined plan 02 §C2).
 *
 * Behind the global Firebase/App Check auth. Returns the dark defaults until
 * a super-admin writes the config row. `rollout_bucket_ok` / `min_client_version`
 * are frozen-client compatibility keys pinned to `true` / `null` — the assistant
 * has no cohort and no per-feature version floor (2026-07-30 ruling).
 */
export const assistantGetAssistantConfig = <ThrowOnError extends boolean = false>(options?: Options<AssistantGetAssistantConfigData, ThrowOnError>): RequestResult<AssistantGetAssistantConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AssistantGetAssistantConfigResponses, unknown, ThrowOnError>({ url: '/assistant/config', ...options });

/**
 * Get Assistant Consent
 *
 * The caller's third-party-AI consent state + the current disclosure (02
 * §C1-3). The client shows the consent sheet when `required and not satisfied`.
 * Always available (a user can read their consent state regardless of the kill
 * switch).
 */
export const assistantGetAssistantConsent = <ThrowOnError extends boolean = false>(options?: Options<AssistantGetAssistantConsentData, ThrowOnError>): RequestResult<AssistantGetAssistantConsentResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AssistantGetAssistantConsentResponses, unknown, ThrowOnError>({ url: '/assistant/consent', ...options });

/**
 * Record Assistant Consent
 *
 * Record the caller's consent to the current disclosure version (02 §C1-3).
 * The body carries the `version` the client displayed; a stale version → 409
 * (re-fetch the disclosure). Idempotent at the current version.
 */
export const assistantRecordAssistantConsent = <ThrowOnError extends boolean = false>(options: Options<AssistantRecordAssistantConsentData, ThrowOnError>): RequestResult<AssistantRecordAssistantConsentResponses, AssistantRecordAssistantConsentErrors, ThrowOnError> => (options.client ?? client).post<AssistantRecordAssistantConsentResponses, AssistantRecordAssistantConsentErrors, ThrowOnError>({
    url: '/assistant/consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Assistant Conversations
 *
 * Paginated conversation history, newest activity first (02 §C2). Always
 * available (a user can read their history even when the assistant is off).
 */
export const assistantListAssistantConversations = <ThrowOnError extends boolean = false>(options?: Options<AssistantListAssistantConversationsData, ThrowOnError>): RequestResult<AssistantListAssistantConversationsResponses, AssistantListAssistantConversationsErrors, ThrowOnError> => (options?.client ?? client).get<AssistantListAssistantConversationsResponses, AssistantListAssistantConversationsErrors, ThrowOnError>({ url: '/assistant/conversations', ...options });

/**
 * Create Assistant Conversation
 *
 * Create a conversation (combined plan 02 §C2). Returns the conversation with
 * its server-generated opening message (the interim AI disclosure) — or with
 * `messages: []` on the employer surface, which is seeded with no opening at all
 * (the consumer string promises a "Talk to a human" control that surface lacks;
 * see `assistant.conversation_service`). Gated server-side on the assistant being
 * enabled for the caller (the kill switch) → 403 when dark/disabled.
 */
export const assistantCreateAssistantConversation = <ThrowOnError extends boolean = false>(options: Options<AssistantCreateAssistantConversationData, ThrowOnError>): RequestResult<AssistantCreateAssistantConversationResponses, AssistantCreateAssistantConversationErrors, ThrowOnError> => (options.client ?? client).post<AssistantCreateAssistantConversationResponses, AssistantCreateAssistantConversationErrors, ThrowOnError>({
    url: '/assistant/conversations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Assistant Conversation
 *
 * Hard-delete a conversation + its messages (CCPA; 02 §C2). Cross-user/
 * missing → 404 (constant detail). Always available to the owner.
 */
export const assistantDeleteAssistantConversation = <ThrowOnError extends boolean = false>(options: Options<AssistantDeleteAssistantConversationData, ThrowOnError>): RequestResult<AssistantDeleteAssistantConversationResponses, AssistantDeleteAssistantConversationErrors, ThrowOnError> => (options.client ?? client).delete<AssistantDeleteAssistantConversationResponses, AssistantDeleteAssistantConversationErrors, ThrowOnError>({ url: '/assistant/conversations/{conversation_id}', ...options });

/**
 * Get Assistant Conversation
 *
 * Conversation detail + messages (02 §C2). Cross-user/missing → 404 with a
 * constant detail (no id echo). Always available to the owner.
 */
export const assistantGetAssistantConversation = <ThrowOnError extends boolean = false>(options: Options<AssistantGetAssistantConversationData, ThrowOnError>): RequestResult<AssistantGetAssistantConversationResponses, AssistantGetAssistantConversationErrors, ThrowOnError> => (options.client ?? client).get<AssistantGetAssistantConversationResponses, AssistantGetAssistantConversationErrors, ThrowOnError>({ url: '/assistant/conversations/{conversation_id}', ...options });

/**
 * Cancel Assistant Turn
 *
 * Cancel the conversation's in-flight assistant turn (combined plan 02 §C10).
 *
 * Conversation-level (one active turn per conversation is DB-enforced, so the
 * target is unambiguous and the client needn't track the turn id). Sets the turn
 * `cancel_requested`; the worker stops cooperatively at its next agent-loop round
 * boundary, finalizes the turn CANCELLED with its partial spend still accounted,
 * and streams a terminal `turn_cancelled` event the client tails on the SSE
 * stream. **Idempotent** — a second cancel while still `cancel_requested` returns
 * the same 200. Nothing in progress to cancel (latest turn terminal / no turn) →
 * 409; cross-user/missing conversation → 404 (constant detail).
 */
export const assistantCancelAssistantTurn = <ThrowOnError extends boolean = false>(options: Options<AssistantCancelAssistantTurnData, ThrowOnError>): RequestResult<AssistantCancelAssistantTurnResponses, AssistantCancelAssistantTurnErrors, ThrowOnError> => (options.client ?? client).post<AssistantCancelAssistantTurnResponses, AssistantCancelAssistantTurnErrors, ThrowOnError>({ url: '/assistant/conversations/{conversation_id}/cancel', ...options });

/**
 * Propose Assistant Escalation
 *
 * Phase 1 — the user-initiated "talk to a human" handoff (02 §C7 L6). Records
 * a `proposed` escalation; sends NOTHING (only the confirm endpoint sends).
 * Gated on the assistant being available for the caller (403) and owning the
 * conversation (cross-user/missing → 404).
 */
export const assistantProposeAssistantEscalation = <ThrowOnError extends boolean = false>(options: Options<AssistantProposeAssistantEscalationData, ThrowOnError>): RequestResult<AssistantProposeAssistantEscalationResponses, AssistantProposeAssistantEscalationErrors, ThrowOnError> => (options.client ?? client).post<AssistantProposeAssistantEscalationResponses, AssistantProposeAssistantEscalationErrors, ThrowOnError>({
    url: '/assistant/conversations/{conversation_id}/escalations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Assistant Message
 *
 * Send a message (combined plan 02 §C1).
 *
 * **Default:** the turn is queued and generation is dispatched off the request
 * → `202 {turn_id, stream_path}`; the client opens `stream_path` (SSE) for the
 * reply. **`Accept: application/json`:** the turn runs inline and the final
 * message is returned `200` (the Newman/testing affordance). Idempotent on
 * `(conversation_id, client_msg_id)`; one active turn per conversation (409);
 * gated on the kill switch (403); cross-user/missing → 404.
 */
export const assistantSendAssistantMessage = <ThrowOnError extends boolean = false>(options: Options<AssistantSendAssistantMessageData, ThrowOnError>): RequestResult<AssistantSendAssistantMessageResponses, AssistantSendAssistantMessageErrors, ThrowOnError> => (options.client ?? client).post<AssistantSendAssistantMessageResponses, AssistantSendAssistantMessageErrors, ThrowOnError>({
    url: '/assistant/conversations/{conversation_id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Assistant Feedback
 *
 * Record a thumbs rating + the in-app AI-content report on a message (02 §C2;
 * 05 §4-§5 — the report control required by Google Play AI-Generated Content +
 * Apple 1.2). Append-only: each POST inserts one feedback row (a rating and a
 * report may be filed separately). Requires auth + ownership only — it is NOT
 * gated on the kill switch, so the compliance control always
 * works for a message the user already has. The message must belong to a
 * conversation owned by the caller; cross-user / missing conversation /
 * message-not-in-conversation → 404 (constant detail, no enumeration oracle).
 * An invalid rating / off-set report_category / unknown field / over-long
 * comment → 422 at the schema layer.
 */
export const assistantSubmitAssistantFeedback = <ThrowOnError extends boolean = false>(options: Options<AssistantSubmitAssistantFeedbackData, ThrowOnError>): RequestResult<AssistantSubmitAssistantFeedbackResponses, AssistantSubmitAssistantFeedbackErrors, ThrowOnError> => (options.client ?? client).post<AssistantSubmitAssistantFeedbackResponses, AssistantSubmitAssistantFeedbackErrors, ThrowOnError>({
    url: '/assistant/conversations/{conversation_id}/messages/{message_id}/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stream Assistant Turn
 *
 * Resumable SSE tail of a conversation's turn (combined plan 02 §C1/§C3).
 *
 * Streams `message_start` → `text_delta*` → `message_complete` (or
 * `turn_failed`), tailing the durable `assistant_event` log so disconnect/
 * reconnect replays losslessly via `Last-Event-ID`. `?format=json` returns the
 * persisted event array (e2e / poll-until-persisted). Cross-user/missing/
 * no-turn → 404 (constant detail). The reader never queries the request
 * session; it tails via short-lived `independent_session` reads (C0 shape).
 */
export const assistantStreamAssistantTurn = <ThrowOnError extends boolean = false>(options: Options<AssistantStreamAssistantTurnData, ThrowOnError>): RequestResult<AssistantStreamAssistantTurnResponses, AssistantStreamAssistantTurnErrors, ThrowOnError> => (options.client ?? client).get<AssistantStreamAssistantTurnResponses, AssistantStreamAssistantTurnErrors, ThrowOnError>({ url: '/assistant/conversations/{conversation_id}/stream', ...options });

/**
 * Confirm Assistant Escalation
 *
 * Phase 2 — the deterministic, user-confirmed endpoint that sends the handoff
 * email (02 §C7 L6 — the model can never send email). Transitions
 * `proposed → confirmed → sent`/`failed`; idempotent (a row past `proposed` is
 * returned unchanged). Cross-user/missing → 404.
 */
export const assistantConfirmAssistantEscalation = <ThrowOnError extends boolean = false>(options: Options<AssistantConfirmAssistantEscalationData, ThrowOnError>): RequestResult<AssistantConfirmAssistantEscalationResponses, AssistantConfirmAssistantEscalationErrors, ThrowOnError> => (options.client ?? client).post<AssistantConfirmAssistantEscalationResponses, AssistantConfirmAssistantEscalationErrors, ThrowOnError>({
    url: '/assistant/escalations/{escalation_id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board About
 *
 * About the board, from its own records: who serves and in what role, the duties the board
 * recorded for its officers, its recorded meeting rules and next meeting, its governing documents
 * in force, and its minutes and written consents of the last twelve months. Nothing from a
 * closed session.
 */
export const boardDirectorGetBoardAbout = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardAboutData, ThrowOnError>): RequestResult<BoardDirectorGetBoardAboutResponses, BoardDirectorGetBoardAboutErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardAboutResponses, BoardDirectorGetBoardAboutErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/about-the-board', ...options });

/**
 * Get Board Director Attention
 *
 * What is waiting for this director on this board.
 *
 * Three kinds share one list, each narrowable on its ``kind`` discriminator: an
 * unanswered meeting, a consent awaiting this seat's signature, and approved minutes
 * awaiting it. Only what this director can ACT on appears, so an empty list is an
 * honest "nothing is waiting".
 */
export const boardDirectorGetBoardDirectorAttention = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardDirectorAttentionData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorAttentionResponses, BoardDirectorGetBoardDirectorAttentionErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardDirectorAttentionResponses, BoardDirectorGetBoardDirectorAttentionErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/attention', ...options });

/**
 * Get Board Director Attention Completed
 *
 * What you did on this board in the last 90 days, newest first: written consents you signed,
 * minutes you signed, meetings you answered for, questionnaires and self-assessments you
 * answered, copies of the return you opened. Your own acts only, scoped as what waits for you
 * is: a closed session's minutes only once you've confirmed it's you.
 */
export const boardDirectorGetBoardDirectorAttentionCompleted = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardDirectorAttentionCompletedData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorAttentionCompletedResponses, BoardDirectorGetBoardDirectorAttentionCompletedErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardDirectorAttentionCompletedResponses, BoardDirectorGetBoardDirectorAttentionCompletedErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/attention/completed', ...options });

/**
 * List Own Board Coi Cycles
 *
 * The years you were asked for your conflict-of-interest answers on this board, newest
 * first, with your own answers where you've sent them.
 */
export const boardDirectorListOwnBoardCoiCycles = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorListOwnBoardCoiCyclesData, ThrowOnError>): RequestResult<BoardDirectorListOwnBoardCoiCyclesResponses, BoardDirectorListOwnBoardCoiCyclesErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorListOwnBoardCoiCyclesResponses, BoardDirectorListOwnBoardCoiCyclesErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/coi-cycles', ...options });

/**
 * Get Own Board Coi Questionnaire
 *
 * Your questionnaire for the year: the questions as you're asked them, your board's policy,
 * your answers from last year filled in, and the single disclosures you've made since.
 */
export const boardDirectorGetOwnBoardCoiQuestionnaire = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetOwnBoardCoiQuestionnaireData, ThrowOnError>): RequestResult<BoardDirectorGetOwnBoardCoiQuestionnaireResponses, BoardDirectorGetOwnBoardCoiQuestionnaireErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetOwnBoardCoiQuestionnaireResponses, BoardDirectorGetOwnBoardCoiQuestionnaireErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/coi-cycles/{cycle_id}/questionnaire', ...options });

/**
 * Get Own Board Coi Response
 *
 * Your answers for the year as recorded, with any correction you've made.
 */
export const boardDirectorGetOwnBoardCoiResponse = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetOwnBoardCoiResponseData, ThrowOnError>): RequestResult<BoardDirectorGetOwnBoardCoiResponseResponses, BoardDirectorGetOwnBoardCoiResponseErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetOwnBoardCoiResponseResponses, BoardDirectorGetOwnBoardCoiResponseErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/coi-cycles/{cycle_id}/response', ...options });

/**
 * Submit Own Board Coi Response
 *
 * Sign your answers for the year. A signature-class act: it needs your signing window open,
 * and `intent_statement_id` echoes the words beside Sign (a stale id is a typed 409). Your
 * signed answers become your disclosure in the board's records, in place of last year's.
 * `corrects_record_id` adds a correction beside answers you've already signed.
 */
export const boardDirectorSubmitOwnBoardCoiResponse = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorSubmitOwnBoardCoiResponseData, ThrowOnError>): RequestResult<BoardDirectorSubmitOwnBoardCoiResponseResponses, BoardDirectorSubmitOwnBoardCoiResponseErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorSubmitOwnBoardCoiResponseResponses, BoardDirectorSubmitOwnBoardCoiResponseErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/coi-cycles/{cycle_id}/response',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Own Board Coi Response Changes
 *
 * Your answers for the year against your answers from the year before, question by
 * question.
 */
export const boardDirectorGetOwnBoardCoiResponseChanges = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetOwnBoardCoiResponseChangesData, ThrowOnError>): RequestResult<BoardDirectorGetOwnBoardCoiResponseChangesResponses, BoardDirectorGetOwnBoardCoiResponseChangesErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetOwnBoardCoiResponseChangesResponses, BoardDirectorGetOwnBoardCoiResponseChangesErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/coi-cycles/{cycle_id}/response/changes', ...options });

/**
 * Get Own Board Coi Response Document
 *
 * Your copy of your answers for the year, as a PDF: as recorded, or the changes from the
 * year before.
 */
export const boardDirectorGetOwnBoardCoiResponseDocument = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetOwnBoardCoiResponseDocumentData, ThrowOnError>): RequestResult<BoardDirectorGetOwnBoardCoiResponseDocumentResponses, BoardDirectorGetOwnBoardCoiResponseDocumentErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetOwnBoardCoiResponseDocumentResponses, BoardDirectorGetOwnBoardCoiResponseDocumentErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/coi-cycles/{cycle_id}/response/document', ...options });

/**
 * List Own Board Conflict Disclosures
 *
 * Your own recorded disclosures on this board — what the book says about you.
 *
 * Never another director's: the seat is the one your account claimed, and this route takes
 * no id that could name someone else. `status` on each entry says whether it still stands
 * or a later disclosure of yours replaced it.
 */
export const boardDirectorListOwnBoardConflictDisclosures = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorListOwnBoardConflictDisclosuresData, ThrowOnError>): RequestResult<BoardDirectorListOwnBoardConflictDisclosuresResponses, BoardDirectorListOwnBoardConflictDisclosuresErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorListOwnBoardConflictDisclosuresResponses, BoardDirectorListOwnBoardConflictDisclosuresErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/conflict-disclosures', ...options });

/**
 * Record Own Board Conflict Disclosure
 *
 * Record your own conflict-of-interest disclosure.
 *
 * Describe the interest in your own words and, where there is one, name the counterparty
 * — the person or organization on the other side of it. The name is what lets the
 * recording officer be shown this disclosure beside an agenda item or motion that
 * mentions it, before the board votes.
 *
 * A signature-class act: it needs the director's signing window, for the same reason a
 * consent signature does. Without it the answer is the typed 400
 * `board_director_signing_required` the console turns into its confirm sheet, never a 401.
 * `intent_statement_id` echoes the words beside the button.
 *
 * `supersedes_record_id` records that your position has CHANGED — the earlier disclosure
 * stays an accurate record of what was true at its time, which is usually what you mean.
 * `corrects_record_id` records that the earlier one was wrong.
 *
 * Recording this does not decide anything: whether you stand out of a vote is the
 * board's determination, recorded in the minutes as a recusal.
 */
export const boardDirectorRecordOwnBoardConflictDisclosure = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorRecordOwnBoardConflictDisclosureData, ThrowOnError>): RequestResult<BoardDirectorRecordOwnBoardConflictDisclosureResponses, BoardDirectorRecordOwnBoardConflictDisclosureErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorRecordOwnBoardConflictDisclosureResponses, BoardDirectorRecordOwnBoardConflictDisclosureErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/conflict-disclosures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Own Board Getting Started
 *
 * Your getting-started list on this board: the documents to read and confirm, your first
 * conflict-of-interest disclosure, the board's own steps, and your board buddy.
 */
export const boardDirectorGetOwnBoardGettingStarted = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetOwnBoardGettingStartedData, ThrowOnError>): RequestResult<BoardDirectorGetOwnBoardGettingStartedResponses, BoardDirectorGetOwnBoardGettingStartedErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetOwnBoardGettingStartedResponses, BoardDirectorGetOwnBoardGettingStartedErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/getting-started', ...options });

/**
 * Mark Own Board Getting Started Step
 *
 * Mark one of your board's steps on your list done, with the date, or clear it.
 */
export const boardDirectorMarkOwnBoardGettingStartedStep = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorMarkOwnBoardGettingStartedStepData, ThrowOnError>): RequestResult<BoardDirectorMarkOwnBoardGettingStartedStepResponses, BoardDirectorMarkOwnBoardGettingStartedStepErrors, ThrowOnError> => (options.client ?? client).put<BoardDirectorMarkOwnBoardGettingStartedStepResponses, BoardDirectorMarkOwnBoardGettingStartedStepErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/getting-started/items/{item_id}/done',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Director Meetings
 *
 * This board's meetings, soonest first, with this seat's own answer on each.
 *
 * Defaults to upcoming only: a director opening the surface is looking at what is ahead.
 * Past meetings are available by asking for them.
 */
export const boardDirectorListBoardDirectorMeetings = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorListBoardDirectorMeetingsData, ThrowOnError>): RequestResult<BoardDirectorListBoardDirectorMeetingsResponses, BoardDirectorListBoardDirectorMeetingsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorListBoardDirectorMeetingsResponses, BoardDirectorListBoardDirectorMeetingsErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/meetings', ...options });

/**
 * Get Board Director Meeting
 *
 * One meeting, with its agenda and the current published packet's id.
 *
 * The notice block is included: it is the charity's own recorded parameter and the
 * arithmetic against it, and the sentence names the section the charity attributed the
 * period to — so a director can read it against the instrument themselves rather than
 * take the product's word for anything.
 */
export const boardDirectorGetBoardDirectorMeeting = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardDirectorMeetingData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorMeetingResponses, BoardDirectorGetBoardDirectorMeetingErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardDirectorMeetingResponses, BoardDirectorGetBoardDirectorMeetingErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/meetings/{meeting_id}', ...options });

/**
 * Record Board Director Attendance Intent
 *
 * Answer whether this director expects to attend.
 *
 * Rides the account's sign-in and needs no signing window: how strongly a director must
 * confirm it's them is tiered by the weight of the act, and an answer about attendance
 * binds nobody to anything. A vote, a written consent, or e-signing minutes does need one.
 *
 * A PUT because there is one current answer per director per meeting; changing it
 * replaces it, and when the answer was FIRST given is kept either way.
 */
export const boardDirectorRecordBoardDirectorAttendanceIntent = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorRecordBoardDirectorAttendanceIntentData, ThrowOnError>): RequestResult<BoardDirectorRecordBoardDirectorAttendanceIntentResponses, BoardDirectorRecordBoardDirectorAttendanceIntentErrors, ThrowOnError> => (options.client ?? client).put<BoardDirectorRecordBoardDirectorAttendanceIntentResponses, BoardDirectorRecordBoardDirectorAttendanceIntentErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/meetings/{meeting_id}/attendance-intent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Director Meeting Calendar
 *
 * The meeting as an iCalendar file, for the director's own calendar.
 */
export const boardDirectorGetBoardDirectorMeetingCalendar = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardDirectorMeetingCalendarData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorMeetingCalendarResponses, BoardDirectorGetBoardDirectorMeetingCalendarErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardDirectorMeetingCalendarResponses, BoardDirectorGetBoardDirectorMeetingCalendarErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/meetings/{meeting_id}/calendar', ...options });

/**
 * Sign Board Minutes
 *
 * Sign approved minutes.
 *
 * A signature-class act: it needs the director's signing window open (CBG-SEC2), and the
 * factor that opened it, when it was confirmed and the words affirmed are recorded beside
 * the signature. Reading and answering an invitation do not — the weight of the act sets the
 * bar. `intent_statement_id` echoes the words beside the button; a stale id is a typed 409.
 *
 * `content_hash` is the address of the exact minutes being signed. If they changed since
 * they were read, the signature is refused rather than attached to different words.
 *
 * `capacity_title_id` (optional) records the title this person signs as: one of the titles
 * their seat holds now, kept with the signature in the words it has today. A title the seat
 * doesn't hold is a 409 `board_signature_capacity_not_held`.
 *
 * A signature follows the board's approval; minutes still in draft cannot be signed.
 */
export const boardDirectorSignBoardMinutes = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorSignBoardMinutesData, ThrowOnError>): RequestResult<BoardDirectorSignBoardMinutesResponses, BoardDirectorSignBoardMinutesErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorSignBoardMinutesResponses, BoardDirectorSignBoardMinutesErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/meetings/{meeting_id}/minutes/signature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Director Meeting Record
 *
 * What the charity recorded about one meeting, as this director may see it.
 *
 * Who was present, the parts of the meeting, and the motions with their recorded votes,
 * recusals, and the quorum figures taken at each — plus this seat's own votes and recusals,
 * so a director can see what the book says about them without reading every motion.
 *
 * A closed session this director was not part of is absent, and so is everything recorded
 * inside it. Nothing on the wire counts what was withheld.
 */
export const boardDirectorGetBoardDirectorMeetingRecord = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardDirectorMeetingRecordData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorMeetingRecordResponses, BoardDirectorGetBoardDirectorMeetingRecordErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardDirectorMeetingRecordResponses, BoardDirectorGetBoardDirectorMeetingRecordErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/meetings/{meeting_id}/record', ...options });

/**
 * Get Board Director Packet
 *
 * One published packet version, and a recorded open for the chair's view.
 *
 * A version still being assembled answers exactly as a missing one does — a director
 * reads what the board was sent. An entry pointing at a closed session this director was
 * not part of is absent from the entries. The open is recorded only after the read is
 * allowed, so the chair's view never shows something that did not happen.
 */
export const boardDirectorGetBoardDirectorPacket = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardDirectorPacketData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorPacketResponses, BoardDirectorGetBoardDirectorPacketErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardDirectorPacketResponses, BoardDirectorGetBoardDirectorPacketErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/packets/{packet_id}', ...options });

/**
 * List Board Director Annotations
 *
 * This director's own notes plus every board-visible comment on this version.
 *
 * Another director's personal note is absent, not refused, so the list cannot be used to
 * learn that one exists.
 */
export const boardDirectorListBoardDirectorAnnotations = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorListBoardDirectorAnnotationsData, ThrowOnError>): RequestResult<BoardDirectorListBoardDirectorAnnotationsResponses, BoardDirectorListBoardDirectorAnnotationsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorListBoardDirectorAnnotationsResponses, BoardDirectorListBoardDirectorAnnotationsErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/packets/{packet_id}/annotations', ...options });

/**
 * Create Board Director Annotation
 *
 * Write a note on this packet version, or on one of its entries.
 *
 * `visibility` has no default: a personal note and something the whole board will read
 * are different things, and choosing between them is the director's to make explicitly.
 * A personal note is readable by this seat and by nobody else — not another director, and
 * not the charity's own administrators.
 */
export const boardDirectorCreateBoardDirectorAnnotation = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorCreateBoardDirectorAnnotationData, ThrowOnError>): RequestResult<BoardDirectorCreateBoardDirectorAnnotationResponses, BoardDirectorCreateBoardDirectorAnnotationErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorCreateBoardDirectorAnnotationResponses, BoardDirectorCreateBoardDirectorAnnotationErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/packets/{packet_id}/annotations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Board Director Annotation
 *
 * Delete one of this director's own notes.
 *
 * Naming another director's note answers exactly as naming one that does not exist.
 * There is no edit: a comment the rest of the board has read must not change under them,
 * and a personal note costs nothing to write again.
 */
export const boardDirectorDeleteBoardDirectorAnnotation = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorDeleteBoardDirectorAnnotationData, ThrowOnError>): RequestResult<BoardDirectorDeleteBoardDirectorAnnotationResponses, BoardDirectorDeleteBoardDirectorAnnotationErrors, ThrowOnError> => (options.client ?? client).delete<BoardDirectorDeleteBoardDirectorAnnotationResponses, BoardDirectorDeleteBoardDirectorAnnotationErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/packets/{packet_id}/annotations/{annotation_id}', ...options });

/**
 * Get Board Director Packet Document Download Url
 *
 * A short-lived read URL for one attachment in this packet version.
 *
 * Reachable only because the attachment is IN a packet this director may read. An
 * attachment uploaded against the meeting but never placed in a published version is not
 * something the board was sent, so it answers as absent.
 */
export const boardDirectorGetBoardDirectorPacketDocumentDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlResponses, BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlResponses, BoardDirectorGetBoardDirectorPacketDocumentDownloadUrlErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/packets/{packet_id}/documents/{document_id}/download-url', ...options });

/**
 * Get Board Director Filing Receipt Download Url
 *
 * Authorize this seat to the exact published snapshot before a URL is signed.
 */
export const boardDirectorGetBoardDirectorFilingReceiptDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlResponses, BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlResponses, BoardDirectorGetBoardDirectorFilingReceiptDownloadUrlErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/packets/{packet_id}/items/{packet_item_id}/filing-receipts/{artifact_id}/download-url', ...options });

/**
 * List Board Director Records
 *
 * This board's records, scoped to what this director may read.
 *
 * A closed session the director did not attend is ABSENT from the page and from
 * `meta.total` — scoped together in SQL, so an offset walk cannot map the number or
 * position of the records withheld.
 */
export const boardDirectorListBoardDirectorRecords = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorListBoardDirectorRecordsData, ThrowOnError>): RequestResult<BoardDirectorListBoardDirectorRecordsResponses, BoardDirectorListBoardDirectorRecordsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorListBoardDirectorRecordsResponses, BoardDirectorListBoardDirectorRecordsErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/records', ...options });

/**
 * Get Board Director Record
 *
 * One record, and a recorded open for the chair's engagement view.
 *
 * A record this director may not read answers exactly as a record that does not exist
 * does, and the open is recorded only after the read is allowed.
 */
export const boardDirectorGetBoardDirectorRecord = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardDirectorRecordData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorRecordResponses, BoardDirectorGetBoardDirectorRecordErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardDirectorRecordResponses, BoardDirectorGetBoardDirectorRecordErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/records/{record_id}', ...options });

/**
 * Acknowledge Board Record
 *
 * Record this director's acknowledgment of a record — a signature-class act.
 *
 * Needs the director's signing window open (their passkey, or on an account with no passkey
 * their authenticator app, confirmed in this sign-in within the hour); without it the answer
 * is the typed 400 `board_director_signing_required` the console turns into its confirm
 * sheet, never a 401 that would read as "sign in again".
 *
 * `content_hash` is a required echo of what the director read: the act's whole value is
 * that it names the exact bytes a human saw, so a mismatch is refused rather than
 * recorded. `intent_statement_id` echoes the words beside the button (`/me` lists the
 * current ones); a stale id is a typed 409. The response carries the recorded capture back —
 * which seat, what identity it asserted, the factor that opened the window and when it was
 * confirmed, the words affirmed, and when the act happened.
 */
export const boardDirectorAcknowledgeBoardRecord = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorAcknowledgeBoardRecordData, ThrowOnError>): RequestResult<BoardDirectorAcknowledgeBoardRecordResponses, BoardDirectorAcknowledgeBoardRecordErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorAcknowledgeBoardRecordResponses, BoardDirectorAcknowledgeBoardRecordErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/records/{record_id}/acknowledgment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign Board Minutes To Approve
 *
 * Sign to approve a closed session's minutes, as one of the directors who were in it.
 *
 * Only where the board's rule approves a closed session's minutes by the signatures of the
 * directors who were there, and only for a director its open request asked: the seat recorded as
 * in the session whose account it was at the meeting's start. Anyone else gets the not-found, as
 * a record that does not exist does. A signature-class act: it needs the director's signing
 * window, and records the factor, when it was confirmed and the words affirmed
 * (`intent_statement_id`; a stale id is a typed 409). `content_hash` is the bytes read: minutes
 * that changed since are refused rather than signed. The last asked signature on the current
 * bytes approves the minutes (`approved`).
 */
export const boardDirectorSignBoardMinutesToApprove = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorSignBoardMinutesToApproveData, ThrowOnError>): RequestResult<BoardDirectorSignBoardMinutesToApproveResponses, BoardDirectorSignBoardMinutesToApproveErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorSignBoardMinutesToApproveResponses, BoardDirectorSignBoardMinutesToApproveErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/records/{record_id}/approval-signature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Return Copy For Director
 *
 * A copy of the organization's return provided to the board: the tax year, who provided it
 * and when, the file's name, size and pages, when you opened it, and your recorded reading of
 * it. Nothing about anyone else.
 */
export const boardDirectorGetBoardReturnCopyForDirector = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardReturnCopyForDirectorData, ThrowOnError>): RequestResult<BoardDirectorGetBoardReturnCopyForDirectorResponses, BoardDirectorGetBoardReturnCopyForDirectorErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardReturnCopyForDirectorResponses, BoardDirectorGetBoardReturnCopyForDirectorErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/return-distributions/{record_id}', ...options });

/**
 * Open Board Return Copy For Director
 *
 * A link to open the copy, valid for 15 minutes. If it was sent to you, the first time you
 * open it is recorded first, so the board can see you received it.
 */
export const boardDirectorOpenBoardReturnCopyForDirector = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOpenBoardReturnCopyForDirectorData, ThrowOnError>): RequestResult<BoardDirectorOpenBoardReturnCopyForDirectorResponses, BoardDirectorOpenBoardReturnCopyForDirectorErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOpenBoardReturnCopyForDirectorResponses, BoardDirectorOpenBoardReturnCopyForDirectorErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/return-distributions/{record_id}/copy-url', ...options });

/**
 * Start Board Seat Move
 *
 * Start moving your seat on this board to another of your Givmo accounts.
 *
 * Answers a single-use ticket, ONCE, for this page to keep in its own tab — never in an
 * address or a mail — with when it stops working (30 minutes) and the seat's address,
 * masked. The ticket is the move's first proof: this account, which holds the seat, was
 * signed in when the move began. It moves nothing by itself: the move finishes signed in to
 * the other account, which proves the seat's address (its own confirmed email is that
 * address, or a code mailed there). Starting a move is capped per seat per day
 * (`board_seat_claim_code_throttled`).
 */
export const boardDirectorStartBoardSeatMove = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorStartBoardSeatMoveData, ThrowOnError>): RequestResult<BoardDirectorStartBoardSeatMoveResponses, BoardDirectorStartBoardSeatMoveErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorStartBoardSeatMoveResponses, BoardDirectorStartBoardSeatMoveErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/seat-moves', ...options });

/**
 * List Own Board Self Assessments
 *
 * The board's self-assessments you were asked to answer, newest first, with your own part in
 * each: whether you've answered, and whether the results are in.
 */
export const boardDirectorListOwnBoardSelfAssessments = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorListOwnBoardSelfAssessmentsData, ThrowOnError>): RequestResult<BoardDirectorListOwnBoardSelfAssessmentsResponses, BoardDirectorListOwnBoardSelfAssessmentsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorListOwnBoardSelfAssessmentsResponses, BoardDirectorListOwnBoardSelfAssessmentsErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/self-assessments', ...options });

/**
 * Save Own Board Self Assessment Answers
 *
 * Send your answers. They replace your earlier ones until the self-assessment closes, and
 * stay private to you: the board sees only the results, together and without names.
 */
export const boardDirectorSaveOwnBoardSelfAssessmentAnswers = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorSaveOwnBoardSelfAssessmentAnswersData, ThrowOnError>): RequestResult<BoardDirectorSaveOwnBoardSelfAssessmentAnswersResponses, BoardDirectorSaveOwnBoardSelfAssessmentAnswersErrors, ThrowOnError> => (options.client ?? client).put<BoardDirectorSaveOwnBoardSelfAssessmentAnswersResponses, BoardDirectorSaveOwnBoardSelfAssessmentAnswersErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/self-assessments/{assessment_id}/answers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Own Board Self Assessment Questions
 *
 * The self-assessment's statements, each with its source, and your own answers while it's
 * open. No one else sees your answers.
 */
export const boardDirectorGetOwnBoardSelfAssessmentQuestions = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetOwnBoardSelfAssessmentQuestionsData, ThrowOnError>): RequestResult<BoardDirectorGetOwnBoardSelfAssessmentQuestionsResponses, BoardDirectorGetOwnBoardSelfAssessmentQuestionsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetOwnBoardSelfAssessmentQuestionsResponses, BoardDirectorGetOwnBoardSelfAssessmentQuestionsErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/self-assessments/{assessment_id}/questions', ...options });

/**
 * Get Board Self Assessment Results For Director
 *
 * A closed self-assessment's results: how many people chose each answer and the comments
 * without names, or, with fewer than three answers, only how many were asked and answered.
 */
export const boardDirectorGetBoardSelfAssessmentResultsForDirector = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardSelfAssessmentResultsForDirectorData, ThrowOnError>): RequestResult<BoardDirectorGetBoardSelfAssessmentResultsForDirectorResponses, BoardDirectorGetBoardSelfAssessmentResultsForDirectorErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardSelfAssessmentResultsForDirectorResponses, BoardDirectorGetBoardSelfAssessmentResultsForDirectorErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/self-assessments/{assessment_id}/results', ...options });

/**
 * List Board Director Consents
 *
 * The consents this director is being asked to sign.
 *
 * Scoped to the roster the consent currently before the board went out to, so a
 * consent this director was not asked to sign is ABSENT — from the page and from
 * `meta.total` together.
 */
export const boardDirectorListBoardDirectorConsents = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorListBoardDirectorConsentsData, ThrowOnError>): RequestResult<BoardDirectorListBoardDirectorConsentsResponses, BoardDirectorListBoardDirectorConsentsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorListBoardDirectorConsentsResponses, BoardDirectorListBoardDirectorConsentsErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/written-consents', ...options });

/**
 * Get Board Director Consent
 *
 * One consent, with its full text and this director's own standing.
 *
 * `content_hash` is the address of the text shown here, and it is what a signature has
 * to echo — so a director who signs is signing exactly what they were shown.
 */
export const boardDirectorGetBoardDirectorConsent = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardDirectorConsentData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorConsentResponses, BoardDirectorGetBoardDirectorConsentErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardDirectorConsentResponses, BoardDirectorGetBoardDirectorConsentErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/written-consents/{consent_id}', ...options });

/**
 * Get Board Compensation Document Download For Director
 *
 * A short-lived link to read one document a consent's compensation details name, for anyone
 * on the board's roster once the consent has gone out — so each document the text names can be
 * opened before signing. Made for this request and never stored.
 */
export const boardDirectorGetBoardCompensationDocumentDownloadForDirector = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorGetBoardCompensationDocumentDownloadForDirectorData, ThrowOnError>): RequestResult<BoardDirectorGetBoardCompensationDocumentDownloadForDirectorResponses, BoardDirectorGetBoardCompensationDocumentDownloadForDirectorErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorGetBoardCompensationDocumentDownloadForDirectorResponses, BoardDirectorGetBoardCompensationDocumentDownloadForDirectorErrors, ThrowOnError>({ url: '/board-director/charities/{charity_id}/written-consents/{consent_id}/compensation-decisions/{decision_id}/documents/{document_id}/download', ...options });

/**
 * Sign Board Written Consent
 *
 * Sign the consent.
 *
 * Needs the director's signing window open; without it the answer is the typed 400
 * `board_director_signing_required` the console turns into its confirm sheet.
 * `intent_statement_id` echoes the words beside the button; a stale id is a typed 409.
 *
 * `content_hash` is a required echo of the text this director read, so a signature can
 * never land on text that changed after they read it. If this is the last outstanding
 * signature, the same request records the consent in the charity's board records.
 */
export const boardDirectorSignBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorSignBoardWrittenConsentData, ThrowOnError>): RequestResult<BoardDirectorSignBoardWrittenConsentResponses, BoardDirectorSignBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorSignBoardWrittenConsentResponses, BoardDirectorSignBoardWrittenConsentErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/written-consents/{consent_id}/signature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Board Written Consent Signature
 *
 * Withdraw a signature already given, while the consent is still pending.
 *
 * A director who has second thoughts sends the matter to a meeting instead, and this
 * is how. It is appended as its own act — the signature it withdraws stays in the
 * record — and it needs the signing window for the same reason giving the signature did.
 *
 * Once the consent has been signed by every seat it went out to, it is the board's act
 * and this is no longer available.
 */
export const boardDirectorRevokeBoardWrittenConsentSignature = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorRevokeBoardWrittenConsentSignatureData, ThrowOnError>): RequestResult<BoardDirectorRevokeBoardWrittenConsentSignatureResponses, BoardDirectorRevokeBoardWrittenConsentSignatureErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorRevokeBoardWrittenConsentSignatureResponses, BoardDirectorRevokeBoardWrittenConsentSignatureErrors, ThrowOnError>({
    url: '/board-director/charities/{charity_id}/written-consents/{consent_id}/signature-withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Director Me
 *
 * The director's directory: every board this account holds a claimed seat on, the
 * account's signing window, and the words each signature-class act affirms.
 *
 * The board list — organization, role, seat, the board's adopted mode — carries nothing
 * about any board's content, and it is by ACCOUNT only (CBG-SEC2; CBG-FIX17 subsumed):
 * nothing joins by address, so no officer can make anyone's seats appear here. `signing`
 * says whether this sign-in may sign now and, when not, why (`closed_reason`); the console
 * counts down from `closes_at`. The one director read a board that asks for confirmation
 * before anything opens still answers.
 */
export const boardDirectorGetBoardDirectorMe = <ThrowOnError extends boolean = false>(options?: Options<BoardDirectorGetBoardDirectorMeData, ThrowOnError>): RequestResult<BoardDirectorGetBoardDirectorMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<BoardDirectorGetBoardDirectorMeResponses, unknown, ThrowOnError>({ url: '/board-director/me', ...options });

/**
 * Org Claim Board Seat
 *
 * Claim the invited seat into the signed-in Givmo account: automatically when the
 * account's email, confirmed by its sign-in provider, matches the seat's address, otherwise
 * with the code that account asked for (`board_seat_claim_code_required` names where it
 * would go, masked). Answers the seat as `/me` lists it; claiming a seat the account already
 * holds answers the same. An account that already holds another seat on this board is
 * refused (`board_account_already_seated_here`), and so is an account another organization's
 * sign-in lock binds (`board_another_account_required`).
 */
export const boardDirectorOrgClaimBoardSeat = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgClaimBoardSeatData, ThrowOnError>): RequestResult<BoardDirectorOrgClaimBoardSeatResponses, BoardDirectorOrgClaimBoardSeatErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgClaimBoardSeatResponses, BoardDirectorOrgClaimBoardSeatErrors, ThrowOnError>({
    url: '/board-director/organizations/invitations/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Request Board Seat Claim Code
 *
 * Email a six-digit code to the invited seat's address, for the signed-in account to
 * claim the seat with when its own email does not match. The code is spendable only by the
 * account that asked, for 10 minutes and 5 tries, and appears in no response. `email_sent`
 * false means this environment sends no such mail (no code exists); a send that failed is
 * the typed 503 `board_seat_claim_code_not_sent`. Throttled per seat and capped per
 * invitation (`board_seat_claim_code_throttled`). An account another organization's sign-in
 * lock binds is refused before any code exists (`board_another_account_required`).
 */
export const boardDirectorOrgRequestBoardSeatClaimCode = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgRequestBoardSeatClaimCodeData, ThrowOnError>): RequestResult<BoardDirectorOrgRequestBoardSeatClaimCodeResponses, BoardDirectorOrgRequestBoardSeatClaimCodeErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgRequestBoardSeatClaimCodeResponses, BoardDirectorOrgRequestBoardSeatClaimCodeErrors, ThrowOnError>({
    url: '/board-director/organizations/invitations/claim-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Preview Board Invitation
 *
 * What a board invitation is for, before it is used: the organization, the seat's name,
 * and where a code would go — masked. When the signed-in account already holds the seat,
 * `claimed_by_you` is true and the landing opens the board instead. Nothing is written, and
 * no account is needed. A link that can't be used — unknown, spent, expired, retired, its
 * seat removed or claimed by another account — gets one constant refusal,
 * `board_invitation_unavailable`. For a signed-in account whose answer is known,
 * `another_account_required` is true when another organization's sign-in lock binds the
 * account (today, an employer's company-only sign-in), so it can't join this board and the
 * landing offers another Givmo account.
 */
export const boardDirectorOrgPreviewBoardInvitation = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgPreviewBoardInvitationData, ThrowOnError>): RequestResult<BoardDirectorOrgPreviewBoardInvitationResponses, BoardDirectorOrgPreviewBoardInvitationErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgPreviewBoardInvitationResponses, BoardDirectorOrgPreviewBoardInvitationErrors, ThrowOnError>({
    url: '/board-director/organizations/invitations/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Director Me
 *
 * The director's directory: every board this account holds a claimed seat on, the
 * account's signing window, and the words each signature-class act affirms.
 *
 * The board list — organization, role, seat, the board's adopted mode — carries nothing
 * about any board's content, and it is by ACCOUNT only (CBG-SEC2; CBG-FIX17 subsumed):
 * nothing joins by address, so no officer can make anyone's seats appear here. `signing`
 * says whether this sign-in may sign now and, when not, why (`closed_reason`); the console
 * counts down from `closes_at`. The one director read a board that asks for confirmation
 * before anything opens still answers.
 */
export const boardDirectorOrgGetBoardDirectorMe = <ThrowOnError extends boolean = false>(options?: Options<BoardDirectorOrgGetBoardDirectorMeData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<BoardDirectorOrgGetBoardDirectorMeResponses, unknown, ThrowOnError>({ url: '/board-director/organizations/me', ...options });

/**
 * Org Request Board Seat Move Code
 *
 * Email a six-digit code to the moving seat's address, for the signed-in account to finish
 * the move with when its own email does not match. The code is spendable only by the account
 * that asked, for 10 minutes and 5 tries, and appears in no response; it shares the claim
 * code's caps, counted per seat (`board_seat_claim_code_throttled`). `email_sent` false means
 * this environment sends no such mail (no code exists); a send that failed is the typed 503
 * `board_seat_claim_code_not_sent`. Refused before any code exists for the account the seat is
 * on (`board_seat_move_same_account`), an account another organization's sign-in lock binds
 * (`board_another_account_required`) and one that already holds a seat on this board
 * (`board_account_already_seated_here`).
 */
export const boardDirectorOrgRequestBoardSeatMoveCode = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgRequestBoardSeatMoveCodeData, ThrowOnError>): RequestResult<BoardDirectorOrgRequestBoardSeatMoveCodeResponses, BoardDirectorOrgRequestBoardSeatMoveCodeErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgRequestBoardSeatMoveCodeResponses, BoardDirectorOrgRequestBoardSeatMoveCodeErrors, ThrowOnError>({
    url: '/board-director/organizations/seat-moves/code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Complete Board Seat Move
 *
 * Move the seat into the signed-in Givmo account: automatically when the account's email,
 * confirmed by its sign-in provider, is the seat's address, otherwise with the code that
 * account asked for (`board_seat_claim_code_required` names where it would go, masked). One
 * step that can't half-happen: the seat, the ticket and the code, and the seat's history line.
 * Both the account the seat left and the seat's address get an email. Answers the seat as
 * `/me` lists it; finishing a move that already finished here answers the same. Refused for
 * the account the seat is on (`board_seat_move_same_account`), an account another
 * organization's sign-in lock binds (`board_another_account_required`) and one that already
 * holds a seat on this board (`board_account_already_seated_here`).
 */
export const boardDirectorOrgCompleteBoardSeatMove = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgCompleteBoardSeatMoveData, ThrowOnError>): RequestResult<BoardDirectorOrgCompleteBoardSeatMoveResponses, BoardDirectorOrgCompleteBoardSeatMoveErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgCompleteBoardSeatMoveResponses, BoardDirectorOrgCompleteBoardSeatMoveErrors, ThrowOnError>({
    url: '/board-director/organizations/seat-moves/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Preview Board Seat Move
 *
 * What a seat move is for, before it finishes: the organization, the seat's name, the
 * seat's address and the account it moves from — both masked. Nothing is written. For a
 * signed-in account: `from_this_account` (it is the account the seat is on, so it can't take
 * the seat), `email_matches_seat` (its confirmed email is the seat's address, so no code is
 * needed) and, when known, `another_account_required` (another organization's sign-in lock
 * binds it, so it can't hold the seat either). A ticket that can't be used — unknown, spent,
 * expired, retired, or its seat removed, released or moved meanwhile — gets one constant
 * refusal, `board_seat_move_unavailable`.
 */
export const boardDirectorOrgPreviewBoardSeatMove = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgPreviewBoardSeatMoveData, ThrowOnError>): RequestResult<BoardDirectorOrgPreviewBoardSeatMoveResponses, BoardDirectorOrgPreviewBoardSeatMoveErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgPreviewBoardSeatMoveResponses, BoardDirectorOrgPreviewBoardSeatMoveErrors, ThrowOnError>({
    url: '/board-director/organizations/seat-moves/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Director Upcoming Meetings
 *
 * Upcoming meetings across every board this account holds a claimed seat on.
 *
 * It carries a directory's restraint — which board, which seat, when, and this seat's own
 * answer; deliberately no title, no location and no agenda, because a meeting's title is
 * content. It spans the account's OWN claimed seats only (CBG-SEC2; CBG-FIX17 subsumed), so
 * no officer can make anyone's schedule appear by seating an address; a board that asks for
 * confirmation before anything opens is left out while this sign-in's signing window is shut.
 */
export const boardDirectorOrgListBoardDirectorUpcomingMeetings = <ThrowOnError extends boolean = false>(options?: Options<BoardDirectorOrgListBoardDirectorUpcomingMeetingsData, ThrowOnError>): RequestResult<BoardDirectorOrgListBoardDirectorUpcomingMeetingsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<BoardDirectorOrgListBoardDirectorUpcomingMeetingsResponses, unknown, ThrowOnError>({ url: '/board-director/organizations/upcoming-meetings', ...options });

/**
 * Org Get Board About
 *
 * About the board, from its own records: who serves and in what role, the duties the board
 * recorded for its officers, its recorded meeting rules and next meeting, its governing documents
 * in force, and its minutes and written consents of the last twelve months. Nothing from a
 * closed session.
 */
export const boardDirectorOrgGetBoardAbout = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardAboutData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardAboutResponses, BoardDirectorOrgGetBoardAboutErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardAboutResponses, BoardDirectorOrgGetBoardAboutErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/about-the-board', ...options });

/**
 * Org Get Board Director Attention
 *
 * What is waiting for this director on this board.
 *
 * Three kinds share one list, each narrowable on its ``kind`` discriminator: an
 * unanswered meeting, a consent awaiting this seat's signature, and approved minutes
 * awaiting it. Only what this director can ACT on appears, so an empty list is an
 * honest "nothing is waiting".
 */
export const boardDirectorOrgGetBoardDirectorAttention = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardDirectorAttentionData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorAttentionResponses, BoardDirectorOrgGetBoardDirectorAttentionErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardDirectorAttentionResponses, BoardDirectorOrgGetBoardDirectorAttentionErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/attention', ...options });

/**
 * Org Get Board Director Attention Completed
 *
 * What you did on this board in the last 90 days, newest first: written consents you signed,
 * minutes you signed, meetings you answered for, questionnaires and self-assessments you
 * answered, copies of the return you opened. Your own acts only, scoped as what waits for you
 * is: a closed session's minutes only once you've confirmed it's you.
 */
export const boardDirectorOrgGetBoardDirectorAttentionCompleted = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardDirectorAttentionCompletedData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorAttentionCompletedResponses, BoardDirectorOrgGetBoardDirectorAttentionCompletedErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardDirectorAttentionCompletedResponses, BoardDirectorOrgGetBoardDirectorAttentionCompletedErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/attention/completed', ...options });

/**
 * Org List Own Board Coi Cycles
 *
 * The years you were asked for your conflict-of-interest answers on this board, newest
 * first, with your own answers where you've sent them.
 */
export const boardDirectorOrgListOwnBoardCoiCycles = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgListOwnBoardCoiCyclesData, ThrowOnError>): RequestResult<BoardDirectorOrgListOwnBoardCoiCyclesResponses, BoardDirectorOrgListOwnBoardCoiCyclesErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgListOwnBoardCoiCyclesResponses, BoardDirectorOrgListOwnBoardCoiCyclesErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/coi-cycles', ...options });

/**
 * Org Get Own Board Coi Questionnaire
 *
 * Your questionnaire for the year: the questions as you're asked them, your board's policy,
 * your answers from last year filled in, and the single disclosures you've made since.
 */
export const boardDirectorOrgGetOwnBoardCoiQuestionnaire = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetOwnBoardCoiQuestionnaireData, ThrowOnError>): RequestResult<BoardDirectorOrgGetOwnBoardCoiQuestionnaireResponses, BoardDirectorOrgGetOwnBoardCoiQuestionnaireErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetOwnBoardCoiQuestionnaireResponses, BoardDirectorOrgGetOwnBoardCoiQuestionnaireErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/coi-cycles/{cycle_id}/questionnaire', ...options });

/**
 * Org Get Own Board Coi Response
 *
 * Your answers for the year as recorded, with any correction you've made.
 */
export const boardDirectorOrgGetOwnBoardCoiResponse = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetOwnBoardCoiResponseData, ThrowOnError>): RequestResult<BoardDirectorOrgGetOwnBoardCoiResponseResponses, BoardDirectorOrgGetOwnBoardCoiResponseErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetOwnBoardCoiResponseResponses, BoardDirectorOrgGetOwnBoardCoiResponseErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/coi-cycles/{cycle_id}/response', ...options });

/**
 * Org Submit Own Board Coi Response
 *
 * Sign your answers for the year. A signature-class act: it needs your signing window open,
 * and `intent_statement_id` echoes the words beside Sign (a stale id is a typed 409). Your
 * signed answers become your disclosure in the board's records, in place of last year's.
 * `corrects_record_id` adds a correction beside answers you've already signed.
 */
export const boardDirectorOrgSubmitOwnBoardCoiResponse = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgSubmitOwnBoardCoiResponseData, ThrowOnError>): RequestResult<BoardDirectorOrgSubmitOwnBoardCoiResponseResponses, BoardDirectorOrgSubmitOwnBoardCoiResponseErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgSubmitOwnBoardCoiResponseResponses, BoardDirectorOrgSubmitOwnBoardCoiResponseErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/coi-cycles/{cycle_id}/response',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Own Board Coi Response Changes
 *
 * Your answers for the year against your answers from the year before, question by
 * question.
 */
export const boardDirectorOrgGetOwnBoardCoiResponseChanges = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetOwnBoardCoiResponseChangesData, ThrowOnError>): RequestResult<BoardDirectorOrgGetOwnBoardCoiResponseChangesResponses, BoardDirectorOrgGetOwnBoardCoiResponseChangesErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetOwnBoardCoiResponseChangesResponses, BoardDirectorOrgGetOwnBoardCoiResponseChangesErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/coi-cycles/{cycle_id}/response/changes', ...options });

/**
 * Org Get Own Board Coi Response Document
 *
 * Your copy of your answers for the year, as a PDF: as recorded, or the changes from the
 * year before.
 */
export const boardDirectorOrgGetOwnBoardCoiResponseDocument = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetOwnBoardCoiResponseDocumentData, ThrowOnError>): RequestResult<BoardDirectorOrgGetOwnBoardCoiResponseDocumentResponses, BoardDirectorOrgGetOwnBoardCoiResponseDocumentErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetOwnBoardCoiResponseDocumentResponses, BoardDirectorOrgGetOwnBoardCoiResponseDocumentErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/coi-cycles/{cycle_id}/response/document', ...options });

/**
 * Org List Own Board Conflict Disclosures
 *
 * Your own recorded disclosures on this board — what the book says about you.
 *
 * Never another director's: the seat is the one your account claimed, and this route takes
 * no id that could name someone else. `status` on each entry says whether it still stands
 * or a later disclosure of yours replaced it.
 */
export const boardDirectorOrgListOwnBoardConflictDisclosures = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgListOwnBoardConflictDisclosuresData, ThrowOnError>): RequestResult<BoardDirectorOrgListOwnBoardConflictDisclosuresResponses, BoardDirectorOrgListOwnBoardConflictDisclosuresErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgListOwnBoardConflictDisclosuresResponses, BoardDirectorOrgListOwnBoardConflictDisclosuresErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/conflict-disclosures', ...options });

/**
 * Org Record Own Board Conflict Disclosure
 *
 * Record your own conflict-of-interest disclosure.
 *
 * Describe the interest in your own words and, where there is one, name the counterparty
 * — the person or organization on the other side of it. The name is what lets the
 * recording officer be shown this disclosure beside an agenda item or motion that
 * mentions it, before the board votes.
 *
 * A signature-class act: it needs the director's signing window, for the same reason a
 * consent signature does. Without it the answer is the typed 400
 * `board_director_signing_required` the console turns into its confirm sheet, never a 401.
 * `intent_statement_id` echoes the words beside the button.
 *
 * `supersedes_record_id` records that your position has CHANGED — the earlier disclosure
 * stays an accurate record of what was true at its time, which is usually what you mean.
 * `corrects_record_id` records that the earlier one was wrong.
 *
 * Recording this does not decide anything: whether you stand out of a vote is the
 * board's determination, recorded in the minutes as a recusal.
 */
export const boardDirectorOrgRecordOwnBoardConflictDisclosure = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgRecordOwnBoardConflictDisclosureData, ThrowOnError>): RequestResult<BoardDirectorOrgRecordOwnBoardConflictDisclosureResponses, BoardDirectorOrgRecordOwnBoardConflictDisclosureErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgRecordOwnBoardConflictDisclosureResponses, BoardDirectorOrgRecordOwnBoardConflictDisclosureErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/conflict-disclosures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Own Board Getting Started
 *
 * Your getting-started list on this board: the documents to read and confirm, your first
 * conflict-of-interest disclosure, the board's own steps, and your board buddy.
 */
export const boardDirectorOrgGetOwnBoardGettingStarted = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetOwnBoardGettingStartedData, ThrowOnError>): RequestResult<BoardDirectorOrgGetOwnBoardGettingStartedResponses, BoardDirectorOrgGetOwnBoardGettingStartedErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetOwnBoardGettingStartedResponses, BoardDirectorOrgGetOwnBoardGettingStartedErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/getting-started', ...options });

/**
 * Org Mark Own Board Getting Started Step
 *
 * Mark one of your board's steps on your list done, with the date, or clear it.
 */
export const boardDirectorOrgMarkOwnBoardGettingStartedStep = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgMarkOwnBoardGettingStartedStepData, ThrowOnError>): RequestResult<BoardDirectorOrgMarkOwnBoardGettingStartedStepResponses, BoardDirectorOrgMarkOwnBoardGettingStartedStepErrors, ThrowOnError> => (options.client ?? client).put<BoardDirectorOrgMarkOwnBoardGettingStartedStepResponses, BoardDirectorOrgMarkOwnBoardGettingStartedStepErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/getting-started/items/{item_id}/done',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Director Meetings
 *
 * This board's meetings, soonest first, with this seat's own answer on each.
 *
 * Defaults to upcoming only: a director opening the surface is looking at what is ahead.
 * Past meetings are available by asking for them.
 */
export const boardDirectorOrgListBoardDirectorMeetings = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgListBoardDirectorMeetingsData, ThrowOnError>): RequestResult<BoardDirectorOrgListBoardDirectorMeetingsResponses, BoardDirectorOrgListBoardDirectorMeetingsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgListBoardDirectorMeetingsResponses, BoardDirectorOrgListBoardDirectorMeetingsErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/meetings', ...options });

/**
 * Org Get Board Director Meeting
 *
 * One meeting, with its agenda and the current published packet's id.
 *
 * The notice block is included: it is the charity's own recorded parameter and the
 * arithmetic against it, and the sentence names the section the charity attributed the
 * period to — so a director can read it against the instrument themselves rather than
 * take the product's word for anything.
 */
export const boardDirectorOrgGetBoardDirectorMeeting = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardDirectorMeetingData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorMeetingResponses, BoardDirectorOrgGetBoardDirectorMeetingErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardDirectorMeetingResponses, BoardDirectorOrgGetBoardDirectorMeetingErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/meetings/{meeting_id}', ...options });

/**
 * Org Record Board Director Attendance Intent
 *
 * Answer whether this director expects to attend.
 *
 * Rides the account's sign-in and needs no signing window: how strongly a director must
 * confirm it's them is tiered by the weight of the act, and an answer about attendance
 * binds nobody to anything. A vote, a written consent, or e-signing minutes does need one.
 *
 * A PUT because there is one current answer per director per meeting; changing it
 * replaces it, and when the answer was FIRST given is kept either way.
 */
export const boardDirectorOrgRecordBoardDirectorAttendanceIntent = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgRecordBoardDirectorAttendanceIntentData, ThrowOnError>): RequestResult<BoardDirectorOrgRecordBoardDirectorAttendanceIntentResponses, BoardDirectorOrgRecordBoardDirectorAttendanceIntentErrors, ThrowOnError> => (options.client ?? client).put<BoardDirectorOrgRecordBoardDirectorAttendanceIntentResponses, BoardDirectorOrgRecordBoardDirectorAttendanceIntentErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/meetings/{meeting_id}/attendance-intent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Director Meeting Calendar
 *
 * The meeting as an iCalendar file, for the director's own calendar.
 */
export const boardDirectorOrgGetBoardDirectorMeetingCalendar = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardDirectorMeetingCalendarData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorMeetingCalendarResponses, BoardDirectorOrgGetBoardDirectorMeetingCalendarErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardDirectorMeetingCalendarResponses, BoardDirectorOrgGetBoardDirectorMeetingCalendarErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/meetings/{meeting_id}/calendar', ...options });

/**
 * Org Sign Board Minutes
 *
 * Sign approved minutes.
 *
 * A signature-class act: it needs the director's signing window open (CBG-SEC2), and the
 * factor that opened it, when it was confirmed and the words affirmed are recorded beside
 * the signature. Reading and answering an invitation do not — the weight of the act sets the
 * bar. `intent_statement_id` echoes the words beside the button; a stale id is a typed 409.
 *
 * `content_hash` is the address of the exact minutes being signed. If they changed since
 * they were read, the signature is refused rather than attached to different words.
 *
 * `capacity_title_id` (optional) records the title this person signs as: one of the titles
 * their seat holds now, kept with the signature in the words it has today. A title the seat
 * doesn't hold is a 409 `board_signature_capacity_not_held`.
 *
 * A signature follows the board's approval; minutes still in draft cannot be signed.
 */
export const boardDirectorOrgSignBoardMinutes = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgSignBoardMinutesData, ThrowOnError>): RequestResult<BoardDirectorOrgSignBoardMinutesResponses, BoardDirectorOrgSignBoardMinutesErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgSignBoardMinutesResponses, BoardDirectorOrgSignBoardMinutesErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/meetings/{meeting_id}/minutes/signature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Director Meeting Record
 *
 * What the charity recorded about one meeting, as this director may see it.
 *
 * Who was present, the parts of the meeting, and the motions with their recorded votes,
 * recusals, and the quorum figures taken at each — plus this seat's own votes and recusals,
 * so a director can see what the book says about them without reading every motion.
 *
 * A closed session this director was not part of is absent, and so is everything recorded
 * inside it. Nothing on the wire counts what was withheld.
 */
export const boardDirectorOrgGetBoardDirectorMeetingRecord = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardDirectorMeetingRecordData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorMeetingRecordResponses, BoardDirectorOrgGetBoardDirectorMeetingRecordErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardDirectorMeetingRecordResponses, BoardDirectorOrgGetBoardDirectorMeetingRecordErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/meetings/{meeting_id}/record', ...options });

/**
 * Org Get Board Director Packet
 *
 * One published packet version, and a recorded open for the chair's view.
 *
 * A version still being assembled answers exactly as a missing one does — a director
 * reads what the board was sent. An entry pointing at a closed session this director was
 * not part of is absent from the entries. The open is recorded only after the read is
 * allowed, so the chair's view never shows something that did not happen.
 */
export const boardDirectorOrgGetBoardDirectorPacket = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardDirectorPacketData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorPacketResponses, BoardDirectorOrgGetBoardDirectorPacketErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardDirectorPacketResponses, BoardDirectorOrgGetBoardDirectorPacketErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/packets/{packet_id}', ...options });

/**
 * Org List Board Director Annotations
 *
 * This director's own notes plus every board-visible comment on this version.
 *
 * Another director's personal note is absent, not refused, so the list cannot be used to
 * learn that one exists.
 */
export const boardDirectorOrgListBoardDirectorAnnotations = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgListBoardDirectorAnnotationsData, ThrowOnError>): RequestResult<BoardDirectorOrgListBoardDirectorAnnotationsResponses, BoardDirectorOrgListBoardDirectorAnnotationsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgListBoardDirectorAnnotationsResponses, BoardDirectorOrgListBoardDirectorAnnotationsErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/packets/{packet_id}/annotations', ...options });

/**
 * Org Create Board Director Annotation
 *
 * Write a note on this packet version, or on one of its entries.
 *
 * `visibility` has no default: a personal note and something the whole board will read
 * are different things, and choosing between them is the director's to make explicitly.
 * A personal note is readable by this seat and by nobody else — not another director, and
 * not the charity's own administrators.
 */
export const boardDirectorOrgCreateBoardDirectorAnnotation = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgCreateBoardDirectorAnnotationData, ThrowOnError>): RequestResult<BoardDirectorOrgCreateBoardDirectorAnnotationResponses, BoardDirectorOrgCreateBoardDirectorAnnotationErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgCreateBoardDirectorAnnotationResponses, BoardDirectorOrgCreateBoardDirectorAnnotationErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/packets/{packet_id}/annotations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Delete Board Director Annotation
 *
 * Delete one of this director's own notes.
 *
 * Naming another director's note answers exactly as naming one that does not exist.
 * There is no edit: a comment the rest of the board has read must not change under them,
 * and a personal note costs nothing to write again.
 */
export const boardDirectorOrgDeleteBoardDirectorAnnotation = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgDeleteBoardDirectorAnnotationData, ThrowOnError>): RequestResult<BoardDirectorOrgDeleteBoardDirectorAnnotationResponses, BoardDirectorOrgDeleteBoardDirectorAnnotationErrors, ThrowOnError> => (options.client ?? client).delete<BoardDirectorOrgDeleteBoardDirectorAnnotationResponses, BoardDirectorOrgDeleteBoardDirectorAnnotationErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/packets/{packet_id}/annotations/{annotation_id}', ...options });

/**
 * Org Get Board Director Packet Document Download Url
 *
 * A short-lived read URL for one attachment in this packet version.
 *
 * Reachable only because the attachment is IN a packet this director may read. An
 * attachment uploaded against the meeting but never placed in a published version is not
 * something the board was sent, so it answers as absent.
 */
export const boardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlResponses, BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlResponses, BoardDirectorOrgGetBoardDirectorPacketDocumentDownloadUrlErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/packets/{packet_id}/documents/{document_id}/download-url', ...options });

/**
 * Org Get Board Director Filing Receipt Download Url
 *
 * Authorize this seat to the exact published snapshot before a URL is signed.
 */
export const boardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlResponses, BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlResponses, BoardDirectorOrgGetBoardDirectorFilingReceiptDownloadUrlErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/packets/{packet_id}/items/{packet_item_id}/filing-receipts/{artifact_id}/download-url', ...options });

/**
 * Org List Board Director Records
 *
 * This board's records, scoped to what this director may read.
 *
 * A closed session the director did not attend is ABSENT from the page and from
 * `meta.total` — scoped together in SQL, so an offset walk cannot map the number or
 * position of the records withheld.
 */
export const boardDirectorOrgListBoardDirectorRecords = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgListBoardDirectorRecordsData, ThrowOnError>): RequestResult<BoardDirectorOrgListBoardDirectorRecordsResponses, BoardDirectorOrgListBoardDirectorRecordsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgListBoardDirectorRecordsResponses, BoardDirectorOrgListBoardDirectorRecordsErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/records', ...options });

/**
 * Org Get Board Director Record
 *
 * One record, and a recorded open for the chair's engagement view.
 *
 * A record this director may not read answers exactly as a record that does not exist
 * does, and the open is recorded only after the read is allowed.
 */
export const boardDirectorOrgGetBoardDirectorRecord = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardDirectorRecordData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorRecordResponses, BoardDirectorOrgGetBoardDirectorRecordErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardDirectorRecordResponses, BoardDirectorOrgGetBoardDirectorRecordErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/records/{record_id}', ...options });

/**
 * Org Acknowledge Board Record
 *
 * Record this director's acknowledgment of a record — a signature-class act.
 *
 * Needs the director's signing window open (their passkey, or on an account with no passkey
 * their authenticator app, confirmed in this sign-in within the hour); without it the answer
 * is the typed 400 `board_director_signing_required` the console turns into its confirm
 * sheet, never a 401 that would read as "sign in again".
 *
 * `content_hash` is a required echo of what the director read: the act's whole value is
 * that it names the exact bytes a human saw, so a mismatch is refused rather than
 * recorded. `intent_statement_id` echoes the words beside the button (`/me` lists the
 * current ones); a stale id is a typed 409. The response carries the recorded capture back —
 * which seat, what identity it asserted, the factor that opened the window and when it was
 * confirmed, the words affirmed, and when the act happened.
 */
export const boardDirectorOrgAcknowledgeBoardRecord = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgAcknowledgeBoardRecordData, ThrowOnError>): RequestResult<BoardDirectorOrgAcknowledgeBoardRecordResponses, BoardDirectorOrgAcknowledgeBoardRecordErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgAcknowledgeBoardRecordResponses, BoardDirectorOrgAcknowledgeBoardRecordErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/records/{record_id}/acknowledgment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Sign Board Minutes To Approve
 *
 * Sign to approve a closed session's minutes, as one of the directors who were in it.
 *
 * Only where the board's rule approves a closed session's minutes by the signatures of the
 * directors who were there, and only for a director its open request asked: the seat recorded as
 * in the session whose account it was at the meeting's start. Anyone else gets the not-found, as
 * a record that does not exist does. A signature-class act: it needs the director's signing
 * window, and records the factor, when it was confirmed and the words affirmed
 * (`intent_statement_id`; a stale id is a typed 409). `content_hash` is the bytes read: minutes
 * that changed since are refused rather than signed. The last asked signature on the current
 * bytes approves the minutes (`approved`).
 */
export const boardDirectorOrgSignBoardMinutesToApprove = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgSignBoardMinutesToApproveData, ThrowOnError>): RequestResult<BoardDirectorOrgSignBoardMinutesToApproveResponses, BoardDirectorOrgSignBoardMinutesToApproveErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgSignBoardMinutesToApproveResponses, BoardDirectorOrgSignBoardMinutesToApproveErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/records/{record_id}/approval-signature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Return Copy For Director
 *
 * A copy of the organization's return provided to the board: the tax year, who provided it
 * and when, the file's name, size and pages, when you opened it, and your recorded reading of
 * it. Nothing about anyone else.
 */
export const boardDirectorOrgGetBoardReturnCopyForDirector = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardReturnCopyForDirectorData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardReturnCopyForDirectorResponses, BoardDirectorOrgGetBoardReturnCopyForDirectorErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardReturnCopyForDirectorResponses, BoardDirectorOrgGetBoardReturnCopyForDirectorErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/return-distributions/{record_id}', ...options });

/**
 * Org Open Board Return Copy For Director
 *
 * A link to open the copy, valid for 15 minutes. If it was sent to you, the first time you
 * open it is recorded first, so the board can see you received it.
 */
export const boardDirectorOrgOpenBoardReturnCopyForDirector = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgOpenBoardReturnCopyForDirectorData, ThrowOnError>): RequestResult<BoardDirectorOrgOpenBoardReturnCopyForDirectorResponses, BoardDirectorOrgOpenBoardReturnCopyForDirectorErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgOpenBoardReturnCopyForDirectorResponses, BoardDirectorOrgOpenBoardReturnCopyForDirectorErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/return-distributions/{record_id}/copy-url', ...options });

/**
 * Org Start Board Seat Move
 *
 * Start moving your seat on this board to another of your Givmo accounts.
 *
 * Answers a single-use ticket, ONCE, for this page to keep in its own tab — never in an
 * address or a mail — with when it stops working (30 minutes) and the seat's address,
 * masked. The ticket is the move's first proof: this account, which holds the seat, was
 * signed in when the move began. It moves nothing by itself: the move finishes signed in to
 * the other account, which proves the seat's address (its own confirmed email is that
 * address, or a code mailed there). Starting a move is capped per seat per day
 * (`board_seat_claim_code_throttled`).
 */
export const boardDirectorOrgStartBoardSeatMove = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgStartBoardSeatMoveData, ThrowOnError>): RequestResult<BoardDirectorOrgStartBoardSeatMoveResponses, BoardDirectorOrgStartBoardSeatMoveErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgStartBoardSeatMoveResponses, BoardDirectorOrgStartBoardSeatMoveErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/seat-moves', ...options });

/**
 * Org List Own Board Self Assessments
 *
 * The board's self-assessments you were asked to answer, newest first, with your own part in
 * each: whether you've answered, and whether the results are in.
 */
export const boardDirectorOrgListOwnBoardSelfAssessments = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgListOwnBoardSelfAssessmentsData, ThrowOnError>): RequestResult<BoardDirectorOrgListOwnBoardSelfAssessmentsResponses, BoardDirectorOrgListOwnBoardSelfAssessmentsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgListOwnBoardSelfAssessmentsResponses, BoardDirectorOrgListOwnBoardSelfAssessmentsErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/self-assessments', ...options });

/**
 * Org Save Own Board Self Assessment Answers
 *
 * Send your answers. They replace your earlier ones until the self-assessment closes, and
 * stay private to you: the board sees only the results, together and without names.
 */
export const boardDirectorOrgSaveOwnBoardSelfAssessmentAnswers = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersData, ThrowOnError>): RequestResult<BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersResponses, BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersErrors, ThrowOnError> => (options.client ?? client).put<BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersResponses, BoardDirectorOrgSaveOwnBoardSelfAssessmentAnswersErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/self-assessments/{assessment_id}/answers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Own Board Self Assessment Questions
 *
 * The self-assessment's statements, each with its source, and your own answers while it's
 * open. No one else sees your answers.
 */
export const boardDirectorOrgGetOwnBoardSelfAssessmentQuestions = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsData, ThrowOnError>): RequestResult<BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsResponses, BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsResponses, BoardDirectorOrgGetOwnBoardSelfAssessmentQuestionsErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/self-assessments/{assessment_id}/questions', ...options });

/**
 * Org Get Board Self Assessment Results For Director
 *
 * A closed self-assessment's results: how many people chose each answer and the comments
 * without names, or, with fewer than three answers, only how many were asked and answered.
 */
export const boardDirectorOrgGetBoardSelfAssessmentResultsForDirector = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorResponses, BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorResponses, BoardDirectorOrgGetBoardSelfAssessmentResultsForDirectorErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/self-assessments/{assessment_id}/results', ...options });

/**
 * Org List Board Director Consents
 *
 * The consents this director is being asked to sign.
 *
 * Scoped to the roster the consent currently before the board went out to, so a
 * consent this director was not asked to sign is ABSENT — from the page and from
 * `meta.total` together.
 */
export const boardDirectorOrgListBoardDirectorConsents = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgListBoardDirectorConsentsData, ThrowOnError>): RequestResult<BoardDirectorOrgListBoardDirectorConsentsResponses, BoardDirectorOrgListBoardDirectorConsentsErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgListBoardDirectorConsentsResponses, BoardDirectorOrgListBoardDirectorConsentsErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/written-consents', ...options });

/**
 * Org Get Board Director Consent
 *
 * One consent, with its full text and this director's own standing.
 *
 * `content_hash` is the address of the text shown here, and it is what a signature has
 * to echo — so a director who signs is signing exactly what they were shown.
 */
export const boardDirectorOrgGetBoardDirectorConsent = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardDirectorConsentData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardDirectorConsentResponses, BoardDirectorOrgGetBoardDirectorConsentErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardDirectorConsentResponses, BoardDirectorOrgGetBoardDirectorConsentErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/written-consents/{consent_id}', ...options });

/**
 * Org Get Board Compensation Document Download For Director
 *
 * A short-lived link to read one document a consent's compensation details name, for anyone
 * on the board's roster once the consent has gone out — so each document the text names can be
 * opened before signing. Made for this request and never stored.
 */
export const boardDirectorOrgGetBoardCompensationDocumentDownloadForDirector = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorData, ThrowOnError>): RequestResult<BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorResponses, BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorErrors, ThrowOnError> => (options.client ?? client).get<BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorResponses, BoardDirectorOrgGetBoardCompensationDocumentDownloadForDirectorErrors, ThrowOnError>({ url: '/board-director/organizations/{org_ref}/written-consents/{consent_id}/compensation-decisions/{decision_id}/documents/{document_id}/download', ...options });

/**
 * Org Sign Board Written Consent
 *
 * Sign the consent.
 *
 * Needs the director's signing window open; without it the answer is the typed 400
 * `board_director_signing_required` the console turns into its confirm sheet.
 * `intent_statement_id` echoes the words beside the button; a stale id is a typed 409.
 *
 * `content_hash` is a required echo of the text this director read, so a signature can
 * never land on text that changed after they read it. If this is the last outstanding
 * signature, the same request records the consent in the charity's board records.
 */
export const boardDirectorOrgSignBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgSignBoardWrittenConsentData, ThrowOnError>): RequestResult<BoardDirectorOrgSignBoardWrittenConsentResponses, BoardDirectorOrgSignBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgSignBoardWrittenConsentResponses, BoardDirectorOrgSignBoardWrittenConsentErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/written-consents/{consent_id}/signature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Revoke Board Written Consent Signature
 *
 * Withdraw a signature already given, while the consent is still pending.
 *
 * A director who has second thoughts sends the matter to a meeting instead, and this
 * is how. It is appended as its own act — the signature it withdraws stays in the
 * record — and it needs the signing window for the same reason giving the signature did.
 *
 * Once the consent has been signed by every seat it went out to, it is the board's act
 * and this is no longer available.
 */
export const boardDirectorOrgRevokeBoardWrittenConsentSignature = <ThrowOnError extends boolean = false>(options: Options<BoardDirectorOrgRevokeBoardWrittenConsentSignatureData, ThrowOnError>): RequestResult<BoardDirectorOrgRevokeBoardWrittenConsentSignatureResponses, BoardDirectorOrgRevokeBoardWrittenConsentSignatureErrors, ThrowOnError> => (options.client ?? client).post<BoardDirectorOrgRevokeBoardWrittenConsentSignatureResponses, BoardDirectorOrgRevokeBoardWrittenConsentSignatureErrors, ThrowOnError>({
    url: '/board-director/organizations/{org_ref}/written-consents/{consent_id}/signature-withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Director Upcoming Meetings
 *
 * Upcoming meetings across every board this account holds a claimed seat on.
 *
 * It carries a directory's restraint — which board, which seat, when, and this seat's own
 * answer; deliberately no title, no location and no agenda, because a meeting's title is
 * content. It spans the account's OWN claimed seats only (CBG-SEC2; CBG-FIX17 subsumed), so
 * no officer can make anyone's schedule appear by seating an address; a board that asks for
 * confirmation before anything opens is left out while this sign-in's signing window is shut.
 */
export const boardDirectorListBoardDirectorUpcomingMeetings = <ThrowOnError extends boolean = false>(options?: Options<BoardDirectorListBoardDirectorUpcomingMeetingsData, ThrowOnError>): RequestResult<BoardDirectorListBoardDirectorUpcomingMeetingsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<BoardDirectorListBoardDirectorUpcomingMeetingsResponses, unknown, ThrowOnError>({ url: '/board-director/upcoming-meetings', ...options });

/**
 * Org List Board Agenda Templates
 *
 * The neutral agenda templates a charity may select.
 *
 * Structural sections only. Nothing in a template is drawn from any charity's own
 * documents, calendar, or history, and nothing applies one — the charity names the
 * template it wants. `suggested_for` orders a human's picker and is read by nothing.
 */
export const orgBoardOrgListBoardAgendaTemplates = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardAgendaTemplatesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardAgendaTemplatesResponses, OrgBoardOrgListBoardAgendaTemplatesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardAgendaTemplatesResponses, OrgBoardOrgListBoardAgendaTemplatesErrors, ThrowOnError>({ url: '/board/{org_ref}/agenda-templates', ...options });

/**
 * Org List Board Calendar Connections
 *
 * Every calendar connected for the board, with the upcoming meetings each one sends (the
 * handover view), in the canonical `{data, meta, links}` envelope.
 */
export const orgBoardOrgListBoardCalendarConnections = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardCalendarConnectionsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardCalendarConnectionsResponses, OrgBoardOrgListBoardCalendarConnectionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardCalendarConnectionsResponses, OrgBoardOrgListBoardCalendarConnectionsErrors, ThrowOnError>({ url: '/board/{org_ref}/calendar/connections', ...options });

/**
 * Org Move Board Calendar Meetings
 *
 * Move every upcoming meeting one calendar sends to another sender in one act (directors
 * get one cancellation and one new invitation each), or stop keeping them in step.
 */
export const orgBoardOrgMoveBoardCalendarMeetings = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgMoveBoardCalendarMeetingsData, ThrowOnError>): RequestResult<OrgBoardOrgMoveBoardCalendarMeetingsResponses, OrgBoardOrgMoveBoardCalendarMeetingsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgMoveBoardCalendarMeetingsResponses, OrgBoardOrgMoveBoardCalendarMeetingsErrors, ThrowOnError>({
    url: '/board/{org_ref}/calendar/moves',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Calendar Senders
 *
 * Who can send this charity's meeting invitations, in order: the officer's own connected
 * calendar, then the board account — and whether the officer can connect their own calendar
 * here.
 */
export const orgBoardOrgListBoardCalendarSenders = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardCalendarSendersData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardCalendarSendersResponses, OrgBoardOrgListBoardCalendarSendersErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardCalendarSendersResponses, OrgBoardOrgListBoardCalendarSendersErrors, ThrowOnError>({ url: '/board/{org_ref}/calendar/senders', ...options });

/**
 * Org Get Board Calendar Settings
 *
 * The board's calendar settings: whether directors may change a meeting's details in
 * their calendar, propose new times and see the guest list, and whether invitations use the
 * meetings' own titles. The shipped defaults until an Owner adopts settings.
 */
export const orgBoardOrgGetBoardCalendarSettings = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCalendarSettingsData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCalendarSettingsResponses, OrgBoardOrgGetBoardCalendarSettingsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCalendarSettingsResponses, OrgBoardOrgGetBoardCalendarSettingsErrors, ThrowOnError>({ url: '/board/{org_ref}/calendar/settings', ...options });

/**
 * Org Adopt Board Calendar Settings
 *
 * Adopt the board's calendar settings (all four). They apply to meetings sent from now
 * on; "Apply to upcoming meetings" applies them to meetings already sent.
 */
export const orgBoardOrgAdoptBoardCalendarSettings = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgAdoptBoardCalendarSettingsData, ThrowOnError>): RequestResult<OrgBoardOrgAdoptBoardCalendarSettingsResponses, OrgBoardOrgAdoptBoardCalendarSettingsErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgAdoptBoardCalendarSettingsResponses, OrgBoardOrgAdoptBoardCalendarSettingsErrors, ThrowOnError>({
    url: '/board/{org_ref}/calendar/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Apply Board Calendar Settings
 *
 * Apply the board's calendar settings to every upcoming meeting already sent from a
 * connected calendar.
 */
export const orgBoardOrgApplyBoardCalendarSettings = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgApplyBoardCalendarSettingsData, ThrowOnError>): RequestResult<OrgBoardOrgApplyBoardCalendarSettingsResponses, OrgBoardOrgApplyBoardCalendarSettingsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgApplyBoardCalendarSettingsResponses, OrgBoardOrgApplyBoardCalendarSettingsErrors, ThrowOnError>({ url: '/board/{org_ref}/calendar/settings/application', ...options });

/**
 * Org List Board Carry Forward Items
 *
 * Prior meetings' agenda items the charity marked as left open.
 *
 * Exactly what the charity marked, and nothing else. An item nobody dispositioned does
 * not appear here — deciding on the charity's behalf that a past item is unfinished
 * business would be the module making a governance judgment.
 */
export const orgBoardOrgListBoardCarryForwardItems = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardCarryForwardItemsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardCarryForwardItemsResponses, OrgBoardOrgListBoardCarryForwardItemsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardCarryForwardItemsResponses, OrgBoardOrgListBoardCarryForwardItemsErrors, ThrowOnError>({ url: '/board/{org_ref}/carry-forward-items', ...options });

/**
 * Org List Board Carry Forward Motions
 *
 * Motions from past meetings that are still before the board.
 *
 * The companion of the carry-forward agenda items on the meetings surface: together they
 * are what an officer building the next agenda needs to see. Both report only what the
 * charity itself left open — a motion nobody withdrew and nobody voted on — and neither
 * infers that anything else is unfinished business.
 *
 * A motion made inside a closed session this reader was not part of does not appear.
 */
export const orgBoardOrgListBoardCarryForwardMotions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardCarryForwardMotionsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardCarryForwardMotionsResponses, OrgBoardOrgListBoardCarryForwardMotionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardCarryForwardMotionsResponses, OrgBoardOrgListBoardCarryForwardMotionsErrors, ThrowOnError>({ url: '/board/{org_ref}/carry-forward-motions', ...options });

/**
 * Org List Board Coi Cycles
 *
 * Every year's annual disclosures, newest first: each one's dates, status and count of
 * submissions (never a count of conflicts).
 */
export const orgBoardOrgListBoardCoiCycles = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardCoiCyclesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardCoiCyclesResponses, OrgBoardOrgListBoardCoiCyclesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardCoiCyclesResponses, OrgBoardOrgListBoardCoiCyclesErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-cycles', ...options });

/**
 * Org Open Board Coi Cycle
 *
 * Start a year's annual conflict-of-interest disclosures: everyone on the roster is asked,
 * with Givmo's starting questionnaire (any question turned off) and the organization's own
 * policy from Governance, if it holds one. Each person is emailed the request; a seat no
 * account has joined gets an invitation to join with it.
 */
export const orgBoardOrgOpenBoardCoiCycle = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgOpenBoardCoiCycleData, ThrowOnError>): RequestResult<OrgBoardOrgOpenBoardCoiCycleResponses, OrgBoardOrgOpenBoardCoiCycleErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgOpenBoardCoiCycleResponses, OrgBoardOrgOpenBoardCoiCycleErrors, ThrowOnError>({
    url: '/board/{org_ref}/coi-cycles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Coi Cycle
 *
 * One year's annual disclosures: who was asked, who has submitted and when, what was sent
 * and when, and who can be reminded now.
 */
export const orgBoardOrgGetBoardCoiCycle = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCoiCycleData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCoiCycleResponses, OrgBoardOrgGetBoardCoiCycleErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCoiCycleResponses, OrgBoardOrgGetBoardCoiCycleErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-cycles/{cycle_id}', ...options });

/**
 * Org Update Board Coi Cycle
 *
 * Change an open year's due date. Recorded in the year's log; sends nothing.
 */
export const orgBoardOrgUpdateBoardCoiCycle = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardCoiCycleData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardCoiCycleResponses, OrgBoardOrgUpdateBoardCoiCycleErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardCoiCycleResponses, OrgBoardOrgUpdateBoardCoiCycleErrors, ThrowOnError>({
    url: '/board/{org_ref}/coi-cycles/{cycle_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Cancel Board Coi Cycle
 *
 * Withdraw a year opened by mistake, before anyone has answered. Nothing is added to the
 * minute book.
 */
export const orgBoardOrgCancelBoardCoiCycle = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCancelBoardCoiCycleData, ThrowOnError>): RequestResult<OrgBoardOrgCancelBoardCoiCycleResponses, OrgBoardOrgCancelBoardCoiCycleErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCancelBoardCoiCycleResponses, OrgBoardOrgCancelBoardCoiCycleErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-cycles/{cycle_id}/cancellation', ...options });

/**
 * Org Close Board Coi Cycle
 *
 * Close the year. Adds one record to the minute book: who was asked, and who submitted and
 * when. It names no one's interests. Anyone who hasn't submitted can still send their answers
 * afterwards; theirs are recorded as received after the year closed.
 */
export const orgBoardOrgCloseBoardCoiCycle = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCloseBoardCoiCycleData, ThrowOnError>): RequestResult<OrgBoardOrgCloseBoardCoiCycleResponses, OrgBoardOrgCloseBoardCoiCycleErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCloseBoardCoiCycleResponses, OrgBoardOrgCloseBoardCoiCycleErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-cycles/{cycle_id}/close', ...options });

/**
 * Org Get Board Coi Cycle Document
 *
 * Every response submitted for the year, in one PDF.
 */
export const orgBoardOrgGetBoardCoiCycleDocument = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCoiCycleDocumentData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCoiCycleDocumentResponses, OrgBoardOrgGetBoardCoiCycleDocumentErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCoiCycleDocumentResponses, OrgBoardOrgGetBoardCoiCycleDocumentErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-cycles/{cycle_id}/document', ...options });

/**
 * Org Get Board Coi Paper Form
 *
 * A paper form for one person to fill in and sign: the year's questions as they're asked
 * them, with their answers from last year where there are any.
 */
export const orgBoardOrgGetBoardCoiPaperForm = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCoiPaperFormData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCoiPaperFormResponses, OrgBoardOrgGetBoardCoiPaperFormErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCoiPaperFormResponses, OrgBoardOrgGetBoardCoiPaperFormErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-cycles/{cycle_id}/paper-form', ...options });

/**
 * Org Get Board Coi Person Questionnaire
 *
 * One person's questionnaire for the year, for entering their signed paper form: the
 * questions as they're asked them, the board's policy, their answers from last year where there
 * are any, and whether a first answer can be recorded for them now (CBG-YR2-BE5).
 */
export const orgBoardOrgGetBoardCoiPersonQuestionnaire = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCoiPersonQuestionnaireData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCoiPersonQuestionnaireResponses, OrgBoardOrgGetBoardCoiPersonQuestionnaireErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCoiPersonQuestionnaireResponses, OrgBoardOrgGetBoardCoiPersonQuestionnaireErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-cycles/{cycle_id}/questionnaire', ...options });

/**
 * Org Remind Board Coi Cycle Recipients
 *
 * Remind people who haven't sent their answers yet. Each gets one email, at most once a day.
 * Reminders go only when you send them. Name the people in `board_member_ids`, or send null for
 * everyone who can be reminded now.
 */
export const orgBoardOrgRemindBoardCoiCycleRecipients = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemindBoardCoiCycleRecipientsData, ThrowOnError>): RequestResult<OrgBoardOrgRemindBoardCoiCycleRecipientsResponses, OrgBoardOrgRemindBoardCoiCycleRecipientsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRemindBoardCoiCycleRecipientsResponses, OrgBoardOrgRemindBoardCoiCycleRecipientsErrors, ThrowOnError>({
    url: '/board/{org_ref}/coi-cycles/{cycle_id}/reminders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Send Board Coi Cycle Requests
 *
 * Send the year's questionnaire to people who haven't been sent it — someone who joined the
 * board since it started, say. A seat that hasn't joined Board yet gets an invitation with it.
 * Name the people in `board_member_ids`, or send null for everyone it can go to.
 */
export const orgBoardOrgSendBoardCoiCycleRequests = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgSendBoardCoiCycleRequestsData, ThrowOnError>): RequestResult<OrgBoardOrgSendBoardCoiCycleRequestsResponses, OrgBoardOrgSendBoardCoiCycleRequestsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgSendBoardCoiCycleRequestsResponses, OrgBoardOrgSendBoardCoiCycleRequestsErrors, ThrowOnError>({
    url: '/board/{org_ref}/coi-cycles/{cycle_id}/requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Coi Paper Response
 *
 * Record a person's signed paper form. Their answers become their disclosure for the year,
 * recorded as entered by you from paper, with your note saying where it came from. Someone who
 * joined the board after the year started is added to it by this, with no email.
 */
export const orgBoardOrgRecordBoardCoiPaperResponse = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardCoiPaperResponseData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardCoiPaperResponseResponses, OrgBoardOrgRecordBoardCoiPaperResponseErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardCoiPaperResponseResponses, OrgBoardOrgRecordBoardCoiPaperResponseErrors, ThrowOnError>({
    url: '/board/{org_ref}/coi-cycles/{cycle_id}/responses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Coi Response
 *
 * One person's answers for the year, as recorded: every question as they were asked it, with
 * their answer, how it was signed or recorded, and its fingerprint.
 */
export const orgBoardOrgGetBoardCoiResponse = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCoiResponseData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCoiResponseResponses, OrgBoardOrgGetBoardCoiResponseErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCoiResponseResponses, OrgBoardOrgGetBoardCoiResponseErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-cycles/{cycle_id}/responses/{record_id}', ...options });

/**
 * Org Get Board Coi Response Changes
 *
 * One person's answers for the year against their answers from the year before, question by
 * question: what changed, what was added and what was removed, with both records' fingerprints.
 * Made from the two recorded disclosures; not itself a record.
 */
export const orgBoardOrgGetBoardCoiResponseChanges = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCoiResponseChangesData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCoiResponseChangesResponses, OrgBoardOrgGetBoardCoiResponseChangesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCoiResponseChangesResponses, OrgBoardOrgGetBoardCoiResponseChangesErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-cycles/{cycle_id}/responses/{record_id}/changes', ...options });

/**
 * Org Get Board Coi Response Document
 *
 * One person's answers for the year as a PDF: the answers as recorded, or the changes from
 * the year before. `time_zone` (an IANA name) sets the zone its times print in; UTC otherwise.
 */
export const orgBoardOrgGetBoardCoiResponseDocument = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCoiResponseDocumentData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCoiResponseDocumentResponses, OrgBoardOrgGetBoardCoiResponseDocumentErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCoiResponseDocumentResponses, OrgBoardOrgGetBoardCoiResponseDocumentErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-cycles/{cycle_id}/responses/{record_id}/document', ...options });

/**
 * Org List Board Coi Questionnaires
 *
 * Givmo's starting conflict-of-interest questionnaires this organization is offered: each
 * with its provenance, its IRS sources and the review-with-counsel line. A template, never a
 * statement that a questionnaire is required or sufficient.
 */
export const orgBoardOrgListBoardCoiQuestionnaires = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardCoiQuestionnairesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardCoiQuestionnairesResponses, OrgBoardOrgListBoardCoiQuestionnairesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardCoiQuestionnairesResponses, OrgBoardOrgListBoardCoiQuestionnairesErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-questionnaires', ...options });

/**
 * Org Get Board Coi Questionnaire
 *
 * One starting questionnaire with every question: its words, whom it is asked of (the
 * independence question is asked of directors only), the IRS text it is drawn from, and its
 * "What counts" lines.
 */
export const orgBoardOrgGetBoardCoiQuestionnaire = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCoiQuestionnaireData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCoiQuestionnaireResponses, OrgBoardOrgGetBoardCoiQuestionnaireErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCoiQuestionnaireResponses, OrgBoardOrgGetBoardCoiQuestionnaireErrors, ThrowOnError>({ url: '/board/{org_ref}/coi-questionnaires/{template_id}', ...options });

/**
 * Org List Board Committee Sources
 *
 * What a committee's establishment, its dissolution or a member's appointment may be linked
 * to: motions recorded as carried, executed written consents and records in the minute book,
 * each one you may read, the most recent first.
 */
export const orgBoardOrgListBoardCommitteeSources = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardCommitteeSourcesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardCommitteeSourcesResponses, OrgBoardOrgListBoardCommitteeSourcesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardCommitteeSourcesResponses, OrgBoardOrgListBoardCommitteeSourcesErrors, ThrowOnError>({ url: '/board/{org_ref}/committee-sources', ...options });

/**
 * Org List Board Committees
 *
 * Your board's committees: the ones that stand first, by name, then those dissolved, the
 * most recent first. Each carries its chair and, where your organization's type is asked,
 * your organization's answer about its authority to act for the board, as recorded.
 */
export const orgBoardOrgListBoardCommittees = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardCommitteesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardCommitteesResponses, OrgBoardOrgListBoardCommitteesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardCommitteesResponses, OrgBoardOrgListBoardCommitteesErrors, ThrowOnError>({ url: '/board/{org_ref}/committees', ...options });

/**
 * Org Create Board Committee
 *
 * Add a committee: its name, standing or ad hoc, when it was established and where that is
 * recorded. With `charter_form_id`, the committee keeps the form's id and holds the charter
 * label its name gives; its charter is then drafted from the form like any governing document.
 * No record is written here. A name an active committee already has is a 409
 * `board_committee_name_taken`.
 */
export const orgBoardOrgCreateBoardCommittee = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardCommitteeData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardCommitteeResponses, OrgBoardOrgCreateBoardCommitteeErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardCommitteeResponses, OrgBoardOrgCreateBoardCommitteeErrors, ThrowOnError>({
    url: '/board/{org_ref}/committees',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Committee
 *
 * One committee: its record, its members, its rules and where its acts are recorded, as far
 * as you may read them. Its charter is the committee charter recorded under its
 * `charter_label` (the governing documents read, by that label).
 */
export const orgBoardOrgGetBoardCommittee = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCommitteeData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCommitteeResponses, OrgBoardOrgGetBoardCommitteeErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCommitteeResponses, OrgBoardOrgGetBoardCommitteeErrors, ThrowOnError>({ url: '/board/{org_ref}/committees/{committee_id}', ...options });

/**
 * Org Update Board Committee
 *
 * Change a committee's name, kind, establishment date or where its establishment is
 * recorded. Send only what changes; `null` clears the date, and a `null` `recorded_in` makes
 * it your own entry. A renamed committee keeps its charter's label. A dissolved committee isn't
 * changed (409 `board_committee_dissolved`).
 */
export const orgBoardOrgUpdateBoardCommittee = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardCommitteeData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardCommitteeResponses, OrgBoardOrgUpdateBoardCommitteeErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardCommitteeResponses, OrgBoardOrgUpdateBoardCommitteeErrors, ThrowOnError>({
    url: '/board/{org_ref}/committees/{committee_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Link Board Committee Charter
 *
 * The committee charter a committee holds, by the label its versions are recorded under. No
 * record changes. A label another committee holds is a 409
 * `board_committee_charter_label_taken`.
 */
export const orgBoardOrgLinkBoardCommitteeCharter = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgLinkBoardCommitteeCharterData, ThrowOnError>): RequestResult<OrgBoardOrgLinkBoardCommitteeCharterResponses, OrgBoardOrgLinkBoardCommitteeCharterErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgLinkBoardCommitteeCharterResponses, OrgBoardOrgLinkBoardCommitteeCharterErrors, ThrowOnError>({
    url: '/board/{org_ref}/committees/{committee_id}/charter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Set Board Committee Confirmation
 *
 * Whether the committee's decisions are suggested for the board's next meeting, and where the
 * organization wrote that practice down. Recorded in the committee's history, and reversible;
 * turning it off clears where it is written. Nothing waits on it: a committee's decisions stand as
 * recorded either way. A dissolved committee is a 409 `board_committee_dissolved`.
 */
export const orgBoardOrgSetBoardCommitteeConfirmation = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgSetBoardCommitteeConfirmationData, ThrowOnError>): RequestResult<OrgBoardOrgSetBoardCommitteeConfirmationResponses, OrgBoardOrgSetBoardCommitteeConfirmationErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgSetBoardCommitteeConfirmationResponses, OrgBoardOrgSetBoardCommitteeConfirmationErrors, ThrowOnError>({
    url: '/board/{org_ref}/committees/{committee_id}/confirmation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Dissolve Board Committee
 *
 * Dissolve a committee: the date, where it is recorded, and your note. Every membership ends
 * with it, and everything recorded about it stays. A dissolved committee answers as it is.
 */
export const orgBoardOrgDissolveBoardCommittee = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDissolveBoardCommitteeData, ThrowOnError>): RequestResult<OrgBoardOrgDissolveBoardCommitteeResponses, OrgBoardOrgDissolveBoardCommitteeErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgDissolveBoardCommitteeResponses, OrgBoardOrgDissolveBoardCommitteeErrors, ThrowOnError>({
    url: '/board/{org_ref}/committees/{committee_id}/dissolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Correct Board Committee Dissolution
 *
 * Correct a dissolution made by mistake, saying why: the committee stands again, with the
 * memberships its dissolution ended, for everyone still serving on the board.
 */
export const orgBoardOrgCorrectBoardCommitteeDissolution = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCorrectBoardCommitteeDissolutionData, ThrowOnError>): RequestResult<OrgBoardOrgCorrectBoardCommitteeDissolutionResponses, OrgBoardOrgCorrectBoardCommitteeDissolutionErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCorrectBoardCommitteeDissolutionResponses, OrgBoardOrgCorrectBoardCommitteeDissolutionErrors, ThrowOnError>({
    url: '/board/{org_ref}/committees/{committee_id}/dissolution/correction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Add Board Committee Member
 *
 * Add someone on your board's roster to a committee, director or not. `votes` is your
 * organization's record of whether they vote on the committee: yes unless you say otherwise.
 * Someone no longer serving is a 409 `board_committee_member_not_serving`; a second chair, a
 * 409 `board_committee_chair_taken`.
 */
export const orgBoardOrgAddBoardCommitteeMember = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgAddBoardCommitteeMemberData, ThrowOnError>): RequestResult<OrgBoardOrgAddBoardCommitteeMemberResponses, OrgBoardOrgAddBoardCommitteeMemberErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgAddBoardCommitteeMemberResponses, OrgBoardOrgAddBoardCommitteeMemberErrors, ThrowOnError>({
    url: '/board/{org_ref}/committees/{committee_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Update Board Committee Member
 *
 * Change a committee member's role, whether they vote on the committee, their dates, or
 * where their appointment is recorded. Send only what changes. A membership that has ended
 * isn't changed (409 `board_committee_member_ended`).
 */
export const orgBoardOrgUpdateBoardCommitteeMember = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardCommitteeMemberData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardCommitteeMemberResponses, OrgBoardOrgUpdateBoardCommitteeMemberErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardCommitteeMemberResponses, OrgBoardOrgUpdateBoardCommitteeMemberErrors, ThrowOnError>({
    url: '/board/{org_ref}/committees/{committee_id}/members/{membership_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org End Board Committee Member
 *
 * End someone's membership of a committee, with their last day if you have one, and your
 * note. An ended membership answers as it is.
 */
export const orgBoardOrgEndBoardCommitteeMember = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgEndBoardCommitteeMemberData, ThrowOnError>): RequestResult<OrgBoardOrgEndBoardCommitteeMemberResponses, OrgBoardOrgEndBoardCommitteeMemberErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgEndBoardCommitteeMemberResponses, OrgBoardOrgEndBoardCommitteeMemberErrors, ThrowOnError>({
    url: '/board/{org_ref}/committees/{committee_id}/members/{membership_id}/end',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Committee Rule
 *
 * Record one of a committee's rules, replacing the one in force, which stays in its history:
 * its notice period, its quorum, how its minutes are approved, or your organization's answer
 * about its authority to act for the board. `citation`, the section of your governing documents
 * the rule comes from, is required. Givmo doesn't read your governing documents.
 */
export const orgBoardOrgRecordBoardCommitteeRule = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardCommitteeRuleData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardCommitteeRuleResponses, OrgBoardOrgRecordBoardCommitteeRuleErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardCommitteeRuleResponses, OrgBoardOrgRecordBoardCommitteeRuleErrors, ThrowOnError>({
    url: '/board/{org_ref}/committees/{committee_id}/rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Compensation Decisions
 *
 * Every compensation decision you may read, grouped by person, newest first: each in the
 * regulation's order — the decision and its date, who took part, what the board relied on, and
 * when it was written down beside the date the regulation's rule gives. Facts the record holds;
 * Board answers no Form 990 question.
 */
export const orgBoardOrgListBoardCompensationDecisions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardCompensationDecisionsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardCompensationDecisionsResponses, OrgBoardOrgListBoardCompensationDecisionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardCompensationDecisionsResponses, OrgBoardOrgListBoardCompensationDecisionsErrors, ThrowOnError>({ url: '/board/{org_ref}/compensation-decisions', ...options });

/**
 * Org Record Board Compensation Index Entry
 *
 * Add a decision from your records: label minutes, a resolution or a written consent already
 * in the minute book (approved or imported) as recording the board's decision on one person's
 * pay, with where in that record it appears. The record itself never changes.
 */
export const orgBoardOrgRecordBoardCompensationIndexEntry = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardCompensationIndexEntryData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardCompensationIndexEntryResponses, OrgBoardOrgRecordBoardCompensationIndexEntryErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardCompensationIndexEntryResponses, OrgBoardOrgRecordBoardCompensationIndexEntryErrors, ThrowOnError>({
    url: '/board/{org_ref}/compensation-decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Remove Board Compensation Index Entry
 *
 * Remove a decision added from your records. A decision recorded on a motion or a written
 * consent is removed there.
 */
export const orgBoardOrgRemoveBoardCompensationIndexEntry = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemoveBoardCompensationIndexEntryData, ThrowOnError>): RequestResult<OrgBoardOrgRemoveBoardCompensationIndexEntryResponses, OrgBoardOrgRemoveBoardCompensationIndexEntryErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgRemoveBoardCompensationIndexEntryResponses, OrgBoardOrgRemoveBoardCompensationIndexEntryErrors, ThrowOnError>({ url: '/board/{org_ref}/compensation-decisions/{decision_id}', ...options });

/**
 * Org Get Board Compensation Decision
 *
 * One compensation decision, in the regulation's order, with its history: who recorded and
 * changed it, and when.
 */
export const orgBoardOrgGetBoardCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCompensationDecisionData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCompensationDecisionResponses, OrgBoardOrgGetBoardCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCompensationDecisionResponses, OrgBoardOrgGetBoardCompensationDecisionErrors, ThrowOnError>({ url: '/board/{org_ref}/compensation-decisions/{decision_id}', ...options });

/**
 * Org Update Board Compensation Decision
 *
 * Change an index entry's details, or any decision's two labels — your Form 990 answer for
 * the person (line 15a or 15b, a charity's only) and the link to the person's seat — which print
 * nowhere and change at any time. A field you send as null is cleared; one you leave out is
 * kept.
 */
export const orgBoardOrgUpdateBoardCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardCompensationDecisionData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardCompensationDecisionResponses, OrgBoardOrgUpdateBoardCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardCompensationDecisionResponses, OrgBoardOrgUpdateBoardCompensationDecisionErrors, ThrowOnError>({
    url: '/board/{org_ref}/compensation-decisions/{decision_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Compensation Decision Document Download
 *
 * A short-lived link to one document a compensation decision names, one of its meeting's
 * papers or a document uploaded onto a written consent: the exact version of the file whose
 * fingerprint the decision records, minted for this request and never stored. On a closed
 * session's motion, only for a reader that session was sent to.
 */
export const orgBoardOrgGetBoardCompensationDecisionDocumentDownload = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadResponses, OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadResponses, OrgBoardOrgGetBoardCompensationDecisionDocumentDownloadErrors, ThrowOnError>({ url: '/board/{org_ref}/compensation-decisions/{decision_id}/documents/{document_id}/download', ...options });

/**
 * Org List Board Conflict Register
 *
 * The charity's conflict register — its recorded disclosures, per seat.
 *
 * `status` is DERIVED from the version pointers, not stored: `superseded` means a later
 * disclosure by the same seat replaced this one, and `active` means none has. Filter on
 * it to see what stands today, or omit it to read the whole history.
 *
 * A disclosure filed into an executive session this reader was not part of is ABSENT,
 * exactly as the session itself is — that binds charity admins as well as directors. No
 * disclosure is filed that way today: every one goes in at standard visibility, so the
 * scoping is here for the rule rather than for a case you will meet.
 */
export const orgBoardOrgListBoardConflictRegister = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardConflictRegisterData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardConflictRegisterResponses, OrgBoardOrgListBoardConflictRegisterErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardConflictRegisterResponses, OrgBoardOrgListBoardConflictRegisterErrors, ThrowOnError>({ url: '/board/{org_ref}/conflict-disclosures', ...options });

/**
 * Org Record Board Conflict Disclosure
 *
 * Record a conflict-of-interest disclosure a director made outside the portal.
 *
 * Plan §1.7's manual path, first-class and permanent: a volunteer board hands the
 * secretary a signed form, or says it in the room, and the module has to be able to write
 * that down. `provenance_note` is required — it says where the disclosure came from, so
 * the entry can never be read as the director having acted inside their own session.
 *
 * The record names the DIRECTOR'S OWN SEAT as its approver, not the officer's account:
 * the director disclosed, and the officer wrote it down. A director recording their own
 * disclosure does it through their board session instead, where it is a signature-class
 * act on the step-up rail.
 *
 * `supersedes_record_id` records that the director's position has CHANGED — the earlier
 * disclosure stays an accurate record of what was true at its time. `corrects_record_id`
 * records that the earlier one was WRONG. They are different statements about a person
 * and a record carries one or the other, never both.
 */
export const orgBoardOrgRecordBoardConflictDisclosure = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardConflictDisclosureData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardConflictDisclosureResponses, OrgBoardOrgRecordBoardConflictDisclosureErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardConflictDisclosureResponses, OrgBoardOrgRecordBoardConflictDisclosureErrors, ThrowOnError>({
    url: '/board/{org_ref}/conflict-disclosures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Consent Templates
 *
 * The consent and resolution forms the charity may choose from, without the full
 * text of each.
 *
 * Structurally neutral scaffolds with bracketed fields the organization fills in, each
 * naming the authority its structure is modeled on. The library is the same for every
 * charity: this route reads nothing about the organization, so it can never present a
 * form as one the organization ought to adopt.
 */
export const orgBoardOrgListBoardConsentTemplates = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardConsentTemplatesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardConsentTemplatesResponses, OrgBoardOrgListBoardConsentTemplatesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardConsentTemplatesResponses, OrgBoardOrgListBoardConsentTemplatesErrors, ThrowOnError>({ url: '/board/{org_ref}/consent-templates', ...options });

/**
 * Org Get Board Consent Template
 *
 * One form, with its full text, the fields the organization fills in, and the
 * provenance of its structure.
 *
 * Served with the line the organization should read before adopting anything from it:
 * template — review with your counsel before adopting. A form written for a committee is
 * fetched for one of the organization's committees (``committee_id``), its text naming it.
 */
export const orgBoardOrgGetBoardConsentTemplate = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardConsentTemplateData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardConsentTemplateResponses, OrgBoardOrgGetBoardConsentTemplateErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardConsentTemplateResponses, OrgBoardOrgGetBoardConsentTemplateErrors, ThrowOnError>({ url: '/board/{org_ref}/consent-templates/{template_id}', ...options });

/**
 * Org List Board Contemporaneity
 *
 * Each of the charity's held meetings and executed written consents, with its date.
 *
 * The Form 990 instructions for Part VI, line 8 describe documentation as contemporaneous
 * when it is prepared by the later of the next meeting of the governing body or 60 days
 * after the meeting or written action. This view does that arithmetic and shows the dates
 * it applied it to.
 *
 * It reports what is recorded and what the dates are, and draws no conclusion from them
 * about the charity's governance — the answer on the return is the charity's own to give.
 */
export const orgBoardOrgListBoardContemporaneity = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardContemporaneityData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardContemporaneityResponses, OrgBoardOrgListBoardContemporaneityErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardContemporaneityResponses, OrgBoardOrgListBoardContemporaneityErrors, ThrowOnError>({ url: '/board/{org_ref}/contemporaneity', ...options });

/**
 * Org Get Board Director Access Policy
 *
 * What this board asks of a director before it opens, and who decided it.
 *
 * `tiered` is what every board runs: what a director must prove follows the weight of
 * what they are doing, so reading and replying ride the director's own Givmo sign-in,
 * and signature-class acts need a second factor confirmed within the hour.
 *
 * `step_up_always` ("confirm before anything opens") was retired on 2026-10-05. A board
 * that adopted it before gets that adoption back as it was recorded: it asks nothing more
 * of a director than `tiered` does, and no board can adopt a policy any more.
 *
 * Executive-session material needs a second factor on every board. That is a floor
 * beneath the setting rather than part of it.
 *
 * A board that has adopted nothing answers with the default and a null adopter,
 * never a 404.
 */
export const orgBoardOrgGetBoardDirectorAccessPolicy = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardDirectorAccessPolicyData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardDirectorAccessPolicyResponses, OrgBoardOrgGetBoardDirectorAccessPolicyErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardDirectorAccessPolicyResponses, OrgBoardOrgGetBoardDirectorAccessPolicyErrors, ThrowOnError>({ url: '/board/{org_ref}/director-access-policy', ...options });

/**
 * Org List Board Director Classes
 *
 * The board's own names for its classes of directors, active first in the board's order,
 * then retired. A board with no classes has none: nothing is added for it. A class is a label
 * on a term; it changes no vote, quorum or written consent. Reading this list never changes it.
 */
export const orgBoardOrgListBoardDirectorClasses = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardDirectorClassesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardDirectorClassesResponses, OrgBoardOrgListBoardDirectorClassesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardDirectorClassesResponses, OrgBoardOrgListBoardDirectorClassesErrors, ThrowOnError>({ url: '/board/{org_ref}/director-classes', ...options });

/**
 * Org Create Board Director Class
 *
 * Add one of the board's classes, last in the board's order. No two active classes share a
 * name, whatever the case or spacing: that is a 409 `board_director_class_name_taken`.
 */
export const orgBoardOrgCreateBoardDirectorClass = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardDirectorClassData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardDirectorClassResponses, OrgBoardOrgCreateBoardDirectorClassErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardDirectorClassResponses, OrgBoardOrgCreateBoardDirectorClassErrors, ThrowOnError>({
    url: '/board/{org_ref}/director-classes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Update Board Director Class
 *
 * Rename a class, move it in the board's order, or both. `position` is its place among the
 * active classes, counting from 1; past the last means last. A retired class is neither renamed
 * nor moved (409 `board_director_class_retired`).
 */
export const orgBoardOrgUpdateBoardDirectorClass = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardDirectorClassData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardDirectorClassResponses, OrgBoardOrgUpdateBoardDirectorClassErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardDirectorClassResponses, OrgBoardOrgUpdateBoardDirectorClassErrors, ThrowOnError>({
    url: '/board/{org_ref}/director-classes/{class_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Retire Board Director Class
 *
 * Retire a class the board no longer uses. It is never deleted and stays on every term that
 * names it. Retiring a class already retired answers it as it is.
 */
export const orgBoardOrgRetireBoardDirectorClass = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRetireBoardDirectorClassData, ThrowOnError>): RequestResult<OrgBoardOrgRetireBoardDirectorClassResponses, OrgBoardOrgRetireBoardDirectorClassErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRetireBoardDirectorClassResponses, OrgBoardOrgRetireBoardDirectorClassErrors, ThrowOnError>({ url: '/board/{org_ref}/director-classes/{class_id}/retirement', ...options });

/**
 * Org List Board Engagement
 *
 * Who has opened what — the chair's engagement view.
 *
 * Measurement, not shaming (plan §1.7). Per-(seat, artifact) open counts and instants,
 * with deliberately nothing about how long anything was open and no ranking, so the
 * surface built on this answers "has this director opened the packet?" without becoming
 * a leaderboard. The charity configures whether it is shown at all.
 */
export const orgBoardOrgListBoardEngagement = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardEngagementData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardEngagementResponses, OrgBoardOrgListBoardEngagementErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardEngagementResponses, OrgBoardOrgListBoardEngagementErrors, ThrowOnError>({ url: '/board/{org_ref}/engagement', ...options });

/**
 * Org Export Board Minute Book
 *
 * The machine-readable minute-book export, manifest-bound.
 *
 * Continuous — callable any time, no request queue and no waiting period. Every record
 * carries the content hash fixed when it became the record, and `manifest_hash` binds
 * the set, so the charity can re-derive both from the export alone, with nothing from
 * Givmo.
 */
export const orgBoardOrgExportBoardMinuteBook = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgExportBoardMinuteBookData, ThrowOnError>): RequestResult<OrgBoardOrgExportBoardMinuteBookResponses, OrgBoardOrgExportBoardMinuteBookErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgExportBoardMinuteBookResponses, OrgBoardOrgExportBoardMinuteBookErrors, ThrowOnError>({ url: '/board/{org_ref}/export', ...options });

/**
 * Org Export Board Minute Book Document
 *
 * The same export as a human-readable minute book — readable, printable, and
 * hand-able to counsel with no tooling at all.
 */
export const orgBoardOrgExportBoardMinuteBookDocument = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgExportBoardMinuteBookDocumentData, ThrowOnError>): RequestResult<OrgBoardOrgExportBoardMinuteBookDocumentResponses, OrgBoardOrgExportBoardMinuteBookDocumentErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgExportBoardMinuteBookDocumentResponses, OrgBoardOrgExportBoardMinuteBookDocumentErrors, ThrowOnError>({ url: '/board/{org_ref}/export/document', ...options });

/**
 * Org Get Board Filing Governance Feed
 *
 * The filing module's current governance projection.
 *
 * While Org Machinery standing or the held D-CCM-2 legal rows are absent, the
 * operation fails typed and returns no dependent facts.
 */
export const orgBoardOrgGetBoardFilingGovernanceFeed = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardFilingGovernanceFeedData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardFilingGovernanceFeedResponses, OrgBoardOrgGetBoardFilingGovernanceFeedErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardFilingGovernanceFeedResponses, OrgBoardOrgGetBoardFilingGovernanceFeedErrors, ThrowOnError>({ url: '/board/{org_ref}/filing-governance', ...options });

/**
 * Org Open Board Filing Receipt
 *
 * Mint from an authorized current feed or exact published packet snapshot.
 */
export const orgBoardOrgOpenBoardFilingReceipt = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgOpenBoardFilingReceiptData, ThrowOnError>): RequestResult<OrgBoardOrgOpenBoardFilingReceiptResponses, OrgBoardOrgOpenBoardFilingReceiptErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgOpenBoardFilingReceiptResponses, OrgBoardOrgOpenBoardFilingReceiptErrors, ThrowOnError>({ url: '/board/{org_ref}/filing-governance/obligations/{obligation_id}/receipts/{artifact_id}/download-url', ...options });

/**
 * Org Get Board Form 990
 *
 * One tax year of Form 990, Part VI: each question in the IRS's own words, with its
 * instructions quoted, and beside it what your board's records hold that bears on it, as far as
 * you may read them. Your organization answers each question on its return; this page doesn't.
 *
 * The tax years come from the fiscal year end your organization recorded in Givmo; with none
 * recorded, from the month and day in `year_end_month` and `year_end_day`. `tax_year_ends_on`
 * picks a year by its last day; without it, the latest year that has ended. Computed when read;
 * nothing is stored.
 */
export const orgBoardOrgGetBoardForm990 = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardForm990Data, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardForm990Responses, OrgBoardOrgGetBoardForm990Errors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardForm990Responses, OrgBoardOrgGetBoardForm990Errors, ThrowOnError>({ url: '/board/{org_ref}/form-990', ...options });

/**
 * Org Get Board Schedule O Draft
 *
 * One tax year's Schedule O draft: sentences built only from what your board recorded, for
 * you to edit into your own words — line 8b's, where no committee is recorded for the year, and
 * line 11b's (the copy of the return provided to the board, who opened and read it, and the
 * review linked to it, the board's or a committee's). The text follows the IRS e-file character
 * set. The year is the Form 990 page's, with the same address. Computed when read; never stored,
 * and never your organization's Schedule O, which is whatever it files.
 */
export const orgBoardOrgGetBoardScheduleODraft = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardScheduleODraftData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardScheduleODraftResponses, OrgBoardOrgGetBoardScheduleODraftErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardScheduleODraftResponses, OrgBoardOrgGetBoardScheduleODraftErrors, ThrowOnError>({ url: '/board/{org_ref}/form-990/schedule-o-draft', ...options });

/**
 * Org List Board Getting Started Steps
 *
 * New members, and the steps on their getting-started lists that are the officers' own:
 * sending the year's conflict-of-interest questionnaire, choosing a board buddy.
 */
export const orgBoardOrgListBoardGettingStartedSteps = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardGettingStartedStepsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardGettingStartedStepsResponses, OrgBoardOrgListBoardGettingStartedStepsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardGettingStartedStepsResponses, OrgBoardOrgListBoardGettingStartedStepsErrors, ThrowOnError>({ url: '/board/{org_ref}/getting-started', ...options });

/**
 * Org Get Board Getting Started List
 *
 * The board's getting-started list: the one the board adopted, or — before it adopted one —
 * Givmo's starting list, built only from the governing documents the board recorded, the first
 * disclosure and a board buddy. Nothing is in use until the board adopts a list.
 */
export const orgBoardOrgGetBoardGettingStartedList = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardGettingStartedListData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardGettingStartedListResponses, OrgBoardOrgGetBoardGettingStartedListErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardGettingStartedListResponses, OrgBoardOrgGetBoardGettingStartedListErrors, ThrowOnError>({ url: '/board/{org_ref}/getting-started-list', ...options });

/**
 * Org Save Board Getting Started List
 *
 * Use this list (no revision yet), or change the board's list from the revision you read:
 * add, remove or reorder items. Members added after this get the list; a list a member already
 * has doesn't change. A list that changed meanwhile is refused, so no change undoes another.
 */
export const orgBoardOrgSaveBoardGettingStartedList = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgSaveBoardGettingStartedListData, ThrowOnError>): RequestResult<OrgBoardOrgSaveBoardGettingStartedListResponses, OrgBoardOrgSaveBoardGettingStartedListErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgSaveBoardGettingStartedListResponses, OrgBoardOrgSaveBoardGettingStartedListErrors, ThrowOnError>({
    url: '/board/{org_ref}/getting-started-list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Governance Parameters
 *
 * The charity's recorded parameters — in force first, then history when asked for.
 *
 * The history is opt-in because it is what a past meeting's figures were counted
 * against: a reader checking an old meeting's notice needs the row that was in force
 * then, not only the one in force now.
 */
export const orgBoardOrgListBoardGovernanceParameters = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardGovernanceParametersData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardGovernanceParametersResponses, OrgBoardOrgListBoardGovernanceParametersErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardGovernanceParametersResponses, OrgBoardOrgListBoardGovernanceParametersErrors, ThrowOnError>({ url: '/board/{org_ref}/governance-parameters', ...options });

/**
 * Org Record Board Governance Parameter
 *
 * Record a governance parameter the charity has entered, with its bylaw attribution.
 *
 * The number is the charity's, and `bylaw_citation` — the section of its own governing
 * documents it comes from — is REQUIRED. The module computes arithmetic against what is
 * recorded here and echoes the citation in every sentence it renders; it reads no
 * governing document and derives none of these numbers.
 *
 * PUT rather than POST because the charity has exactly one parameter in force per key.
 * Recording again does not edit the old row: it writes a new one and supersedes the
 * prior, so a meeting scheduled under the earlier number keeps the figures it was given.
 */
export const orgBoardOrgRecordBoardGovernanceParameter = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardGovernanceParameterData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardGovernanceParameterResponses, OrgBoardOrgRecordBoardGovernanceParameterErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgRecordBoardGovernanceParameterResponses, OrgBoardOrgRecordBoardGovernanceParameterErrors, ThrowOnError>({
    url: '/board/{org_ref}/governance-parameters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Governing Document Templates
 *
 * The form library the charity may choose from, without the full text of each form.
 *
 * Structurally neutral scaffolds with bracketed fields the organization fills in, each
 * naming the authority its structure is modeled on. The library is the same for every
 * charity: this route reads nothing about the organization, so it can never present a form
 * as one the organization ought to adopt.
 */
export const orgBoardOrgListBoardGoverningDocumentTemplates = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardGoverningDocumentTemplatesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardGoverningDocumentTemplatesResponses, OrgBoardOrgListBoardGoverningDocumentTemplatesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardGoverningDocumentTemplatesResponses, OrgBoardOrgListBoardGoverningDocumentTemplatesErrors, ThrowOnError>({ url: '/board/{org_ref}/governing-document-templates', ...options });

/**
 * Org Get Board Governing Document Template
 *
 * One form, with its full text, the fields the organization fills in, and the
 * provenance of its structure.
 *
 * Served with the line the organization should read before adopting anything from it:
 * template — review with your counsel before adopting.
 */
export const orgBoardOrgGetBoardGoverningDocumentTemplate = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardGoverningDocumentTemplateData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardGoverningDocumentTemplateResponses, OrgBoardOrgGetBoardGoverningDocumentTemplateErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardGoverningDocumentTemplateResponses, OrgBoardOrgGetBoardGoverningDocumentTemplateErrors, ThrowOnError>({ url: '/board/{org_ref}/governing-document-templates/{template_id}', ...options });

/**
 * Org List Board Governing Documents
 *
 * The charity's governing documents, each as the chain of versions it adopted.
 *
 * Versions are in the order the charity recorded — each names the version it replaced —
 * and the last one is flagged as in force. A version recorded as executive session that
 * the caller did not take part in is absent from the chain, like every other board read.
 *
 * The response describes what the charity recorded and nothing else: there is no entry for
 * an instrument the charity has no version of.
 */
export const orgBoardOrgListBoardGoverningDocuments = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardGoverningDocumentsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardGoverningDocumentsResponses, OrgBoardOrgListBoardGoverningDocumentsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardGoverningDocumentsResponses, OrgBoardOrgListBoardGoverningDocumentsErrors, ThrowOnError>({ url: '/board/{org_ref}/governing-documents', ...options });

/**
 * Org Record Historical Board Member
 *
 * Record a FORMER seat — someone who served on this board before the module was in
 * use (CBG-RC8).
 *
 * A separate route from adding a seat, because the row it creates is already ended: the
 * status is not the caller's to choose and no removal reason is asked for, since no
 * removal happened here. `served_from` / `served_to` are the charity's own account of the
 * term and are read back beside the module's own timestamps, so a 2026 entry of a 2019
 * term reads as exactly that rather than as a director who left today.
 *
 * A former seat holds no credentials and never will — every access link and session
 * re-reads the seat's standing on use, and this seat is a former one from the moment it
 * exists. It is here for the record: attendance in historical minutes, and the term
 * lifecycle a later item builds.
 */
export const orgBoardOrgRecordHistoricalBoardMember = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordHistoricalBoardMemberData, ThrowOnError>): RequestResult<OrgBoardOrgRecordHistoricalBoardMemberResponses, OrgBoardOrgRecordHistoricalBoardMemberErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordHistoricalBoardMemberResponses, OrgBoardOrgRecordHistoricalBoardMemberErrors, ThrowOnError>({
    url: '/board/{org_ref}/historical-members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Import Batches
 *
 * The charity's import sessions, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Each carries the count of what THIS reader may see in it, so a closed-session record
 * the caller was not part of is missing from the count exactly as it is missing from the
 * listing.
 */
export const orgBoardOrgListBoardImportBatches = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardImportBatchesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardImportBatchesResponses, OrgBoardOrgListBoardImportBatchesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardImportBatchesResponses, OrgBoardOrgListBoardImportBatchesErrors, ThrowOnError>({ url: '/board/{org_ref}/import-batches', ...options });

/**
 * Org Open Board Import Batch
 *
 * Open a session for bringing in records from before this module was in use.
 *
 * `source_description` is the charity's own account of where the corpus came from — a box
 * of paper, a prior system, a predecessor's files. The module observed none of it, so the
 * charity's own words are the only honest source, and they travel with every record
 * entered under the session.
 */
export const orgBoardOrgOpenBoardImportBatch = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgOpenBoardImportBatchData, ThrowOnError>): RequestResult<OrgBoardOrgOpenBoardImportBatchResponses, OrgBoardOrgOpenBoardImportBatchErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgOpenBoardImportBatchResponses, OrgBoardOrgOpenBoardImportBatchErrors, ThrowOnError>({
    url: '/board/{org_ref}/import-batches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Import Batch
 *
 * Twin of ``get_board_import_batch``.
 */
export const orgBoardOrgGetBoardImportBatch = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardImportBatchData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardImportBatchResponses, OrgBoardOrgGetBoardImportBatchErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardImportBatchResponses, OrgBoardOrgGetBoardImportBatchErrors, ThrowOnError>({ url: '/board/{org_ref}/import-batches/{batch_id}', ...options });

/**
 * Org Update Board Import Batch
 *
 * Edit an OPEN session's description. Refused once it is closed — at that point the
 * label and the source description are what every record entered under it says about its
 * own origin, and those records are themselves immutable.
 */
export const orgBoardOrgUpdateBoardImportBatch = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardImportBatchData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardImportBatchResponses, OrgBoardOrgUpdateBoardImportBatchErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardImportBatchResponses, OrgBoardOrgUpdateBoardImportBatchErrors, ThrowOnError>({
    url: '/board/{org_ref}/import-batches/{batch_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Close Board Import Batch
 *
 * Close a session — the charity saying the backfill is finished.
 *
 * Nothing further can be entered under it and the session itself stops being editable.
 * The route is named for the thing it creates (the closure), not for a verb, because the
 * closure is the durable artifact: it names who drew the boundary and when.
 */
export const orgBoardOrgCloseBoardImportBatch = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCloseBoardImportBatchData, ThrowOnError>): RequestResult<OrgBoardOrgCloseBoardImportBatchResponses, OrgBoardOrgCloseBoardImportBatchErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCloseBoardImportBatchResponses, OrgBoardOrgCloseBoardImportBatchErrors, ThrowOnError>({
    url: '/board/{org_ref}/import-batches/{batch_id}/closure',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Issue Board Import File Upload Url
 *
 * A signed upload URL for the file of a record you're entering into an open import batch: PUT
 * the file there once, sending exactly `headers`, then send the record with `file.upload_id`. A
 * PDF or a picture, up to 50 MB. Nothing is recorded until the record is sent.
 */
export const orgBoardOrgIssueBoardImportFileUploadUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgIssueBoardImportFileUploadUrlData, ThrowOnError>): RequestResult<OrgBoardOrgIssueBoardImportFileUploadUrlResponses, OrgBoardOrgIssueBoardImportFileUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgIssueBoardImportFileUploadUrlResponses, OrgBoardOrgIssueBoardImportFileUploadUrlErrors, ThrowOnError>({
    url: '/board/{org_ref}/import-batches/{batch_id}/file-upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Delete Board Import File Upload
 *
 * Delete a file uploaded for a record you didn't send (the form was cancelled). A record's
 * own file is never deleted here.
 */
export const orgBoardOrgDeleteBoardImportFileUpload = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDeleteBoardImportFileUploadData, ThrowOnError>): RequestResult<OrgBoardOrgDeleteBoardImportFileUploadResponses, OrgBoardOrgDeleteBoardImportFileUploadErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgDeleteBoardImportFileUploadResponses, OrgBoardOrgDeleteBoardImportFileUploadErrors, ThrowOnError>({ url: '/board/{org_ref}/import-batches/{batch_id}/file-uploads/{upload_id}', ...options });

/**
 * Org List Board Import Batch Records
 *
 * Everything entered under one session, in entry order — the review listing.
 *
 * This is what makes a backfill checkable: the charity reads back what it just brought
 * in, with each record's content hash beside it so a reviewer can tie a row to the page
 * of paper it came from. Records the caller may not read are ABSENT, and the total
 * reflects only what they may see.
 */
export const orgBoardOrgListBoardImportBatchRecords = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardImportBatchRecordsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardImportBatchRecordsResponses, OrgBoardOrgListBoardImportBatchRecordsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardImportBatchRecordsResponses, OrgBoardOrgListBoardImportBatchRecordsErrors, ThrowOnError>({ url: '/board/{org_ref}/import-batches/{batch_id}/records', ...options });

/**
 * Org Issue Board Import Record File Upload Url
 *
 * A signed upload URL for the file of a record you're entering by hand: PUT the file there
 * once, sending exactly `headers`, then send the record with `file.upload_id`. A PDF or a
 * picture, up to 50 MB. Nothing is recorded until the record is sent.
 */
export const orgBoardOrgIssueBoardImportRecordFileUploadUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgIssueBoardImportRecordFileUploadUrlData, ThrowOnError>): RequestResult<OrgBoardOrgIssueBoardImportRecordFileUploadUrlResponses, OrgBoardOrgIssueBoardImportRecordFileUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgIssueBoardImportRecordFileUploadUrlResponses, OrgBoardOrgIssueBoardImportRecordFileUploadUrlErrors, ThrowOnError>({
    url: '/board/{org_ref}/import-file-upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Delete Board Import Record File Upload
 *
 * Delete a file uploaded for a record you didn't send (you chose another file, or left the
 * page). A record's own file is never deleted here.
 */
export const orgBoardOrgDeleteBoardImportRecordFileUpload = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDeleteBoardImportRecordFileUploadData, ThrowOnError>): RequestResult<OrgBoardOrgDeleteBoardImportRecordFileUploadResponses, OrgBoardOrgDeleteBoardImportRecordFileUploadErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgDeleteBoardImportRecordFileUploadResponses, OrgBoardOrgDeleteBoardImportRecordFileUploadErrors, ThrowOnError>({ url: '/board/{org_ref}/import-file-uploads/{upload_id}', ...options });

/**
 * Org List Board Import Inbox
 *
 * The files uploaded for your AI: those waiting for it, those it proposed records from (each
 * waiting for you to confirm), and those in your minute book, with how many there are and how
 * many can wait at once. Nothing here is in the minute book until you confirm it.
 */
export const orgBoardOrgListBoardImportInbox = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardImportInboxData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardImportInboxResponses, OrgBoardOrgListBoardImportInboxErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardImportInboxResponses, OrgBoardOrgListBoardImportInboxErrors, ThrowOnError>({ url: '/board/{org_ref}/import-inbox', ...options });

/**
 * Org Issue Board Import Inbox Upload Url
 *
 * A signed upload URL for one file you're uploading for your AI: PUT the file there once,
 * sending exactly `headers`, then ask Board to check it with the `upload_id` it names. A PDF or a
 * picture, up to 50 MB. Nothing is added until Board's check passes.
 */
export const orgBoardOrgIssueBoardImportInboxUploadUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgIssueBoardImportInboxUploadUrlData, ThrowOnError>): RequestResult<OrgBoardOrgIssueBoardImportInboxUploadUrlResponses, OrgBoardOrgIssueBoardImportInboxUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgIssueBoardImportInboxUploadUrlResponses, OrgBoardOrgIssueBoardImportInboxUploadUrlErrors, ThrowOnError>({
    url: '/board/{org_ref}/import-inbox/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Remove Board Import Inbox File
 *
 * Remove a file waiting in your uploads: it is deleted, and your AI no longer sees it. A
 * file your AI proposed a record from waits for you on the confirmation page instead. A
 * person's act.
 */
export const orgBoardOrgRemoveBoardImportInboxFile = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemoveBoardImportInboxFileData, ThrowOnError>): RequestResult<OrgBoardOrgRemoveBoardImportInboxFileResponses, OrgBoardOrgRemoveBoardImportInboxFileErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgRemoveBoardImportInboxFileResponses, OrgBoardOrgRemoveBoardImportInboxFileErrors, ThrowOnError>({ url: '/board/{org_ref}/import-inbox/{upload_id}', ...options });

/**
 * Org Check Board Import Inbox File
 *
 * Ask Board to check a file you uploaded, with its name and type. If the check passes, the
 * file waits in your uploads for your AI; if not, the answer says why and the upload is
 * deleted. A file already uploaded, or already in your minute book, is added and says so.
 */
export const orgBoardOrgCheckBoardImportInboxFile = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCheckBoardImportInboxFileData, ThrowOnError>): RequestResult<OrgBoardOrgCheckBoardImportInboxFileResponses, OrgBoardOrgCheckBoardImportInboxFileErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCheckBoardImportInboxFileResponses, OrgBoardOrgCheckBoardImportInboxFileErrors, ThrowOnError>({
    url: '/board/{org_ref}/import-inbox/{upload_id}/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Import Inbox File Url
 *
 * A short-lived link that downloads a file waiting in your uploads, as Board checked it.
 */
export const orgBoardOrgGetBoardImportInboxFileUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardImportInboxFileUrlData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardImportInboxFileUrlResponses, OrgBoardOrgGetBoardImportInboxFileUrlErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardImportInboxFileUrlResponses, OrgBoardOrgGetBoardImportInboxFileUrlErrors, ThrowOnError>({ url: '/board/{org_ref}/import-inbox/{upload_id}/file', ...options });

/**
 * Org Import Board Record
 *
 * Bring in a pre-module historical record (CBG-RC8), one document at a time.
 *
 * A separate route from draft creation on purpose: an imported record lands immutable
 * and never passes through submit/approve, so conflating the two entry points would
 * invite a caller to think an import can be "approved" later. It cannot — the database
 * ties imported provenance to the imported state and nothing else.
 *
 * **This is the only import door.** `source_note`, the organization's own note of where
 * the record came from, is optional. A file goes in with the record (`file`, from the
 * slot `…/import-file-upload-url` named) or never. An `import_batch_id` names a backfill
 * session, which is answered as not found while the sessions are switched off.
 *
 * **The call is idempotent.** A "Record it" pressed again, or a backfill retried after a
 * dropped connection, re-sends what it already sent; a record whose content the
 * organization already holds (entered with no session, or in the named one) is not
 * written twice. The already-recorded one comes back with `already_recorded: true` and a
 * **200** rather than a 201, so a caller can tell a fresh entry from a replayed one
 * without comparing ids.
 */
export const orgBoardOrgImportBoardRecord = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgImportBoardRecordData, ThrowOnError>): RequestResult<OrgBoardOrgImportBoardRecordResponses, OrgBoardOrgImportBoardRecordErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgImportBoardRecordResponses, OrgBoardOrgImportBoardRecordErrors, ThrowOnError>({
    url: '/board/{org_ref}/imported-records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Legal Holds
 *
 * Twin of ``list_board_legal_holds``.
 */
export const orgBoardOrgListBoardLegalHolds = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardLegalHoldsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardLegalHoldsResponses, OrgBoardOrgListBoardLegalHoldsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardLegalHoldsResponses, OrgBoardOrgListBoardLegalHoldsErrors, ThrowOnError>({ url: '/board/{org_ref}/legal-holds', ...options });

/**
 * Org Place Board Legal Hold
 *
 * Twin of ``place_board_legal_hold``.
 */
export const orgBoardOrgPlaceBoardLegalHold = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgPlaceBoardLegalHoldData, ThrowOnError>): RequestResult<OrgBoardOrgPlaceBoardLegalHoldResponses, OrgBoardOrgPlaceBoardLegalHoldErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgPlaceBoardLegalHoldResponses, OrgBoardOrgPlaceBoardLegalHoldErrors, ThrowOnError>({
    url: '/board/{org_ref}/legal-holds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Release Board Legal Hold
 *
 * Twin of ``release_board_legal_hold``.
 */
export const orgBoardOrgReleaseBoardLegalHold = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgReleaseBoardLegalHoldData, ThrowOnError>): RequestResult<OrgBoardOrgReleaseBoardLegalHoldResponses, OrgBoardOrgReleaseBoardLegalHoldErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgReleaseBoardLegalHoldResponses, OrgBoardOrgReleaseBoardLegalHoldErrors, ThrowOnError>({
    url: '/board/{org_ref}/legal-holds/{hold_id}/release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Legal Hold Report
 *
 * What a hold covers — the enumeration the charity can hand to whoever asked for it.
 *
 * A hold preserves records; it does not widen who may read them, so the report is
 * confidentiality-scoped like every other read.
 */
export const orgBoardOrgGetBoardLegalHoldReport = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardLegalHoldReportData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardLegalHoldReportResponses, OrgBoardOrgGetBoardLegalHoldReportErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardLegalHoldReportResponses, OrgBoardOrgGetBoardLegalHoldReportErrors, ThrowOnError>({ url: '/board/{org_ref}/legal-holds/{hold_id}/report', ...options });

/**
 * Org List Board Meetings
 *
 * The charity's meetings, soonest first, in the canonical `{data, meta, links}`
 * envelope.
 */
export const orgBoardOrgListBoardMeetings = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardMeetingsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardMeetingsResponses, OrgBoardOrgListBoardMeetingsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardMeetingsResponses, OrgBoardOrgListBoardMeetingsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings', ...options });

/**
 * Org Create Board Meeting
 *
 * Schedule a meeting.
 *
 * The response's `notice` block is captured here, against the notice period the charity
 * recorded for THIS meeting type. It carries the period, the section it was attributed
 * to, the day count, any shortfall in days, and the counting method — and it never says
 * a meeting was noticed correctly or otherwise. A shortfall is surfaced and never
 * blocks: the board owns its own acts.
 *
 * With no period recorded for this meeting type the block is empty and its statement
 * says so. Nothing is counted, because there is nothing recorded to count against.
 */
export const orgBoardOrgCreateBoardMeeting = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardMeetingData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardMeetingResponses, OrgBoardOrgCreateBoardMeetingErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardMeetingResponses, OrgBoardOrgCreateBoardMeetingErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Meeting
 *
 * Twin of ``get_board_meeting``.
 */
export const orgBoardOrgGetBoardMeeting = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardMeetingData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardMeetingResponses, OrgBoardOrgGetBoardMeetingErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardMeetingResponses, OrgBoardOrgGetBoardMeetingErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}', ...options });

/**
 * Org Update Board Meeting
 *
 * Edit an upcoming meeting (skip-None partial update).
 *
 * Moving the date re-counts the notice against the period recorded at that moment and
 * bumps the schedule revision, so a director's calendar updates the entry it holds
 * rather than gaining a second one. Correcting the time zone alone re-counts against the
 * SAME recorded period — the zone is what the count is taken in, so a correction can
 * legitimately move the figure by a day without the notice itself having changed.
 *
 * Cancelling is not here: it has its own route and its own required reason.
 */
export const orgBoardOrgUpdateBoardMeeting = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardMeetingData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardMeetingResponses, OrgBoardOrgUpdateBoardMeetingErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardMeetingResponses, OrgBoardOrgUpdateBoardMeetingErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Agenda Items
 *
 * One meeting's agenda, in order.
 */
export const orgBoardOrgListBoardAgendaItems = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardAgendaItemsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardAgendaItemsResponses, OrgBoardOrgListBoardAgendaItemsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardAgendaItemsResponses, OrgBoardOrgListBoardAgendaItemsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/agenda-items', ...options });

/**
 * Org Create Board Agenda Item
 *
 * Add an agenda item. Omitted `position` appends to the end.
 */
export const orgBoardOrgCreateBoardAgendaItem = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardAgendaItemData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardAgendaItemResponses, OrgBoardOrgCreateBoardAgendaItemErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardAgendaItemResponses, OrgBoardOrgCreateBoardAgendaItemErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/agenda-items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Add Board Committee Suggestion Items
 *
 * Add the suggested committee decisions to this meeting's agenda: one ordinary item per
 * committee, listing each decision, which can be edited, moved or deleted like any other. Nothing
 * else is filled in. Pressing again adds only decisions not yet on an agenda. A committee's
 * meeting, or one whose minutes are approved, is a 409 `board_committee_suggestion_not_offered`;
 * a suggestion put away for this meeting, a 409 `board_committee_suggestion_dismissed`.
 */
export const orgBoardOrgAddBoardCommitteeSuggestionItems = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgAddBoardCommitteeSuggestionItemsData, ThrowOnError>): RequestResult<OrgBoardOrgAddBoardCommitteeSuggestionItemsResponses, OrgBoardOrgAddBoardCommitteeSuggestionItemsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgAddBoardCommitteeSuggestionItemsResponses, OrgBoardOrgAddBoardCommitteeSuggestionItemsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/agenda-items/from-committee-suggestion', ...options });

/**
 * Org Apply Board Agenda Template
 *
 * Write the sections of a neutral template the charity selected.
 *
 * `template_id` is required and has no default: the charity names the template it wants.
 * The sections land as ordinary agenda items with nothing populated — no presenter, no
 * time box, no consent-agenda placement — because each of those is a decision about this
 * charity's meeting. Which template was applied is recorded on the meeting and in its
 * event log.
 */
export const orgBoardOrgApplyBoardAgendaTemplate = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgApplyBoardAgendaTemplateData, ThrowOnError>): RequestResult<OrgBoardOrgApplyBoardAgendaTemplateResponses, OrgBoardOrgApplyBoardAgendaTemplateErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgApplyBoardAgendaTemplateResponses, OrgBoardOrgApplyBoardAgendaTemplateErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/agenda-items/from-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Add Board Term Suggestion Items
 *
 * Add the elections the annual meeting's terms suggest: "Election of directors" and
 * "Election of officers", each an ordinary item naming the people whose terms end — or, where the
 * annual template's own "Directors" or "Officers" section is on the agenda, those names added to
 * it. Nothing else is filled in. Added once: pressing again adds nothing. A meeting not typed
 * annual is a 409 `board_term_suggestion_not_offered`; a suggestion put away for this meeting, a
 * 409 `board_term_suggestion_dismissed`.
 */
export const orgBoardOrgAddBoardTermSuggestionItems = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgAddBoardTermSuggestionItemsData, ThrowOnError>): RequestResult<OrgBoardOrgAddBoardTermSuggestionItemsResponses, OrgBoardOrgAddBoardTermSuggestionItemsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgAddBoardTermSuggestionItemsResponses, OrgBoardOrgAddBoardTermSuggestionItemsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/agenda-items/from-term-suggestion', ...options });

/**
 * Org Delete Board Agenda Item
 *
 * Remove an agenda item, closing the gap it leaves in the ordering.
 *
 * A real delete: a planned agenda item is working content, not part of the charity's
 * record. What the board actually took up is recorded with the minutes, where nothing is
 * ever deleted.
 */
export const orgBoardOrgDeleteBoardAgendaItem = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDeleteBoardAgendaItemData, ThrowOnError>): RequestResult<OrgBoardOrgDeleteBoardAgendaItemResponses, OrgBoardOrgDeleteBoardAgendaItemErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgDeleteBoardAgendaItemResponses, OrgBoardOrgDeleteBoardAgendaItemErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/agenda-items/{agenda_item_id}', ...options });

/**
 * Org Update Board Agenda Item
 *
 * Edit an agenda item (skip-None partial update).
 *
 * `disposition` is the mark the carry-forward read selects on: an item the charity marks
 * as left open is what resurfaces on a later agenda. It is a mark the charity applies —
 * the module never infers that an item nobody dispositioned is unfinished business.
 *
 * Editing stays open after the meeting has started, because dispositioning an item is
 * inherently something the recording officer does afterwards.
 */
export const orgBoardOrgUpdateBoardAgendaItem = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardAgendaItemData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardAgendaItemResponses, OrgBoardOrgUpdateBoardAgendaItemErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardAgendaItemResponses, OrgBoardOrgUpdateBoardAgendaItemErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/agenda-items/{agenda_item_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Reorder Board Agenda
 *
 * Reorder the agenda by naming every item once, in the order wanted.
 *
 * The whole agenda rather than a delta: a partial list leaves the unnamed items at
 * positions that may now collide, and reconciling that on the server means guessing at
 * an intent the caller did not state.
 */
export const orgBoardOrgReorderBoardAgenda = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgReorderBoardAgendaData, ThrowOnError>): RequestResult<OrgBoardOrgReorderBoardAgendaResponses, OrgBoardOrgReorderBoardAgendaErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgReorderBoardAgendaResponses, OrgBoardOrgReorderBoardAgendaErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/agenda-order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Approvable Minutes
 *
 * The minutes a motion at this meeting may approve: minutes of earlier meetings the board
 * hasn't approved yet, sent to this reader, whose approval way admits a vote at a meeting now.
 *
 * Named by public facts only — the meeting's title and start, and a closed session's general
 * purpose. A list, never a door: recording the motion decides again.
 */
export const orgBoardOrgListBoardApprovableMinutes = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardApprovableMinutesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardApprovableMinutesResponses, OrgBoardOrgListBoardApprovableMinutesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardApprovableMinutesResponses, OrgBoardOrgListBoardApprovableMinutesErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/approvable-minutes', ...options });

/**
 * Org List Board Meeting Attendance
 *
 * Who the charity recorded as present at one meeting.
 */
export const orgBoardOrgListBoardMeetingAttendance = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardMeetingAttendanceData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardMeetingAttendanceResponses, OrgBoardOrgListBoardMeetingAttendanceErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardMeetingAttendanceResponses, OrgBoardOrgListBoardMeetingAttendanceErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/attendance', ...options });

/**
 * Org List Board Attendance Intents
 *
 * Who has answered for one meeting, and how.
 *
 * An intent, not attendance: who was actually in the room is recorded with the minutes.
 */
export const orgBoardOrgListBoardAttendanceIntents = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardAttendanceIntentsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardAttendanceIntentsResponses, OrgBoardOrgListBoardAttendanceIntentsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardAttendanceIntentsResponses, OrgBoardOrgListBoardAttendanceIntentsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/attendance-intents', ...options });

/**
 * Org Record Board Attendance Intent On Behalf
 *
 * Record a director's attendance intent on their behalf.
 *
 * The manual path, and it is first-class rather than a fallback: a director who
 * telephones, replies to a paper notice, or tells the secretary in the corridor still
 * has an answer on record. The row is stamped as recorded by a charity admin and names
 * the person who entered it, so the charity's own record says which of the two happened.
 */
export const orgBoardOrgRecordBoardAttendanceIntentOnBehalf = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardAttendanceIntentOnBehalfData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardAttendanceIntentOnBehalfResponses, OrgBoardOrgRecordBoardAttendanceIntentOnBehalfErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgRecordBoardAttendanceIntentOnBehalfResponses, OrgBoardOrgRecordBoardAttendanceIntentOnBehalfErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/attendance-intents/{member_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Meeting Attendance
 *
 * Record who was actually in the room, one seat at a time.
 *
 * Distinct from the RSVP: that is what a director said they would do, this is what the
 * charity says happened, and it is what the quorum figures at each vote are counted from.
 *
 * `arrived_at` and `departed_at` are optional instants rather than states, so a seat that
 * came in late AND left early is expressible — and so a vote taken between those two
 * instants counts that seat as present while one taken outside them does not.
 *
 * PUT rather than POST because there is one answer per seat per meeting: recording again
 * corrects it rather than adding a second.
 */
export const orgBoardOrgRecordBoardMeetingAttendance = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardMeetingAttendanceData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardMeetingAttendanceResponses, OrgBoardOrgRecordBoardMeetingAttendanceErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgRecordBoardMeetingAttendanceResponses, OrgBoardOrgRecordBoardMeetingAttendanceErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/attendance/{board_member_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Meeting Calendar
 *
 * The meeting as an iCalendar file, for any calendar application.
 *
 * Generated from the stored row each time it is asked for, so a rescheduled meeting's
 * file carries the new instant and a higher sequence number — which is what makes a
 * calendar application update the entry it already has instead of adding a second one.
 */
export const orgBoardOrgGetBoardMeetingCalendar = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardMeetingCalendarData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardMeetingCalendarResponses, OrgBoardOrgGetBoardMeetingCalendarErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardMeetingCalendarResponses, OrgBoardOrgGetBoardMeetingCalendarErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/calendar', ...options });

/**
 * Org Cancel Board Meeting
 *
 * Cancel a meeting, with a recorded reason.
 *
 * A POST carrying a required reason rather than a status flip on the edit route: the
 * roster was told about this meeting, so calling it off is its own act with its own
 * actor, instant, and explanation. Never a delete. Re-cancelling is a no-op, so a
 * retried request does not read as a failure.
 */
export const orgBoardOrgCancelBoardMeeting = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCancelBoardMeetingData, ThrowOnError>): RequestResult<OrgBoardOrgCancelBoardMeetingResponses, OrgBoardOrgCancelBoardMeetingErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCancelBoardMeetingResponses, OrgBoardOrgCancelBoardMeetingErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/cancellation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Committee Suggestions
 *
 * On a board meeting whose minutes are not approved, the decisions of each committee whose
 * practice is to bring them to the board's next meeting: motions recorded as carried at its own
 * meetings, in the open session, and its executed written consents (none approving minutes),
 * recorded while that practice was on, taken before the meeting's day and on no board meeting's
 * agenda yet. Worked out each time it is read; nothing is added to the agenda until someone adds
 * it. On a committee's meeting, a cancelled one or one whose minutes are approved, `offered` is
 * false and the list is empty.
 */
export const orgBoardOrgGetBoardCommitteeSuggestions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCommitteeSuggestionsData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCommitteeSuggestionsResponses, OrgBoardOrgGetBoardCommitteeSuggestionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCommitteeSuggestionsResponses, OrgBoardOrgGetBoardCommitteeSuggestionsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/committee-suggestions', ...options });

/**
 * Org Restore Board Committee Suggestion
 *
 * Bring the suggested committee decisions back after they were put away for this meeting.
 */
export const orgBoardOrgRestoreBoardCommitteeSuggestion = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRestoreBoardCommitteeSuggestionData, ThrowOnError>): RequestResult<OrgBoardOrgRestoreBoardCommitteeSuggestionResponses, OrgBoardOrgRestoreBoardCommitteeSuggestionErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgRestoreBoardCommitteeSuggestionResponses, OrgBoardOrgRestoreBoardCommitteeSuggestionErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/committee-suggestions/dismissal', ...options });

/**
 * Org Dismiss Board Committee Suggestion
 *
 * Put the suggested committee decisions away for this meeting ("Not for this meeting"),
 * recording who and when. They can be brought back, and the next board meeting suggests them
 * again.
 */
export const orgBoardOrgDismissBoardCommitteeSuggestion = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDismissBoardCommitteeSuggestionData, ThrowOnError>): RequestResult<OrgBoardOrgDismissBoardCommitteeSuggestionResponses, OrgBoardOrgDismissBoardCommitteeSuggestionErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgDismissBoardCommitteeSuggestionResponses, OrgBoardOrgDismissBoardCommitteeSuggestionErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/committee-suggestions/dismissal', ...options });

/**
 * Org List Board Meeting Compensation Decisions
 *
 * A meeting's compensation decisions, on the motions you may read: each with whose pay it
 * set, the documents the board relied on (by name and fingerprint), how the board obtained
 * them, the board's reason when it set pay outside the range in that information, who took
 * part, and when it was written down. With the meeting's uploaded papers a decision may name,
 * and whether its record is still open to change.
 */
export const orgBoardOrgListBoardMeetingCompensationDecisions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardMeetingCompensationDecisionsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardMeetingCompensationDecisionsResponses, OrgBoardOrgListBoardMeetingCompensationDecisionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardMeetingCompensationDecisionsResponses, OrgBoardOrgListBoardMeetingCompensationDecisionsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/compensation-decisions', ...options });

/**
 * Org List Board Conflict Links
 *
 * Every decision recorded for this meeting — confirmed links and dismissed ones.
 *
 * Both, because this answers what you have decided about the meeting. The pre-vote view
 * on the in-meeting record carries confirmations only: showing a dismissal beside a
 * motion would put in front of the board exactly the thing you recorded as not being
 * there.
 *
 * A link naming a motion made inside an executive session you were not part of is
 * absent, like the motion itself.
 */
export const orgBoardOrgListBoardConflictLinks = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardConflictLinksData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardConflictLinksResponses, OrgBoardOrgListBoardConflictLinksErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardConflictLinksResponses, OrgBoardOrgListBoardConflictLinksErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/conflict-links', ...options });

/**
 * Org Record Board Conflict Link
 *
 * Record your decision about one disclosure and one agenda item or motion.
 *
 * `confirmed` records that the disclosure names this item; `dismissed` records that it
 * does not. Both are kept — a dismissal means the same candidate is not put in front of
 * you again, and it says a human looked, which a missing row does not.
 *
 * A confirmed link on a motion, or on the agenda item a motion was made under, appears
 * beside that motion on the in-meeting record so the board can read it before the vote,
 * and enters the minutes when the draft is next refreshed. What appears there is the
 * recorded facts: who disclosed what, when, when you linked it, and whether a recusal
 * for that seat has been recorded on the motion.
 *
 * A disclosure a later one has replaced can still be linked: only the suggestions filter
 * on what stands today, because a meeting may be minuting something that happened while
 * the earlier disclosure was in force.
 *
 * Refused once the minutes of the meeting are approved — from that point the link is
 * inside the record's content hash, and a change is a correction of the minutes.
 */
export const orgBoardOrgRecordBoardConflictLink = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardConflictLinkData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardConflictLinkResponses, OrgBoardOrgRecordBoardConflictLinkErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardConflictLinkResponses, OrgBoardOrgRecordBoardConflictLinkErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/conflict-links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Delete Board Conflict Link
 *
 * Remove a link recorded in error, while the meeting's record is still open.
 *
 * There is no edit: a decision is recorded or it is not, and changing one is removing it
 * and recording the other. Refused once the minutes are approved, like every other write
 * against a closed meeting record.
 */
export const orgBoardOrgDeleteBoardConflictLink = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDeleteBoardConflictLinkData, ThrowOnError>): RequestResult<OrgBoardOrgDeleteBoardConflictLinkResponses, OrgBoardOrgDeleteBoardConflictLinkErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgDeleteBoardConflictLinkResponses, OrgBoardOrgDeleteBoardConflictLinkErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/conflict-links/{link_id}', ...options });

/**
 * Org List Board Conflict Suggestions
 *
 * Candidate links between recorded disclosures and this meeting's items.
 *
 * Each counterparty name recorded on a standing disclosure is looked for in the wording
 * of the meeting's agenda items and motions, matching whole words only. Nothing else is
 * read, and nothing is recorded here: a candidate becomes a fact when you confirm it.
 *
 * `method` says exactly that on every response, because the risky reading of an empty
 * list is that something was checked and found clear. A candidate that does not appear
 * is one this text match did not find.
 */
export const orgBoardOrgListBoardConflictSuggestions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardConflictSuggestionsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardConflictSuggestionsResponses, OrgBoardOrgListBoardConflictSuggestionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardConflictSuggestionsResponses, OrgBoardOrgListBoardConflictSuggestionsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/conflict-suggestions', ...options });

/**
 * Org List Board Documents
 *
 * One meeting's attachments. Never carries a storage key or a read URL.
 */
export const orgBoardOrgListBoardDocuments = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardDocumentsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardDocumentsResponses, OrgBoardOrgListBoardDocumentsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardDocumentsResponses, OrgBoardOrgListBoardDocumentsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/documents', ...options });

/**
 * Org Confirm Board Document
 *
 * Confirm that an attachment finished uploading.
 *
 * Nothing is recorded unless the object is found where the reference says it is: a row
 * for an upload that never completed is an attachment the packet cannot render.
 * `reported_content_digest` is optional and self-reported — this API does not read the
 * object back to check it, and the field name says so.
 */
export const orgBoardOrgConfirmBoardDocument = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgConfirmBoardDocumentData, ThrowOnError>): RequestResult<OrgBoardOrgConfirmBoardDocumentResponses, OrgBoardOrgConfirmBoardDocumentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgConfirmBoardDocumentResponses, OrgBoardOrgConfirmBoardDocumentErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Issue Board Document Upload Url
 *
 * Issue a short-lived signed upload URL for one packet attachment.
 *
 * Two steps — issue, then confirm — so the bytes go straight to storage and never
 * through this API. The URL is bound to the content type declared here, and no row is
 * written until the confirm call finds the object actually there.
 */
export const orgBoardOrgIssueBoardDocumentUploadUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgIssueBoardDocumentUploadUrlData, ThrowOnError>): RequestResult<OrgBoardOrgIssueBoardDocumentUploadUrlResponses, OrgBoardOrgIssueBoardDocumentUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgIssueBoardDocumentUploadUrlResponses, OrgBoardOrgIssueBoardDocumentUploadUrlErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/documents/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Document Download Url
 *
 * Mint a short-lived signed read URL for one attachment. Never persisted.
 */
export const orgBoardOrgGetBoardDocumentDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardDocumentDownloadUrlData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardDocumentDownloadUrlResponses, OrgBoardOrgGetBoardDocumentDownloadUrlErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardDocumentDownloadUrlResponses, OrgBoardOrgGetBoardDocumentDownloadUrlErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/documents/{document_id}/download-url', ...options });

/**
 * Org Get Board In Meeting Record
 *
 * Everything the charity recorded about one meeting, as this reader may see it.
 */
export const orgBoardOrgGetBoardInMeetingRecord = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardInMeetingRecordData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardInMeetingRecordResponses, OrgBoardOrgGetBoardInMeetingRecordErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardInMeetingRecordResponses, OrgBoardOrgGetBoardInMeetingRecordErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/in-meeting-record', ...options });

/**
 * Org Get Board Meeting Invitations
 *
 * How a meeting reached directors' calendars: the sender, the state, and each invited
 * director with their latest reply in their calendar.
 */
export const orgBoardOrgGetBoardMeetingInvitations = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardMeetingInvitationsData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardMeetingInvitationsResponses, OrgBoardOrgGetBoardMeetingInvitationsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardMeetingInvitationsResponses, OrgBoardOrgGetBoardMeetingInvitationsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/invitations', ...options });

/**
 * Org Send Board Meeting Invitations
 *
 * Send a meeting's invitations to the board's active directors from the chosen sender.
 * Scheduling a meeting sends nothing; this is the officer's act. Sending again from the same
 * sender retries what did not go out.
 */
export const orgBoardOrgSendBoardMeetingInvitations = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgSendBoardMeetingInvitationsData, ThrowOnError>): RequestResult<OrgBoardOrgSendBoardMeetingInvitationsResponses, OrgBoardOrgSendBoardMeetingInvitationsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgSendBoardMeetingInvitationsResponses, OrgBoardOrgSendBoardMeetingInvitationsErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Directors Told
 *
 * Record that an officer told the directors about a meeting's earlier invitations, which
 * Board can't prove are gone: the warning clears and Board stops acting on those invitations.
 * Sends nothing (CBG-FIX32).
 */
export const orgBoardOrgRecordBoardDirectorsTold = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardDirectorsToldData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardDirectorsToldResponses, OrgBoardOrgRecordBoardDirectorsToldErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardDirectorsToldResponses, OrgBoardOrgRecordBoardDirectorsToldErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/invitations/directors-told', ...options });

/**
 * Org Reinvite Board Meeting Invitee
 *
 * Invite one director again, including one removed from the invitation in a calendar.
 */
export const orgBoardOrgReinviteBoardMeetingInvitee = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgReinviteBoardMeetingInviteeData, ThrowOnError>): RequestResult<OrgBoardOrgReinviteBoardMeetingInviteeResponses, OrgBoardOrgReinviteBoardMeetingInviteeErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgReinviteBoardMeetingInviteeResponses, OrgBoardOrgReinviteBoardMeetingInviteeErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/invitations/invitees/{member_id}', ...options });

/**
 * Org Move Board Meeting Invitations
 *
 * Send a meeting's invitations from another sender instead (directors get one
 * cancellation and one new invitation), or stop keeping it in step with a calendar.
 */
export const orgBoardOrgMoveBoardMeetingInvitations = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgMoveBoardMeetingInvitationsData, ThrowOnError>): RequestResult<OrgBoardOrgMoveBoardMeetingInvitationsResponses, OrgBoardOrgMoveBoardMeetingInvitationsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgMoveBoardMeetingInvitationsResponses, OrgBoardOrgMoveBoardMeetingInvitationsErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/invitations/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Schedule Restored Board Meeting
 *
 * Schedule again a meeting that was cancelled in the organizer's calendar and is back
 * there: a new meeting linked to the restored event, with the old meeting's agenda. Sends no
 * invitation.
 */
export const orgBoardOrgScheduleRestoredBoardMeeting = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgScheduleRestoredBoardMeetingData, ThrowOnError>): RequestResult<OrgBoardOrgScheduleRestoredBoardMeetingResponses, OrgBoardOrgScheduleRestoredBoardMeetingErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgScheduleRestoredBoardMeetingResponses, OrgBoardOrgScheduleRestoredBoardMeetingErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/invitations/rescheduling', ...options });

/**
 * Org List Board Meeting Events
 *
 * One meeting's append-only event log, oldest first.
 *
 * It exists for the notice figures: a meeting moved from twenty days out to three shows
 * its final count, and this log is where a reader sees that it was once different.
 */
export const orgBoardOrgListBoardMeetingEvents = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardMeetingEventsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardMeetingEventsResponses, OrgBoardOrgListBoardMeetingEventsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardMeetingEventsResponses, OrgBoardOrgListBoardMeetingEventsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/meeting-events', ...options });

/**
 * Org Get Board Minutes
 *
 * The minutes of one meeting — or, with `segment_id`, of one of its closed sessions.
 */
export const orgBoardOrgGetBoardMinutes = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardMinutesData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardMinutesResponses, OrgBoardOrgGetBoardMinutesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardMinutesResponses, OrgBoardOrgGetBoardMinutesErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/minutes', ...options });

/**
 * Org Write Board Minutes Draft
 *
 * Open or refresh the minutes draft for a meeting, or for one of its closed sessions.
 *
 * What the charity recorded about the meeting — who was present, the sessions, the motions
 * with their votes and recusals and the quorum figures at each — is assembled by the module
 * and returned as `structured_record`. `body` is the recording officer's own sections and
 * is theirs alone; the two are separate fields so it stays answerable afterwards which
 * words were whose.
 *
 * Call it again while the minutes are a draft and the assembled part is re-taken, so a
 * motion recorded after the draft was opened is in it. Once the board has approved them it
 * is refused: a change to approved minutes is recorded as a correction.
 */
export const orgBoardOrgWriteBoardMinutesDraft = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgWriteBoardMinutesDraftData, ThrowOnError>): RequestResult<OrgBoardOrgWriteBoardMinutesDraftResponses, OrgBoardOrgWriteBoardMinutesDraftErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgWriteBoardMinutesDraftResponses, OrgBoardOrgWriteBoardMinutesDraftErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/minutes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Approve Board Minutes
 *
 * Approve minutes as the recording officer.
 *
 * The other door is a motion the board carries at its next meeting, which records which
 * meeting approved them. Both write the same approval event and name a human.
 *
 * `content_hash` is the address of the exact minutes being approved. If they changed since
 * they were read, the approval is refused rather than applied to different words.
 */
export const orgBoardOrgApproveBoardMinutes = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgApproveBoardMinutesData, ThrowOnError>): RequestResult<OrgBoardOrgApproveBoardMinutesResponses, OrgBoardOrgApproveBoardMinutesErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgApproveBoardMinutesResponses, OrgBoardOrgApproveBoardMinutesErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/minutes/approval',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Ask Board Minutes Approval Signatures
 *
 * Ask the directors who were in a closed session to sign to approve its minutes.
 *
 * Only where the board's own rule approves a closed session's minutes by the signatures of the
 * directors who were there; any other way is the typed 409 `board_minutes_approval_way`. Asked:
 * every seat recorded as in the session that is a director now, recused from a decision in it or
 * not. Not a written consent: it is never every director's. `content_hash` is the bytes read; the
 * minutes stay a draft while the request is out, and the last asked signature on the current
 * bytes approves them. Nobody to ask, or a request already out, is a typed 409; nothing written.
 */
export const orgBoardOrgAskBoardMinutesApprovalSignatures = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgAskBoardMinutesApprovalSignaturesData, ThrowOnError>): RequestResult<OrgBoardOrgAskBoardMinutesApprovalSignaturesResponses, OrgBoardOrgAskBoardMinutesApprovalSignaturesErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgAskBoardMinutesApprovalSignaturesResponses, OrgBoardOrgAskBoardMinutesApprovalSignaturesErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/minutes/approval-signatures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Minutes Approval Signature On Behalf
 *
 * Record an asked director's signature to approve, given on paper or by email.
 *
 * The officer's entry, never the director's own act: it records that the officer wrote it down,
 * with a required note saying where the signature came from. The seat must be one the open
 * request asked (else the typed 409 `board_minutes_not_asked_to_sign`). It may be the last
 * signature, and then the minutes are approved.
 */
export const orgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalf = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfResponses, OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfResponses, OrgBoardOrgRecordBoardMinutesApprovalSignatureOnBehalfErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/minutes/approval-signatures/on-behalf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Withdraw Board Minutes Approval Signatures
 *
 * Withdraw the open request for signatures on a closed session's minutes, with the reason.
 *
 * The signatures already given stay in the minutes' history and count for nothing; asking
 * again starts fresh. No request out is a typed 409 `board_minutes_no_signatures_asked`.
 */
export const orgBoardOrgWithdrawBoardMinutesApprovalSignatures = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesData, ThrowOnError>): RequestResult<OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesResponses, OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesResponses, OrgBoardOrgWithdrawBoardMinutesApprovalSignaturesErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/minutes/approval-signatures/withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Send Board Minutes Reminder
 *
 * Send the board a reminder that a meeting's minutes are not yet recorded.
 *
 * An act the charity performs; nothing schedules it. The response carries the same dates
 * the in-app view shows, and `skip_reason` says why no mail went out when none did, rather
 * than leaving a count of zero to read as a failure.
 */
export const orgBoardOrgSendBoardMinutesReminder = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgSendBoardMinutesReminderData, ThrowOnError>): RequestResult<OrgBoardOrgSendBoardMinutesReminderResponses, OrgBoardOrgSendBoardMinutesReminderErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgSendBoardMinutesReminderResponses, OrgBoardOrgSendBoardMinutesReminderErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/minutes/reminders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Sign Board Minutes On Behalf
 *
 * Record a signature someone on the roster gave on paper.
 *
 * The manual path, and it stays valid forever: nothing about the board's ability to record
 * its own minutes depends on a director adopting the portal. The entry records that the
 * officer wrote it down, never that the person acted inside their own session, and it
 * carries a required note saying where the signature came from.
 *
 * `capacity_title_id` (optional) records the title they signed as: one of the titles that seat
 * holds now, kept with the signature in the words it has today, so a later rename never changes
 * it. A title the seat doesn't hold is a 409 `board_signature_capacity_not_held`.
 */
export const orgBoardOrgSignBoardMinutesOnBehalf = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgSignBoardMinutesOnBehalfData, ThrowOnError>): RequestResult<OrgBoardOrgSignBoardMinutesOnBehalfResponses, OrgBoardOrgSignBoardMinutesOnBehalfErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgSignBoardMinutesOnBehalfResponses, OrgBoardOrgSignBoardMinutesOnBehalfErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/minutes/signatures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Motions
 *
 * One meeting's motions, in order, as this reader may see them.
 *
 * A motion made inside a closed session this reader was not part of does not appear.
 */
export const orgBoardOrgListBoardMotions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardMotionsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardMotionsResponses, OrgBoardOrgListBoardMotionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardMotionsResponses, OrgBoardOrgListBoardMotionsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/motions', ...options });

/**
 * Org Create Board Motion
 *
 * Record a motion as put — its exact wording, who moved it, and who seconded it.
 *
 * An amendment names the motion it amends, so the board's own drafting history stays
 * walkable. The wording stays editable until a vote is recorded and is frozen from then on.
 */
export const orgBoardOrgCreateBoardMotion = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardMotionData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardMotionResponses, OrgBoardOrgCreateBoardMotionErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardMotionResponses, OrgBoardOrgCreateBoardMotionErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/motions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Delete Board Motion
 *
 * Remove a motion recorded in error, while no vote on it has been recorded.
 */
export const orgBoardOrgDeleteBoardMotion = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDeleteBoardMotionData, ThrowOnError>): RequestResult<OrgBoardOrgDeleteBoardMotionResponses, OrgBoardOrgDeleteBoardMotionErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgDeleteBoardMotionResponses, OrgBoardOrgDeleteBoardMotionErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/motions/{motion_id}', ...options });

/**
 * Org Update Board Motion
 *
 * Edit a motion recorded in error, before a vote on it is recorded.
 */
export const orgBoardOrgUpdateBoardMotion = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardMotionData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardMotionResponses, OrgBoardOrgUpdateBoardMotionErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardMotionResponses, OrgBoardOrgUpdateBoardMotionErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/motions/{motion_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Add Board Motion Compensation Decision
 *
 * Record the board's compensation decision for one person on a motion it carried, after the
 * motion's others: whose pay, their position, the meeting's papers the board relied on, how it
 * obtained them, and its reason when it set pay outside the range in that information. Board
 * reads each paper's stored bytes and records its fingerprint. Refused once the meeting's
 * minutes are approved.
 */
export const orgBoardOrgAddBoardMotionCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgAddBoardMotionCompensationDecisionData, ThrowOnError>): RequestResult<OrgBoardOrgAddBoardMotionCompensationDecisionResponses, OrgBoardOrgAddBoardMotionCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgAddBoardMotionCompensationDecisionResponses, OrgBoardOrgAddBoardMotionCompensationDecisionErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/motions/{motion_id}/compensation-decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Remove Board Motion Compensation Decision
 *
 * Remove one decision recorded on a motion, while the meeting's record is open. Its history
 * keeps who recorded and removed it, and when.
 */
export const orgBoardOrgRemoveBoardMotionCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemoveBoardMotionCompensationDecisionData, ThrowOnError>): RequestResult<OrgBoardOrgRemoveBoardMotionCompensationDecisionResponses, OrgBoardOrgRemoveBoardMotionCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgRemoveBoardMotionCompensationDecisionResponses, OrgBoardOrgRemoveBoardMotionCompensationDecisionErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/motions/{motion_id}/compensation-decisions/{decision_id}', ...options });

/**
 * Org Replace Board Motion Compensation Decision
 *
 * Replace one decision's details whole, while the meeting's record is open. A paper it keeps
 * keeps the fingerprint it was recorded with. Minutes drafted before the change name the old
 * details until they are refreshed.
 */
export const orgBoardOrgReplaceBoardMotionCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgReplaceBoardMotionCompensationDecisionData, ThrowOnError>): RequestResult<OrgBoardOrgReplaceBoardMotionCompensationDecisionResponses, OrgBoardOrgReplaceBoardMotionCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgReplaceBoardMotionCompensationDecisionResponses, OrgBoardOrgReplaceBoardMotionCompensationDecisionErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/motions/{motion_id}/compensation-decisions/{decision_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Minutes Approval Vote
 *
 * Record the vote on a motion that approves prior minutes.
 *
 * Its own route because a carried vote here does something the ordinary one never does: it
 * turns a draft into the charity's record. The minutes then name the seat the charity
 * recorded as presiding as the person whose declaration concluded the board's approval,
 * the instant, and the exact bytes approved.
 *
 * A vote recorded as failed is recorded exactly that way and the minutes stay a draft — the
 * board declined to approve them, which is itself something the book should say.
 */
export const orgBoardOrgRecordBoardMinutesApprovalVote = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardMinutesApprovalVoteData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardMinutesApprovalVoteResponses, OrgBoardOrgRecordBoardMinutesApprovalVoteErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardMinutesApprovalVoteResponses, OrgBoardOrgRecordBoardMinutesApprovalVoteErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/motions/{motion_id}/minutes-approval',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Motion Recusal
 *
 * Record a seat as having stood out of the debate and the vote on one motion.
 *
 * Two things follow, and the second is the one boards most often get wrong. The seat's
 * vote becomes uncastable — recording one is refused. And the seat STILL counts among the
 * seats recorded as present, because standing out of a vote is not leaving the room; under
 * Delaware General Corporation Law section 144(d)(1) an interested director is counted for
 * that purpose, and dropping them would tell a board it had lost the seats it needed to act
 * every time someone was conflicted.
 */
export const orgBoardOrgRecordBoardMotionRecusal = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardMotionRecusalData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardMotionRecusalResponses, OrgBoardOrgRecordBoardMotionRecusalErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardMotionRecusalResponses, OrgBoardOrgRecordBoardMotionRecusalErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/motions/{motion_id}/recusals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Remove Board Motion Recusal
 *
 * Remove a recusal recorded in error, before a vote on the motion is recorded.
 */
export const orgBoardOrgRemoveBoardMotionRecusal = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemoveBoardMotionRecusalData, ThrowOnError>): RequestResult<OrgBoardOrgRemoveBoardMotionRecusalResponses, OrgBoardOrgRemoveBoardMotionRecusalErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgRemoveBoardMotionRecusalResponses, OrgBoardOrgRemoveBoardMotionRecusalErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/motions/{motion_id}/recusals/{board_member_id}', ...options });

/**
 * Org Record Board Motion Vote
 *
 * Record the vote on a motion.
 *
 * Two ways to record it, and both are first class: name each seat's own cast, or give the
 * three counts. With the casts recorded the counts are taken from them, so the two can
 * never disagree.
 *
 * The response carries the quorum figures captured at the instant of the vote — how many
 * of the board's seats were recorded as present, against the quorum the charity itself
 * recorded, with the section of its own governing instrument that number came from. A
 * shortfall is stated in seats and never blocks: the board owns its own acts.
 *
 * `outcome` is what the charity records. The module states the tally beside the recorded
 * threshold; whether a motion carried is the chair's declaration.
 *
 * A motion that approves prior minutes is refused here and belongs on the minutes-approval
 * route, which requires the authority to record the charity's own minute book.
 */
export const orgBoardOrgRecordBoardMotionVote = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardMotionVoteData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardMotionVoteResponses, OrgBoardOrgRecordBoardMotionVoteErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardMotionVoteResponses, OrgBoardOrgRecordBoardMotionVoteErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/motions/{motion_id}/vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Withdraw Board Motion
 *
 * Record a motion as withdrawn before it was voted on.
 *
 * Recorded rather than deleted: withdrawing is a real thing the board did. It also takes
 * the motion out of the carry-forward list, which reports only what is still open.
 */
export const orgBoardOrgWithdrawBoardMotion = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgWithdrawBoardMotionData, ThrowOnError>): RequestResult<OrgBoardOrgWithdrawBoardMotionResponses, OrgBoardOrgWithdrawBoardMotionErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgWithdrawBoardMotionResponses, OrgBoardOrgWithdrawBoardMotionErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/motions/{motion_id}/withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Packets
 *
 * A meeting's packet versions, newest first. Contents are not hydrated here.
 */
export const orgBoardOrgListBoardPackets = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardPacketsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardPacketsResponses, OrgBoardOrgListBoardPacketsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardPacketsResponses, OrgBoardOrgListBoardPacketsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/packets', ...options });

/**
 * Org Create Board Packet
 *
 * Open the next draft packet version for a meeting.
 *
 * The version number is assigned by the module. At most one draft is in flight at a
 * time: two drafts for one meeting are two people assembling different packets with no
 * way to say which is next.
 */
export const orgBoardOrgCreateBoardPacket = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardPacketData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardPacketResponses, OrgBoardOrgCreateBoardPacketErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardPacketResponses, OrgBoardOrgCreateBoardPacketErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/packets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Meeting Presiding
 *
 * Who presided at the meeting, the people recorded as present (each as the minutes would
 * name them presiding), and whom the board's adopted duties suggest: the person present who held,
 * on the meeting's day, a title the duties give presiding. Nothing is recorded by reading it.
 */
export const orgBoardOrgGetBoardMeetingPresiding = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardMeetingPresidingData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardMeetingPresidingResponses, OrgBoardOrgGetBoardMeetingPresidingErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardMeetingPresidingResponses, OrgBoardOrgGetBoardMeetingPresidingErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/presiding', ...options });

/**
 * Org Record Board Meeting Presiding
 *
 * Record who presided at the meeting, or clear it with a null.
 *
 * A recorded fact, the officer's entry in "Who was there": one of the people recorded as present,
 * never derived from a title. At most one person presides per meeting, and only someone recorded
 * as present — both held by the database. Answers the meeting's attendance rows as they now
 * stand, the presiding person's carrying `presided: true`.
 */
export const orgBoardOrgRecordBoardMeetingPresiding = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardMeetingPresidingData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardMeetingPresidingResponses, OrgBoardOrgRecordBoardMeetingPresidingErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgRecordBoardMeetingPresidingResponses, OrgBoardOrgRecordBoardMeetingPresidingErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/presiding',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Meeting Segments
 *
 * The parts of one meeting, in order, as this reader may see them.
 *
 * A closed session this reader was not part of does not appear, and no ordinal is carried
 * on the wire — an index on a list that may have had entries withheld would count them.
 */
export const orgBoardOrgListBoardMeetingSegments = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardMeetingSegmentsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardMeetingSegmentsResponses, OrgBoardOrgListBoardMeetingSegmentsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardMeetingSegmentsResponses, OrgBoardOrgListBoardMeetingSegmentsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/sessions', ...options });

/**
 * Org Create Board Meeting Segment
 *
 * Record a part of a meeting — an ordinary session, or an executive session.
 *
 * An executive session carries its own participant list, and everything recorded inside it
 * is readable only by those participants. That binds charity admins as well as directors:
 * an administrator who was not in the room does not see it, and it is ABSENT for them
 * rather than refused.
 */
export const orgBoardOrgCreateBoardMeetingSegment = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardMeetingSegmentData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardMeetingSegmentResponses, OrgBoardOrgCreateBoardMeetingSegmentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardMeetingSegmentResponses, OrgBoardOrgCreateBoardMeetingSegmentErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Reorder Board Meeting Segments
 *
 * Reorder a meeting's sessions by naming every one once, in the order wanted.
 */
export const orgBoardOrgReorderBoardMeetingSegments = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgReorderBoardMeetingSegmentsData, ThrowOnError>): RequestResult<OrgBoardOrgReorderBoardMeetingSegmentsResponses, OrgBoardOrgReorderBoardMeetingSegmentsErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgReorderBoardMeetingSegmentsResponses, OrgBoardOrgReorderBoardMeetingSegmentsErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/sessions/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Delete Board Meeting Segment
 *
 * Remove a session recorded in error, while the minutes are still a draft.
 */
export const orgBoardOrgDeleteBoardMeetingSegment = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDeleteBoardMeetingSegmentData, ThrowOnError>): RequestResult<OrgBoardOrgDeleteBoardMeetingSegmentResponses, OrgBoardOrgDeleteBoardMeetingSegmentErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgDeleteBoardMeetingSegmentResponses, OrgBoardOrgDeleteBoardMeetingSegmentErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/sessions/{segment_id}', ...options });

/**
 * Org Update Board Meeting Segment
 *
 * Edit a recorded session.
 *
 * Which KIND of session it is cannot be changed here or anywhere: that would change who may
 * read everything recorded inside it, and a field flip is how a closed session gets
 * published by accident.
 */
export const orgBoardOrgUpdateBoardMeetingSegment = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardMeetingSegmentData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardMeetingSegmentResponses, OrgBoardOrgUpdateBoardMeetingSegmentErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardMeetingSegmentResponses, OrgBoardOrgUpdateBoardMeetingSegmentErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/sessions/{segment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Segment Participant
 *
 * Record one person as present for a session — a seat on this board, or someone else.
 *
 * A non-director the board invited in is named outright, because the point of a closed
 * session's list is who was in the room. A seat's name is taken from the roster and stored
 * as it stood then, so a later rename does not change what this says about that evening.
 */
export const orgBoardOrgRecordBoardSegmentParticipant = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardSegmentParticipantData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardSegmentParticipantResponses, OrgBoardOrgRecordBoardSegmentParticipantErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardSegmentParticipantResponses, OrgBoardOrgRecordBoardSegmentParticipantErrors, ThrowOnError>({
    url: '/board/{org_ref}/meetings/{meeting_id}/sessions/{segment_id}/participants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Remove Board Segment Participant
 *
 * Remove someone recorded in error, while the minutes are still a draft.
 */
export const orgBoardOrgRemoveBoardSegmentParticipant = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemoveBoardSegmentParticipantData, ThrowOnError>): RequestResult<OrgBoardOrgRemoveBoardSegmentParticipantResponses, OrgBoardOrgRemoveBoardSegmentParticipantErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgRemoveBoardSegmentParticipantResponses, OrgBoardOrgRemoveBoardSegmentParticipantErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/sessions/{segment_id}/participants/{participant_id}', ...options });

/**
 * Org Get Board Term Suggestions
 *
 * On a meeting typed annual, the terms on the roster that have ended, or end within three
 * months of the meeting: directors by their current term's recorded end, officers by their
 * title's recorded end (or, when the board recorded its officers' term length, the end it gives).
 * Worked out each time it is read; nothing here is stored but a dismissal, and nothing is added
 * to the agenda until someone adds it. On any other meeting, `offered` is false and the lists
 * are empty.
 */
export const orgBoardOrgGetBoardTermSuggestions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardTermSuggestionsData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardTermSuggestionsResponses, OrgBoardOrgGetBoardTermSuggestionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardTermSuggestionsResponses, OrgBoardOrgGetBoardTermSuggestionsErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/term-suggestions', ...options });

/**
 * Org Restore Board Term Suggestion
 *
 * Bring the annual meeting's election suggestion back after it was put away.
 */
export const orgBoardOrgRestoreBoardTermSuggestion = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRestoreBoardTermSuggestionData, ThrowOnError>): RequestResult<OrgBoardOrgRestoreBoardTermSuggestionResponses, OrgBoardOrgRestoreBoardTermSuggestionErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgRestoreBoardTermSuggestionResponses, OrgBoardOrgRestoreBoardTermSuggestionErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/term-suggestions/dismissal', ...options });

/**
 * Org Dismiss Board Term Suggestion
 *
 * Put the annual meeting's election suggestion away for this meeting ("Not for this
 * meeting"), recording who and when. It can be brought back.
 */
export const orgBoardOrgDismissBoardTermSuggestion = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDismissBoardTermSuggestionData, ThrowOnError>): RequestResult<OrgBoardOrgDismissBoardTermSuggestionResponses, OrgBoardOrgDismissBoardTermSuggestionErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgDismissBoardTermSuggestionResponses, OrgBoardOrgDismissBoardTermSuggestionErrors, ThrowOnError>({ url: '/board/{org_ref}/meetings/{meeting_id}/term-suggestions/dismissal', ...options });

/**
 * Org List Board Member Proposals
 *
 * The board members a connected AI proposed that wait for a person to add or discard them,
 * oldest first: each one's details as proposed, the AI's note on where it found them, and whose
 * connection proposed them. None of them is on the board until a person adds them.
 */
export const orgBoardOrgListBoardMemberProposals = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardMemberProposalsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardMemberProposalsResponses, OrgBoardOrgListBoardMemberProposalsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardMemberProposalsResponses, OrgBoardOrgListBoardMemberProposalsErrors, ThrowOnError>({ url: '/board/{org_ref}/member-proposals', ...options });

/**
 * Org Discard Board Member Proposal
 *
 * Discard a proposed board member. Nobody is added, and the proposal keeps no name or
 * address. A person's act: a connected AI cannot discard one.
 */
export const orgBoardOrgDiscardBoardMemberProposal = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDiscardBoardMemberProposalData, ThrowOnError>): RequestResult<OrgBoardOrgDiscardBoardMemberProposalResponses, OrgBoardOrgDiscardBoardMemberProposalErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgDiscardBoardMemberProposalResponses, OrgBoardOrgDiscardBoardMemberProposalErrors, ThrowOnError>({ url: '/board/{org_ref}/member-proposals/{proposal_id}/discard', ...options });

/**
 * Org List Board Members
 *
 * The charity's board roster, newest first.
 *
 * Active seats only unless `include_removed` is set: the ordinary question is who is on
 * the board, and roster history — which is never deleted — is opt-in.
 */
export const orgBoardOrgListBoardMembers = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardMembersData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardMembersResponses, OrgBoardOrgListBoardMembersErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardMembersResponses, OrgBoardOrgListBoardMembersErrors, ThrowOnError>({ url: '/board/{org_ref}/members', ...options });

/**
 * Org Create Board Member
 *
 * Add a seat to the roster.
 *
 * A seat is created from a name and an email of record — nothing else, and nothing about
 * a Givmo account. A director may sit on this roster, receive packets, and have acts
 * recorded on their behalf without ever signing in; their own Givmo account connects to
 * the seat later, through an invitation and a proof of the mailbox, or never.
 */
export const orgBoardOrgCreateBoardMember = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardMemberData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardMemberResponses, OrgBoardOrgCreateBoardMemberErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardMemberResponses, OrgBoardOrgCreateBoardMemberErrors, ThrowOnError>({
    url: '/board/{org_ref}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Member
 *
 * Twin of ``get_board_member``.
 */
export const orgBoardOrgGetBoardMember = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardMemberData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardMemberResponses, OrgBoardOrgGetBoardMemberErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardMemberResponses, OrgBoardOrgGetBoardMemberErrors, ThrowOnError>({ url: '/board/{org_ref}/members/{member_id}', ...options });

/**
 * Org Update Board Member
 *
 * Edit a seat (skip-None partial update).
 *
 * Cannot end a seat — that is its own operation, because it kills live credentials and a
 * spelling fix should not travel on the same route.
 */
export const orgBoardOrgUpdateBoardMember = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardMemberData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardMemberResponses, OrgBoardOrgUpdateBoardMemberErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardMemberResponses, OrgBoardOrgUpdateBoardMemberErrors, ThrowOnError>({
    url: '/board/{org_ref}/members/{member_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Mint Board Access Link
 *
 * Mint a director's invitation link, and mail it when the module can.
 *
 * The response carries the PLAINTEXT token — the one place it ever appears in one. That
 * is a real product path, not a fallback: the recording officer hands a director their
 * link directly (reads it out, pastes it into their own message, prints it), and a module
 * that only ever emailed links would make the volunteer's actual route in impossible. It
 * is safe to hand over: the link only lets the director join with their own Givmo account
 * and their own mailbox. The stored row keeps only the token's digest. A seat whose director
 * has already joined is refused (`board_seat_already_connected`).
 *
 * `email_sent` reports whether a mail also went out. It is false when no template or no
 * board-app base URL is configured, so the caller is told what happened rather than left
 * to assume.
 */
export const orgBoardOrgMintBoardAccessLink = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgMintBoardAccessLinkData, ThrowOnError>): RequestResult<OrgBoardOrgMintBoardAccessLinkResponses, OrgBoardOrgMintBoardAccessLinkErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgMintBoardAccessLinkResponses, OrgBoardOrgMintBoardAccessLinkErrors, ThrowOnError>({ url: '/board/{org_ref}/members/{member_id}/access-links', ...options });

/**
 * Org Release Board Member Account
 *
 * Disconnect the Givmo account that joined the board through this seat, with a recorded
 * reason.
 *
 * The seat stays on the roster and can be invited and joined again; the account's next
 * request as a director is refused. Both the account's own email and the seat's address are
 * told. Changing a seat's email address never disconnects its account — this does, and only
 * this. A seat no account has joined is refused (`board_seat_not_connected`).
 */
export const orgBoardOrgReleaseBoardMemberAccount = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgReleaseBoardMemberAccountData, ThrowOnError>): RequestResult<OrgBoardOrgReleaseBoardMemberAccountResponses, OrgBoardOrgReleaseBoardMemberAccountErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgReleaseBoardMemberAccountResponses, OrgBoardOrgReleaseBoardMemberAccountErrors, ThrowOnError>({
    url: '/board/{org_ref}/members/{member_id}/account-release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Paper Acknowledgments
 *
 * Record a signed paper form: that this member signed a paper acknowledgment of these
 * documents, on the date written on it, with a note on where it came from. Each document is
 * recorded as acknowledged, exactly the version named, as entered by you from a paper form.
 */
export const orgBoardOrgRecordBoardPaperAcknowledgments = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardPaperAcknowledgmentsData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardPaperAcknowledgmentsResponses, OrgBoardOrgRecordBoardPaperAcknowledgmentsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardPaperAcknowledgmentsResponses, OrgBoardOrgRecordBoardPaperAcknowledgmentsErrors, ThrowOnError>({
    url: '/board/{org_ref}/members/{member_id}/acknowledgments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Add Board Member To Board
 *
 * Add someone who serves on a committee to the board (CBG-YR6-OUTSIDE-WIDEN): their seat,
 * one for someone who isn't on the board, becomes the board's.
 *
 * The Owner's act, its own operation, as ending a seat is: from the next request the board's
 * meetings, papers, minutes and written consents are open to the seat's account, earlier ones
 * included, and the board's year counts the person as joining today. Nothing else about the seat
 * changes — whether they're a director, and any title, are recorded afterwards — and it can't be
 * undone: a board seat never becomes a committee's alone. No body. A seat someone has joined is
 * emailed to say so.
 */
export const orgBoardOrgAddBoardMemberToBoard = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgAddBoardMemberToBoardData, ThrowOnError>): RequestResult<OrgBoardOrgAddBoardMemberToBoardResponses, OrgBoardOrgAddBoardMemberToBoardErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgAddBoardMemberToBoardResponses, OrgBoardOrgAddBoardMemberToBoardErrors, ThrowOnError>({ url: '/board/{org_ref}/members/{member_id}/board-addition', ...options });

/**
 * Org Get Board Member Getting Started
 *
 * A member's getting-started list, each item with what the records say about it: a document
 * confirmed (in Board, from a paper form, or in their annual disclosure) or not yet, their first
 * disclosure, their board buddy, the board's own steps.
 */
export const orgBoardOrgGetBoardMemberGettingStarted = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardMemberGettingStartedData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardMemberGettingStartedResponses, OrgBoardOrgGetBoardMemberGettingStartedErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardMemberGettingStartedResponses, OrgBoardOrgGetBoardMemberGettingStartedErrors, ThrowOnError>({ url: '/board/{org_ref}/members/{member_id}/getting-started', ...options });

/**
 * Org Start Board Member Getting Started
 *
 * Start a getting-started list for a member who has none, from the board's list.
 */
export const orgBoardOrgStartBoardMemberGettingStarted = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgStartBoardMemberGettingStartedData, ThrowOnError>): RequestResult<OrgBoardOrgStartBoardMemberGettingStartedResponses, OrgBoardOrgStartBoardMemberGettingStartedErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgStartBoardMemberGettingStartedResponses, OrgBoardOrgStartBoardMemberGettingStartedErrors, ThrowOnError>({ url: '/board/{org_ref}/members/{member_id}/getting-started', ...options });

/**
 * Org Save Board Member Getting Started
 *
 * Change one member's list from the revision you read: an item sent with its id stays (a
 * step keeps its done date), one without is added, one left out is removed.
 */
export const orgBoardOrgSaveBoardMemberGettingStarted = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgSaveBoardMemberGettingStartedData, ThrowOnError>): RequestResult<OrgBoardOrgSaveBoardMemberGettingStartedResponses, OrgBoardOrgSaveBoardMemberGettingStartedErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgSaveBoardMemberGettingStartedResponses, OrgBoardOrgSaveBoardMemberGettingStartedErrors, ThrowOnError>({
    url: '/board/{org_ref}/members/{member_id}/getting-started',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Choose Board Member Buddy
 *
 * Choose a member's board buddy: someone serving on the board. It's recorded on the member's
 * history; the buddy is sent nothing and asked to do nothing.
 */
export const orgBoardOrgChooseBoardMemberBuddy = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgChooseBoardMemberBuddyData, ThrowOnError>): RequestResult<OrgBoardOrgChooseBoardMemberBuddyResponses, OrgBoardOrgChooseBoardMemberBuddyErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgChooseBoardMemberBuddyResponses, OrgBoardOrgChooseBoardMemberBuddyErrors, ThrowOnError>({
    url: '/board/{org_ref}/members/{member_id}/getting-started/buddy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Close Board Member Getting Started
 *
 * Close a member's list — for someone who left, or a list the board considers done. It can't
 * be reopened.
 */
export const orgBoardOrgCloseBoardMemberGettingStarted = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCloseBoardMemberGettingStartedData, ThrowOnError>): RequestResult<OrgBoardOrgCloseBoardMemberGettingStartedResponses, OrgBoardOrgCloseBoardMemberGettingStartedErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCloseBoardMemberGettingStartedResponses, OrgBoardOrgCloseBoardMemberGettingStartedErrors, ThrowOnError>({ url: '/board/{org_ref}/members/{member_id}/getting-started/closure', ...options });

/**
 * Org Mark Board Member Getting Started Step
 *
 * Mark one of the board's own steps done on a member's list, with the date, or clear it.
 */
export const orgBoardOrgMarkBoardMemberGettingStartedStep = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgMarkBoardMemberGettingStartedStepData, ThrowOnError>): RequestResult<OrgBoardOrgMarkBoardMemberGettingStartedStepResponses, OrgBoardOrgMarkBoardMemberGettingStartedStepErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgMarkBoardMemberGettingStartedStepResponses, OrgBoardOrgMarkBoardMemberGettingStartedStepErrors, ThrowOnError>({
    url: '/board/{org_ref}/members/{member_id}/getting-started/items/{item_id}/done',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Member History
 *
 * One seat's history, newest first: when it was added and edited, every change to its
 * email address (the old and the new one), every invitation and whether it was emailed, who
 * joined with which Givmo account and how, any account disconnected and why, and the
 * removal. Each entry names who did it.
 *
 * Owner-only, because the entries carry a director's addresses. Readable for a removed
 * seat too.
 */
export const orgBoardOrgListBoardMemberHistory = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardMemberHistoryData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardMemberHistoryResponses, OrgBoardOrgListBoardMemberHistoryErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardMemberHistoryResponses, OrgBoardOrgListBoardMemberHistoryErrors, ThrowOnError>({ url: '/board/{org_ref}/members/{member_id}/history', ...options });

/**
 * Org Remove Board Member
 *
 * End a seat, with a recorded reason.
 *
 * Never a delete: the row and its history stay, because who sat on this board and when
 * is part of the charity's record and a former director's past acts must keep resolving
 * to a named seat. Every outstanding invitation of that seat dies with it, and the seat's
 * own standing is re-read on every director request — so removal takes effect on the
 * director's very next call.
 */
export const orgBoardOrgRemoveBoardMember = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemoveBoardMemberData, ThrowOnError>): RequestResult<OrgBoardOrgRemoveBoardMemberResponses, OrgBoardOrgRemoveBoardMemberErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRemoveBoardMemberResponses, OrgBoardOrgRemoveBoardMemberErrors, ThrowOnError>({
    url: '/board/{org_ref}/members/{member_id}/removal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Member Term
 *
 * Record a term of this seat: the organization's own start and end (at least one), its
 * class, whether the board counts it toward its limit on consecutive terms, the minute-book
 * record it came from (`record_id`) or none, and a note. Saved as entered: dates that overlap
 * another term, or run past the term length or the limit the board recorded, are recorded as
 * they are. A term changes no vote, quorum or written consent.
 */
export const orgBoardOrgRecordBoardMemberTerm = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardMemberTermData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardMemberTermResponses, OrgBoardOrgRecordBoardMemberTermErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardMemberTermResponses, OrgBoardOrgRecordBoardMemberTermErrors, ThrowOnError>({
    url: '/board/{org_ref}/members/{member_id}/terms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Remove Board Member Term
 *
 * Remove a term recorded in error, such as one recorded for the wrong person. The motion,
 * written consent or record it was linked to stays exactly as recorded; the seat's history
 * notes the change.
 */
export const orgBoardOrgRemoveBoardMemberTerm = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemoveBoardMemberTermData, ThrowOnError>): RequestResult<OrgBoardOrgRemoveBoardMemberTermResponses, OrgBoardOrgRemoveBoardMemberTermErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgRemoveBoardMemberTermResponses, OrgBoardOrgRemoveBoardMemberTermErrors, ThrowOnError>({ url: '/board/{org_ref}/members/{member_id}/terms/{term_id}', ...options });

/**
 * Org Update Board Member Term
 *
 * Correct a term. Send only what changes: a field left out keeps its value, and `null`
 * clears a date, the class or the note. A term keeps at least one date (422
 * `board_member_term_undated`) and never ends before it starts (422
 * `board_member_term_dates_out_of_order`). The record it came from is never changed here.
 */
export const orgBoardOrgUpdateBoardMemberTerm = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardMemberTermData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardMemberTermResponses, OrgBoardOrgUpdateBoardMemberTermErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardMemberTermResponses, OrgBoardOrgUpdateBoardMemberTermErrors, ThrowOnError>({
    url: '/board/{org_ref}/members/{member_id}/terms/{term_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Officer Duties
 *
 * What each officer title does in Givmo: Board's own acts the board ties to its titles.
 *
 * `adopted` is the board's adoption in force, or null before the first — then `duties` is
 * Givmo's starting point, which does nothing until the board adopts it. `earlier` lists the
 * adoptions replaced since, newest first. A duty never decides who may act: it decides whom
 * Board asks to sign the minutes, and what a few dialogs suggest. Reading this never changes it.
 */
export const orgBoardOrgGetBoardOfficerDuties = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardOfficerDutiesData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardOfficerDutiesResponses, OrgBoardOrgGetBoardOfficerDutiesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardOfficerDutiesResponses, OrgBoardOrgGetBoardOfficerDutiesErrors, ThrowOnError>({ url: '/board/{org_ref}/officer-duties', ...options });

/**
 * Org Adopt Board Officer Duties
 *
 * Adopt the board's duties — the first time, or to change them: the WHOLE set.
 *
 * Each duty names one of Board's own acts, the title that does it (its `id`, or for one of the
 * starting four nobody has used yet its `default_key`) and, optionally, where the board's own
 * documents say so. An act left out is not assigned to a title. Saving replaces the duties in
 * force; the earlier ones stay in the history. Sending the set already in force changes nothing.
 * A retired title is a 409 `board_officer_duty_title_retired`.
 */
export const orgBoardOrgAdoptBoardOfficerDuties = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgAdoptBoardOfficerDutiesData, ThrowOnError>): RequestResult<OrgBoardOrgAdoptBoardOfficerDutiesResponses, OrgBoardOrgAdoptBoardOfficerDutiesErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgAdoptBoardOfficerDutiesResponses, OrgBoardOrgAdoptBoardOfficerDutiesErrors, ThrowOnError>({
    url: '/board/{org_ref}/officer-duties',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Officer Titles
 *
 * The board's officer titles, in the board's order: Chair, Vice Chair, Secretary and
 * Treasurer to start with, as the board names them.
 *
 * A title with no `id` is one of the starting four that no member has been given yet; give it
 * to someone by its `default_key`. Reading this list never changes it. A title is a label: it
 * changes no vote, quorum or written consent.
 */
export const orgBoardOrgListBoardOfficerTitles = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardOfficerTitlesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardOfficerTitlesResponses, OrgBoardOrgListBoardOfficerTitlesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardOfficerTitlesResponses, OrgBoardOrgListBoardOfficerTitlesErrors, ThrowOnError>({ url: '/board/{org_ref}/officer-titles', ...options });

/**
 * Org Create Board Officer Title
 *
 * Add one of the board's own officer titles, last in the board's order.
 *
 * No two active titles share a name, whatever the case or spacing — one of the starting four the
 * board hasn't used yet included: that is a 409 `board_officer_title_name_taken`. A title is a
 * label: it changes no vote, quorum or written consent. Who holds it is set on each member.
 */
export const orgBoardOrgCreateBoardOfficerTitle = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardOfficerTitleData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardOfficerTitleResponses, OrgBoardOrgCreateBoardOfficerTitleErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardOfficerTitleResponses, OrgBoardOrgCreateBoardOfficerTitleErrors, ThrowOnError>({
    url: '/board/{org_ref}/officer-titles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Update Board Officer Title
 *
 * Rename a title, move it in the board's order, or both.
 *
 * `title_ref` is the title's `id`, or — for one of the starting four that has no `id` yet — its
 * `default_key`. `position` is the title's place among the board's active titles, counting from
 * 1; past the last means last. Renaming changes the title's words everywhere they are shown; a
 * signature already recorded keeps the words it was made with. A retired title is neither
 * renamed nor moved (409 `board_officer_title_retired`); a name another active title has is a
 * 409 `board_officer_title_name_taken`.
 */
export const orgBoardOrgUpdateBoardOfficerTitle = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardOfficerTitleData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardOfficerTitleResponses, OrgBoardOrgUpdateBoardOfficerTitleErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardOfficerTitleResponses, OrgBoardOrgUpdateBoardOfficerTitleErrors, ThrowOnError>({
    url: '/board/{org_ref}/officer-titles/{title_ref}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Retire Board Officer Title
 *
 * Retire a title the board no longer uses.
 *
 * A retired title is never deleted and never given to anyone new; it stays in the history of
 * everyone who held it. While anyone holds it, it can't be retired (409
 * `board_officer_title_held`): take it off them on their member pages first. `title_ref` is as
 * for renaming. Retiring a title already retired answers it as it is.
 */
export const orgBoardOrgRetireBoardOfficerTitle = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRetireBoardOfficerTitleData, ThrowOnError>): RequestResult<OrgBoardOrgRetireBoardOfficerTitleResponses, OrgBoardOrgRetireBoardOfficerTitleErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRetireBoardOfficerTitleResponses, OrgBoardOrgRetireBoardOfficerTitleErrors, ThrowOnError>({ url: '/board/{org_ref}/officer-titles/{title_ref}/retirement', ...options });

/**
 * Org Discard Board Packet
 *
 * Discard a DRAFT packet version.
 *
 * A published version cannot be discarded — the board already has it, so the honest move
 * is to publish a further version.
 */
export const orgBoardOrgDiscardBoardPacket = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDiscardBoardPacketData, ThrowOnError>): RequestResult<OrgBoardOrgDiscardBoardPacketResponses, OrgBoardOrgDiscardBoardPacketErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgDiscardBoardPacketResponses, OrgBoardOrgDiscardBoardPacketErrors, ThrowOnError>({ url: '/board/{org_ref}/packets/{packet_id}', ...options });

/**
 * Org Get Board Packet
 *
 * One packet version with its entries.
 *
 * An entry naming a minute-book record the caller may not read is ABSENT from the list —
 * including for an Owner who was not in a closed session. `ledger_financial_pack_available`
 * says whether the treasurer's pages can be generated from the charity's own ledger;
 * while it is false the treasurer's report is attached as an ordinary document.
 */
export const orgBoardOrgGetBoardPacket = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardPacketData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardPacketResponses, OrgBoardOrgGetBoardPacketErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardPacketResponses, OrgBoardOrgGetBoardPacketErrors, ThrowOnError>({ url: '/board/{org_ref}/packets/{packet_id}', ...options });

/**
 * Org List Board Packet Comments
 *
 * Board-visible comments on one packet version.
 *
 * A director's private note is not reachable through this read at all. The filter takes
 * no role into account, so it binds every charity administrator including an Owner.
 */
export const orgBoardOrgListBoardPacketComments = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardPacketCommentsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardPacketCommentsResponses, OrgBoardOrgListBoardPacketCommentsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardPacketCommentsResponses, OrgBoardOrgListBoardPacketCommentsErrors, ThrowOnError>({ url: '/board/{org_ref}/packets/{packet_id}/comments', ...options });

/**
 * Org Record Board Packet Shared Comment
 *
 * Record a board-visible comment on a director's behalf.
 *
 * The manual path for a comment a director made by telephone or in person. There is
 * deliberately no equivalent for a director's PRIVATE note: entering one on someone's
 * behalf would mean having read it, so that combination does not exist here and is
 * refused by the database as well.
 */
export const orgBoardOrgRecordBoardPacketSharedComment = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardPacketSharedCommentData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardPacketSharedCommentResponses, OrgBoardOrgRecordBoardPacketSharedCommentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardPacketSharedCommentResponses, OrgBoardOrgRecordBoardPacketSharedCommentErrors, ThrowOnError>({
    url: '/board/{org_ref}/packets/{packet_id}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Packet Distributions
 *
 * Who was sent one packet version. Its sibling read is who has opened it.
 */
export const orgBoardOrgListBoardPacketDistributions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardPacketDistributionsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardPacketDistributionsResponses, OrgBoardOrgListBoardPacketDistributionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardPacketDistributionsResponses, OrgBoardOrgListBoardPacketDistributionsErrors, ThrowOnError>({ url: '/board/{org_ref}/packets/{packet_id}/distribution', ...options });

/**
 * Org Distribute Board Packet
 *
 * Send a published packet version to every active seat on the roster.
 *
 * Each seat gets a fresh access link, so a director follows one link and lands in a
 * session rather than at a sign-in page they have no credentials for. The response
 * carries every seat's plaintext link, once — the recording officer hands a director
 * their link directly as often as the module mails it, and a product that only ever
 * emailed the link would make the volunteer's real route in impossible.
 *
 * `emails_sent` reports how many mails actually went out; with no template or no board
 * app base URL configured it is zero and each row records why, so the caller is told
 * what happened rather than left to assume.
 */
export const orgBoardOrgDistributeBoardPacket = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDistributeBoardPacketData, ThrowOnError>): RequestResult<OrgBoardOrgDistributeBoardPacketResponses, OrgBoardOrgDistributeBoardPacketErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgDistributeBoardPacketResponses, OrgBoardOrgDistributeBoardPacketErrors, ThrowOnError>({ url: '/board/{org_ref}/packets/{packet_id}/distribution', ...options });

/**
 * Org Reorder Board Packet Items
 *
 * Reorder a draft packet version by naming every entry once, in the order wanted.
 */
export const orgBoardOrgReorderBoardPacketItems = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgReorderBoardPacketItemsData, ThrowOnError>): RequestResult<OrgBoardOrgReorderBoardPacketItemsResponses, OrgBoardOrgReorderBoardPacketItemsErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgReorderBoardPacketItemsResponses, OrgBoardOrgReorderBoardPacketItemsErrors, ThrowOnError>({
    url: '/board/{org_ref}/packets/{packet_id}/item-order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Create Board Packet Item
 *
 * Add an entry to a draft packet version.
 *
 * A minute-book record can be placed only by someone who may read it: otherwise an
 * administrator who was not in a closed session could hand the whole board a pointer to
 * content the record store withholds from them.
 */
export const orgBoardOrgCreateBoardPacketItem = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardPacketItemData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardPacketItemResponses, OrgBoardOrgCreateBoardPacketItemErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardPacketItemResponses, OrgBoardOrgCreateBoardPacketItemErrors, ThrowOnError>({
    url: '/board/{org_ref}/packets/{packet_id}/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Delete Board Packet Item
 *
 * Remove one entry from a draft packet version, closing the gap it leaves.
 */
export const orgBoardOrgDeleteBoardPacketItem = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDeleteBoardPacketItemData, ThrowOnError>): RequestResult<OrgBoardOrgDeleteBoardPacketItemResponses, OrgBoardOrgDeleteBoardPacketItemErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgDeleteBoardPacketItemResponses, OrgBoardOrgDeleteBoardPacketItemErrors, ThrowOnError>({ url: '/board/{org_ref}/packets/{packet_id}/items/{packet_item_id}', ...options });

/**
 * Org Refresh Board Filing Snapshot
 *
 * Append a snapshot and repoint a still-draft fifth packet item.
 */
export const orgBoardOrgRefreshBoardFilingSnapshot = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRefreshBoardFilingSnapshotData, ThrowOnError>): RequestResult<OrgBoardOrgRefreshBoardFilingSnapshotResponses, OrgBoardOrgRefreshBoardFilingSnapshotErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRefreshBoardFilingSnapshotResponses, OrgBoardOrgRefreshBoardFilingSnapshotErrors, ThrowOnError>({
    url: '/board/{org_ref}/packets/{packet_id}/items/{packet_item_id}/filing-snapshot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Publish Board Packet
 *
 * Issue a draft packet version.
 *
 * The route is named for the thing it creates, not for a verb. From here the version's
 * contents are frozen: directors may already be reading it, and a change opens the next
 * version instead.
 */
export const orgBoardOrgPublishBoardPacket = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgPublishBoardPacketData, ThrowOnError>): RequestResult<OrgBoardOrgPublishBoardPacketResponses, OrgBoardOrgPublishBoardPacketErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgPublishBoardPacketResponses, OrgBoardOrgPublishBoardPacketErrors, ThrowOnError>({
    url: '/board/{org_ref}/packets/{packet_id}/publication',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Past Record Batches
 *
 * The batches of past records a connected AI proposed that wait for a person to confirm or
 * discard them: how many records each holds and how many have their file, and whose connection
 * proposed them. Nothing in them is in the minute book.
 */
export const orgBoardOrgListBoardPastRecordBatches = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardPastRecordBatchesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardPastRecordBatchesResponses, OrgBoardOrgListBoardPastRecordBatchesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardPastRecordBatchesResponses, OrgBoardOrgListBoardPastRecordBatchesErrors, ThrowOnError>({ url: '/board/{org_ref}/past-record-batches', ...options });

/**
 * Org Get Board Past Record Batch
 *
 * One batch of proposed past records, each record in the order it was proposed, word for word
 * as it would go into the minute book, with its file's state. A batch already confirmed or
 * discarded answers its state (and the import batch it became) with no records.
 */
export const orgBoardOrgGetBoardPastRecordBatch = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardPastRecordBatchData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardPastRecordBatchResponses, OrgBoardOrgGetBoardPastRecordBatchErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardPastRecordBatchResponses, OrgBoardOrgGetBoardPastRecordBatchErrors, ThrowOnError>({ url: '/board/{org_ref}/past-record-batches/{batch_id}', ...options });

/**
 * Org Confirm Board Past Record Batch
 *
 * Import the proposed records into the minute book together, exactly as they are on their
 * page, with their files. All of them go in or none do. Echo the `revision` you read: if
 * anything changed since, nothing goes in. A `label` and a `source_description` are optional
 * (Board names the records' internal import batch from the connection that proposed them).
 * After this a record can't be changed or take a file. A person's act: a connected AI cannot
 * confirm them.
 */
export const orgBoardOrgConfirmBoardPastRecordBatch = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgConfirmBoardPastRecordBatchData, ThrowOnError>): RequestResult<OrgBoardOrgConfirmBoardPastRecordBatchResponses, OrgBoardOrgConfirmBoardPastRecordBatchErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgConfirmBoardPastRecordBatchResponses, OrgBoardOrgConfirmBoardPastRecordBatchErrors, ThrowOnError>({
    url: '/board/{org_ref}/past-record-batches/{batch_id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Discard Board Past Record Batch
 *
 * Discard a batch: nothing goes into the minute book, and its records' text and files are
 * deleted. Echo the batch's `revision`. A person's act.
 */
export const orgBoardOrgDiscardBoardPastRecordBatch = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDiscardBoardPastRecordBatchData, ThrowOnError>): RequestResult<OrgBoardOrgDiscardBoardPastRecordBatchResponses, OrgBoardOrgDiscardBoardPastRecordBatchErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgDiscardBoardPastRecordBatchResponses, OrgBoardOrgDiscardBoardPastRecordBatchErrors, ThrowOnError>({
    url: '/board/{org_ref}/past-record-batches/{batch_id}/discard',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Mark Board Past Record Confidentiality
 *
 * Mark one proposed record as a closed (executive) session's own record, or not, before the
 * records are confirmed: it imports as the mark says, a closed session's record as one recorded by
 * hand. Echo the batch's `revision`; the answer carries the batch's new one. A person's act.
 */
export const orgBoardOrgMarkBoardPastRecordConfidentiality = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgMarkBoardPastRecordConfidentialityData, ThrowOnError>): RequestResult<OrgBoardOrgMarkBoardPastRecordConfidentialityResponses, OrgBoardOrgMarkBoardPastRecordConfidentialityErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgMarkBoardPastRecordConfidentialityResponses, OrgBoardOrgMarkBoardPastRecordConfidentialityErrors, ThrowOnError>({
    url: '/board/{org_ref}/past-record-proposals/{proposal_id}/confidentiality',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Proposal File Url
 *
 * A short-lived link that downloads a proposed record's file, as Board checked it.
 */
export const orgBoardOrgGetBoardProposalFileUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardProposalFileUrlData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardProposalFileUrlResponses, OrgBoardOrgGetBoardProposalFileUrlErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardProposalFileUrlResponses, OrgBoardOrgGetBoardProposalFileUrlErrors, ThrowOnError>({ url: '/board/{org_ref}/past-record-proposals/{proposal_id}/file', ...options });

/**
 * Org Check Board Proposal File
 *
 * Ask Board to check a proposed record's file. With the `object_ref` an upload URL named and
 * the file's name and type, the file you added: if Board's check passes it becomes the record's
 * file; if not, the answer says why and the upload is deleted. Without them, the file the
 * connected AI was asked to upload, if it has arrived.
 */
export const orgBoardOrgCheckBoardProposalFile = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCheckBoardProposalFileData, ThrowOnError>): RequestResult<OrgBoardOrgCheckBoardProposalFileResponses, OrgBoardOrgCheckBoardProposalFileErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCheckBoardProposalFileResponses, OrgBoardOrgCheckBoardProposalFileErrors, ThrowOnError>({
    url: '/board/{org_ref}/past-record-proposals/{proposal_id}/file/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Issue Board Proposal File Upload Url
 *
 * A signed upload URL for a proposed record's missing or replacement file: PUT the file there
 * once, sending exactly `headers`, then ask Board to check it with the `object_ref` it names. A
 * PDF or a picture, up to 50 MB. Nothing is recorded until Board's check passes.
 */
export const orgBoardOrgIssueBoardProposalFileUploadUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgIssueBoardProposalFileUploadUrlData, ThrowOnError>): RequestResult<OrgBoardOrgIssueBoardProposalFileUploadUrlResponses, OrgBoardOrgIssueBoardProposalFileUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgIssueBoardProposalFileUploadUrlResponses, OrgBoardOrgIssueBoardProposalFileUploadUrlErrors, ThrowOnError>({
    url: '/board/{org_ref}/past-record-proposals/{proposal_id}/file/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Leave Out Board Past Record
 *
 * Leave one proposed record out of its batch: it won't be imported, and its text and file are
 * deleted. Echo the batch's `revision`; the answer carries the batch's new one. A person's act.
 */
export const orgBoardOrgLeaveOutBoardPastRecord = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgLeaveOutBoardPastRecordData, ThrowOnError>): RequestResult<OrgBoardOrgLeaveOutBoardPastRecordResponses, OrgBoardOrgLeaveOutBoardPastRecordErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgLeaveOutBoardPastRecordResponses, OrgBoardOrgLeaveOutBoardPastRecordErrors, ThrowOnError>({
    url: '/board/{org_ref}/past-record-proposals/{proposal_id}/leave-out',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Records
 *
 * The charity's board records, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Executive-session records the caller did not take part in are ABSENT, and the total
 * reflects only what they may see — reporting the unfiltered total would leak the
 * existence of withheld records through arithmetic.
 *
 * `q` narrows the list to records whose TITLE contains it, ignoring case (CBG-UX1). It is
 * applied in the same query as the executive-session rule, so a withheld record is never
 * found or counted by a search. A `q` longer than a title can be, or holding a NUL, is a
 * 422.
 */
export const orgBoardOrgListBoardRecords = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardRecordsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardRecordsResponses, OrgBoardOrgListBoardRecordsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardRecordsResponses, OrgBoardOrgListBoardRecordsErrors, ThrowOnError>({ url: '/board/{org_ref}/records', ...options });

/**
 * Org Create Board Record Draft
 *
 * Twin of ``create_board_record_draft``.
 */
export const orgBoardOrgCreateBoardRecordDraft = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardRecordDraftData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardRecordDraftResponses, OrgBoardOrgCreateBoardRecordDraftErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardRecordDraftResponses, OrgBoardOrgCreateBoardRecordDraftErrors, ThrowOnError>({
    url: '/board/{org_ref}/records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Record
 *
 * Twin of ``get_board_record``.
 */
export const orgBoardOrgGetBoardRecord = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardRecordData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardRecordResponses, OrgBoardOrgGetBoardRecordErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardRecordResponses, OrgBoardOrgGetBoardRecordErrors, ThrowOnError>({ url: '/board/{org_ref}/records/{record_id}', ...options });

/**
 * Org Update Board Record Draft
 *
 * Twin of ``update_board_record_draft``.
 */
export const orgBoardOrgUpdateBoardRecordDraft = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardRecordDraftData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardRecordDraftResponses, OrgBoardOrgUpdateBoardRecordDraftErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardRecordDraftResponses, OrgBoardOrgUpdateBoardRecordDraftErrors, ThrowOnError>({
    url: '/board/{org_ref}/records/{record_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Record Acknowledgments
 *
 * Who has confirmed reading a document, which version, how and when — confirmed in Board,
 * recorded from a signed paper form, or confirmed in an annual conflict-of-interest disclosure
 * (the policy only) — across the document's versions, newest first.
 */
export const orgBoardOrgListBoardRecordAcknowledgments = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardRecordAcknowledgmentsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardRecordAcknowledgmentsResponses, OrgBoardOrgListBoardRecordAcknowledgmentsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardRecordAcknowledgmentsResponses, OrgBoardOrgListBoardRecordAcknowledgmentsErrors, ThrowOnError>({ url: '/board/{org_ref}/records/{record_id}/acknowledgments', ...options });

/**
 * Org Approve Board Record
 *
 * Record the approval — the door from a draft to the charity's record.
 *
 * The body's `content_hash` is a required echo of the artifact the approver read; a
 * mismatch is a 409 and the reviewer re-reads the current version. A record is approved
 * only with the date it is about: `occurred_on` supplies a date the draft is missing or
 * confirms the one it carries, and a record left without one is a 409. The route is
 * named for the thing it creates (the approval event), not for a verb, because that
 * event is the durable artifact.
 */
export const orgBoardOrgApproveBoardRecord = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgApproveBoardRecordData, ThrowOnError>): RequestResult<OrgBoardOrgApproveBoardRecordResponses, OrgBoardOrgApproveBoardRecordErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgApproveBoardRecordResponses, OrgBoardOrgApproveBoardRecordErrors, ThrowOnError>({
    url: '/board/{org_ref}/records/{record_id}/approval',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Minutes Approval Consent Form
 *
 * The form for a written consent approving one set of minutes, filled in from them.
 *
 * A neutral form whose structure is modeled on the Model Nonprofit Corporation Act's board
 * action without a meeting. The module fills in only what the organization already recorded
 * about the minutes — their title, the date of their meeting, their record reference and their
 * fingerprint — and leaves every other term as a field for the organization. The text is the
 * organization's to edit; the fingerprint stays in it, because it is how the text the
 * directors sign names the minutes they approve.
 *
 * Available for a meeting's own minutes that are still a draft.
 */
export const orgBoardOrgGetBoardMinutesApprovalConsentForm = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardMinutesApprovalConsentFormData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardMinutesApprovalConsentFormResponses, OrgBoardOrgGetBoardMinutesApprovalConsentFormErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardMinutesApprovalConsentFormResponses, OrgBoardOrgGetBoardMinutesApprovalConsentFormErrors, ThrowOnError>({ url: '/board/{org_ref}/records/{record_id}/approval-consent-form', ...options });

/**
 * Org Create Board Minutes Approval Consent
 *
 * Open a working consent that names the minutes it approves.
 *
 * A draft like any other: nothing is put to the board here, and the text is the
 * organization's to edit. The minutes are the ones in the path, and that never changes.
 * When the consent goes to the board, its text carries the minutes' fingerprint and the
 * version that goes out records it. When the last director it went out to signs, the
 * minutes are approved — unless they changed after it went out, were approved another way,
 * or are no longer there; then the consent is still recorded, and says the minutes were not
 * approved and why.
 */
export const orgBoardOrgCreateBoardMinutesApprovalConsent = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardMinutesApprovalConsentData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardMinutesApprovalConsentResponses, OrgBoardOrgCreateBoardMinutesApprovalConsentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardMinutesApprovalConsentResponses, OrgBoardOrgCreateBoardMinutesApprovalConsentErrors, ThrowOnError>({
    url: '/board/{org_ref}/records/{record_id}/approval-consents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Delete Board Record Chain
 *
 * Delete a record together with its whole correction chain, as one act.
 *
 * A correction and the record it corrects are each other's context, so they are retained
 * and deleted as a unit — the single-record route refuses a chain member and points here.
 * Any member's id resolves the chain, and the request is refused outright if any member
 * is still inside the retention floor or under an active legal hold. Every member gets
 * its own ``deleted`` event.
 */
export const orgBoardOrgDeleteBoardRecordChain = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDeleteBoardRecordChainData, ThrowOnError>): RequestResult<OrgBoardOrgDeleteBoardRecordChainResponses, OrgBoardOrgDeleteBoardRecordChainErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgDeleteBoardRecordChainResponses, OrgBoardOrgDeleteBoardRecordChainErrors, ThrowOnError>({
    url: '/board/{org_ref}/records/{record_id}/chain-deletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Delete Board Record
 *
 * Delete ONE board record at the charity's explicit request.
 *
 * A POST carrying a required reason rather than a bare DELETE: the reason is recorded,
 * and a deletion of the charity's legal memory should not be something a stray verb can
 * accomplish. Refused while any active legal hold covers the record, and refused before
 * the record has passed the charity's adopted retention floor — both at the service for
 * a clear message and at the database independently.
 */
export const orgBoardOrgDeleteBoardRecord = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDeleteBoardRecordData, ThrowOnError>): RequestResult<OrgBoardOrgDeleteBoardRecordResponses, OrgBoardOrgDeleteBoardRecordErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgDeleteBoardRecordResponses, OrgBoardOrgDeleteBoardRecordErrors, ThrowOnError>({
    url: '/board/{org_ref}/records/{record_id}/deletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Discard Board Record Draft
 *
 * Twin of ``discard_board_record_draft``.
 */
export const orgBoardOrgDiscardBoardRecordDraft = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgDiscardBoardRecordDraftData, ThrowOnError>): RequestResult<OrgBoardOrgDiscardBoardRecordDraftResponses, OrgBoardOrgDiscardBoardRecordDraftErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgDiscardBoardRecordDraftResponses, OrgBoardOrgDiscardBoardRecordDraftErrors, ThrowOnError>({
    url: '/board/{org_ref}/records/{record_id}/discard',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Record File Url
 *
 * A short-lived link that downloads a record's file, the one Board checked when the record
 * was imported. A closed session's file opens only for those who may read its record.
 */
export const orgBoardOrgGetBoardRecordFileUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardRecordFileUrlData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardRecordFileUrlResponses, OrgBoardOrgGetBoardRecordFileUrlErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardRecordFileUrlResponses, OrgBoardOrgGetBoardRecordFileUrlErrors, ThrowOnError>({ url: '/board/{org_ref}/records/{record_id}/file', ...options });

/**
 * Org Get Board Officer Statement
 *
 * A statement about one record, generated for an officer of the organization to
 * execute.
 *
 * The module fills in only what the charity already recorded — the record's title, its
 * date, when it was recorded, its reference and its text — and leaves every statement
 * the officer makes, and the officer's own name, title and date, as fields for them.
 * The organization's officer signs it; this product signs nothing.
 *
 * Available for a record the charity has recorded. There is nothing to state about a
 * working draft.
 */
export const orgBoardOrgGetBoardOfficerStatement = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardOfficerStatementData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardOfficerStatementResponses, OrgBoardOrgGetBoardOfficerStatementErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardOfficerStatementResponses, OrgBoardOrgGetBoardOfficerStatementErrors, ThrowOnError>({ url: '/board/{org_ref}/records/{record_id}/officer-statement', ...options });

/**
 * Org List Board Record Events
 *
 * One record's append-only record event log, oldest first — including the approval
 * event, which is the evidence of who approved what and when.
 */
export const orgBoardOrgListBoardRecordEvents = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardRecordEventsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardRecordEventsResponses, OrgBoardOrgListBoardRecordEventsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardRecordEventsResponses, OrgBoardOrgListBoardRecordEventsErrors, ThrowOnError>({ url: '/board/{org_ref}/records/{record_id}/record-events', ...options });

/**
 * Org Submit Board Record
 *
 * Twin of ``submit_board_record``.
 */
export const orgBoardOrgSubmitBoardRecord = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgSubmitBoardRecordData, ThrowOnError>): RequestResult<OrgBoardOrgSubmitBoardRecordResponses, OrgBoardOrgSubmitBoardRecordErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgSubmitBoardRecordResponses, OrgBoardOrgSubmitBoardRecordErrors, ThrowOnError>({
    url: '/board/{org_ref}/records/{record_id}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Retention Policies
 *
 * Twin of ``list_board_retention_policies``.
 */
export const orgBoardOrgListBoardRetentionPolicies = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardRetentionPoliciesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardRetentionPoliciesResponses, OrgBoardOrgListBoardRetentionPoliciesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardRetentionPoliciesResponses, OrgBoardOrgListBoardRetentionPoliciesErrors, ThrowOnError>({ url: '/board/{org_ref}/retention-policies', ...options });

/**
 * Org Adopt Board Retention Policy
 *
 * Adopt (or replace) the charity's retention schedule for one record kind.
 *
 * `minimum_retention_years` is a FLOOR, never an expiry: reaching it deletes nothing.
 * PUT rather than POST because the charity has exactly one live schedule per record
 * kind — adopting again replaces it (and supersedes the prior row, which stays readable
 * as history).
 */
export const orgBoardOrgAdoptBoardRetentionPolicy = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgAdoptBoardRetentionPolicyData, ThrowOnError>): RequestResult<OrgBoardOrgAdoptBoardRetentionPolicyResponses, OrgBoardOrgAdoptBoardRetentionPolicyErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgAdoptBoardRetentionPolicyResponses, OrgBoardOrgAdoptBoardRetentionPolicyErrors, ThrowOnError>({
    url: '/board/{org_ref}/retention-policies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Return Distributions
 *
 * Every copy of the return provided to the board, newest first: the tax year, who provided
 * it and when, how many people it went to, and how many of the directors were provided it.
 * `tax_year_ends_on` narrows the list to one tax year's copies.
 */
export const orgBoardOrgListBoardReturnDistributions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardReturnDistributionsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardReturnDistributionsResponses, OrgBoardOrgListBoardReturnDistributionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardReturnDistributionsResponses, OrgBoardOrgListBoardReturnDistributionsErrors, ThrowOnError>({ url: '/board/{org_ref}/return-distributions', ...options });

/**
 * Org Provide Board Return
 *
 * Provide a copy of the return to the board. Adds one record to the minute book: the copy's
 * fingerprint, who provided it and when, and everyone on the roster it went to. Each person is
 * emailed that it's available to review in Givmo; a seat no account has joined gets an
 * invitation to join with it. `follows_record_id` provides a newer copy of a return already
 * provided.
 */
export const orgBoardOrgProvideBoardReturn = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgProvideBoardReturnData, ThrowOnError>): RequestResult<OrgBoardOrgProvideBoardReturnResponses, OrgBoardOrgProvideBoardReturnErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgProvideBoardReturnResponses, OrgBoardOrgProvideBoardReturnErrors, ThrowOnError>({
    url: '/board/{org_ref}/return-distributions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Confirm Board Return Copy
 *
 * Check an uploaded copy: Board reads it and answers its size, its number of pages and its
 * SHA-256 fingerprint, which Board computes itself. A PDF with a password to open is refused.
 * Nothing is recorded.
 */
export const orgBoardOrgConfirmBoardReturnCopy = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgConfirmBoardReturnCopyData, ThrowOnError>): RequestResult<OrgBoardOrgConfirmBoardReturnCopyResponses, OrgBoardOrgConfirmBoardReturnCopyErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgConfirmBoardReturnCopyResponses, OrgBoardOrgConfirmBoardReturnCopyErrors, ThrowOnError>({
    url: '/board/{org_ref}/return-distributions/copies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Issue Board Return Copy Upload Url
 *
 * A link to upload one copy of the return, a PDF of at most 50 MB, valid for 15 minutes.
 * Nothing is recorded until the copy is provided.
 */
export const orgBoardOrgIssueBoardReturnCopyUploadUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgIssueBoardReturnCopyUploadUrlData, ThrowOnError>): RequestResult<OrgBoardOrgIssueBoardReturnCopyUploadUrlResponses, OrgBoardOrgIssueBoardReturnCopyUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgIssueBoardReturnCopyUploadUrlResponses, OrgBoardOrgIssueBoardReturnCopyUploadUrlErrors, ThrowOnError>({
    url: '/board/{org_ref}/return-distributions/copies/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Preview Board Return Recipients
 *
 * Who a copy provided now would go to: everyone on the board's roster today, directors first,
 * with the titles they hold on `provided_on`, the day you'll provide it (today when unsent).
 * The same list the act uses.
 */
export const orgBoardOrgPreviewBoardReturnRecipients = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgPreviewBoardReturnRecipientsData, ThrowOnError>): RequestResult<OrgBoardOrgPreviewBoardReturnRecipientsResponses, OrgBoardOrgPreviewBoardReturnRecipientsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgPreviewBoardReturnRecipientsResponses, OrgBoardOrgPreviewBoardReturnRecipientsErrors, ThrowOnError>({ url: '/board/{org_ref}/return-distributions/recipients', ...options });

/**
 * Org List Board Return Review Candidates
 *
 * The board's acts a copy's review can name, newest first: each motion with a recorded vote,
 * carried or failed, made in a meeting's open session (its meeting's title and day, and its own
 * words), and each written consent waiting on signatures or signed by everyone. A closed
 * session's motion is never listed.
 */
export const orgBoardOrgListBoardReturnReviewCandidates = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardReturnReviewCandidatesData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardReturnReviewCandidatesResponses, OrgBoardOrgListBoardReturnReviewCandidatesErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardReturnReviewCandidatesResponses, OrgBoardOrgListBoardReturnReviewCandidatesErrors, ThrowOnError>({ url: '/board/{org_ref}/return-distributions/review-candidates', ...options });

/**
 * Org Get Board Return Distribution
 *
 * One copy of the return provided to the board, and what Board recorded of each person it
 * went to: their email, when they opened it, a printed copy given to them, and their recorded
 * reading.
 */
export const orgBoardOrgGetBoardReturnDistribution = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardReturnDistributionData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardReturnDistributionResponses, OrgBoardOrgGetBoardReturnDistributionErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardReturnDistributionResponses, OrgBoardOrgGetBoardReturnDistributionErrors, ThrowOnError>({ url: '/board/{org_ref}/return-distributions/{record_id}', ...options });

/**
 * Org Get Board Return Copy Url
 *
 * A link to download the copy provided, valid for 15 minutes. Your download isn't recorded
 * as anyone's receipt.
 */
export const orgBoardOrgGetBoardReturnCopyUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardReturnCopyUrlData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardReturnCopyUrlResponses, OrgBoardOrgGetBoardReturnCopyUrlErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardReturnCopyUrlResponses, OrgBoardOrgGetBoardReturnCopyUrlErrors, ThrowOnError>({ url: '/board/{org_ref}/return-distributions/{record_id}/copy-url', ...options });

/**
 * Org Email Board Return Again
 *
 * Email one person again after their email didn't go out. At most once a day each; no new
 * record. A seat no account has joined gets a new invitation with it.
 */
export const orgBoardOrgEmailBoardReturnAgain = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgEmailBoardReturnAgainData, ThrowOnError>): RequestResult<OrgBoardOrgEmailBoardReturnAgainResponses, OrgBoardOrgEmailBoardReturnAgainErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgEmailBoardReturnAgainResponses, OrgBoardOrgEmailBoardReturnAgainErrors, ThrowOnError>({ url: '/board/{org_ref}/return-distributions/{record_id}/people/{board_member_id}/email', ...options });

/**
 * Org Record Board Return Printed Copy
 *
 * Record that a printed copy was given to this person: the day it was given, and how. Once
 * per person for each copy.
 */
export const orgBoardOrgRecordBoardReturnPrintedCopy = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardReturnPrintedCopyData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardReturnPrintedCopyResponses, OrgBoardOrgRecordBoardReturnPrintedCopyErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardReturnPrintedCopyResponses, OrgBoardOrgRecordBoardReturnPrintedCopyErrors, ThrowOnError>({
    url: '/board/{org_ref}/return-distributions/{record_id}/people/{board_member_id}/printed-copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Link Board Return Review
 *
 * Record the board's review of this copy: one of the acts the review list names, a motion
 * or a written consent. One per copy at a time; remove it to record another. The board's own
 * record is unchanged.
 */
export const orgBoardOrgLinkBoardReturnReview = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgLinkBoardReturnReviewData, ThrowOnError>): RequestResult<OrgBoardOrgLinkBoardReturnReviewResponses, OrgBoardOrgLinkBoardReturnReviewErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgLinkBoardReturnReviewResponses, OrgBoardOrgLinkBoardReturnReviewErrors, ThrowOnError>({
    url: '/board/{org_ref}/return-distributions/{record_id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Unlink Board Return Review
 *
 * Remove this copy's review link. Who removed it and when is kept with the copy's earlier
 * links.
 */
export const orgBoardOrgUnlinkBoardReturnReview = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUnlinkBoardReturnReviewData, ThrowOnError>): RequestResult<OrgBoardOrgUnlinkBoardReturnReviewResponses, OrgBoardOrgUnlinkBoardReturnReviewErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgUnlinkBoardReturnReviewResponses, OrgBoardOrgUnlinkBoardReturnReviewErrors, ThrowOnError>({ url: '/board/{org_ref}/return-distributions/{record_id}/review/{link_id}', ...options });

/**
 * Org Withdraw Board Return
 *
 * Withdraw this copy, with the reason directors will see. Their pages stop offering it; the
 * record, what was recorded of each person and the file stay.
 */
export const orgBoardOrgWithdrawBoardReturn = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgWithdrawBoardReturnData, ThrowOnError>): RequestResult<OrgBoardOrgWithdrawBoardReturnResponses, OrgBoardOrgWithdrawBoardReturnErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgWithdrawBoardReturnResponses, OrgBoardOrgWithdrawBoardReturnErrors, ThrowOnError>({
    url: '/board/{org_ref}/return-distributions/{record_id}/withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Roster Result
 *
 * Record an election's result on the roster, from the motion recorded as carried
 * (`motion_id`) or the executed written consent (`consent_id`) that elected them: a term for
 * each director named, and the title for each officer named (ending that person's earlier
 * holding of the same title, which stays in their history). Each is linked to the motion or
 * consent; the motion, the consent and the minutes don't change. The roster never changes from
 * an election by itself; this is the officer's act. Givmo doesn't read the motion's or the
 * consent's words: whoever is named here is recorded.
 *
 * A motion not recorded as carried is a 409 `board_roster_result_not_carried`; a written
 * consent not executed, a 409 `board_roster_result_not_executed`; a director named who isn't
 * recorded as a director, a 409 `board_roster_result_not_a_director`.
 */
export const orgBoardOrgRecordBoardRosterResult = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardRosterResultData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardRosterResultResponses, OrgBoardOrgRecordBoardRosterResultErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardRosterResultResponses, OrgBoardOrgRecordBoardRosterResultErrors, ThrowOnError>({
    url: '/board/{org_ref}/roster-results',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Board Self Assessment Instruments
 *
 * Givmo's starting self-assessments this organization is offered, each with where its
 * statements come from. Never a statement that one is required or recommended.
 */
export const orgBoardOrgListBoardSelfAssessmentInstruments = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardSelfAssessmentInstrumentsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardSelfAssessmentInstrumentsResponses, OrgBoardOrgListBoardSelfAssessmentInstrumentsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardSelfAssessmentInstrumentsResponses, OrgBoardOrgListBoardSelfAssessmentInstrumentsErrors, ThrowOnError>({ url: '/board/{org_ref}/self-assessment-instruments', ...options });

/**
 * Org Get Board Self Assessment Instrument
 *
 * One starting self-assessment with every statement, in its group, and the text each is
 * written from: the IRS's Form 990 and its instructions, or a state's statute.
 */
export const orgBoardOrgGetBoardSelfAssessmentInstrument = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardSelfAssessmentInstrumentData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardSelfAssessmentInstrumentResponses, OrgBoardOrgGetBoardSelfAssessmentInstrumentErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardSelfAssessmentInstrumentResponses, OrgBoardOrgGetBoardSelfAssessmentInstrumentErrors, ThrowOnError>({ url: '/board/{org_ref}/self-assessment-instruments/{template_id}', ...options });

/**
 * Org List Board Self Assessments
 *
 * Every self-assessment of the board, newest first: each one's dates, where it stands, and
 * how many were asked and how many answered.
 */
export const orgBoardOrgListBoardSelfAssessments = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardSelfAssessmentsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardSelfAssessmentsResponses, OrgBoardOrgListBoardSelfAssessmentsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardSelfAssessmentsResponses, OrgBoardOrgListBoardSelfAssessmentsErrors, ThrowOnError>({ url: '/board/{org_ref}/self-assessments', ...options });

/**
 * Org Open Board Self Assessment
 *
 * Start the board's self-assessment: everyone on the roster is asked, but the people named in
 * `not_asked`, with Givmo's starting statements (any turned off). Each person is emailed the
 * ask; a seat that hasn't joined Board yet gets an invitation to join with it. Each person's
 * answers are private to them until it is closed.
 */
export const orgBoardOrgOpenBoardSelfAssessment = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgOpenBoardSelfAssessmentData, ThrowOnError>): RequestResult<OrgBoardOrgOpenBoardSelfAssessmentResponses, OrgBoardOrgOpenBoardSelfAssessmentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgOpenBoardSelfAssessmentResponses, OrgBoardOrgOpenBoardSelfAssessmentErrors, ThrowOnError>({
    url: '/board/{org_ref}/self-assessments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Self Assessment
 *
 * One self-assessment: who was asked, who has answered and when (never what), what was sent
 * and when, who can be reminded now, what became of the answers once it closed, and the
 * board's priorities.
 */
export const orgBoardOrgGetBoardSelfAssessment = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardSelfAssessmentData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardSelfAssessmentResponses, OrgBoardOrgGetBoardSelfAssessmentErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardSelfAssessmentResponses, OrgBoardOrgGetBoardSelfAssessmentErrors, ThrowOnError>({ url: '/board/{org_ref}/self-assessments/{assessment_id}', ...options });

/**
 * Org Cancel Board Self Assessment
 *
 * Withdraw a self-assessment started by mistake, before anyone has answered. Nothing is added
 * to the minute book.
 */
export const orgBoardOrgCancelBoardSelfAssessment = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCancelBoardSelfAssessmentData, ThrowOnError>): RequestResult<OrgBoardOrgCancelBoardSelfAssessmentResponses, OrgBoardOrgCancelBoardSelfAssessmentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCancelBoardSelfAssessmentResponses, OrgBoardOrgCancelBoardSelfAssessmentErrors, ThrowOnError>({ url: '/board/{org_ref}/self-assessments/{assessment_id}/cancellation', ...options });

/**
 * Org Close Board Self Assessment
 *
 * Close the self-assessment. Adds one record to the minute book: how many people chose each
 * answer, and the comments without names, or, with fewer than three answers, only how many were
 * asked and answered. Each person's answers are then deleted, unless a legal hold covers the
 * board, which keeps them.
 */
export const orgBoardOrgCloseBoardSelfAssessment = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCloseBoardSelfAssessmentData, ThrowOnError>): RequestResult<OrgBoardOrgCloseBoardSelfAssessmentResponses, OrgBoardOrgCloseBoardSelfAssessmentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCloseBoardSelfAssessmentResponses, OrgBoardOrgCloseBoardSelfAssessmentErrors, ThrowOnError>({ url: '/board/{org_ref}/self-assessments/{assessment_id}/close', ...options });

/**
 * Org Unmark Board Self Assessment Paper Hand In
 *
 * Undo a paper hand-in marked by mistake.
 */
export const orgBoardOrgUnmarkBoardSelfAssessmentPaperHandIn = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInData, ThrowOnError>): RequestResult<OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInResponses, OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInResponses, OrgBoardOrgUnmarkBoardSelfAssessmentPaperHandInErrors, ThrowOnError>({ url: '/board/{org_ref}/self-assessments/{assessment_id}/paper-hand-ins/{board_member_id}', ...options });

/**
 * Org Mark Board Self Assessment Paper Hand In
 *
 * Mark that someone asked handed in a paper answer sheet, so they count as answered and are
 * not reminded.
 */
export const orgBoardOrgMarkBoardSelfAssessmentPaperHandIn = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgMarkBoardSelfAssessmentPaperHandInData, ThrowOnError>): RequestResult<OrgBoardOrgMarkBoardSelfAssessmentPaperHandInResponses, OrgBoardOrgMarkBoardSelfAssessmentPaperHandInErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgMarkBoardSelfAssessmentPaperHandInResponses, OrgBoardOrgMarkBoardSelfAssessmentPaperHandInErrors, ThrowOnError>({ url: '/board/{org_ref}/self-assessments/{assessment_id}/paper-hand-ins/{board_member_id}', ...options });

/**
 * Org Record Board Self Assessment Paper Sheet
 *
 * Enter one paper answer sheet. It names nobody: nothing entered here ties it to a person.
 * Mark who handed one in separately.
 */
export const orgBoardOrgRecordBoardSelfAssessmentPaperSheet = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardSelfAssessmentPaperSheetData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardSelfAssessmentPaperSheetResponses, OrgBoardOrgRecordBoardSelfAssessmentPaperSheetErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardSelfAssessmentPaperSheetResponses, OrgBoardOrgRecordBoardSelfAssessmentPaperSheetErrors, ThrowOnError>({
    url: '/board/{org_ref}/self-assessments/{assessment_id}/paper-sheets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Link Board Self Assessment Priorities
 *
 * Link the results to the board's own act choosing its priorities: a motion the board
 * carried, or a written consent every director signed, and the statements it addresses. Board
 * never chooses or drafts the priorities.
 */
export const orgBoardOrgLinkBoardSelfAssessmentPriorities = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgLinkBoardSelfAssessmentPrioritiesData, ThrowOnError>): RequestResult<OrgBoardOrgLinkBoardSelfAssessmentPrioritiesResponses, OrgBoardOrgLinkBoardSelfAssessmentPrioritiesErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgLinkBoardSelfAssessmentPrioritiesResponses, OrgBoardOrgLinkBoardSelfAssessmentPrioritiesErrors, ThrowOnError>({
    url: '/board/{org_ref}/self-assessments/{assessment_id}/priorities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Self Assessment Questions
 *
 * What the self-assessment asks: its statements, in their groups, with their sources, the
 * answers, and the questions in a person's own words — to print a blank answer sheet, and to
 * enter one.
 */
export const orgBoardOrgGetBoardSelfAssessmentQuestions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardSelfAssessmentQuestionsData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardSelfAssessmentQuestionsResponses, OrgBoardOrgGetBoardSelfAssessmentQuestionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardSelfAssessmentQuestionsResponses, OrgBoardOrgGetBoardSelfAssessmentQuestionsErrors, ThrowOnError>({ url: '/board/{org_ref}/self-assessments/{assessment_id}/questions', ...options });

/**
 * Org Remind Board Self Assessment Recipients
 *
 * Remind people who haven't answered yet. Each gets one email, at most once a day. Reminders
 * go only when you send them. Name the people in `board_member_ids`, or send null for everyone
 * who can be reminded now.
 */
export const orgBoardOrgRemindBoardSelfAssessmentRecipients = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemindBoardSelfAssessmentRecipientsData, ThrowOnError>): RequestResult<OrgBoardOrgRemindBoardSelfAssessmentRecipientsResponses, OrgBoardOrgRemindBoardSelfAssessmentRecipientsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRemindBoardSelfAssessmentRecipientsResponses, OrgBoardOrgRemindBoardSelfAssessmentRecipientsErrors, ThrowOnError>({
    url: '/board/{org_ref}/self-assessments/{assessment_id}/reminders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Send Board Self Assessment Requests
 *
 * Send the self-assessment to people who haven't been sent it — someone who joined the board
 * since it started, or someone left out at the start. A seat that hasn't joined Board yet gets
 * an invitation with it. Name the people in `board_member_ids`, or send null for everyone it can
 * go to (never someone left out at the start).
 */
export const orgBoardOrgSendBoardSelfAssessmentRequests = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgSendBoardSelfAssessmentRequestsData, ThrowOnError>): RequestResult<OrgBoardOrgSendBoardSelfAssessmentRequestsResponses, OrgBoardOrgSendBoardSelfAssessmentRequestsErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgSendBoardSelfAssessmentRequestsResponses, OrgBoardOrgSendBoardSelfAssessmentRequestsErrors, ThrowOnError>({
    url: '/board/{org_ref}/self-assessments/{assessment_id}/requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Self Assessment Results
 *
 * A closed self-assessment's results, from its record in the minute book: how many people
 * chose each answer, in the statements' own order, and the comments without names, sorted. With
 * fewer than three answers, only how many were asked and answered.
 */
export const orgBoardOrgGetBoardSelfAssessmentResults = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardSelfAssessmentResultsData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardSelfAssessmentResultsResponses, OrgBoardOrgGetBoardSelfAssessmentResultsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardSelfAssessmentResultsResponses, OrgBoardOrgGetBoardSelfAssessmentResultsErrors, ThrowOnError>({ url: '/board/{org_ref}/self-assessments/{assessment_id}/results', ...options });

/**
 * Org Get Board To Do
 *
 * Your to-do list on this board: what an officer can do next in Board's record-keeping, and
 * what officers did in the last 90 days. A new member's steps (the year's conflict-of-interest
 * questionnaire to send, a board buddy to choose), minutes to write and to send for approval
 * with the date the Form 990 instructions use, records waiting for approval, and members or past
 * records a connected AI proposed. Each is listed only for someone who can do it, and each keeps
 * the scoping of the page it is done on. Never what a member hasn't read or answered. Computed
 * when read from your board's own records; nothing is stored.
 */
export const orgBoardOrgGetBoardToDo = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardToDoData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardToDoResponses, OrgBoardOrgGetBoardToDoErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardToDoResponses, OrgBoardOrgGetBoardToDoErrors, ThrowOnError>({ url: '/board/{org_ref}/to-do', ...options });

/**
 * Org List Board Written Consents
 *
 * The charity's written consents, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Each entry carries where the consent stands and how many of the seats it went out to
 * have signed. The roster and the signature log come with the single-consent read
 * rather than with a page of them.
 */
export const orgBoardOrgListBoardWrittenConsents = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardWrittenConsentsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardWrittenConsentsResponses, OrgBoardOrgListBoardWrittenConsentsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardWrittenConsentsResponses, OrgBoardOrgListBoardWrittenConsentsErrors, ThrowOnError>({ url: '/board/{org_ref}/written-consents', ...options });

/**
 * Org Create Board Written Consent
 *
 * Open a working consent.
 *
 * Nothing is put to the board here: a draft has no roster and nobody can sign it. That
 * is a separate act, on a separate permission.
 */
export const orgBoardOrgCreateBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCreateBoardWrittenConsentData, ThrowOnError>): RequestResult<OrgBoardOrgCreateBoardWrittenConsentResponses, OrgBoardOrgCreateBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCreateBoardWrittenConsentResponses, OrgBoardOrgCreateBoardWrittenConsentErrors, ThrowOnError>({
    url: '/board/{org_ref}/written-consents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Board Written Consent
 *
 * One consent: the text before the board, the roster it went out to, and every
 * signature act recorded against it — who, what identity they asserted, how it was
 * captured, which text they named, and when.
 */
export const orgBoardOrgGetBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardWrittenConsentData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardWrittenConsentResponses, OrgBoardOrgGetBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardWrittenConsentResponses, OrgBoardOrgGetBoardWrittenConsentErrors, ThrowOnError>({ url: '/board/{org_ref}/written-consents/{consent_id}', ...options });

/**
 * Org Update Board Written Consent
 *
 * Edit a working consent's text (skip-None partial update).
 *
 * Refused once the consent has been circulated. From there a change is a revision: the
 * text goes out again as a new version and every signature starts again, because a
 * signature names the bytes a director read.
 */
export const orgBoardOrgUpdateBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgUpdateBoardWrittenConsentData, ThrowOnError>): RequestResult<OrgBoardOrgUpdateBoardWrittenConsentResponses, OrgBoardOrgUpdateBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).patch<OrgBoardOrgUpdateBoardWrittenConsentResponses, OrgBoardOrgUpdateBoardWrittenConsentErrors, ThrowOnError>({
    url: '/board/{org_ref}/written-consents/{consent_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Circulate Board Written Consent
 *
 * Put the consent to the board.
 *
 * Freezes the text, records the roster it is going out to, and leaves the consent
 * pending. Until every seat on that roster has signed, the response says so in as many
 * words: the consent is pending, and how many seats have signed.
 *
 * Observers are not on the roster a consent goes to — the roster records them as
 * non-voting seats.
 */
export const orgBoardOrgCirculateBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgCirculateBoardWrittenConsentData, ThrowOnError>): RequestResult<OrgBoardOrgCirculateBoardWrittenConsentResponses, OrgBoardOrgCirculateBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgCirculateBoardWrittenConsentResponses, OrgBoardOrgCirculateBoardWrittenConsentErrors, ThrowOnError>({ url: '/board/{org_ref}/written-consents/{consent_id}/circulation', ...options });

/**
 * Org List Board Consent Compensation Decisions
 *
 * A written consent's compensation decisions, in order, with their documents, and the one
 * block its text must carry, exactly as shown, to go out to the board: the directors sign the
 * details in the text they read. Whether the current text carries it.
 */
export const orgBoardOrgListBoardConsentCompensationDecisions = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgListBoardConsentCompensationDecisionsData, ThrowOnError>): RequestResult<OrgBoardOrgListBoardConsentCompensationDecisionsResponses, OrgBoardOrgListBoardConsentCompensationDecisionsErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgListBoardConsentCompensationDecisionsResponses, OrgBoardOrgListBoardConsentCompensationDecisionsErrors, ThrowOnError>({ url: '/board/{org_ref}/written-consents/{consent_id}/compensation-decisions', ...options });

/**
 * Org Add Board Consent Compensation Decision
 *
 * Record the board's compensation decision for one person on a written consent's draft,
 * after its others: whose pay, their position, how the board obtained what it relied on, and
 * its reason when it set pay outside the range in that information. Its documents are uploaded
 * onto it. Refused once the consent has gone out to the board.
 */
export const orgBoardOrgAddBoardConsentCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgAddBoardConsentCompensationDecisionData, ThrowOnError>): RequestResult<OrgBoardOrgAddBoardConsentCompensationDecisionResponses, OrgBoardOrgAddBoardConsentCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgAddBoardConsentCompensationDecisionResponses, OrgBoardOrgAddBoardConsentCompensationDecisionErrors, ThrowOnError>({
    url: '/board/{org_ref}/written-consents/{consent_id}/compensation-decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Remove Board Consent Compensation Decision
 *
 * Remove one consent decision, with its documents, while the consent is a draft. Its
 * history keeps who recorded and removed it, and when.
 */
export const orgBoardOrgRemoveBoardConsentCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemoveBoardConsentCompensationDecisionData, ThrowOnError>): RequestResult<OrgBoardOrgRemoveBoardConsentCompensationDecisionResponses, OrgBoardOrgRemoveBoardConsentCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgRemoveBoardConsentCompensationDecisionResponses, OrgBoardOrgRemoveBoardConsentCompensationDecisionErrors, ThrowOnError>({ url: '/board/{org_ref}/written-consents/{consent_id}/compensation-decisions/{decision_id}', ...options });

/**
 * Org Replace Board Consent Compensation Decision
 *
 * Replace one consent decision's details whole, while the consent is a draft. Its uploaded
 * documents stay. The consent's text must then carry the block as it now reads.
 */
export const orgBoardOrgReplaceBoardConsentCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgReplaceBoardConsentCompensationDecisionData, ThrowOnError>): RequestResult<OrgBoardOrgReplaceBoardConsentCompensationDecisionResponses, OrgBoardOrgReplaceBoardConsentCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).put<OrgBoardOrgReplaceBoardConsentCompensationDecisionResponses, OrgBoardOrgReplaceBoardConsentCompensationDecisionErrors, ThrowOnError>({
    url: '/board/{org_ref}/written-consents/{consent_id}/compensation-decisions/{decision_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Confirm Board Compensation Document
 *
 * Confirm a document finished uploading: Board reads the stored file and records its
 * fingerprint and size, which the consent's text names. A file over 100 MB is refused.
 */
export const orgBoardOrgConfirmBoardCompensationDocument = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgConfirmBoardCompensationDocumentData, ThrowOnError>): RequestResult<OrgBoardOrgConfirmBoardCompensationDocumentResponses, OrgBoardOrgConfirmBoardCompensationDocumentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgConfirmBoardCompensationDocumentResponses, OrgBoardOrgConfirmBoardCompensationDocumentErrors, ThrowOnError>({
    url: '/board/{org_ref}/written-consents/{consent_id}/compensation-decisions/{decision_id}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Issue Board Compensation Document Upload Url
 *
 * A short-lived signed URL to upload one document the board relied on, onto a consent
 * decision, bound to its file type. Nothing is recorded until the upload is confirmed.
 */
export const orgBoardOrgIssueBoardCompensationDocumentUploadUrl = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgIssueBoardCompensationDocumentUploadUrlData, ThrowOnError>): RequestResult<OrgBoardOrgIssueBoardCompensationDocumentUploadUrlResponses, OrgBoardOrgIssueBoardCompensationDocumentUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgIssueBoardCompensationDocumentUploadUrlResponses, OrgBoardOrgIssueBoardCompensationDocumentUploadUrlErrors, ThrowOnError>({
    url: '/board/{org_ref}/written-consents/{consent_id}/compensation-decisions/{decision_id}/documents/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Remove Board Compensation Document
 *
 * Remove one of a consent decision's documents, while the consent is a draft.
 */
export const orgBoardOrgRemoveBoardCompensationDocument = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRemoveBoardCompensationDocumentData, ThrowOnError>): RequestResult<OrgBoardOrgRemoveBoardCompensationDocumentResponses, OrgBoardOrgRemoveBoardCompensationDocumentErrors, ThrowOnError> => (options.client ?? client).delete<OrgBoardOrgRemoveBoardCompensationDocumentResponses, OrgBoardOrgRemoveBoardCompensationDocumentErrors, ThrowOnError>({ url: '/board/{org_ref}/written-consents/{consent_id}/compensation-decisions/{decision_id}/documents/{document_id}', ...options });

/**
 * Org Get Board Compensation Document Download
 *
 * A short-lived link to read one of a consent decision's documents, made for this request
 * and never stored.
 */
export const orgBoardOrgGetBoardCompensationDocumentDownload = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgGetBoardCompensationDocumentDownloadData, ThrowOnError>): RequestResult<OrgBoardOrgGetBoardCompensationDocumentDownloadResponses, OrgBoardOrgGetBoardCompensationDocumentDownloadErrors, ThrowOnError> => (options.client ?? client).get<OrgBoardOrgGetBoardCompensationDocumentDownloadResponses, OrgBoardOrgGetBoardCompensationDocumentDownloadErrors, ThrowOnError>({ url: '/board/{org_ref}/written-consents/{consent_id}/compensation-decisions/{decision_id}/documents/{document_id}/download', ...options });

/**
 * Org Record Board Consent Revocation
 *
 * Withdraw an assent recorded on a director's behalf.
 *
 * Appended as its own act with its own note, never an edit of the entry it withdraws —
 * the signature log is only ever added to.
 */
export const orgBoardOrgRecordBoardConsentRevocation = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardConsentRevocationData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardConsentRevocationResponses, OrgBoardOrgRecordBoardConsentRevocationErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardConsentRevocationResponses, OrgBoardOrgRecordBoardConsentRevocationErrors, ThrowOnError>({
    url: '/board/{org_ref}/written-consents/{consent_id}/recorded-signature-withdrawals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Board Consent Signature
 *
 * Record a director's assent on their behalf.
 *
 * The path a board actually needs: a director who signed on paper, or who will not use
 * the portal at all, is not thereby unable to act. The entry is labelled as one the
 * officer made, carries the officer's own identity, and requires a note saying where
 * the assent came from. It completes a consent exactly as a director's own signature
 * does.
 */
export const orgBoardOrgRecordBoardConsentSignature = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgRecordBoardConsentSignatureData, ThrowOnError>): RequestResult<OrgBoardOrgRecordBoardConsentSignatureResponses, OrgBoardOrgRecordBoardConsentSignatureErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgRecordBoardConsentSignatureResponses, OrgBoardOrgRecordBoardConsentSignatureErrors, ThrowOnError>({
    url: '/board/{org_ref}/written-consents/{consent_id}/recorded-signatures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Revise Board Written Consent
 *
 * Revise a consent that is before the board.
 *
 * The new text goes out as a new version to a freshly recorded roster, and **every
 * signature already given starts again** — a director who signed the earlier text has
 * not signed this one. The earlier version keeps its own signatures as history.
 */
export const orgBoardOrgReviseBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgReviseBoardWrittenConsentData, ThrowOnError>): RequestResult<OrgBoardOrgReviseBoardWrittenConsentResponses, OrgBoardOrgReviseBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgReviseBoardWrittenConsentResponses, OrgBoardOrgReviseBoardWrittenConsentErrors, ThrowOnError>({
    url: '/board/{org_ref}/written-consents/{consent_id}/revision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Withdraw Board Written Consent
 *
 * Stop a consent before every seat has signed, with a recorded reason.
 *
 * The consent and its signatures stay: how the board arrived at whatever it did
 * instead is part of the charity's own history.
 */
export const orgBoardOrgWithdrawBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<OrgBoardOrgWithdrawBoardWrittenConsentData, ThrowOnError>): RequestResult<OrgBoardOrgWithdrawBoardWrittenConsentResponses, OrgBoardOrgWithdrawBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).post<OrgBoardOrgWithdrawBoardWrittenConsentResponses, OrgBoardOrgWithdrawBoardWrittenConsentErrors, ThrowOnError>({
    url: '/board/{org_ref}/written-consents/{consent_id}/withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Books
 *
 * Open one organization's Books read surface.
 *
 * A0 never returns 200: an authorized, provisioned organization reaches the
 * typed ``BOOKS_READ_UNAVAILABLE`` 503 until A1 installs the dedicated reader.
 */
export const booksGetBooks = <ThrowOnError extends boolean = false>(options: Options<BooksGetBooksData, ThrowOnError>): RequestResult<BooksGetBooksResponses, BooksGetBooksErrors, ThrowOnError> => (options.client ?? client).get<BooksGetBooksResponses, BooksGetBooksErrors, ThrowOnError>({ url: '/books/{org_ref}', ...options });

/**
 * Activate Books
 *
 * Advance one organization's Books setup from durable enrollment truth.
 */
export const booksActivateBooks = <ThrowOnError extends boolean = false>(options: Options<BooksActivateBooksData, ThrowOnError>): RequestResult<BooksActivateBooksResponses, BooksActivateBooksErrors, ThrowOnError> => (options.client ?? client).post<BooksActivateBooksResponses, BooksActivateBooksErrors, ThrowOnError>({ url: '/books/{org_ref}/activation', ...options });

/**
 * Get Supporter
 */
export const p2pGetSupporter = <ThrowOnError extends boolean = false>(options: Options<P2pGetSupporterData, ThrowOnError>): RequestResult<P2pGetSupporterResponses, P2pGetSupporterErrors, ThrowOnError> => (options.client ?? client).get<P2pGetSupporterResponses, P2pGetSupporterErrors, ThrowOnError>({ url: '/campaign-supporters/{supporter_id}', ...options });

/**
 * Update Supporter
 */
export const p2pUpdateSupporter = <ThrowOnError extends boolean = false>(options: Options<P2pUpdateSupporterData, ThrowOnError>): RequestResult<P2pUpdateSupporterResponses, P2pUpdateSupporterErrors, ThrowOnError> => (options.client ?? client).patch<P2pUpdateSupporterResponses, P2pUpdateSupporterErrors, ThrowOnError>({
    url: '/campaign-supporters/{supporter_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Team
 */
export const p2pGetTeam = <ThrowOnError extends boolean = false>(options: Options<P2pGetTeamData, ThrowOnError>): RequestResult<P2pGetTeamResponses, P2pGetTeamErrors, ThrowOnError> => (options.client ?? client).get<P2pGetTeamResponses, P2pGetTeamErrors, ThrowOnError>({ url: '/campaign-teams/{team_id}', ...options });

/**
 * Get Campaign P2P
 */
export const p2pGetCampaignP2P = <ThrowOnError extends boolean = false>(options: Options<P2pGetCampaignP2pData, ThrowOnError>): RequestResult<P2pGetCampaignP2pResponses, P2pGetCampaignP2pErrors, ThrowOnError> => (options.client ?? client).get<P2pGetCampaignP2pResponses, P2pGetCampaignP2pErrors, ThrowOnError>({ url: '/campaigns/{campaign_id}', ...options });

/**
 * Get Activity
 */
export const p2pGetActivity = <ThrowOnError extends boolean = false>(options: Options<P2pGetActivityData, ThrowOnError>): RequestResult<P2pGetActivityResponses, P2pGetActivityErrors, ThrowOnError> => (options.client ?? client).get<P2pGetActivityResponses, P2pGetActivityErrors, ThrowOnError>({ url: '/campaigns/{campaign_id}/activity', ...options });

/**
 * List Give Options
 *
 * FCM-BE74 (D-FCM-33 5.5; FCM-WEB26's picker): the fundraisers under the campaign that
 * still take a gift, its campaigns first, then people's pages, each kind ranked by its
 * board and then, unranked by name, those whose own switch is off; each with the ids of
 * what it raises for and no amount. `search` narrows both by name. Anonymous, like every
 * `/campaigns` read; a campaign the public campaign read does not serve is its one
 * not-found.
 */
export const p2pListGiveOptions = <ThrowOnError extends boolean = false>(options: Options<P2pListGiveOptionsData, ThrowOnError>): RequestResult<P2pListGiveOptionsResponses, P2pListGiveOptionsErrors, ThrowOnError> => (options.client ?? client).get<P2pListGiveOptionsResponses, P2pListGiveOptionsErrors, ThrowOnError>({ url: '/campaigns/{campaign_id}/give-options', ...options });

/**
 * Join Campaign
 */
export const p2pJoinCampaign = <ThrowOnError extends boolean = false>(options: Options<P2pJoinCampaignData, ThrowOnError>): RequestResult<P2pJoinCampaignResponses, P2pJoinCampaignErrors, ThrowOnError> => (options.client ?? client).post<P2pJoinCampaignResponses, P2pJoinCampaignErrors, ThrowOnError>({
    url: '/campaigns/{campaign_id}/join',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Campaign Join
 *
 * Whether the join would admit the caller now, by the join setting's own gate, as if
 * they held no invitation (D-FCM-35 6.10: the donate join page's "Members only" up front),
 * and the gate's own words when it would not. Mints, spends and reserves nothing.
 */
export const p2pCheckCampaignJoin = <ThrowOnError extends boolean = false>(options: Options<P2pCheckCampaignJoinData, ThrowOnError>): RequestResult<P2pCheckCampaignJoinResponses, P2pCheckCampaignJoinErrors, ThrowOnError> => (options.client ?? client).get<P2pCheckCampaignJoinResponses, P2pCheckCampaignJoinErrors, ThrowOnError>({ url: '/campaigns/{campaign_id}/join-check', ...options });

/**
 * Request To Join Campaign
 *
 * Ask to start a supporter page under the campaign (its join setting is "Request to
 * join"): 202 with the request waiting for its organizers; 200 with what stands when the
 * person asked already (the request waiting, or a decline, which is final) or already has
 * a page (``supporter_id``). Counted against the join's own rate limit.
 */
export const p2pRequestToJoinCampaign = <ThrowOnError extends boolean = false>(options: Options<P2pRequestToJoinCampaignData, ThrowOnError>): RequestResult<P2pRequestToJoinCampaignResponses, P2pRequestToJoinCampaignErrors, ThrowOnError> => (options.client ?? client).post<P2pRequestToJoinCampaignResponses, P2pRequestToJoinCampaignErrors, ThrowOnError>({
    url: '/campaigns/{campaign_id}/join-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw My Campaign Join Request
 *
 * Withdraw the caller's waiting request; nothing waiting is a no-op 204.
 */
export const p2pWithdrawMyCampaignJoinRequest = <ThrowOnError extends boolean = false>(options: Options<P2pWithdrawMyCampaignJoinRequestData, ThrowOnError>): RequestResult<P2pWithdrawMyCampaignJoinRequestResponses, P2pWithdrawMyCampaignJoinRequestErrors, ThrowOnError> => (options.client ?? client).delete<P2pWithdrawMyCampaignJoinRequestResponses, P2pWithdrawMyCampaignJoinRequestErrors, ThrowOnError>({ url: '/campaigns/{campaign_id}/join-requests/mine', ...options });

/**
 * Get My Campaign Join Request
 *
 * The caller's own standing with the campaign: their latest request (its status as
 * read: a waiting one past its 14 days reads ``expired``), and their page's link when they
 * have one.
 */
export const p2pGetMyCampaignJoinRequest = <ThrowOnError extends boolean = false>(options: Options<P2pGetMyCampaignJoinRequestData, ThrowOnError>): RequestResult<P2pGetMyCampaignJoinRequestResponses, P2pGetMyCampaignJoinRequestErrors, ThrowOnError> => (options.client ?? client).get<P2pGetMyCampaignJoinRequestResponses, P2pGetMyCampaignJoinRequestErrors, ThrowOnError>({ url: '/campaigns/{campaign_id}/join-requests/mine', ...options });

/**
 * List Campaign Layer Board
 *
 * FCM-BE33: the campaign's board of child layers, its public subtree's totals by
 * child: by rank (amount, then donors, then when attached), or by date (each child's
 * end). A layer whose own switch is off is not a row (D-FCM-26). Anonymous; a campaign
 * the public campaign read does not serve is its one not-found.
 */
export const campaignsListCampaignLayerBoard = <ThrowOnError extends boolean = false>(options: Options<CampaignsListCampaignLayerBoardData, ThrowOnError>): RequestResult<CampaignsListCampaignLayerBoardResponses, CampaignsListCampaignLayerBoardErrors, ThrowOnError> => (options.client ?? client).get<CampaignsListCampaignLayerBoardResponses, CampaignsListCampaignLayerBoardErrors, ThrowOnError>({ url: '/campaigns/{campaign_id}/layers', ...options });

/**
 * Get Leaderboard
 */
export const p2pGetLeaderboard = <ThrowOnError extends boolean = false>(options: Options<P2pGetLeaderboardData, ThrowOnError>): RequestResult<P2pGetLeaderboardResponses, P2pGetLeaderboardErrors, ThrowOnError> => (options.client ?? client).get<P2pGetLeaderboardResponses, P2pGetLeaderboardErrors, ThrowOnError>({ url: '/campaigns/{campaign_id}/leaderboard', ...options });

/**
 * List Campaign Schedule
 *
 * FCM-BE56: what a campaign's `schedule` card draws, its child layers on a timeline:
 * each one that counts publicly, in the order they end, with its public total (null while
 * its own switch is off) and whether it has ended. Anonymous; a campaign the public
 * campaign read does not serve is its one not-found.
 */
export const campaignsListCampaignSchedule = <ThrowOnError extends boolean = false>(options: Options<CampaignsListCampaignScheduleData, ThrowOnError>): RequestResult<CampaignsListCampaignScheduleResponses, CampaignsListCampaignScheduleErrors, ThrowOnError> => (options.client ?? client).get<CampaignsListCampaignScheduleResponses, CampaignsListCampaignScheduleErrors, ThrowOnError>({ url: '/campaigns/{campaign_id}/schedule', ...options });

/**
 * List Teams
 */
export const p2pListTeams = <ThrowOnError extends boolean = false>(options: Options<P2pListTeamsData, ThrowOnError>): RequestResult<P2pListTeamsResponses, P2pListTeamsErrors, ThrowOnError> => (options.client ?? client).get<P2pListTeamsResponses, P2pListTeamsErrors, ThrowOnError>({ url: '/campaigns/{campaign_id}/teams', ...options });

/**
 * Get All Cause Tags
 */
export const causeTagsGetAllCauseTags = <ThrowOnError extends boolean = false>(options?: Options<CauseTagsGetAllCauseTagsData, ThrowOnError>): RequestResult<CauseTagsGetAllCauseTagsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CauseTagsGetAllCauseTagsResponses, unknown, ThrowOnError>({ url: '/cause-tags', ...options });

/**
 * Create Cause Tag
 */
export const causeTagsCreateCauseTag = <ThrowOnError extends boolean = false>(options: Options<CauseTagsCreateCauseTagData, ThrowOnError>): RequestResult<CauseTagsCreateCauseTagResponses, CauseTagsCreateCauseTagErrors, ThrowOnError> => (options.client ?? client).post<CauseTagsCreateCauseTagResponses, CauseTagsCreateCauseTagErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/cause-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Cause Tag
 */
export const causeTagsDeleteCauseTag = <ThrowOnError extends boolean = false>(options: Options<CauseTagsDeleteCauseTagData, ThrowOnError>): RequestResult<CauseTagsDeleteCauseTagResponses, CauseTagsDeleteCauseTagErrors, ThrowOnError> => (options.client ?? client).delete<CauseTagsDeleteCauseTagResponses, CauseTagsDeleteCauseTagErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/cause-tags/{tag_id}',
    ...options
});

/**
 * Update Cause Tag
 */
export const causeTagsUpdateCauseTag = <ThrowOnError extends boolean = false>(options: Options<CauseTagsUpdateCauseTagData, ThrowOnError>): RequestResult<CauseTagsUpdateCauseTagResponses, CauseTagsUpdateCauseTagErrors, ThrowOnError> => (options.client ?? client).put<CauseTagsUpdateCauseTagResponses, CauseTagsUpdateCauseTagErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/cause-tags/{tag_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Celebrity Charities
 */
export const celebrityCharitiesGetCelebrityCharities = <ThrowOnError extends boolean = false>(options?: Options<CelebrityCharitiesGetCelebrityCharitiesData, ThrowOnError>): RequestResult<CelebrityCharitiesGetCelebrityCharitiesResponses, CelebrityCharitiesGetCelebrityCharitiesErrors, ThrowOnError> => (options?.client ?? client).get<CelebrityCharitiesGetCelebrityCharitiesResponses, CelebrityCharitiesGetCelebrityCharitiesErrors, ThrowOnError>({ url: '/celebrity-charities', ...options });

/**
 * Create Celebrity Charity
 */
export const celebrityCharitiesCreateCelebrityCharity = <ThrowOnError extends boolean = false>(options: Options<CelebrityCharitiesCreateCelebrityCharityData, ThrowOnError>): RequestResult<CelebrityCharitiesCreateCelebrityCharityResponses, CelebrityCharitiesCreateCelebrityCharityErrors, ThrowOnError> => (options.client ?? client).post<CelebrityCharitiesCreateCelebrityCharityResponses, CelebrityCharitiesCreateCelebrityCharityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/celebrity-charities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Celebrity Charity
 */
export const celebrityCharitiesDeleteCelebrityCharity = <ThrowOnError extends boolean = false>(options: Options<CelebrityCharitiesDeleteCelebrityCharityData, ThrowOnError>): RequestResult<CelebrityCharitiesDeleteCelebrityCharityResponses, CelebrityCharitiesDeleteCelebrityCharityErrors, ThrowOnError> => (options.client ?? client).delete<CelebrityCharitiesDeleteCelebrityCharityResponses, CelebrityCharitiesDeleteCelebrityCharityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/celebrity-charities/{celebrity_charity_id}',
    ...options
});

/**
 * Get Celebrity Charity
 */
export const celebrityCharitiesGetCelebrityCharity = <ThrowOnError extends boolean = false>(options: Options<CelebrityCharitiesGetCelebrityCharityData, ThrowOnError>): RequestResult<CelebrityCharitiesGetCelebrityCharityResponses, CelebrityCharitiesGetCelebrityCharityErrors, ThrowOnError> => (options.client ?? client).get<CelebrityCharitiesGetCelebrityCharityResponses, CelebrityCharitiesGetCelebrityCharityErrors, ThrowOnError>({ url: '/celebrity-charities/{celebrity_charity_id}', ...options });

/**
 * Update Celebrity Charity
 */
export const celebrityCharitiesUpdateCelebrityCharity = <ThrowOnError extends boolean = false>(options: Options<CelebrityCharitiesUpdateCelebrityCharityData, ThrowOnError>): RequestResult<CelebrityCharitiesUpdateCelebrityCharityResponses, CelebrityCharitiesUpdateCelebrityCharityErrors, ThrowOnError> => (options.client ?? client).put<CelebrityCharitiesUpdateCelebrityCharityResponses, CelebrityCharitiesUpdateCelebrityCharityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/celebrity-charities/{celebrity_charity_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Celebrity Charity Poster
 */
export const celebrityCharitiesUploadCelebrityCharityPoster = <ThrowOnError extends boolean = false>(options: Options<CelebrityCharitiesUploadCelebrityCharityPosterData, ThrowOnError>): RequestResult<CelebrityCharitiesUploadCelebrityCharityPosterResponses, CelebrityCharitiesUploadCelebrityCharityPosterErrors, ThrowOnError> => (options.client ?? client).post<CelebrityCharitiesUploadCelebrityCharityPosterResponses, CelebrityCharitiesUploadCelebrityCharityPosterErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/celebrity-charities/{celebrity_charity_id}/poster',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Resolve Champion Native
 *
 * Resolve a give.givmo.io ``/<segment>`` (slug | handle | retired handle) to
 * its target charity id for an installed, authenticated client (D-CQ-19).
 *
 * Flag-gated (404 dark when ``CHAMPION_GIVE_HOST_ENABLED`` is off), authenticated
 * (no user → 403), and per-user rate-limited FAIL-CLOSED (→ 429). ``segment`` is
 * the RAW path segment — ``ChampionService.resolve`` lowercases it internally, so
 * do NOT lowercase here. The returned ``charity_id`` is the champion's CURRENT
 * target when ACTIVE, else ``None`` on any fallback (D-CQ-23: no fallback
 * charity). Anti-enumeration (D-CQ-14) rests on this route being authed +
 * App-Check-gated + fail-closed-rate-limited, not on a same-shape blend.
 */
export const championsResolveChampionNative = <ThrowOnError extends boolean = false>(options: Options<ChampionsResolveChampionNativeData, ThrowOnError>): RequestResult<ChampionsResolveChampionNativeResponses, ChampionsResolveChampionNativeErrors, ThrowOnError> => (options.client ?? client).get<ChampionsResolveChampionNativeResponses, ChampionsResolveChampionNativeErrors, ThrowOnError>({ url: '/champions/{segment}', ...options });

/**
 * Resolve Champion Landing
 *
 * Resolve a give.givmo.io ``/<segment>`` (slug | handle | retired handle) to
 * its target charity for the donate-web champion landing SSR loader (CQ3-BE4).
 *
 * ANONYMOUS + App-Check-gated. The donate-web ``/champion/<slug>`` React-Router
 * SSR loader resolves the segment SERVER-SIDE, and its only backend trust is a
 * server-minted App-Check token — NO user auth — so it cannot call the
 * authenticated ``GET /champions/{segment}`` (which 403s without a user). This is
 * that route's anonymous sibling: no ``request.state.user`` check. App-Check is
 * still auto-enforced because ``champions`` is a REGISTERED top-level path segment,
 * so ``handler_middleware`` never give-exempts this path (the give exemption only
 * fires for a bare single-segment path; this multi-segment path is not a bare
 * segment, and ``champions`` is in ``registered_top_segments`` regardless).
 *
 * Order — mirroring the authed sibling, but ANONYMOUS + FAIL-OPEN on the limit:
 * 1. Flag-gate FIRST (``CHAMPION_GIVE_HOST_ENABLED`` off → 404 dark,
 * indistinguishable from a missing route, before any other signal);
 * 2. per-IP rate limit FAIL-OPEN (the INVERSE of the authed endpoint's
 * fail-closed posture — a printed code's landing must NEVER 429 a donor);
 * 3. resolve with the RAW ``segment`` (``ChampionService.resolve`` lowercases
 * internally — do NOT lowercase here).
 *
 * Response is the 4-field ``{charity_id, outcome, attribution_token, banner}``
 * (PV1-BE1). ``outcome`` is the hit/miss discriminator, derived from the
 * internal ``ChampionResolution.outcome``: a genuine hit (``slug`` / ``handle``
 * / ``retired_handle``) → ``"resolved"`` with the champion's current
 * active-charity id; anything collapsed to ``fallback`` → ``"fallback"`` with
 * ``charity_id=None`` (D-CQ-23: there is no fallback charity).
 * ``attribution_token`` (USER-owned resolved champions only; ref-less degrade)
 * and ``banner`` (public-safe owner display) are both ``None`` on every
 * fallback. Under D-CQ-14 the banner is a DELIBERATE disclosure of owner
 * display identity: a champion link is a public artifact whose handle/QR
 * already advertises its owner, so the banner (PublicUserOut-safe fields only)
 * adds nothing scrape-worthy — anti-enumeration rests on App-Check + the rate
 * limit + the 50-bit slug space, not on shape blending (the authoritative
 * statement lives on ``ChampionBannerOut`` / ``ChampionLandingResolveOut``).
 */
export const championsResolveChampionLanding = <ThrowOnError extends boolean = false>(options: Options<ChampionsResolveChampionLandingData, ThrowOnError>): RequestResult<ChampionsResolveChampionLandingResponses, ChampionsResolveChampionLandingErrors, ThrowOnError> => (options.client ?? client).get<ChampionsResolveChampionLandingResponses, ChampionsResolveChampionLandingErrors, ThrowOnError>({ url: '/champions/{segment}/landing', ...options });

/**
 * Get Charities
 */
export const charitiesGetCharities = <ThrowOnError extends boolean = false>(options?: Options<CharitiesGetCharitiesData, ThrowOnError>): RequestResult<CharitiesGetCharitiesResponses, CharitiesGetCharitiesErrors, ThrowOnError> => (options?.client ?? client).get<CharitiesGetCharitiesResponses, CharitiesGetCharitiesErrors, ThrowOnError>({ url: '/charities', ...options });

/**
 * Create Charity
 */
export const charitiesCreateCharity = <ThrowOnError extends boolean = false>(options: Options<CharitiesCreateCharityData, ThrowOnError>): RequestResult<CharitiesCreateCharityResponses, CharitiesCreateCharityErrors, ThrowOnError> => (options.client ?? client).post<CharitiesCreateCharityResponses, CharitiesCreateCharityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/charities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Charities By Cause Tag
 */
export const charitiesGetCharitiesByCauseTag = <ThrowOnError extends boolean = false>(options: Options<CharitiesGetCharitiesByCauseTagData, ThrowOnError>): RequestResult<CharitiesGetCharitiesByCauseTagResponses, CharitiesGetCharitiesByCauseTagErrors, ThrowOnError> => (options.client ?? client).get<CharitiesGetCharitiesByCauseTagResponses, CharitiesGetCharitiesByCauseTagErrors, ThrowOnError>({ url: '/charities/cause-tag/{tag_id}', ...options });

/**
 * Get Follows Championed Charities
 */
export const charitiesGetFollowsChampionedCharities = <ThrowOnError extends boolean = false>(options?: Options<CharitiesGetFollowsChampionedCharitiesData, ThrowOnError>): RequestResult<CharitiesGetFollowsChampionedCharitiesResponses, CharitiesGetFollowsChampionedCharitiesErrors, ThrowOnError> => (options?.client ?? client).get<CharitiesGetFollowsChampionedCharitiesResponses, CharitiesGetFollowsChampionedCharitiesErrors, ThrowOnError>({ url: '/charities/follows/championed', ...options });

/**
 * Get Follows Donated Charities
 */
export const charitiesGetFollowsDonatedCharities = <ThrowOnError extends boolean = false>(options?: Options<CharitiesGetFollowsDonatedCharitiesData, ThrowOnError>): RequestResult<CharitiesGetFollowsDonatedCharitiesResponses, CharitiesGetFollowsDonatedCharitiesErrors, ThrowOnError> => (options?.client ?? client).get<CharitiesGetFollowsDonatedCharitiesResponses, CharitiesGetFollowsDonatedCharitiesErrors, ThrowOnError>({ url: '/charities/follows/donated', ...options });

/**
 * Lookup Charity By Domain
 *
 * Resolve a scanned/external domain to a known charity. Intentionally
 * unauthenticated and returns a reduced payload (no internal/financial fields).
 */
export const charitiesLookupCharityByDomain = <ThrowOnError extends boolean = false>(options: Options<CharitiesLookupCharityByDomainData, ThrowOnError>): RequestResult<CharitiesLookupCharityByDomainResponses, CharitiesLookupCharityByDomainErrors, ThrowOnError> => (options.client ?? client).get<CharitiesLookupCharityByDomainResponses, CharitiesLookupCharityByDomainErrors, ThrowOnError>({ url: '/charities/lookup', ...options });

/**
 * Get Suggested Charities
 */
export const charitiesGetSuggestedCharities = <ThrowOnError extends boolean = false>(options?: Options<CharitiesGetSuggestedCharitiesData, ThrowOnError>): RequestResult<CharitiesGetSuggestedCharitiesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CharitiesGetSuggestedCharitiesResponses, unknown, ThrowOnError>({ url: '/charities/suggested', ...options });

/**
 * Get Charity
 *
 * One charity, with ``legal_name`` (CPA-BE44): the name the IRS records for its EIN,
 * which the "Charity details" control shows beside the EIN; ``name`` is the name donors
 * see (a claimed charity's display name when it set one). ``legal_name`` is null when no
 * IRS legal name is on file.
 */
export const charitiesGetCharity = <ThrowOnError extends boolean = false>(options: Options<CharitiesGetCharityData, ThrowOnError>): RequestResult<CharitiesGetCharityResponses, CharitiesGetCharityErrors, ThrowOnError> => (options.client ?? client).get<CharitiesGetCharityResponses, CharitiesGetCharityErrors, ThrowOnError>({ url: '/charities/{charity_id}', ...options });

/**
 * Update Charity
 */
export const charitiesUpdateCharity = <ThrowOnError extends boolean = false>(options: Options<CharitiesUpdateCharityData, ThrowOnError>): RequestResult<CharitiesUpdateCharityResponses, CharitiesUpdateCharityErrors, ThrowOnError> => (options.client ?? client).put<CharitiesUpdateCharityResponses, CharitiesUpdateCharityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/charities/{charity_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Cause Tags For Charity
 */
export const charitiesGetCauseTagsForCharity = <ThrowOnError extends boolean = false>(options: Options<CharitiesGetCauseTagsForCharityData, ThrowOnError>): RequestResult<CharitiesGetCauseTagsForCharityResponses, CharitiesGetCauseTagsForCharityErrors, ThrowOnError> => (options.client ?? client).get<CharitiesGetCauseTagsForCharityResponses, CharitiesGetCauseTagsForCharityErrors, ThrowOnError>({ url: '/charities/{charity_id}/cause-tags', ...options });

/**
 * Remove Cause Tag From Charity
 */
export const charitiesRemoveCauseTagFromCharity = <ThrowOnError extends boolean = false>(options: Options<CharitiesRemoveCauseTagFromCharityData, ThrowOnError>): RequestResult<CharitiesRemoveCauseTagFromCharityResponses, CharitiesRemoveCauseTagFromCharityErrors, ThrowOnError> => (options.client ?? client).delete<CharitiesRemoveCauseTagFromCharityResponses, CharitiesRemoveCauseTagFromCharityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/charities/{charity_id}/cause-tags/{tag_id}',
    ...options
});

/**
 * Add Cause Tag To Charity
 */
export const charitiesAddCauseTagToCharity = <ThrowOnError extends boolean = false>(options: Options<CharitiesAddCauseTagToCharityData, ThrowOnError>): RequestResult<CharitiesAddCauseTagToCharityResponses, CharitiesAddCauseTagToCharityErrors, ThrowOnError> => (options.client ?? client).post<CharitiesAddCauseTagToCharityResponses, CharitiesAddCauseTagToCharityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/charities/{charity_id}/cause-tags/{tag_id}',
    ...options
});

/**
 * Create Charity Donation
 */
export const donationsCreateCharityDonation = <ThrowOnError extends boolean = false>(options: Options<DonationsCreateCharityDonationData, ThrowOnError>): RequestResult<DonationsCreateCharityDonationResponses, DonationsCreateCharityDonationErrors, ThrowOnError> => (options.client ?? client).post<DonationsCreateCharityDonationResponses, DonationsCreateCharityDonationErrors, ThrowOnError>({
    url: '/charities/{charity_id}/donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create External Donation
 *
 * Book an EXTERNAL donation (moves no money; ``request_match`` spawns a
 * pending company match). Authenticated + ownership-gated: the caller may only
 * book their OWN external donation (body ``user_id`` must equal the caller), a
 * super-admin included (CAM-R39, D-CAM-35). Booking on another user's behalf
 * is the dedicated, money-action-guarded ``POST /super-admin/users/{user_id}/
 * donations/external`` route — the only door the COO lane and the super-admin
 * portal use. FU-01 closed this legacy path to anonymous and arbitrary-user
 * bookings.
 */
export const donationsCreateExternalDonation = <ThrowOnError extends boolean = false>(options: Options<DonationsCreateExternalDonationData, ThrowOnError>): RequestResult<DonationsCreateExternalDonationResponses, DonationsCreateExternalDonationErrors, ThrowOnError> => (options.client ?? client).post<DonationsCreateExternalDonationResponses, DonationsCreateExternalDonationErrors, ThrowOnError>({
    url: '/charities/{charity_id}/donations/external',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Grants By Charity
 */
export const grantsGetGrantsByCharity = <ThrowOnError extends boolean = false>(options: Options<GrantsGetGrantsByCharityData, ThrowOnError>): RequestResult<GrantsGetGrantsByCharityResponses, GrantsGetGrantsByCharityErrors, ThrowOnError> => (options.client ?? client).get<GrantsGetGrantsByCharityResponses, GrantsGetGrantsByCharityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/charities/{charity_id}/grants',
    ...options
});

/**
 * List Charity Match Offers
 *
 * The claim-banner read (03 §2.4): the engine's claim-candidate offers for
 * the charity, oldest-first (the banner's first row IS the offer a
 * claim-eligible donation would claim — 02 §1.3 "display matches the engine"),
 * LIVE remaining off the row. PUBLIC read (``user`` may be None); when a valid
 * token IS presented, the middleware-resolved user feeds the ADDITIVE
 * ``is_own_offer`` flag (PV2-BE7 — never the offeror's user id). Each row also
 * carries ``leg_count``, the §1.3 canonical-line N ("one of N offers backed by
 * the same fund"). Respects the publicize_consent →
 * display-name-or-"A Givmo member" masking rule.
 */
export const matchOffersListCharityMatchOffers = <ThrowOnError extends boolean = false>(options: Options<MatchOffersListCharityMatchOffersData, ThrowOnError>): RequestResult<MatchOffersListCharityMatchOffersResponses, MatchOffersListCharityMatchOffersErrors, ThrowOnError> => (options.client ?? client).get<MatchOffersListCharityMatchOffersResponses, MatchOffersListCharityMatchOffersErrors, ThrowOnError>({ url: '/charities/{charity_id}/match-offers', ...options });

/**
 * Upload Charity Profile Picture
 */
export const charitiesUploadCharityProfilePicture = <ThrowOnError extends boolean = false>(options: Options<CharitiesUploadCharityProfilePictureData, ThrowOnError>): RequestResult<CharitiesUploadCharityProfilePictureResponses, CharitiesUploadCharityProfilePictureErrors, ThrowOnError> => (options.client ?? client).post<CharitiesUploadCharityProfilePictureResponses, CharitiesUploadCharityProfilePictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/charities/{charity_id}/profile_picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Create Charity Recurring Donation
 */
export const donationsCreateCharityRecurringDonation = <ThrowOnError extends boolean = false>(options: Options<DonationsCreateCharityRecurringDonationData, ThrowOnError>): RequestResult<DonationsCreateCharityRecurringDonationResponses, DonationsCreateCharityRecurringDonationErrors, ThrowOnError> => (options.client ?? client).post<DonationsCreateCharityRecurringDonationResponses, DonationsCreateCharityRecurringDonationErrors, ThrowOnError>({
    url: '/charities/{charity_id}/recurring-donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Agenda Templates
 *
 * The neutral agenda templates a charity may select.
 *
 * Structural sections only. Nothing in a template is drawn from any charity's own
 * documents, calendar, or history, and nothing applies one — the charity names the
 * template it wants. `suggested_for` orders a human's picker and is read by nothing.
 */
export const charityBoardListBoardAgendaTemplates = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardAgendaTemplatesData, ThrowOnError>): RequestResult<CharityBoardListBoardAgendaTemplatesResponses, CharityBoardListBoardAgendaTemplatesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardAgendaTemplatesResponses, CharityBoardListBoardAgendaTemplatesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/agenda-templates', ...options });

/**
 * List Board Calendar Connections
 *
 * Every calendar connected for the board, with the upcoming meetings each one sends (the
 * handover view), in the canonical `{data, meta, links}` envelope.
 */
export const charityBoardListBoardCalendarConnections = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardCalendarConnectionsData, ThrowOnError>): RequestResult<CharityBoardListBoardCalendarConnectionsResponses, CharityBoardListBoardCalendarConnectionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardCalendarConnectionsResponses, CharityBoardListBoardCalendarConnectionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/calendar/connections', ...options });

/**
 * Move Board Calendar Meetings
 *
 * Move every upcoming meeting one calendar sends to another sender in one act (directors
 * get one cancellation and one new invitation each), or stop keeping them in step.
 */
export const charityBoardMoveBoardCalendarMeetings = <ThrowOnError extends boolean = false>(options: Options<CharityBoardMoveBoardCalendarMeetingsData, ThrowOnError>): RequestResult<CharityBoardMoveBoardCalendarMeetingsResponses, CharityBoardMoveBoardCalendarMeetingsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardMoveBoardCalendarMeetingsResponses, CharityBoardMoveBoardCalendarMeetingsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/calendar/moves',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Calendar Senders
 *
 * Who can send this charity's meeting invitations, in order: the officer's own connected
 * calendar, then the board account — and whether the officer can connect their own calendar
 * here.
 */
export const charityBoardListBoardCalendarSenders = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardCalendarSendersData, ThrowOnError>): RequestResult<CharityBoardListBoardCalendarSendersResponses, CharityBoardListBoardCalendarSendersErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardCalendarSendersResponses, CharityBoardListBoardCalendarSendersErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/calendar/senders', ...options });

/**
 * Get Board Calendar Settings
 *
 * The board's calendar settings: whether directors may change a meeting's details in
 * their calendar, propose new times and see the guest list, and whether invitations use the
 * meetings' own titles. The shipped defaults until an Owner adopts settings.
 */
export const charityBoardGetBoardCalendarSettings = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCalendarSettingsData, ThrowOnError>): RequestResult<CharityBoardGetBoardCalendarSettingsResponses, CharityBoardGetBoardCalendarSettingsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCalendarSettingsResponses, CharityBoardGetBoardCalendarSettingsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/calendar/settings', ...options });

/**
 * Adopt Board Calendar Settings
 *
 * Adopt the board's calendar settings (all four). They apply to meetings sent from now
 * on; "Apply to upcoming meetings" applies them to meetings already sent.
 */
export const charityBoardAdoptBoardCalendarSettings = <ThrowOnError extends boolean = false>(options: Options<CharityBoardAdoptBoardCalendarSettingsData, ThrowOnError>): RequestResult<CharityBoardAdoptBoardCalendarSettingsResponses, CharityBoardAdoptBoardCalendarSettingsErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardAdoptBoardCalendarSettingsResponses, CharityBoardAdoptBoardCalendarSettingsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/calendar/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply Board Calendar Settings
 *
 * Apply the board's calendar settings to every upcoming meeting already sent from a
 * connected calendar.
 */
export const charityBoardApplyBoardCalendarSettings = <ThrowOnError extends boolean = false>(options: Options<CharityBoardApplyBoardCalendarSettingsData, ThrowOnError>): RequestResult<CharityBoardApplyBoardCalendarSettingsResponses, CharityBoardApplyBoardCalendarSettingsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardApplyBoardCalendarSettingsResponses, CharityBoardApplyBoardCalendarSettingsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/calendar/settings/application', ...options });

/**
 * List Board Carry Forward Items
 *
 * Prior meetings' agenda items the charity marked as left open.
 *
 * Exactly what the charity marked, and nothing else. An item nobody dispositioned does
 * not appear here — deciding on the charity's behalf that a past item is unfinished
 * business would be the module making a governance judgment.
 */
export const charityBoardListBoardCarryForwardItems = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardCarryForwardItemsData, ThrowOnError>): RequestResult<CharityBoardListBoardCarryForwardItemsResponses, CharityBoardListBoardCarryForwardItemsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardCarryForwardItemsResponses, CharityBoardListBoardCarryForwardItemsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/carry-forward-items', ...options });

/**
 * List Board Carry Forward Motions
 *
 * Motions from past meetings that are still before the board.
 *
 * The companion of the carry-forward agenda items on the meetings surface: together they
 * are what an officer building the next agenda needs to see. Both report only what the
 * charity itself left open — a motion nobody withdrew and nobody voted on — and neither
 * infers that anything else is unfinished business.
 *
 * A motion made inside a closed session this reader was not part of does not appear.
 */
export const charityBoardListBoardCarryForwardMotions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardCarryForwardMotionsData, ThrowOnError>): RequestResult<CharityBoardListBoardCarryForwardMotionsResponses, CharityBoardListBoardCarryForwardMotionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardCarryForwardMotionsResponses, CharityBoardListBoardCarryForwardMotionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/carry-forward-motions', ...options });

/**
 * List Board Coi Cycles
 *
 * Every year's annual disclosures, newest first: each one's dates, status and count of
 * submissions (never a count of conflicts).
 */
export const charityBoardListBoardCoiCycles = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardCoiCyclesData, ThrowOnError>): RequestResult<CharityBoardListBoardCoiCyclesResponses, CharityBoardListBoardCoiCyclesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardCoiCyclesResponses, CharityBoardListBoardCoiCyclesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-cycles', ...options });

/**
 * Open Board Coi Cycle
 *
 * Start a year's annual conflict-of-interest disclosures: everyone on the roster is asked,
 * with Givmo's starting questionnaire (any question turned off) and the organization's own
 * policy from Governance, if it holds one. Each person is emailed the request; a seat no
 * account has joined gets an invitation to join with it.
 */
export const charityBoardOpenBoardCoiCycle = <ThrowOnError extends boolean = false>(options: Options<CharityBoardOpenBoardCoiCycleData, ThrowOnError>): RequestResult<CharityBoardOpenBoardCoiCycleResponses, CharityBoardOpenBoardCoiCycleErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardOpenBoardCoiCycleResponses, CharityBoardOpenBoardCoiCycleErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/coi-cycles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Coi Cycle
 *
 * One year's annual disclosures: who was asked, who has submitted and when, what was sent
 * and when, and who can be reminded now.
 */
export const charityBoardGetBoardCoiCycle = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCoiCycleData, ThrowOnError>): RequestResult<CharityBoardGetBoardCoiCycleResponses, CharityBoardGetBoardCoiCycleErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCoiCycleResponses, CharityBoardGetBoardCoiCycleErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}', ...options });

/**
 * Update Board Coi Cycle
 *
 * Change an open year's due date. Recorded in the year's log; sends nothing.
 */
export const charityBoardUpdateBoardCoiCycle = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardCoiCycleData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardCoiCycleResponses, CharityBoardUpdateBoardCoiCycleErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardCoiCycleResponses, CharityBoardUpdateBoardCoiCycleErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Board Coi Cycle
 *
 * Withdraw a year opened by mistake, before anyone has answered. Nothing is added to the
 * minute book.
 */
export const charityBoardCancelBoardCoiCycle = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCancelBoardCoiCycleData, ThrowOnError>): RequestResult<CharityBoardCancelBoardCoiCycleResponses, CharityBoardCancelBoardCoiCycleErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCancelBoardCoiCycleResponses, CharityBoardCancelBoardCoiCycleErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/cancellation', ...options });

/**
 * Close Board Coi Cycle
 *
 * Close the year. Adds one record to the minute book: who was asked, and who submitted and
 * when. It names no one's interests. Anyone who hasn't submitted can still send their answers
 * afterwards; theirs are recorded as received after the year closed.
 */
export const charityBoardCloseBoardCoiCycle = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCloseBoardCoiCycleData, ThrowOnError>): RequestResult<CharityBoardCloseBoardCoiCycleResponses, CharityBoardCloseBoardCoiCycleErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCloseBoardCoiCycleResponses, CharityBoardCloseBoardCoiCycleErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/close', ...options });

/**
 * Get Board Coi Cycle Document
 *
 * Every response submitted for the year, in one PDF.
 */
export const charityBoardGetBoardCoiCycleDocument = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCoiCycleDocumentData, ThrowOnError>): RequestResult<CharityBoardGetBoardCoiCycleDocumentResponses, CharityBoardGetBoardCoiCycleDocumentErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCoiCycleDocumentResponses, CharityBoardGetBoardCoiCycleDocumentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/document', ...options });

/**
 * Get Board Coi Paper Form
 *
 * A paper form for one person to fill in and sign: the year's questions as they're asked
 * them, with their answers from last year where there are any.
 */
export const charityBoardGetBoardCoiPaperForm = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCoiPaperFormData, ThrowOnError>): RequestResult<CharityBoardGetBoardCoiPaperFormResponses, CharityBoardGetBoardCoiPaperFormErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCoiPaperFormResponses, CharityBoardGetBoardCoiPaperFormErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/paper-form', ...options });

/**
 * Get Board Coi Person Questionnaire
 *
 * One person's questionnaire for the year, for entering their signed paper form: the
 * questions as they're asked them, the board's policy, their answers from last year where there
 * are any, and whether a first answer can be recorded for them now (CBG-YR2-BE5).
 */
export const charityBoardGetBoardCoiPersonQuestionnaire = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCoiPersonQuestionnaireData, ThrowOnError>): RequestResult<CharityBoardGetBoardCoiPersonQuestionnaireResponses, CharityBoardGetBoardCoiPersonQuestionnaireErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCoiPersonQuestionnaireResponses, CharityBoardGetBoardCoiPersonQuestionnaireErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/questionnaire', ...options });

/**
 * Remind Board Coi Cycle Recipients
 *
 * Remind people who haven't sent their answers yet. Each gets one email, at most once a day.
 * Reminders go only when you send them. Name the people in `board_member_ids`, or send null for
 * everyone who can be reminded now.
 */
export const charityBoardRemindBoardCoiCycleRecipients = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemindBoardCoiCycleRecipientsData, ThrowOnError>): RequestResult<CharityBoardRemindBoardCoiCycleRecipientsResponses, CharityBoardRemindBoardCoiCycleRecipientsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRemindBoardCoiCycleRecipientsResponses, CharityBoardRemindBoardCoiCycleRecipientsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/reminders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Board Coi Cycle Requests
 *
 * Send the year's questionnaire to people who haven't been sent it — someone who joined the
 * board since it started, say. A seat that hasn't joined Board yet gets an invitation with it.
 * Name the people in `board_member_ids`, or send null for everyone it can go to.
 */
export const charityBoardSendBoardCoiCycleRequests = <ThrowOnError extends boolean = false>(options: Options<CharityBoardSendBoardCoiCycleRequestsData, ThrowOnError>): RequestResult<CharityBoardSendBoardCoiCycleRequestsResponses, CharityBoardSendBoardCoiCycleRequestsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardSendBoardCoiCycleRequestsResponses, CharityBoardSendBoardCoiCycleRequestsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Coi Paper Response
 *
 * Record a person's signed paper form. Their answers become their disclosure for the year,
 * recorded as entered by you from paper, with your note saying where it came from. Someone who
 * joined the board after the year started is added to it by this, with no email.
 */
export const charityBoardRecordBoardCoiPaperResponse = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardCoiPaperResponseData, ThrowOnError>): RequestResult<CharityBoardRecordBoardCoiPaperResponseResponses, CharityBoardRecordBoardCoiPaperResponseErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardCoiPaperResponseResponses, CharityBoardRecordBoardCoiPaperResponseErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/responses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Coi Response
 *
 * One person's answers for the year, as recorded: every question as they were asked it, with
 * their answer, how it was signed or recorded, and its fingerprint.
 */
export const charityBoardGetBoardCoiResponse = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCoiResponseData, ThrowOnError>): RequestResult<CharityBoardGetBoardCoiResponseResponses, CharityBoardGetBoardCoiResponseErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCoiResponseResponses, CharityBoardGetBoardCoiResponseErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/responses/{record_id}', ...options });

/**
 * Get Board Coi Response Changes
 *
 * One person's answers for the year against their answers from the year before, question by
 * question: what changed, what was added and what was removed, with both records' fingerprints.
 * Made from the two recorded disclosures; not itself a record.
 */
export const charityBoardGetBoardCoiResponseChanges = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCoiResponseChangesData, ThrowOnError>): RequestResult<CharityBoardGetBoardCoiResponseChangesResponses, CharityBoardGetBoardCoiResponseChangesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCoiResponseChangesResponses, CharityBoardGetBoardCoiResponseChangesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/responses/{record_id}/changes', ...options });

/**
 * Get Board Coi Response Document
 *
 * One person's answers for the year as a PDF: the answers as recorded, or the changes from
 * the year before. `time_zone` (an IANA name) sets the zone its times print in; UTC otherwise.
 */
export const charityBoardGetBoardCoiResponseDocument = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCoiResponseDocumentData, ThrowOnError>): RequestResult<CharityBoardGetBoardCoiResponseDocumentResponses, CharityBoardGetBoardCoiResponseDocumentErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCoiResponseDocumentResponses, CharityBoardGetBoardCoiResponseDocumentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-cycles/{cycle_id}/responses/{record_id}/document', ...options });

/**
 * List Board Coi Questionnaires
 *
 * Givmo's starting conflict-of-interest questionnaires this organization is offered: each
 * with its provenance, its IRS sources and the review-with-counsel line. A template, never a
 * statement that a questionnaire is required or sufficient.
 */
export const charityBoardListBoardCoiQuestionnaires = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardCoiQuestionnairesData, ThrowOnError>): RequestResult<CharityBoardListBoardCoiQuestionnairesResponses, CharityBoardListBoardCoiQuestionnairesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardCoiQuestionnairesResponses, CharityBoardListBoardCoiQuestionnairesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-questionnaires', ...options });

/**
 * Get Board Coi Questionnaire
 *
 * One starting questionnaire with every question: its words, whom it is asked of (the
 * independence question is asked of directors only), the IRS text it is drawn from, and its
 * "What counts" lines.
 */
export const charityBoardGetBoardCoiQuestionnaire = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCoiQuestionnaireData, ThrowOnError>): RequestResult<CharityBoardGetBoardCoiQuestionnaireResponses, CharityBoardGetBoardCoiQuestionnaireErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCoiQuestionnaireResponses, CharityBoardGetBoardCoiQuestionnaireErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/coi-questionnaires/{template_id}', ...options });

/**
 * List Board Committee Sources
 *
 * What a committee's establishment, its dissolution or a member's appointment may be linked
 * to: motions recorded as carried, executed written consents and records in the minute book,
 * each one you may read, the most recent first.
 */
export const charityBoardListBoardCommitteeSources = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardCommitteeSourcesData, ThrowOnError>): RequestResult<CharityBoardListBoardCommitteeSourcesResponses, CharityBoardListBoardCommitteeSourcesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardCommitteeSourcesResponses, CharityBoardListBoardCommitteeSourcesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/committee-sources', ...options });

/**
 * List Board Committees
 *
 * Your board's committees: the ones that stand first, by name, then those dissolved, the
 * most recent first. Each carries its chair and, where your organization's type is asked,
 * your organization's answer about its authority to act for the board, as recorded.
 */
export const charityBoardListBoardCommittees = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardCommitteesData, ThrowOnError>): RequestResult<CharityBoardListBoardCommitteesResponses, CharityBoardListBoardCommitteesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardCommitteesResponses, CharityBoardListBoardCommitteesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/committees', ...options });

/**
 * Create Board Committee
 *
 * Add a committee: its name, standing or ad hoc, when it was established and where that is
 * recorded. With `charter_form_id`, the committee keeps the form's id and holds the charter
 * label its name gives; its charter is then drafted from the form like any governing document.
 * No record is written here. A name an active committee already has is a 409
 * `board_committee_name_taken`.
 */
export const charityBoardCreateBoardCommittee = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardCommitteeData, ThrowOnError>): RequestResult<CharityBoardCreateBoardCommitteeResponses, CharityBoardCreateBoardCommitteeErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardCommitteeResponses, CharityBoardCreateBoardCommitteeErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/committees',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Committee
 *
 * One committee: its record, its members, its rules and where its acts are recorded, as far
 * as you may read them. Its charter is the committee charter recorded under its
 * `charter_label` (the governing documents read, by that label).
 */
export const charityBoardGetBoardCommittee = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCommitteeData, ThrowOnError>): RequestResult<CharityBoardGetBoardCommitteeResponses, CharityBoardGetBoardCommitteeErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCommitteeResponses, CharityBoardGetBoardCommitteeErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/committees/{committee_id}', ...options });

/**
 * Update Board Committee
 *
 * Change a committee's name, kind, establishment date or where its establishment is
 * recorded. Send only what changes; `null` clears the date, and a `null` `recorded_in` makes
 * it your own entry. A renamed committee keeps its charter's label. A dissolved committee isn't
 * changed (409 `board_committee_dissolved`).
 */
export const charityBoardUpdateBoardCommittee = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardCommitteeData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardCommitteeResponses, CharityBoardUpdateBoardCommitteeErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardCommitteeResponses, CharityBoardUpdateBoardCommitteeErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/committees/{committee_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link Board Committee Charter
 *
 * The committee charter a committee holds, by the label its versions are recorded under. No
 * record changes. A label another committee holds is a 409
 * `board_committee_charter_label_taken`.
 */
export const charityBoardLinkBoardCommitteeCharter = <ThrowOnError extends boolean = false>(options: Options<CharityBoardLinkBoardCommitteeCharterData, ThrowOnError>): RequestResult<CharityBoardLinkBoardCommitteeCharterResponses, CharityBoardLinkBoardCommitteeCharterErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardLinkBoardCommitteeCharterResponses, CharityBoardLinkBoardCommitteeCharterErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/committees/{committee_id}/charter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Board Committee Confirmation
 *
 * Whether the committee's decisions are suggested for the board's next meeting, and where the
 * organization wrote that practice down. Recorded in the committee's history, and reversible;
 * turning it off clears where it is written. Nothing waits on it: a committee's decisions stand as
 * recorded either way. A dissolved committee is a 409 `board_committee_dissolved`.
 */
export const charityBoardSetBoardCommitteeConfirmation = <ThrowOnError extends boolean = false>(options: Options<CharityBoardSetBoardCommitteeConfirmationData, ThrowOnError>): RequestResult<CharityBoardSetBoardCommitteeConfirmationResponses, CharityBoardSetBoardCommitteeConfirmationErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardSetBoardCommitteeConfirmationResponses, CharityBoardSetBoardCommitteeConfirmationErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/committees/{committee_id}/confirmation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dissolve Board Committee
 *
 * Dissolve a committee: the date, where it is recorded, and your note. Every membership ends
 * with it, and everything recorded about it stays. A dissolved committee answers as it is.
 */
export const charityBoardDissolveBoardCommittee = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDissolveBoardCommitteeData, ThrowOnError>): RequestResult<CharityBoardDissolveBoardCommitteeResponses, CharityBoardDissolveBoardCommitteeErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardDissolveBoardCommitteeResponses, CharityBoardDissolveBoardCommitteeErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/committees/{committee_id}/dissolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Correct Board Committee Dissolution
 *
 * Correct a dissolution made by mistake, saying why: the committee stands again, with the
 * memberships its dissolution ended, for everyone still serving on the board.
 */
export const charityBoardCorrectBoardCommitteeDissolution = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCorrectBoardCommitteeDissolutionData, ThrowOnError>): RequestResult<CharityBoardCorrectBoardCommitteeDissolutionResponses, CharityBoardCorrectBoardCommitteeDissolutionErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCorrectBoardCommitteeDissolutionResponses, CharityBoardCorrectBoardCommitteeDissolutionErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/committees/{committee_id}/dissolution/correction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Board Committee Member
 *
 * Add someone on your board's roster to a committee, director or not. `votes` is your
 * organization's record of whether they vote on the committee: yes unless you say otherwise.
 * Someone no longer serving is a 409 `board_committee_member_not_serving`; a second chair, a
 * 409 `board_committee_chair_taken`.
 */
export const charityBoardAddBoardCommitteeMember = <ThrowOnError extends boolean = false>(options: Options<CharityBoardAddBoardCommitteeMemberData, ThrowOnError>): RequestResult<CharityBoardAddBoardCommitteeMemberResponses, CharityBoardAddBoardCommitteeMemberErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardAddBoardCommitteeMemberResponses, CharityBoardAddBoardCommitteeMemberErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/committees/{committee_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Board Committee Member
 *
 * Change a committee member's role, whether they vote on the committee, their dates, or
 * where their appointment is recorded. Send only what changes. A membership that has ended
 * isn't changed (409 `board_committee_member_ended`).
 */
export const charityBoardUpdateBoardCommitteeMember = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardCommitteeMemberData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardCommitteeMemberResponses, CharityBoardUpdateBoardCommitteeMemberErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardCommitteeMemberResponses, CharityBoardUpdateBoardCommitteeMemberErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/committees/{committee_id}/members/{membership_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * End Board Committee Member
 *
 * End someone's membership of a committee, with their last day if you have one, and your
 * note. An ended membership answers as it is.
 */
export const charityBoardEndBoardCommitteeMember = <ThrowOnError extends boolean = false>(options: Options<CharityBoardEndBoardCommitteeMemberData, ThrowOnError>): RequestResult<CharityBoardEndBoardCommitteeMemberResponses, CharityBoardEndBoardCommitteeMemberErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardEndBoardCommitteeMemberResponses, CharityBoardEndBoardCommitteeMemberErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/committees/{committee_id}/members/{membership_id}/end',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Committee Rule
 *
 * Record one of a committee's rules, replacing the one in force, which stays in its history:
 * its notice period, its quorum, how its minutes are approved, or your organization's answer
 * about its authority to act for the board. `citation`, the section of your governing documents
 * the rule comes from, is required. Givmo doesn't read your governing documents.
 */
export const charityBoardRecordBoardCommitteeRule = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardCommitteeRuleData, ThrowOnError>): RequestResult<CharityBoardRecordBoardCommitteeRuleResponses, CharityBoardRecordBoardCommitteeRuleErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardCommitteeRuleResponses, CharityBoardRecordBoardCommitteeRuleErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/committees/{committee_id}/rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Compensation Decisions
 *
 * Every compensation decision you may read, grouped by person, newest first: each in the
 * regulation's order — the decision and its date, who took part, what the board relied on, and
 * when it was written down beside the date the regulation's rule gives. Facts the record holds;
 * Board answers no Form 990 question.
 */
export const charityBoardListBoardCompensationDecisions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardCompensationDecisionsData, ThrowOnError>): RequestResult<CharityBoardListBoardCompensationDecisionsResponses, CharityBoardListBoardCompensationDecisionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardCompensationDecisionsResponses, CharityBoardListBoardCompensationDecisionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/compensation-decisions', ...options });

/**
 * Record Board Compensation Index Entry
 *
 * Add a decision from your records: label minutes, a resolution or a written consent already
 * in the minute book (approved or imported) as recording the board's decision on one person's
 * pay, with where in that record it appears. The record itself never changes.
 */
export const charityBoardRecordBoardCompensationIndexEntry = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardCompensationIndexEntryData, ThrowOnError>): RequestResult<CharityBoardRecordBoardCompensationIndexEntryResponses, CharityBoardRecordBoardCompensationIndexEntryErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardCompensationIndexEntryResponses, CharityBoardRecordBoardCompensationIndexEntryErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/compensation-decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Board Compensation Index Entry
 *
 * Remove a decision added from your records. A decision recorded on a motion or a written
 * consent is removed there.
 */
export const charityBoardRemoveBoardCompensationIndexEntry = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemoveBoardCompensationIndexEntryData, ThrowOnError>): RequestResult<CharityBoardRemoveBoardCompensationIndexEntryResponses, CharityBoardRemoveBoardCompensationIndexEntryErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardRemoveBoardCompensationIndexEntryResponses, CharityBoardRemoveBoardCompensationIndexEntryErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/compensation-decisions/{decision_id}', ...options });

/**
 * Get Board Compensation Decision
 *
 * One compensation decision, in the regulation's order, with its history: who recorded and
 * changed it, and when.
 */
export const charityBoardGetBoardCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCompensationDecisionData, ThrowOnError>): RequestResult<CharityBoardGetBoardCompensationDecisionResponses, CharityBoardGetBoardCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCompensationDecisionResponses, CharityBoardGetBoardCompensationDecisionErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/compensation-decisions/{decision_id}', ...options });

/**
 * Update Board Compensation Decision
 *
 * Change an index entry's details, or any decision's two labels — your Form 990 answer for
 * the person (line 15a or 15b, a charity's only) and the link to the person's seat — which print
 * nowhere and change at any time. A field you send as null is cleared; one you leave out is
 * kept.
 */
export const charityBoardUpdateBoardCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardCompensationDecisionData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardCompensationDecisionResponses, CharityBoardUpdateBoardCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardCompensationDecisionResponses, CharityBoardUpdateBoardCompensationDecisionErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/compensation-decisions/{decision_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Compensation Decision Document Download
 *
 * A short-lived link to one document a compensation decision names, one of its meeting's
 * papers or a document uploaded onto a written consent: the exact version of the file whose
 * fingerprint the decision records, minted for this request and never stored. On a closed
 * session's motion, only for a reader that session was sent to.
 */
export const charityBoardGetBoardCompensationDecisionDocumentDownload = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCompensationDecisionDocumentDownloadData, ThrowOnError>): RequestResult<CharityBoardGetBoardCompensationDecisionDocumentDownloadResponses, CharityBoardGetBoardCompensationDecisionDocumentDownloadErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCompensationDecisionDocumentDownloadResponses, CharityBoardGetBoardCompensationDecisionDocumentDownloadErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/compensation-decisions/{decision_id}/documents/{document_id}/download', ...options });

/**
 * List Board Conflict Register
 *
 * The charity's conflict register — its recorded disclosures, per seat.
 *
 * `status` is DERIVED from the version pointers, not stored: `superseded` means a later
 * disclosure by the same seat replaced this one, and `active` means none has. Filter on
 * it to see what stands today, or omit it to read the whole history.
 *
 * A disclosure filed into an executive session this reader was not part of is ABSENT,
 * exactly as the session itself is — that binds charity admins as well as directors. No
 * disclosure is filed that way today: every one goes in at standard visibility, so the
 * scoping is here for the rule rather than for a case you will meet.
 */
export const charityBoardListBoardConflictRegister = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardConflictRegisterData, ThrowOnError>): RequestResult<CharityBoardListBoardConflictRegisterResponses, CharityBoardListBoardConflictRegisterErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardConflictRegisterResponses, CharityBoardListBoardConflictRegisterErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/conflict-disclosures', ...options });

/**
 * Record Board Conflict Disclosure
 *
 * Record a conflict-of-interest disclosure a director made outside the portal.
 *
 * Plan §1.7's manual path, first-class and permanent: a volunteer board hands the
 * secretary a signed form, or says it in the room, and the module has to be able to write
 * that down. `provenance_note` is required — it says where the disclosure came from, so
 * the entry can never be read as the director having acted inside their own session.
 *
 * The record names the DIRECTOR'S OWN SEAT as its approver, not the officer's account:
 * the director disclosed, and the officer wrote it down. A director recording their own
 * disclosure does it through their board session instead, where it is a signature-class
 * act on the step-up rail.
 *
 * `supersedes_record_id` records that the director's position has CHANGED — the earlier
 * disclosure stays an accurate record of what was true at its time. `corrects_record_id`
 * records that the earlier one was WRONG. They are different statements about a person
 * and a record carries one or the other, never both.
 */
export const charityBoardRecordBoardConflictDisclosure = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardConflictDisclosureData, ThrowOnError>): RequestResult<CharityBoardRecordBoardConflictDisclosureResponses, CharityBoardRecordBoardConflictDisclosureErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardConflictDisclosureResponses, CharityBoardRecordBoardConflictDisclosureErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/conflict-disclosures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Consent Templates
 *
 * The consent and resolution forms the charity may choose from, without the full
 * text of each.
 *
 * Structurally neutral scaffolds with bracketed fields the organization fills in, each
 * naming the authority its structure is modeled on. The library is the same for every
 * charity: this route reads nothing about the organization, so it can never present a
 * form as one the organization ought to adopt.
 */
export const charityBoardListBoardConsentTemplates = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardConsentTemplatesData, ThrowOnError>): RequestResult<CharityBoardListBoardConsentTemplatesResponses, CharityBoardListBoardConsentTemplatesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardConsentTemplatesResponses, CharityBoardListBoardConsentTemplatesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/consent-templates', ...options });

/**
 * Get Board Consent Template
 *
 * One form, with its full text, the fields the organization fills in, and the
 * provenance of its structure.
 *
 * Served with the line the organization should read before adopting anything from it:
 * template — review with your counsel before adopting. A form written for a committee is
 * fetched for one of the organization's committees (``committee_id``), its text naming it.
 */
export const charityBoardGetBoardConsentTemplate = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardConsentTemplateData, ThrowOnError>): RequestResult<CharityBoardGetBoardConsentTemplateResponses, CharityBoardGetBoardConsentTemplateErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardConsentTemplateResponses, CharityBoardGetBoardConsentTemplateErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/consent-templates/{template_id}', ...options });

/**
 * List Board Contemporaneity
 *
 * Each of the charity's held meetings and executed written consents, with its date.
 *
 * The Form 990 instructions for Part VI, line 8 describe documentation as contemporaneous
 * when it is prepared by the later of the next meeting of the governing body or 60 days
 * after the meeting or written action. This view does that arithmetic and shows the dates
 * it applied it to.
 *
 * It reports what is recorded and what the dates are, and draws no conclusion from them
 * about the charity's governance — the answer on the return is the charity's own to give.
 */
export const charityBoardListBoardContemporaneity = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardContemporaneityData, ThrowOnError>): RequestResult<CharityBoardListBoardContemporaneityResponses, CharityBoardListBoardContemporaneityErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardContemporaneityResponses, CharityBoardListBoardContemporaneityErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/contemporaneity', ...options });

/**
 * Get Board Director Access Policy
 *
 * What this board asks of a director before it opens, and who decided it.
 *
 * `tiered` is what every board runs: what a director must prove follows the weight of
 * what they are doing, so reading and replying ride the director's own Givmo sign-in,
 * and signature-class acts need a second factor confirmed within the hour.
 *
 * `step_up_always` ("confirm before anything opens") was retired on 2026-10-05. A board
 * that adopted it before gets that adoption back as it was recorded: it asks nothing more
 * of a director than `tiered` does, and no board can adopt a policy any more.
 *
 * Executive-session material needs a second factor on every board. That is a floor
 * beneath the setting rather than part of it.
 *
 * A board that has adopted nothing answers with the default and a null adopter,
 * never a 404.
 */
export const charityBoardGetBoardDirectorAccessPolicy = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardDirectorAccessPolicyData, ThrowOnError>): RequestResult<CharityBoardGetBoardDirectorAccessPolicyResponses, CharityBoardGetBoardDirectorAccessPolicyErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardDirectorAccessPolicyResponses, CharityBoardGetBoardDirectorAccessPolicyErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/director-access-policy', ...options });

/**
 * List Board Director Classes
 *
 * The board's own names for its classes of directors, active first in the board's order,
 * then retired. A board with no classes has none: nothing is added for it. A class is a label
 * on a term; it changes no vote, quorum or written consent. Reading this list never changes it.
 */
export const charityBoardListBoardDirectorClasses = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardDirectorClassesData, ThrowOnError>): RequestResult<CharityBoardListBoardDirectorClassesResponses, CharityBoardListBoardDirectorClassesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardDirectorClassesResponses, CharityBoardListBoardDirectorClassesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/director-classes', ...options });

/**
 * Create Board Director Class
 *
 * Add one of the board's classes, last in the board's order. No two active classes share a
 * name, whatever the case or spacing: that is a 409 `board_director_class_name_taken`.
 */
export const charityBoardCreateBoardDirectorClass = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardDirectorClassData, ThrowOnError>): RequestResult<CharityBoardCreateBoardDirectorClassResponses, CharityBoardCreateBoardDirectorClassErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardDirectorClassResponses, CharityBoardCreateBoardDirectorClassErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/director-classes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Board Director Class
 *
 * Rename a class, move it in the board's order, or both. `position` is its place among the
 * active classes, counting from 1; past the last means last. A retired class is neither renamed
 * nor moved (409 `board_director_class_retired`).
 */
export const charityBoardUpdateBoardDirectorClass = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardDirectorClassData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardDirectorClassResponses, CharityBoardUpdateBoardDirectorClassErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardDirectorClassResponses, CharityBoardUpdateBoardDirectorClassErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/director-classes/{class_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retire Board Director Class
 *
 * Retire a class the board no longer uses. It is never deleted and stays on every term that
 * names it. Retiring a class already retired answers it as it is.
 */
export const charityBoardRetireBoardDirectorClass = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRetireBoardDirectorClassData, ThrowOnError>): RequestResult<CharityBoardRetireBoardDirectorClassResponses, CharityBoardRetireBoardDirectorClassErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRetireBoardDirectorClassResponses, CharityBoardRetireBoardDirectorClassErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/director-classes/{class_id}/retirement', ...options });

/**
 * List Board Engagement
 *
 * Who has opened what — the chair's engagement view.
 *
 * Measurement, not shaming (plan §1.7). Per-(seat, artifact) open counts and instants,
 * with deliberately nothing about how long anything was open and no ranking, so the
 * surface built on this answers "has this director opened the packet?" without becoming
 * a leaderboard. The charity configures whether it is shown at all.
 */
export const charityBoardListBoardEngagement = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardEngagementData, ThrowOnError>): RequestResult<CharityBoardListBoardEngagementResponses, CharityBoardListBoardEngagementErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardEngagementResponses, CharityBoardListBoardEngagementErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/engagement', ...options });

/**
 * Export Board Minute Book
 *
 * The machine-readable minute-book export, manifest-bound.
 *
 * Continuous — callable any time, no request queue and no waiting period. Every record
 * carries the content hash fixed when it became the record, and `manifest_hash` binds
 * the set, so the charity can re-derive both from the export alone, with nothing from
 * Givmo.
 */
export const charityBoardExportBoardMinuteBook = <ThrowOnError extends boolean = false>(options: Options<CharityBoardExportBoardMinuteBookData, ThrowOnError>): RequestResult<CharityBoardExportBoardMinuteBookResponses, CharityBoardExportBoardMinuteBookErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardExportBoardMinuteBookResponses, CharityBoardExportBoardMinuteBookErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/export', ...options });

/**
 * Export Board Minute Book Document
 *
 * The same export as a human-readable minute book — readable, printable, and
 * hand-able to counsel with no tooling at all.
 */
export const charityBoardExportBoardMinuteBookDocument = <ThrowOnError extends boolean = false>(options: Options<CharityBoardExportBoardMinuteBookDocumentData, ThrowOnError>): RequestResult<CharityBoardExportBoardMinuteBookDocumentResponses, CharityBoardExportBoardMinuteBookDocumentErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardExportBoardMinuteBookDocumentResponses, CharityBoardExportBoardMinuteBookDocumentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/export/document', ...options });

/**
 * Get Board Filing Governance Feed
 *
 * The filing module's current governance projection.
 *
 * While Org Machinery standing or the held D-CCM-2 legal rows are absent, the
 * operation fails typed and returns no dependent facts.
 */
export const charityBoardGetBoardFilingGovernanceFeed = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardFilingGovernanceFeedData, ThrowOnError>): RequestResult<CharityBoardGetBoardFilingGovernanceFeedResponses, CharityBoardGetBoardFilingGovernanceFeedErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardFilingGovernanceFeedResponses, CharityBoardGetBoardFilingGovernanceFeedErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/filing-governance', ...options });

/**
 * Open Board Filing Receipt
 *
 * Mint from an authorized current feed or exact published packet snapshot.
 */
export const charityBoardOpenBoardFilingReceipt = <ThrowOnError extends boolean = false>(options: Options<CharityBoardOpenBoardFilingReceiptData, ThrowOnError>): RequestResult<CharityBoardOpenBoardFilingReceiptResponses, CharityBoardOpenBoardFilingReceiptErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardOpenBoardFilingReceiptResponses, CharityBoardOpenBoardFilingReceiptErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/filing-governance/obligations/{obligation_id}/receipts/{artifact_id}/download-url', ...options });

/**
 * Get Board Form 990
 *
 * One tax year of Form 990, Part VI: each question in the IRS's own words, with its
 * instructions quoted, and beside it what your board's records hold that bears on it, as far as
 * you may read them. Your organization answers each question on its return; this page doesn't.
 *
 * The tax years come from the fiscal year end your organization recorded in Givmo; with none
 * recorded, from the month and day in `year_end_month` and `year_end_day`. `tax_year_ends_on`
 * picks a year by its last day; without it, the latest year that has ended. Computed when read;
 * nothing is stored.
 */
export const charityBoardGetBoardForm990 = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardForm990Data, ThrowOnError>): RequestResult<CharityBoardGetBoardForm990Responses, CharityBoardGetBoardForm990Errors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardForm990Responses, CharityBoardGetBoardForm990Errors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/form-990', ...options });

/**
 * Get Board Schedule O Draft
 *
 * One tax year's Schedule O draft: sentences built only from what your board recorded, for
 * you to edit into your own words — line 8b's, where no committee is recorded for the year, and
 * line 11b's (the copy of the return provided to the board, who opened and read it, and the
 * review linked to it, the board's or a committee's). The text follows the IRS e-file character
 * set. The year is the Form 990 page's, with the same address. Computed when read; never stored,
 * and never your organization's Schedule O, which is whatever it files.
 */
export const charityBoardGetBoardScheduleODraft = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardScheduleODraftData, ThrowOnError>): RequestResult<CharityBoardGetBoardScheduleODraftResponses, CharityBoardGetBoardScheduleODraftErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardScheduleODraftResponses, CharityBoardGetBoardScheduleODraftErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/form-990/schedule-o-draft', ...options });

/**
 * List Board Getting Started Steps
 *
 * New members, and the steps on their getting-started lists that are the officers' own:
 * sending the year's conflict-of-interest questionnaire, choosing a board buddy.
 */
export const charityBoardListBoardGettingStartedSteps = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardGettingStartedStepsData, ThrowOnError>): RequestResult<CharityBoardListBoardGettingStartedStepsResponses, CharityBoardListBoardGettingStartedStepsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardGettingStartedStepsResponses, CharityBoardListBoardGettingStartedStepsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/getting-started', ...options });

/**
 * Get Board Getting Started List
 *
 * The board's getting-started list: the one the board adopted, or — before it adopted one —
 * Givmo's starting list, built only from the governing documents the board recorded, the first
 * disclosure and a board buddy. Nothing is in use until the board adopts a list.
 */
export const charityBoardGetBoardGettingStartedList = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardGettingStartedListData, ThrowOnError>): RequestResult<CharityBoardGetBoardGettingStartedListResponses, CharityBoardGetBoardGettingStartedListErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardGettingStartedListResponses, CharityBoardGetBoardGettingStartedListErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/getting-started-list', ...options });

/**
 * Save Board Getting Started List
 *
 * Use this list (no revision yet), or change the board's list from the revision you read:
 * add, remove or reorder items. Members added after this get the list; a list a member already
 * has doesn't change. A list that changed meanwhile is refused, so no change undoes another.
 */
export const charityBoardSaveBoardGettingStartedList = <ThrowOnError extends boolean = false>(options: Options<CharityBoardSaveBoardGettingStartedListData, ThrowOnError>): RequestResult<CharityBoardSaveBoardGettingStartedListResponses, CharityBoardSaveBoardGettingStartedListErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardSaveBoardGettingStartedListResponses, CharityBoardSaveBoardGettingStartedListErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/getting-started-list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Governance Parameters
 *
 * The charity's recorded parameters — in force first, then history when asked for.
 *
 * The history is opt-in because it is what a past meeting's figures were counted
 * against: a reader checking an old meeting's notice needs the row that was in force
 * then, not only the one in force now.
 */
export const charityBoardListBoardGovernanceParameters = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardGovernanceParametersData, ThrowOnError>): RequestResult<CharityBoardListBoardGovernanceParametersResponses, CharityBoardListBoardGovernanceParametersErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardGovernanceParametersResponses, CharityBoardListBoardGovernanceParametersErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/governance-parameters', ...options });

/**
 * Record Board Governance Parameter
 *
 * Record a governance parameter the charity has entered, with its bylaw attribution.
 *
 * The number is the charity's, and `bylaw_citation` — the section of its own governing
 * documents it comes from — is REQUIRED. The module computes arithmetic against what is
 * recorded here and echoes the citation in every sentence it renders; it reads no
 * governing document and derives none of these numbers.
 *
 * PUT rather than POST because the charity has exactly one parameter in force per key.
 * Recording again does not edit the old row: it writes a new one and supersedes the
 * prior, so a meeting scheduled under the earlier number keeps the figures it was given.
 */
export const charityBoardRecordBoardGovernanceParameter = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardGovernanceParameterData, ThrowOnError>): RequestResult<CharityBoardRecordBoardGovernanceParameterResponses, CharityBoardRecordBoardGovernanceParameterErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardRecordBoardGovernanceParameterResponses, CharityBoardRecordBoardGovernanceParameterErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/governance-parameters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Governing Document Templates
 *
 * The form library the charity may choose from, without the full text of each form.
 *
 * Structurally neutral scaffolds with bracketed fields the organization fills in, each
 * naming the authority its structure is modeled on. The library is the same for every
 * charity: this route reads nothing about the organization, so it can never present a form
 * as one the organization ought to adopt.
 */
export const charityBoardListBoardGoverningDocumentTemplates = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardGoverningDocumentTemplatesData, ThrowOnError>): RequestResult<CharityBoardListBoardGoverningDocumentTemplatesResponses, CharityBoardListBoardGoverningDocumentTemplatesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardGoverningDocumentTemplatesResponses, CharityBoardListBoardGoverningDocumentTemplatesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/governing-document-templates', ...options });

/**
 * Get Board Governing Document Template
 *
 * One form, with its full text, the fields the organization fills in, and the
 * provenance of its structure.
 *
 * Served with the line the organization should read before adopting anything from it:
 * template — review with your counsel before adopting.
 */
export const charityBoardGetBoardGoverningDocumentTemplate = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardGoverningDocumentTemplateData, ThrowOnError>): RequestResult<CharityBoardGetBoardGoverningDocumentTemplateResponses, CharityBoardGetBoardGoverningDocumentTemplateErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardGoverningDocumentTemplateResponses, CharityBoardGetBoardGoverningDocumentTemplateErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/governing-document-templates/{template_id}', ...options });

/**
 * List Board Governing Documents
 *
 * The charity's governing documents, each as the chain of versions it adopted.
 *
 * Versions are in the order the charity recorded — each names the version it replaced —
 * and the last one is flagged as in force. A version recorded as executive session that
 * the caller did not take part in is absent from the chain, like every other board read.
 *
 * The response describes what the charity recorded and nothing else: there is no entry for
 * an instrument the charity has no version of.
 */
export const charityBoardListBoardGoverningDocuments = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardGoverningDocumentsData, ThrowOnError>): RequestResult<CharityBoardListBoardGoverningDocumentsResponses, CharityBoardListBoardGoverningDocumentsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardGoverningDocumentsResponses, CharityBoardListBoardGoverningDocumentsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/governing-documents', ...options });

/**
 * Record Historical Board Member
 *
 * Record a FORMER seat — someone who served on this board before the module was in
 * use (CBG-RC8).
 *
 * A separate route from adding a seat, because the row it creates is already ended: the
 * status is not the caller's to choose and no removal reason is asked for, since no
 * removal happened here. `served_from` / `served_to` are the charity's own account of the
 * term and are read back beside the module's own timestamps, so a 2026 entry of a 2019
 * term reads as exactly that rather than as a director who left today.
 *
 * A former seat holds no credentials and never will — every access link and session
 * re-reads the seat's standing on use, and this seat is a former one from the moment it
 * exists. It is here for the record: attendance in historical minutes, and the term
 * lifecycle a later item builds.
 */
export const charityBoardRecordHistoricalBoardMember = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordHistoricalBoardMemberData, ThrowOnError>): RequestResult<CharityBoardRecordHistoricalBoardMemberResponses, CharityBoardRecordHistoricalBoardMemberErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordHistoricalBoardMemberResponses, CharityBoardRecordHistoricalBoardMemberErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/historical-members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Import Batches
 *
 * The charity's import sessions, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Each carries the count of what THIS reader may see in it, so a closed-session record
 * the caller was not part of is missing from the count exactly as it is missing from the
 * listing.
 */
export const charityBoardListBoardImportBatches = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardImportBatchesData, ThrowOnError>): RequestResult<CharityBoardListBoardImportBatchesResponses, CharityBoardListBoardImportBatchesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardImportBatchesResponses, CharityBoardListBoardImportBatchesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/import-batches', ...options });

/**
 * Open Board Import Batch
 *
 * Open a session for bringing in records from before this module was in use.
 *
 * `source_description` is the charity's own account of where the corpus came from — a box
 * of paper, a prior system, a predecessor's files. The module observed none of it, so the
 * charity's own words are the only honest source, and they travel with every record
 * entered under the session.
 */
export const charityBoardOpenBoardImportBatch = <ThrowOnError extends boolean = false>(options: Options<CharityBoardOpenBoardImportBatchData, ThrowOnError>): RequestResult<CharityBoardOpenBoardImportBatchResponses, CharityBoardOpenBoardImportBatchErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardOpenBoardImportBatchResponses, CharityBoardOpenBoardImportBatchErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/import-batches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Import Batch
 */
export const charityBoardGetBoardImportBatch = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardImportBatchData, ThrowOnError>): RequestResult<CharityBoardGetBoardImportBatchResponses, CharityBoardGetBoardImportBatchErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardImportBatchResponses, CharityBoardGetBoardImportBatchErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/import-batches/{batch_id}', ...options });

/**
 * Update Board Import Batch
 *
 * Edit an OPEN session's description. Refused once it is closed — at that point the
 * label and the source description are what every record entered under it says about its
 * own origin, and those records are themselves immutable.
 */
export const charityBoardUpdateBoardImportBatch = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardImportBatchData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardImportBatchResponses, CharityBoardUpdateBoardImportBatchErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardImportBatchResponses, CharityBoardUpdateBoardImportBatchErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/import-batches/{batch_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close Board Import Batch
 *
 * Close a session — the charity saying the backfill is finished.
 *
 * Nothing further can be entered under it and the session itself stops being editable.
 * The route is named for the thing it creates (the closure), not for a verb, because the
 * closure is the durable artifact: it names who drew the boundary and when.
 */
export const charityBoardCloseBoardImportBatch = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCloseBoardImportBatchData, ThrowOnError>): RequestResult<CharityBoardCloseBoardImportBatchResponses, CharityBoardCloseBoardImportBatchErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCloseBoardImportBatchResponses, CharityBoardCloseBoardImportBatchErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/import-batches/{batch_id}/closure',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issue Board Import File Upload Url
 *
 * A signed upload URL for the file of a record you're entering into an open import batch: PUT
 * the file there once, sending exactly `headers`, then send the record with `file.upload_id`. A
 * PDF or a picture, up to 50 MB. Nothing is recorded until the record is sent.
 */
export const charityBoardIssueBoardImportFileUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardIssueBoardImportFileUploadUrlData, ThrowOnError>): RequestResult<CharityBoardIssueBoardImportFileUploadUrlResponses, CharityBoardIssueBoardImportFileUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardIssueBoardImportFileUploadUrlResponses, CharityBoardIssueBoardImportFileUploadUrlErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/import-batches/{batch_id}/file-upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Board Import File Upload
 *
 * Delete a file uploaded for a record you didn't send (the form was cancelled). A record's
 * own file is never deleted here.
 */
export const charityBoardDeleteBoardImportFileUpload = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDeleteBoardImportFileUploadData, ThrowOnError>): RequestResult<CharityBoardDeleteBoardImportFileUploadResponses, CharityBoardDeleteBoardImportFileUploadErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardDeleteBoardImportFileUploadResponses, CharityBoardDeleteBoardImportFileUploadErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/import-batches/{batch_id}/file-uploads/{upload_id}', ...options });

/**
 * List Board Import Batch Records
 *
 * Everything entered under one session, in entry order — the review listing.
 *
 * This is what makes a backfill checkable: the charity reads back what it just brought
 * in, with each record's content hash beside it so a reviewer can tie a row to the page
 * of paper it came from. Records the caller may not read are ABSENT, and the total
 * reflects only what they may see.
 */
export const charityBoardListBoardImportBatchRecords = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardImportBatchRecordsData, ThrowOnError>): RequestResult<CharityBoardListBoardImportBatchRecordsResponses, CharityBoardListBoardImportBatchRecordsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardImportBatchRecordsResponses, CharityBoardListBoardImportBatchRecordsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/import-batches/{batch_id}/records', ...options });

/**
 * Issue Board Import Record File Upload Url
 *
 * A signed upload URL for the file of a record you're entering by hand: PUT the file there
 * once, sending exactly `headers`, then send the record with `file.upload_id`. A PDF or a
 * picture, up to 50 MB. Nothing is recorded until the record is sent.
 */
export const charityBoardIssueBoardImportRecordFileUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardIssueBoardImportRecordFileUploadUrlData, ThrowOnError>): RequestResult<CharityBoardIssueBoardImportRecordFileUploadUrlResponses, CharityBoardIssueBoardImportRecordFileUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardIssueBoardImportRecordFileUploadUrlResponses, CharityBoardIssueBoardImportRecordFileUploadUrlErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/import-file-upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Board Import Record File Upload
 *
 * Delete a file uploaded for a record you didn't send (you chose another file, or left the
 * page). A record's own file is never deleted here.
 */
export const charityBoardDeleteBoardImportRecordFileUpload = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDeleteBoardImportRecordFileUploadData, ThrowOnError>): RequestResult<CharityBoardDeleteBoardImportRecordFileUploadResponses, CharityBoardDeleteBoardImportRecordFileUploadErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardDeleteBoardImportRecordFileUploadResponses, CharityBoardDeleteBoardImportRecordFileUploadErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/import-file-uploads/{upload_id}', ...options });

/**
 * List Board Import Inbox
 *
 * The files uploaded for your AI: those waiting for it, those it proposed records from (each
 * waiting for you to confirm), and those in your minute book, with how many there are and how
 * many can wait at once. Nothing here is in the minute book until you confirm it.
 */
export const charityBoardListBoardImportInbox = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardImportInboxData, ThrowOnError>): RequestResult<CharityBoardListBoardImportInboxResponses, CharityBoardListBoardImportInboxErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardImportInboxResponses, CharityBoardListBoardImportInboxErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/import-inbox', ...options });

/**
 * Issue Board Import Inbox Upload Url
 *
 * A signed upload URL for one file you're uploading for your AI: PUT the file there once,
 * sending exactly `headers`, then ask Board to check it with the `upload_id` it names. A PDF or a
 * picture, up to 50 MB. Nothing is added until Board's check passes.
 */
export const charityBoardIssueBoardImportInboxUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardIssueBoardImportInboxUploadUrlData, ThrowOnError>): RequestResult<CharityBoardIssueBoardImportInboxUploadUrlResponses, CharityBoardIssueBoardImportInboxUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardIssueBoardImportInboxUploadUrlResponses, CharityBoardIssueBoardImportInboxUploadUrlErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/import-inbox/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Board Import Inbox File
 *
 * Remove a file waiting in your uploads: it is deleted, and your AI no longer sees it. A
 * file your AI proposed a record from waits for you on the confirmation page instead. A
 * person's act.
 */
export const charityBoardRemoveBoardImportInboxFile = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemoveBoardImportInboxFileData, ThrowOnError>): RequestResult<CharityBoardRemoveBoardImportInboxFileResponses, CharityBoardRemoveBoardImportInboxFileErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardRemoveBoardImportInboxFileResponses, CharityBoardRemoveBoardImportInboxFileErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/import-inbox/{upload_id}', ...options });

/**
 * Check Board Import Inbox File
 *
 * Ask Board to check a file you uploaded, with its name and type. If the check passes, the
 * file waits in your uploads for your AI; if not, the answer says why and the upload is
 * deleted. A file already uploaded, or already in your minute book, is added and says so.
 */
export const charityBoardCheckBoardImportInboxFile = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCheckBoardImportInboxFileData, ThrowOnError>): RequestResult<CharityBoardCheckBoardImportInboxFileResponses, CharityBoardCheckBoardImportInboxFileErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCheckBoardImportInboxFileResponses, CharityBoardCheckBoardImportInboxFileErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/import-inbox/{upload_id}/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Import Inbox File Url
 *
 * A short-lived link that downloads a file waiting in your uploads, as Board checked it.
 */
export const charityBoardGetBoardImportInboxFileUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardImportInboxFileUrlData, ThrowOnError>): RequestResult<CharityBoardGetBoardImportInboxFileUrlResponses, CharityBoardGetBoardImportInboxFileUrlErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardImportInboxFileUrlResponses, CharityBoardGetBoardImportInboxFileUrlErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/import-inbox/{upload_id}/file', ...options });

/**
 * Import Board Record
 *
 * Bring in a pre-module historical record (CBG-RC8), one document at a time.
 *
 * A separate route from draft creation on purpose: an imported record lands immutable
 * and never passes through submit/approve, so conflating the two entry points would
 * invite a caller to think an import can be "approved" later. It cannot — the database
 * ties imported provenance to the imported state and nothing else.
 *
 * **This is the only import door.** `source_note`, the organization's own note of where
 * the record came from, is optional. A file goes in with the record (`file`, from the
 * slot `…/import-file-upload-url` named) or never. An `import_batch_id` names a backfill
 * session, which is answered as not found while the sessions are switched off.
 *
 * **The call is idempotent.** A "Record it" pressed again, or a backfill retried after a
 * dropped connection, re-sends what it already sent; a record whose content the
 * organization already holds (entered with no session, or in the named one) is not
 * written twice. The already-recorded one comes back with `already_recorded: true` and a
 * **200** rather than a 201, so a caller can tell a fresh entry from a replayed one
 * without comparing ids.
 */
export const charityBoardImportBoardRecord = <ThrowOnError extends boolean = false>(options: Options<CharityBoardImportBoardRecordData, ThrowOnError>): RequestResult<CharityBoardImportBoardRecordResponses, CharityBoardImportBoardRecordErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardImportBoardRecordResponses, CharityBoardImportBoardRecordErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/imported-records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Legal Holds
 */
export const charityBoardListBoardLegalHolds = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardLegalHoldsData, ThrowOnError>): RequestResult<CharityBoardListBoardLegalHoldsResponses, CharityBoardListBoardLegalHoldsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardLegalHoldsResponses, CharityBoardListBoardLegalHoldsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/legal-holds', ...options });

/**
 * Place Board Legal Hold
 */
export const charityBoardPlaceBoardLegalHold = <ThrowOnError extends boolean = false>(options: Options<CharityBoardPlaceBoardLegalHoldData, ThrowOnError>): RequestResult<CharityBoardPlaceBoardLegalHoldResponses, CharityBoardPlaceBoardLegalHoldErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardPlaceBoardLegalHoldResponses, CharityBoardPlaceBoardLegalHoldErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/legal-holds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Release Board Legal Hold
 */
export const charityBoardReleaseBoardLegalHold = <ThrowOnError extends boolean = false>(options: Options<CharityBoardReleaseBoardLegalHoldData, ThrowOnError>): RequestResult<CharityBoardReleaseBoardLegalHoldResponses, CharityBoardReleaseBoardLegalHoldErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardReleaseBoardLegalHoldResponses, CharityBoardReleaseBoardLegalHoldErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/legal-holds/{hold_id}/release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Legal Hold Report
 *
 * What a hold covers — the enumeration the charity can hand to whoever asked for it.
 *
 * A hold preserves records; it does not widen who may read them, so the report is
 * confidentiality-scoped like every other read.
 */
export const charityBoardGetBoardLegalHoldReport = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardLegalHoldReportData, ThrowOnError>): RequestResult<CharityBoardGetBoardLegalHoldReportResponses, CharityBoardGetBoardLegalHoldReportErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardLegalHoldReportResponses, CharityBoardGetBoardLegalHoldReportErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/legal-holds/{hold_id}/report', ...options });

/**
 * List Board Meetings
 *
 * The charity's meetings, soonest first, in the canonical `{data, meta, links}`
 * envelope.
 */
export const charityBoardListBoardMeetings = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardMeetingsData, ThrowOnError>): RequestResult<CharityBoardListBoardMeetingsResponses, CharityBoardListBoardMeetingsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardMeetingsResponses, CharityBoardListBoardMeetingsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings', ...options });

/**
 * Create Board Meeting
 *
 * Schedule a meeting.
 *
 * The response's `notice` block is captured here, against the notice period the charity
 * recorded for THIS meeting type. It carries the period, the section it was attributed
 * to, the day count, any shortfall in days, and the counting method — and it never says
 * a meeting was noticed correctly or otherwise. A shortfall is surfaced and never
 * blocks: the board owns its own acts.
 *
 * With no period recorded for this meeting type the block is empty and its statement
 * says so. Nothing is counted, because there is nothing recorded to count against.
 */
export const charityBoardCreateBoardMeeting = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardMeetingData, ThrowOnError>): RequestResult<CharityBoardCreateBoardMeetingResponses, CharityBoardCreateBoardMeetingErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardMeetingResponses, CharityBoardCreateBoardMeetingErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Meeting
 */
export const charityBoardGetBoardMeeting = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardMeetingData, ThrowOnError>): RequestResult<CharityBoardGetBoardMeetingResponses, CharityBoardGetBoardMeetingErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardMeetingResponses, CharityBoardGetBoardMeetingErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}', ...options });

/**
 * Update Board Meeting
 *
 * Edit an upcoming meeting (skip-None partial update).
 *
 * Moving the date re-counts the notice against the period recorded at that moment and
 * bumps the schedule revision, so a director's calendar updates the entry it holds
 * rather than gaining a second one. Correcting the time zone alone re-counts against the
 * SAME recorded period — the zone is what the count is taken in, so a correction can
 * legitimately move the figure by a day without the notice itself having changed.
 *
 * Cancelling is not here: it has its own route and its own required reason.
 */
export const charityBoardUpdateBoardMeeting = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardMeetingData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardMeetingResponses, CharityBoardUpdateBoardMeetingErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardMeetingResponses, CharityBoardUpdateBoardMeetingErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Agenda Items
 *
 * One meeting's agenda, in order.
 */
export const charityBoardListBoardAgendaItems = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardAgendaItemsData, ThrowOnError>): RequestResult<CharityBoardListBoardAgendaItemsResponses, CharityBoardListBoardAgendaItemsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardAgendaItemsResponses, CharityBoardListBoardAgendaItemsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/agenda-items', ...options });

/**
 * Create Board Agenda Item
 *
 * Add an agenda item. Omitted `position` appends to the end.
 */
export const charityBoardCreateBoardAgendaItem = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardAgendaItemData, ThrowOnError>): RequestResult<CharityBoardCreateBoardAgendaItemResponses, CharityBoardCreateBoardAgendaItemErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardAgendaItemResponses, CharityBoardCreateBoardAgendaItemErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/agenda-items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Board Committee Suggestion Items
 *
 * Add the suggested committee decisions to this meeting's agenda: one ordinary item per
 * committee, listing each decision, which can be edited, moved or deleted like any other. Nothing
 * else is filled in. Pressing again adds only decisions not yet on an agenda. A committee's
 * meeting, or one whose minutes are approved, is a 409 `board_committee_suggestion_not_offered`;
 * a suggestion put away for this meeting, a 409 `board_committee_suggestion_dismissed`.
 */
export const charityBoardAddBoardCommitteeSuggestionItems = <ThrowOnError extends boolean = false>(options: Options<CharityBoardAddBoardCommitteeSuggestionItemsData, ThrowOnError>): RequestResult<CharityBoardAddBoardCommitteeSuggestionItemsResponses, CharityBoardAddBoardCommitteeSuggestionItemsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardAddBoardCommitteeSuggestionItemsResponses, CharityBoardAddBoardCommitteeSuggestionItemsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/agenda-items/from-committee-suggestion', ...options });

/**
 * Apply Board Agenda Template
 *
 * Write the sections of a neutral template the charity selected.
 *
 * `template_id` is required and has no default: the charity names the template it wants.
 * The sections land as ordinary agenda items with nothing populated — no presenter, no
 * time box, no consent-agenda placement — because each of those is a decision about this
 * charity's meeting. Which template was applied is recorded on the meeting and in its
 * event log.
 */
export const charityBoardApplyBoardAgendaTemplate = <ThrowOnError extends boolean = false>(options: Options<CharityBoardApplyBoardAgendaTemplateData, ThrowOnError>): RequestResult<CharityBoardApplyBoardAgendaTemplateResponses, CharityBoardApplyBoardAgendaTemplateErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardApplyBoardAgendaTemplateResponses, CharityBoardApplyBoardAgendaTemplateErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/agenda-items/from-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Board Term Suggestion Items
 *
 * Add the elections the annual meeting's terms suggest: "Election of directors" and
 * "Election of officers", each an ordinary item naming the people whose terms end — or, where the
 * annual template's own "Directors" or "Officers" section is on the agenda, those names added to
 * it. Nothing else is filled in. Added once: pressing again adds nothing. A meeting not typed
 * annual is a 409 `board_term_suggestion_not_offered`; a suggestion put away for this meeting, a
 * 409 `board_term_suggestion_dismissed`.
 */
export const charityBoardAddBoardTermSuggestionItems = <ThrowOnError extends boolean = false>(options: Options<CharityBoardAddBoardTermSuggestionItemsData, ThrowOnError>): RequestResult<CharityBoardAddBoardTermSuggestionItemsResponses, CharityBoardAddBoardTermSuggestionItemsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardAddBoardTermSuggestionItemsResponses, CharityBoardAddBoardTermSuggestionItemsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/agenda-items/from-term-suggestion', ...options });

/**
 * Delete Board Agenda Item
 *
 * Remove an agenda item, closing the gap it leaves in the ordering.
 *
 * A real delete: a planned agenda item is working content, not part of the charity's
 * record. What the board actually took up is recorded with the minutes, where nothing is
 * ever deleted.
 */
export const charityBoardDeleteBoardAgendaItem = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDeleteBoardAgendaItemData, ThrowOnError>): RequestResult<CharityBoardDeleteBoardAgendaItemResponses, CharityBoardDeleteBoardAgendaItemErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardDeleteBoardAgendaItemResponses, CharityBoardDeleteBoardAgendaItemErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/agenda-items/{agenda_item_id}', ...options });

/**
 * Update Board Agenda Item
 *
 * Edit an agenda item (skip-None partial update).
 *
 * `disposition` is the mark the carry-forward read selects on: an item the charity marks
 * as left open is what resurfaces on a later agenda. It is a mark the charity applies —
 * the module never infers that an item nobody dispositioned is unfinished business.
 *
 * Editing stays open after the meeting has started, because dispositioning an item is
 * inherently something the recording officer does afterwards.
 */
export const charityBoardUpdateBoardAgendaItem = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardAgendaItemData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardAgendaItemResponses, CharityBoardUpdateBoardAgendaItemErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardAgendaItemResponses, CharityBoardUpdateBoardAgendaItemErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/agenda-items/{agenda_item_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder Board Agenda
 *
 * Reorder the agenda by naming every item once, in the order wanted.
 *
 * The whole agenda rather than a delta: a partial list leaves the unnamed items at
 * positions that may now collide, and reconciling that on the server means guessing at
 * an intent the caller did not state.
 */
export const charityBoardReorderBoardAgenda = <ThrowOnError extends boolean = false>(options: Options<CharityBoardReorderBoardAgendaData, ThrowOnError>): RequestResult<CharityBoardReorderBoardAgendaResponses, CharityBoardReorderBoardAgendaErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardReorderBoardAgendaResponses, CharityBoardReorderBoardAgendaErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/agenda-order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Approvable Minutes
 *
 * The minutes a motion at this meeting may approve: minutes of earlier meetings the board
 * hasn't approved yet, sent to this reader, whose approval way admits a vote at a meeting now.
 *
 * Named by public facts only — the meeting's title and start, and a closed session's general
 * purpose. A list, never a door: recording the motion decides again.
 */
export const charityBoardListBoardApprovableMinutes = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardApprovableMinutesData, ThrowOnError>): RequestResult<CharityBoardListBoardApprovableMinutesResponses, CharityBoardListBoardApprovableMinutesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardApprovableMinutesResponses, CharityBoardListBoardApprovableMinutesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/approvable-minutes', ...options });

/**
 * List Board Meeting Attendance
 *
 * Who the charity recorded as present at one meeting.
 */
export const charityBoardListBoardMeetingAttendance = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardMeetingAttendanceData, ThrowOnError>): RequestResult<CharityBoardListBoardMeetingAttendanceResponses, CharityBoardListBoardMeetingAttendanceErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardMeetingAttendanceResponses, CharityBoardListBoardMeetingAttendanceErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/attendance', ...options });

/**
 * List Board Attendance Intents
 *
 * Who has answered for one meeting, and how.
 *
 * An intent, not attendance: who was actually in the room is recorded with the minutes.
 */
export const charityBoardListBoardAttendanceIntents = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardAttendanceIntentsData, ThrowOnError>): RequestResult<CharityBoardListBoardAttendanceIntentsResponses, CharityBoardListBoardAttendanceIntentsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardAttendanceIntentsResponses, CharityBoardListBoardAttendanceIntentsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/attendance-intents', ...options });

/**
 * Record Board Attendance Intent On Behalf
 *
 * Record a director's attendance intent on their behalf.
 *
 * The manual path, and it is first-class rather than a fallback: a director who
 * telephones, replies to a paper notice, or tells the secretary in the corridor still
 * has an answer on record. The row is stamped as recorded by a charity admin and names
 * the person who entered it, so the charity's own record says which of the two happened.
 */
export const charityBoardRecordBoardAttendanceIntentOnBehalf = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardAttendanceIntentOnBehalfData, ThrowOnError>): RequestResult<CharityBoardRecordBoardAttendanceIntentOnBehalfResponses, CharityBoardRecordBoardAttendanceIntentOnBehalfErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardRecordBoardAttendanceIntentOnBehalfResponses, CharityBoardRecordBoardAttendanceIntentOnBehalfErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/attendance-intents/{member_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Meeting Attendance
 *
 * Record who was actually in the room, one seat at a time.
 *
 * Distinct from the RSVP: that is what a director said they would do, this is what the
 * charity says happened, and it is what the quorum figures at each vote are counted from.
 *
 * `arrived_at` and `departed_at` are optional instants rather than states, so a seat that
 * came in late AND left early is expressible — and so a vote taken between those two
 * instants counts that seat as present while one taken outside them does not.
 *
 * PUT rather than POST because there is one answer per seat per meeting: recording again
 * corrects it rather than adding a second.
 */
export const charityBoardRecordBoardMeetingAttendance = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardMeetingAttendanceData, ThrowOnError>): RequestResult<CharityBoardRecordBoardMeetingAttendanceResponses, CharityBoardRecordBoardMeetingAttendanceErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardRecordBoardMeetingAttendanceResponses, CharityBoardRecordBoardMeetingAttendanceErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/attendance/{board_member_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Meeting Calendar
 *
 * The meeting as an iCalendar file, for any calendar application.
 *
 * Generated from the stored row each time it is asked for, so a rescheduled meeting's
 * file carries the new instant and a higher sequence number — which is what makes a
 * calendar application update the entry it already has instead of adding a second one.
 */
export const charityBoardGetBoardMeetingCalendar = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardMeetingCalendarData, ThrowOnError>): RequestResult<CharityBoardGetBoardMeetingCalendarResponses, CharityBoardGetBoardMeetingCalendarErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardMeetingCalendarResponses, CharityBoardGetBoardMeetingCalendarErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/calendar', ...options });

/**
 * Cancel Board Meeting
 *
 * Cancel a meeting, with a recorded reason.
 *
 * A POST carrying a required reason rather than a status flip on the edit route: the
 * roster was told about this meeting, so calling it off is its own act with its own
 * actor, instant, and explanation. Never a delete. Re-cancelling is a no-op, so a
 * retried request does not read as a failure.
 */
export const charityBoardCancelBoardMeeting = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCancelBoardMeetingData, ThrowOnError>): RequestResult<CharityBoardCancelBoardMeetingResponses, CharityBoardCancelBoardMeetingErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCancelBoardMeetingResponses, CharityBoardCancelBoardMeetingErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/cancellation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Committee Suggestions
 *
 * On a board meeting whose minutes are not approved, the decisions of each committee whose
 * practice is to bring them to the board's next meeting: motions recorded as carried at its own
 * meetings, in the open session, and its executed written consents (none approving minutes),
 * recorded while that practice was on, taken before the meeting's day and on no board meeting's
 * agenda yet. Worked out each time it is read; nothing is added to the agenda until someone adds
 * it. On a committee's meeting, a cancelled one or one whose minutes are approved, `offered` is
 * false and the list is empty.
 */
export const charityBoardGetBoardCommitteeSuggestions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCommitteeSuggestionsData, ThrowOnError>): RequestResult<CharityBoardGetBoardCommitteeSuggestionsResponses, CharityBoardGetBoardCommitteeSuggestionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCommitteeSuggestionsResponses, CharityBoardGetBoardCommitteeSuggestionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/committee-suggestions', ...options });

/**
 * Restore Board Committee Suggestion
 *
 * Bring the suggested committee decisions back after they were put away for this meeting.
 */
export const charityBoardRestoreBoardCommitteeSuggestion = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRestoreBoardCommitteeSuggestionData, ThrowOnError>): RequestResult<CharityBoardRestoreBoardCommitteeSuggestionResponses, CharityBoardRestoreBoardCommitteeSuggestionErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardRestoreBoardCommitteeSuggestionResponses, CharityBoardRestoreBoardCommitteeSuggestionErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/committee-suggestions/dismissal', ...options });

/**
 * Dismiss Board Committee Suggestion
 *
 * Put the suggested committee decisions away for this meeting ("Not for this meeting"),
 * recording who and when. They can be brought back, and the next board meeting suggests them
 * again.
 */
export const charityBoardDismissBoardCommitteeSuggestion = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDismissBoardCommitteeSuggestionData, ThrowOnError>): RequestResult<CharityBoardDismissBoardCommitteeSuggestionResponses, CharityBoardDismissBoardCommitteeSuggestionErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardDismissBoardCommitteeSuggestionResponses, CharityBoardDismissBoardCommitteeSuggestionErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/committee-suggestions/dismissal', ...options });

/**
 * List Board Meeting Compensation Decisions
 *
 * A meeting's compensation decisions, on the motions you may read: each with whose pay it
 * set, the documents the board relied on (by name and fingerprint), how the board obtained
 * them, the board's reason when it set pay outside the range in that information, who took
 * part, and when it was written down. With the meeting's uploaded papers a decision may name,
 * and whether its record is still open to change.
 */
export const charityBoardListBoardMeetingCompensationDecisions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardMeetingCompensationDecisionsData, ThrowOnError>): RequestResult<CharityBoardListBoardMeetingCompensationDecisionsResponses, CharityBoardListBoardMeetingCompensationDecisionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardMeetingCompensationDecisionsResponses, CharityBoardListBoardMeetingCompensationDecisionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/compensation-decisions', ...options });

/**
 * List Board Conflict Links
 *
 * Every decision recorded for this meeting — confirmed links and dismissed ones.
 *
 * Both, because this answers what you have decided about the meeting. The pre-vote view
 * on the in-meeting record carries confirmations only: showing a dismissal beside a
 * motion would put in front of the board exactly the thing you recorded as not being
 * there.
 *
 * A link naming a motion made inside an executive session you were not part of is
 * absent, like the motion itself.
 */
export const charityBoardListBoardConflictLinks = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardConflictLinksData, ThrowOnError>): RequestResult<CharityBoardListBoardConflictLinksResponses, CharityBoardListBoardConflictLinksErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardConflictLinksResponses, CharityBoardListBoardConflictLinksErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/conflict-links', ...options });

/**
 * Record Board Conflict Link
 *
 * Record your decision about one disclosure and one agenda item or motion.
 *
 * `confirmed` records that the disclosure names this item; `dismissed` records that it
 * does not. Both are kept — a dismissal means the same candidate is not put in front of
 * you again, and it says a human looked, which a missing row does not.
 *
 * A confirmed link on a motion, or on the agenda item a motion was made under, appears
 * beside that motion on the in-meeting record so the board can read it before the vote,
 * and enters the minutes when the draft is next refreshed. What appears there is the
 * recorded facts: who disclosed what, when, when you linked it, and whether a recusal
 * for that seat has been recorded on the motion.
 *
 * A disclosure a later one has replaced can still be linked: only the suggestions filter
 * on what stands today, because a meeting may be minuting something that happened while
 * the earlier disclosure was in force.
 *
 * Refused once the minutes of the meeting are approved — from that point the link is
 * inside the record's content hash, and a change is a correction of the minutes.
 */
export const charityBoardRecordBoardConflictLink = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardConflictLinkData, ThrowOnError>): RequestResult<CharityBoardRecordBoardConflictLinkResponses, CharityBoardRecordBoardConflictLinkErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardConflictLinkResponses, CharityBoardRecordBoardConflictLinkErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/conflict-links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Board Conflict Link
 *
 * Remove a link recorded in error, while the meeting's record is still open.
 *
 * There is no edit: a decision is recorded or it is not, and changing one is removing it
 * and recording the other. Refused once the minutes are approved, like every other write
 * against a closed meeting record.
 */
export const charityBoardDeleteBoardConflictLink = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDeleteBoardConflictLinkData, ThrowOnError>): RequestResult<CharityBoardDeleteBoardConflictLinkResponses, CharityBoardDeleteBoardConflictLinkErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardDeleteBoardConflictLinkResponses, CharityBoardDeleteBoardConflictLinkErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/conflict-links/{link_id}', ...options });

/**
 * List Board Conflict Suggestions
 *
 * Candidate links between recorded disclosures and this meeting's items.
 *
 * Each counterparty name recorded on a standing disclosure is looked for in the wording
 * of the meeting's agenda items and motions, matching whole words only. Nothing else is
 * read, and nothing is recorded here: a candidate becomes a fact when you confirm it.
 *
 * `method` says exactly that on every response, because the risky reading of an empty
 * list is that something was checked and found clear. A candidate that does not appear
 * is one this text match did not find.
 */
export const charityBoardListBoardConflictSuggestions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardConflictSuggestionsData, ThrowOnError>): RequestResult<CharityBoardListBoardConflictSuggestionsResponses, CharityBoardListBoardConflictSuggestionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardConflictSuggestionsResponses, CharityBoardListBoardConflictSuggestionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/conflict-suggestions', ...options });

/**
 * List Board Documents
 *
 * One meeting's attachments. Never carries a storage key or a read URL.
 */
export const charityBoardListBoardDocuments = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardDocumentsData, ThrowOnError>): RequestResult<CharityBoardListBoardDocumentsResponses, CharityBoardListBoardDocumentsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardDocumentsResponses, CharityBoardListBoardDocumentsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/documents', ...options });

/**
 * Confirm Board Document
 *
 * Confirm that an attachment finished uploading.
 *
 * Nothing is recorded unless the object is found where the reference says it is: a row
 * for an upload that never completed is an attachment the packet cannot render.
 * `reported_content_digest` is optional and self-reported — this API does not read the
 * object back to check it, and the field name says so.
 */
export const charityBoardConfirmBoardDocument = <ThrowOnError extends boolean = false>(options: Options<CharityBoardConfirmBoardDocumentData, ThrowOnError>): RequestResult<CharityBoardConfirmBoardDocumentResponses, CharityBoardConfirmBoardDocumentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardConfirmBoardDocumentResponses, CharityBoardConfirmBoardDocumentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issue Board Document Upload Url
 *
 * Issue a short-lived signed upload URL for one packet attachment.
 *
 * Two steps — issue, then confirm — so the bytes go straight to storage and never
 * through this API. The URL is bound to the content type declared here, and no row is
 * written until the confirm call finds the object actually there.
 */
export const charityBoardIssueBoardDocumentUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardIssueBoardDocumentUploadUrlData, ThrowOnError>): RequestResult<CharityBoardIssueBoardDocumentUploadUrlResponses, CharityBoardIssueBoardDocumentUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardIssueBoardDocumentUploadUrlResponses, CharityBoardIssueBoardDocumentUploadUrlErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/documents/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Document Download Url
 *
 * Mint a short-lived signed read URL for one attachment. Never persisted.
 */
export const charityBoardGetBoardDocumentDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardDocumentDownloadUrlData, ThrowOnError>): RequestResult<CharityBoardGetBoardDocumentDownloadUrlResponses, CharityBoardGetBoardDocumentDownloadUrlErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardDocumentDownloadUrlResponses, CharityBoardGetBoardDocumentDownloadUrlErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/documents/{document_id}/download-url', ...options });

/**
 * Get Board In Meeting Record
 *
 * Everything the charity recorded about one meeting, as this reader may see it.
 */
export const charityBoardGetBoardInMeetingRecord = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardInMeetingRecordData, ThrowOnError>): RequestResult<CharityBoardGetBoardInMeetingRecordResponses, CharityBoardGetBoardInMeetingRecordErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardInMeetingRecordResponses, CharityBoardGetBoardInMeetingRecordErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/in-meeting-record', ...options });

/**
 * Get Board Meeting Invitations
 *
 * How a meeting reached directors' calendars: the sender, the state, and each invited
 * director with their latest reply in their calendar.
 */
export const charityBoardGetBoardMeetingInvitations = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardMeetingInvitationsData, ThrowOnError>): RequestResult<CharityBoardGetBoardMeetingInvitationsResponses, CharityBoardGetBoardMeetingInvitationsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardMeetingInvitationsResponses, CharityBoardGetBoardMeetingInvitationsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/invitations', ...options });

/**
 * Send Board Meeting Invitations
 *
 * Send a meeting's invitations to the board's active directors from the chosen sender.
 * Scheduling a meeting sends nothing; this is the officer's act. Sending again from the same
 * sender retries what did not go out.
 */
export const charityBoardSendBoardMeetingInvitations = <ThrowOnError extends boolean = false>(options: Options<CharityBoardSendBoardMeetingInvitationsData, ThrowOnError>): RequestResult<CharityBoardSendBoardMeetingInvitationsResponses, CharityBoardSendBoardMeetingInvitationsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardSendBoardMeetingInvitationsResponses, CharityBoardSendBoardMeetingInvitationsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Directors Told
 *
 * Record that an officer told the directors about a meeting's earlier invitations, which
 * Board can't prove are gone: the warning clears and Board stops acting on those invitations.
 * Sends nothing (CBG-FIX32).
 */
export const charityBoardRecordBoardDirectorsTold = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardDirectorsToldData, ThrowOnError>): RequestResult<CharityBoardRecordBoardDirectorsToldResponses, CharityBoardRecordBoardDirectorsToldErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardDirectorsToldResponses, CharityBoardRecordBoardDirectorsToldErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/invitations/directors-told', ...options });

/**
 * Reinvite Board Meeting Invitee
 *
 * Invite one director again, including one removed from the invitation in a calendar.
 */
export const charityBoardReinviteBoardMeetingInvitee = <ThrowOnError extends boolean = false>(options: Options<CharityBoardReinviteBoardMeetingInviteeData, ThrowOnError>): RequestResult<CharityBoardReinviteBoardMeetingInviteeResponses, CharityBoardReinviteBoardMeetingInviteeErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardReinviteBoardMeetingInviteeResponses, CharityBoardReinviteBoardMeetingInviteeErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/invitations/invitees/{member_id}', ...options });

/**
 * Move Board Meeting Invitations
 *
 * Send a meeting's invitations from another sender instead (directors get one
 * cancellation and one new invitation), or stop keeping it in step with a calendar.
 */
export const charityBoardMoveBoardMeetingInvitations = <ThrowOnError extends boolean = false>(options: Options<CharityBoardMoveBoardMeetingInvitationsData, ThrowOnError>): RequestResult<CharityBoardMoveBoardMeetingInvitationsResponses, CharityBoardMoveBoardMeetingInvitationsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardMoveBoardMeetingInvitationsResponses, CharityBoardMoveBoardMeetingInvitationsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/invitations/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Schedule Restored Board Meeting
 *
 * Schedule again a meeting that was cancelled in the organizer's calendar and is back
 * there: a new meeting linked to the restored event, with the old meeting's agenda. Sends no
 * invitation.
 */
export const charityBoardScheduleRestoredBoardMeeting = <ThrowOnError extends boolean = false>(options: Options<CharityBoardScheduleRestoredBoardMeetingData, ThrowOnError>): RequestResult<CharityBoardScheduleRestoredBoardMeetingResponses, CharityBoardScheduleRestoredBoardMeetingErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardScheduleRestoredBoardMeetingResponses, CharityBoardScheduleRestoredBoardMeetingErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/invitations/rescheduling', ...options });

/**
 * List Board Meeting Events
 *
 * One meeting's append-only event log, oldest first.
 *
 * It exists for the notice figures: a meeting moved from twenty days out to three shows
 * its final count, and this log is where a reader sees that it was once different.
 */
export const charityBoardListBoardMeetingEvents = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardMeetingEventsData, ThrowOnError>): RequestResult<CharityBoardListBoardMeetingEventsResponses, CharityBoardListBoardMeetingEventsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardMeetingEventsResponses, CharityBoardListBoardMeetingEventsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/meeting-events', ...options });

/**
 * Get Board Minutes
 *
 * The minutes of one meeting — or, with `segment_id`, of one of its closed sessions.
 */
export const charityBoardGetBoardMinutes = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardMinutesData, ThrowOnError>): RequestResult<CharityBoardGetBoardMinutesResponses, CharityBoardGetBoardMinutesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardMinutesResponses, CharityBoardGetBoardMinutesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/minutes', ...options });

/**
 * Write Board Minutes Draft
 *
 * Open or refresh the minutes draft for a meeting, or for one of its closed sessions.
 *
 * What the charity recorded about the meeting — who was present, the sessions, the motions
 * with their votes and recusals and the quorum figures at each — is assembled by the module
 * and returned as `structured_record`. `body` is the recording officer's own sections and
 * is theirs alone; the two are separate fields so it stays answerable afterwards which
 * words were whose.
 *
 * Call it again while the minutes are a draft and the assembled part is re-taken, so a
 * motion recorded after the draft was opened is in it. Once the board has approved them it
 * is refused: a change to approved minutes is recorded as a correction.
 */
export const charityBoardWriteBoardMinutesDraft = <ThrowOnError extends boolean = false>(options: Options<CharityBoardWriteBoardMinutesDraftData, ThrowOnError>): RequestResult<CharityBoardWriteBoardMinutesDraftResponses, CharityBoardWriteBoardMinutesDraftErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardWriteBoardMinutesDraftResponses, CharityBoardWriteBoardMinutesDraftErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/minutes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve Board Minutes
 *
 * Approve minutes as the recording officer.
 *
 * The other door is a motion the board carries at its next meeting, which records which
 * meeting approved them. Both write the same approval event and name a human.
 *
 * `content_hash` is the address of the exact minutes being approved. If they changed since
 * they were read, the approval is refused rather than applied to different words.
 */
export const charityBoardApproveBoardMinutes = <ThrowOnError extends boolean = false>(options: Options<CharityBoardApproveBoardMinutesData, ThrowOnError>): RequestResult<CharityBoardApproveBoardMinutesResponses, CharityBoardApproveBoardMinutesErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardApproveBoardMinutesResponses, CharityBoardApproveBoardMinutesErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/minutes/approval',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ask Board Minutes Approval Signatures
 *
 * Ask the directors who were in a closed session to sign to approve its minutes.
 *
 * Only where the board's own rule approves a closed session's minutes by the signatures of the
 * directors who were there; any other way is the typed 409 `board_minutes_approval_way`. Asked:
 * every seat recorded as in the session that is a director now, recused from a decision in it or
 * not. Not a written consent: it is never every director's. `content_hash` is the bytes read; the
 * minutes stay a draft while the request is out, and the last asked signature on the current
 * bytes approves them. Nobody to ask, or a request already out, is a typed 409; nothing written.
 */
export const charityBoardAskBoardMinutesApprovalSignatures = <ThrowOnError extends boolean = false>(options: Options<CharityBoardAskBoardMinutesApprovalSignaturesData, ThrowOnError>): RequestResult<CharityBoardAskBoardMinutesApprovalSignaturesResponses, CharityBoardAskBoardMinutesApprovalSignaturesErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardAskBoardMinutesApprovalSignaturesResponses, CharityBoardAskBoardMinutesApprovalSignaturesErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/minutes/approval-signatures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Minutes Approval Signature On Behalf
 *
 * Record an asked director's signature to approve, given on paper or by email.
 *
 * The officer's entry, never the director's own act: it records that the officer wrote it down,
 * with a required note saying where the signature came from. The seat must be one the open
 * request asked (else the typed 409 `board_minutes_not_asked_to_sign`). It may be the last
 * signature, and then the minutes are approved.
 */
export const charityBoardRecordBoardMinutesApprovalSignatureOnBehalf = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfData, ThrowOnError>): RequestResult<CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfResponses, CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfResponses, CharityBoardRecordBoardMinutesApprovalSignatureOnBehalfErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/minutes/approval-signatures/on-behalf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw Board Minutes Approval Signatures
 *
 * Withdraw the open request for signatures on a closed session's minutes, with the reason.
 *
 * The signatures already given stay in the minutes' history and count for nothing; asking
 * again starts fresh. No request out is a typed 409 `board_minutes_no_signatures_asked`.
 */
export const charityBoardWithdrawBoardMinutesApprovalSignatures = <ThrowOnError extends boolean = false>(options: Options<CharityBoardWithdrawBoardMinutesApprovalSignaturesData, ThrowOnError>): RequestResult<CharityBoardWithdrawBoardMinutesApprovalSignaturesResponses, CharityBoardWithdrawBoardMinutesApprovalSignaturesErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardWithdrawBoardMinutesApprovalSignaturesResponses, CharityBoardWithdrawBoardMinutesApprovalSignaturesErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/minutes/approval-signatures/withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Board Minutes Reminder
 *
 * Send the board a reminder that a meeting's minutes are not yet recorded.
 *
 * An act the charity performs; nothing schedules it. The response carries the same dates
 * the in-app view shows, and `skip_reason` says why no mail went out when none did, rather
 * than leaving a count of zero to read as a failure.
 */
export const charityBoardSendBoardMinutesReminder = <ThrowOnError extends boolean = false>(options: Options<CharityBoardSendBoardMinutesReminderData, ThrowOnError>): RequestResult<CharityBoardSendBoardMinutesReminderResponses, CharityBoardSendBoardMinutesReminderErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardSendBoardMinutesReminderResponses, CharityBoardSendBoardMinutesReminderErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/minutes/reminders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign Board Minutes On Behalf
 *
 * Record a signature someone on the roster gave on paper.
 *
 * The manual path, and it stays valid forever: nothing about the board's ability to record
 * its own minutes depends on a director adopting the portal. The entry records that the
 * officer wrote it down, never that the person acted inside their own session, and it
 * carries a required note saying where the signature came from.
 *
 * `capacity_title_id` (optional) records the title they signed as: one of the titles that seat
 * holds now, kept with the signature in the words it has today, so a later rename never changes
 * it. A title the seat doesn't hold is a 409 `board_signature_capacity_not_held`.
 */
export const charityBoardSignBoardMinutesOnBehalf = <ThrowOnError extends boolean = false>(options: Options<CharityBoardSignBoardMinutesOnBehalfData, ThrowOnError>): RequestResult<CharityBoardSignBoardMinutesOnBehalfResponses, CharityBoardSignBoardMinutesOnBehalfErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardSignBoardMinutesOnBehalfResponses, CharityBoardSignBoardMinutesOnBehalfErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/minutes/signatures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Motions
 *
 * One meeting's motions, in order, as this reader may see them.
 *
 * A motion made inside a closed session this reader was not part of does not appear.
 */
export const charityBoardListBoardMotions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardMotionsData, ThrowOnError>): RequestResult<CharityBoardListBoardMotionsResponses, CharityBoardListBoardMotionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardMotionsResponses, CharityBoardListBoardMotionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions', ...options });

/**
 * Create Board Motion
 *
 * Record a motion as put — its exact wording, who moved it, and who seconded it.
 *
 * An amendment names the motion it amends, so the board's own drafting history stays
 * walkable. The wording stays editable until a vote is recorded and is frozen from then on.
 */
export const charityBoardCreateBoardMotion = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardMotionData, ThrowOnError>): RequestResult<CharityBoardCreateBoardMotionResponses, CharityBoardCreateBoardMotionErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardMotionResponses, CharityBoardCreateBoardMotionErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Board Motion
 *
 * Remove a motion recorded in error, while no vote on it has been recorded.
 */
export const charityBoardDeleteBoardMotion = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDeleteBoardMotionData, ThrowOnError>): RequestResult<CharityBoardDeleteBoardMotionResponses, CharityBoardDeleteBoardMotionErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardDeleteBoardMotionResponses, CharityBoardDeleteBoardMotionErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions/{motion_id}', ...options });

/**
 * Update Board Motion
 *
 * Edit a motion recorded in error, before a vote on it is recorded.
 */
export const charityBoardUpdateBoardMotion = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardMotionData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardMotionResponses, CharityBoardUpdateBoardMotionErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardMotionResponses, CharityBoardUpdateBoardMotionErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions/{motion_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Board Motion Compensation Decision
 *
 * Record the board's compensation decision for one person on a motion it carried, after the
 * motion's others: whose pay, their position, the meeting's papers the board relied on, how it
 * obtained them, and its reason when it set pay outside the range in that information. Board
 * reads each paper's stored bytes and records its fingerprint. Refused once the meeting's
 * minutes are approved.
 */
export const charityBoardAddBoardMotionCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<CharityBoardAddBoardMotionCompensationDecisionData, ThrowOnError>): RequestResult<CharityBoardAddBoardMotionCompensationDecisionResponses, CharityBoardAddBoardMotionCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardAddBoardMotionCompensationDecisionResponses, CharityBoardAddBoardMotionCompensationDecisionErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions/{motion_id}/compensation-decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Board Motion Compensation Decision
 *
 * Remove one decision recorded on a motion, while the meeting's record is open. Its history
 * keeps who recorded and removed it, and when.
 */
export const charityBoardRemoveBoardMotionCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemoveBoardMotionCompensationDecisionData, ThrowOnError>): RequestResult<CharityBoardRemoveBoardMotionCompensationDecisionResponses, CharityBoardRemoveBoardMotionCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardRemoveBoardMotionCompensationDecisionResponses, CharityBoardRemoveBoardMotionCompensationDecisionErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions/{motion_id}/compensation-decisions/{decision_id}', ...options });

/**
 * Replace Board Motion Compensation Decision
 *
 * Replace one decision's details whole, while the meeting's record is open. A paper it keeps
 * keeps the fingerprint it was recorded with. Minutes drafted before the change name the old
 * details until they are refreshed.
 */
export const charityBoardReplaceBoardMotionCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<CharityBoardReplaceBoardMotionCompensationDecisionData, ThrowOnError>): RequestResult<CharityBoardReplaceBoardMotionCompensationDecisionResponses, CharityBoardReplaceBoardMotionCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardReplaceBoardMotionCompensationDecisionResponses, CharityBoardReplaceBoardMotionCompensationDecisionErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions/{motion_id}/compensation-decisions/{decision_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Minutes Approval Vote
 *
 * Record the vote on a motion that approves prior minutes.
 *
 * Its own route because a carried vote here does something the ordinary one never does: it
 * turns a draft into the charity's record. The minutes then name the seat the charity
 * recorded as presiding as the person whose declaration concluded the board's approval,
 * the instant, and the exact bytes approved.
 *
 * A vote recorded as failed is recorded exactly that way and the minutes stay a draft — the
 * board declined to approve them, which is itself something the book should say.
 */
export const charityBoardRecordBoardMinutesApprovalVote = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardMinutesApprovalVoteData, ThrowOnError>): RequestResult<CharityBoardRecordBoardMinutesApprovalVoteResponses, CharityBoardRecordBoardMinutesApprovalVoteErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardMinutesApprovalVoteResponses, CharityBoardRecordBoardMinutesApprovalVoteErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions/{motion_id}/minutes-approval',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Motion Recusal
 *
 * Record a seat as having stood out of the debate and the vote on one motion.
 *
 * Two things follow, and the second is the one boards most often get wrong. The seat's
 * vote becomes uncastable — recording one is refused. And the seat STILL counts among the
 * seats recorded as present, because standing out of a vote is not leaving the room; under
 * Delaware General Corporation Law section 144(d)(1) an interested director is counted for
 * that purpose, and dropping them would tell a board it had lost the seats it needed to act
 * every time someone was conflicted.
 */
export const charityBoardRecordBoardMotionRecusal = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardMotionRecusalData, ThrowOnError>): RequestResult<CharityBoardRecordBoardMotionRecusalResponses, CharityBoardRecordBoardMotionRecusalErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardMotionRecusalResponses, CharityBoardRecordBoardMotionRecusalErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions/{motion_id}/recusals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Board Motion Recusal
 *
 * Remove a recusal recorded in error, before a vote on the motion is recorded.
 */
export const charityBoardRemoveBoardMotionRecusal = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemoveBoardMotionRecusalData, ThrowOnError>): RequestResult<CharityBoardRemoveBoardMotionRecusalResponses, CharityBoardRemoveBoardMotionRecusalErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardRemoveBoardMotionRecusalResponses, CharityBoardRemoveBoardMotionRecusalErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions/{motion_id}/recusals/{board_member_id}', ...options });

/**
 * Record Board Motion Vote
 *
 * Record the vote on a motion.
 *
 * Two ways to record it, and both are first class: name each seat's own cast, or give the
 * three counts. With the casts recorded the counts are taken from them, so the two can
 * never disagree.
 *
 * The response carries the quorum figures captured at the instant of the vote — how many
 * of the board's seats were recorded as present, against the quorum the charity itself
 * recorded, with the section of its own governing instrument that number came from. A
 * shortfall is stated in seats and never blocks: the board owns its own acts.
 *
 * `outcome` is what the charity records. The module states the tally beside the recorded
 * threshold; whether a motion carried is the chair's declaration.
 *
 * A motion that approves prior minutes is refused here and belongs on the minutes-approval
 * route, which requires the authority to record the charity's own minute book.
 */
export const charityBoardRecordBoardMotionVote = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardMotionVoteData, ThrowOnError>): RequestResult<CharityBoardRecordBoardMotionVoteResponses, CharityBoardRecordBoardMotionVoteErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardMotionVoteResponses, CharityBoardRecordBoardMotionVoteErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions/{motion_id}/vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw Board Motion
 *
 * Record a motion as withdrawn before it was voted on.
 *
 * Recorded rather than deleted: withdrawing is a real thing the board did. It also takes
 * the motion out of the carry-forward list, which reports only what is still open.
 */
export const charityBoardWithdrawBoardMotion = <ThrowOnError extends boolean = false>(options: Options<CharityBoardWithdrawBoardMotionData, ThrowOnError>): RequestResult<CharityBoardWithdrawBoardMotionResponses, CharityBoardWithdrawBoardMotionErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardWithdrawBoardMotionResponses, CharityBoardWithdrawBoardMotionErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/motions/{motion_id}/withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Packets
 *
 * A meeting's packet versions, newest first. Contents are not hydrated here.
 */
export const charityBoardListBoardPackets = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardPacketsData, ThrowOnError>): RequestResult<CharityBoardListBoardPacketsResponses, CharityBoardListBoardPacketsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardPacketsResponses, CharityBoardListBoardPacketsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/packets', ...options });

/**
 * Create Board Packet
 *
 * Open the next draft packet version for a meeting.
 *
 * The version number is assigned by the module. At most one draft is in flight at a
 * time: two drafts for one meeting are two people assembling different packets with no
 * way to say which is next.
 */
export const charityBoardCreateBoardPacket = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardPacketData, ThrowOnError>): RequestResult<CharityBoardCreateBoardPacketResponses, CharityBoardCreateBoardPacketErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardPacketResponses, CharityBoardCreateBoardPacketErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/packets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Meeting Presiding
 *
 * Who presided at the meeting, the people recorded as present (each as the minutes would
 * name them presiding), and whom the board's adopted duties suggest: the person present who held,
 * on the meeting's day, a title the duties give presiding. Nothing is recorded by reading it.
 */
export const charityBoardGetBoardMeetingPresiding = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardMeetingPresidingData, ThrowOnError>): RequestResult<CharityBoardGetBoardMeetingPresidingResponses, CharityBoardGetBoardMeetingPresidingErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardMeetingPresidingResponses, CharityBoardGetBoardMeetingPresidingErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/presiding', ...options });

/**
 * Record Board Meeting Presiding
 *
 * Record who presided at the meeting, or clear it with a null.
 *
 * A recorded fact, the officer's entry in "Who was there": one of the people recorded as present,
 * never derived from a title. At most one person presides per meeting, and only someone recorded
 * as present — both held by the database. Answers the meeting's attendance rows as they now
 * stand, the presiding person's carrying `presided: true`.
 */
export const charityBoardRecordBoardMeetingPresiding = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardMeetingPresidingData, ThrowOnError>): RequestResult<CharityBoardRecordBoardMeetingPresidingResponses, CharityBoardRecordBoardMeetingPresidingErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardRecordBoardMeetingPresidingResponses, CharityBoardRecordBoardMeetingPresidingErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/presiding',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Meeting Segments
 *
 * The parts of one meeting, in order, as this reader may see them.
 *
 * A closed session this reader was not part of does not appear, and no ordinal is carried
 * on the wire — an index on a list that may have had entries withheld would count them.
 */
export const charityBoardListBoardMeetingSegments = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardMeetingSegmentsData, ThrowOnError>): RequestResult<CharityBoardListBoardMeetingSegmentsResponses, CharityBoardListBoardMeetingSegmentsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardMeetingSegmentsResponses, CharityBoardListBoardMeetingSegmentsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/sessions', ...options });

/**
 * Create Board Meeting Segment
 *
 * Record a part of a meeting — an ordinary session, or an executive session.
 *
 * An executive session carries its own participant list, and everything recorded inside it
 * is readable only by those participants. That binds charity admins as well as directors:
 * an administrator who was not in the room does not see it, and it is ABSENT for them
 * rather than refused.
 */
export const charityBoardCreateBoardMeetingSegment = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardMeetingSegmentData, ThrowOnError>): RequestResult<CharityBoardCreateBoardMeetingSegmentResponses, CharityBoardCreateBoardMeetingSegmentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardMeetingSegmentResponses, CharityBoardCreateBoardMeetingSegmentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder Board Meeting Segments
 *
 * Reorder a meeting's sessions by naming every one once, in the order wanted.
 */
export const charityBoardReorderBoardMeetingSegments = <ThrowOnError extends boolean = false>(options: Options<CharityBoardReorderBoardMeetingSegmentsData, ThrowOnError>): RequestResult<CharityBoardReorderBoardMeetingSegmentsResponses, CharityBoardReorderBoardMeetingSegmentsErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardReorderBoardMeetingSegmentsResponses, CharityBoardReorderBoardMeetingSegmentsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/sessions/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Board Meeting Segment
 *
 * Remove a session recorded in error, while the minutes are still a draft.
 */
export const charityBoardDeleteBoardMeetingSegment = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDeleteBoardMeetingSegmentData, ThrowOnError>): RequestResult<CharityBoardDeleteBoardMeetingSegmentResponses, CharityBoardDeleteBoardMeetingSegmentErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardDeleteBoardMeetingSegmentResponses, CharityBoardDeleteBoardMeetingSegmentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/sessions/{segment_id}', ...options });

/**
 * Update Board Meeting Segment
 *
 * Edit a recorded session.
 *
 * Which KIND of session it is cannot be changed here or anywhere: that would change who may
 * read everything recorded inside it, and a field flip is how a closed session gets
 * published by accident.
 */
export const charityBoardUpdateBoardMeetingSegment = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardMeetingSegmentData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardMeetingSegmentResponses, CharityBoardUpdateBoardMeetingSegmentErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardMeetingSegmentResponses, CharityBoardUpdateBoardMeetingSegmentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/sessions/{segment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Segment Participant
 *
 * Record one person as present for a session — a seat on this board, or someone else.
 *
 * A non-director the board invited in is named outright, because the point of a closed
 * session's list is who was in the room. A seat's name is taken from the roster and stored
 * as it stood then, so a later rename does not change what this says about that evening.
 */
export const charityBoardRecordBoardSegmentParticipant = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardSegmentParticipantData, ThrowOnError>): RequestResult<CharityBoardRecordBoardSegmentParticipantResponses, CharityBoardRecordBoardSegmentParticipantErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardSegmentParticipantResponses, CharityBoardRecordBoardSegmentParticipantErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/sessions/{segment_id}/participants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Board Segment Participant
 *
 * Remove someone recorded in error, while the minutes are still a draft.
 */
export const charityBoardRemoveBoardSegmentParticipant = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemoveBoardSegmentParticipantData, ThrowOnError>): RequestResult<CharityBoardRemoveBoardSegmentParticipantResponses, CharityBoardRemoveBoardSegmentParticipantErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardRemoveBoardSegmentParticipantResponses, CharityBoardRemoveBoardSegmentParticipantErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/sessions/{segment_id}/participants/{participant_id}', ...options });

/**
 * Get Board Term Suggestions
 *
 * On a meeting typed annual, the terms on the roster that have ended, or end within three
 * months of the meeting: directors by their current term's recorded end, officers by their
 * title's recorded end (or, when the board recorded its officers' term length, the end it gives).
 * Worked out each time it is read; nothing here is stored but a dismissal, and nothing is added
 * to the agenda until someone adds it. On any other meeting, `offered` is false and the lists
 * are empty.
 */
export const charityBoardGetBoardTermSuggestions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardTermSuggestionsData, ThrowOnError>): RequestResult<CharityBoardGetBoardTermSuggestionsResponses, CharityBoardGetBoardTermSuggestionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardTermSuggestionsResponses, CharityBoardGetBoardTermSuggestionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/term-suggestions', ...options });

/**
 * Restore Board Term Suggestion
 *
 * Bring the annual meeting's election suggestion back after it was put away.
 */
export const charityBoardRestoreBoardTermSuggestion = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRestoreBoardTermSuggestionData, ThrowOnError>): RequestResult<CharityBoardRestoreBoardTermSuggestionResponses, CharityBoardRestoreBoardTermSuggestionErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardRestoreBoardTermSuggestionResponses, CharityBoardRestoreBoardTermSuggestionErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/term-suggestions/dismissal', ...options });

/**
 * Dismiss Board Term Suggestion
 *
 * Put the annual meeting's election suggestion away for this meeting ("Not for this
 * meeting"), recording who and when. It can be brought back.
 */
export const charityBoardDismissBoardTermSuggestion = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDismissBoardTermSuggestionData, ThrowOnError>): RequestResult<CharityBoardDismissBoardTermSuggestionResponses, CharityBoardDismissBoardTermSuggestionErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardDismissBoardTermSuggestionResponses, CharityBoardDismissBoardTermSuggestionErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/meetings/{meeting_id}/term-suggestions/dismissal', ...options });

/**
 * List Board Member Proposals
 *
 * The board members a connected AI proposed that wait for a person to add or discard them,
 * oldest first: each one's details as proposed, the AI's note on where it found them, and whose
 * connection proposed them. None of them is on the board until a person adds them.
 */
export const charityBoardListBoardMemberProposals = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardMemberProposalsData, ThrowOnError>): RequestResult<CharityBoardListBoardMemberProposalsResponses, CharityBoardListBoardMemberProposalsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardMemberProposalsResponses, CharityBoardListBoardMemberProposalsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/member-proposals', ...options });

/**
 * Discard Board Member Proposal
 *
 * Discard a proposed board member. Nobody is added, and the proposal keeps no name or
 * address. A person's act: a connected AI cannot discard one.
 */
export const charityBoardDiscardBoardMemberProposal = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDiscardBoardMemberProposalData, ThrowOnError>): RequestResult<CharityBoardDiscardBoardMemberProposalResponses, CharityBoardDiscardBoardMemberProposalErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardDiscardBoardMemberProposalResponses, CharityBoardDiscardBoardMemberProposalErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/member-proposals/{proposal_id}/discard', ...options });

/**
 * List Board Members
 *
 * The charity's board roster, newest first.
 *
 * Active seats only unless `include_removed` is set: the ordinary question is who is on
 * the board, and roster history — which is never deleted — is opt-in.
 */
export const charityBoardListBoardMembers = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardMembersData, ThrowOnError>): RequestResult<CharityBoardListBoardMembersResponses, CharityBoardListBoardMembersErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardMembersResponses, CharityBoardListBoardMembersErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/members', ...options });

/**
 * Create Board Member
 *
 * Add a seat to the roster.
 *
 * A seat is created from a name and an email of record — nothing else, and nothing about
 * a Givmo account. A director may sit on this roster, receive packets, and have acts
 * recorded on their behalf without ever signing in; their own Givmo account connects to
 * the seat later, through an invitation and a proof of the mailbox, or never.
 */
export const charityBoardCreateBoardMember = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardMemberData, ThrowOnError>): RequestResult<CharityBoardCreateBoardMemberResponses, CharityBoardCreateBoardMemberErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardMemberResponses, CharityBoardCreateBoardMemberErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Member
 */
export const charityBoardGetBoardMember = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardMemberData, ThrowOnError>): RequestResult<CharityBoardGetBoardMemberResponses, CharityBoardGetBoardMemberErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardMemberResponses, CharityBoardGetBoardMemberErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/members/{member_id}', ...options });

/**
 * Update Board Member
 *
 * Edit a seat (skip-None partial update).
 *
 * Cannot end a seat — that is its own operation, because it kills live credentials and a
 * spelling fix should not travel on the same route.
 */
export const charityBoardUpdateBoardMember = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardMemberData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardMemberResponses, CharityBoardUpdateBoardMemberErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardMemberResponses, CharityBoardUpdateBoardMemberErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/members/{member_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mint Board Access Link
 *
 * Mint a director's invitation link, and mail it when the module can.
 *
 * The response carries the PLAINTEXT token — the one place it ever appears in one. That
 * is a real product path, not a fallback: the recording officer hands a director their
 * link directly (reads it out, pastes it into their own message, prints it), and a module
 * that only ever emailed links would make the volunteer's actual route in impossible. It
 * is safe to hand over: the link only lets the director join with their own Givmo account
 * and their own mailbox. The stored row keeps only the token's digest. A seat whose director
 * has already joined is refused (`board_seat_already_connected`).
 *
 * `email_sent` reports whether a mail also went out. It is false when no template or no
 * board-app base URL is configured, so the caller is told what happened rather than left
 * to assume.
 */
export const charityBoardMintBoardAccessLink = <ThrowOnError extends boolean = false>(options: Options<CharityBoardMintBoardAccessLinkData, ThrowOnError>): RequestResult<CharityBoardMintBoardAccessLinkResponses, CharityBoardMintBoardAccessLinkErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardMintBoardAccessLinkResponses, CharityBoardMintBoardAccessLinkErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/access-links', ...options });

/**
 * Release Board Member Account
 *
 * Disconnect the Givmo account that joined the board through this seat, with a recorded
 * reason.
 *
 * The seat stays on the roster and can be invited and joined again; the account's next
 * request as a director is refused. Both the account's own email and the seat's address are
 * told. Changing a seat's email address never disconnects its account — this does, and only
 * this. A seat no account has joined is refused (`board_seat_not_connected`).
 */
export const charityBoardReleaseBoardMemberAccount = <ThrowOnError extends boolean = false>(options: Options<CharityBoardReleaseBoardMemberAccountData, ThrowOnError>): RequestResult<CharityBoardReleaseBoardMemberAccountResponses, CharityBoardReleaseBoardMemberAccountErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardReleaseBoardMemberAccountResponses, CharityBoardReleaseBoardMemberAccountErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/account-release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Paper Acknowledgments
 *
 * Record a signed paper form: that this member signed a paper acknowledgment of these
 * documents, on the date written on it, with a note on where it came from. Each document is
 * recorded as acknowledged, exactly the version named, as entered by you from a paper form.
 */
export const charityBoardRecordBoardPaperAcknowledgments = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardPaperAcknowledgmentsData, ThrowOnError>): RequestResult<CharityBoardRecordBoardPaperAcknowledgmentsResponses, CharityBoardRecordBoardPaperAcknowledgmentsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardPaperAcknowledgmentsResponses, CharityBoardRecordBoardPaperAcknowledgmentsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/acknowledgments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Board Member To Board
 *
 * Add someone who serves on a committee to the board (CBG-YR6-OUTSIDE-WIDEN): their seat,
 * one for someone who isn't on the board, becomes the board's.
 *
 * The Owner's act, its own operation, as ending a seat is: from the next request the board's
 * meetings, papers, minutes and written consents are open to the seat's account, earlier ones
 * included, and the board's year counts the person as joining today. Nothing else about the seat
 * changes — whether they're a director, and any title, are recorded afterwards — and it can't be
 * undone: a board seat never becomes a committee's alone. No body. A seat someone has joined is
 * emailed to say so.
 */
export const charityBoardAddBoardMemberToBoard = <ThrowOnError extends boolean = false>(options: Options<CharityBoardAddBoardMemberToBoardData, ThrowOnError>): RequestResult<CharityBoardAddBoardMemberToBoardResponses, CharityBoardAddBoardMemberToBoardErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardAddBoardMemberToBoardResponses, CharityBoardAddBoardMemberToBoardErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/board-addition', ...options });

/**
 * Get Board Member Getting Started
 *
 * A member's getting-started list, each item with what the records say about it: a document
 * confirmed (in Board, from a paper form, or in their annual disclosure) or not yet, their first
 * disclosure, their board buddy, the board's own steps.
 */
export const charityBoardGetBoardMemberGettingStarted = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardMemberGettingStartedData, ThrowOnError>): RequestResult<CharityBoardGetBoardMemberGettingStartedResponses, CharityBoardGetBoardMemberGettingStartedErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardMemberGettingStartedResponses, CharityBoardGetBoardMemberGettingStartedErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/getting-started', ...options });

/**
 * Start Board Member Getting Started
 *
 * Start a getting-started list for a member who has none, from the board's list.
 */
export const charityBoardStartBoardMemberGettingStarted = <ThrowOnError extends boolean = false>(options: Options<CharityBoardStartBoardMemberGettingStartedData, ThrowOnError>): RequestResult<CharityBoardStartBoardMemberGettingStartedResponses, CharityBoardStartBoardMemberGettingStartedErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardStartBoardMemberGettingStartedResponses, CharityBoardStartBoardMemberGettingStartedErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/getting-started', ...options });

/**
 * Save Board Member Getting Started
 *
 * Change one member's list from the revision you read: an item sent with its id stays (a
 * step keeps its done date), one without is added, one left out is removed.
 */
export const charityBoardSaveBoardMemberGettingStarted = <ThrowOnError extends boolean = false>(options: Options<CharityBoardSaveBoardMemberGettingStartedData, ThrowOnError>): RequestResult<CharityBoardSaveBoardMemberGettingStartedResponses, CharityBoardSaveBoardMemberGettingStartedErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardSaveBoardMemberGettingStartedResponses, CharityBoardSaveBoardMemberGettingStartedErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/getting-started',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Choose Board Member Buddy
 *
 * Choose a member's board buddy: someone serving on the board. It's recorded on the member's
 * history; the buddy is sent nothing and asked to do nothing.
 */
export const charityBoardChooseBoardMemberBuddy = <ThrowOnError extends boolean = false>(options: Options<CharityBoardChooseBoardMemberBuddyData, ThrowOnError>): RequestResult<CharityBoardChooseBoardMemberBuddyResponses, CharityBoardChooseBoardMemberBuddyErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardChooseBoardMemberBuddyResponses, CharityBoardChooseBoardMemberBuddyErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/getting-started/buddy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close Board Member Getting Started
 *
 * Close a member's list — for someone who left, or a list the board considers done. It can't
 * be reopened.
 */
export const charityBoardCloseBoardMemberGettingStarted = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCloseBoardMemberGettingStartedData, ThrowOnError>): RequestResult<CharityBoardCloseBoardMemberGettingStartedResponses, CharityBoardCloseBoardMemberGettingStartedErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCloseBoardMemberGettingStartedResponses, CharityBoardCloseBoardMemberGettingStartedErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/getting-started/closure', ...options });

/**
 * Mark Board Member Getting Started Step
 *
 * Mark one of the board's own steps done on a member's list, with the date, or clear it.
 */
export const charityBoardMarkBoardMemberGettingStartedStep = <ThrowOnError extends boolean = false>(options: Options<CharityBoardMarkBoardMemberGettingStartedStepData, ThrowOnError>): RequestResult<CharityBoardMarkBoardMemberGettingStartedStepResponses, CharityBoardMarkBoardMemberGettingStartedStepErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardMarkBoardMemberGettingStartedStepResponses, CharityBoardMarkBoardMemberGettingStartedStepErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/getting-started/items/{item_id}/done',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Member History
 *
 * One seat's history, newest first: when it was added and edited, every change to its
 * email address (the old and the new one), every invitation and whether it was emailed, who
 * joined with which Givmo account and how, any account disconnected and why, and the
 * removal. Each entry names who did it.
 *
 * Owner-only, because the entries carry a director's addresses. Readable for a removed
 * seat too.
 */
export const charityBoardListBoardMemberHistory = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardMemberHistoryData, ThrowOnError>): RequestResult<CharityBoardListBoardMemberHistoryResponses, CharityBoardListBoardMemberHistoryErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardMemberHistoryResponses, CharityBoardListBoardMemberHistoryErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/history', ...options });

/**
 * Remove Board Member
 *
 * End a seat, with a recorded reason.
 *
 * Never a delete: the row and its history stay, because who sat on this board and when
 * is part of the charity's record and a former director's past acts must keep resolving
 * to a named seat. Every outstanding invitation of that seat dies with it, and the seat's
 * own standing is re-read on every director request — so removal takes effect on the
 * director's very next call.
 */
export const charityBoardRemoveBoardMember = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemoveBoardMemberData, ThrowOnError>): RequestResult<CharityBoardRemoveBoardMemberResponses, CharityBoardRemoveBoardMemberErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRemoveBoardMemberResponses, CharityBoardRemoveBoardMemberErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/removal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Member Term
 *
 * Record a term of this seat: the organization's own start and end (at least one), its
 * class, whether the board counts it toward its limit on consecutive terms, the minute-book
 * record it came from (`record_id`) or none, and a note. Saved as entered: dates that overlap
 * another term, or run past the term length or the limit the board recorded, are recorded as
 * they are. A term changes no vote, quorum or written consent.
 */
export const charityBoardRecordBoardMemberTerm = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardMemberTermData, ThrowOnError>): RequestResult<CharityBoardRecordBoardMemberTermResponses, CharityBoardRecordBoardMemberTermErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardMemberTermResponses, CharityBoardRecordBoardMemberTermErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/terms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Board Member Term
 *
 * Remove a term recorded in error, such as one recorded for the wrong person. The motion,
 * written consent or record it was linked to stays exactly as recorded; the seat's history
 * notes the change.
 */
export const charityBoardRemoveBoardMemberTerm = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemoveBoardMemberTermData, ThrowOnError>): RequestResult<CharityBoardRemoveBoardMemberTermResponses, CharityBoardRemoveBoardMemberTermErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardRemoveBoardMemberTermResponses, CharityBoardRemoveBoardMemberTermErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/terms/{term_id}', ...options });

/**
 * Update Board Member Term
 *
 * Correct a term. Send only what changes: a field left out keeps its value, and `null`
 * clears a date, the class or the note. A term keeps at least one date (422
 * `board_member_term_undated`) and never ends before it starts (422
 * `board_member_term_dates_out_of_order`). The record it came from is never changed here.
 */
export const charityBoardUpdateBoardMemberTerm = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardMemberTermData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardMemberTermResponses, CharityBoardUpdateBoardMemberTermErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardMemberTermResponses, CharityBoardUpdateBoardMemberTermErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/members/{member_id}/terms/{term_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Officer Duties
 *
 * What each officer title does in Givmo: Board's own acts the board ties to its titles.
 *
 * `adopted` is the board's adoption in force, or null before the first — then `duties` is
 * Givmo's starting point, which does nothing until the board adopts it. `earlier` lists the
 * adoptions replaced since, newest first. A duty never decides who may act: it decides whom
 * Board asks to sign the minutes, and what a few dialogs suggest. Reading this never changes it.
 */
export const charityBoardGetBoardOfficerDuties = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardOfficerDutiesData, ThrowOnError>): RequestResult<CharityBoardGetBoardOfficerDutiesResponses, CharityBoardGetBoardOfficerDutiesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardOfficerDutiesResponses, CharityBoardGetBoardOfficerDutiesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/officer-duties', ...options });

/**
 * Adopt Board Officer Duties
 *
 * Adopt the board's duties — the first time, or to change them: the WHOLE set.
 *
 * Each duty names one of Board's own acts, the title that does it (its `id`, or for one of the
 * starting four nobody has used yet its `default_key`) and, optionally, where the board's own
 * documents say so. An act left out is not assigned to a title. Saving replaces the duties in
 * force; the earlier ones stay in the history. Sending the set already in force changes nothing.
 * A retired title is a 409 `board_officer_duty_title_retired`.
 */
export const charityBoardAdoptBoardOfficerDuties = <ThrowOnError extends boolean = false>(options: Options<CharityBoardAdoptBoardOfficerDutiesData, ThrowOnError>): RequestResult<CharityBoardAdoptBoardOfficerDutiesResponses, CharityBoardAdoptBoardOfficerDutiesErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardAdoptBoardOfficerDutiesResponses, CharityBoardAdoptBoardOfficerDutiesErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/officer-duties',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Officer Titles
 *
 * The board's officer titles, in the board's order: Chair, Vice Chair, Secretary and
 * Treasurer to start with, as the board names them.
 *
 * A title with no `id` is one of the starting four that no member has been given yet; give it
 * to someone by its `default_key`. Reading this list never changes it. A title is a label: it
 * changes no vote, quorum or written consent.
 */
export const charityBoardListBoardOfficerTitles = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardOfficerTitlesData, ThrowOnError>): RequestResult<CharityBoardListBoardOfficerTitlesResponses, CharityBoardListBoardOfficerTitlesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardOfficerTitlesResponses, CharityBoardListBoardOfficerTitlesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/officer-titles', ...options });

/**
 * Create Board Officer Title
 *
 * Add one of the board's own officer titles, last in the board's order.
 *
 * No two active titles share a name, whatever the case or spacing — one of the starting four the
 * board hasn't used yet included: that is a 409 `board_officer_title_name_taken`. A title is a
 * label: it changes no vote, quorum or written consent. Who holds it is set on each member.
 */
export const charityBoardCreateBoardOfficerTitle = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardOfficerTitleData, ThrowOnError>): RequestResult<CharityBoardCreateBoardOfficerTitleResponses, CharityBoardCreateBoardOfficerTitleErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardOfficerTitleResponses, CharityBoardCreateBoardOfficerTitleErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/officer-titles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Board Officer Title
 *
 * Rename a title, move it in the board's order, or both.
 *
 * `title_ref` is the title's `id`, or — for one of the starting four that has no `id` yet — its
 * `default_key`. `position` is the title's place among the board's active titles, counting from
 * 1; past the last means last. Renaming changes the title's words everywhere they are shown; a
 * signature already recorded keeps the words it was made with. A retired title is neither
 * renamed nor moved (409 `board_officer_title_retired`); a name another active title has is a
 * 409 `board_officer_title_name_taken`.
 */
export const charityBoardUpdateBoardOfficerTitle = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardOfficerTitleData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardOfficerTitleResponses, CharityBoardUpdateBoardOfficerTitleErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardOfficerTitleResponses, CharityBoardUpdateBoardOfficerTitleErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/officer-titles/{title_ref}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retire Board Officer Title
 *
 * Retire a title the board no longer uses.
 *
 * A retired title is never deleted and never given to anyone new; it stays in the history of
 * everyone who held it. While anyone holds it, it can't be retired (409
 * `board_officer_title_held`): take it off them on their member pages first. `title_ref` is as
 * for renaming. Retiring a title already retired answers it as it is.
 */
export const charityBoardRetireBoardOfficerTitle = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRetireBoardOfficerTitleData, ThrowOnError>): RequestResult<CharityBoardRetireBoardOfficerTitleResponses, CharityBoardRetireBoardOfficerTitleErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRetireBoardOfficerTitleResponses, CharityBoardRetireBoardOfficerTitleErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/officer-titles/{title_ref}/retirement', ...options });

/**
 * Discard Board Packet
 *
 * Discard a DRAFT packet version.
 *
 * A published version cannot be discarded — the board already has it, so the honest move
 * is to publish a further version.
 */
export const charityBoardDiscardBoardPacket = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDiscardBoardPacketData, ThrowOnError>): RequestResult<CharityBoardDiscardBoardPacketResponses, CharityBoardDiscardBoardPacketErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardDiscardBoardPacketResponses, CharityBoardDiscardBoardPacketErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}', ...options });

/**
 * Get Board Packet
 *
 * One packet version with its entries.
 *
 * An entry naming a minute-book record the caller may not read is ABSENT from the list —
 * including for an Owner who was not in a closed session. `ledger_financial_pack_available`
 * says whether the treasurer's pages can be generated from the charity's own ledger;
 * while it is false the treasurer's report is attached as an ordinary document.
 */
export const charityBoardGetBoardPacket = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardPacketData, ThrowOnError>): RequestResult<CharityBoardGetBoardPacketResponses, CharityBoardGetBoardPacketErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardPacketResponses, CharityBoardGetBoardPacketErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}', ...options });

/**
 * List Board Packet Comments
 *
 * Board-visible comments on one packet version.
 *
 * A director's private note is not reachable through this read at all. The filter takes
 * no role into account, so it binds every charity administrator including an Owner.
 */
export const charityBoardListBoardPacketComments = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardPacketCommentsData, ThrowOnError>): RequestResult<CharityBoardListBoardPacketCommentsResponses, CharityBoardListBoardPacketCommentsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardPacketCommentsResponses, CharityBoardListBoardPacketCommentsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}/comments', ...options });

/**
 * Record Board Packet Shared Comment
 *
 * Record a board-visible comment on a director's behalf.
 *
 * The manual path for a comment a director made by telephone or in person. There is
 * deliberately no equivalent for a director's PRIVATE note: entering one on someone's
 * behalf would mean having read it, so that combination does not exist here and is
 * refused by the database as well.
 */
export const charityBoardRecordBoardPacketSharedComment = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardPacketSharedCommentData, ThrowOnError>): RequestResult<CharityBoardRecordBoardPacketSharedCommentResponses, CharityBoardRecordBoardPacketSharedCommentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardPacketSharedCommentResponses, CharityBoardRecordBoardPacketSharedCommentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Packet Distributions
 *
 * Who was sent one packet version. Its sibling read is who has opened it.
 */
export const charityBoardListBoardPacketDistributions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardPacketDistributionsData, ThrowOnError>): RequestResult<CharityBoardListBoardPacketDistributionsResponses, CharityBoardListBoardPacketDistributionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardPacketDistributionsResponses, CharityBoardListBoardPacketDistributionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}/distribution', ...options });

/**
 * Distribute Board Packet
 *
 * Send a published packet version to every active seat on the roster.
 *
 * Each seat gets a fresh access link, so a director follows one link and lands in a
 * session rather than at a sign-in page they have no credentials for. The response
 * carries every seat's plaintext link, once — the recording officer hands a director
 * their link directly as often as the module mails it, and a product that only ever
 * emailed the link would make the volunteer's real route in impossible.
 *
 * `emails_sent` reports how many mails actually went out; with no template or no board
 * app base URL configured it is zero and each row records why, so the caller is told
 * what happened rather than left to assume.
 */
export const charityBoardDistributeBoardPacket = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDistributeBoardPacketData, ThrowOnError>): RequestResult<CharityBoardDistributeBoardPacketResponses, CharityBoardDistributeBoardPacketErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardDistributeBoardPacketResponses, CharityBoardDistributeBoardPacketErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}/distribution', ...options });

/**
 * Reorder Board Packet Items
 *
 * Reorder a draft packet version by naming every entry once, in the order wanted.
 */
export const charityBoardReorderBoardPacketItems = <ThrowOnError extends boolean = false>(options: Options<CharityBoardReorderBoardPacketItemsData, ThrowOnError>): RequestResult<CharityBoardReorderBoardPacketItemsResponses, CharityBoardReorderBoardPacketItemsErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardReorderBoardPacketItemsResponses, CharityBoardReorderBoardPacketItemsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}/item-order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Board Packet Item
 *
 * Add an entry to a draft packet version.
 *
 * A minute-book record can be placed only by someone who may read it: otherwise an
 * administrator who was not in a closed session could hand the whole board a pointer to
 * content the record store withholds from them.
 */
export const charityBoardCreateBoardPacketItem = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardPacketItemData, ThrowOnError>): RequestResult<CharityBoardCreateBoardPacketItemResponses, CharityBoardCreateBoardPacketItemErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardPacketItemResponses, CharityBoardCreateBoardPacketItemErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Board Packet Item
 *
 * Remove one entry from a draft packet version, closing the gap it leaves.
 */
export const charityBoardDeleteBoardPacketItem = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDeleteBoardPacketItemData, ThrowOnError>): RequestResult<CharityBoardDeleteBoardPacketItemResponses, CharityBoardDeleteBoardPacketItemErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardDeleteBoardPacketItemResponses, CharityBoardDeleteBoardPacketItemErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}/items/{packet_item_id}', ...options });

/**
 * Refresh Board Filing Snapshot
 *
 * Append a snapshot and repoint a still-draft fifth packet item.
 */
export const charityBoardRefreshBoardFilingSnapshot = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRefreshBoardFilingSnapshotData, ThrowOnError>): RequestResult<CharityBoardRefreshBoardFilingSnapshotResponses, CharityBoardRefreshBoardFilingSnapshotErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRefreshBoardFilingSnapshotResponses, CharityBoardRefreshBoardFilingSnapshotErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}/items/{packet_item_id}/filing-snapshot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish Board Packet
 *
 * Issue a draft packet version.
 *
 * The route is named for the thing it creates, not for a verb. From here the version's
 * contents are frozen: directors may already be reading it, and a change opens the next
 * version instead.
 */
export const charityBoardPublishBoardPacket = <ThrowOnError extends boolean = false>(options: Options<CharityBoardPublishBoardPacketData, ThrowOnError>): RequestResult<CharityBoardPublishBoardPacketResponses, CharityBoardPublishBoardPacketErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardPublishBoardPacketResponses, CharityBoardPublishBoardPacketErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/packets/{packet_id}/publication',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Past Record Batches
 *
 * The batches of past records a connected AI proposed that wait for a person to confirm or
 * discard them: how many records each holds and how many have their file, and whose connection
 * proposed them. Nothing in them is in the minute book.
 */
export const charityBoardListBoardPastRecordBatches = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardPastRecordBatchesData, ThrowOnError>): RequestResult<CharityBoardListBoardPastRecordBatchesResponses, CharityBoardListBoardPastRecordBatchesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardPastRecordBatchesResponses, CharityBoardListBoardPastRecordBatchesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/past-record-batches', ...options });

/**
 * Get Board Past Record Batch
 *
 * One batch of proposed past records, each record in the order it was proposed, word for word
 * as it would go into the minute book, with its file's state. A batch already confirmed or
 * discarded answers its state (and the import batch it became) with no records.
 */
export const charityBoardGetBoardPastRecordBatch = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardPastRecordBatchData, ThrowOnError>): RequestResult<CharityBoardGetBoardPastRecordBatchResponses, CharityBoardGetBoardPastRecordBatchErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardPastRecordBatchResponses, CharityBoardGetBoardPastRecordBatchErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/past-record-batches/{batch_id}', ...options });

/**
 * Confirm Board Past Record Batch
 *
 * Import the proposed records into the minute book together, exactly as they are on their
 * page, with their files. All of them go in or none do. Echo the `revision` you read: if
 * anything changed since, nothing goes in. A `label` and a `source_description` are optional
 * (Board names the records' internal import batch from the connection that proposed them).
 * After this a record can't be changed or take a file. A person's act: a connected AI cannot
 * confirm them.
 */
export const charityBoardConfirmBoardPastRecordBatch = <ThrowOnError extends boolean = false>(options: Options<CharityBoardConfirmBoardPastRecordBatchData, ThrowOnError>): RequestResult<CharityBoardConfirmBoardPastRecordBatchResponses, CharityBoardConfirmBoardPastRecordBatchErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardConfirmBoardPastRecordBatchResponses, CharityBoardConfirmBoardPastRecordBatchErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/past-record-batches/{batch_id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Discard Board Past Record Batch
 *
 * Discard a batch: nothing goes into the minute book, and its records' text and files are
 * deleted. Echo the batch's `revision`. A person's act.
 */
export const charityBoardDiscardBoardPastRecordBatch = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDiscardBoardPastRecordBatchData, ThrowOnError>): RequestResult<CharityBoardDiscardBoardPastRecordBatchResponses, CharityBoardDiscardBoardPastRecordBatchErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardDiscardBoardPastRecordBatchResponses, CharityBoardDiscardBoardPastRecordBatchErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/past-record-batches/{batch_id}/discard',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Board Past Record Confidentiality
 *
 * Mark one proposed record as a closed (executive) session's own record, or not, before the
 * records are confirmed: it imports as the mark says, a closed session's record as one recorded by
 * hand. Echo the batch's `revision`; the answer carries the batch's new one. A person's act.
 */
export const charityBoardMarkBoardPastRecordConfidentiality = <ThrowOnError extends boolean = false>(options: Options<CharityBoardMarkBoardPastRecordConfidentialityData, ThrowOnError>): RequestResult<CharityBoardMarkBoardPastRecordConfidentialityResponses, CharityBoardMarkBoardPastRecordConfidentialityErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardMarkBoardPastRecordConfidentialityResponses, CharityBoardMarkBoardPastRecordConfidentialityErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/past-record-proposals/{proposal_id}/confidentiality',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Proposal File Url
 *
 * A short-lived link that downloads a proposed record's file, as Board checked it.
 */
export const charityBoardGetBoardProposalFileUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardProposalFileUrlData, ThrowOnError>): RequestResult<CharityBoardGetBoardProposalFileUrlResponses, CharityBoardGetBoardProposalFileUrlErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardProposalFileUrlResponses, CharityBoardGetBoardProposalFileUrlErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/past-record-proposals/{proposal_id}/file', ...options });

/**
 * Check Board Proposal File
 *
 * Ask Board to check a proposed record's file. With the `object_ref` an upload URL named and
 * the file's name and type, the file you added: if Board's check passes it becomes the record's
 * file; if not, the answer says why and the upload is deleted. Without them, the file the
 * connected AI was asked to upload, if it has arrived.
 */
export const charityBoardCheckBoardProposalFile = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCheckBoardProposalFileData, ThrowOnError>): RequestResult<CharityBoardCheckBoardProposalFileResponses, CharityBoardCheckBoardProposalFileErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCheckBoardProposalFileResponses, CharityBoardCheckBoardProposalFileErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/past-record-proposals/{proposal_id}/file/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issue Board Proposal File Upload Url
 *
 * A signed upload URL for a proposed record's missing or replacement file: PUT the file there
 * once, sending exactly `headers`, then ask Board to check it with the `object_ref` it names. A
 * PDF or a picture, up to 50 MB. Nothing is recorded until Board's check passes.
 */
export const charityBoardIssueBoardProposalFileUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardIssueBoardProposalFileUploadUrlData, ThrowOnError>): RequestResult<CharityBoardIssueBoardProposalFileUploadUrlResponses, CharityBoardIssueBoardProposalFileUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardIssueBoardProposalFileUploadUrlResponses, CharityBoardIssueBoardProposalFileUploadUrlErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/past-record-proposals/{proposal_id}/file/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Leave Out Board Past Record
 *
 * Leave one proposed record out of its batch: it won't be imported, and its text and file are
 * deleted. Echo the batch's `revision`; the answer carries the batch's new one. A person's act.
 */
export const charityBoardLeaveOutBoardPastRecord = <ThrowOnError extends boolean = false>(options: Options<CharityBoardLeaveOutBoardPastRecordData, ThrowOnError>): RequestResult<CharityBoardLeaveOutBoardPastRecordResponses, CharityBoardLeaveOutBoardPastRecordErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardLeaveOutBoardPastRecordResponses, CharityBoardLeaveOutBoardPastRecordErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/past-record-proposals/{proposal_id}/leave-out',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Records
 *
 * The charity's board records, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Executive-session records the caller did not take part in are ABSENT, and the total
 * reflects only what they may see — reporting the unfiltered total would leak the
 * existence of withheld records through arithmetic.
 *
 * `q` narrows the list to records whose TITLE contains it, ignoring case (CBG-UX1). It is
 * applied in the same query as the executive-session rule, so a withheld record is never
 * found or counted by a search. A `q` longer than a title can be, or holding a NUL, is a
 * 422.
 */
export const charityBoardListBoardRecords = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardRecordsData, ThrowOnError>): RequestResult<CharityBoardListBoardRecordsResponses, CharityBoardListBoardRecordsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardRecordsResponses, CharityBoardListBoardRecordsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/records', ...options });

/**
 * Create Board Record Draft
 */
export const charityBoardCreateBoardRecordDraft = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardRecordDraftData, ThrowOnError>): RequestResult<CharityBoardCreateBoardRecordDraftResponses, CharityBoardCreateBoardRecordDraftErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardRecordDraftResponses, CharityBoardCreateBoardRecordDraftErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Record
 */
export const charityBoardGetBoardRecord = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardRecordData, ThrowOnError>): RequestResult<CharityBoardGetBoardRecordResponses, CharityBoardGetBoardRecordErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardRecordResponses, CharityBoardGetBoardRecordErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/records/{record_id}', ...options });

/**
 * Update Board Record Draft
 */
export const charityBoardUpdateBoardRecordDraft = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardRecordDraftData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardRecordDraftResponses, CharityBoardUpdateBoardRecordDraftErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardRecordDraftResponses, CharityBoardUpdateBoardRecordDraftErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/records/{record_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Record Acknowledgments
 *
 * Who has confirmed reading a document, which version, how and when — confirmed in Board,
 * recorded from a signed paper form, or confirmed in an annual conflict-of-interest disclosure
 * (the policy only) — across the document's versions, newest first.
 */
export const charityBoardListBoardRecordAcknowledgments = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardRecordAcknowledgmentsData, ThrowOnError>): RequestResult<CharityBoardListBoardRecordAcknowledgmentsResponses, CharityBoardListBoardRecordAcknowledgmentsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardRecordAcknowledgmentsResponses, CharityBoardListBoardRecordAcknowledgmentsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/acknowledgments', ...options });

/**
 * Approve Board Record
 *
 * Record the approval — the door from a draft to the charity's record.
 *
 * The body's `content_hash` is a required echo of the artifact the approver read; a
 * mismatch is a 409 and the reviewer re-reads the current version. A record is approved
 * only with the date it is about: `occurred_on` supplies a date the draft is missing or
 * confirms the one it carries, and a record left without one is a 409. The route is
 * named for the thing it creates (the approval event), not for a verb, because that
 * event is the durable artifact.
 */
export const charityBoardApproveBoardRecord = <ThrowOnError extends boolean = false>(options: Options<CharityBoardApproveBoardRecordData, ThrowOnError>): RequestResult<CharityBoardApproveBoardRecordResponses, CharityBoardApproveBoardRecordErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardApproveBoardRecordResponses, CharityBoardApproveBoardRecordErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/approval',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Minutes Approval Consent Form
 *
 * The form for a written consent approving one set of minutes, filled in from them.
 *
 * A neutral form whose structure is modeled on the Model Nonprofit Corporation Act's board
 * action without a meeting. The module fills in only what the organization already recorded
 * about the minutes — their title, the date of their meeting, their record reference and their
 * fingerprint — and leaves every other term as a field for the organization. The text is the
 * organization's to edit; the fingerprint stays in it, because it is how the text the
 * directors sign names the minutes they approve.
 *
 * Available for a meeting's own minutes that are still a draft.
 */
export const charityBoardGetBoardMinutesApprovalConsentForm = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardMinutesApprovalConsentFormData, ThrowOnError>): RequestResult<CharityBoardGetBoardMinutesApprovalConsentFormResponses, CharityBoardGetBoardMinutesApprovalConsentFormErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardMinutesApprovalConsentFormResponses, CharityBoardGetBoardMinutesApprovalConsentFormErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/approval-consent-form', ...options });

/**
 * Create Board Minutes Approval Consent
 *
 * Open a working consent that names the minutes it approves.
 *
 * A draft like any other: nothing is put to the board here, and the text is the
 * organization's to edit. The minutes are the ones in the path, and that never changes.
 * When the consent goes to the board, its text carries the minutes' fingerprint and the
 * version that goes out records it. When the last director it went out to signs, the
 * minutes are approved — unless they changed after it went out, were approved another way,
 * or are no longer there; then the consent is still recorded, and says the minutes were not
 * approved and why.
 */
export const charityBoardCreateBoardMinutesApprovalConsent = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardMinutesApprovalConsentData, ThrowOnError>): RequestResult<CharityBoardCreateBoardMinutesApprovalConsentResponses, CharityBoardCreateBoardMinutesApprovalConsentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardMinutesApprovalConsentResponses, CharityBoardCreateBoardMinutesApprovalConsentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/approval-consents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Board Record Chain
 *
 * Delete a record together with its whole correction chain, as one act.
 *
 * A correction and the record it corrects are each other's context, so they are retained
 * and deleted as a unit — the single-record route refuses a chain member and points here.
 * Any member's id resolves the chain, and the request is refused outright if any member
 * is still inside the retention floor or under an active legal hold. Every member gets
 * its own ``deleted`` event.
 */
export const charityBoardDeleteBoardRecordChain = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDeleteBoardRecordChainData, ThrowOnError>): RequestResult<CharityBoardDeleteBoardRecordChainResponses, CharityBoardDeleteBoardRecordChainErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardDeleteBoardRecordChainResponses, CharityBoardDeleteBoardRecordChainErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/chain-deletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Board Record
 *
 * Delete ONE board record at the charity's explicit request.
 *
 * A POST carrying a required reason rather than a bare DELETE: the reason is recorded,
 * and a deletion of the charity's legal memory should not be something a stray verb can
 * accomplish. Refused while any active legal hold covers the record, and refused before
 * the record has passed the charity's adopted retention floor — both at the service for
 * a clear message and at the database independently.
 */
export const charityBoardDeleteBoardRecord = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDeleteBoardRecordData, ThrowOnError>): RequestResult<CharityBoardDeleteBoardRecordResponses, CharityBoardDeleteBoardRecordErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardDeleteBoardRecordResponses, CharityBoardDeleteBoardRecordErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/deletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Discard Board Record Draft
 */
export const charityBoardDiscardBoardRecordDraft = <ThrowOnError extends boolean = false>(options: Options<CharityBoardDiscardBoardRecordDraftData, ThrowOnError>): RequestResult<CharityBoardDiscardBoardRecordDraftResponses, CharityBoardDiscardBoardRecordDraftErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardDiscardBoardRecordDraftResponses, CharityBoardDiscardBoardRecordDraftErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/discard',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Record File Url
 *
 * A short-lived link that downloads a record's file, the one Board checked when the record
 * was imported. A closed session's file opens only for those who may read its record.
 */
export const charityBoardGetBoardRecordFileUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardRecordFileUrlData, ThrowOnError>): RequestResult<CharityBoardGetBoardRecordFileUrlResponses, CharityBoardGetBoardRecordFileUrlErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardRecordFileUrlResponses, CharityBoardGetBoardRecordFileUrlErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/file', ...options });

/**
 * Get Board Officer Statement
 *
 * A statement about one record, generated for an officer of the organization to
 * execute.
 *
 * The module fills in only what the charity already recorded — the record's title, its
 * date, when it was recorded, its reference and its text — and leaves every statement
 * the officer makes, and the officer's own name, title and date, as fields for them.
 * The organization's officer signs it; this product signs nothing.
 *
 * Available for a record the charity has recorded. There is nothing to state about a
 * working draft.
 */
export const charityBoardGetBoardOfficerStatement = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardOfficerStatementData, ThrowOnError>): RequestResult<CharityBoardGetBoardOfficerStatementResponses, CharityBoardGetBoardOfficerStatementErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardOfficerStatementResponses, CharityBoardGetBoardOfficerStatementErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/officer-statement', ...options });

/**
 * List Board Record Events
 *
 * One record's append-only record event log, oldest first — including the approval
 * event, which is the evidence of who approved what and when.
 */
export const charityBoardListBoardRecordEvents = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardRecordEventsData, ThrowOnError>): RequestResult<CharityBoardListBoardRecordEventsResponses, CharityBoardListBoardRecordEventsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardRecordEventsResponses, CharityBoardListBoardRecordEventsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/record-events', ...options });

/**
 * Submit Board Record
 */
export const charityBoardSubmitBoardRecord = <ThrowOnError extends boolean = false>(options: Options<CharityBoardSubmitBoardRecordData, ThrowOnError>): RequestResult<CharityBoardSubmitBoardRecordResponses, CharityBoardSubmitBoardRecordErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardSubmitBoardRecordResponses, CharityBoardSubmitBoardRecordErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/records/{record_id}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Retention Policies
 */
export const charityBoardListBoardRetentionPolicies = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardRetentionPoliciesData, ThrowOnError>): RequestResult<CharityBoardListBoardRetentionPoliciesResponses, CharityBoardListBoardRetentionPoliciesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardRetentionPoliciesResponses, CharityBoardListBoardRetentionPoliciesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/retention-policies', ...options });

/**
 * Adopt Board Retention Policy
 *
 * Adopt (or replace) the charity's retention schedule for one record kind.
 *
 * `minimum_retention_years` is a FLOOR, never an expiry: reaching it deletes nothing.
 * PUT rather than POST because the charity has exactly one live schedule per record
 * kind — adopting again replaces it (and supersedes the prior row, which stays readable
 * as history).
 */
export const charityBoardAdoptBoardRetentionPolicy = <ThrowOnError extends boolean = false>(options: Options<CharityBoardAdoptBoardRetentionPolicyData, ThrowOnError>): RequestResult<CharityBoardAdoptBoardRetentionPolicyResponses, CharityBoardAdoptBoardRetentionPolicyErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardAdoptBoardRetentionPolicyResponses, CharityBoardAdoptBoardRetentionPolicyErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/retention-policies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Return Distributions
 *
 * Every copy of the return provided to the board, newest first: the tax year, who provided
 * it and when, how many people it went to, and how many of the directors were provided it.
 * `tax_year_ends_on` narrows the list to one tax year's copies.
 */
export const charityBoardListBoardReturnDistributions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardReturnDistributionsData, ThrowOnError>): RequestResult<CharityBoardListBoardReturnDistributionsResponses, CharityBoardListBoardReturnDistributionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardReturnDistributionsResponses, CharityBoardListBoardReturnDistributionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/return-distributions', ...options });

/**
 * Provide Board Return
 *
 * Provide a copy of the return to the board. Adds one record to the minute book: the copy's
 * fingerprint, who provided it and when, and everyone on the roster it went to. Each person is
 * emailed that it's available to review in Givmo; a seat no account has joined gets an
 * invitation to join with it. `follows_record_id` provides a newer copy of a return already
 * provided.
 */
export const charityBoardProvideBoardReturn = <ThrowOnError extends boolean = false>(options: Options<CharityBoardProvideBoardReturnData, ThrowOnError>): RequestResult<CharityBoardProvideBoardReturnResponses, CharityBoardProvideBoardReturnErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardProvideBoardReturnResponses, CharityBoardProvideBoardReturnErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/return-distributions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Board Return Copy
 *
 * Check an uploaded copy: Board reads it and answers its size, its number of pages and its
 * SHA-256 fingerprint, which Board computes itself. A PDF with a password to open is refused.
 * Nothing is recorded.
 */
export const charityBoardConfirmBoardReturnCopy = <ThrowOnError extends boolean = false>(options: Options<CharityBoardConfirmBoardReturnCopyData, ThrowOnError>): RequestResult<CharityBoardConfirmBoardReturnCopyResponses, CharityBoardConfirmBoardReturnCopyErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardConfirmBoardReturnCopyResponses, CharityBoardConfirmBoardReturnCopyErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/return-distributions/copies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issue Board Return Copy Upload Url
 *
 * A link to upload one copy of the return, a PDF of at most 50 MB, valid for 15 minutes.
 * Nothing is recorded until the copy is provided.
 */
export const charityBoardIssueBoardReturnCopyUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardIssueBoardReturnCopyUploadUrlData, ThrowOnError>): RequestResult<CharityBoardIssueBoardReturnCopyUploadUrlResponses, CharityBoardIssueBoardReturnCopyUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardIssueBoardReturnCopyUploadUrlResponses, CharityBoardIssueBoardReturnCopyUploadUrlErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/return-distributions/copies/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Board Return Recipients
 *
 * Who a copy provided now would go to: everyone on the board's roster today, directors first,
 * with the titles they hold on `provided_on`, the day you'll provide it (today when unsent).
 * The same list the act uses.
 */
export const charityBoardPreviewBoardReturnRecipients = <ThrowOnError extends boolean = false>(options: Options<CharityBoardPreviewBoardReturnRecipientsData, ThrowOnError>): RequestResult<CharityBoardPreviewBoardReturnRecipientsResponses, CharityBoardPreviewBoardReturnRecipientsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardPreviewBoardReturnRecipientsResponses, CharityBoardPreviewBoardReturnRecipientsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/return-distributions/recipients', ...options });

/**
 * List Board Return Review Candidates
 *
 * The board's acts a copy's review can name, newest first: each motion with a recorded vote,
 * carried or failed, made in a meeting's open session (its meeting's title and day, and its own
 * words), and each written consent waiting on signatures or signed by everyone. A closed
 * session's motion is never listed.
 */
export const charityBoardListBoardReturnReviewCandidates = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardReturnReviewCandidatesData, ThrowOnError>): RequestResult<CharityBoardListBoardReturnReviewCandidatesResponses, CharityBoardListBoardReturnReviewCandidatesErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardReturnReviewCandidatesResponses, CharityBoardListBoardReturnReviewCandidatesErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/return-distributions/review-candidates', ...options });

/**
 * Get Board Return Distribution
 *
 * One copy of the return provided to the board, and what Board recorded of each person it
 * went to: their email, when they opened it, a printed copy given to them, and their recorded
 * reading.
 */
export const charityBoardGetBoardReturnDistribution = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardReturnDistributionData, ThrowOnError>): RequestResult<CharityBoardGetBoardReturnDistributionResponses, CharityBoardGetBoardReturnDistributionErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardReturnDistributionResponses, CharityBoardGetBoardReturnDistributionErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/return-distributions/{record_id}', ...options });

/**
 * Get Board Return Copy Url
 *
 * A link to download the copy provided, valid for 15 minutes. Your download isn't recorded
 * as anyone's receipt.
 */
export const charityBoardGetBoardReturnCopyUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardReturnCopyUrlData, ThrowOnError>): RequestResult<CharityBoardGetBoardReturnCopyUrlResponses, CharityBoardGetBoardReturnCopyUrlErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardReturnCopyUrlResponses, CharityBoardGetBoardReturnCopyUrlErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/return-distributions/{record_id}/copy-url', ...options });

/**
 * Email Board Return Again
 *
 * Email one person again after their email didn't go out. At most once a day each; no new
 * record. A seat no account has joined gets a new invitation with it.
 */
export const charityBoardEmailBoardReturnAgain = <ThrowOnError extends boolean = false>(options: Options<CharityBoardEmailBoardReturnAgainData, ThrowOnError>): RequestResult<CharityBoardEmailBoardReturnAgainResponses, CharityBoardEmailBoardReturnAgainErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardEmailBoardReturnAgainResponses, CharityBoardEmailBoardReturnAgainErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/return-distributions/{record_id}/people/{board_member_id}/email', ...options });

/**
 * Record Board Return Printed Copy
 *
 * Record that a printed copy was given to this person: the day it was given, and how. Once
 * per person for each copy.
 */
export const charityBoardRecordBoardReturnPrintedCopy = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardReturnPrintedCopyData, ThrowOnError>): RequestResult<CharityBoardRecordBoardReturnPrintedCopyResponses, CharityBoardRecordBoardReturnPrintedCopyErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardReturnPrintedCopyResponses, CharityBoardRecordBoardReturnPrintedCopyErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/return-distributions/{record_id}/people/{board_member_id}/printed-copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link Board Return Review
 *
 * Record the board's review of this copy: one of the acts the review list names, a motion
 * or a written consent. One per copy at a time; remove it to record another. The board's own
 * record is unchanged.
 */
export const charityBoardLinkBoardReturnReview = <ThrowOnError extends boolean = false>(options: Options<CharityBoardLinkBoardReturnReviewData, ThrowOnError>): RequestResult<CharityBoardLinkBoardReturnReviewResponses, CharityBoardLinkBoardReturnReviewErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardLinkBoardReturnReviewResponses, CharityBoardLinkBoardReturnReviewErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/return-distributions/{record_id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unlink Board Return Review
 *
 * Remove this copy's review link. Who removed it and when is kept with the copy's earlier
 * links.
 */
export const charityBoardUnlinkBoardReturnReview = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUnlinkBoardReturnReviewData, ThrowOnError>): RequestResult<CharityBoardUnlinkBoardReturnReviewResponses, CharityBoardUnlinkBoardReturnReviewErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardUnlinkBoardReturnReviewResponses, CharityBoardUnlinkBoardReturnReviewErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/return-distributions/{record_id}/review/{link_id}', ...options });

/**
 * Withdraw Board Return
 *
 * Withdraw this copy, with the reason directors will see. Their pages stop offering it; the
 * record, what was recorded of each person and the file stay.
 */
export const charityBoardWithdrawBoardReturn = <ThrowOnError extends boolean = false>(options: Options<CharityBoardWithdrawBoardReturnData, ThrowOnError>): RequestResult<CharityBoardWithdrawBoardReturnResponses, CharityBoardWithdrawBoardReturnErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardWithdrawBoardReturnResponses, CharityBoardWithdrawBoardReturnErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/return-distributions/{record_id}/withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Roster Result
 *
 * Record an election's result on the roster, from the motion recorded as carried
 * (`motion_id`) or the executed written consent (`consent_id`) that elected them: a term for
 * each director named, and the title for each officer named (ending that person's earlier
 * holding of the same title, which stays in their history). Each is linked to the motion or
 * consent; the motion, the consent and the minutes don't change. The roster never changes from
 * an election by itself; this is the officer's act. Givmo doesn't read the motion's or the
 * consent's words: whoever is named here is recorded.
 *
 * A motion not recorded as carried is a 409 `board_roster_result_not_carried`; a written
 * consent not executed, a 409 `board_roster_result_not_executed`; a director named who isn't
 * recorded as a director, a 409 `board_roster_result_not_a_director`.
 */
export const charityBoardRecordBoardRosterResult = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardRosterResultData, ThrowOnError>): RequestResult<CharityBoardRecordBoardRosterResultResponses, CharityBoardRecordBoardRosterResultErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardRosterResultResponses, CharityBoardRecordBoardRosterResultErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/roster-results',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Board Self Assessment Instruments
 *
 * Givmo's starting self-assessments this organization is offered, each with where its
 * statements come from. Never a statement that one is required or recommended.
 */
export const charityBoardListBoardSelfAssessmentInstruments = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardSelfAssessmentInstrumentsData, ThrowOnError>): RequestResult<CharityBoardListBoardSelfAssessmentInstrumentsResponses, CharityBoardListBoardSelfAssessmentInstrumentsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardSelfAssessmentInstrumentsResponses, CharityBoardListBoardSelfAssessmentInstrumentsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/self-assessment-instruments', ...options });

/**
 * Get Board Self Assessment Instrument
 *
 * One starting self-assessment with every statement, in its group, and the text each is
 * written from: the IRS's Form 990 and its instructions, or a state's statute.
 */
export const charityBoardGetBoardSelfAssessmentInstrument = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardSelfAssessmentInstrumentData, ThrowOnError>): RequestResult<CharityBoardGetBoardSelfAssessmentInstrumentResponses, CharityBoardGetBoardSelfAssessmentInstrumentErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardSelfAssessmentInstrumentResponses, CharityBoardGetBoardSelfAssessmentInstrumentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/self-assessment-instruments/{template_id}', ...options });

/**
 * List Board Self Assessments
 *
 * Every self-assessment of the board, newest first: each one's dates, where it stands, and
 * how many were asked and how many answered.
 */
export const charityBoardListBoardSelfAssessments = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardSelfAssessmentsData, ThrowOnError>): RequestResult<CharityBoardListBoardSelfAssessmentsResponses, CharityBoardListBoardSelfAssessmentsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardSelfAssessmentsResponses, CharityBoardListBoardSelfAssessmentsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/self-assessments', ...options });

/**
 * Open Board Self Assessment
 *
 * Start the board's self-assessment: everyone on the roster is asked, but the people named in
 * `not_asked`, with Givmo's starting statements (any turned off). Each person is emailed the
 * ask; a seat that hasn't joined Board yet gets an invitation to join with it. Each person's
 * answers are private to them until it is closed.
 */
export const charityBoardOpenBoardSelfAssessment = <ThrowOnError extends boolean = false>(options: Options<CharityBoardOpenBoardSelfAssessmentData, ThrowOnError>): RequestResult<CharityBoardOpenBoardSelfAssessmentResponses, CharityBoardOpenBoardSelfAssessmentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardOpenBoardSelfAssessmentResponses, CharityBoardOpenBoardSelfAssessmentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/self-assessments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Self Assessment
 *
 * One self-assessment: who was asked, who has answered and when (never what), what was sent
 * and when, who can be reminded now, what became of the answers once it closed, and the
 * board's priorities.
 */
export const charityBoardGetBoardSelfAssessment = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardSelfAssessmentData, ThrowOnError>): RequestResult<CharityBoardGetBoardSelfAssessmentResponses, CharityBoardGetBoardSelfAssessmentErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardSelfAssessmentResponses, CharityBoardGetBoardSelfAssessmentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}', ...options });

/**
 * Cancel Board Self Assessment
 *
 * Withdraw a self-assessment started by mistake, before anyone has answered. Nothing is added
 * to the minute book.
 */
export const charityBoardCancelBoardSelfAssessment = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCancelBoardSelfAssessmentData, ThrowOnError>): RequestResult<CharityBoardCancelBoardSelfAssessmentResponses, CharityBoardCancelBoardSelfAssessmentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCancelBoardSelfAssessmentResponses, CharityBoardCancelBoardSelfAssessmentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}/cancellation', ...options });

/**
 * Close Board Self Assessment
 *
 * Close the self-assessment. Adds one record to the minute book: how many people chose each
 * answer, and the comments without names, or, with fewer than three answers, only how many were
 * asked and answered. Each person's answers are then deleted, unless a legal hold covers the
 * board, which keeps them.
 */
export const charityBoardCloseBoardSelfAssessment = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCloseBoardSelfAssessmentData, ThrowOnError>): RequestResult<CharityBoardCloseBoardSelfAssessmentResponses, CharityBoardCloseBoardSelfAssessmentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCloseBoardSelfAssessmentResponses, CharityBoardCloseBoardSelfAssessmentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}/close', ...options });

/**
 * Unmark Board Self Assessment Paper Hand In
 *
 * Undo a paper hand-in marked by mistake.
 */
export const charityBoardUnmarkBoardSelfAssessmentPaperHandIn = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUnmarkBoardSelfAssessmentPaperHandInData, ThrowOnError>): RequestResult<CharityBoardUnmarkBoardSelfAssessmentPaperHandInResponses, CharityBoardUnmarkBoardSelfAssessmentPaperHandInErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardUnmarkBoardSelfAssessmentPaperHandInResponses, CharityBoardUnmarkBoardSelfAssessmentPaperHandInErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}/paper-hand-ins/{board_member_id}', ...options });

/**
 * Mark Board Self Assessment Paper Hand In
 *
 * Mark that someone asked handed in a paper answer sheet, so they count as answered and are
 * not reminded.
 */
export const charityBoardMarkBoardSelfAssessmentPaperHandIn = <ThrowOnError extends boolean = false>(options: Options<CharityBoardMarkBoardSelfAssessmentPaperHandInData, ThrowOnError>): RequestResult<CharityBoardMarkBoardSelfAssessmentPaperHandInResponses, CharityBoardMarkBoardSelfAssessmentPaperHandInErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardMarkBoardSelfAssessmentPaperHandInResponses, CharityBoardMarkBoardSelfAssessmentPaperHandInErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}/paper-hand-ins/{board_member_id}', ...options });

/**
 * Record Board Self Assessment Paper Sheet
 *
 * Enter one paper answer sheet. It names nobody: nothing entered here ties it to a person.
 * Mark who handed one in separately.
 */
export const charityBoardRecordBoardSelfAssessmentPaperSheet = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardSelfAssessmentPaperSheetData, ThrowOnError>): RequestResult<CharityBoardRecordBoardSelfAssessmentPaperSheetResponses, CharityBoardRecordBoardSelfAssessmentPaperSheetErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardSelfAssessmentPaperSheetResponses, CharityBoardRecordBoardSelfAssessmentPaperSheetErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}/paper-sheets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link Board Self Assessment Priorities
 *
 * Link the results to the board's own act choosing its priorities: a motion the board
 * carried, or a written consent every director signed, and the statements it addresses. Board
 * never chooses or drafts the priorities.
 */
export const charityBoardLinkBoardSelfAssessmentPriorities = <ThrowOnError extends boolean = false>(options: Options<CharityBoardLinkBoardSelfAssessmentPrioritiesData, ThrowOnError>): RequestResult<CharityBoardLinkBoardSelfAssessmentPrioritiesResponses, CharityBoardLinkBoardSelfAssessmentPrioritiesErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardLinkBoardSelfAssessmentPrioritiesResponses, CharityBoardLinkBoardSelfAssessmentPrioritiesErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}/priorities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Self Assessment Questions
 *
 * What the self-assessment asks: its statements, in their groups, with their sources, the
 * answers, and the questions in a person's own words — to print a blank answer sheet, and to
 * enter one.
 */
export const charityBoardGetBoardSelfAssessmentQuestions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardSelfAssessmentQuestionsData, ThrowOnError>): RequestResult<CharityBoardGetBoardSelfAssessmentQuestionsResponses, CharityBoardGetBoardSelfAssessmentQuestionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardSelfAssessmentQuestionsResponses, CharityBoardGetBoardSelfAssessmentQuestionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}/questions', ...options });

/**
 * Remind Board Self Assessment Recipients
 *
 * Remind people who haven't answered yet. Each gets one email, at most once a day. Reminders
 * go only when you send them. Name the people in `board_member_ids`, or send null for everyone
 * who can be reminded now.
 */
export const charityBoardRemindBoardSelfAssessmentRecipients = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemindBoardSelfAssessmentRecipientsData, ThrowOnError>): RequestResult<CharityBoardRemindBoardSelfAssessmentRecipientsResponses, CharityBoardRemindBoardSelfAssessmentRecipientsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRemindBoardSelfAssessmentRecipientsResponses, CharityBoardRemindBoardSelfAssessmentRecipientsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}/reminders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Board Self Assessment Requests
 *
 * Send the self-assessment to people who haven't been sent it — someone who joined the board
 * since it started, or someone left out at the start. A seat that hasn't joined Board yet gets
 * an invitation with it. Name the people in `board_member_ids`, or send null for everyone it can
 * go to (never someone left out at the start).
 */
export const charityBoardSendBoardSelfAssessmentRequests = <ThrowOnError extends boolean = false>(options: Options<CharityBoardSendBoardSelfAssessmentRequestsData, ThrowOnError>): RequestResult<CharityBoardSendBoardSelfAssessmentRequestsResponses, CharityBoardSendBoardSelfAssessmentRequestsErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardSendBoardSelfAssessmentRequestsResponses, CharityBoardSendBoardSelfAssessmentRequestsErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}/requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Self Assessment Results
 *
 * A closed self-assessment's results, from its record in the minute book: how many people
 * chose each answer, in the statements' own order, and the comments without names, sorted. With
 * fewer than three answers, only how many were asked and answered.
 */
export const charityBoardGetBoardSelfAssessmentResults = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardSelfAssessmentResultsData, ThrowOnError>): RequestResult<CharityBoardGetBoardSelfAssessmentResultsResponses, CharityBoardGetBoardSelfAssessmentResultsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardSelfAssessmentResultsResponses, CharityBoardGetBoardSelfAssessmentResultsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/self-assessments/{assessment_id}/results', ...options });

/**
 * Get Board To Do
 *
 * Your to-do list on this board: what an officer can do next in Board's record-keeping, and
 * what officers did in the last 90 days. A new member's steps (the year's conflict-of-interest
 * questionnaire to send, a board buddy to choose), minutes to write and to send for approval
 * with the date the Form 990 instructions use, records waiting for approval, and members or past
 * records a connected AI proposed. Each is listed only for someone who can do it, and each keeps
 * the scoping of the page it is done on. Never what a member hasn't read or answered. Computed
 * when read from your board's own records; nothing is stored.
 */
export const charityBoardGetBoardToDo = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardToDoData, ThrowOnError>): RequestResult<CharityBoardGetBoardToDoResponses, CharityBoardGetBoardToDoErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardToDoResponses, CharityBoardGetBoardToDoErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/to-do', ...options });

/**
 * List Board Written Consents
 *
 * The charity's written consents, newest first, in the canonical
 * `{data, meta, links}` envelope.
 *
 * Each entry carries where the consent stands and how many of the seats it went out to
 * have signed. The roster and the signature log come with the single-consent read
 * rather than with a page of them.
 */
export const charityBoardListBoardWrittenConsents = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardWrittenConsentsData, ThrowOnError>): RequestResult<CharityBoardListBoardWrittenConsentsResponses, CharityBoardListBoardWrittenConsentsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardWrittenConsentsResponses, CharityBoardListBoardWrittenConsentsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/written-consents', ...options });

/**
 * Create Board Written Consent
 *
 * Open a working consent.
 *
 * Nothing is put to the board here: a draft has no roster and nobody can sign it. That
 * is a separate act, on a separate permission.
 */
export const charityBoardCreateBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCreateBoardWrittenConsentData, ThrowOnError>): RequestResult<CharityBoardCreateBoardWrittenConsentResponses, CharityBoardCreateBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCreateBoardWrittenConsentResponses, CharityBoardCreateBoardWrittenConsentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/written-consents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Board Written Consent
 *
 * One consent: the text before the board, the roster it went out to, and every
 * signature act recorded against it — who, what identity they asserted, how it was
 * captured, which text they named, and when.
 */
export const charityBoardGetBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardWrittenConsentData, ThrowOnError>): RequestResult<CharityBoardGetBoardWrittenConsentResponses, CharityBoardGetBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardWrittenConsentResponses, CharityBoardGetBoardWrittenConsentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}', ...options });

/**
 * Update Board Written Consent
 *
 * Edit a working consent's text (skip-None partial update).
 *
 * Refused once the consent has been circulated. From there a change is a revision: the
 * text goes out again as a new version and every signature starts again, because a
 * signature names the bytes a director read.
 */
export const charityBoardUpdateBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<CharityBoardUpdateBoardWrittenConsentData, ThrowOnError>): RequestResult<CharityBoardUpdateBoardWrittenConsentResponses, CharityBoardUpdateBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).patch<CharityBoardUpdateBoardWrittenConsentResponses, CharityBoardUpdateBoardWrittenConsentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Circulate Board Written Consent
 *
 * Put the consent to the board.
 *
 * Freezes the text, records the roster it is going out to, and leaves the consent
 * pending. Until every seat on that roster has signed, the response says so in as many
 * words: the consent is pending, and how many seats have signed.
 *
 * Observers are not on the roster a consent goes to — the roster records them as
 * non-voting seats.
 */
export const charityBoardCirculateBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<CharityBoardCirculateBoardWrittenConsentData, ThrowOnError>): RequestResult<CharityBoardCirculateBoardWrittenConsentResponses, CharityBoardCirculateBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardCirculateBoardWrittenConsentResponses, CharityBoardCirculateBoardWrittenConsentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/circulation', ...options });

/**
 * List Board Consent Compensation Decisions
 *
 * A written consent's compensation decisions, in order, with their documents, and the one
 * block its text must carry, exactly as shown, to go out to the board: the directors sign the
 * details in the text they read. Whether the current text carries it.
 */
export const charityBoardListBoardConsentCompensationDecisions = <ThrowOnError extends boolean = false>(options: Options<CharityBoardListBoardConsentCompensationDecisionsData, ThrowOnError>): RequestResult<CharityBoardListBoardConsentCompensationDecisionsResponses, CharityBoardListBoardConsentCompensationDecisionsErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardListBoardConsentCompensationDecisionsResponses, CharityBoardListBoardConsentCompensationDecisionsErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/compensation-decisions', ...options });

/**
 * Add Board Consent Compensation Decision
 *
 * Record the board's compensation decision for one person on a written consent's draft,
 * after its others: whose pay, their position, how the board obtained what it relied on, and
 * its reason when it set pay outside the range in that information. Its documents are uploaded
 * onto it. Refused once the consent has gone out to the board.
 */
export const charityBoardAddBoardConsentCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<CharityBoardAddBoardConsentCompensationDecisionData, ThrowOnError>): RequestResult<CharityBoardAddBoardConsentCompensationDecisionResponses, CharityBoardAddBoardConsentCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardAddBoardConsentCompensationDecisionResponses, CharityBoardAddBoardConsentCompensationDecisionErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/compensation-decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Board Consent Compensation Decision
 *
 * Remove one consent decision, with its documents, while the consent is a draft. Its
 * history keeps who recorded and removed it, and when.
 */
export const charityBoardRemoveBoardConsentCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemoveBoardConsentCompensationDecisionData, ThrowOnError>): RequestResult<CharityBoardRemoveBoardConsentCompensationDecisionResponses, CharityBoardRemoveBoardConsentCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardRemoveBoardConsentCompensationDecisionResponses, CharityBoardRemoveBoardConsentCompensationDecisionErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/compensation-decisions/{decision_id}', ...options });

/**
 * Replace Board Consent Compensation Decision
 *
 * Replace one consent decision's details whole, while the consent is a draft. Its uploaded
 * documents stay. The consent's text must then carry the block as it now reads.
 */
export const charityBoardReplaceBoardConsentCompensationDecision = <ThrowOnError extends boolean = false>(options: Options<CharityBoardReplaceBoardConsentCompensationDecisionData, ThrowOnError>): RequestResult<CharityBoardReplaceBoardConsentCompensationDecisionResponses, CharityBoardReplaceBoardConsentCompensationDecisionErrors, ThrowOnError> => (options.client ?? client).put<CharityBoardReplaceBoardConsentCompensationDecisionResponses, CharityBoardReplaceBoardConsentCompensationDecisionErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/compensation-decisions/{decision_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Board Compensation Document
 *
 * Confirm a document finished uploading: Board reads the stored file and records its
 * fingerprint and size, which the consent's text names. A file over 100 MB is refused.
 */
export const charityBoardConfirmBoardCompensationDocument = <ThrowOnError extends boolean = false>(options: Options<CharityBoardConfirmBoardCompensationDocumentData, ThrowOnError>): RequestResult<CharityBoardConfirmBoardCompensationDocumentResponses, CharityBoardConfirmBoardCompensationDocumentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardConfirmBoardCompensationDocumentResponses, CharityBoardConfirmBoardCompensationDocumentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/compensation-decisions/{decision_id}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issue Board Compensation Document Upload Url
 *
 * A short-lived signed URL to upload one document the board relied on, onto a consent
 * decision, bound to its file type. Nothing is recorded until the upload is confirmed.
 */
export const charityBoardIssueBoardCompensationDocumentUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CharityBoardIssueBoardCompensationDocumentUploadUrlData, ThrowOnError>): RequestResult<CharityBoardIssueBoardCompensationDocumentUploadUrlResponses, CharityBoardIssueBoardCompensationDocumentUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardIssueBoardCompensationDocumentUploadUrlResponses, CharityBoardIssueBoardCompensationDocumentUploadUrlErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/compensation-decisions/{decision_id}/documents/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Board Compensation Document
 *
 * Remove one of a consent decision's documents, while the consent is a draft.
 */
export const charityBoardRemoveBoardCompensationDocument = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRemoveBoardCompensationDocumentData, ThrowOnError>): RequestResult<CharityBoardRemoveBoardCompensationDocumentResponses, CharityBoardRemoveBoardCompensationDocumentErrors, ThrowOnError> => (options.client ?? client).delete<CharityBoardRemoveBoardCompensationDocumentResponses, CharityBoardRemoveBoardCompensationDocumentErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/compensation-decisions/{decision_id}/documents/{document_id}', ...options });

/**
 * Get Board Compensation Document Download
 *
 * A short-lived link to read one of a consent decision's documents, made for this request
 * and never stored.
 */
export const charityBoardGetBoardCompensationDocumentDownload = <ThrowOnError extends boolean = false>(options: Options<CharityBoardGetBoardCompensationDocumentDownloadData, ThrowOnError>): RequestResult<CharityBoardGetBoardCompensationDocumentDownloadResponses, CharityBoardGetBoardCompensationDocumentDownloadErrors, ThrowOnError> => (options.client ?? client).get<CharityBoardGetBoardCompensationDocumentDownloadResponses, CharityBoardGetBoardCompensationDocumentDownloadErrors, ThrowOnError>({ url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/compensation-decisions/{decision_id}/documents/{document_id}/download', ...options });

/**
 * Record Board Consent Revocation
 *
 * Withdraw an assent recorded on a director's behalf.
 *
 * Appended as its own act with its own note, never an edit of the entry it withdraws —
 * the signature log is only ever added to.
 */
export const charityBoardRecordBoardConsentRevocation = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardConsentRevocationData, ThrowOnError>): RequestResult<CharityBoardRecordBoardConsentRevocationResponses, CharityBoardRecordBoardConsentRevocationErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardConsentRevocationResponses, CharityBoardRecordBoardConsentRevocationErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/recorded-signature-withdrawals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Board Consent Signature
 *
 * Record a director's assent on their behalf.
 *
 * The path a board actually needs: a director who signed on paper, or who will not use
 * the portal at all, is not thereby unable to act. The entry is labelled as one the
 * officer made, carries the officer's own identity, and requires a note saying where
 * the assent came from. It completes a consent exactly as a director's own signature
 * does.
 */
export const charityBoardRecordBoardConsentSignature = <ThrowOnError extends boolean = false>(options: Options<CharityBoardRecordBoardConsentSignatureData, ThrowOnError>): RequestResult<CharityBoardRecordBoardConsentSignatureResponses, CharityBoardRecordBoardConsentSignatureErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardRecordBoardConsentSignatureResponses, CharityBoardRecordBoardConsentSignatureErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/recorded-signatures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revise Board Written Consent
 *
 * Revise a consent that is before the board.
 *
 * The new text goes out as a new version to a freshly recorded roster, and **every
 * signature already given starts again** — a director who signed the earlier text has
 * not signed this one. The earlier version keeps its own signatures as history.
 */
export const charityBoardReviseBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<CharityBoardReviseBoardWrittenConsentData, ThrowOnError>): RequestResult<CharityBoardReviseBoardWrittenConsentResponses, CharityBoardReviseBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardReviseBoardWrittenConsentResponses, CharityBoardReviseBoardWrittenConsentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/revision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw Board Written Consent
 *
 * Stop a consent before every seat has signed, with a recorded reason.
 *
 * The consent and its signatures stay: how the board arrived at whatever it did
 * instead is part of the charity's own history.
 */
export const charityBoardWithdrawBoardWrittenConsent = <ThrowOnError extends boolean = false>(options: Options<CharityBoardWithdrawBoardWrittenConsentData, ThrowOnError>): RequestResult<CharityBoardWithdrawBoardWrittenConsentResponses, CharityBoardWithdrawBoardWrittenConsentErrors, ThrowOnError> => (options.client ?? client).post<CharityBoardWithdrawBoardWrittenConsentResponses, CharityBoardWithdrawBoardWrittenConsentErrors, ThrowOnError>({
    url: '/charity-admin/board/charities/{charity_id}/written-consents/{consent_id}/withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Charity Admins
 */
export const charityAdminListCharityAdmins = <ThrowOnError extends boolean = false>(options: Options<CharityAdminListCharityAdminsData, ThrowOnError>): RequestResult<CharityAdminListCharityAdminsResponses, CharityAdminListCharityAdminsErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminListCharityAdminsResponses, CharityAdminListCharityAdminsErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/admins', ...options });

/**
 * Add Charity Admin
 */
export const charityAdminAddCharityAdmin = <ThrowOnError extends boolean = false>(options: Options<CharityAdminAddCharityAdminData, ThrowOnError>): RequestResult<CharityAdminAddCharityAdminResponses, CharityAdminAddCharityAdminErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminAddCharityAdminResponses, CharityAdminAddCharityAdminErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Charity Admin
 */
export const charityAdminRemoveCharityAdmin = <ThrowOnError extends boolean = false>(options: Options<CharityAdminRemoveCharityAdminData, ThrowOnError>): RequestResult<CharityAdminRemoveCharityAdminResponses, CharityAdminRemoveCharityAdminErrors, ThrowOnError> => (options.client ?? client).delete<CharityAdminRemoveCharityAdminResponses, CharityAdminRemoveCharityAdminErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/admins/{user_id}', ...options });

/**
 * Update Charity Admin Role
 */
export const charityAdminUpdateCharityAdminRole = <ThrowOnError extends boolean = false>(options: Options<CharityAdminUpdateCharityAdminRoleData, ThrowOnError>): RequestResult<CharityAdminUpdateCharityAdminRoleResponses, CharityAdminUpdateCharityAdminRoleErrors, ThrowOnError> => (options.client ?? client).patch<CharityAdminUpdateCharityAdminRoleResponses, CharityAdminUpdateCharityAdminRoleErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/admins/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Crm Retention
 *
 * THIS charity's donor retention grouped by FIRST-DONATION YEAR: per group,
 * how many of those donors gave again in each later year through the latest year
 * with data (zero years included — an honest decay curve). Anonymous counts
 * only. 404 when the CRM flag is off; scoped to the caller's membership.
 */
export const charityAdminGetCrmRetention = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetCrmRetentionData, ThrowOnError>): RequestResult<CharityAdminGetCrmRetentionResponses, CharityAdminGetCrmRetentionErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetCrmRetentionResponses, CharityAdminGetCrmRetentionErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/analytics/retention', ...options });

/**
 * Get Crm Analytics Summary
 *
 * THIS charity's lifetime + per-year donation analytics: counts, gross/net
 * sums, distinct/new/returning donor counts, recurring-donor counts, and the
 * first/last gift dates. Aggregate only — no donor identity — so it is available
 * to a claimed charity that has not yet accepted the donor-data terms. The
 * numbers tie to the §321 dashboard exactly. 404 when the CRM flag is off; scoped
 * to the caller's membership.
 */
export const charityAdminGetCrmAnalyticsSummary = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetCrmAnalyticsSummaryData, ThrowOnError>): RequestResult<CharityAdminGetCrmAnalyticsSummaryResponses, CharityAdminGetCrmAnalyticsSummaryErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetCrmAnalyticsSummaryResponses, CharityAdminGetCrmAnalyticsSummaryErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/analytics/summary', ...options });

/**
 * Export Crm Analytics Csv
 *
 * CSV export of THIS charity's per-year analytics (one row per year). Built
 * from the same pipeline as the JSON summary, so the two can never disagree. 404 when the CRM flag is off; scoped to the caller's membership.
 */
export const charityAdminExportCrmAnalyticsCsv = <ThrowOnError extends boolean = false>(options: Options<CharityAdminExportCrmAnalyticsCsvData, ThrowOnError>): RequestResult<CharityAdminExportCrmAnalyticsCsvResponses, CharityAdminExportCrmAnalyticsCsvErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminExportCrmAnalyticsCsvResponses, CharityAdminExportCrmAnalyticsCsvErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/analytics/yearly.csv', ...options });

/**
 * Submit Charity Claim
 *
 * Submit a claim for a charity, then run the Tier-1 auto-verify engine.
 *
 * The claimant's VERIFIED email is read from the Firebase ID token
 * (``request.state.idp_user`` — the ``email`` whose ``email_verified`` claim
 * applies), NEVER from the request body: the verified-email domain is conjunct
 * (a) of the SAFETY-CRITICAL Tier-1 conjunction, so it must be the authenticated
 * claim, not a client-asserted value. The result's ``outcome`` discriminates
 * AUTO_VERIFIED (claim approved in this call) / PENDING_REVIEW (Tier-2 queue) /
 * CANNOT_CLAIM (deactivated/screened dead-end). Returns 200 in all three cases —
 * a Tier-2 route and a cannot-claim dead-end are valid outcomes, not errors.
 */
export const charityAdminSubmitCharityClaim = <ThrowOnError extends boolean = false>(options: Options<CharityAdminSubmitCharityClaimData, ThrowOnError>): RequestResult<CharityAdminSubmitCharityClaimResponses, CharityAdminSubmitCharityClaimErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminSubmitCharityClaimResponses, CharityAdminSubmitCharityClaimErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Charity Terms For Claim
 *
 * The CURRENT effective Charity Terms for a charity the caller is about to
 * CLAIM: the canonical body with that organization's legal name / EIN /
 * registered domain substituted, plus the ``version_number`` + CANONICAL
 * (pre-substitution) ``content_hash`` to echo on the claim submit.
 *
 * Signed in, and that is the whole authorization — **no membership**, because a
 * claimant has none until their claim is approved. Byte-identical response shape
 * to ``GET /charity-admin/charities/{charity_id}/terms`` (the same
 * ``CharityTermsOut``, the same projection), so a client that already decodes
 * the portal's terms read needs no second decoder.
 *
 * ``content_hash`` is a RECORD, not display copy: it exists so the acceptance
 * row pins exactly the bytes that were shown. Echo it; never render it.
 *
 * 404 when no effective version exists. Serves normally for a charity with no
 * EIN on file (the body renders "not on file") — only the submit refuses that
 * case, with its own 409.
 *
 * ⚠ It ALSO serves normally for a TERMINALLY-REMOVED charity, which the consumer
 * ``GET /charities/{id}`` refuses as not-found — a known, bounded, test-pinned
 * disclosure of that organization's legal name / EIN / registered domain. The
 * reasoning, the bound (the claim funnel's own search cannot reach such a
 * charity, so a caller must already hold its UUID) and what would change it are
 * recorded in full on ``CharityTermsService.get_current_terms_for_claim``; read
 * that before adding a second no-membership door on this prefix.
 */
export const charityAdminGetCharityTermsForClaim = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetCharityTermsForClaimData, ThrowOnError>): RequestResult<CharityAdminGetCharityTermsForClaimResponses, CharityAdminGetCharityTermsForClaimErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetCharityTermsForClaimResponses, CharityAdminGetCharityTermsForClaimErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/claim/terms', ...options });

/**
 * List Crm Donors
 *
 * THIS charity's consented, sharing donors with their CRM tags and recurring
 * flag. Donor identity appears ONLY when the charity holds an operative Charity
 * Terms acceptance AND the specific donation carries the share flag; otherwise
 * an honest, PII-free empty state. 404 when the CRM flag is off; scoped to the
 * caller's membership.
 */
export const charityAdminListCrmDonors = <ThrowOnError extends boolean = false>(options: Options<CharityAdminListCrmDonorsData, ThrowOnError>): RequestResult<CharityAdminListCrmDonorsResponses, CharityAdminListCrmDonorsErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminListCrmDonorsResponses, CharityAdminListCrmDonorsErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/crm/donors', ...options });

/**
 * Export Crm Donors Csv
 *
 * CSV of the CRM donor list. SAME gate as the JSON read — a charity without
 * an operative acceptance gets a HEADER-ONLY CSV (no donor PII, never an
 * error). 404 when the CRM flag is off; scoped to the caller's membership.
 */
export const charityAdminExportCrmDonorsCsv = <ThrowOnError extends boolean = false>(options: Options<CharityAdminExportCrmDonorsCsvData, ThrowOnError>): RequestResult<CharityAdminExportCrmDonorsCsvResponses, CharityAdminExportCrmDonorsCsvErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminExportCrmDonorsCsvResponses, CharityAdminExportCrmDonorsCsvErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/crm/donors.csv', ...options });

/**
 * Get Crm Donor
 *
 * One donor's CRM record: rollup + per-donation lines + notes (newest
 * first). A gate-closed charity, a donor who never shared, and a donor who does
 * not exist all resolve to the SAME not-found failure — no existence oracle —
 * which surfaces as 400, not 404 (``CharityNotFoundException`` is a
 * ``ValidationException`` fallthrough). 404 is reserved for the flag gate:
 * the CRM flag off and the route does not exist. Scoped to the caller's
 * membership.
 */
export const charityAdminGetCrmDonor = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetCrmDonorData, ThrowOnError>): RequestResult<CharityAdminGetCrmDonorResponses, CharityAdminGetCrmDonorErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetCrmDonorResponses, CharityAdminGetCrmDonorErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/crm/donors/{donor_user_id}', ...options });

/**
 * Create Crm Donor Note
 *
 * Append a timestamped note to a qualifying donor's CRM record.
 */
export const charityAdminCreateCrmDonorNote = <ThrowOnError extends boolean = false>(options: Options<CharityAdminCreateCrmDonorNoteData, ThrowOnError>): RequestResult<CharityAdminCreateCrmDonorNoteResponses, CharityAdminCreateCrmDonorNoteErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminCreateCrmDonorNoteResponses, CharityAdminCreateCrmDonorNoteErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/crm/donors/{donor_user_id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Crm Donor Note
 *
 * Delete one note of this charity, on this donor.
 */
export const charityAdminDeleteCrmDonorNote = <ThrowOnError extends boolean = false>(options: Options<CharityAdminDeleteCrmDonorNoteData, ThrowOnError>): RequestResult<CharityAdminDeleteCrmDonorNoteResponses, CharityAdminDeleteCrmDonorNoteErrors, ThrowOnError> => (options.client ?? client).delete<CharityAdminDeleteCrmDonorNoteResponses, CharityAdminDeleteCrmDonorNoteErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/crm/donors/{donor_user_id}/notes/{note_id}', ...options });

/**
 * Update Crm Donor Note
 *
 * Rewrite one note's body. A note belonging to another charity or another
 * donor resolves to not-found.
 */
export const charityAdminUpdateCrmDonorNote = <ThrowOnError extends boolean = false>(options: Options<CharityAdminUpdateCrmDonorNoteData, ThrowOnError>): RequestResult<CharityAdminUpdateCrmDonorNoteResponses, CharityAdminUpdateCrmDonorNoteErrors, ThrowOnError> => (options.client ?? client).patch<CharityAdminUpdateCrmDonorNoteResponses, CharityAdminUpdateCrmDonorNoteErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/crm/donors/{donor_user_id}/notes/{note_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Crm Donor Tag
 *
 * Attach a tag to a qualifying donor and return the donor with its updated
 * tags. A case-insensitive duplicate is a 409. 404 when the CRM flag is off.
 */
export const charityAdminAddCrmDonorTag = <ThrowOnError extends boolean = false>(options: Options<CharityAdminAddCrmDonorTagData, ThrowOnError>): RequestResult<CharityAdminAddCrmDonorTagResponses, CharityAdminAddCrmDonorTagErrors, ThrowOnError> => (options.client ?? client).put<CharityAdminAddCrmDonorTagResponses, CharityAdminAddCrmDonorTagErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/crm/donors/{donor_user_id}/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Crm Donor Tag
 *
 * Detach a tag (case-insensitive) from a qualifying donor. 404 when the CRM flag is off; a donor or tag that does not qualify is a not-found FAILURE that
 * surfaces as 400 (``CharityNotFoundException`` is a ``ValidationException``
 * fallthrough, not a registered 404).
 */
export const charityAdminRemoveCrmDonorTag = <ThrowOnError extends boolean = false>(options: Options<CharityAdminRemoveCrmDonorTagData, ThrowOnError>): RequestResult<CharityAdminRemoveCrmDonorTagResponses, CharityAdminRemoveCrmDonorTagErrors, ThrowOnError> => (options.client ?? client).delete<CharityAdminRemoveCrmDonorTagResponses, CharityAdminRemoveCrmDonorTagErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/crm/donors/{donor_user_id}/tags/{label}', ...options });

/**
 * List Crm Imported Contacts
 *
 * THIS charity's own imported contacts. ``q`` searches display name / email
 * WITHIN this charity's rows only — never a lookup against Givmo identity, and
 * these records are never matched or combined with donor accounts. Reads stay
 * available even when the terms gate is closed (it is the charity's own data).
 * 404 when the CRM flag is off; scoped to the caller's membership.
 */
export const charityAdminListCrmImportedContacts = <ThrowOnError extends boolean = false>(options: Options<CharityAdminListCrmImportedContactsData, ThrowOnError>): RequestResult<CharityAdminListCrmImportedContactsResponses, CharityAdminListCrmImportedContactsErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminListCrmImportedContactsResponses, CharityAdminListCrmImportedContactsErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/crm/imported-contacts', ...options });

/**
 * Create Crm Imported Contact
 *
 * Add one charity-supplied contact. Requires an operative Charity Terms
 * acceptance (409 otherwise — the charity processes its own uploaded records
 * under the terms it accepted). ``source`` is server-stamped 'manual'.
 */
export const charityAdminCreateCrmImportedContact = <ThrowOnError extends boolean = false>(options: Options<CharityAdminCreateCrmImportedContactData, ThrowOnError>): RequestResult<CharityAdminCreateCrmImportedContactResponses, CharityAdminCreateCrmImportedContactErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminCreateCrmImportedContactResponses, CharityAdminCreateCrmImportedContactErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/crm/imported-contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Crm Imported Contacts Csv
 *
 * CSV of the charity's imported contacts. Carries NO donation or identity
 * column — there is nothing to join.
 */
export const charityAdminExportCrmImportedContactsCsv = <ThrowOnError extends boolean = false>(options: Options<CharityAdminExportCrmImportedContactsCsvData, ThrowOnError>): RequestResult<CharityAdminExportCrmImportedContactsCsvResponses, CharityAdminExportCrmImportedContactsCsvErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminExportCrmImportedContactsCsvResponses, CharityAdminExportCrmImportedContactsCsvErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/crm/imported-contacts.csv', ...options });

/**
 * Delete Crm Imported Contact
 *
 * Delete one contact of THIS charity. Deliberately NOT terms-gated —
 * removing your own uploaded data is never blocked by a lapsed acceptance.
 */
export const charityAdminDeleteCrmImportedContact = <ThrowOnError extends boolean = false>(options: Options<CharityAdminDeleteCrmImportedContactData, ThrowOnError>): RequestResult<CharityAdminDeleteCrmImportedContactResponses, CharityAdminDeleteCrmImportedContactErrors, ThrowOnError> => (options.client ?? client).delete<CharityAdminDeleteCrmImportedContactResponses, CharityAdminDeleteCrmImportedContactErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/crm/imported-contacts/{contact_id}', ...options });

/**
 * Update Crm Imported Contact
 *
 * Patch one contact — absent ≠ null, so an omitted field is left alone.
 * Requires an operative Charity Terms acceptance (409 otherwise).
 */
export const charityAdminUpdateCrmImportedContact = <ThrowOnError extends boolean = false>(options: Options<CharityAdminUpdateCrmImportedContactData, ThrowOnError>): RequestResult<CharityAdminUpdateCrmImportedContactResponses, CharityAdminUpdateCrmImportedContactErrors, ThrowOnError> => (options.client ?? client).patch<CharityAdminUpdateCrmImportedContactResponses, CharityAdminUpdateCrmImportedContactErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/crm/imported-contacts/{contact_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Charity Display Name
 *
 * Go back to the charity's catalog name — OWNER-only: the live display name ends and a
 * request waiting for review is withdrawn. Idempotent. Served whatever
 * ``CHARITY_DISPLAY_NAME_ENABLED`` says, so a charity can always end one; the returned block
 * is null while the flag is off. The console ends a live name by saving the catalog name
 * through the PUT instead, and withdraws a request alone through ``…/display-name/request``.
 */
export const charityAdminClearCharityDisplayName = <ThrowOnError extends boolean = false>(options: Options<CharityAdminClearCharityDisplayNameData, ThrowOnError>): RequestResult<CharityAdminClearCharityDisplayNameResponses, CharityAdminClearCharityDisplayNameErrors, ThrowOnError> => (options.client ?? client).delete<CharityAdminClearCharityDisplayNameResponses, CharityAdminClearCharityDisplayNameErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/display-name', ...options });

/**
 * Set Charity Display Name
 *
 * Set the charity's display name, the name donors see on Givmo — OWNER-only
 * (``charity_profile:write``), and only while the charity is claimed, has accepted the
 * Charity Terms, has its IRS legal name on file and is listed. The name is checked against
 * other organizations' names first: a clear name goes live at once; a name close to
 * another organization's answers 409 ``CHARITY_DISPLAY_NAME_NEEDS_REVIEW`` with what it is
 * close to, and with ``submit_for_review`` true waits for Givmo's review instead; another
 * organization's name answers 422 ``CHARITY_DISPLAY_NAME_REFUSED``; a charity that cannot
 * carry one now answers 409 ``CHARITY_DISPLAY_NAME_NOT_AVAILABLE``. Every refusal's
 * ``detail`` is a sentence to show as it is. The catalog name sent while a display name is
 * live ends the display name and withdraws a request waiting beside it, even for a charity
 * that can no longer carry one. Returns the ``display_name`` block. Dark behind
 * ``CHARITY_DISPLAY_NAME_ENABLED`` (the absent-route 404).
 */
export const charityAdminSetCharityDisplayName = <ThrowOnError extends boolean = false>(options: Options<CharityAdminSetCharityDisplayNameData, ThrowOnError>): RequestResult<CharityAdminSetCharityDisplayNameResponses, CharityAdminSetCharityDisplayNameErrors, ThrowOnError> => (options.client ?? client).put<CharityAdminSetCharityDisplayNameResponses, CharityAdminSetCharityDisplayNameErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/display-name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw Charity Display Name Request
 *
 * Withdraw the request waiting for Givmo's review and nothing else (CPA-BE65) — OWNER-only:
 * a live display name stays as it is. 409 ``CHARITY_DISPLAY_NAME_NOT_AVAILABLE`` with a
 * sentence when no request is waiting. Returns the ``display_name`` block (null while the flag
 * is off). Served whatever ``CHARITY_DISPLAY_NAME_ENABLED`` says, as the DELETE above is: the
 * flag gates only the writes that grow exposure, and its definition keeps every act that ends
 * or withdraws one served "so exposure can always shrink".
 */
export const charityAdminWithdrawCharityDisplayNameRequest = <ThrowOnError extends boolean = false>(options: Options<CharityAdminWithdrawCharityDisplayNameRequestData, ThrowOnError>): RequestResult<CharityAdminWithdrawCharityDisplayNameRequestResponses, CharityAdminWithdrawCharityDisplayNameRequestErrors, ThrowOnError> => (options.client ?? client).delete<CharityAdminWithdrawCharityDisplayNameRequestResponses, CharityAdminWithdrawCharityDisplayNameRequestErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/display-name/request', ...options });

/**
 * Get Charity Follower Count
 *
 * CPB-BE15 (D-CP-27) — the AGGREGATE follower count for THIS charity: an
 * integer, never identities (invariant 2 — no wire anywhere carries follower
 * identities to a charity). Owner or Member (`charity:read`). 404 when the follows flag is off; scoped to the caller's membership.
 */
export const charityAdminGetCharityFollowerCount = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetCharityFollowerCountData, ThrowOnError>): RequestResult<CharityAdminGetCharityFollowerCountResponses, CharityAdminGetCharityFollowerCountErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetCharityFollowerCountResponses, CharityAdminGetCharityFollowerCountErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/follower-count', ...options });

/**
 * List Charity Invites
 *
 * List a charity's PENDING invites (newest first). **Owner-only**. NEVER
 * carries a token or its hash.
 */
export const charityAdminListCharityInvites = <ThrowOnError extends boolean = false>(options: Options<CharityAdminListCharityInvitesData, ThrowOnError>): RequestResult<CharityAdminListCharityInvitesResponses, CharityAdminListCharityInvitesErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminListCharityInvitesResponses, CharityAdminListCharityInvitesErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/invites', ...options });

/**
 * Create Charity Invite
 *
 * Owner invites a colleague to a charity by email + role → mint a single-use,
 * email-bound, expiring invite token + record. **Owner-only** (the service's
 * ``@has_charity_permission("charity_admin:add")`` — a Member is 403'd). The
 * plaintext token is the CPA-BE11 email hand-off and is NEVER returned on the
 * wire (``CharityInviteOut`` omits it). If the invited email already administers
 * the charity, no token is minted — the existing invite/membership stands and
 * the response echoes the (no-op) state.
 */
export const charityAdminCreateCharityInvite = <ThrowOnError extends boolean = false>(options: Options<CharityAdminCreateCharityInviteData, ThrowOnError>): RequestResult<CharityAdminCreateCharityInviteResponses, CharityAdminCreateCharityInviteErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminCreateCharityInviteResponses, CharityAdminCreateCharityInviteErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Charity Invite
 *
 * Revoke a PENDING invite (**Owner-only**). The invite must belong to the
 * scoped charity (a cross-charity id → 404).
 */
export const charityAdminRevokeCharityInvite = <ThrowOnError extends boolean = false>(options: Options<CharityAdminRevokeCharityInviteData, ThrowOnError>): RequestResult<CharityAdminRevokeCharityInviteResponses, CharityAdminRevokeCharityInviteErrors, ThrowOnError> => (options.client ?? client).delete<CharityAdminRevokeCharityInviteResponses, CharityAdminRevokeCharityInviteErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/invites/{invite_id}', ...options });

/**
 * Get Charity Page
 *
 * The charity's OWNER view of its page: every block, unlisted ones included
 * with their takedown state (``profile:read`` — every admin of the org).
 */
export const charityAdminProfilePageGetCharityPage = <ThrowOnError extends boolean = false>(options: Options<CharityAdminProfilePageGetCharityPageData, ThrowOnError>): RequestResult<CharityAdminProfilePageGetCharityPageResponses, CharityAdminProfilePageGetCharityPageErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminProfilePageGetCharityPageResponses, CharityAdminProfilePageGetCharityPageErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/page', ...options });

/**
 * Replace Charity Page
 *
 * The id-preserving full-list replace (``profile:write`` — a Global Admin or
 * any Owner-tier module grant holder, D-PE-14 — behind the three-conjunct
 * Charity Terms gate).
 */
export const charityAdminProfilePageReplaceCharityPage = <ThrowOnError extends boolean = false>(options: Options<CharityAdminProfilePageReplaceCharityPageData, ThrowOnError>): RequestResult<CharityAdminProfilePageReplaceCharityPageResponses, CharityAdminProfilePageReplaceCharityPageErrors, ThrowOnError> => (options.client ?? client).put<CharityAdminProfilePageReplaceCharityPageResponses, CharityAdminProfilePageReplaceCharityPageErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/page',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Charity Page Image
 *
 * Upload one page image (sniff-validated; stored as a private object KEY under
 * ``charity/{EIN}/page/…``; signed on read). A charity with no EIN on file 409s.
 */
export const charityAdminProfilePageUploadCharityPageImage = <ThrowOnError extends boolean = false>(options: Options<CharityAdminProfilePageUploadCharityPageImageData, ThrowOnError>): RequestResult<CharityAdminProfilePageUploadCharityPageImageResponses, CharityAdminProfilePageUploadCharityPageImageErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminProfilePageUploadCharityPageImageResponses, CharityAdminProfilePageUploadCharityPageImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/charity-admin/charities/{charity_id}/page/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Charity Payment Events
 *
 * The charity's append-only payment audit history (create/change/verify/flag),
 * newest first. Vocabulary-clean; carries NO bank data. permission-scoped to the caller's membership.
 */
export const charityAdminListCharityPaymentEvents = <ThrowOnError extends boolean = false>(options: Options<CharityAdminListCharityPaymentEventsData, ThrowOnError>): RequestResult<CharityAdminListCharityPaymentEventsResponses, CharityAdminListCharityPaymentEventsErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminListCharityPaymentEventsResponses, CharityAdminListCharityPaymentEventsErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/payment-events', ...options });

/**
 * Get Charity Payment Profile
 *
 * The charity's CURRENT (active) MASKED payment profile, or a null profile
 * (clean empty state) when it has never set one. NEVER returns full bank numbers.
 * ``check_address`` is populated (read-only IRS address) when the active election
 * is CHECK. permission-scoped to the caller's
 * membership for this charity.
 */
export const charityAdminGetCharityPaymentProfile = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetCharityPaymentProfileData, ThrowOnError>): RequestResult<CharityAdminGetCharityPaymentProfileResponses, CharityAdminGetCharityPaymentProfileErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetCharityPaymentProfileResponses, CharityAdminGetCharityPaymentProfileErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/payment-profile', ...options });

/**
 * Submit Charity Ach
 *
 * Enter ACH bank details into the vault for THIS charity (OWNER-only).
 *
 * The routing/account numbers are WRITE-ONLY: they are validated, KMS-encrypted
 * into the vault, and NEVER echoed back — the response is a MASKED confirmation
 * (last-4 + status). If the account-holder name doesn't match the charity's legal
 * name the profile is saved FLAGGED for human review and never auto-bound (rail
 * §3.4) — still a 201 (saved), with an honest ``flagged``/message. OWNER-scoped to this charity.
 */
export const charityAdminSubmitCharityAch = <ThrowOnError extends boolean = false>(options: Options<CharityAdminSubmitCharityAchData, ThrowOnError>): RequestResult<CharityAdminSubmitCharityAchResponses, CharityAdminSubmitCharityAchErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminSubmitCharityAchResponses, CharityAdminSubmitCharityAchErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/payment-profile/ach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elect Charity Check
 *
 * Elect the mailed-CHECK rail for THIS charity (OWNER-only). The request body
 * carries NO address — the mailing address is ALWAYS the IRS address on file,
 * returned read-only in ``check_address``. OWNER-scoped to this charity.
 */
export const charityAdminElectCharityCheck = <ThrowOnError extends boolean = false>(options: Options<CharityAdminElectCharityCheckData, ThrowOnError>): RequestResult<CharityAdminElectCharityCheckResponses, CharityAdminElectCharityCheckErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminElectCharityCheckResponses, CharityAdminElectCharityCheckErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/payment-profile/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Charity Check Address
 *
 * The READ-ONLY IRS address a mailed check would go to (from the IRS record on
 * file), so the check-election UI can show it BEFORE electing. A user-typed
 * address is never accepted anywhere.
 */
export const charityAdminGetCharityCheckAddress = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetCharityCheckAddressData, ThrowOnError>): RequestResult<CharityAdminGetCharityCheckAddressResponses, CharityAdminGetCharityCheckAddressErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetCharityCheckAddressResponses, CharityAdminGetCharityCheckAddressErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/payment-profile/check-address', ...options });

/**
 * Get Charity Profile
 *
 * The charity's editable public profile (mission / contact / logo / the
 * organization domain) plus per-field PROVENANCE (which values were charity-entered
 * vs machine-sourced). ``organization_domain`` is the verification trust anchor AND
 * the charity's website, returned as the normalized eTLD+1 — a console renders
 * ``https://`` + it. readable by Owner or Member (``charity:read``).
 */
export const charityAdminGetCharityProfile = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetCharityProfileData, ThrowOnError>): RequestResult<CharityAdminGetCharityProfileResponses, CharityAdminGetCharityProfileErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetCharityProfileResponses, CharityAdminGetCharityProfileErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/profile', ...options });

/**
 * Update Charity Profile
 *
 * Edit the charity's profile (mission / contact / the organization domain) —
 * OWNER-only. PATCH semantics: only the fields present in the body change (absent =
 * unchanged; null = cleared). Every human edit of a provenance-tracked field records
 * a ``human`` provenance row (sacred — never overwritten by ETL).
 *
 * ``organization_domain`` is the charity's WEBSITE and its verification trust anchor
 * at once (D-CP-73), editable here since CPA-BE20: send the website URL (or a
 * hostname) and the stored value is its eTLD+1. It cannot be cleared, it 422s when
 * the charity's claim is not approved, it 409s when that claim no longer stands or
 * when another active charity already holds that domain, and a successful change
 * alerts EVERY admin of the org. OWNER-scoped to this charity.
 */
export const charityAdminUpdateCharityProfile = <ThrowOnError extends boolean = false>(options: Options<CharityAdminUpdateCharityProfileData, ThrowOnError>): RequestResult<CharityAdminUpdateCharityProfileResponses, CharityAdminUpdateCharityProfileErrors, ThrowOnError> => (options.client ?? client).patch<CharityAdminUpdateCharityProfileResponses, CharityAdminUpdateCharityProfileErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Charity Profile Logo
 *
 * Upload/replace the charity's logo image — OWNER-only. Reuses the EXISTING
 * charity-logo GCS path (EIN-keyed public bucket); the ``logo_url`` is computed off
 * the EIN (never a stored column), and a ``logo`` ``human`` provenance row is
 * recorded. OWNER-scoped to this charity.
 */
export const charityAdminUploadCharityProfileLogo = <ThrowOnError extends boolean = false>(options: Options<CharityAdminUploadCharityProfileLogoData, ThrowOnError>): RequestResult<CharityAdminUploadCharityProfileLogoResponses, CharityAdminUploadCharityProfileLogoErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminUploadCharityProfileLogoResponses, CharityAdminUploadCharityProfileLogoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/charity-admin/charities/{charity_id}/profile/logo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Request Charity Removal
 *
 * Request removal of THIS charity from the platform (OWNER-only). Records the
 * required ``written_request_reason`` (the "support for written requests" note) and
 * starts the 3-business-day identity-verify SLA; a super-admin then verifies +
 * processes the removal. Idempotent — a second request while one is already in
 * progress returns 409. OWNER-scoped to this
 * charity.
 */
export const charityAdminRequestCharityRemoval = <ThrowOnError extends boolean = false>(options: Options<CharityAdminRequestCharityRemovalData, ThrowOnError>): RequestResult<CharityAdminRequestCharityRemovalResponses, CharityAdminRequestCharityRemovalErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminRequestCharityRemovalResponses, CharityAdminRequestCharityRemovalErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/removal-request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Charity Removal Requests
 *
 * The removal-request history for THIS charity (newest first), with each
 * request's SLA deadlines. Owner or Member (``charity:read``). permission-scoped to the caller's membership for this charity.
 */
export const charityAdminListCharityRemovalRequests = <ThrowOnError extends boolean = false>(options: Options<CharityAdminListCharityRemovalRequestsData, ThrowOnError>): RequestResult<CharityAdminListCharityRemovalRequestsResponses, CharityAdminListCharityRemovalRequestsErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminListCharityRemovalRequestsResponses, CharityAdminListCharityRemovalRequestsErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/removal-requests', ...options });

/**
 * Get Section321 Consenting Donors
 *
 * The consent-gated §321(a)(6) consenting-donor report for THIS charity: donors
 * who chose to share, with name / contact / total-donated + per-donation detail.
 * Donor identity is surfaced ONLY when the charity is CONSENTED (has accepted the
 * donor-data terms); otherwise an honest, PII-free empty state. scoped to the caller's membership.
 */
export const charityAdminGetSection321ConsentingDonors = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetSection321ConsentingDonorsData, ThrowOnError>): RequestResult<CharityAdminGetSection321ConsentingDonorsResponses, CharityAdminGetSection321ConsentingDonorsErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetSection321ConsentingDonorsResponses, CharityAdminGetSection321ConsentingDonorsErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/section321/consenting-donors', ...options });

/**
 * Get Section321 Dashboard
 *
 * The always-available §321 dashboard aggregates for THIS charity: donation
 * count, covered period, gross-before-fees / total-fees / net-after-fees /
 * total-sent / net-pending, plus the platform legal name (from config). Zero-data
 * is an honest empty state, scoped to the caller's membership.
 */
export const charityAdminGetSection321Dashboard = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetSection321DashboardData, ThrowOnError>): RequestResult<CharityAdminGetSection321DashboardResponses, CharityAdminGetSection321DashboardErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetSection321DashboardResponses, CharityAdminGetSection321DashboardErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/section321/dashboard', ...options });

/**
 * List Section321 Fundraisers
 *
 * THIS charity's §321-attributed fundraisers (FCA-BE1): one decorated
 * rollup row per fundraiser whose creator opted IN to charity-facing
 * attribution (D-ATT-2) — name, public URL, image, donor count, gross/net/
 * fee totals, first/last donation dates. NO donor identity here (aggregates
 * only). Canonical {data, meta, links} paginated envelope (`page[limit]`/
 * `page[offset]`, house default/cap) — pagination slices the ALREADY-grouped
 * per-fundraiser rollup rows, never the underlying per-leg rows (grouping
 * must see every leg to tie exactly; see
 * `CharitySection321Service.list_fundraisers`). scoped to the caller's
 * membership.
 */
export const charityAdminListSection321Fundraisers = <ThrowOnError extends boolean = false>(options: Options<CharityAdminListSection321FundraisersData, ThrowOnError>): RequestResult<CharityAdminListSection321FundraisersResponses, CharityAdminListSection321FundraisersErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminListSection321FundraisersResponses, CharityAdminListSection321FundraisersErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/section321/fundraisers', ...options });

/**
 * Get Section321 Fundraiser Detail
 *
 * One attributed fundraiser's §321 detail for THIS charity: its rollup +
 * constituent donation lines. Donor identity per line is revealed ONLY when
 * BOTH the charity's §318-qualifying consent gate is open AND that leg's own
 * `share_with_charities` is set (D-ATT-3) — never a third path. A
 * toggle-off, non-existent, or cross-charity fundraiser id all collapse to
 * the SAME not-found (no existence oracle). scoped to the caller's membership.
 */
export const charityAdminGetSection321FundraiserDetail = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetSection321FundraiserDetailData, ThrowOnError>): RequestResult<CharityAdminGetSection321FundraiserDetailResponses, CharityAdminGetSection321FundraiserDetailErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetSection321FundraiserDetailResponses, CharityAdminGetSection321FundraiserDetailErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/section321/fundraisers/{fundraiser_id}', ...options });

/**
 * Object To Fundraiser Message
 *
 * Object to a fundraiser's creator-message (FCA-BE9). One click — no body
 * required (an optional ``reason`` ≤500 chars may be sent). The fundraiser must be
 * attributed + visible to THIS charity per the §321 read semantics AND carry a
 * non-empty stored message; otherwise the SAME not-found the read raises (no
 * existence oracle) or a 409 when there is no message to object to. Idempotent — a
 * repeat while one objection is OPEN returns the existing one. 404 when the portal
 * flag, the fundraiser-attribution flag, OR the message flag
 * (``FUNDRAISER_CHARITY_MESSAGE_ENABLED``) is off — pre-flip a charity that cannot
 * read any message must not learn one exists via this route; scoped to the caller's
 * membership.
 */
export const charityAdminObjectToFundraiserMessage = <ThrowOnError extends boolean = false>(options: Options<CharityAdminObjectToFundraiserMessageData, ThrowOnError>): RequestResult<CharityAdminObjectToFundraiserMessageResponses, CharityAdminObjectToFundraiserMessageErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminObjectToFundraiserMessageResponses, CharityAdminObjectToFundraiserMessageErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/section321/fundraisers/{fundraiser_id}/message-objection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Section321 Grants
 *
 * THIS charity's grants, each summarized over its constituent donations
 * (gross/fee/net totals + a vocab-clean disclosure status; amount/date/method sent
 * only when truly sent). scoped to the caller's
 * membership.
 */
export const charityAdminListSection321Grants = <ThrowOnError extends boolean = false>(options: Options<CharityAdminListSection321GrantsData, ThrowOnError>): RequestResult<CharityAdminListSection321GrantsResponses, CharityAdminListSection321GrantsErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminListSection321GrantsResponses, CharityAdminListSection321GrantsErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/section321/grants', ...options });

/**
 * Get Section321 Grant Detail
 *
 * One grant's §321 detail: its summary + the constituent donations (per-donation
 * gross/fee/net/sent + designation-instructions ((a)(8))). The grant MUST belong to
 * THIS charity — a cross-charity grant id resolves to not-found (no leak). scoped to the caller's membership.
 */
export const charityAdminGetSection321GrantDetail = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetSection321GrantDetailData, ThrowOnError>): RequestResult<CharityAdminGetSection321GrantDetailResponses, CharityAdminGetSection321GrantDetailErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetSection321GrantDetailResponses, CharityAdminGetSection321GrantDetailErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/section321/grants/{grant_id}', ...options });

/**
 * Get Section321 Statement
 *
 * CPA-BE14 — THE unified §321 statement for THIS charity: the donation set
 * plus every per-dimension aggregate needed to render it grouped by grant, by
 * fundraiser, or by donor. All three groupings are complete partitions of one
 * set, so all three reconcile to the same charity total (and to the dashboard
 * tiles). Every subtotal is computed server-side — the client never sums money.
 *
 * A COMPOSITE STATEMENT RESOURCE, not a paginated list: donation rows plus
 * aggregate blocks keyed by refs (the `/section321/grants/{grant_id}` detail
 * response is the in-repo precedent for the shape). It therefore carries no
 * `{data, meta, links}` envelope and takes no pagination/sort/filter query
 * parameters — group-by, sort, search and filter are client-side lenses over
 * ONE payload, and group subtotals deliberately never recompute under a filter.
 *
 * Donor name/email appear ONLY behind the existing §321(a)(6) conjunction
 * (§318-qualifying Terms acceptance AND the leg's own `share_with_charities`
 * AND the minor-protection backstop) — never a third path; the opaque
 * `donor_ref` grouping key rides the same conjunction so a gated read leaks no
 * linkage either. scoped to the caller's
 * membership. `consent_available` is that conjunction's organization half, as
 * this read resolved it (CPA-BE84). Deliberately NOT gated on the
 * fundraiser-attribution flag: the grant -> donations levels must work
 * regardless, and that flag instead conditions whether an opted-in fundraiser
 * may be NAMED here.
 *
 * Private, non-cacheable: this body carries donor names and emails, and it is a
 * NEW PII-bearing route — the header is set here at its creation rather than
 * inherited from the JSON siblings' (older, unheadered) posture.
 */
export const charityAdminGetSection321Statement = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetSection321StatementData, ThrowOnError>): RequestResult<CharityAdminGetSection321StatementResponses, CharityAdminGetSection321StatementErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetSection321StatementResponses, CharityAdminGetSection321StatementErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/section321/statement', ...options });

/**
 * Export Section321 Statement Workbook
 *
 * CPA-BE15 — THE Grants & donations download for THIS charity: one `.xlsx`
 * with four sheets (Summary · Grants · Donations · Donors), replacing the two
 * CSVs a charity had to download separately and join on a UUID by hand.
 *
 * A BINARY DOWNLOAD, not a list endpoint: it declares its media type explicitly
 * and carries no `{data, meta, links}` envelope, because there is no JSON body to
 * envelope. The canonical-envelope rule governs JSON list responses; this route's
 * response schema is `{type: string, format: binary}`, the same shape the two
 * sibling CSV exports declare.
 *
 * Built from the same unified statement read the screen uses, but **whole-history
 * always** — never the screen's recent-N window. Every sheet's money ties to the
 * ledger to the penny and to the dashboard tiles above the table.
 *
 * Donor name/email appear ONLY behind the existing §321(a)(6) conjunction, and
 * with the gate closed the Donors sheet carries its header plus the same
 * server-authored explanation the screen shows — never a silently empty tab.
 *
 * The filename's date is the generation date **in UTC** — the same instant, and
 * the same zone choice, as the Summary sheet's "Generated on" cell (which names
 * its zone explicitly) and as the grant label BE14 already composes. So a
 * US-Pacific charity downloading at 6pm on Aug 20 gets an Aug 21 filename; the
 * artifact is internally consistent, and the alternative — a server composing a
 * date in an unstated zone — is the thing this surface has ruled out everywhere
 * else.
 *
 * Private, non-cacheable: this body carries donor names and emails. scoped to the caller's membership.
 */
export const charityAdminExportSection321StatementWorkbook = <ThrowOnError extends boolean = false>(options: Options<CharityAdminExportSection321StatementWorkbookData, ThrowOnError>): RequestResult<CharityAdminExportSection321StatementWorkbookResponses, CharityAdminExportSection321StatementWorkbookErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminExportSection321StatementWorkbookResponses, CharityAdminExportSection321StatementWorkbookErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/section321/statement.xlsx', ...options });

/**
 * Get Charity Terms
 *
 * The CURRENT effective Charity Terms for THIS charity: the canonical body
 * with the org's legal name / EIN / registered domain substituted, plus the
 * ``version_number`` + CANONICAL (pre-substitution) ``content_hash`` the client
 * must echo back on acceptance. Owner or Member (``charity:read``). 404 when no effective version exists.
 */
export const charityAdminGetCharityTerms = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetCharityTermsData, ThrowOnError>): RequestResult<CharityAdminGetCharityTermsResponses, CharityAdminGetCharityTermsErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetCharityTermsResponses, CharityAdminGetCharityTermsErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/terms', ...options });

/**
 * Get Charity Terms Acceptance State
 *
 * Whether THIS organization has an operative acceptance of the CURRENT
 * effective Charity Terms (CPA-UIX1 / UIX-02) — the read the portal dashboard's
 * "Terms" onboarding step needs, and the GET counterpart of the POST below.
 * Distinguishes never-accepted / accepted-an-older-version / accepted-the-
 * current-version. ``accepted`` is the §318 seam's own verdict
 * (``is_section_318_consent``), never a bare overlay-status comparison. Owner or
 * Member (``charity:read``) — a Member sees the state even though only an Owner
 * can act on it. Version metadata and timestamps only: never the accepting
 * representative's identity. 404 when no effective version exists.
 */
export const charityAdminGetCharityTermsAcceptanceState = <ThrowOnError extends boolean = false>(options: Options<CharityAdminGetCharityTermsAcceptanceStateData, ThrowOnError>): RequestResult<CharityAdminGetCharityTermsAcceptanceStateResponses, CharityAdminGetCharityTermsAcceptanceStateErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminGetCharityTermsAcceptanceStateResponses, CharityAdminGetCharityTermsAcceptanceStateErrors, ThrowOnError>({ url: '/charity-admin/charities/{charity_id}/terms/acceptance', ...options });

/**
 * Accept Charity Terms
 *
 * Accept the Charity Terms on the organization's behalf (**OWNER-only**,
 * ``charity_terms:accept`` — acceptance binds the org contractually). The body
 * ECHOES the ``version_number`` + ``content_hash`` the client displayed; a
 * mismatch against the current effective version is a 409 (re-fetch and
 * re-present — never accept-anyway). On success the acceptance record + the
 * CONSENTED overlay write + the claim-trail audit event commit atomically;
 * re-accepting the same version is idempotent (appends another record).
 */
export const charityAdminAcceptCharityTerms = <ThrowOnError extends boolean = false>(options: Options<CharityAdminAcceptCharityTermsData, ThrowOnError>): RequestResult<CharityAdminAcceptCharityTermsResponses, CharityAdminAcceptCharityTermsErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminAcceptCharityTermsResponses, CharityAdminAcceptCharityTermsErrors, ThrowOnError>({
    url: '/charity-admin/charities/{charity_id}/terms/acceptance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List My Charity Claims
 *
 * The calling user's own claim requests (newest first). Self-scoped — a
 * caller can only ever see their own claims.
 */
export const charityAdminListMyCharityClaims = <ThrowOnError extends boolean = false>(options?: Options<CharityAdminListMyCharityClaimsData, ThrowOnError>): RequestResult<CharityAdminListMyCharityClaimsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CharityAdminListMyCharityClaimsResponses, unknown, ThrowOnError>({ url: '/charity-admin/claims', ...options });

/**
 * List My Verification Documents
 *
 * The verification documents on the CALLER'S OWN claim (identity + type +
 * status only — never a read URL or the raw object key; the sensitive bytes are
 * super-admin-review-only). Self-scoped.
 */
export const charityAdminListMyVerificationDocuments = <ThrowOnError extends boolean = false>(options: Options<CharityAdminListMyVerificationDocumentsData, ThrowOnError>): RequestResult<CharityAdminListMyVerificationDocumentsResponses, CharityAdminListMyVerificationDocumentsErrors, ThrowOnError> => (options.client ?? client).get<CharityAdminListMyVerificationDocumentsResponses, CharityAdminListMyVerificationDocumentsErrors, ThrowOnError>({ url: '/charity-admin/claims/{claim_request_id}/documents', ...options });

/**
 * Confirm Verification Upload
 *
 * Confirm a completed upload → record the ``charity_verification_document``
 * row + audit. Self-scoped. The service verifies the object exists in the
 * restricted bucket before recording (no dangling evidence ref).
 */
export const charityAdminConfirmVerificationUpload = <ThrowOnError extends boolean = false>(options: Options<CharityAdminConfirmVerificationUploadData, ThrowOnError>): RequestResult<CharityAdminConfirmVerificationUploadResponses, CharityAdminConfirmVerificationUploadErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminConfirmVerificationUploadResponses, CharityAdminConfirmVerificationUploadErrors, ThrowOnError>({
    url: '/charity-admin/claims/{claim_request_id}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Verification Upload Url
 *
 * Issue a short-lived signed UPLOAD URL for a Tier-2 verification document on
 * the CALLER'S OWN ``PENDING_REVIEW`` claim. Self-scoped: the service 404s if
 * the claim is not the caller's, so a user can never attach evidence to another
 * claim. The document bytes go straight to the RESTRICTED bucket via the signed
 * PUT — never through this backend.
 */
export const charityAdminRequestVerificationUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CharityAdminRequestVerificationUploadUrlData, ThrowOnError>): RequestResult<CharityAdminRequestVerificationUploadUrlResponses, CharityAdminRequestVerificationUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminRequestVerificationUploadUrlResponses, CharityAdminRequestVerificationUploadUrlErrors, ThrowOnError>({
    url: '/charity-admin/claims/{claim_request_id}/documents/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Artifacts
 *
 * The documents your organization has recorded, most recent first.
 *
 * `attached_at` is set once a document has been recorded as the confirmation on a
 * filing or against an imported registration. From that point it is part of your
 * organization's filing record and stays there — it cannot be removed, and that does
 * not change if the filing it backed is later withdrawn.
 */
export const charityComplianceListComplianceArtifacts = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceArtifactsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceArtifactsResponses, CharityComplianceListComplianceArtifactsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceArtifactsResponses, CharityComplianceListComplianceArtifactsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/artifacts', ...options });

/**
 * Confirm Compliance Artifact
 *
 * Confirm an upload finished, recording the document in your organization's records.
 *
 * The document has to actually be there: a reference to an upload that did not finish
 * is refused and nothing is recorded. That is what lets the id this returns be used as
 * the confirmation on a filing record — the register never points at a document that
 * is not in your records.
 *
 * A document is recorded once and is never edited afterwards. Uploading a corrected
 * version records a separate document rather than changing this one.
 */
export const charityComplianceConfirmComplianceArtifact = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceConfirmComplianceArtifactData, ThrowOnError>): RequestResult<CharityComplianceConfirmComplianceArtifactResponses, CharityComplianceConfirmComplianceArtifactErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceConfirmComplianceArtifactResponses, CharityComplianceConfirmComplianceArtifactErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/artifacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issue Compliance Artifact Upload Url
 *
 * Get a short-lived link for uploading one document.
 *
 * Upload the file straight to the returned link with a PUT, using exactly the content
 * type you declared here, then confirm it with the object reference this returns.
 * Nothing is recorded until you confirm — the document is not in your records until
 * the upload has finished and you say so.
 *
 * PDFs, Word files and images only. A macro-enabled Word file (.docm) is stored as a
 * .docx with its macros removed; a Word file is always downloaded, never shown inline.
 */
export const charityComplianceIssueComplianceArtifactUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceIssueComplianceArtifactUploadUrlData, ThrowOnError>): RequestResult<CharityComplianceIssueComplianceArtifactUploadUrlResponses, CharityComplianceIssueComplianceArtifactUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceIssueComplianceArtifactUploadUrlResponses, CharityComplianceIssueComplianceArtifactUploadUrlErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/artifacts/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Compliance Artifact
 *
 * Remove a document your organization has not recorded against anything yet.
 *
 * A document that has been recorded as the confirmation on a filing, or against an
 * imported registration, is part of your organization's filing record and cannot be
 * removed. That stays true afterwards: withdrawing the filing, dismissing the
 * obligation, or recording a later submission does not make the document removable
 * again, because the record of what was filed still refers to it.
 */
export const charityComplianceDeleteComplianceArtifact = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceDeleteComplianceArtifactData, ThrowOnError>): RequestResult<CharityComplianceDeleteComplianceArtifactResponses, CharityComplianceDeleteComplianceArtifactErrors, ThrowOnError> => (options.client ?? client).delete<CharityComplianceDeleteComplianceArtifactResponses, CharityComplianceDeleteComplianceArtifactErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/artifacts/{artifact_id}', ...options });

/**
 * Get Compliance Artifact Download
 *
 * A short-lived link for downloading one document.
 *
 * Minted for this request and not stored anywhere: fetch a new one each time rather
 * than keeping the link.
 */
export const charityComplianceGetComplianceArtifactDownload = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceArtifactDownloadData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceArtifactDownloadResponses, CharityComplianceGetComplianceArtifactDownloadErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceArtifactDownloadResponses, CharityComplianceGetComplianceArtifactDownloadErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/artifacts/{artifact_id}/download', ...options });

/**
 * List Compliance Candidates
 *
 * Candidate obligations awaiting the organization's review.
 *
 * Each row carries the jurisdiction's rule, its citation and source date, and the
 * parameters the organization recorded — review each with your counsel. A source date
 * is the day the official source was checked live where `rule_source_date_basis` is
 * `checked_live`, and the day Givmo's research notes recorded the rule where it is
 * `research_notes`. Candidates resting on the nationwide-or-online answer are marked.
 */
export const charityComplianceListComplianceCandidates = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceCandidatesData, ThrowOnError>): RequestResult<CharityComplianceListComplianceCandidatesResponses, CharityComplianceListComplianceCandidatesErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceCandidatesResponses, CharityComplianceListComplianceCandidatesErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/candidates', ...options });

/**
 * Confirm Compliance Candidate
 *
 * Confirm ONE candidate into the organization's register.
 *
 * This route takes exactly one candidate. Confirmation pins the rule version reviewed,
 * and a later change to that rule is flagged for re-review rather than applied.
 */
export const charityComplianceConfirmComplianceCandidate = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceConfirmComplianceCandidateData, ThrowOnError>): RequestResult<CharityComplianceConfirmComplianceCandidateResponses, CharityComplianceConfirmComplianceCandidateErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceConfirmComplianceCandidateResponses, CharityComplianceConfirmComplianceCandidateErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/candidates/{obligation_id}/confirmation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dismiss Compliance Candidate
 *
 * Dismiss ONE candidate, with the organization's reason.
 *
 * The mirror of confirmation — one candidate, the same shape, the same cost. A
 * dismissed candidate returns only if the recorded facts behind it change.
 */
export const charityComplianceDismissComplianceCandidate = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceDismissComplianceCandidateData, ThrowOnError>): RequestResult<CharityComplianceDismissComplianceCandidateResponses, CharityComplianceDismissComplianceCandidateErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceDismissComplianceCandidateResponses, CharityComplianceDismissComplianceCandidateErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/candidates/{obligation_id}/dismissal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run Compliance Derivation
 *
 * Re-derive candidate obligations from the organization's recorded profile.
 *
 * Each candidate pairs one jurisdiction's transcribed rule — with its citation and
 * source date — against the parameters the organization recorded. A candidate is not
 * a determination that the organization is required to register or is eligible for an
 * exemption in any state, and nothing becomes a deadline or a calendar entry until
 * someone at the organization confirms it.
 *
 * Candidates derived from the nationwide-or-online answer are marked and returned
 * first: whether an online presence alone amounts to soliciting in a particular state
 * is treated differently by different states and is not settled, so those are the ones
 * to review with counsel first.
 *
 * Idempotent — an open candidate stays open, a confirmed obligation is untouched, and
 * a dismissal stands unless the recorded facts behind it changed.
 */
export const charityComplianceRunComplianceDerivation = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRunComplianceDerivationData, ThrowOnError>): RequestResult<CharityComplianceRunComplianceDerivationResponses, CharityComplianceRunComplianceDerivationErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRunComplianceDerivationResponses, CharityComplianceRunComplianceDerivationErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/derivation-runs', ...options });

/**
 * Get Compliance Desk Authorization
 */
export const charityComplianceGetComplianceDeskAuthorization = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceDeskAuthorizationData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceDeskAuthorizationResponses, CharityComplianceGetComplianceDeskAuthorizationErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceDeskAuthorizationResponses, CharityComplianceGetComplianceDeskAuthorizationErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/desk-authorization', ...options });

/**
 * Revoke Compliance Desk Authorization
 */
export const charityComplianceRevokeComplianceDeskAuthorization = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRevokeComplianceDeskAuthorizationData, ThrowOnError>): RequestResult<CharityComplianceRevokeComplianceDeskAuthorizationResponses, CharityComplianceRevokeComplianceDeskAuthorizationErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRevokeComplianceDeskAuthorizationResponses, CharityComplianceRevokeComplianceDeskAuthorizationErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/desk-authorization/revoke', ...options });

/**
 * List Compliance Filing Cases
 *
 * The organization's filing cases, oldest first; with `obligation_id`, one filing's.
 *
 * A filing case is one filing the organization is preparing — a filing on its register, for
 * a year or licence period where the filing has them — and holds the documents the filing
 * is made of. Each case says how many documents it holds.
 */
export const charityComplianceListComplianceFilingCases = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceFilingCasesData, ThrowOnError>): RequestResult<CharityComplianceListComplianceFilingCasesResponses, CharityComplianceListComplianceFilingCasesErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceFilingCasesResponses, CharityComplianceListComplianceFilingCasesErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases', ...options });

/**
 * Get Compliance Filing Case
 *
 * One filing case with the documents it holds, in the order they were added.
 *
 * Each document shows its latest version and who added it to the case, and when.
 */
export const charityComplianceGetComplianceFilingCase = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceFilingCaseData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceFilingCaseResponses, CharityComplianceGetComplianceFilingCaseErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceFilingCaseResponses, CharityComplianceGetComplianceFilingCaseErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}', ...options });

/**
 * Get Compliance Filing Case Checklist
 *
 * What goes with the filing: the rule's attachment list, item by item, with the
 * documents attached to each and whether the organization marked it not needed.
 */
export const charityComplianceGetComplianceFilingCaseChecklist = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceFilingCaseChecklistData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceFilingCaseChecklistResponses, CharityComplianceGetComplianceFilingCaseChecklistErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceFilingCaseChecklistResponses, CharityComplianceGetComplianceFilingCaseChecklistErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/checklist', ...options });

/**
 * Record Compliance Checklist Act
 *
 * Remove a document from one checklist item, or mark the item not needed for this
 * filing, or needed after all. An act that changes nothing records nothing.
 */
export const charityComplianceRecordComplianceChecklistAct = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceChecklistActData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceChecklistActResponses, CharityComplianceRecordComplianceChecklistActErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceChecklistActResponses, CharityComplianceRecordComplianceChecklistActErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/checklist/{attachment_index}/acts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach Compliance Checklist Document
 *
 * Attach a PDF from the organization's documents to one checklist item.
 *
 * It goes with the filing as uploaded, never changed. Refused for a PDF protected with
 * encryption, and for anything but a PDF; the document stays in the organization's
 * documents as uploaded.
 */
export const charityComplianceAttachComplianceChecklistDocument = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAttachComplianceChecklistDocumentData, ThrowOnError>): RequestResult<CharityComplianceAttachComplianceChecklistDocumentResponses, CharityComplianceAttachComplianceChecklistDocumentErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAttachComplianceChecklistDocumentResponses, CharityComplianceAttachComplianceChecklistDocumentErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/checklist/{attachment_index}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hand Compliance Filing To Desk
 */
export const charityComplianceHandComplianceFilingToDesk = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceHandComplianceFilingToDeskData, ThrowOnError>): RequestResult<CharityComplianceHandComplianceFilingToDeskResponses, CharityComplianceHandComplianceFilingToDeskErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceHandComplianceFilingToDeskResponses, CharityComplianceHandComplianceFilingToDeskErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/desk', ...options });

/**
 * Resume Compliance Desk
 */
export const charityComplianceResumeComplianceDesk = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceResumeComplianceDeskData, ThrowOnError>): RequestResult<CharityComplianceResumeComplianceDeskResponses, CharityComplianceResumeComplianceDeskErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceResumeComplianceDeskResponses, CharityComplianceResumeComplianceDeskErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/desk/resume', ...options });

/**
 * Take Compliance Filing From Desk
 */
export const charityComplianceTakeComplianceFilingFromDesk = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceTakeComplianceFilingFromDeskData, ThrowOnError>): RequestResult<CharityComplianceTakeComplianceFilingFromDeskResponses, CharityComplianceTakeComplianceFilingFromDeskErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceTakeComplianceFilingFromDeskResponses, CharityComplianceTakeComplianceFilingFromDeskErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/desk/take-back', ...options });

/**
 * Attach Compliance Filing Case Document
 *
 * Add one of the organization's filing documents to an open filing case.
 *
 * A document stays in the first case it is added to; adding it to the same case again
 * changes nothing. Refused, with nothing recorded, for a withdrawn case, or a document that
 * is already in another case. Answers with the case and its documents.
 */
export const charityComplianceAttachComplianceFilingCaseDocument = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAttachComplianceFilingCaseDocumentData, ThrowOnError>): RequestResult<CharityComplianceAttachComplianceFilingCaseDocumentResponses, CharityComplianceAttachComplianceFilingCaseDocumentErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAttachComplianceFilingCaseDocumentResponses, CharityComplianceAttachComplianceFilingCaseDocumentErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Form Preparations
 *
 * A filing case's form preparations, oldest first.
 *
 * Each names its preparation, the form document and the form it started on, and who started
 * it and when. Starting a preparation is its own request; the preparation read says what the
 * form says.
 */
export const charityComplianceListComplianceFormPreparations = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceFormPreparationsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceFormPreparationsResponses, CharityComplianceListComplianceFormPreparationsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceFormPreparationsResponses, CharityComplianceListComplianceFormPreparationsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/form-preparations', ...options });

/**
 * Start Compliance Form Preparation
 *
 * Start preparing the form of a filing case's filing.
 *
 * Adds the form to the case as a filing document and answers the preparation: every item of
 * the form, filled from the organization's records where they hold the answer. When the
 * case's form is already being prepared, answers that preparation.
 */
export const charityComplianceStartComplianceFormPreparation = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceStartComplianceFormPreparationData, ThrowOnError>): RequestResult<CharityComplianceStartComplianceFormPreparationResponses, CharityComplianceStartComplianceFormPreparationErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceStartComplianceFormPreparationResponses, CharityComplianceStartComplianceFormPreparationErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/form-preparations', ...options });

/**
 * Get Compliance Submission
 *
 * A filing case's submission: whether Givmo can email it and, if not, why.
 *
 * The files exactly as they would go and the SHA-256 that binds them, the email's subject
 * and body, the agency's address, the fee as the form states it, the signed forms'
 * request, the addresses the agency's replies can go to, who the email actually goes to,
 * the latest authorization and every send. Reading it sends nothing.
 */
export const charityComplianceGetComplianceSubmission = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceSubmissionData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceSubmissionResponses, CharityComplianceGetComplianceSubmissionErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceSubmissionResponses, CharityComplianceGetComplianceSubmissionErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/submission', ...options });

/**
 * Authorize Compliance Submission
 *
 * Authorize Givmo to send this filing exactly as you reviewed it.
 *
 * For a Compliance Owner or a Global Admin, at your organization's sign-in check. The
 * authorization binds the files, the email, the agency's address, the reply contact and the
 * fee statement, and sends nothing by itself. Refused when anything differs from what you
 * were shown, and while another package is authorized.
 */
export const charityComplianceAuthorizeComplianceSubmission = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAuthorizeComplianceSubmissionData, ThrowOnError>): RequestResult<CharityComplianceAuthorizeComplianceSubmissionResponses, CharityComplianceAuthorizeComplianceSubmissionErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAuthorizeComplianceSubmissionResponses, CharityComplianceAuthorizeComplianceSubmissionErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/submission-authorizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Compliance Submission Evidence
 *
 * Record the agency's answer about a send of this filing, as your organization's record.
 *
 * That it acknowledged the filing, rejected it or asked for changes, and the day it did: from
 * its own message, attached, or from your organization's own account. It's labelled as
 * recorded by you, and it doesn't record the filing as accepted: attaching the confirmation
 * does that. Refused for a send nothing shows went out, and for a date before it was sent or
 * after today.
 */
export const charityComplianceRecordComplianceSubmissionEvidence = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceSubmissionEvidenceData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceSubmissionEvidenceResponses, CharityComplianceRecordComplianceSubmissionEvidenceErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceSubmissionEvidenceResponses, CharityComplianceRecordComplianceSubmissionEvidenceErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/submission-evidence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Answer Compliance Submission Evidence
 *
 * Say a record about a send of this filing is wrong.
 *
 * The email service's report about the agency's address, or a record someone in your
 * organization made: say what you found. The record stays, shown with what you said, and
 * nothing counts it any more. For a Compliance Owner or a Global Admin, in Givmo.
 */
export const charityComplianceAnswerComplianceSubmissionEvidence = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAnswerComplianceSubmissionEvidenceData, ThrowOnError>): RequestResult<CharityComplianceAnswerComplianceSubmissionEvidenceResponses, CharityComplianceAnswerComplianceSubmissionEvidenceErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAnswerComplianceSubmissionEvidenceResponses, CharityComplianceAnswerComplianceSubmissionEvidenceErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/submission-evidence/{evidence_id}/answer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Compliance Submission Handoff
 *
 * Record what your organization sent itself, as its own act.
 *
 * The way it went (one the agency's sources record for this filing) and the date; and what:
 * the package, named by the SHA-256 this filing's submission read served, or one of your
 * organization's documents. A proof of sending is optional. Givmo sends nothing, and the
 * record doesn't show that the agency received it. Refused for a package already recorded
 * or already sent by Givmo, or while Givmo's own send of it is in progress or uncertain.
 */
export const charityComplianceRecordComplianceSubmissionHandoff = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceSubmissionHandoffData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceSubmissionHandoffResponses, CharityComplianceRecordComplianceSubmissionHandoffErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceSubmissionHandoffResponses, CharityComplianceRecordComplianceSubmissionHandoffErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/submission-handoffs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Submission Package
 *
 * The package as one zip: a short-lived link to exactly its files.
 *
 * The files keep the names the email gives them, and nothing else goes in. Name the package
 * by the SHA-256 its submission read served: the one the case holds now, or one an
 * authorization bound. Each file is matched to its SHA-256 first, and each one's reading is
 * recorded. Downloading it sends nothing.
 */
export const charityComplianceGetComplianceSubmissionPackage = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceSubmissionPackageData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceSubmissionPackageResponses, CharityComplianceGetComplianceSubmissionPackageErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceSubmissionPackageResponses, CharityComplianceGetComplianceSubmissionPackageErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/submission/package', ...options });

/**
 * Withdraw Compliance Filing Case
 *
 * Withdraw a filing case: the organization stops preparing this filing in it.
 *
 * The case keeps its documents and takes no new one, and a new case can be opened for the
 * same filing. Withdrawing a case already withdrawn changes nothing. Answers with the case
 * and its documents.
 */
export const charityComplianceWithdrawComplianceFilingCase = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceWithdrawComplianceFilingCaseData, ThrowOnError>): RequestResult<CharityComplianceWithdrawComplianceFilingCaseResponses, CharityComplianceWithdrawComplianceFilingCaseErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceWithdrawComplianceFilingCaseResponses, CharityComplianceWithdrawComplianceFilingCaseErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-cases/{case_id}/withdrawal', ...options });

/**
 * List Compliance Filing Documents
 *
 * The organization's filing documents, oldest first, each with its latest version.
 *
 * A filing document is a PDF the organization's filings use, kept as versions that never
 * change: the PDF as it was uploaded, and the copy Givmo prepared from it.
 */
export const charityComplianceListComplianceFilingDocuments = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceFilingDocumentsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceFilingDocumentsResponses, CharityComplianceListComplianceFilingDocumentsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceFilingDocumentsResponses, CharityComplianceListComplianceFilingDocumentsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-documents', ...options });

/**
 * Create Compliance Filing Document
 *
 * Start a filing document, with the organization's title for it.
 *
 * It has no version until an uploaded PDF is recorded as one.
 */
export const charityComplianceCreateComplianceFilingDocument = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceCreateComplianceFilingDocumentData, ThrowOnError>): RequestResult<CharityComplianceCreateComplianceFilingDocumentResponses, CharityComplianceCreateComplianceFilingDocumentErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceCreateComplianceFilingDocumentResponses, CharityComplianceCreateComplianceFilingDocumentErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Filing Document
 *
 * One filing document with every version, oldest first.
 *
 * Each version is named by the SHA-256 of its exact bytes. A version Givmo prepared begins
 * with the exact bytes of what it was made from: the version it was prepared from, which it
 * names, or, for a form Givmo fills, the agency's official template.
 */
export const charityComplianceGetComplianceFilingDocument = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceFilingDocumentData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceFilingDocumentResponses, CharityComplianceGetComplianceFilingDocumentErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceFilingDocumentResponses, CharityComplianceGetComplianceFilingDocumentErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-documents/{document_id}', ...options });

/**
 * Register Compliance Filing Document Version
 *
 * Record an uploaded PDF as the document's next version.
 *
 * The PDF is one the organization already uploaded to its documents. Givmo reads its
 * exact bytes and records the version under their SHA-256; from then on the uploaded
 * document stays in the organization's records. When the PDF carries filled form fields,
 * or text and drawings added with a PDF app's tools, Givmo also records a copy that draws
 * each one's saved appearance into the page, as the version after: the upload is an exact
 * byte prefix of that copy.
 *
 * Refused, with nothing recorded, for a PDF protected with encryption (a restrictions-only
 * password included), a filled field or an added drawing with no saved appearance,
 * comments or other added content Givmo can't make part of the page, a dynamic form, or a
 * PDF Givmo can't read. Recording the same PDF again changes nothing. Answers with the
 * document and every version.
 */
export const charityComplianceRegisterComplianceFilingDocumentVersion = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRegisterComplianceFilingDocumentVersionData, ThrowOnError>): RequestResult<CharityComplianceRegisterComplianceFilingDocumentVersionResponses, CharityComplianceRegisterComplianceFilingDocumentVersionErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRegisterComplianceFilingDocumentVersionResponses, CharityComplianceRegisterComplianceFilingDocumentVersionErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-documents/{document_id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Filing Document Version Download
 *
 * A short-lived link to one version's exact bytes.
 *
 * The link names those exact bytes, whatever else is uploaded later. Each download link
 * Givmo issues is recorded: who asked, when, and the SHA-256 of the bytes it names. The
 * record is not an approval of anything. Fetch a new link each time rather than keeping
 * one.
 */
export const charityComplianceGetComplianceFilingDocumentVersionDownload = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceFilingDocumentVersionDownloadData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceFilingDocumentVersionDownloadResponses, CharityComplianceGetComplianceFilingDocumentVersionDownloadErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceFilingDocumentVersionDownloadResponses, CharityComplianceGetComplianceFilingDocumentVersionDownloadErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-documents/{document_id}/versions/{version_id}/download', ...options });

/**
 * Record Compliance Executed Copy
 *
 * Record the organization's upload of this version as it was signed outside Givmo, with who
 * signed it, in what capacity and when, as the organization states. This isn't a Givmo
 * signature, and Givmo doesn't check the signatures or that the copy matches this version. Only
 * a form Givmo prepared takes one, and not while it is out for signature or once it was signed
 * in Givmo; a PDF that is already a version of the form is refused. The same copy again changes
 * nothing; a different copy is recorded beside the first, and the newer one stands.
 */
export const charityComplianceRecordComplianceExecutedCopy = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceExecutedCopyData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceExecutedCopyResponses, CharityComplianceRecordComplianceExecutedCopyErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceExecutedCopyResponses, CharityComplianceRecordComplianceExecutedCopyErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-documents/{document_id}/versions/{version_id}/executed-copies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Filing Document Version Rendition
 *
 * What one version looks like, page by page.
 *
 * Each page was drawn once, with its form fields shown as a form-aware viewer shows
 * them, when the version was recorded; viewing draws nothing new. Each page is a
 * short-lived link to its image.
 */
export const charityComplianceGetComplianceFilingDocumentVersionRendition = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceFilingDocumentVersionRenditionData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceFilingDocumentVersionRenditionResponses, CharityComplianceGetComplianceFilingDocumentVersionRenditionErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceFilingDocumentVersionRenditionResponses, CharityComplianceGetComplianceFilingDocumentVersionRenditionErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-documents/{document_id}/versions/{version_id}/rendition', ...options });

/**
 * Get Compliance Filing Document Signing Places
 *
 * What the person sending a filing document out for signature needs before they send it:
 * the document's filing case, the form Givmo matched this version to among that filing's
 * own forms, every signature place the form has (its page, where it is, and where the
 * printed name, the title and the date go), each page's draw scale, whether Givmo can sign
 * it for each way the filing is sent (with the line that says when the agency hasn't
 * confirmed it accepts e-signatures), and why sending it would be refused now, if it would.
 * Writes nothing.
 */
export const charityComplianceGetComplianceFilingDocumentSigningPlaces = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceFilingDocumentSigningPlacesData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceFilingDocumentSigningPlacesResponses, CharityComplianceGetComplianceFilingDocumentSigningPlacesErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceFilingDocumentSigningPlacesResponses, CharityComplianceGetComplianceFilingDocumentSigningPlacesErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-documents/{document_id}/versions/{version_id}/signing-places', ...options });

/**
 * List Compliance Filing Groups
 *
 * The organization's filing groups, in its order, each with the filings moved into it.
 *
 * Filings group automatically by family (fundraising registrations, corporate filings
 * and so on); the organization can rename a family's group, reorder the groups, make
 * groups of its own and move a filing between them. Every member of the organization
 * sees the same groups. A filing not listed as a member of any group sits in its
 * family's group.
 */
export const charityComplianceListComplianceFilingGroups = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceFilingGroupsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceFilingGroupsResponses, CharityComplianceListComplianceFilingGroupsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceFilingGroupsResponses, CharityComplianceListComplianceFilingGroupsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-groups', ...options });

/**
 * Create Compliance Filing Group
 *
 * Make a group, named by the organization, with the one filing that starts it.
 *
 * The new group goes last in the organization's order and the filing moves into it.
 * Answers with the new group.
 */
export const charityComplianceCreateComplianceFilingGroup = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceCreateComplianceFilingGroupData, ThrowOnError>): RequestResult<CharityComplianceCreateComplianceFilingGroupResponses, CharityComplianceCreateComplianceFilingGroupErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceCreateComplianceFilingGroupResponses, CharityComplianceCreateComplianceFilingGroupErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Compliance Filing Group
 *
 * Remove a group the organization made. Its filings go back to their families' groups.
 *
 * A family's group is never removed; it leaves the page when it holds no filing.
 */
export const charityComplianceRemoveComplianceFilingGroup = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRemoveComplianceFilingGroupData, ThrowOnError>): RequestResult<CharityComplianceRemoveComplianceFilingGroupResponses, CharityComplianceRemoveComplianceFilingGroupErrors, ThrowOnError> => (options.client ?? client).delete<CharityComplianceRemoveComplianceFilingGroupResponses, CharityComplianceRemoveComplianceFilingGroupErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-groups/{group_id}', ...options });

/**
 * Move Compliance Filing To Group
 *
 * Move one filing into this group.
 *
 * Moving a filing into its own family's group puts it back there. Answers with the
 * group the filing is now in.
 */
export const charityComplianceMoveComplianceFilingToGroup = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceMoveComplianceFilingToGroupData, ThrowOnError>): RequestResult<CharityComplianceMoveComplianceFilingToGroupResponses, CharityComplianceMoveComplianceFilingToGroupErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceMoveComplianceFilingToGroupResponses, CharityComplianceMoveComplianceFilingToGroupErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-groups/{group_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move Compliance Filing Group
 *
 * Move one group one place up or down among the groups the Filings page shows.
 *
 * A family's group holding no filing is not shown, so a move passes it. At the top or
 * the bottom the order stays as it is. Answers with the group at its new place.
 */
export const charityComplianceMoveComplianceFilingGroup = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceMoveComplianceFilingGroupData, ThrowOnError>): RequestResult<CharityComplianceMoveComplianceFilingGroupResponses, CharityComplianceMoveComplianceFilingGroupErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceMoveComplianceFilingGroupResponses, CharityComplianceMoveComplianceFilingGroupErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-groups/{group_id}/moves',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rename Compliance Filing Group
 *
 * Rename one group.
 *
 * A family's group goes back to its family's own name when no name is given; a group
 * the organization made always has one. Answers with the group.
 */
export const charityComplianceRenameComplianceFilingGroup = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRenameComplianceFilingGroupData, ThrowOnError>): RequestResult<CharityComplianceRenameComplianceFilingGroupResponses, CharityComplianceRenameComplianceFilingGroupErrors, ThrowOnError> => (options.client ?? client).put<CharityComplianceRenameComplianceFilingGroupResponses, CharityComplianceRenameComplianceFilingGroupErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/filing-groups/{group_id}/name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Filing Options
 *
 * The filings Givmo's rules library offers for adding, one jurisdiction's or all.
 *
 * Each option is a jurisdiction's current rule with its citation and source date, and
 * how the Filings page presents it: its family (fundraising registrations, corporate
 * filings and so on), a short title and what the organization's own number is called.
 * Each option also carries, in `next_dates`, its next date for each deadline the rule
 * records, worked out from the organization's recorded facts with the rule's own deadline
 * entry as its basis, or the reason no date could be worked out; an entry whose dates have
 * all passed is left out. An option says what kind of filing a rule describes; it never
 * says the organization must make it. Ordered by jurisdiction, then as the library lists
 * that jurisdiction's filings.
 */
export const charityComplianceListComplianceFilingOptions = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceFilingOptionsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceFilingOptionsResponses, CharityComplianceListComplianceFilingOptionsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceFilingOptionsResponses, CharityComplianceListComplianceFilingOptionsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/filing-options', ...options });

/**
 * List Compliance Form Adapters
 *
 * The agency forms Givmo prepares from their official templates.
 *
 * Each names the rule it is filed under, the form's own number, the template (where it was
 * taken from, when, and the SHA-256 of its exact bytes) and its pages.
 */
export const charityComplianceListComplianceFormAdapters = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceFormAdaptersData, ThrowOnError>): RequestResult<CharityComplianceListComplianceFormAdaptersResponses, CharityComplianceListComplianceFormAdaptersErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceFormAdaptersResponses, CharityComplianceListComplianceFormAdaptersErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/form-adapters', ...options });

/**
 * Get Compliance Form Preparation
 *
 * A form being prepared: every item in the form's order and own words, where it stands,
 * what goes on the form for it and where, and the records it comes from.
 *
 * ``values_sha256`` binds everything the form says; recording a version echoes it.
 */
export const charityComplianceGetComplianceFormPreparation = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceFormPreparationData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceFormPreparationResponses, CharityComplianceGetComplianceFormPreparationErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceFormPreparationResponses, CharityComplianceGetComplianceFormPreparationErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/form-preparations/{preparation_id}', ...options });

/**
 * Answer Compliance Form Item
 *
 * The organization's answer to one item of the form.
 *
 * Recorded beside the earlier ones, with who gave it and when; the newest stands. An answer
 * that changes nothing records nothing. Refused for an answer the item does not take, a
 * character the form can't be printed with, or a value too long for the form's line, and
 * while the form is out for signature.
 */
export const charityComplianceAnswerComplianceFormItem = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAnswerComplianceFormItemData, ThrowOnError>): RequestResult<CharityComplianceAnswerComplianceFormItemResponses, CharityComplianceAnswerComplianceFormItemErrors, ThrowOnError> => (options.client ?? client).put<CharityComplianceAnswerComplianceFormItemResponses, CharityComplianceAnswerComplianceFormItemErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/form-preparations/{preparation_id}/items/{item_key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Form Page Preview
 *
 * One page of the form as it stands, drawn as a form-aware viewer shows it.
 *
 * Not a version: recording one is its own request.
 */
export const charityComplianceGetComplianceFormPagePreview = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceFormPagePreviewData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceFormPagePreviewResponses, CharityComplianceGetComplianceFormPagePreviewErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceFormPagePreviewResponses, CharityComplianceGetComplianceFormPagePreviewErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/form-preparations/{preparation_id}/pages/{page}/preview', ...options });

/**
 * Mint Compliance Form Version
 *
 * Record the prepared form as it stands as a version of its document.
 *
 * The version is the agency's template and one appended change carrying the form's values;
 * it never changes, and the same answers record the same version. Anyone who can read the
 * module may record it, as downloading it does. Refused when the form changed since it was
 * read (``expected_values_sha256``) and while it is out for signature.
 */
export const charityComplianceMintComplianceFormVersion = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceMintComplianceFormVersionData, ThrowOnError>): RequestResult<CharityComplianceMintComplianceFormVersionResponses, CharityComplianceMintComplianceFormVersionErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceMintComplianceFormVersionResponses, CharityComplianceMintComplianceFormVersionErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/form-preparations/{preparation_id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Obligations
 *
 * The organization's register.
 *
 * Each row records what the organization filed and when, and the confirmation the
 * state issued for it. It records filings; it is not a statement that the
 * organization is registered, exempt, in good standing, or in compliance anywhere —
 * only the state that issued a confirmation can say that.
 */
export const charityComplianceListComplianceObligations = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceObligationsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceObligationsResponses, CharityComplianceListComplianceObligationsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceObligationsResponses, CharityComplianceListComplianceObligationsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/obligations', ...options });

/**
 * Get Compliance Obligation
 *
 * One obligation, its computed dates, and everything recorded about it.
 *
 * Each date is calculated from a filing period transcribed from the cited source,
 * applied to the fiscal year end the organization recorded. Confirm the current due
 * date with the state before filing.
 */
export const charityComplianceGetComplianceObligation = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceObligationData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceObligationResponses, CharityComplianceGetComplianceObligationErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceObligationResponses, CharityComplianceGetComplianceObligationErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}', ...options });

/**
 * List Compliance Obligation Artifacts
 *
 * Every document recorded against this obligation — currently and historically.
 *
 * `reference_role` says what each document was recorded AS: `confirmation`, the
 * confirmation the state issued; `submission_proof`, your organization's own proof of a
 * submission; `filed_copy`, the filing itself as your organization sent it; or
 * `attachment`, another document kept with the filing. Only a confirmation is the
 * state's answer. `is_current` says whether this obligation itself still carries the
 * reference: a document stays listed after a candidate is dismissed or a later
 * submission is recorded, because the history of what was recorded does not change when
 * the current record does, and a document one of its renewal cycles holds is listed as
 * not current here.
 */
export const charityComplianceListComplianceObligationArtifacts = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceObligationArtifactsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceObligationArtifactsResponses, CharityComplianceListComplianceObligationArtifactsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceObligationArtifactsResponses, CharityComplianceListComplianceObligationArtifactsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/artifacts', ...options });

/**
 * Add Compliance Obligation Attachment
 *
 * Keep one more document with a filing made once rather than each period, or with
 * the first filing of one that also recurs (the filing due before the first
 * solicitation). The document must already be uploaded for your organization; adding it
 * again changes nothing.
 */
export const charityComplianceAddComplianceObligationAttachment = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAddComplianceObligationAttachmentData, ThrowOnError>): RequestResult<CharityComplianceAddComplianceObligationAttachmentResponses, CharityComplianceAddComplianceObligationAttachmentErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAddComplianceObligationAttachmentResponses, CharityComplianceAddComplianceObligationAttachmentErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/attachments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Compliance Earlier Renewal Cycle
 *
 * Add an earlier year to one filing's history: a renewal cycle for a year the
 * calendar does not show, before the latest one it does, dated by the same cited rule and
 * your organization's recorded fiscal year end. It starts with nothing recorded, and no
 * reminder is sent for it; record the year's filing on the cycle it returns. A year
 * already shown returns its own cycle.
 */
export const charityComplianceAddComplianceEarlierRenewalCycle = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAddComplianceEarlierRenewalCycleData, ThrowOnError>): RequestResult<CharityComplianceAddComplianceEarlierRenewalCycleResponses, CharityComplianceAddComplianceEarlierRenewalCycleErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAddComplianceEarlierRenewalCycleResponses, CharityComplianceAddComplianceEarlierRenewalCycleErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/earlier-cycles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach Compliance Obligation Filed Copy
 *
 * Attach the filing itself, as your organization sent it, to a filing made once
 * rather than each period, or to the first filing of one that also recurs (the filing
 * due before the first solicitation). It keeps one; the document must already be
 * uploaded for your organization. It is not the jurisdiction's confirmation. Each later
 * period keeps its own filing as sent on its renewal cycle.
 */
export const charityComplianceAttachComplianceObligationFiledCopy = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAttachComplianceObligationFiledCopyData, ThrowOnError>): RequestResult<CharityComplianceAttachComplianceObligationFiledCopyResponses, CharityComplianceAttachComplianceObligationFiledCopyErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAttachComplianceObligationFiledCopyResponses, CharityComplianceAttachComplianceObligationFiledCopyErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/filed-copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open Compliance Filing Case
 *
 * Open a filing case for one filing on the organization's register.
 *
 * Say what kind of filing it is. For a filing made each year or each licence period, name
 * the year's record on its calendar; leave it out for a filing made once, or for the first
 * filing of one that also recurs. One case of each kind can be open for a filing and
 * period at a time: withdraw the open one to start over. Refused, with nothing recorded,
 * for a filing that is not confirmed on the register or a year's record that was replaced.
 */
export const charityComplianceOpenComplianceFilingCase = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceOpenComplianceFilingCaseData, ThrowOnError>): RequestResult<CharityComplianceOpenComplianceFilingCaseResponses, CharityComplianceOpenComplianceFilingCaseErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceOpenComplianceFilingCaseResponses, CharityComplianceOpenComplianceFilingCaseErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/filing-cases',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Compliance Filing
 *
 * Record a filing the organization made, with the confirmation the state issued.
 *
 * The confirmation is required — there is no path on this surface that records a
 * filing without one, and the database refuses such a row independently. What is
 * recorded is that the organization filed, on the date it gives, with the
 * confirmation it uploaded.
 */
export const charityComplianceRecordComplianceFiling = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceFilingData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceFilingResponses, CharityComplianceRecordComplianceFilingErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceFilingResponses, CharityComplianceRecordComplianceFilingErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/filing-records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Packets
 *
 * The versions of one obligation's packet, newest first.
 *
 * Every version stays readable — a superseded one keeps its content address and its
 * download history. Items and execution steps are read per version. `download_state`
 * says what asking for each version's document would actually do, and `download_count`
 * how many times this organization has fetched it.
 */
export const charityComplianceListCompliancePackets = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListCompliancePacketsData, ThrowOnError>): RequestResult<CharityComplianceListCompliancePacketsResponses, CharityComplianceListCompliancePacketsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListCompliancePacketsResponses, CharityComplianceListCompliancePacketsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/packets', ...options });

/**
 * Assemble Compliance Packet
 *
 * Assemble a new packet version for one confirmed obligation.
 *
 * The packet pairs the jurisdiction's rule as transcribed — form, agency, channel and
 * address, fee, attachments, signature requirement, prerequisites, filing period — each
 * with its source date and, where one was recorded, its citation, against the parameters
 * the organization recorded and the documents it has cited. Where the rule records no
 * form, channel, fee, attachment, signature requirement or filing period, the packet
 * records a gap rather than supplying one. Signer instructions may also appear in
 * recorded form or submission notes.
 *
 * Each step is carried with the source date and, where recorded, the citation of the rule
 * field it restates, or marked as this product's own instruction where it restates no
 * rule. Each item carries the source line frozen when its version was assembled: its
 * source date, `rule_source_date`, worded by `rule_source_date_basis` (an item assembled
 * without them dates its source by `rule_source_checked_on`, a live check only where
 * `rule_source_check_status` is `read_live`), and its citation, `rule_display_citation`,
 * where one was recorded.
 *
 * Assembling again supersedes the previous version: a new version is a new set of
 * bytes, and a download record names the exact bytes it served. Optionally cite ONE
 * more document of the organization's own; documents cited on earlier versions carry
 * forward. Nothing is filed anywhere by this or any other operation here.
 */
export const charityComplianceAssembleCompliancePacket = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAssembleCompliancePacketData, ThrowOnError>): RequestResult<CharityComplianceAssembleCompliancePacketResponses, CharityComplianceAssembleCompliancePacketErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAssembleCompliancePacketResponses, CharityComplianceAssembleCompliancePacketErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/packets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Compliance Registration Date
 *
 * Record the dates this obligation's renewal runs from: its registration date
 * (CCM-BE2), the expiry date printed on its licence (CCM-R1-INTAKE-ANCHOR), or both.
 *
 * Recorded on the obligation itself rather than by declining it and confirming it
 * again — an obligation's recorded filings and its whole history stay where they are
 * while the date under its renewal corrects. Where a licence expiry is recorded, the
 * licence period ends on it. The dates it computes are recomputed; nothing about what
 * your organization filed changes, and no confirmation is needed to correct a date.
 */
export const charityComplianceRecordComplianceRegistrationDate = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceRegistrationDateData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceRegistrationDateResponses, CharityComplianceRecordComplianceRegistrationDateErrors, ThrowOnError> => (options.client ?? client).put<CharityComplianceRecordComplianceRegistrationDateResponses, CharityComplianceRecordComplianceRegistrationDateErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/registration-date',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Obligation Rule Change
 *
 * What changed between the rule version a filing is pinned to and its rule's current
 * version (CCM-OPS1-REPIN): each kind of change, with the deadline entry it is about, and
 * each deadline entry's next date under each version. Structure only.
 */
export const charityComplianceGetComplianceObligationRuleChange = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceObligationRuleChangeData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceObligationRuleChangeResponses, CharityComplianceGetComplianceObligationRuleChangeErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceObligationRuleChangeResponses, CharityComplianceGetComplianceObligationRuleChangeErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/rule-change', ...options });

/**
 * Repin Compliance Obligation
 *
 * Move a filing to its rule's current version, the version named (CCM-OPS1-REPIN): the
 * organization's own act, attributed on the filing's history, which clears the filing's
 * rule-change flag and works its dates out again from that version. Its record is kept.
 * Refused, with nothing written, unless the version named is still the rule's current one;
 * a filing already there is answered as it stands.
 */
export const charityComplianceRepinComplianceObligation = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRepinComplianceObligationData, ThrowOnError>): RequestResult<CharityComplianceRepinComplianceObligationResponses, CharityComplianceRepinComplianceObligationErrors, ThrowOnError> => (options.client ?? client).put<CharityComplianceRepinComplianceObligationResponses, CharityComplianceRepinComplianceObligationErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/rule-version',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Compliance Submission
 *
 * Record that the organization submitted a filing, on the date it gives.
 *
 * This records the organization's own act and nothing about the jurisdiction's
 * answer. Render it as "submission recorded «date» — awaiting the state's
 * confirmation": the register does not know whether the submission arrived, was
 * accepted, or was returned, and it does not become a recorded filing until the
 * organization records the confirmation the state issued, on the filing-records
 * route, with that confirmation attached.
 *
 * Its own route because it takes no confirmation — the filing route's confirmation is
 * required and has no nullable form. The optional proof reference here is the
 * organization's own paperwork and is never read as a confirmation.
 *
 * Dates the organization is working toward are recomputed, and the notices for the
 * cycle this submission was for change voice accordingly. If the recorded window
 * closes with no confirmation recorded against it, the register still reports the
 * closed window.
 */
export const charityComplianceRecordComplianceSubmission = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceSubmissionData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceSubmissionResponses, CharityComplianceRecordComplianceSubmissionErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceSubmissionResponses, CharityComplianceRecordComplianceSubmissionErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resume Tracking Compliance Obligation
 *
 * Start tracking a stopped filing again (CCM-R1-TRACKING-PANEL, D-CCM-58): the
 * organization's own act, attributed on the filing's history. It goes back onto the calendar
 * on its own rule version and its dates are worked out again. A filing being tracked is
 * answered as it stands. Refused, with nothing written, for a filing not on the calendar.
 */
export const charityComplianceResumeTrackingComplianceObligation = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceResumeTrackingComplianceObligationData, ThrowOnError>): RequestResult<CharityComplianceResumeTrackingComplianceObligationResponses, CharityComplianceResumeTrackingComplianceObligationErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceResumeTrackingComplianceObligationResponses, CharityComplianceResumeTrackingComplianceObligationErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/tracking-resume', ...options });

/**
 * Stop Tracking Compliance Obligation
 *
 * Stop tracking a filing on the calendar (CCM-R1-TRACKING-PANEL, D-CCM-58): the
 * organization's own act, attributed on the filing's history. Its record and history stay;
 * Givmo works out no new dates for it, so nothing reminds. A filing already stopped is
 * answered as it stands. Refused, with nothing written, for a filing not on the calendar.
 */
export const charityComplianceStopTrackingComplianceObligation = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceStopTrackingComplianceObligationData, ThrowOnError>): RequestResult<CharityComplianceStopTrackingComplianceObligationResponses, CharityComplianceStopTrackingComplianceObligationErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceStopTrackingComplianceObligationResponses, CharityComplianceStopTrackingComplianceObligationErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/tracking-stop', ...options });

/**
 * Record Compliance Window Closed
 *
 * Record that a refiling window the organization recorded closed with no filing
 * recorded against it.
 *
 * A dated fact. The register does not assess what a closed window means for the
 * organization.
 */
export const charityComplianceRecordComplianceWindowClosed = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceWindowClosedData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceWindowClosedResponses, CharityComplianceRecordComplianceWindowClosedErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceWindowClosedResponses, CharityComplianceRecordComplianceWindowClosedErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/obligations/{obligation_id}/window-closures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Occurrences
 *
 * Computed dates across the organization's confirmed obligations.
 *
 * Each date is calculated from a filing period transcribed from the cited source,
 * applied to the fiscal year end the organization recorded, and travels with both.
 * Some obligations have no calendar date at all — a filing due before the first
 * solicitation has no date to compute — and those rows say so rather than being
 * omitted.
 *
 * `due_before` bounds the window; rows with no computable date are returned
 * regardless.
 */
export const charityComplianceListComplianceOccurrences = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceOccurrencesData, ThrowOnError>): RequestResult<CharityComplianceListComplianceOccurrencesResponses, CharityComplianceListComplianceOccurrencesErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceOccurrencesResponses, CharityComplianceListComplianceOccurrencesErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/occurrences', ...options });

/**
 * List Compliance Organization Filings
 *
 * The filings the organization records itself, oldest first, each with its latest
 * period.
 *
 * These are filings Givmo's rules library does not have. Their dates are the ones the
 * organization entered, and nothing on them was checked against a source.
 */
export const charityComplianceListComplianceOrganizationFilings = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceOrganizationFilingsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceOrganizationFilingsResponses, CharityComplianceListComplianceOrganizationFilingsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceOrganizationFilingsResponses, CharityComplianceListComplianceOrganizationFilingsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/organization-filings', ...options });

/**
 * Add Compliance Organization Filing
 *
 * Add a filing Givmo's rules library does not have.
 *
 * The organization gives its title, who it is filed with, its family, how often it
 * comes round and its next date; its first period opens at that date. Answers with the
 * filing and that period.
 */
export const charityComplianceAddComplianceOrganizationFiling = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAddComplianceOrganizationFilingData, ThrowOnError>): RequestResult<CharityComplianceAddComplianceOrganizationFilingResponses, CharityComplianceAddComplianceOrganizationFilingErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAddComplianceOrganizationFilingResponses, CharityComplianceAddComplianceOrganizationFilingErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/organization-filings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Organization Filing
 *
 * One filing the organization records itself, with every period, latest date
 * first, its history, the number it first entered, and each change to that number.
 */
export const charityComplianceGetComplianceOrganizationFiling = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceOrganizationFilingData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceOrganizationFilingResponses, CharityComplianceGetComplianceOrganizationFilingErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceOrganizationFilingResponses, CharityComplianceGetComplianceOrganizationFilingErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/organization-filings/{filing_id}', ...options });

/**
 * Update Compliance Organization Filing
 *
 * Change a filing the organization records itself.
 *
 * A field left out stays as it is; the agency and the number are cleared with null.
 * Changing how often it comes round, or its next date, re-dates only the period nothing
 * is recorded for yet. Each change is kept in the filing's history. A reason, in the
 * person's own words, is kept with each change.
 */
export const charityComplianceUpdateComplianceOrganizationFiling = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceUpdateComplianceOrganizationFilingData, ThrowOnError>): RequestResult<CharityComplianceUpdateComplianceOrganizationFilingResponses, CharityComplianceUpdateComplianceOrganizationFilingErrors, ThrowOnError> => (options.client ?? client).patch<CharityComplianceUpdateComplianceOrganizationFilingResponses, CharityComplianceUpdateComplianceOrganizationFilingErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/organization-filings/{filing_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Compliance Organization Filing Cycle
 *
 * Add an earlier period of a filing the organization records itself, at a date
 * before its latest period that no period already there covers. It opens nothing new.
 * An earlier date a period already holds returns that period.
 */
export const charityComplianceAddComplianceOrganizationFilingCycle = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAddComplianceOrganizationFilingCycleData, ThrowOnError>): RequestResult<CharityComplianceAddComplianceOrganizationFilingCycleResponses, CharityComplianceAddComplianceOrganizationFilingCycleErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAddComplianceOrganizationFilingCycleResponses, CharityComplianceAddComplianceOrganizationFilingCycleErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/organization-filings/{filing_id}/cycles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Compliance Organization Filing Attachment
 *
 * Keep one more document with one period of a filing your organization records
 * itself, beside its filing and confirmation. The document must already be uploaded for
 * your organization; adding it again changes nothing.
 */
export const charityComplianceAddComplianceOrganizationFilingAttachment = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAddComplianceOrganizationFilingAttachmentData, ThrowOnError>): RequestResult<CharityComplianceAddComplianceOrganizationFilingAttachmentResponses, CharityComplianceAddComplianceOrganizationFilingAttachmentErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAddComplianceOrganizationFilingAttachmentResponses, CharityComplianceAddComplianceOrganizationFilingAttachmentErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/organization-filings/{filing_id}/cycles/{cycle_id}/attachments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach Compliance Organization Filing Filed Copy
 *
 * Keep the filing itself, as your organization sent it, with one period of a filing
 * your organization records itself. A period keeps one; the document must already be
 * uploaded for your organization. It is kept with the period's records and is not the
 * agency's confirmation: the period reads as filed only with that.
 */
export const charityComplianceAttachComplianceOrganizationFilingFiledCopy = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAttachComplianceOrganizationFilingFiledCopyData, ThrowOnError>): RequestResult<CharityComplianceAttachComplianceOrganizationFilingFiledCopyResponses, CharityComplianceAttachComplianceOrganizationFilingFiledCopyErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAttachComplianceOrganizationFilingFiledCopyResponses, CharityComplianceAttachComplianceOrganizationFilingFiledCopyErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/organization-filings/{filing_id}/cycles/{cycle_id}/filed-copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Compliance Organization Filing Filed
 *
 * Record that one period was filed, with the confirmation the agency issued.
 *
 * The confirmation document is required: a period reads as filed only with it. A copy
 * of the filing as sent may ride along; a period keeps one. Recording the same filing
 * again changes nothing. When this is the latest period, the next opens by the
 * filing's cadence.
 */
export const charityComplianceRecordComplianceOrganizationFilingFiled = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceOrganizationFilingFiledData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceOrganizationFilingFiledResponses, CharityComplianceRecordComplianceOrganizationFilingFiledErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceOrganizationFilingFiledResponses, CharityComplianceRecordComplianceOrganizationFilingFiledErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/organization-filings/{filing_id}/cycles/{cycle_id}/filing-records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Compliance Organization Filing Sent
 *
 * Record that one period's filing was sent, on the date the organization gives.
 *
 * Sent is not filed. Recording it again corrects the date and the proof; recording it
 * exactly as it stands changes nothing. A period keeps one filing as sent: a different
 * copy is refused. When this is the latest period, the next opens by the filing's
 * cadence.
 */
export const charityComplianceRecordComplianceOrganizationFilingSent = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceOrganizationFilingSentData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceOrganizationFilingSentResponses, CharityComplianceRecordComplianceOrganizationFilingSentErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceOrganizationFilingSentResponses, CharityComplianceRecordComplianceOrganizationFilingSentErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/organization-filings/{filing_id}/cycles/{cycle_id}/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retire Compliance Organization Filing
 *
 * Stop tracking a filing the organization records itself: it gets no more reminders
 * and opens no next period.
 *
 * The record is kept as it was, with its periods and history, and takes no further
 * changes. A filing already stopped answers as it is.
 */
export const charityComplianceRetireComplianceOrganizationFiling = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRetireComplianceOrganizationFilingData, ThrowOnError>): RequestResult<CharityComplianceRetireComplianceOrganizationFilingResponses, CharityComplianceRetireComplianceOrganizationFilingErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRetireComplianceOrganizationFilingResponses, CharityComplianceRetireComplianceOrganizationFilingErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/organization-filings/{filing_id}/retire', ...options });

/**
 * Switch Compliance Organization Filing
 *
 * Switch a filing the organization records itself to the same filing from Givmo's
 * rules library, once the organization has that one on its register.
 *
 * The record is kept as it was, with its periods and history, and takes no further
 * changes. If it was moved into a group, the library filing takes its place there.
 */
export const charityComplianceSwitchComplianceOrganizationFiling = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceSwitchComplianceOrganizationFilingData, ThrowOnError>): RequestResult<CharityComplianceSwitchComplianceOrganizationFilingResponses, CharityComplianceSwitchComplianceOrganizationFilingErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceSwitchComplianceOrganizationFilingResponses, CharityComplianceSwitchComplianceOrganizationFilingErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/organization-filings/{filing_id}/switch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Packet
 *
 * One packet version with its items.
 *
 * The items are the rule elements with their source dates and, where recorded, citations,
 * the organization's cited documents, and the steps it performs on the jurisdiction's own
 * channel — each step carrying the source date and, where recorded, the citation of the
 * rule field it restates, or marked as this product's own instruction where it restates
 * no rule. Each item carries the source line frozen when its version was assembled: its
 * source date, `rule_source_date`, worded by `rule_source_date_basis` (an item assembled
 * without them dates its source by `rule_source_checked_on`, a live check only where
 * `rule_source_check_status` is `read_live`), and its citation, `rule_display_citation`,
 * where one was recorded. All of them are listed in every packet state. `download_state`
 * says what asking for this version's document would actually do, and `download_count`
 * how many times it has been fetched.
 */
export const charityComplianceGetCompliancePacket = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetCompliancePacketData, ThrowOnError>): RequestResult<CharityComplianceGetCompliancePacketResponses, CharityComplianceGetCompliancePacketErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetCompliancePacketResponses, CharityComplianceGetCompliancePacketErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/packets/{packet_id}', ...options });

/**
 * Get Compliance Packet Checklist
 *
 * The checklist for one packet version.
 *
 * The full working state at any time: the rule elements with their source dates and,
 * where recorded, citations, the organization's cited documents, and the steps it
 * performs on the jurisdiction's own channel — gather the cited documents, obtain the
 * recorded signatures, execute on the recorded channel, remit the recorded amount where
 * one is transcribed, then record the submission in the register. Each step built from
 * the rule carries that rule's source date and, where recorded, its citation; the
 * register step is this product's own instruction and says so. Each item carries the
 * source line frozen when its version was assembled: its source date, `rule_source_date`,
 * worded by `rule_source_date_basis` (an item assembled without them dates its source by
 * `rule_source_checked_on`, a live check only where `rule_source_check_status` is
 * `read_live`), and its citation, `rule_display_citation`, where one was recorded. Where
 * the rule records no channel, fee or signature requirement, the step records a gap
 * rather than supplying one. Signer instructions may also appear in recorded form or
 * submission notes. `download_state` says what asking for this version's document would
 * actually do, and `download_count` how many times it has been fetched.
 */
export const charityComplianceGetCompliancePacketChecklist = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetCompliancePacketChecklistData, ThrowOnError>): RequestResult<CharityComplianceGetCompliancePacketChecklistResponses, CharityComplianceGetCompliancePacketChecklistErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetCompliancePacketChecklistResponses, CharityComplianceGetCompliancePacketChecklistErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/packets/{packet_id}/checklist', ...options });

/**
 * Get Compliance Packet Render
 *
 * Download one packet version's document.
 *
 * Anyone the organization has admitted to this module may download it. There is
 * nothing to confirm and nothing to type. Every download is recorded when it is asked
 * for — who asked, when, and which bytes it names: the content address of the frozen
 * payload the document is rendered from — and that record says exactly that: it is not
 * a signature, an approval, or a statement that anyone is an officer of the
 * organization.
 *
 * Above its download record, the document says that it is not signed, and that who must
 * sign, and how, is set by the jurisdiction's own form and instructions: the rule shows
 * the signer requirements recorded from those sources, and where it shows none they
 * have not been recorded, which does not mean the source is silent.
 *
 * Rendered deterministically from the frozen payload; nothing is stored. Refused for a
 * version whose pinned rule was revised or whose recorded parameters changed since it
 * was assembled — each of those calls for a new version. Nothing is filed anywhere by
 * this or any other operation here.
 */
export const charityComplianceGetCompliancePacketRender = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetCompliancePacketRenderData, ThrowOnError>): RequestResult<CharityComplianceGetCompliancePacketRenderResponses, CharityComplianceGetCompliancePacketRenderErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetCompliancePacketRenderResponses, CharityComplianceGetCompliancePacketRenderErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/packets/{packet_id}/render', ...options });

/**
 * Get Compliance Profile
 *
 * The facts your organization has recorded about itself.
 *
 * Each one was entered by someone at your organization and is shown with who recorded
 * it and when. Givmo does not confirm these facts; the register's candidates and every
 * computed date rest on them, so keeping them current is what keeps those accurate.
 *
 * `missing_required_parameter_keys` lists what still has to be recorded before
 * candidate obligations can be worked out at all.
 */
export const charityComplianceGetComplianceProfile = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceProfileData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceProfileResponses, CharityComplianceGetComplianceProfileErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceProfileResponses, CharityComplianceGetComplianceProfileErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/profile', ...options });

/**
 * List Compliance Profile Parameters
 *
 * The facts your organization recorded — in force first, then their history.
 *
 * Recording a fact again does not edit what was there: it writes a new entry and
 * marks the previous one superseded, so an obligation your organization confirmed
 * against an earlier value still shows the value it was confirmed against.
 */
export const charityComplianceListComplianceProfileParameters = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceProfileParametersData, ThrowOnError>): RequestResult<CharityComplianceListComplianceProfileParametersResponses, CharityComplianceListComplianceProfileParametersErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceProfileParametersResponses, CharityComplianceListComplianceProfileParametersErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/profile/parameters', ...options });

/**
 * Record Compliance Profile Parameter
 *
 * Record ONE fact about your organization.
 *
 * PUT rather than POST because your organization has exactly one value in force for
 * each fact. Recording again does not edit the previous entry — it writes a new one
 * and supersedes the old, so anything already computed can still show the value it
 * was computed from.
 *
 * When the fact you record is one the register reads, the response says so and links
 * the re-derivation. Nothing is re-derived for you: a re-derivation puts candidate
 * obligations in front of your organization to review, and that is a step someone at
 * your organization takes.
 */
export const charityComplianceRecordComplianceProfileParameter = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceProfileParameterData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceProfileParameterResponses, CharityComplianceRecordComplianceProfileParameterErrors, ThrowOnError> => (options.client ?? client).put<CharityComplianceRecordComplianceProfileParameterResponses, CharityComplianceRecordComplianceProfileParameterErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/profile/parameters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Registration Imports
 *
 * Registrations your organization already held when it started here.
 *
 * `artifact_state` is `requested` where the confirmation the state issued has not
 * been supplied yet. Those obligations are in the register and confirmed; they carry
 * no filing record, because the register records filings it can show the state's own
 * document for.
 */
export const charityComplianceListComplianceRegistrationImports = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceRegistrationImportsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceRegistrationImportsResponses, CharityComplianceListComplianceRegistrationImportsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceRegistrationImportsResponses, CharityComplianceListComplianceRegistrationImportsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/profile/registration-imports', ...options });

/**
 * Import Compliance Registration
 *
 * Record ONE registration your organization already holds.
 *
 * This route takes exactly one registration — importing puts the obligation into your
 * organization's register.
 *
 * Supplying the confirmation the state issued records the filing, exactly as
 * recording any other filing does. Importing without one is fully supported: the
 * obligation goes into the register with no filing record against it, and the
 * confirmation is noted as still to be supplied.
 */
export const charityComplianceImportComplianceRegistration = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceImportComplianceRegistrationData, ThrowOnError>): RequestResult<CharityComplianceImportComplianceRegistrationResponses, CharityComplianceImportComplianceRegistrationErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceImportComplianceRegistrationResponses, CharityComplianceImportComplianceRegistrationErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/profile/registration-imports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Registration Import Amendments
 *
 * Every correction recorded against this imported registration, oldest first.
 *
 * The whole chain, not a page of it: this is the answer to what your organization has
 * said about this registration over time, and half of it would be a different answer.
 * Each entry names the field, what the record said before, what it says now, who
 * recorded it and when.
 */
export const charityComplianceListComplianceRegistrationImportAmendments = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceRegistrationImportAmendmentsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceRegistrationImportAmendmentsResponses, CharityComplianceListComplianceRegistrationImportAmendmentsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceRegistrationImportAmendmentsResponses, CharityComplianceListComplianceRegistrationImportAmendmentsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/profile/registration-imports/{import_id}/amendments', ...options });

/**
 * Amend Compliance Registration Import
 *
 * Correct a detail your organization typed when it recorded this registration.
 *
 * The correction is recorded BESIDE the original, not over it. The imported record
 * keeps saying what your organization first entered, this amendment says what it says
 * now, and both are shown with who recorded them and when.
 *
 * It changes nothing about the filing itself: not the confirmation the state issued,
 * not the date it was filed, not what the register shows about this obligation. Only
 * details your organization typed can be amended, and the recorded confirmation is
 * never one of them.
 */
export const charityComplianceAmendComplianceRegistrationImport = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAmendComplianceRegistrationImportData, ThrowOnError>): RequestResult<CharityComplianceAmendComplianceRegistrationImportResponses, CharityComplianceAmendComplianceRegistrationImportErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAmendComplianceRegistrationImportResponses, CharityComplianceAmendComplianceRegistrationImportErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/profile/registration-imports/{import_id}/amendments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Profile Review Flags
 *
 * Where a figure your organization recorded and a figure Givmo measured differ.
 *
 * Each row shows both numbers and where each came from. Givmo does not decide which
 * is correct and does not change what your organization recorded — the two figures
 * can legitimately differ, for instance where most of your revenue does not come
 * through Givmo.
 */
export const charityComplianceListComplianceProfileReviewFlags = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceProfileReviewFlagsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceProfileReviewFlagsResponses, CharityComplianceListComplianceProfileReviewFlagsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceProfileReviewFlagsResponses, CharityComplianceListComplianceProfileReviewFlagsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/profile/review-flags', ...options });

/**
 * Resolve Compliance Profile Review Flag
 *
 * Close ONE flagged difference, recording what your organization decided.
 *
 * Either your organization stands by the figure it recorded, or it records the figure
 * again. Closing a flag changes nothing about the fact itself — to change the fact,
 * record it again.
 */
export const charityComplianceResolveComplianceProfileReviewFlag = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceResolveComplianceProfileReviewFlagData, ThrowOnError>): RequestResult<CharityComplianceResolveComplianceProfileReviewFlagResponses, CharityComplianceResolveComplianceProfileReviewFlagErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceResolveComplianceProfileReviewFlagResponses, CharityComplianceResolveComplianceProfileReviewFlagErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/profile/review-flags/{review_flag_id}/resolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Profile Suggestions
 *
 * Values read off documents your organization uploaded, for it to check.
 *
 * Each row shows what was read and where it was read from. None of them is recorded
 * against your organization until someone at your organization confirms it — or
 * enters a different value, which is recorded as theirs.
 */
export const charityComplianceListComplianceProfileSuggestions = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceProfileSuggestionsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceProfileSuggestionsResponses, CharityComplianceListComplianceProfileSuggestionsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceProfileSuggestionsResponses, CharityComplianceListComplianceProfileSuggestionsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/profile/suggestions', ...options });

/**
 * Resolve Compliance Profile Suggestion
 *
 * Confirm, correct or decline ONE value read off a document.
 *
 * Your organization's answer is what is recorded. Confirming records the value that
 * was read; correcting records the value you enter instead; declining records
 * nothing. In every case the entry names the person who answered, not the reading.
 *
 * Accepting a value has the same consequences as typing it: the dates of obligations
 * your organization has already confirmed are recalculated against it, and the
 * response says whether re-deriving candidate obligations is now worth doing.
 */
export const charityComplianceResolveComplianceProfileSuggestion = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceResolveComplianceProfileSuggestionData, ThrowOnError>): RequestResult<CharityComplianceResolveComplianceProfileSuggestionResponses, CharityComplianceResolveComplianceProfileSuggestionErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceResolveComplianceProfileSuggestionResponses, CharityComplianceResolveComplianceProfileSuggestionErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/profile/suggestions/{suggestion_id}/resolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Proposal
 *
 * The organization's open proposal and its newest revision.
 *
 * A proposal presents an assessment of the organization's rules over its recorded facts:
 * the filings identified, the rules excluded, the facts still to record and the conditions
 * left unresolved. It is a record of what was computed, and it changes nothing by itself.
 * None exists until one is generated.
 */
export const charityComplianceGetComplianceProposal = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceProposalData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceProposalResponses, CharityComplianceGetComplianceProposalErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceProposalResponses, CharityComplianceGetComplianceProposalErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/proposal', ...options });

/**
 * List Compliance Review Asks
 *
 * The organization's asks about items of its review, newest first; with `asked_user_id`,
 * those of one person, and with `state`, those `open`, `resolved` (the item was decided),
 * `withdrawn` or `replaced`.
 */
export const charityComplianceListComplianceReviewAsks = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceReviewAsksData, ThrowOnError>): RequestResult<CharityComplianceListComplianceReviewAsksResponses, CharityComplianceListComplianceReviewAsksErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceReviewAsksResponses, CharityComplianceListComplianceReviewAsksErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/proposal/asks', ...options });

/**
 * Ask About Compliance Review Item
 *
 * Ask a teammate who can make changes in Compliance about one item of the revision being
 * reviewed, with an optional note; they get an email with a link to the review.
 *
 * Asking again about the item replaces the open ask, and the same ask sent again answers the
 * open one. An ask decides nothing: the item stays open until the organization decides it.
 */
export const charityComplianceAskAboutComplianceReviewItem = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAskAboutComplianceReviewItemData, ThrowOnError>): RequestResult<CharityComplianceAskAboutComplianceReviewItemResponses, CharityComplianceAskAboutComplianceReviewItemErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAskAboutComplianceReviewItemResponses, CharityComplianceAskAboutComplianceReviewItemErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/proposal/asks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw Compliance Review Ask
 *
 * Withdraw an ask of a teammate. An ask already withdrawn or replaced is answered as it
 * stands.
 */
export const charityComplianceWithdrawComplianceReviewAsk = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceWithdrawComplianceReviewAskData, ThrowOnError>): RequestResult<CharityComplianceWithdrawComplianceReviewAskResponses, CharityComplianceWithdrawComplianceReviewAskErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceWithdrawComplianceReviewAskResponses, CharityComplianceWithdrawComplianceReviewAskErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/proposal/asks/{ask_id}/withdrawal', ...options });

/**
 * Generate Compliance Proposal Revision
 *
 * Assess the organization's rules over its recorded facts, as of today, and present the
 * result as the proposal's next revision.
 *
 * Each rule in scope gets one result, with its basis: the rule's conditions, how each came
 * out and the facts used. When nothing has moved since the newest revision, that revision
 * is returned and nothing new is recorded. Generating a revision adopts no fact, puts
 * nothing on the calendar and sends nothing.
 */
export const charityComplianceGenerateComplianceProposalRevision = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGenerateComplianceProposalRevisionData, ThrowOnError>): RequestResult<CharityComplianceGenerateComplianceProposalRevisionResponses, CharityComplianceGenerateComplianceProposalRevisionErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceGenerateComplianceProposalRevisionResponses, CharityComplianceGenerateComplianceProposalRevisionErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/proposal/revisions', ...options });

/**
 * Get Compliance Proposal Revision
 *
 * One revision of the organization's proposal.
 *
 * It says what moved since the previous revision, how many results and items of each kind it
 * holds, and whether it still reads what it was computed from: a fact recorded or corrected,
 * a rule re-versioned, the calendar changed, or the date moving into another period each
 * make it stale. A stale revision is shown as it was; the organization generates a new one.
 */
export const charityComplianceGetComplianceProposalRevision = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceProposalRevisionData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceProposalRevisionResponses, CharityComplianceGetComplianceProposalRevisionErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceProposalRevisionResponses, CharityComplianceGetComplianceProposalRevisionErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/proposal/revisions/{revision_id}', ...options });

/**
 * List Compliance Proposal Items
 *
 * A revision's items, in the order they are presented; with `kind`, one kind's.
 *
 * The kinds are a filing identified (`filing_work`, with the dates it would take on the
 * calendar), a rule excluded (`exclusion`), a fact to record (`question`, with the rules
 * its answer decides), an unresolved condition (`issue`), and a filing already on the
 * calendar that the evaluation now reads otherwise (`change`). A rule's item carries its
 * result.
 */
export const charityComplianceListComplianceProposalItems = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceProposalItemsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceProposalItemsResponses, CharityComplianceListComplianceProposalItemsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceProposalItemsResponses, CharityComplianceListComplianceProposalItemsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/proposal/revisions/{revision_id}/items', ...options });

/**
 * List Compliance Proposal Results
 *
 * The results of a revision's assessment, one per rule in scope, in the rules' order;
 * with `result`, one result's.
 *
 * Each is `filing_identified`, `rule_excluded`, `facts_missing`, `unresolved` or
 * `not_supported`, with its basis on the same object: the rule's citation and source, each
 * condition's outcome, the facts used, the facts missing, and the reason where the rule
 * calls for no filing, is unresolved or is not evaluated.
 */
export const charityComplianceListComplianceProposalResults = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceProposalResultsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceProposalResultsResponses, CharityComplianceListComplianceProposalResultsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceProposalResultsResponses, CharityComplianceListComplianceProposalResultsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/proposal/revisions/{revision_id}/results', ...options });

/**
 * Get Compliance Proposal Review
 *
 * The review recorded on one revision: each item the organization decided, what the
 * decision did, who decided and when, and the version of the not-a-substitute sentence shown
 * when it was recorded.
 */
export const charityComplianceGetComplianceProposalReview = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceProposalReviewData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceProposalReviewResponses, CharityComplianceGetComplianceProposalReviewErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceProposalReviewResponses, CharityComplianceGetComplianceProposalReviewErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/proposal/revisions/{revision_id}/review', ...options });

/**
 * Record Compliance Proposal Review
 *
 * Record the organization's decisions on the items of one revision it was shown, with
 * that revision's digest as it was shown.
 *
 * Each decision names an item of the revision: accept or deny a filing identified or a rule
 * excluded, or defer any item. Only the items listed are decided. Accepting a filing puts it
 * on the calendar as the organization's decision; denying one records that the organization
 * chose not to, beside the assessment, which stays as it was computed. A revision is reviewed
 * once: one that changed since it was shown, or already carries a review, is refused so it can
 * be shown again, and the same decisions sent again answer the review already recorded. It
 * signs nothing, authorizes no submission and sends nothing.
 */
export const charityComplianceRecordComplianceProposalReview = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceProposalReviewData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceProposalReviewResponses, CharityComplianceRecordComplianceProposalReviewErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceProposalReviewResponses, CharityComplianceRecordComplianceProposalReviewErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/proposal/revisions/{revision_id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Renewal Cycles
 *
 * Recorded renewal cycles, including earlier dates and their confirmations.
 */
export const charityComplianceListComplianceRenewalCycles = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceRenewalCyclesData, ThrowOnError>): RequestResult<CharityComplianceListComplianceRenewalCyclesResponses, CharityComplianceListComplianceRenewalCyclesErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceRenewalCyclesResponses, CharityComplianceListComplianceRenewalCyclesErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/renewal-cycles', ...options });

/**
 * Get Compliance Renewal Cycle
 *
 * One recorded cycle with its dated changes and confirmation history.
 */
export const charityComplianceGetComplianceRenewalCycle = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceRenewalCycleData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceRenewalCycleResponses, CharityComplianceGetComplianceRenewalCycleErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceRenewalCycleResponses, CharityComplianceGetComplianceRenewalCycleErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/renewal-cycles/{cycle_id}', ...options });

/**
 * Add Compliance Renewal Attachment
 *
 * Keep one more document with one renewal cycle, beside its filing and confirmation.
 * The document must already be uploaded for your organization; adding it again changes
 * nothing.
 */
export const charityComplianceAddComplianceRenewalAttachment = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAddComplianceRenewalAttachmentData, ThrowOnError>): RequestResult<CharityComplianceAddComplianceRenewalAttachmentResponses, CharityComplianceAddComplianceRenewalAttachmentErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAddComplianceRenewalAttachmentResponses, CharityComplianceAddComplianceRenewalAttachmentErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/renewal-cycles/{cycle_id}/attachments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach Compliance Renewal Filed Copy
 *
 * Attach the filing itself, as your organization sent it, to one renewal cycle. A
 * cycle keeps one; the document must already be uploaded for your organization. It is
 * kept with the cycle's records and is not the jurisdiction's confirmation.
 */
export const charityComplianceAttachComplianceRenewalFiledCopy = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceAttachComplianceRenewalFiledCopyData, ThrowOnError>): RequestResult<CharityComplianceAttachComplianceRenewalFiledCopyResponses, CharityComplianceAttachComplianceRenewalFiledCopyErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceAttachComplianceRenewalFiledCopyResponses, CharityComplianceAttachComplianceRenewalFiledCopyErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/renewal-cycles/{cycle_id}/filed-copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Compliance Renewal Filing
 *
 * Record the jurisdiction's confirmation for one selected renewal cycle.
 */
export const charityComplianceRecordComplianceRenewalFiling = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceRenewalFilingData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceRenewalFilingResponses, CharityComplianceRecordComplianceRenewalFilingErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceRenewalFilingResponses, CharityComplianceRecordComplianceRenewalFilingErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/renewal-cycles/{cycle_id}/filing-records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Compliance Renewal Submission
 *
 * Record that your organization sent one renewal cycle's filing, on the date you give,
 * with your own proof of sending if you have one. It records what your organization did
 * and says nothing about what the jurisdiction did; the cycle is not marked filed until
 * the jurisdiction's confirmation is recorded.
 */
export const charityComplianceRecordComplianceRenewalSubmission = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceRenewalSubmissionData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceRenewalSubmissionResponses, CharityComplianceRecordComplianceRenewalSubmissionErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRecordComplianceRenewalSubmissionResponses, CharityComplianceRecordComplianceRenewalSubmissionErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/renewal-cycles/{cycle_id}/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Ai Setting
 *
 * The organization's "Use AI on your organization's data" setting.
 *
 * It covers Givmo's AI only. While it is off, Givmo reads no document with AI, drafts
 * nothing with AI, and prepares or files nothing with AI; everything the organization adds
 * itself works the same. The organization's own connected AI is not governed by it. It is
 * on until the organization turns it off: revision 0 means it was never changed, and then
 * nobody is named.
 */
export const charityComplianceGetComplianceAiSetting = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceAiSettingData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceAiSettingResponses, CharityComplianceGetComplianceAiSettingErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceAiSettingResponses, CharityComplianceGetComplianceAiSettingErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/settings/ai', ...options });

/**
 * Set Compliance Ai Setting
 *
 * Turn Givmo's AI on or off for the organization.
 *
 * A Compliance Owner or a Global Admin changes it. The change is made from the revision it
 * was read at: a change made from an older one is refused and nothing is recorded, so it
 * never lands over a change its author did not see. Each change records who made it and
 * when; asking for the value already in force records nothing. Answers with the setting.
 */
export const charityComplianceSetComplianceAiSetting = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceSetComplianceAiSettingData, ThrowOnError>): RequestResult<CharityComplianceSetComplianceAiSettingResponses, CharityComplianceSetComplianceAiSettingErrors, ThrowOnError> => (options.client ?? client).put<CharityComplianceSetComplianceAiSettingResponses, CharityComplianceSetComplianceAiSettingErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/settings/ai',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Signing Setting
 *
 * The organization's sign-in check before signing.
 *
 * None by default: a signed-in member signs by one deliberate act, and the record of the
 * signature names when they last signed in, and how. An organization may require a sign-in
 * again within the last day, within the last 30 minutes, or for every signature. Revision 0
 * means it was never changed.
 */
export const charityComplianceGetComplianceSigningSetting = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceSigningSettingData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceSigningSettingResponses, CharityComplianceGetComplianceSigningSettingErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceSigningSettingResponses, CharityComplianceGetComplianceSigningSettingErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/settings/signing', ...options });

/**
 * Set Compliance Signing Setting
 *
 * Change the organization's sign-in check before signing.
 *
 * A Compliance Owner or a Global Admin changes it, from the revision it was read at: a
 * change made from an older one is refused and nothing is recorded. Making it stricter
 * asks for nothing; making it less strict asks the person to meet the check in force first.
 * Each change records who made it, when, and what the person showed.
 */
export const charityComplianceSetComplianceSigningSetting = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceSetComplianceSigningSettingData, ThrowOnError>): RequestResult<CharityComplianceSetComplianceSigningSettingResponses, CharityComplianceSetComplianceSigningSettingErrors, ThrowOnError> => (options.client ?? client).put<CharityComplianceSetComplianceSigningSettingResponses, CharityComplianceSetComplianceSigningSettingErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/settings/signing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Compliance Signing People
 *
 * Everyone the organization's signing requests hold sign-in details for, newest first:
 * each person who signed, declined or withdrew a signature on a request, completed or not,
 * and each person who sent one. Each comes with how many requests hold their details and the
 * request to direct their removal on.
 */
export const charityComplianceListComplianceSigningPeople = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceSigningPeopleData, ThrowOnError>): RequestResult<CharityComplianceListComplianceSigningPeopleResponses, CharityComplianceListComplianceSigningPeopleErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceSigningPeopleResponses, CharityComplianceListComplianceSigningPeopleErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/signing-people', ...options });

/**
 * List Compliance Signing Requests
 *
 * The organization's signing requests, oldest first; with `filing_case_id`, one filing
 * case's; with `state`, the requests in that state (a request whose sign-by date has passed
 * reads expired).
 */
export const charityComplianceListComplianceSigningRequests = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceSigningRequestsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceSigningRequestsResponses, CharityComplianceListComplianceSigningRequestsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceSigningRequestsResponses, CharityComplianceListComplianceSigningRequestsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/signing-requests', ...options });

/**
 * Issue Compliance Signing Request
 *
 * Send a filing case's documents out for signature.
 *
 * Name each document at the version its signers sign (Givmo's flattened copy, where the
 * upload had filled fields), a signer for every signature place the form has and the
 * capacity the organization states for each, how the filing will be sent, and the time zone
 * its dates are written in. A note for the signers and a sign-by date are optional.
 * Everyone named needs access to Compliance. One request can be open for a filing case: a
 * package of other documents replaces the open one, and the same package again is refused.
 * Refused, with nothing recorded, where Givmo can't sign a document of the package.
 */
export const charityComplianceIssueComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceIssueComplianceSigningRequestData, ThrowOnError>): RequestResult<CharityComplianceIssueComplianceSigningRequestResponses, CharityComplianceIssueComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceIssueComplianceSigningRequestResponses, CharityComplianceIssueComplianceSigningRequestErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/signing-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Signing Request
 *
 * One signing request with its live version: each document and whether Givmo can sign
 * it, its pages as the signers see them, every signature place and where it stands, the
 * acts on this version, the caller's own places and what they can do now, and what changed
 * around it since it was sent.
 */
export const charityComplianceGetComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceSigningRequestData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceSigningRequestResponses, CharityComplianceGetComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceSigningRequestResponses, CharityComplianceGetComplianceSigningRequestErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}', ...options });

/**
 * Cancel Compliance Signing Request
 *
 * Cancel an open request, with an optional reason. Cancelling a cancelled request
 * changes nothing.
 */
export const charityComplianceCancelComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceCancelComplianceSigningRequestData, ThrowOnError>): RequestResult<CharityComplianceCancelComplianceSigningRequestResponses, CharityComplianceCancelComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceCancelComplianceSigningRequestResponses, CharityComplianceCancelComplianceSigningRequestErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}/cancellation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decline Compliance Signing Request
 *
 * Decline to sign the live version, with an optional reason for the sender. A decline
 * is not final: the caller can sign later, and the request stays open.
 */
export const charityComplianceDeclineComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceDeclineComplianceSigningRequestData, ThrowOnError>): RequestResult<CharityComplianceDeclineComplianceSigningRequestResponses, CharityComplianceDeclineComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceDeclineComplianceSigningRequestResponses, CharityComplianceDeclineComplianceSigningRequestErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}/declines',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Signing Evidence
 *
 * A completed request's signing record: who signed which document, and when, with the
 * sign-in facts each signature's session showed (or when they were removed at the
 * organization's direction), the versions sent, what the signers were shown and the checks on
 * the signed forms. A short-lived link to its exact bytes, as a PDF (the default) or as data
 * (`format=json`), and the record of issuing the link. A request that is not completed has
 * none.
 */
export const charityComplianceGetComplianceSigningEvidence = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceSigningEvidenceData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceSigningEvidenceResponses, CharityComplianceGetComplianceSigningEvidenceErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceSigningEvidenceResponses, CharityComplianceGetComplianceSigningEvidenceErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}/evidence', ...options });

/**
 * Extend Compliance Signing Request
 *
 * Move an open request's sign-by date later. The same date again changes nothing; an
 * earlier one is refused, and so is any change once the date has passed.
 */
export const charityComplianceExtendComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceExtendComplianceSigningRequestData, ThrowOnError>): RequestResult<CharityComplianceExtendComplianceSigningRequestResponses, CharityComplianceExtendComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).put<CharityComplianceExtendComplianceSigningRequestResponses, CharityComplianceExtendComplianceSigningRequestErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}/expiry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Signing Export
 *
 * A completed request's export: one zip holding each signed form, each form as it was
 * prepared, the signing record as a PDF and as data, and a list of each file's SHA-256. A
 * short-lived link to it and the record of issuing the link. Every file is read back and
 * matched to its record first: one that does not match refuses the export rather than hand
 * over something else.
 */
export const charityComplianceGetComplianceSigningExport = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceSigningExportData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceSigningExportResponses, CharityComplianceGetComplianceSigningExportErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceSigningExportResponses, CharityComplianceGetComplianceSigningExportErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}/export', ...options });

/**
 * Remove Compliance Signing Identity
 *
 * At the organization's direction, remove the sign-in email, IP address and browser of a
 * person who acted on this request or sent it from every signing record the organization holds.
 * The signatures and the signed forms stay as they are. Each record is written again and says
 * the details were removed, and the removal keeps the digests of the files it replaced.
 */
export const charityComplianceRemoveComplianceSigningIdentity = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRemoveComplianceSigningIdentityData, ThrowOnError>): RequestResult<CharityComplianceRemoveComplianceSigningIdentityResponses, CharityComplianceRemoveComplianceSigningIdentityErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRemoveComplianceSigningIdentityResponses, CharityComplianceRemoveComplianceSigningIdentityErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}/identity-removals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Compliance Signing Record Lines
 *
 * A completed request's signing record as a page shows it beside the signed form: the
 * record's own first-page lines, read from the stored record and matched to it first, each
 * SHA-256 shortened to its first and last four characters. Nothing is handed over, so
 * nothing is added to the download record. A request that is not completed has none.
 */
export const charityComplianceGetComplianceSigningRecordLines = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceSigningRecordLinesData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceSigningRecordLinesResponses, CharityComplianceGetComplianceSigningRecordLinesErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceSigningRecordLinesResponses, CharityComplianceGetComplianceSigningRecordLinesErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}/record', ...options });

/**
 * Revise Compliance Signing Request
 *
 * A new version of an open request: its signers and capacities, the channel, the time
 * zone and the note, from the version it was read at. Every signature starts over. The
 * documents change only by sending a new request.
 */
export const charityComplianceReviseComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceReviseComplianceSigningRequestData, ThrowOnError>): RequestResult<CharityComplianceReviseComplianceSigningRequestResponses, CharityComplianceReviseComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceReviseComplianceSigningRequestResponses, CharityComplianceReviseComplianceSigningRequestErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}/revisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw Compliance Signature
 *
 * Withdraw the caller's own signature from the live version, before the request is
 * completed.
 */
export const charityComplianceWithdrawComplianceSignature = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceWithdrawComplianceSignatureData, ThrowOnError>): RequestResult<CharityComplianceWithdrawComplianceSignatureResponses, CharityComplianceWithdrawComplianceSignatureErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceWithdrawComplianceSignatureResponses, CharityComplianceWithdrawComplianceSignatureErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}/signature-withdrawals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign Compliance Signing Request
 *
 * Sign every place the caller holds on the live version, by their typed name, under the
 * statement shown above the button.
 *
 * Name the version as it was read: a request that changed since is refused, and so is a
 * signature already made (the answer names it). Where the organization asks for a recent
 * sign-in, the caller signs in again first.
 */
export const charityComplianceSignComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceSignComplianceSigningRequestData, ThrowOnError>): RequestResult<CharityComplianceSignComplianceSigningRequestResponses, CharityComplianceSignComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceSignComplianceSigningRequestResponses, CharityComplianceSignComplianceSigningRequestErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/signing-requests/{request_id}/signatures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reconcile Compliance Submission Attempt
 *
 * Record what you found about a send whose outcome is uncertain.
 *
 * That the copy arrived, or Givmo staff saw it in the email service's records, records it as
 * sent; that the copy never arrived records it as not sent. Nothing is sent again.
 */
export const charityComplianceReconcileComplianceSubmissionAttempt = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceReconcileComplianceSubmissionAttemptData, ThrowOnError>): RequestResult<CharityComplianceReconcileComplianceSubmissionAttemptResponses, CharityComplianceReconcileComplianceSubmissionAttemptErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceReconcileComplianceSubmissionAttemptResponses, CharityComplianceReconcileComplianceSubmissionAttemptErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/submission-attempts/{attempt_id}/reconcile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dispatch Compliance Submission
 *
 * Send the authorized filing by email, once.
 *
 * The send is recorded before the email leaves, then what Givmo's email service answered.
 * Repeating a send already made answers it and sends nothing again.
 */
export const charityComplianceDispatchComplianceSubmission = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceDispatchComplianceSubmissionData, ThrowOnError>): RequestResult<CharityComplianceDispatchComplianceSubmissionResponses, CharityComplianceDispatchComplianceSubmissionErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceDispatchComplianceSubmissionResponses, CharityComplianceDispatchComplianceSubmissionErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/submission-authorizations/{authorization_id}/attempts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Compliance Submission Authorization
 *
 * Revoke an authorization to send, so nothing goes under it.
 *
 * Refused while a send under it is in progress or its outcome is uncertain.
 */
export const charityComplianceRevokeComplianceSubmissionAuthorization = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRevokeComplianceSubmissionAuthorizationData, ThrowOnError>): RequestResult<CharityComplianceRevokeComplianceSubmissionAuthorizationResponses, CharityComplianceRevokeComplianceSubmissionAuthorizationErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceRevokeComplianceSubmissionAuthorizationResponses, CharityComplianceRevokeComplianceSubmissionAuthorizationErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/submission-authorizations/{authorization_id}/revoke', ...options });

/**
 * List Compliance Submission Follow Through
 *
 * What is known about each filing's latest send, newest first.
 *
 * For each filing case with something sent, by Givmo or recorded by your organization: the
 * day it went, how many of the case's sends went before it, and what is known so far, such as
 * the email service's report of its delivery, a record someone in your organization made of
 * the agency's answer, the filing's confirmation on file, or that Givmo can't tell whether
 * its email went. Reading it sends nothing.
 */
export const charityComplianceListComplianceSubmissionFollowThrough = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceSubmissionFollowThroughData, ThrowOnError>): RequestResult<CharityComplianceListComplianceSubmissionFollowThroughResponses, CharityComplianceListComplianceSubmissionFollowThroughErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceSubmissionFollowThroughResponses, CharityComplianceListComplianceSubmissionFollowThroughErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/submission-follow-through', ...options });

/**
 * List Compliance Vendors
 *
 * Recorded registered-agent and foreign-qualification facts, with provenance.
 */
export const charityComplianceListComplianceVendors = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceListComplianceVendorsData, ThrowOnError>): RequestResult<CharityComplianceListComplianceVendorsResponses, CharityComplianceListComplianceVendorsErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceListComplianceVendorsResponses, CharityComplianceListComplianceVendorsErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/vendor-records', ...options });

/**
 * Get Compliance Vendor
 *
 * One factual vendor record and each attributed correction.
 */
export const charityComplianceGetComplianceVendor = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceGetComplianceVendorData, ThrowOnError>): RequestResult<CharityComplianceGetComplianceVendorResponses, CharityComplianceGetComplianceVendorErrors, ThrowOnError> => (options.client ?? client).get<CharityComplianceGetComplianceVendorResponses, CharityComplianceGetComplianceVendorErrors, ThrowOnError>({ url: '/charity-admin/compliance/charities/{charity_id}/vendor-records/{vendor_id}', ...options });

/**
 * Record Compliance Vendor
 *
 * Record or correct one row. Zero revision creates a new caller-chosen id.
 */
export const charityComplianceRecordComplianceVendor = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceRecordComplianceVendorData, ThrowOnError>): RequestResult<CharityComplianceRecordComplianceVendorResponses, CharityComplianceRecordComplianceVendorErrors, ThrowOnError> => (options.client ?? client).put<CharityComplianceRecordComplianceVendorResponses, CharityComplianceRecordComplianceVendorErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/vendor-records/{vendor_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link Compliance Vendor Filing
 *
 * Link a record to the library filing it is (CCM-MOD5-RECORD-FILING-LINK): the
 * organization's own statement, recorded on both histories with who made it. The filing
 * then shows the record's renewal date where the library has none. The same link again is
 * answered as it stands.
 */
export const charityComplianceLinkComplianceVendorFiling = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceLinkComplianceVendorFilingData, ThrowOnError>): RequestResult<CharityComplianceLinkComplianceVendorFilingResponses, CharityComplianceLinkComplianceVendorFilingErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceLinkComplianceVendorFilingResponses, CharityComplianceLinkComplianceVendorFilingErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/vendor-records/{vendor_id}/filing-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unlink Compliance Vendor Filing
 *
 * Undo the link between a record and a filing (CCM-MOD5-RECORD-FILING-LINK). Both
 * histories keep the link and record the unlink. A pair no longer linked is answered with the
 * link as it was closed; a pair never linked is refused.
 */
export const charityComplianceUnlinkComplianceVendorFiling = <ThrowOnError extends boolean = false>(options: Options<CharityComplianceUnlinkComplianceVendorFilingData, ThrowOnError>): RequestResult<CharityComplianceUnlinkComplianceVendorFilingResponses, CharityComplianceUnlinkComplianceVendorFilingErrors, ThrowOnError> => (options.client ?? client).post<CharityComplianceUnlinkComplianceVendorFilingResponses, CharityComplianceUnlinkComplianceVendorFilingErrors, ThrowOnError>({
    url: '/charity-admin/compliance/charities/{charity_id}/vendor-records/{vendor_id}/filing-unlink',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Enrollments
 *
 * The organization's own records, newest first.
 *
 * The canonical `{data, meta, links}` envelope, like every other `/charity-admin`
 * listing — a new consumer-surface list takes shape 1, and the bare `{data}` form is
 * reserved for the grandfathered reference lists. Worth noting because the
 * conformance test cannot catch the difference (a bare `{data}` still carries a
 * `data` key), so this is a rule a reader enforces.
 *
 * Paginated for a real reason, not for symmetry: enrollment is a once-ever act, but
 * withdrawn and rejected records accumulate without bound because withdrawing is the
 * sanctioned way to start over.
 */
export const charityEnrollmentListEnrollments = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentListEnrollmentsData, ThrowOnError>): RequestResult<CharityEnrollmentListEnrollmentsResponses, CharityEnrollmentListEnrollmentsErrors, ThrowOnError> => (options.client ?? client).get<CharityEnrollmentListEnrollmentsResponses, CharityEnrollmentListEnrollmentsErrors, ThrowOnError>({ url: '/charity-admin/enrollment/charities/{charity_id}/enrollments', ...options });

/**
 * Create Enrollment Draft
 *
 * Start the organization's enrollment record.
 *
 * 201 with a `Location` header, because this mints a resource the caller then works
 * against by id. A second live record is refused rather than silently created:
 * enrollment is a once-ever act per entity.
 *
 * Both of the draft's optional fields are applied. `fiscal_year_end_month` was
 * accepted, range-checked, and then never passed to the command, so a caller who
 * stated a June year-end at creation got a record carrying nothing and had to PATCH
 * the same value in afterwards. The field is settled at submission either way, so
 * nothing downstream was wrong — it was the caller's stated answer that was dropped.
 */
export const charityEnrollmentCreateEnrollmentDraft = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentCreateEnrollmentDraftData, ThrowOnError>): RequestResult<CharityEnrollmentCreateEnrollmentDraftResponses, CharityEnrollmentCreateEnrollmentDraftErrors, ThrowOnError> => (options.client ?? client).post<CharityEnrollmentCreateEnrollmentDraftResponses, CharityEnrollmentCreateEnrollmentDraftErrors, ThrowOnError>({
    url: '/charity-admin/enrollment/charities/{charity_id}/enrollments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Enrollment
 *
 * One record and its event log.
 *
 * The log is the record of what happened and in what order; it is what makes the
 * surface able to say where the record has got to without asserting anything about
 * what happens next.
 */
export const charityEnrollmentGetEnrollment = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentGetEnrollmentData, ThrowOnError>): RequestResult<CharityEnrollmentGetEnrollmentResponses, CharityEnrollmentGetEnrollmentErrors, ThrowOnError> => (options.client ?? client).get<CharityEnrollmentGetEnrollmentResponses, CharityEnrollmentGetEnrollmentErrors, ThrowOnError>({ url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}', ...options });

/**
 * Update Enrollment Draft
 *
 * Edit the record's content while it is still editable.
 *
 * PATCH, and absent-vs-null is load-bearing: only fields the caller actually sent are
 * applied, so a partial update cannot blank a field the caller never mentioned. The
 * command's `model_fields_set` is what carries that through to the service.
 */
export const charityEnrollmentUpdateEnrollmentDraft = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentUpdateEnrollmentDraftData, ThrowOnError>): RequestResult<CharityEnrollmentUpdateEnrollmentDraftResponses, CharityEnrollmentUpdateEnrollmentDraftErrors, ThrowOnError> => (options.client ?? client).patch<CharityEnrollmentUpdateEnrollmentDraftResponses, CharityEnrollmentUpdateEnrollmentDraftErrors, ThrowOnError>({
    url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Backfill Choice
 *
 * Record how this organization's history comes in.
 *
 * Once. Opening balances and full history are different shapes, and the choice decides
 * which doors render and which rails a run may drive — so recording a DIFFERENT one
 * afterwards answers 409 and is an operator-mediated correction. Recording the same one
 * again is a replay and answers with the record's current state.
 */
export const charityEnrollmentRecordBackfillChoice = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentRecordBackfillChoiceData, ThrowOnError>): RequestResult<CharityEnrollmentRecordBackfillChoiceResponses, CharityEnrollmentRecordBackfillChoiceErrors, ThrowOnError> => (options.client ?? client).post<CharityEnrollmentRecordBackfillChoiceResponses, CharityEnrollmentRecordBackfillChoiceErrors, ThrowOnError>({
    url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/backfill-choice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Import Run
 *
 * Post into your organization's books — a cut-in, or a month of your bank activity.
 *
 * `idempotency_key` is required: sending the same key again answers with the run it
 * already named rather than running a second time. A second import over the same window
 * is a real second act, and only the caller knows which one this is.
 *
 * The rails take opposite inputs. A cut-in states a position as at a date, so it carries
 * `effective_date` and reads its figures from this record. A STANDING run covers one
 * `period` and carries that period's own population: `bank_export_csv` for the bank rail
 * (the institution's own CSV, unedited, classified through the bank-flow map recorded for
 * this organization) and `platform_facts` + `platform_facts_digest` for the platform rail.
 * A field the answering rail does not read is refused rather than dropped.
 *
 * A month may carry BOTH standing rails, and then it is ONE run: send both payloads and
 * the period posts as a single act. `rail` names the rail you are declaring and must be
 * one of the rails you sent — the run row records that declaration, while the bound
 * record is what carries the full per-rail account of what posted.
 *
 * The response is the run's TRUTHFUL state — it may have bound its record, or it may name
 * why it did not. Runs are refused, not queued: nothing here retries in the background.
 */
export const charityEnrollmentStartImportRun = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentStartImportRunData, ThrowOnError>): RequestResult<CharityEnrollmentStartImportRunResponses, CharityEnrollmentStartImportRunErrors, ThrowOnError> => (options.client ?? client).post<CharityEnrollmentStartImportRunResponses, CharityEnrollmentStartImportRunErrors, ThrowOnError>({
    url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/import-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Mapping Rows
 *
 * Every source account and merchant, and where each one posts.
 *
 * `unresolved_only=true` is the working view: what still stands between this
 * organization and a run. It includes DECLINED rows as well as untouched ones — a row
 * somebody looked at and would not answer still blocks, and hiding it would leave a run
 * refused by something nobody could find.
 */
export const charityEnrollmentListMappingRows = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentListMappingRowsData, ThrowOnError>): RequestResult<CharityEnrollmentListMappingRowsResponses, CharityEnrollmentListMappingRowsErrors, ThrowOnError> => (options.client ?? client).get<CharityEnrollmentListMappingRowsResponses, CharityEnrollmentListMappingRowsErrors, ThrowOnError>({ url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/mapping-rows', ...options });

/**
 * Resolve Mapping Row
 *
 * Confirm, correct or decline ONE source account or merchant.
 *
 * One row per call, and there is no bulk form. The tie a run computes proves that
 * everything the source held came across and that each source account's total matches;
 * it proves nothing at all about whether an account was mapped to the right place. This
 * is where that gets decided.
 */
export const charityEnrollmentResolveMappingRow = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentResolveMappingRowData, ThrowOnError>): RequestResult<CharityEnrollmentResolveMappingRowResponses, CharityEnrollmentResolveMappingRowErrors, ThrowOnError> => (options.client ?? client).post<CharityEnrollmentResolveMappingRowResponses, CharityEnrollmentResolveMappingRowErrors, ThrowOnError>({
    url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/mapping-rows/{mapping_row_id}/resolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert Entity Maps
 *
 * Record one rail's map and put every subject it names in front of a reviewer.
 *
 * PUT because an organization has exactly one map in force per rail. Recording again
 * does not edit the previous version — it writes a new one and supersedes the old, so an
 * import record that pinned an earlier version still names content that exists.
 *
 * The document is built through the accounting engine's own strict loader: an unknown
 * key, a missing required key, or a map naming other books is a 400 carrying the
 * loader's own message.
 */
export const charityEnrollmentUpsertEntityMaps = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentUpsertEntityMapsData, ThrowOnError>): RequestResult<CharityEnrollmentUpsertEntityMapsResponses, CharityEnrollmentUpsertEntityMapsErrors, ThrowOnError> => (options.client ?? client).put<CharityEnrollmentUpsertEntityMapsResponses, CharityEnrollmentUpsertEntityMapsErrors, ThrowOnError>({
    url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/maps',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Onboarding Records
 *
 * Your organization's onboarding records, oldest first.
 *
 * A stack, and only that: one entry for the books being opened, then one
 * for each import that brought something in. It grows whenever something real is added,
 * and nothing in it says setup is finished — no organization arrives with complete
 * historical books, and the books' own open items are where readiness is read from.
 */
export const charityEnrollmentListOnboardingRecords = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentListOnboardingRecordsData, ThrowOnError>): RequestResult<CharityEnrollmentListOnboardingRecordsResponses, CharityEnrollmentListOnboardingRecordsErrors, ThrowOnError> => (options.client ?? client).get<CharityEnrollmentListOnboardingRecordsResponses, CharityEnrollmentListOnboardingRecordsErrors, ThrowOnError>({ url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/onboarding-records', ...options });

/**
 * List Opening Balance Fields
 *
 * Each account's opening figure — what was proposed, and what you recorded.
 *
 * Amounts are debit-positive cents; a credit balance is negative, which is the same
 * convention a trial balance uses.
 */
export const charityEnrollmentListOpeningBalanceFields = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentListOpeningBalanceFieldsData, ThrowOnError>): RequestResult<CharityEnrollmentListOpeningBalanceFieldsResponses, CharityEnrollmentListOpeningBalanceFieldsErrors, ThrowOnError> => (options.client ?? client).get<CharityEnrollmentListOpeningBalanceFieldsResponses, CharityEnrollmentListOpeningBalanceFieldsErrors, ThrowOnError>({ url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/opening-balances', ...options });

/**
 * Seed Opening Balance Fields
 *
 * Put accounts in front of your organization, each with the figure proposed for it.
 *
 * This PROPOSES; it records nothing against the organization. Every account is then
 * answered on its own through the resolution route below, and the row keeps which of
 * the three answers a person gave.
 *
 * Re-seeding an account whose proposed figure has changed returns it to unanswered — a
 * figure that moved has not been agreed to.
 */
export const charityEnrollmentSeedOpeningBalanceFields = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentSeedOpeningBalanceFieldsData, ThrowOnError>): RequestResult<CharityEnrollmentSeedOpeningBalanceFieldsResponses, CharityEnrollmentSeedOpeningBalanceFieldsErrors, ThrowOnError> => (options.client ?? client).post<CharityEnrollmentSeedOpeningBalanceFieldsResponses, CharityEnrollmentSeedOpeningBalanceFieldsErrors, ThrowOnError>({
    url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/opening-balances',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Opening Balance Field
 *
 * Confirm, correct or decline ONE account's opening figure.
 *
 * One account per call. What your organization records here becomes a line of an entry
 * that cannot be edited afterwards, so each figure is somebody's own answer rather than
 * a page they agreed with. Confirming takes the proposed figure; correcting records
 * yours instead; declining records that you would not state one, and the import waits.
 */
export const charityEnrollmentConfirmOpeningBalanceField = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentConfirmOpeningBalanceFieldData, ThrowOnError>): RequestResult<CharityEnrollmentConfirmOpeningBalanceFieldResponses, CharityEnrollmentConfirmOpeningBalanceFieldErrors, ThrowOnError> => (options.client ?? client).post<CharityEnrollmentConfirmOpeningBalanceFieldResponses, CharityEnrollmentConfirmOpeningBalanceFieldErrors, ThrowOnError>({
    url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/opening-balances/{field_id}/resolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Enrollment
 *
 * Submit the record.
 *
 * The response is the record's TRUTHFUL state afterwards, which may be `submitted` or
 * `approved` — approval fires automatically the moment the precondition set is
 * satisfied, and does not when it is not. The caller renders what it is given rather
 * than assuming submission means approval.
 *
 * A replay returns the current state rather than refusing, so a caller who lost the
 * response and retried gets the outcome instead of an error about the retry.
 */
export const charityEnrollmentSubmitEnrollment = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentSubmitEnrollmentData, ThrowOnError>): RequestResult<CharityEnrollmentSubmitEnrollmentResponses, CharityEnrollmentSubmitEnrollmentErrors, ThrowOnError> => (options.client ?? client).post<CharityEnrollmentSubmitEnrollmentResponses, CharityEnrollmentSubmitEnrollmentErrors, ThrowOnError>({ url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/submission', ...options });

/**
 * Withdraw Enrollment
 *
 * Withdraw a draft or submitted record.
 *
 * An approved record refuses with a 400 — by approval it carries a permanent ledger
 * identity a committed store row may already be using, and the store never reuses
 * one. A withdrawn record does not block a fresh enrollment; that is what the state
 * is for.
 */
export const charityEnrollmentWithdrawEnrollment = <ThrowOnError extends boolean = false>(options: Options<CharityEnrollmentWithdrawEnrollmentData, ThrowOnError>): RequestResult<CharityEnrollmentWithdrawEnrollmentResponses, CharityEnrollmentWithdrawEnrollmentErrors, ThrowOnError> => (options.client ?? client).post<CharityEnrollmentWithdrawEnrollmentResponses, CharityEnrollmentWithdrawEnrollmentErrors, ThrowOnError>({
    url: '/charity-admin/enrollment/charities/{charity_id}/enrollments/{enrollment_id}/withdrawal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Charity Invite
 *
 * Redeem an invite token → create a ``charity_admin`` membership with the
 * invited role (``@is_authenticated``; the caller need not have a membership
 * yet). The caller's VERIFIED email (from the Firebase ID token —
 * ``request.state.idp_user``, NEVER the body) must match the invite's bound
 * email. Single-use + expiry enforced; every invalid condition (unknown / spent
 * / expired / wrong email) collapses to the SAME 400 (no oracle). Returns the
 * new membership (charity + role).
 */
export const charityAdminAcceptCharityInvite = <ThrowOnError extends boolean = false>(options: Options<CharityAdminAcceptCharityInviteData, ThrowOnError>): RequestResult<CharityAdminAcceptCharityInviteResponses, CharityAdminAcceptCharityInviteErrors, ThrowOnError> => (options.client ?? client).post<CharityAdminAcceptCharityInviteResponses, CharityAdminAcceptCharityInviteErrors, ThrowOnError>({
    url: '/charity-admin/invites/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List My Memberships
 */
export const charityAdminListMyMemberships = <ThrowOnError extends boolean = false>(options?: Options<CharityAdminListMyMembershipsData, ThrowOnError>): RequestResult<CharityAdminListMyMembershipsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CharityAdminListMyMembershipsResponses, unknown, ThrowOnError>({ url: '/charity-admin/memberships', ...options });

/**
 * Discover Charity Collections
 *
 * CC-BE18: GLOBAL discovery browse — the token-permissive, cross-creator
 * no-login funnel. NO `@is_authenticated` (mirrors `get_charity_collection` /
 * the fundraiser browse): `user` may be None (anonymous).
 *
 * The service/repo apply the SERVER-SIDE discoverable-set filter
 * (`visibility == PUBLIC AND status == ACTIVE AND unlisted_at IS NULL`). The
 * visibility clause is `== PUBLIC` — DELIBERATELY STRICTER than
 * `is_publicly_visible` (`!= PRIVATE`, which includes UNLISTED): UNLISTED
 * (link-only) collections are intentionally NOT browsable here (do not loosen
 * it to `!= PRIVATE` — see the repo `discover` docstring). That filter is
 * requester-independent and is the ONLY gate, so an anonymous and an
 * authenticated non-owner caller both see EXACTLY the discoverable set: a
 * private, unlisted-visibility, creator-deactivated, or super-admin-unlisted
 * collection can NEVER appear here. `show_on_profile` does NOT gate discovery
 * (it gates only the profile row).
 * Optional `q` is a simple name match; newest-first by default.
 */
export const charityCollectionsDiscoverCharityCollections = <ThrowOnError extends boolean = false>(options?: Options<CharityCollectionsDiscoverCharityCollectionsData, ThrowOnError>): RequestResult<CharityCollectionsDiscoverCharityCollectionsResponses, CharityCollectionsDiscoverCharityCollectionsErrors, ThrowOnError> => (options?.client ?? client).get<CharityCollectionsDiscoverCharityCollectionsResponses, CharityCollectionsDiscoverCharityCollectionsErrors, ThrowOnError>({ url: '/charity-collections', ...options });

/**
 * Create Charity Collection
 */
export const charityCollectionsCreateCharityCollection = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsCreateCharityCollectionData, ThrowOnError>): RequestResult<CharityCollectionsCreateCharityCollectionResponses, CharityCollectionsCreateCharityCollectionErrors, ThrowOnError> => (options.client ?? client).post<CharityCollectionsCreateCharityCollectionResponses, CharityCollectionsCreateCharityCollectionErrors, ThrowOnError>({
    url: '/charity-collections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Charity Collection
 */
export const charityCollectionsDeleteCharityCollection = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsDeleteCharityCollectionData, ThrowOnError>): RequestResult<CharityCollectionsDeleteCharityCollectionResponses, CharityCollectionsDeleteCharityCollectionErrors, ThrowOnError> => (options.client ?? client).delete<CharityCollectionsDeleteCharityCollectionResponses, CharityCollectionsDeleteCharityCollectionErrors, ThrowOnError>({ url: '/charity-collections/{collection_id}', ...options });

/**
 * Get Charity Collection
 *
 * Token-permissive detail — NO `@is_authenticated` (mirrors `get_etf`):
 * `user` may be None. The service applies the server-side visibility gate
 * (public → anyone; unlisted → by direct id; private → owner-only; else 404).
 */
export const charityCollectionsGetCharityCollection = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsGetCharityCollectionData, ThrowOnError>): RequestResult<CharityCollectionsGetCharityCollectionResponses, CharityCollectionsGetCharityCollectionErrors, ThrowOnError> => (options.client ?? client).get<CharityCollectionsGetCharityCollectionResponses, CharityCollectionsGetCharityCollectionErrors, ThrowOnError>({ url: '/charity-collections/{collection_id}', ...options });

/**
 * Update Charity Collection
 */
export const charityCollectionsUpdateCharityCollection = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsUpdateCharityCollectionData, ThrowOnError>): RequestResult<CharityCollectionsUpdateCharityCollectionResponses, CharityCollectionsUpdateCharityCollectionErrors, ThrowOnError> => (options.client ?? client).put<CharityCollectionsUpdateCharityCollectionResponses, CharityCollectionsUpdateCharityCollectionErrors, ThrowOnError>({
    url: '/charity-collections/{collection_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Charity To Collection
 */
export const charityCollectionsAddCharityToCollection = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsAddCharityToCollectionData, ThrowOnError>): RequestResult<CharityCollectionsAddCharityToCollectionResponses, CharityCollectionsAddCharityToCollectionErrors, ThrowOnError> => (options.client ?? client).post<CharityCollectionsAddCharityToCollectionResponses, CharityCollectionsAddCharityToCollectionErrors, ThrowOnError>({
    url: '/charity-collections/{collection_id}/charities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Charity From Collection
 */
export const charityCollectionsRemoveCharityFromCollection = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsRemoveCharityFromCollectionData, ThrowOnError>): RequestResult<CharityCollectionsRemoveCharityFromCollectionResponses, CharityCollectionsRemoveCharityFromCollectionErrors, ThrowOnError> => (options.client ?? client).delete<CharityCollectionsRemoveCharityFromCollectionResponses, CharityCollectionsRemoveCharityFromCollectionErrors, ThrowOnError>({ url: '/charity-collections/{collection_id}/charities/{charity_id}', ...options });

/**
 * Create Charity Collection Donation
 *
 * Authenticated Collection donation: ONE charge → equal-weight penny-exact
 * split → N sub-donations + ONE consolidated receipt. The service re-reads the
 * collection (404 if unreadable). Mirrors `create_fundraiser_donation` —
 * INCLUDING the mandatory per-sub-donation grant-dispatch loop below.
 */
export const charityCollectionsCreateCharityCollectionDonation = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsCreateCharityCollectionDonationData, ThrowOnError>): RequestResult<CharityCollectionsCreateCharityCollectionDonationResponses, CharityCollectionsCreateCharityCollectionDonationErrors, ThrowOnError> => (options.client ?? client).post<CharityCollectionsCreateCharityCollectionDonationResponses, CharityCollectionsCreateCharityCollectionDonationErrors, ThrowOnError>({
    url: '/charity-collections/{collection_id}/donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Charity Collection Posts
 *
 * CC-BE9: the Charity Collection activity feed. Direct mirror of
 * `/fundraiser/{fundraiser_id}/posts` (posts.py), placed on the collections
 * router — only authenticated users can list a collection's posts.
 *
 * The service (`get_collection_posts`) reuses the SAME server-side visibility
 * gate as the collection detail GET (public→anyone, unlisted→by direct id,
 * private→owner-only/404), so a private/unlisted collection's feed 404s for a
 * non-owner and never leaks posts of a non-public collection.
 */
export const charityCollectionsGetCharityCollectionPosts = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsGetCharityCollectionPostsData, ThrowOnError>): RequestResult<CharityCollectionsGetCharityCollectionPostsResponses, CharityCollectionsGetCharityCollectionPostsErrors, ThrowOnError> => (options.client ?? client).get<CharityCollectionsGetCharityCollectionPostsResponses, CharityCollectionsGetCharityCollectionPostsErrors, ThrowOnError>({ url: '/charity-collections/{collection_id}/posts', ...options });

/**
 * Upload Charity Collection Picture
 */
export const charityCollectionsUploadCharityCollectionPicture = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsUploadCharityCollectionPictureData, ThrowOnError>): RequestResult<CharityCollectionsUploadCharityCollectionPictureResponses, CharityCollectionsUploadCharityCollectionPictureErrors, ThrowOnError> => (options.client ?? client).post<CharityCollectionsUploadCharityCollectionPictureResponses, CharityCollectionsUploadCharityCollectionPictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/charity-collections/{collection_id}/profile_picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Set Charity Collection Visibility
 */
export const charityCollectionsSetCharityCollectionVisibility = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsSetCharityCollectionVisibilityData, ThrowOnError>): RequestResult<CharityCollectionsSetCharityCollectionVisibilityResponses, CharityCollectionsSetCharityCollectionVisibilityErrors, ThrowOnError> => (options.client ?? client).post<CharityCollectionsSetCharityCollectionVisibilityResponses, CharityCollectionsSetCharityCollectionVisibilityErrors, ThrowOnError>({
    url: '/charity-collections/{collection_id}/visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Charity Posts
 */
export const postsGetCharityPosts = <ThrowOnError extends boolean = false>(options: Options<PostsGetCharityPostsData, ThrowOnError>): RequestResult<PostsGetCharityPostsResponses, PostsGetCharityPostsErrors, ThrowOnError> => (options.client ?? client).get<PostsGetCharityPostsResponses, PostsGetCharityPostsErrors, ThrowOnError>({ url: '/charity/{charity_id}/posts', ...options });

/**
 * Get Public Company
 */
export const companiesGetPublicCompany = <ThrowOnError extends boolean = false>(options: Options<CompaniesGetPublicCompanyData, ThrowOnError>): RequestResult<CompaniesGetPublicCompanyResponses, CompaniesGetPublicCompanyErrors, ThrowOnError> => (options.client ?? client).get<CompaniesGetPublicCompanyResponses, CompaniesGetPublicCompanyErrors, ThrowOnError>({ url: '/companies/{company_id}', ...options });

/**
 * Get Public Company Statistics
 */
export const companiesGetPublicCompanyStatistics = <ThrowOnError extends boolean = false>(options: Options<CompaniesGetPublicCompanyStatisticsData, ThrowOnError>): RequestResult<CompaniesGetPublicCompanyStatisticsResponses, CompaniesGetPublicCompanyStatisticsErrors, ThrowOnError> => (options.client ?? client).get<CompaniesGetPublicCompanyStatisticsResponses, CompaniesGetPublicCompanyStatisticsErrors, ThrowOnError>({ url: '/companies/{company_id}/statistics', ...options });

/**
 * Get Company Public Steps Competitions
 *
 * PUBLIC competitions for a company's public profile (§2.4). Any signed-in
 * user may read (PUBLIC-visibility competitions are, by definition, visible to
 * any signed-in user); only PUBLIC, non-DRAFT competitions appear.
 */
export const stepsCompetitionsGetCompanyPublicStepsCompetitions = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsGetCompanyPublicStepsCompetitionsData, ThrowOnError>): RequestResult<StepsCompetitionsGetCompanyPublicStepsCompetitionsResponses, StepsCompetitionsGetCompanyPublicStepsCompetitionsErrors, ThrowOnError> => (options.client ?? client).get<StepsCompetitionsGetCompanyPublicStepsCompetitionsResponses, StepsCompetitionsGetCompanyPublicStepsCompetitionsErrors, ThrowOnError>({ url: '/companies/{company_id}/steps-competitions', ...options });

/**
 * Org List Compliance Artifacts
 *
 * The documents your organization has recorded, most recent first.
 *
 * `attached_at` is set once a document has been recorded as the confirmation on a
 * filing or against an imported registration. From that point it is part of your
 * organization's filing record and stays there — it cannot be removed, and that does
 * not change if the filing it backed is later withdrawn.
 */
export const orgComplianceOrgListComplianceArtifacts = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceArtifactsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceArtifactsResponses, OrgComplianceOrgListComplianceArtifactsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceArtifactsResponses, OrgComplianceOrgListComplianceArtifactsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/artifacts', ...options });

/**
 * Org Confirm Compliance Artifact
 *
 * Confirm an upload finished, recording the document in your organization's records.
 *
 * The document has to actually be there: a reference to an upload that did not finish
 * is refused and nothing is recorded. That is what lets the id this returns be used as
 * the confirmation on a filing record — the register never points at a document that
 * is not in your records.
 *
 * A document is recorded once and is never edited afterwards. Uploading a corrected
 * version records a separate document rather than changing this one.
 */
export const orgComplianceOrgConfirmComplianceArtifact = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgConfirmComplianceArtifactData, ThrowOnError>): RequestResult<OrgComplianceOrgConfirmComplianceArtifactResponses, OrgComplianceOrgConfirmComplianceArtifactErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgConfirmComplianceArtifactResponses, OrgComplianceOrgConfirmComplianceArtifactErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/artifacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Issue Compliance Artifact Upload Url
 *
 * Get a short-lived link for uploading one document.
 *
 * Upload the file straight to the returned link with a PUT, using exactly the content
 * type you declared here, then confirm it with the object reference this returns.
 * Nothing is recorded until you confirm — the document is not in your records until
 * the upload has finished and you say so.
 *
 * PDFs, Word files and images only. A macro-enabled Word file (.docm) is stored as a
 * .docx with its macros removed; a Word file is always downloaded, never shown inline.
 */
export const orgComplianceOrgIssueComplianceArtifactUploadUrl = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgIssueComplianceArtifactUploadUrlData, ThrowOnError>): RequestResult<OrgComplianceOrgIssueComplianceArtifactUploadUrlResponses, OrgComplianceOrgIssueComplianceArtifactUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgIssueComplianceArtifactUploadUrlResponses, OrgComplianceOrgIssueComplianceArtifactUploadUrlErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/artifacts/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Delete Compliance Artifact
 *
 * Remove a document your organization has not recorded against anything yet.
 *
 * A document that has been recorded as the confirmation on a filing, or against an
 * imported registration, is part of your organization's filing record and cannot be
 * removed. That stays true afterwards: withdrawing the filing, dismissing the
 * obligation, or recording a later submission does not make the document removable
 * again, because the record of what was filed still refers to it.
 */
export const orgComplianceOrgDeleteComplianceArtifact = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgDeleteComplianceArtifactData, ThrowOnError>): RequestResult<OrgComplianceOrgDeleteComplianceArtifactResponses, OrgComplianceOrgDeleteComplianceArtifactErrors, ThrowOnError> => (options.client ?? client).delete<OrgComplianceOrgDeleteComplianceArtifactResponses, OrgComplianceOrgDeleteComplianceArtifactErrors, ThrowOnError>({ url: '/compliance/{org_ref}/artifacts/{artifact_id}', ...options });

/**
 * Org Get Compliance Artifact Download
 *
 * A short-lived link for downloading one document.
 *
 * Minted for this request and not stored anywhere: fetch a new one each time rather
 * than keeping the link.
 */
export const orgComplianceOrgGetComplianceArtifactDownload = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceArtifactDownloadData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceArtifactDownloadResponses, OrgComplianceOrgGetComplianceArtifactDownloadErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceArtifactDownloadResponses, OrgComplianceOrgGetComplianceArtifactDownloadErrors, ThrowOnError>({ url: '/compliance/{org_ref}/artifacts/{artifact_id}/download', ...options });

/**
 * Org List Compliance Candidates
 *
 * Candidate obligations awaiting the organization's review.
 *
 * Each row carries the jurisdiction's rule, its citation and source date, and the
 * parameters the organization recorded — review each with your counsel. A source date
 * is the day the official source was checked live where `rule_source_date_basis` is
 * `checked_live`, and the day Givmo's research notes recorded the rule where it is
 * `research_notes`. Candidates resting on the nationwide-or-online answer are marked.
 */
export const orgComplianceOrgListComplianceCandidates = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceCandidatesData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceCandidatesResponses, OrgComplianceOrgListComplianceCandidatesErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceCandidatesResponses, OrgComplianceOrgListComplianceCandidatesErrors, ThrowOnError>({ url: '/compliance/{org_ref}/candidates', ...options });

/**
 * Org Confirm Compliance Candidate
 *
 * Confirm ONE candidate into the organization's register.
 *
 * This route takes exactly one candidate. Confirmation pins the rule version reviewed,
 * and a later change to that rule is flagged for re-review rather than applied.
 */
export const orgComplianceOrgConfirmComplianceCandidate = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgConfirmComplianceCandidateData, ThrowOnError>): RequestResult<OrgComplianceOrgConfirmComplianceCandidateResponses, OrgComplianceOrgConfirmComplianceCandidateErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgConfirmComplianceCandidateResponses, OrgComplianceOrgConfirmComplianceCandidateErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/candidates/{obligation_id}/confirmation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Dismiss Compliance Candidate
 *
 * Dismiss ONE candidate, with the organization's reason.
 *
 * The mirror of confirmation — one candidate, the same shape, the same cost. A
 * dismissed candidate returns only if the recorded facts behind it change.
 */
export const orgComplianceOrgDismissComplianceCandidate = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgDismissComplianceCandidateData, ThrowOnError>): RequestResult<OrgComplianceOrgDismissComplianceCandidateResponses, OrgComplianceOrgDismissComplianceCandidateErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgDismissComplianceCandidateResponses, OrgComplianceOrgDismissComplianceCandidateErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/candidates/{obligation_id}/dismissal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Run Compliance Derivation
 *
 * Re-derive candidate obligations from the organization's recorded profile.
 *
 * Each candidate pairs one jurisdiction's transcribed rule — with its citation and
 * source date — against the parameters the organization recorded. A candidate is not
 * a determination that the organization is required to register or is eligible for an
 * exemption in any state, and nothing becomes a deadline or a calendar entry until
 * someone at the organization confirms it.
 *
 * Candidates derived from the nationwide-or-online answer are marked and returned
 * first: whether an online presence alone amounts to soliciting in a particular state
 * is treated differently by different states and is not settled, so those are the ones
 * to review with counsel first.
 *
 * Idempotent — an open candidate stays open, a confirmed obligation is untouched, and
 * a dismissal stands unless the recorded facts behind it changed.
 */
export const orgComplianceOrgRunComplianceDerivation = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRunComplianceDerivationData, ThrowOnError>): RequestResult<OrgComplianceOrgRunComplianceDerivationResponses, OrgComplianceOrgRunComplianceDerivationErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRunComplianceDerivationResponses, OrgComplianceOrgRunComplianceDerivationErrors, ThrowOnError>({ url: '/compliance/{org_ref}/derivation-runs', ...options });

/**
 * Org Get Compliance Desk Authorization
 */
export const orgComplianceOrgGetComplianceDeskAuthorization = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceDeskAuthorizationData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceDeskAuthorizationResponses, OrgComplianceOrgGetComplianceDeskAuthorizationErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceDeskAuthorizationResponses, OrgComplianceOrgGetComplianceDeskAuthorizationErrors, ThrowOnError>({ url: '/compliance/{org_ref}/desk-authorization', ...options });

/**
 * Org Revoke Compliance Desk Authorization
 */
export const orgComplianceOrgRevokeComplianceDeskAuthorization = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRevokeComplianceDeskAuthorizationData, ThrowOnError>): RequestResult<OrgComplianceOrgRevokeComplianceDeskAuthorizationResponses, OrgComplianceOrgRevokeComplianceDeskAuthorizationErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRevokeComplianceDeskAuthorizationResponses, OrgComplianceOrgRevokeComplianceDeskAuthorizationErrors, ThrowOnError>({ url: '/compliance/{org_ref}/desk-authorization/revoke', ...options });

/**
 * Org List Compliance Filing Cases
 *
 * The organization's filing cases, oldest first; with `obligation_id`, one filing's.
 *
 * A filing case is one filing the organization is preparing — a filing on its register, for
 * a year or licence period where the filing has them — and holds the documents the filing
 * is made of. Each case says how many documents it holds.
 */
export const orgComplianceOrgListComplianceFilingCases = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceFilingCasesData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceFilingCasesResponses, OrgComplianceOrgListComplianceFilingCasesErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceFilingCasesResponses, OrgComplianceOrgListComplianceFilingCasesErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases', ...options });

/**
 * Org Get Compliance Filing Case
 *
 * One filing case with the documents it holds, in the order they were added.
 *
 * Each document shows its latest version and who added it to the case, and when.
 */
export const orgComplianceOrgGetComplianceFilingCase = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceFilingCaseData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceFilingCaseResponses, OrgComplianceOrgGetComplianceFilingCaseErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceFilingCaseResponses, OrgComplianceOrgGetComplianceFilingCaseErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases/{case_id}', ...options });

/**
 * Org Get Compliance Filing Case Checklist
 *
 * What goes with the filing: the rule's attachment list, item by item, with the
 * documents attached to each and whether the organization marked it not needed.
 */
export const orgComplianceOrgGetComplianceFilingCaseChecklist = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceFilingCaseChecklistData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceFilingCaseChecklistResponses, OrgComplianceOrgGetComplianceFilingCaseChecklistErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceFilingCaseChecklistResponses, OrgComplianceOrgGetComplianceFilingCaseChecklistErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases/{case_id}/checklist', ...options });

/**
 * Org Record Compliance Checklist Act
 *
 * Remove a document from one checklist item, or mark the item not needed for this
 * filing, or needed after all. An act that changes nothing records nothing.
 */
export const orgComplianceOrgRecordComplianceChecklistAct = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceChecklistActData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceChecklistActResponses, OrgComplianceOrgRecordComplianceChecklistActErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceChecklistActResponses, OrgComplianceOrgRecordComplianceChecklistActErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-cases/{case_id}/checklist/{attachment_index}/acts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Attach Compliance Checklist Document
 *
 * Attach a PDF from the organization's documents to one checklist item.
 *
 * It goes with the filing as uploaded, never changed. Refused for a PDF protected with
 * encryption, and for anything but a PDF; the document stays in the organization's
 * documents as uploaded.
 */
export const orgComplianceOrgAttachComplianceChecklistDocument = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAttachComplianceChecklistDocumentData, ThrowOnError>): RequestResult<OrgComplianceOrgAttachComplianceChecklistDocumentResponses, OrgComplianceOrgAttachComplianceChecklistDocumentErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAttachComplianceChecklistDocumentResponses, OrgComplianceOrgAttachComplianceChecklistDocumentErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-cases/{case_id}/checklist/{attachment_index}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Hand Compliance Filing To Desk
 */
export const orgComplianceOrgHandComplianceFilingToDesk = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgHandComplianceFilingToDeskData, ThrowOnError>): RequestResult<OrgComplianceOrgHandComplianceFilingToDeskResponses, OrgComplianceOrgHandComplianceFilingToDeskErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgHandComplianceFilingToDeskResponses, OrgComplianceOrgHandComplianceFilingToDeskErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases/{case_id}/desk', ...options });

/**
 * Org Resume Compliance Desk
 */
export const orgComplianceOrgResumeComplianceDesk = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgResumeComplianceDeskData, ThrowOnError>): RequestResult<OrgComplianceOrgResumeComplianceDeskResponses, OrgComplianceOrgResumeComplianceDeskErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgResumeComplianceDeskResponses, OrgComplianceOrgResumeComplianceDeskErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases/{case_id}/desk/resume', ...options });

/**
 * Org Take Compliance Filing From Desk
 */
export const orgComplianceOrgTakeComplianceFilingFromDesk = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgTakeComplianceFilingFromDeskData, ThrowOnError>): RequestResult<OrgComplianceOrgTakeComplianceFilingFromDeskResponses, OrgComplianceOrgTakeComplianceFilingFromDeskErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgTakeComplianceFilingFromDeskResponses, OrgComplianceOrgTakeComplianceFilingFromDeskErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases/{case_id}/desk/take-back', ...options });

/**
 * Org Attach Compliance Filing Case Document
 *
 * Add one of the organization's filing documents to an open filing case.
 *
 * A document stays in the first case it is added to; adding it to the same case again
 * changes nothing. Refused, with nothing recorded, for a withdrawn case, or a document that
 * is already in another case. Answers with the case and its documents.
 */
export const orgComplianceOrgAttachComplianceFilingCaseDocument = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAttachComplianceFilingCaseDocumentData, ThrowOnError>): RequestResult<OrgComplianceOrgAttachComplianceFilingCaseDocumentResponses, OrgComplianceOrgAttachComplianceFilingCaseDocumentErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAttachComplianceFilingCaseDocumentResponses, OrgComplianceOrgAttachComplianceFilingCaseDocumentErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-cases/{case_id}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Form Preparations
 *
 * A filing case's form preparations, oldest first.
 *
 * Each names its preparation, the form document and the form it started on, and who started
 * it and when. Starting a preparation is its own request; the preparation read says what the
 * form says.
 */
export const orgComplianceOrgListComplianceFormPreparations = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceFormPreparationsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceFormPreparationsResponses, OrgComplianceOrgListComplianceFormPreparationsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceFormPreparationsResponses, OrgComplianceOrgListComplianceFormPreparationsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases/{case_id}/form-preparations', ...options });

/**
 * Org Start Compliance Form Preparation
 *
 * Start preparing the form of a filing case's filing.
 *
 * Adds the form to the case as a filing document and answers the preparation: every item of
 * the form, filled from the organization's records where they hold the answer. When the
 * case's form is already being prepared, answers that preparation.
 */
export const orgComplianceOrgStartComplianceFormPreparation = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgStartComplianceFormPreparationData, ThrowOnError>): RequestResult<OrgComplianceOrgStartComplianceFormPreparationResponses, OrgComplianceOrgStartComplianceFormPreparationErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgStartComplianceFormPreparationResponses, OrgComplianceOrgStartComplianceFormPreparationErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases/{case_id}/form-preparations', ...options });

/**
 * Org Get Compliance Submission
 *
 * A filing case's submission: whether Givmo can email it and, if not, why.
 *
 * The files exactly as they would go and the SHA-256 that binds them, the email's subject
 * and body, the agency's address, the fee as the form states it, the signed forms'
 * request, the addresses the agency's replies can go to, who the email actually goes to,
 * the latest authorization and every send. Reading it sends nothing.
 */
export const orgComplianceOrgGetComplianceSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceSubmissionData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceSubmissionResponses, OrgComplianceOrgGetComplianceSubmissionErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceSubmissionResponses, OrgComplianceOrgGetComplianceSubmissionErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases/{case_id}/submission', ...options });

/**
 * Org Authorize Compliance Submission
 *
 * Authorize Givmo to send this filing exactly as you reviewed it.
 *
 * For a Compliance Owner or a Global Admin, at your organization's sign-in check. The
 * authorization binds the files, the email, the agency's address, the reply contact and the
 * fee statement, and sends nothing by itself. Refused when anything differs from what you
 * were shown, and while another package is authorized.
 */
export const orgComplianceOrgAuthorizeComplianceSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAuthorizeComplianceSubmissionData, ThrowOnError>): RequestResult<OrgComplianceOrgAuthorizeComplianceSubmissionResponses, OrgComplianceOrgAuthorizeComplianceSubmissionErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAuthorizeComplianceSubmissionResponses, OrgComplianceOrgAuthorizeComplianceSubmissionErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-cases/{case_id}/submission-authorizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Compliance Submission Evidence
 *
 * Record the agency's answer about a send of this filing, as your organization's record.
 *
 * That it acknowledged the filing, rejected it or asked for changes, and the day it did: from
 * its own message, attached, or from your organization's own account. It's labelled as
 * recorded by you, and it doesn't record the filing as accepted: attaching the confirmation
 * does that. Refused for a send nothing shows went out, and for a date before it was sent or
 * after today.
 */
export const orgComplianceOrgRecordComplianceSubmissionEvidence = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceSubmissionEvidenceData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceSubmissionEvidenceResponses, OrgComplianceOrgRecordComplianceSubmissionEvidenceErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceSubmissionEvidenceResponses, OrgComplianceOrgRecordComplianceSubmissionEvidenceErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-cases/{case_id}/submission-evidence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Answer Compliance Submission Evidence
 *
 * Say a record about a send of this filing is wrong.
 *
 * The email service's report about the agency's address, or a record someone in your
 * organization made: say what you found. The record stays, shown with what you said, and
 * nothing counts it any more. For a Compliance Owner or a Global Admin, in Givmo.
 */
export const orgComplianceOrgAnswerComplianceSubmissionEvidence = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAnswerComplianceSubmissionEvidenceData, ThrowOnError>): RequestResult<OrgComplianceOrgAnswerComplianceSubmissionEvidenceResponses, OrgComplianceOrgAnswerComplianceSubmissionEvidenceErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAnswerComplianceSubmissionEvidenceResponses, OrgComplianceOrgAnswerComplianceSubmissionEvidenceErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-cases/{case_id}/submission-evidence/{evidence_id}/answer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Compliance Submission Handoff
 *
 * Record what your organization sent itself, as its own act.
 *
 * The way it went (one the agency's sources record for this filing) and the date; and what:
 * the package, named by the SHA-256 this filing's submission read served, or one of your
 * organization's documents. A proof of sending is optional. Givmo sends nothing, and the
 * record doesn't show that the agency received it. Refused for a package already recorded
 * or already sent by Givmo, or while Givmo's own send of it is in progress or uncertain.
 */
export const orgComplianceOrgRecordComplianceSubmissionHandoff = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceSubmissionHandoffData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceSubmissionHandoffResponses, OrgComplianceOrgRecordComplianceSubmissionHandoffErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceSubmissionHandoffResponses, OrgComplianceOrgRecordComplianceSubmissionHandoffErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-cases/{case_id}/submission-handoffs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Submission Package
 *
 * The package as one zip: a short-lived link to exactly its files.
 *
 * The files keep the names the email gives them, and nothing else goes in. Name the package
 * by the SHA-256 its submission read served: the one the case holds now, or one an
 * authorization bound. Each file is matched to its SHA-256 first, and each one's reading is
 * recorded. Downloading it sends nothing.
 */
export const orgComplianceOrgGetComplianceSubmissionPackage = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceSubmissionPackageData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceSubmissionPackageResponses, OrgComplianceOrgGetComplianceSubmissionPackageErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceSubmissionPackageResponses, OrgComplianceOrgGetComplianceSubmissionPackageErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases/{case_id}/submission/package', ...options });

/**
 * Org Withdraw Compliance Filing Case
 *
 * Withdraw a filing case: the organization stops preparing this filing in it.
 *
 * The case keeps its documents and takes no new one, and a new case can be opened for the
 * same filing. Withdrawing a case already withdrawn changes nothing. Answers with the case
 * and its documents.
 */
export const orgComplianceOrgWithdrawComplianceFilingCase = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgWithdrawComplianceFilingCaseData, ThrowOnError>): RequestResult<OrgComplianceOrgWithdrawComplianceFilingCaseResponses, OrgComplianceOrgWithdrawComplianceFilingCaseErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgWithdrawComplianceFilingCaseResponses, OrgComplianceOrgWithdrawComplianceFilingCaseErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-cases/{case_id}/withdrawal', ...options });

/**
 * Org List Compliance Filing Documents
 *
 * The organization's filing documents, oldest first, each with its latest version.
 *
 * A filing document is a PDF the organization's filings use, kept as versions that never
 * change: the PDF as it was uploaded, and the copy Givmo prepared from it.
 */
export const orgComplianceOrgListComplianceFilingDocuments = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceFilingDocumentsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceFilingDocumentsResponses, OrgComplianceOrgListComplianceFilingDocumentsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceFilingDocumentsResponses, OrgComplianceOrgListComplianceFilingDocumentsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-documents', ...options });

/**
 * Org Create Compliance Filing Document
 *
 * Start a filing document, with the organization's title for it.
 *
 * It has no version until an uploaded PDF is recorded as one.
 */
export const orgComplianceOrgCreateComplianceFilingDocument = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgCreateComplianceFilingDocumentData, ThrowOnError>): RequestResult<OrgComplianceOrgCreateComplianceFilingDocumentResponses, OrgComplianceOrgCreateComplianceFilingDocumentErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgCreateComplianceFilingDocumentResponses, OrgComplianceOrgCreateComplianceFilingDocumentErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Filing Document
 *
 * One filing document with every version, oldest first.
 *
 * Each version is named by the SHA-256 of its exact bytes. A version Givmo prepared begins
 * with the exact bytes of what it was made from: the version it was prepared from, which it
 * names, or, for a form Givmo fills, the agency's official template.
 */
export const orgComplianceOrgGetComplianceFilingDocument = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceFilingDocumentData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceFilingDocumentResponses, OrgComplianceOrgGetComplianceFilingDocumentErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceFilingDocumentResponses, OrgComplianceOrgGetComplianceFilingDocumentErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-documents/{document_id}', ...options });

/**
 * Org Register Compliance Filing Document Version
 *
 * Record an uploaded PDF as the document's next version.
 *
 * The PDF is one the organization already uploaded to its documents. Givmo reads its
 * exact bytes and records the version under their SHA-256; from then on the uploaded
 * document stays in the organization's records. When the PDF carries filled form fields,
 * or text and drawings added with a PDF app's tools, Givmo also records a copy that draws
 * each one's saved appearance into the page, as the version after: the upload is an exact
 * byte prefix of that copy.
 *
 * Refused, with nothing recorded, for a PDF protected with encryption (a restrictions-only
 * password included), a filled field or an added drawing with no saved appearance,
 * comments or other added content Givmo can't make part of the page, a dynamic form, or a
 * PDF Givmo can't read. Recording the same PDF again changes nothing. Answers with the
 * document and every version.
 */
export const orgComplianceOrgRegisterComplianceFilingDocumentVersion = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRegisterComplianceFilingDocumentVersionData, ThrowOnError>): RequestResult<OrgComplianceOrgRegisterComplianceFilingDocumentVersionResponses, OrgComplianceOrgRegisterComplianceFilingDocumentVersionErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRegisterComplianceFilingDocumentVersionResponses, OrgComplianceOrgRegisterComplianceFilingDocumentVersionErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-documents/{document_id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Filing Document Version Download
 *
 * A short-lived link to one version's exact bytes.
 *
 * The link names those exact bytes, whatever else is uploaded later. Each download link
 * Givmo issues is recorded: who asked, when, and the SHA-256 of the bytes it names. The
 * record is not an approval of anything. Fetch a new link each time rather than keeping
 * one.
 */
export const orgComplianceOrgGetComplianceFilingDocumentVersionDownload = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadResponses, OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadResponses, OrgComplianceOrgGetComplianceFilingDocumentVersionDownloadErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-documents/{document_id}/versions/{version_id}/download', ...options });

/**
 * Org Record Compliance Executed Copy
 *
 * Record the organization's upload of this version as it was signed outside Givmo, with who
 * signed it, in what capacity and when, as the organization states. This isn't a Givmo
 * signature, and Givmo doesn't check the signatures or that the copy matches this version. Only
 * a form Givmo prepared takes one, and not while it is out for signature or once it was signed
 * in Givmo; a PDF that is already a version of the form is refused. The same copy again changes
 * nothing; a different copy is recorded beside the first, and the newer one stands.
 */
export const orgComplianceOrgRecordComplianceExecutedCopy = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceExecutedCopyData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceExecutedCopyResponses, OrgComplianceOrgRecordComplianceExecutedCopyErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceExecutedCopyResponses, OrgComplianceOrgRecordComplianceExecutedCopyErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-documents/{document_id}/versions/{version_id}/executed-copies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Filing Document Version Rendition
 *
 * What one version looks like, page by page.
 *
 * Each page was drawn once, with its form fields shown as a form-aware viewer shows
 * them, when the version was recorded; viewing draws nothing new. Each page is a
 * short-lived link to its image.
 */
export const orgComplianceOrgGetComplianceFilingDocumentVersionRendition = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionResponses, OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionResponses, OrgComplianceOrgGetComplianceFilingDocumentVersionRenditionErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-documents/{document_id}/versions/{version_id}/rendition', ...options });

/**
 * Org Get Compliance Filing Document Signing Places
 *
 * What the person sending a filing document out for signature needs before they send it:
 * the document's filing case, the form Givmo matched this version to among that filing's
 * own forms, every signature place the form has (its page, where it is, and where the
 * printed name, the title and the date go), each page's draw scale, whether Givmo can sign
 * it for each way the filing is sent (with the line that says when the agency hasn't
 * confirmed it accepts e-signatures), and why sending it would be refused now, if it would.
 * Writes nothing.
 */
export const orgComplianceOrgGetComplianceFilingDocumentSigningPlaces = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesResponses, OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesResponses, OrgComplianceOrgGetComplianceFilingDocumentSigningPlacesErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-documents/{document_id}/versions/{version_id}/signing-places', ...options });

/**
 * Org List Compliance Filing Groups
 *
 * The organization's filing groups, in its order, each with the filings moved into it.
 *
 * Filings group automatically by family (fundraising registrations, corporate filings
 * and so on); the organization can rename a family's group, reorder the groups, make
 * groups of its own and move a filing between them. Every member of the organization
 * sees the same groups. A filing not listed as a member of any group sits in its
 * family's group.
 */
export const orgComplianceOrgListComplianceFilingGroups = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceFilingGroupsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceFilingGroupsResponses, OrgComplianceOrgListComplianceFilingGroupsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceFilingGroupsResponses, OrgComplianceOrgListComplianceFilingGroupsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-groups', ...options });

/**
 * Org Create Compliance Filing Group
 *
 * Make a group, named by the organization, with the one filing that starts it.
 *
 * The new group goes last in the organization's order and the filing moves into it.
 * Answers with the new group.
 */
export const orgComplianceOrgCreateComplianceFilingGroup = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgCreateComplianceFilingGroupData, ThrowOnError>): RequestResult<OrgComplianceOrgCreateComplianceFilingGroupResponses, OrgComplianceOrgCreateComplianceFilingGroupErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgCreateComplianceFilingGroupResponses, OrgComplianceOrgCreateComplianceFilingGroupErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Remove Compliance Filing Group
 *
 * Remove a group the organization made. Its filings go back to their families' groups.
 *
 * A family's group is never removed; it leaves the page when it holds no filing.
 */
export const orgComplianceOrgRemoveComplianceFilingGroup = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRemoveComplianceFilingGroupData, ThrowOnError>): RequestResult<OrgComplianceOrgRemoveComplianceFilingGroupResponses, OrgComplianceOrgRemoveComplianceFilingGroupErrors, ThrowOnError> => (options.client ?? client).delete<OrgComplianceOrgRemoveComplianceFilingGroupResponses, OrgComplianceOrgRemoveComplianceFilingGroupErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-groups/{group_id}', ...options });

/**
 * Org Move Compliance Filing To Group
 *
 * Move one filing into this group.
 *
 * Moving a filing into its own family's group puts it back there. Answers with the
 * group the filing is now in.
 */
export const orgComplianceOrgMoveComplianceFilingToGroup = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgMoveComplianceFilingToGroupData, ThrowOnError>): RequestResult<OrgComplianceOrgMoveComplianceFilingToGroupResponses, OrgComplianceOrgMoveComplianceFilingToGroupErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgMoveComplianceFilingToGroupResponses, OrgComplianceOrgMoveComplianceFilingToGroupErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-groups/{group_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Move Compliance Filing Group
 *
 * Move one group one place up or down among the groups the Filings page shows.
 *
 * A family's group holding no filing is not shown, so a move passes it. At the top or
 * the bottom the order stays as it is. Answers with the group at its new place.
 */
export const orgComplianceOrgMoveComplianceFilingGroup = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgMoveComplianceFilingGroupData, ThrowOnError>): RequestResult<OrgComplianceOrgMoveComplianceFilingGroupResponses, OrgComplianceOrgMoveComplianceFilingGroupErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgMoveComplianceFilingGroupResponses, OrgComplianceOrgMoveComplianceFilingGroupErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-groups/{group_id}/moves',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Rename Compliance Filing Group
 *
 * Rename one group.
 *
 * A family's group goes back to its family's own name when no name is given; a group
 * the organization made always has one. Answers with the group.
 */
export const orgComplianceOrgRenameComplianceFilingGroup = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRenameComplianceFilingGroupData, ThrowOnError>): RequestResult<OrgComplianceOrgRenameComplianceFilingGroupResponses, OrgComplianceOrgRenameComplianceFilingGroupErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceOrgRenameComplianceFilingGroupResponses, OrgComplianceOrgRenameComplianceFilingGroupErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/filing-groups/{group_id}/name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Filing Options
 *
 * The filings Givmo's rules library offers for adding, one jurisdiction's or all.
 *
 * Each option is a jurisdiction's current rule with its citation and source date, and
 * how the Filings page presents it: its family (fundraising registrations, corporate
 * filings and so on), a short title and what the organization's own number is called.
 * Each option also carries, in `next_dates`, its next date for each deadline the rule
 * records, worked out from the organization's recorded facts with the rule's own deadline
 * entry as its basis, or the reason no date could be worked out; an entry whose dates have
 * all passed is left out. An option says what kind of filing a rule describes; it never
 * says the organization must make it. Ordered by jurisdiction, then as the library lists
 * that jurisdiction's filings.
 */
export const orgComplianceOrgListComplianceFilingOptions = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceFilingOptionsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceFilingOptionsResponses, OrgComplianceOrgListComplianceFilingOptionsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceFilingOptionsResponses, OrgComplianceOrgListComplianceFilingOptionsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/filing-options', ...options });

/**
 * Org List Compliance Form Adapters
 *
 * The agency forms Givmo prepares from their official templates.
 *
 * Each names the rule it is filed under, the form's own number, the template (where it was
 * taken from, when, and the SHA-256 of its exact bytes) and its pages.
 */
export const orgComplianceOrgListComplianceFormAdapters = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceFormAdaptersData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceFormAdaptersResponses, OrgComplianceOrgListComplianceFormAdaptersErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceFormAdaptersResponses, OrgComplianceOrgListComplianceFormAdaptersErrors, ThrowOnError>({ url: '/compliance/{org_ref}/form-adapters', ...options });

/**
 * Org Get Compliance Form Preparation
 *
 * A form being prepared: every item in the form's order and own words, where it stands,
 * what goes on the form for it and where, and the records it comes from.
 *
 * ``values_sha256`` binds everything the form says; recording a version echoes it.
 */
export const orgComplianceOrgGetComplianceFormPreparation = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceFormPreparationData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceFormPreparationResponses, OrgComplianceOrgGetComplianceFormPreparationErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceFormPreparationResponses, OrgComplianceOrgGetComplianceFormPreparationErrors, ThrowOnError>({ url: '/compliance/{org_ref}/form-preparations/{preparation_id}', ...options });

/**
 * Org Answer Compliance Form Item
 *
 * The organization's answer to one item of the form.
 *
 * Recorded beside the earlier ones, with who gave it and when; the newest stands. An answer
 * that changes nothing records nothing. Refused for an answer the item does not take, a
 * character the form can't be printed with, or a value too long for the form's line, and
 * while the form is out for signature.
 */
export const orgComplianceOrgAnswerComplianceFormItem = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAnswerComplianceFormItemData, ThrowOnError>): RequestResult<OrgComplianceOrgAnswerComplianceFormItemResponses, OrgComplianceOrgAnswerComplianceFormItemErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceOrgAnswerComplianceFormItemResponses, OrgComplianceOrgAnswerComplianceFormItemErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/form-preparations/{preparation_id}/items/{item_key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Form Page Preview
 *
 * One page of the form as it stands, drawn as a form-aware viewer shows it.
 *
 * Not a version: recording one is its own request.
 */
export const orgComplianceOrgGetComplianceFormPagePreview = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceFormPagePreviewData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceFormPagePreviewResponses, OrgComplianceOrgGetComplianceFormPagePreviewErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceFormPagePreviewResponses, OrgComplianceOrgGetComplianceFormPagePreviewErrors, ThrowOnError>({ url: '/compliance/{org_ref}/form-preparations/{preparation_id}/pages/{page}/preview', ...options });

/**
 * Org Mint Compliance Form Version
 *
 * Record the prepared form as it stands as a version of its document.
 *
 * The version is the agency's template and one appended change carrying the form's values;
 * it never changes, and the same answers record the same version. Anyone who can read the
 * module may record it, as downloading it does. Refused when the form changed since it was
 * read (``expected_values_sha256``) and while it is out for signature.
 */
export const orgComplianceOrgMintComplianceFormVersion = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgMintComplianceFormVersionData, ThrowOnError>): RequestResult<OrgComplianceOrgMintComplianceFormVersionResponses, OrgComplianceOrgMintComplianceFormVersionErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgMintComplianceFormVersionResponses, OrgComplianceOrgMintComplianceFormVersionErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/form-preparations/{preparation_id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Obligations
 *
 * The organization's register.
 *
 * Each row records what the organization filed and when, and the confirmation the
 * state issued for it. It records filings; it is not a statement that the
 * organization is registered, exempt, in good standing, or in compliance anywhere —
 * only the state that issued a confirmation can say that.
 */
export const orgComplianceOrgListComplianceObligations = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceObligationsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceObligationsResponses, OrgComplianceOrgListComplianceObligationsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceObligationsResponses, OrgComplianceOrgListComplianceObligationsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/obligations', ...options });

/**
 * Org Get Compliance Obligation
 *
 * One obligation, its computed dates, and everything recorded about it.
 *
 * Each date is calculated from a filing period transcribed from the cited source,
 * applied to the fiscal year end the organization recorded. Confirm the current due
 * date with the state before filing.
 */
export const orgComplianceOrgGetComplianceObligation = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceObligationData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceObligationResponses, OrgComplianceOrgGetComplianceObligationErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceObligationResponses, OrgComplianceOrgGetComplianceObligationErrors, ThrowOnError>({ url: '/compliance/{org_ref}/obligations/{obligation_id}', ...options });

/**
 * Org List Compliance Obligation Artifacts
 *
 * Every document recorded against this obligation — currently and historically.
 *
 * `reference_role` says what each document was recorded AS: `confirmation`, the
 * confirmation the state issued; `submission_proof`, your organization's own proof of a
 * submission; `filed_copy`, the filing itself as your organization sent it; or
 * `attachment`, another document kept with the filing. Only a confirmation is the
 * state's answer. `is_current` says whether this obligation itself still carries the
 * reference: a document stays listed after a candidate is dismissed or a later
 * submission is recorded, because the history of what was recorded does not change when
 * the current record does, and a document one of its renewal cycles holds is listed as
 * not current here.
 */
export const orgComplianceOrgListComplianceObligationArtifacts = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceObligationArtifactsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceObligationArtifactsResponses, OrgComplianceOrgListComplianceObligationArtifactsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceObligationArtifactsResponses, OrgComplianceOrgListComplianceObligationArtifactsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/obligations/{obligation_id}/artifacts', ...options });

/**
 * Org Add Compliance Obligation Attachment
 *
 * Keep one more document with a filing made once rather than each period, or with
 * the first filing of one that also recurs (the filing due before the first
 * solicitation). The document must already be uploaded for your organization; adding it
 * again changes nothing.
 */
export const orgComplianceOrgAddComplianceObligationAttachment = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAddComplianceObligationAttachmentData, ThrowOnError>): RequestResult<OrgComplianceOrgAddComplianceObligationAttachmentResponses, OrgComplianceOrgAddComplianceObligationAttachmentErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAddComplianceObligationAttachmentResponses, OrgComplianceOrgAddComplianceObligationAttachmentErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/obligations/{obligation_id}/attachments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Add Compliance Earlier Renewal Cycle
 *
 * Add an earlier year to one filing's history: a renewal cycle for a year the
 * calendar does not show, before the latest one it does, dated by the same cited rule and
 * your organization's recorded fiscal year end. It starts with nothing recorded, and no
 * reminder is sent for it; record the year's filing on the cycle it returns. A year
 * already shown returns its own cycle.
 */
export const orgComplianceOrgAddComplianceEarlierRenewalCycle = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAddComplianceEarlierRenewalCycleData, ThrowOnError>): RequestResult<OrgComplianceOrgAddComplianceEarlierRenewalCycleResponses, OrgComplianceOrgAddComplianceEarlierRenewalCycleErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAddComplianceEarlierRenewalCycleResponses, OrgComplianceOrgAddComplianceEarlierRenewalCycleErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/obligations/{obligation_id}/earlier-cycles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Attach Compliance Obligation Filed Copy
 *
 * Attach the filing itself, as your organization sent it, to a filing made once
 * rather than each period, or to the first filing of one that also recurs (the filing
 * due before the first solicitation). It keeps one; the document must already be
 * uploaded for your organization. It is not the jurisdiction's confirmation. Each later
 * period keeps its own filing as sent on its renewal cycle.
 */
export const orgComplianceOrgAttachComplianceObligationFiledCopy = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAttachComplianceObligationFiledCopyData, ThrowOnError>): RequestResult<OrgComplianceOrgAttachComplianceObligationFiledCopyResponses, OrgComplianceOrgAttachComplianceObligationFiledCopyErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAttachComplianceObligationFiledCopyResponses, OrgComplianceOrgAttachComplianceObligationFiledCopyErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/obligations/{obligation_id}/filed-copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Open Compliance Filing Case
 *
 * Open a filing case for one filing on the organization's register.
 *
 * Say what kind of filing it is. For a filing made each year or each licence period, name
 * the year's record on its calendar; leave it out for a filing made once, or for the first
 * filing of one that also recurs. One case of each kind can be open for a filing and
 * period at a time: withdraw the open one to start over. Refused, with nothing recorded,
 * for a filing that is not confirmed on the register or a year's record that was replaced.
 */
export const orgComplianceOrgOpenComplianceFilingCase = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgOpenComplianceFilingCaseData, ThrowOnError>): RequestResult<OrgComplianceOrgOpenComplianceFilingCaseResponses, OrgComplianceOrgOpenComplianceFilingCaseErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgOpenComplianceFilingCaseResponses, OrgComplianceOrgOpenComplianceFilingCaseErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/obligations/{obligation_id}/filing-cases',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Compliance Filing
 *
 * Record a filing the organization made, with the confirmation the state issued.
 *
 * The confirmation is required — there is no path on this surface that records a
 * filing without one, and the database refuses such a row independently. What is
 * recorded is that the organization filed, on the date it gives, with the
 * confirmation it uploaded.
 */
export const orgComplianceOrgRecordComplianceFiling = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceFilingData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceFilingResponses, OrgComplianceOrgRecordComplianceFilingErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceFilingResponses, OrgComplianceOrgRecordComplianceFilingErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/obligations/{obligation_id}/filing-records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Packets
 *
 * The versions of one obligation's packet, newest first.
 *
 * Every version stays readable — a superseded one keeps its content address and its
 * download history. Items and execution steps are read per version. `download_state`
 * says what asking for each version's document would actually do, and `download_count`
 * how many times this organization has fetched it.
 */
export const orgComplianceOrgListCompliancePackets = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListCompliancePacketsData, ThrowOnError>): RequestResult<OrgComplianceOrgListCompliancePacketsResponses, OrgComplianceOrgListCompliancePacketsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListCompliancePacketsResponses, OrgComplianceOrgListCompliancePacketsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/obligations/{obligation_id}/packets', ...options });

/**
 * Org Assemble Compliance Packet
 *
 * Assemble a new packet version for one confirmed obligation.
 *
 * The packet pairs the jurisdiction's rule as transcribed — form, agency, channel and
 * address, fee, attachments, signature requirement, prerequisites, filing period — each
 * with its source date and, where one was recorded, its citation, against the parameters
 * the organization recorded and the documents it has cited. Where the rule records no
 * form, channel, fee, attachment, signature requirement or filing period, the packet
 * records a gap rather than supplying one. Signer instructions may also appear in
 * recorded form or submission notes.
 *
 * Each step is carried with the source date and, where recorded, the citation of the rule
 * field it restates, or marked as this product's own instruction where it restates no
 * rule. Each item carries the source line frozen when its version was assembled: its
 * source date, `rule_source_date`, worded by `rule_source_date_basis` (an item assembled
 * without them dates its source by `rule_source_checked_on`, a live check only where
 * `rule_source_check_status` is `read_live`), and its citation, `rule_display_citation`,
 * where one was recorded.
 *
 * Assembling again supersedes the previous version: a new version is a new set of
 * bytes, and a download record names the exact bytes it served. Optionally cite ONE
 * more document of the organization's own; documents cited on earlier versions carry
 * forward. Nothing is filed anywhere by this or any other operation here.
 */
export const orgComplianceOrgAssembleCompliancePacket = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAssembleCompliancePacketData, ThrowOnError>): RequestResult<OrgComplianceOrgAssembleCompliancePacketResponses, OrgComplianceOrgAssembleCompliancePacketErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAssembleCompliancePacketResponses, OrgComplianceOrgAssembleCompliancePacketErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/obligations/{obligation_id}/packets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Compliance Registration Date
 *
 * Record the dates this obligation's renewal runs from: its registration date
 * (CCM-BE2), the expiry date printed on its licence (CCM-R1-INTAKE-ANCHOR), or both.
 *
 * Recorded on the obligation itself rather than by declining it and confirming it
 * again — an obligation's recorded filings and its whole history stay where they are
 * while the date under its renewal corrects. Where a licence expiry is recorded, the
 * licence period ends on it. The dates it computes are recomputed; nothing about what
 * your organization filed changes, and no confirmation is needed to correct a date.
 */
export const orgComplianceOrgRecordComplianceRegistrationDate = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceRegistrationDateData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceRegistrationDateResponses, OrgComplianceOrgRecordComplianceRegistrationDateErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceOrgRecordComplianceRegistrationDateResponses, OrgComplianceOrgRecordComplianceRegistrationDateErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/obligations/{obligation_id}/registration-date',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Obligation Rule Change
 *
 * What changed between the rule version a filing is pinned to and its rule's current
 * version (CCM-OPS1-REPIN): each kind of change, with the deadline entry it is about, and
 * each deadline entry's next date under each version. Structure only.
 */
export const orgComplianceOrgGetComplianceObligationRuleChange = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceObligationRuleChangeData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceObligationRuleChangeResponses, OrgComplianceOrgGetComplianceObligationRuleChangeErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceObligationRuleChangeResponses, OrgComplianceOrgGetComplianceObligationRuleChangeErrors, ThrowOnError>({ url: '/compliance/{org_ref}/obligations/{obligation_id}/rule-change', ...options });

/**
 * Org Repin Compliance Obligation
 *
 * Move a filing to its rule's current version, the version named (CCM-OPS1-REPIN): the
 * organization's own act, attributed on the filing's history, which clears the filing's
 * rule-change flag and works its dates out again from that version. Its record is kept.
 * Refused, with nothing written, unless the version named is still the rule's current one;
 * a filing already there is answered as it stands.
 */
export const orgComplianceOrgRepinComplianceObligation = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRepinComplianceObligationData, ThrowOnError>): RequestResult<OrgComplianceOrgRepinComplianceObligationResponses, OrgComplianceOrgRepinComplianceObligationErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceOrgRepinComplianceObligationResponses, OrgComplianceOrgRepinComplianceObligationErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/obligations/{obligation_id}/rule-version',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Compliance Submission
 *
 * Record that the organization submitted a filing, on the date it gives.
 *
 * This records the organization's own act and nothing about the jurisdiction's
 * answer. Render it as "submission recorded «date» — awaiting the state's
 * confirmation": the register does not know whether the submission arrived, was
 * accepted, or was returned, and it does not become a recorded filing until the
 * organization records the confirmation the state issued, on the filing-records
 * route, with that confirmation attached.
 *
 * Its own route because it takes no confirmation — the filing route's confirmation is
 * required and has no nullable form. The optional proof reference here is the
 * organization's own paperwork and is never read as a confirmation.
 *
 * Dates the organization is working toward are recomputed, and the notices for the
 * cycle this submission was for change voice accordingly. If the recorded window
 * closes with no confirmation recorded against it, the register still reports the
 * closed window.
 */
export const orgComplianceOrgRecordComplianceSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceSubmissionData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceSubmissionResponses, OrgComplianceOrgRecordComplianceSubmissionErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceSubmissionResponses, OrgComplianceOrgRecordComplianceSubmissionErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/obligations/{obligation_id}/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Resume Tracking Compliance Obligation
 *
 * Start tracking a stopped filing again (CCM-R1-TRACKING-PANEL, D-CCM-58): the
 * organization's own act, attributed on the filing's history. It goes back onto the calendar
 * on its own rule version and its dates are worked out again. A filing being tracked is
 * answered as it stands. Refused, with nothing written, for a filing not on the calendar.
 */
export const orgComplianceOrgResumeTrackingComplianceObligation = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgResumeTrackingComplianceObligationData, ThrowOnError>): RequestResult<OrgComplianceOrgResumeTrackingComplianceObligationResponses, OrgComplianceOrgResumeTrackingComplianceObligationErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgResumeTrackingComplianceObligationResponses, OrgComplianceOrgResumeTrackingComplianceObligationErrors, ThrowOnError>({ url: '/compliance/{org_ref}/obligations/{obligation_id}/tracking-resume', ...options });

/**
 * Org Stop Tracking Compliance Obligation
 *
 * Stop tracking a filing on the calendar (CCM-R1-TRACKING-PANEL, D-CCM-58): the
 * organization's own act, attributed on the filing's history. Its record and history stay;
 * Givmo works out no new dates for it, so nothing reminds. A filing already stopped is
 * answered as it stands. Refused, with nothing written, for a filing not on the calendar.
 */
export const orgComplianceOrgStopTrackingComplianceObligation = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgStopTrackingComplianceObligationData, ThrowOnError>): RequestResult<OrgComplianceOrgStopTrackingComplianceObligationResponses, OrgComplianceOrgStopTrackingComplianceObligationErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgStopTrackingComplianceObligationResponses, OrgComplianceOrgStopTrackingComplianceObligationErrors, ThrowOnError>({ url: '/compliance/{org_ref}/obligations/{obligation_id}/tracking-stop', ...options });

/**
 * Org Record Compliance Window Closed
 *
 * Record that a refiling window the organization recorded closed with no filing
 * recorded against it.
 *
 * A dated fact. The register does not assess what a closed window means for the
 * organization.
 */
export const orgComplianceOrgRecordComplianceWindowClosed = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceWindowClosedData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceWindowClosedResponses, OrgComplianceOrgRecordComplianceWindowClosedErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceWindowClosedResponses, OrgComplianceOrgRecordComplianceWindowClosedErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/obligations/{obligation_id}/window-closures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Occurrences
 *
 * Computed dates across the organization's confirmed obligations.
 *
 * Each date is calculated from a filing period transcribed from the cited source,
 * applied to the fiscal year end the organization recorded, and travels with both.
 * Some obligations have no calendar date at all — a filing due before the first
 * solicitation has no date to compute — and those rows say so rather than being
 * omitted.
 *
 * `due_before` bounds the window; rows with no computable date are returned
 * regardless.
 */
export const orgComplianceOrgListComplianceOccurrences = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceOccurrencesData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceOccurrencesResponses, OrgComplianceOrgListComplianceOccurrencesErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceOccurrencesResponses, OrgComplianceOrgListComplianceOccurrencesErrors, ThrowOnError>({ url: '/compliance/{org_ref}/occurrences', ...options });

/**
 * Org List Compliance Organization Filings
 *
 * The filings the organization records itself, oldest first, each with its latest
 * period.
 *
 * These are filings Givmo's rules library does not have. Their dates are the ones the
 * organization entered, and nothing on them was checked against a source.
 */
export const orgComplianceOrgListComplianceOrganizationFilings = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceOrganizationFilingsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceOrganizationFilingsResponses, OrgComplianceOrgListComplianceOrganizationFilingsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceOrganizationFilingsResponses, OrgComplianceOrgListComplianceOrganizationFilingsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/organization-filings', ...options });

/**
 * Org Add Compliance Organization Filing
 *
 * Add a filing Givmo's rules library does not have.
 *
 * The organization gives its title, who it is filed with, its family, how often it
 * comes round and its next date; its first period opens at that date. Answers with the
 * filing and that period.
 */
export const orgComplianceOrgAddComplianceOrganizationFiling = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAddComplianceOrganizationFilingData, ThrowOnError>): RequestResult<OrgComplianceOrgAddComplianceOrganizationFilingResponses, OrgComplianceOrgAddComplianceOrganizationFilingErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAddComplianceOrganizationFilingResponses, OrgComplianceOrgAddComplianceOrganizationFilingErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/organization-filings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Organization Filing
 *
 * One filing the organization records itself, with every period, latest date
 * first, its history, the number it first entered, and each change to that number.
 */
export const orgComplianceOrgGetComplianceOrganizationFiling = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceOrganizationFilingData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceOrganizationFilingResponses, OrgComplianceOrgGetComplianceOrganizationFilingErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceOrganizationFilingResponses, OrgComplianceOrgGetComplianceOrganizationFilingErrors, ThrowOnError>({ url: '/compliance/{org_ref}/organization-filings/{filing_id}', ...options });

/**
 * Org Update Compliance Organization Filing
 *
 * Change a filing the organization records itself.
 *
 * A field left out stays as it is; the agency and the number are cleared with null.
 * Changing how often it comes round, or its next date, re-dates only the period nothing
 * is recorded for yet. Each change is kept in the filing's history. A reason, in the
 * person's own words, is kept with each change.
 */
export const orgComplianceOrgUpdateComplianceOrganizationFiling = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgUpdateComplianceOrganizationFilingData, ThrowOnError>): RequestResult<OrgComplianceOrgUpdateComplianceOrganizationFilingResponses, OrgComplianceOrgUpdateComplianceOrganizationFilingErrors, ThrowOnError> => (options.client ?? client).patch<OrgComplianceOrgUpdateComplianceOrganizationFilingResponses, OrgComplianceOrgUpdateComplianceOrganizationFilingErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/organization-filings/{filing_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Add Compliance Organization Filing Cycle
 *
 * Add an earlier period of a filing the organization records itself, at a date
 * before its latest period that no period already there covers. It opens nothing new.
 * An earlier date a period already holds returns that period.
 */
export const orgComplianceOrgAddComplianceOrganizationFilingCycle = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAddComplianceOrganizationFilingCycleData, ThrowOnError>): RequestResult<OrgComplianceOrgAddComplianceOrganizationFilingCycleResponses, OrgComplianceOrgAddComplianceOrganizationFilingCycleErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAddComplianceOrganizationFilingCycleResponses, OrgComplianceOrgAddComplianceOrganizationFilingCycleErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/organization-filings/{filing_id}/cycles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Add Compliance Organization Filing Attachment
 *
 * Keep one more document with one period of a filing your organization records
 * itself, beside its filing and confirmation. The document must already be uploaded for
 * your organization; adding it again changes nothing.
 */
export const orgComplianceOrgAddComplianceOrganizationFilingAttachment = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAddComplianceOrganizationFilingAttachmentData, ThrowOnError>): RequestResult<OrgComplianceOrgAddComplianceOrganizationFilingAttachmentResponses, OrgComplianceOrgAddComplianceOrganizationFilingAttachmentErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAddComplianceOrganizationFilingAttachmentResponses, OrgComplianceOrgAddComplianceOrganizationFilingAttachmentErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/organization-filings/{filing_id}/cycles/{cycle_id}/attachments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Attach Compliance Organization Filing Filed Copy
 *
 * Keep the filing itself, as your organization sent it, with one period of a filing
 * your organization records itself. A period keeps one; the document must already be
 * uploaded for your organization. It is kept with the period's records and is not the
 * agency's confirmation: the period reads as filed only with that.
 */
export const orgComplianceOrgAttachComplianceOrganizationFilingFiledCopy = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyData, ThrowOnError>): RequestResult<OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyResponses, OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyResponses, OrgComplianceOrgAttachComplianceOrganizationFilingFiledCopyErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/organization-filings/{filing_id}/cycles/{cycle_id}/filed-copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Compliance Organization Filing Filed
 *
 * Record that one period was filed, with the confirmation the agency issued.
 *
 * The confirmation document is required: a period reads as filed only with it. A copy
 * of the filing as sent may ride along; a period keeps one. Recording the same filing
 * again changes nothing. When this is the latest period, the next opens by the
 * filing's cadence.
 */
export const orgComplianceOrgRecordComplianceOrganizationFilingFiled = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceOrganizationFilingFiledData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceOrganizationFilingFiledResponses, OrgComplianceOrgRecordComplianceOrganizationFilingFiledErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceOrganizationFilingFiledResponses, OrgComplianceOrgRecordComplianceOrganizationFilingFiledErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/organization-filings/{filing_id}/cycles/{cycle_id}/filing-records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Compliance Organization Filing Sent
 *
 * Record that one period's filing was sent, on the date the organization gives.
 *
 * Sent is not filed. Recording it again corrects the date and the proof; recording it
 * exactly as it stands changes nothing. A period keeps one filing as sent: a different
 * copy is refused. When this is the latest period, the next opens by the filing's
 * cadence.
 */
export const orgComplianceOrgRecordComplianceOrganizationFilingSent = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceOrganizationFilingSentData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceOrganizationFilingSentResponses, OrgComplianceOrgRecordComplianceOrganizationFilingSentErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceOrganizationFilingSentResponses, OrgComplianceOrgRecordComplianceOrganizationFilingSentErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/organization-filings/{filing_id}/cycles/{cycle_id}/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Retire Compliance Organization Filing
 *
 * Stop tracking a filing the organization records itself: it gets no more reminders
 * and opens no next period.
 *
 * The record is kept as it was, with its periods and history, and takes no further
 * changes. A filing already stopped answers as it is.
 */
export const orgComplianceOrgRetireComplianceOrganizationFiling = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRetireComplianceOrganizationFilingData, ThrowOnError>): RequestResult<OrgComplianceOrgRetireComplianceOrganizationFilingResponses, OrgComplianceOrgRetireComplianceOrganizationFilingErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRetireComplianceOrganizationFilingResponses, OrgComplianceOrgRetireComplianceOrganizationFilingErrors, ThrowOnError>({ url: '/compliance/{org_ref}/organization-filings/{filing_id}/retire', ...options });

/**
 * Org Switch Compliance Organization Filing
 *
 * Switch a filing the organization records itself to the same filing from Givmo's
 * rules library, once the organization has that one on its register.
 *
 * The record is kept as it was, with its periods and history, and takes no further
 * changes. If it was moved into a group, the library filing takes its place there.
 */
export const orgComplianceOrgSwitchComplianceOrganizationFiling = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgSwitchComplianceOrganizationFilingData, ThrowOnError>): RequestResult<OrgComplianceOrgSwitchComplianceOrganizationFilingResponses, OrgComplianceOrgSwitchComplianceOrganizationFilingErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgSwitchComplianceOrganizationFilingResponses, OrgComplianceOrgSwitchComplianceOrganizationFilingErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/organization-filings/{filing_id}/switch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Packet
 *
 * One packet version with its items.
 *
 * The items are the rule elements with their source dates and, where recorded, citations,
 * the organization's cited documents, and the steps it performs on the jurisdiction's own
 * channel — each step carrying the source date and, where recorded, the citation of the
 * rule field it restates, or marked as this product's own instruction where it restates
 * no rule. Each item carries the source line frozen when its version was assembled: its
 * source date, `rule_source_date`, worded by `rule_source_date_basis` (an item assembled
 * without them dates its source by `rule_source_checked_on`, a live check only where
 * `rule_source_check_status` is `read_live`), and its citation, `rule_display_citation`,
 * where one was recorded. All of them are listed in every packet state. `download_state`
 * says what asking for this version's document would actually do, and `download_count`
 * how many times it has been fetched.
 */
export const orgComplianceOrgGetCompliancePacket = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetCompliancePacketData, ThrowOnError>): RequestResult<OrgComplianceOrgGetCompliancePacketResponses, OrgComplianceOrgGetCompliancePacketErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetCompliancePacketResponses, OrgComplianceOrgGetCompliancePacketErrors, ThrowOnError>({ url: '/compliance/{org_ref}/packets/{packet_id}', ...options });

/**
 * Org Get Compliance Packet Checklist
 *
 * The checklist for one packet version.
 *
 * The full working state at any time: the rule elements with their source dates and,
 * where recorded, citations, the organization's cited documents, and the steps it
 * performs on the jurisdiction's own channel — gather the cited documents, obtain the
 * recorded signatures, execute on the recorded channel, remit the recorded amount where
 * one is transcribed, then record the submission in the register. Each step built from
 * the rule carries that rule's source date and, where recorded, its citation; the
 * register step is this product's own instruction and says so. Each item carries the
 * source line frozen when its version was assembled: its source date, `rule_source_date`,
 * worded by `rule_source_date_basis` (an item assembled without them dates its source by
 * `rule_source_checked_on`, a live check only where `rule_source_check_status` is
 * `read_live`), and its citation, `rule_display_citation`, where one was recorded. Where
 * the rule records no channel, fee or signature requirement, the step records a gap
 * rather than supplying one. Signer instructions may also appear in recorded form or
 * submission notes. `download_state` says what asking for this version's document would
 * actually do, and `download_count` how many times it has been fetched.
 */
export const orgComplianceOrgGetCompliancePacketChecklist = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetCompliancePacketChecklistData, ThrowOnError>): RequestResult<OrgComplianceOrgGetCompliancePacketChecklistResponses, OrgComplianceOrgGetCompliancePacketChecklistErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetCompliancePacketChecklistResponses, OrgComplianceOrgGetCompliancePacketChecklistErrors, ThrowOnError>({ url: '/compliance/{org_ref}/packets/{packet_id}/checklist', ...options });

/**
 * Org Get Compliance Packet Render
 *
 * Download one packet version's document.
 *
 * Anyone the organization has admitted to this module may download it. There is
 * nothing to confirm and nothing to type. Every download is recorded when it is asked
 * for — who asked, when, and which bytes it names: the content address of the frozen
 * payload the document is rendered from — and that record says exactly that: it is not
 * a signature, an approval, or a statement that anyone is an officer of the
 * organization.
 *
 * Above its download record, the document says that it is not signed, and that who must
 * sign, and how, is set by the jurisdiction's own form and instructions: the rule shows
 * the signer requirements recorded from those sources, and where it shows none they
 * have not been recorded, which does not mean the source is silent.
 *
 * Rendered deterministically from the frozen payload; nothing is stored. Refused for a
 * version whose pinned rule was revised or whose recorded parameters changed since it
 * was assembled — each of those calls for a new version. Nothing is filed anywhere by
 * this or any other operation here.
 */
export const orgComplianceOrgGetCompliancePacketRender = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetCompliancePacketRenderData, ThrowOnError>): RequestResult<OrgComplianceOrgGetCompliancePacketRenderResponses, OrgComplianceOrgGetCompliancePacketRenderErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetCompliancePacketRenderResponses, OrgComplianceOrgGetCompliancePacketRenderErrors, ThrowOnError>({ url: '/compliance/{org_ref}/packets/{packet_id}/render', ...options });

/**
 * Org Get Compliance Profile
 *
 * The facts your organization has recorded about itself.
 *
 * Each one was entered by someone at your organization and is shown with who recorded
 * it and when. Givmo does not confirm these facts; the register's candidates and every
 * computed date rest on them, so keeping them current is what keeps those accurate.
 *
 * `missing_required_parameter_keys` lists what still has to be recorded before
 * candidate obligations can be worked out at all.
 */
export const orgComplianceOrgGetComplianceProfile = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceProfileData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceProfileResponses, OrgComplianceOrgGetComplianceProfileErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceProfileResponses, OrgComplianceOrgGetComplianceProfileErrors, ThrowOnError>({ url: '/compliance/{org_ref}/profile', ...options });

/**
 * Org List Compliance Profile Parameters
 *
 * The facts your organization recorded — in force first, then their history.
 *
 * Recording a fact again does not edit what was there: it writes a new entry and
 * marks the previous one superseded, so an obligation your organization confirmed
 * against an earlier value still shows the value it was confirmed against.
 */
export const orgComplianceOrgListComplianceProfileParameters = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceProfileParametersData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceProfileParametersResponses, OrgComplianceOrgListComplianceProfileParametersErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceProfileParametersResponses, OrgComplianceOrgListComplianceProfileParametersErrors, ThrowOnError>({ url: '/compliance/{org_ref}/profile/parameters', ...options });

/**
 * Org Record Compliance Profile Parameter
 *
 * Record ONE fact about your organization.
 *
 * PUT rather than POST because your organization has exactly one value in force for
 * each fact. Recording again does not edit the previous entry — it writes a new one
 * and supersedes the old, so anything already computed can still show the value it
 * was computed from.
 *
 * When the fact you record is one the register reads, the response says so and links
 * the re-derivation. Nothing is re-derived for you: a re-derivation puts candidate
 * obligations in front of your organization to review, and that is a step someone at
 * your organization takes.
 */
export const orgComplianceOrgRecordComplianceProfileParameter = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceProfileParameterData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceProfileParameterResponses, OrgComplianceOrgRecordComplianceProfileParameterErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceOrgRecordComplianceProfileParameterResponses, OrgComplianceOrgRecordComplianceProfileParameterErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/profile/parameters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Registration Imports
 *
 * Registrations your organization already held when it started here.
 *
 * `artifact_state` is `requested` where the confirmation the state issued has not
 * been supplied yet. Those obligations are in the register and confirmed; they carry
 * no filing record, because the register records filings it can show the state's own
 * document for.
 */
export const orgComplianceOrgListComplianceRegistrationImports = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceRegistrationImportsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceRegistrationImportsResponses, OrgComplianceOrgListComplianceRegistrationImportsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceRegistrationImportsResponses, OrgComplianceOrgListComplianceRegistrationImportsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/profile/registration-imports', ...options });

/**
 * Org Import Compliance Registration
 *
 * Record ONE registration your organization already holds.
 *
 * This route takes exactly one registration — importing puts the obligation into your
 * organization's register.
 *
 * Supplying the confirmation the state issued records the filing, exactly as
 * recording any other filing does. Importing without one is fully supported: the
 * obligation goes into the register with no filing record against it, and the
 * confirmation is noted as still to be supplied.
 */
export const orgComplianceOrgImportComplianceRegistration = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgImportComplianceRegistrationData, ThrowOnError>): RequestResult<OrgComplianceOrgImportComplianceRegistrationResponses, OrgComplianceOrgImportComplianceRegistrationErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgImportComplianceRegistrationResponses, OrgComplianceOrgImportComplianceRegistrationErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/profile/registration-imports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Registration Import Amendments
 *
 * Every correction recorded against this imported registration, oldest first.
 *
 * The whole chain, not a page of it: this is the answer to what your organization has
 * said about this registration over time, and half of it would be a different answer.
 * Each entry names the field, what the record said before, what it says now, who
 * recorded it and when.
 */
export const orgComplianceOrgListComplianceRegistrationImportAmendments = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceRegistrationImportAmendmentsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceRegistrationImportAmendmentsResponses, OrgComplianceOrgListComplianceRegistrationImportAmendmentsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceRegistrationImportAmendmentsResponses, OrgComplianceOrgListComplianceRegistrationImportAmendmentsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/profile/registration-imports/{import_id}/amendments', ...options });

/**
 * Org Amend Compliance Registration Import
 *
 * Correct a detail your organization typed when it recorded this registration.
 *
 * The correction is recorded BESIDE the original, not over it. The imported record
 * keeps saying what your organization first entered, this amendment says what it says
 * now, and both are shown with who recorded them and when.
 *
 * It changes nothing about the filing itself: not the confirmation the state issued,
 * not the date it was filed, not what the register shows about this obligation. Only
 * details your organization typed can be amended, and the recorded confirmation is
 * never one of them.
 */
export const orgComplianceOrgAmendComplianceRegistrationImport = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAmendComplianceRegistrationImportData, ThrowOnError>): RequestResult<OrgComplianceOrgAmendComplianceRegistrationImportResponses, OrgComplianceOrgAmendComplianceRegistrationImportErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAmendComplianceRegistrationImportResponses, OrgComplianceOrgAmendComplianceRegistrationImportErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/profile/registration-imports/{import_id}/amendments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Profile Review Flags
 *
 * Where a figure your organization recorded and a figure Givmo measured differ.
 *
 * Each row shows both numbers and where each came from. Givmo does not decide which
 * is correct and does not change what your organization recorded — the two figures
 * can legitimately differ, for instance where most of your revenue does not come
 * through Givmo.
 */
export const orgComplianceOrgListComplianceProfileReviewFlags = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceProfileReviewFlagsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceProfileReviewFlagsResponses, OrgComplianceOrgListComplianceProfileReviewFlagsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceProfileReviewFlagsResponses, OrgComplianceOrgListComplianceProfileReviewFlagsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/profile/review-flags', ...options });

/**
 * Org Resolve Compliance Profile Review Flag
 *
 * Close ONE flagged difference, recording what your organization decided.
 *
 * Either your organization stands by the figure it recorded, or it records the figure
 * again. Closing a flag changes nothing about the fact itself — to change the fact,
 * record it again.
 */
export const orgComplianceOrgResolveComplianceProfileReviewFlag = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgResolveComplianceProfileReviewFlagData, ThrowOnError>): RequestResult<OrgComplianceOrgResolveComplianceProfileReviewFlagResponses, OrgComplianceOrgResolveComplianceProfileReviewFlagErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgResolveComplianceProfileReviewFlagResponses, OrgComplianceOrgResolveComplianceProfileReviewFlagErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/profile/review-flags/{review_flag_id}/resolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Profile Suggestions
 *
 * Values read off documents your organization uploaded, for it to check.
 *
 * Each row shows what was read and where it was read from. None of them is recorded
 * against your organization until someone at your organization confirms it — or
 * enters a different value, which is recorded as theirs.
 */
export const orgComplianceOrgListComplianceProfileSuggestions = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceProfileSuggestionsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceProfileSuggestionsResponses, OrgComplianceOrgListComplianceProfileSuggestionsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceProfileSuggestionsResponses, OrgComplianceOrgListComplianceProfileSuggestionsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/profile/suggestions', ...options });

/**
 * Org Resolve Compliance Profile Suggestion
 *
 * Confirm, correct or decline ONE value read off a document.
 *
 * Your organization's answer is what is recorded. Confirming records the value that
 * was read; correcting records the value you enter instead; declining records
 * nothing. In every case the entry names the person who answered, not the reading.
 *
 * Accepting a value has the same consequences as typing it: the dates of obligations
 * your organization has already confirmed are recalculated against it, and the
 * response says whether re-deriving candidate obligations is now worth doing.
 */
export const orgComplianceOrgResolveComplianceProfileSuggestion = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgResolveComplianceProfileSuggestionData, ThrowOnError>): RequestResult<OrgComplianceOrgResolveComplianceProfileSuggestionResponses, OrgComplianceOrgResolveComplianceProfileSuggestionErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgResolveComplianceProfileSuggestionResponses, OrgComplianceOrgResolveComplianceProfileSuggestionErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/profile/suggestions/{suggestion_id}/resolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Proposal
 *
 * The organization's open proposal and its newest revision.
 *
 * A proposal presents an assessment of the organization's rules over its recorded facts:
 * the filings identified, the rules excluded, the facts still to record and the conditions
 * left unresolved. It is a record of what was computed, and it changes nothing by itself.
 * None exists until one is generated.
 */
export const orgComplianceOrgGetComplianceProposal = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceProposalData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceProposalResponses, OrgComplianceOrgGetComplianceProposalErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceProposalResponses, OrgComplianceOrgGetComplianceProposalErrors, ThrowOnError>({ url: '/compliance/{org_ref}/proposal', ...options });

/**
 * Org List Compliance Review Asks
 *
 * The organization's asks about items of its review, newest first; with `asked_user_id`,
 * those of one person, and with `state`, those `open`, `resolved` (the item was decided),
 * `withdrawn` or `replaced`.
 */
export const orgComplianceOrgListComplianceReviewAsks = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceReviewAsksData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceReviewAsksResponses, OrgComplianceOrgListComplianceReviewAsksErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceReviewAsksResponses, OrgComplianceOrgListComplianceReviewAsksErrors, ThrowOnError>({ url: '/compliance/{org_ref}/proposal/asks', ...options });

/**
 * Org Ask About Compliance Review Item
 *
 * Ask a teammate who can make changes in Compliance about one item of the revision being
 * reviewed, with an optional note; they get an email with a link to the review.
 *
 * Asking again about the item replaces the open ask, and the same ask sent again answers the
 * open one. An ask decides nothing: the item stays open until the organization decides it.
 */
export const orgComplianceOrgAskAboutComplianceReviewItem = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAskAboutComplianceReviewItemData, ThrowOnError>): RequestResult<OrgComplianceOrgAskAboutComplianceReviewItemResponses, OrgComplianceOrgAskAboutComplianceReviewItemErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAskAboutComplianceReviewItemResponses, OrgComplianceOrgAskAboutComplianceReviewItemErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/proposal/asks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Withdraw Compliance Review Ask
 *
 * Withdraw an ask of a teammate. An ask already withdrawn or replaced is answered as it
 * stands.
 */
export const orgComplianceOrgWithdrawComplianceReviewAsk = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgWithdrawComplianceReviewAskData, ThrowOnError>): RequestResult<OrgComplianceOrgWithdrawComplianceReviewAskResponses, OrgComplianceOrgWithdrawComplianceReviewAskErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgWithdrawComplianceReviewAskResponses, OrgComplianceOrgWithdrawComplianceReviewAskErrors, ThrowOnError>({ url: '/compliance/{org_ref}/proposal/asks/{ask_id}/withdrawal', ...options });

/**
 * Org Generate Compliance Proposal Revision
 *
 * Assess the organization's rules over its recorded facts, as of today, and present the
 * result as the proposal's next revision.
 *
 * Each rule in scope gets one result, with its basis: the rule's conditions, how each came
 * out and the facts used. When nothing has moved since the newest revision, that revision
 * is returned and nothing new is recorded. Generating a revision adopts no fact, puts
 * nothing on the calendar and sends nothing.
 */
export const orgComplianceOrgGenerateComplianceProposalRevision = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGenerateComplianceProposalRevisionData, ThrowOnError>): RequestResult<OrgComplianceOrgGenerateComplianceProposalRevisionResponses, OrgComplianceOrgGenerateComplianceProposalRevisionErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgGenerateComplianceProposalRevisionResponses, OrgComplianceOrgGenerateComplianceProposalRevisionErrors, ThrowOnError>({ url: '/compliance/{org_ref}/proposal/revisions', ...options });

/**
 * Org Get Compliance Proposal Revision
 *
 * One revision of the organization's proposal.
 *
 * It says what moved since the previous revision, how many results and items of each kind it
 * holds, and whether it still reads what it was computed from: a fact recorded or corrected,
 * a rule re-versioned, the calendar changed, or the date moving into another period each
 * make it stale. A stale revision is shown as it was; the organization generates a new one.
 */
export const orgComplianceOrgGetComplianceProposalRevision = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceProposalRevisionData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceProposalRevisionResponses, OrgComplianceOrgGetComplianceProposalRevisionErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceProposalRevisionResponses, OrgComplianceOrgGetComplianceProposalRevisionErrors, ThrowOnError>({ url: '/compliance/{org_ref}/proposal/revisions/{revision_id}', ...options });

/**
 * Org List Compliance Proposal Items
 *
 * A revision's items, in the order they are presented; with `kind`, one kind's.
 *
 * The kinds are a filing identified (`filing_work`, with the dates it would take on the
 * calendar), a rule excluded (`exclusion`), a fact to record (`question`, with the rules
 * its answer decides), an unresolved condition (`issue`), and a filing already on the
 * calendar that the evaluation now reads otherwise (`change`). A rule's item carries its
 * result.
 */
export const orgComplianceOrgListComplianceProposalItems = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceProposalItemsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceProposalItemsResponses, OrgComplianceOrgListComplianceProposalItemsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceProposalItemsResponses, OrgComplianceOrgListComplianceProposalItemsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/proposal/revisions/{revision_id}/items', ...options });

/**
 * Org List Compliance Proposal Results
 *
 * The results of a revision's assessment, one per rule in scope, in the rules' order;
 * with `result`, one result's.
 *
 * Each is `filing_identified`, `rule_excluded`, `facts_missing`, `unresolved` or
 * `not_supported`, with its basis on the same object: the rule's citation and source, each
 * condition's outcome, the facts used, the facts missing, and the reason where the rule
 * calls for no filing, is unresolved or is not evaluated.
 */
export const orgComplianceOrgListComplianceProposalResults = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceProposalResultsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceProposalResultsResponses, OrgComplianceOrgListComplianceProposalResultsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceProposalResultsResponses, OrgComplianceOrgListComplianceProposalResultsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/proposal/revisions/{revision_id}/results', ...options });

/**
 * Org Get Compliance Proposal Review
 *
 * The review recorded on one revision: each item the organization decided, what the
 * decision did, who decided and when, and the version of the not-a-substitute sentence shown
 * when it was recorded.
 */
export const orgComplianceOrgGetComplianceProposalReview = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceProposalReviewData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceProposalReviewResponses, OrgComplianceOrgGetComplianceProposalReviewErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceProposalReviewResponses, OrgComplianceOrgGetComplianceProposalReviewErrors, ThrowOnError>({ url: '/compliance/{org_ref}/proposal/revisions/{revision_id}/review', ...options });

/**
 * Org Record Compliance Proposal Review
 *
 * Record the organization's decisions on the items of one revision it was shown, with
 * that revision's digest as it was shown.
 *
 * Each decision names an item of the revision: accept or deny a filing identified or a rule
 * excluded, or defer any item. Only the items listed are decided. Accepting a filing puts it
 * on the calendar as the organization's decision; denying one records that the organization
 * chose not to, beside the assessment, which stays as it was computed. A revision is reviewed
 * once: one that changed since it was shown, or already carries a review, is refused so it can
 * be shown again, and the same decisions sent again answer the review already recorded. It
 * signs nothing, authorizes no submission and sends nothing.
 */
export const orgComplianceOrgRecordComplianceProposalReview = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceProposalReviewData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceProposalReviewResponses, OrgComplianceOrgRecordComplianceProposalReviewErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceProposalReviewResponses, OrgComplianceOrgRecordComplianceProposalReviewErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/proposal/revisions/{revision_id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Renewal Cycles
 *
 * Recorded renewal cycles, including earlier dates and their confirmations.
 */
export const orgComplianceOrgListComplianceRenewalCycles = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceRenewalCyclesData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceRenewalCyclesResponses, OrgComplianceOrgListComplianceRenewalCyclesErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceRenewalCyclesResponses, OrgComplianceOrgListComplianceRenewalCyclesErrors, ThrowOnError>({ url: '/compliance/{org_ref}/renewal-cycles', ...options });

/**
 * Org Get Compliance Renewal Cycle
 *
 * One recorded cycle with its dated changes and confirmation history.
 */
export const orgComplianceOrgGetComplianceRenewalCycle = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceRenewalCycleData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceRenewalCycleResponses, OrgComplianceOrgGetComplianceRenewalCycleErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceRenewalCycleResponses, OrgComplianceOrgGetComplianceRenewalCycleErrors, ThrowOnError>({ url: '/compliance/{org_ref}/renewal-cycles/{cycle_id}', ...options });

/**
 * Org Add Compliance Renewal Attachment
 *
 * Keep one more document with one renewal cycle, beside its filing and confirmation.
 * The document must already be uploaded for your organization; adding it again changes
 * nothing.
 */
export const orgComplianceOrgAddComplianceRenewalAttachment = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAddComplianceRenewalAttachmentData, ThrowOnError>): RequestResult<OrgComplianceOrgAddComplianceRenewalAttachmentResponses, OrgComplianceOrgAddComplianceRenewalAttachmentErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAddComplianceRenewalAttachmentResponses, OrgComplianceOrgAddComplianceRenewalAttachmentErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/renewal-cycles/{cycle_id}/attachments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Attach Compliance Renewal Filed Copy
 *
 * Attach the filing itself, as your organization sent it, to one renewal cycle. A
 * cycle keeps one; the document must already be uploaded for your organization. It is
 * kept with the cycle's records and is not the jurisdiction's confirmation.
 */
export const orgComplianceOrgAttachComplianceRenewalFiledCopy = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgAttachComplianceRenewalFiledCopyData, ThrowOnError>): RequestResult<OrgComplianceOrgAttachComplianceRenewalFiledCopyResponses, OrgComplianceOrgAttachComplianceRenewalFiledCopyErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgAttachComplianceRenewalFiledCopyResponses, OrgComplianceOrgAttachComplianceRenewalFiledCopyErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/renewal-cycles/{cycle_id}/filed-copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Compliance Renewal Filing
 *
 * Record the jurisdiction's confirmation for one selected renewal cycle.
 */
export const orgComplianceOrgRecordComplianceRenewalFiling = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceRenewalFilingData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceRenewalFilingResponses, OrgComplianceOrgRecordComplianceRenewalFilingErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceRenewalFilingResponses, OrgComplianceOrgRecordComplianceRenewalFilingErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/renewal-cycles/{cycle_id}/filing-records',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Record Compliance Renewal Submission
 *
 * Record that your organization sent one renewal cycle's filing, on the date you give,
 * with your own proof of sending if you have one. It records what your organization did
 * and says nothing about what the jurisdiction did; the cycle is not marked filed until
 * the jurisdiction's confirmation is recorded.
 */
export const orgComplianceOrgRecordComplianceRenewalSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceRenewalSubmissionData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceRenewalSubmissionResponses, OrgComplianceOrgRecordComplianceRenewalSubmissionErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRecordComplianceRenewalSubmissionResponses, OrgComplianceOrgRecordComplianceRenewalSubmissionErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/renewal-cycles/{cycle_id}/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Ai Setting
 *
 * The organization's "Use AI on your organization's data" setting.
 *
 * It covers Givmo's AI only. While it is off, Givmo reads no document with AI, drafts
 * nothing with AI, and prepares or files nothing with AI; everything the organization adds
 * itself works the same. The organization's own connected AI is not governed by it. It is
 * on until the organization turns it off: revision 0 means it was never changed, and then
 * nobody is named.
 */
export const orgComplianceOrgGetComplianceAiSetting = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceAiSettingData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceAiSettingResponses, OrgComplianceOrgGetComplianceAiSettingErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceAiSettingResponses, OrgComplianceOrgGetComplianceAiSettingErrors, ThrowOnError>({ url: '/compliance/{org_ref}/settings/ai', ...options });

/**
 * Org Set Compliance Ai Setting
 *
 * Turn Givmo's AI on or off for the organization.
 *
 * A Compliance Owner or a Global Admin changes it. The change is made from the revision it
 * was read at: a change made from an older one is refused and nothing is recorded, so it
 * never lands over a change its author did not see. Each change records who made it and
 * when; asking for the value already in force records nothing. Answers with the setting.
 */
export const orgComplianceOrgSetComplianceAiSetting = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgSetComplianceAiSettingData, ThrowOnError>): RequestResult<OrgComplianceOrgSetComplianceAiSettingResponses, OrgComplianceOrgSetComplianceAiSettingErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceOrgSetComplianceAiSettingResponses, OrgComplianceOrgSetComplianceAiSettingErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/settings/ai',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Signing Setting
 *
 * The organization's sign-in check before signing.
 *
 * None by default: a signed-in member signs by one deliberate act, and the record of the
 * signature names when they last signed in, and how. An organization may require a sign-in
 * again within the last day, within the last 30 minutes, or for every signature. Revision 0
 * means it was never changed.
 */
export const orgComplianceOrgGetComplianceSigningSetting = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceSigningSettingData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceSigningSettingResponses, OrgComplianceOrgGetComplianceSigningSettingErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceSigningSettingResponses, OrgComplianceOrgGetComplianceSigningSettingErrors, ThrowOnError>({ url: '/compliance/{org_ref}/settings/signing', ...options });

/**
 * Org Set Compliance Signing Setting
 *
 * Change the organization's sign-in check before signing.
 *
 * A Compliance Owner or a Global Admin changes it, from the revision it was read at: a
 * change made from an older one is refused and nothing is recorded. Making it stricter
 * asks for nothing; making it less strict asks the person to meet the check in force first.
 * Each change records who made it, when, and what the person showed.
 */
export const orgComplianceOrgSetComplianceSigningSetting = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgSetComplianceSigningSettingData, ThrowOnError>): RequestResult<OrgComplianceOrgSetComplianceSigningSettingResponses, OrgComplianceOrgSetComplianceSigningSettingErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceOrgSetComplianceSigningSettingResponses, OrgComplianceOrgSetComplianceSigningSettingErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/settings/signing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org List Compliance Signing People
 *
 * Everyone the organization's signing requests hold sign-in details for, newest first:
 * each person who signed, declined or withdrew a signature on a request, completed or not,
 * and each person who sent one. Each comes with how many requests hold their details and the
 * request to direct their removal on.
 */
export const orgComplianceOrgListComplianceSigningPeople = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceSigningPeopleData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceSigningPeopleResponses, OrgComplianceOrgListComplianceSigningPeopleErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceSigningPeopleResponses, OrgComplianceOrgListComplianceSigningPeopleErrors, ThrowOnError>({ url: '/compliance/{org_ref}/signing-people', ...options });

/**
 * Org List Compliance Signing Requests
 *
 * The organization's signing requests, oldest first; with `filing_case_id`, one filing
 * case's; with `state`, the requests in that state (a request whose sign-by date has passed
 * reads expired).
 */
export const orgComplianceOrgListComplianceSigningRequests = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceSigningRequestsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceSigningRequestsResponses, OrgComplianceOrgListComplianceSigningRequestsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceSigningRequestsResponses, OrgComplianceOrgListComplianceSigningRequestsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/signing-requests', ...options });

/**
 * Org Issue Compliance Signing Request
 *
 * Send a filing case's documents out for signature.
 *
 * Name each document at the version its signers sign (Givmo's flattened copy, where the
 * upload had filled fields), a signer for every signature place the form has and the
 * capacity the organization states for each, how the filing will be sent, and the time zone
 * its dates are written in. A note for the signers and a sign-by date are optional.
 * Everyone named needs access to Compliance. One request can be open for a filing case: a
 * package of other documents replaces the open one, and the same package again is refused.
 * Refused, with nothing recorded, where Givmo can't sign a document of the package.
 */
export const orgComplianceOrgIssueComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgIssueComplianceSigningRequestData, ThrowOnError>): RequestResult<OrgComplianceOrgIssueComplianceSigningRequestResponses, OrgComplianceOrgIssueComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgIssueComplianceSigningRequestResponses, OrgComplianceOrgIssueComplianceSigningRequestErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/signing-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Signing Request
 *
 * One signing request with its live version: each document and whether Givmo can sign
 * it, its pages as the signers see them, every signature place and where it stands, the
 * acts on this version, the caller's own places and what they can do now, and what changed
 * around it since it was sent.
 */
export const orgComplianceOrgGetComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceSigningRequestData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceSigningRequestResponses, OrgComplianceOrgGetComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceSigningRequestResponses, OrgComplianceOrgGetComplianceSigningRequestErrors, ThrowOnError>({ url: '/compliance/{org_ref}/signing-requests/{request_id}', ...options });

/**
 * Org Cancel Compliance Signing Request
 *
 * Cancel an open request, with an optional reason. Cancelling a cancelled request
 * changes nothing.
 */
export const orgComplianceOrgCancelComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgCancelComplianceSigningRequestData, ThrowOnError>): RequestResult<OrgComplianceOrgCancelComplianceSigningRequestResponses, OrgComplianceOrgCancelComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgCancelComplianceSigningRequestResponses, OrgComplianceOrgCancelComplianceSigningRequestErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/signing-requests/{request_id}/cancellation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Decline Compliance Signing Request
 *
 * Decline to sign the live version, with an optional reason for the sender. A decline
 * is not final: the caller can sign later, and the request stays open.
 */
export const orgComplianceOrgDeclineComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgDeclineComplianceSigningRequestData, ThrowOnError>): RequestResult<OrgComplianceOrgDeclineComplianceSigningRequestResponses, OrgComplianceOrgDeclineComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgDeclineComplianceSigningRequestResponses, OrgComplianceOrgDeclineComplianceSigningRequestErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/signing-requests/{request_id}/declines',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Signing Evidence
 *
 * A completed request's signing record: who signed which document, and when, with the
 * sign-in facts each signature's session showed (or when they were removed at the
 * organization's direction), the versions sent, what the signers were shown and the checks on
 * the signed forms. A short-lived link to its exact bytes, as a PDF (the default) or as data
 * (`format=json`), and the record of issuing the link. A request that is not completed has
 * none.
 */
export const orgComplianceOrgGetComplianceSigningEvidence = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceSigningEvidenceData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceSigningEvidenceResponses, OrgComplianceOrgGetComplianceSigningEvidenceErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceSigningEvidenceResponses, OrgComplianceOrgGetComplianceSigningEvidenceErrors, ThrowOnError>({ url: '/compliance/{org_ref}/signing-requests/{request_id}/evidence', ...options });

/**
 * Org Extend Compliance Signing Request
 *
 * Move an open request's sign-by date later. The same date again changes nothing; an
 * earlier one is refused, and so is any change once the date has passed.
 */
export const orgComplianceOrgExtendComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgExtendComplianceSigningRequestData, ThrowOnError>): RequestResult<OrgComplianceOrgExtendComplianceSigningRequestResponses, OrgComplianceOrgExtendComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceOrgExtendComplianceSigningRequestResponses, OrgComplianceOrgExtendComplianceSigningRequestErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/signing-requests/{request_id}/expiry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Signing Export
 *
 * A completed request's export: one zip holding each signed form, each form as it was
 * prepared, the signing record as a PDF and as data, and a list of each file's SHA-256. A
 * short-lived link to it and the record of issuing the link. Every file is read back and
 * matched to its record first: one that does not match refuses the export rather than hand
 * over something else.
 */
export const orgComplianceOrgGetComplianceSigningExport = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceSigningExportData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceSigningExportResponses, OrgComplianceOrgGetComplianceSigningExportErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceSigningExportResponses, OrgComplianceOrgGetComplianceSigningExportErrors, ThrowOnError>({ url: '/compliance/{org_ref}/signing-requests/{request_id}/export', ...options });

/**
 * Org Remove Compliance Signing Identity
 *
 * At the organization's direction, remove the sign-in email, IP address and browser of a
 * person who acted on this request or sent it from every signing record the organization holds.
 * The signatures and the signed forms stay as they are. Each record is written again and says
 * the details were removed, and the removal keeps the digests of the files it replaced.
 */
export const orgComplianceOrgRemoveComplianceSigningIdentity = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRemoveComplianceSigningIdentityData, ThrowOnError>): RequestResult<OrgComplianceOrgRemoveComplianceSigningIdentityResponses, OrgComplianceOrgRemoveComplianceSigningIdentityErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRemoveComplianceSigningIdentityResponses, OrgComplianceOrgRemoveComplianceSigningIdentityErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/signing-requests/{request_id}/identity-removals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Get Compliance Signing Record Lines
 *
 * A completed request's signing record as a page shows it beside the signed form: the
 * record's own first-page lines, read from the stored record and matched to it first, each
 * SHA-256 shortened to its first and last four characters. Nothing is handed over, so
 * nothing is added to the download record. A request that is not completed has none.
 */
export const orgComplianceOrgGetComplianceSigningRecordLines = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceSigningRecordLinesData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceSigningRecordLinesResponses, OrgComplianceOrgGetComplianceSigningRecordLinesErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceSigningRecordLinesResponses, OrgComplianceOrgGetComplianceSigningRecordLinesErrors, ThrowOnError>({ url: '/compliance/{org_ref}/signing-requests/{request_id}/record', ...options });

/**
 * Org Revise Compliance Signing Request
 *
 * A new version of an open request: its signers and capacities, the channel, the time
 * zone and the note, from the version it was read at. Every signature starts over. The
 * documents change only by sending a new request.
 */
export const orgComplianceOrgReviseComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgReviseComplianceSigningRequestData, ThrowOnError>): RequestResult<OrgComplianceOrgReviseComplianceSigningRequestResponses, OrgComplianceOrgReviseComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgReviseComplianceSigningRequestResponses, OrgComplianceOrgReviseComplianceSigningRequestErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/signing-requests/{request_id}/revisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Withdraw Compliance Signature
 *
 * Withdraw the caller's own signature from the live version, before the request is
 * completed.
 */
export const orgComplianceOrgWithdrawComplianceSignature = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgWithdrawComplianceSignatureData, ThrowOnError>): RequestResult<OrgComplianceOrgWithdrawComplianceSignatureResponses, OrgComplianceOrgWithdrawComplianceSignatureErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgWithdrawComplianceSignatureResponses, OrgComplianceOrgWithdrawComplianceSignatureErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/signing-requests/{request_id}/signature-withdrawals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Sign Compliance Signing Request
 *
 * Sign every place the caller holds on the live version, by their typed name, under the
 * statement shown above the button.
 *
 * Name the version as it was read: a request that changed since is refused, and so is a
 * signature already made (the answer names it). Where the organization asks for a recent
 * sign-in, the caller signs in again first.
 */
export const orgComplianceOrgSignComplianceSigningRequest = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgSignComplianceSigningRequestData, ThrowOnError>): RequestResult<OrgComplianceOrgSignComplianceSigningRequestResponses, OrgComplianceOrgSignComplianceSigningRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgSignComplianceSigningRequestResponses, OrgComplianceOrgSignComplianceSigningRequestErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/signing-requests/{request_id}/signatures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Reconcile Compliance Submission Attempt
 *
 * Record what you found about a send whose outcome is uncertain.
 *
 * That the copy arrived, or Givmo staff saw it in the email service's records, records it as
 * sent; that the copy never arrived records it as not sent. Nothing is sent again.
 */
export const orgComplianceOrgReconcileComplianceSubmissionAttempt = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgReconcileComplianceSubmissionAttemptData, ThrowOnError>): RequestResult<OrgComplianceOrgReconcileComplianceSubmissionAttemptResponses, OrgComplianceOrgReconcileComplianceSubmissionAttemptErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgReconcileComplianceSubmissionAttemptResponses, OrgComplianceOrgReconcileComplianceSubmissionAttemptErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/submission-attempts/{attempt_id}/reconcile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Dispatch Compliance Submission
 *
 * Send the authorized filing by email, once.
 *
 * The send is recorded before the email leaves, then what Givmo's email service answered.
 * Repeating a send already made answers it and sends nothing again.
 */
export const orgComplianceOrgDispatchComplianceSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgDispatchComplianceSubmissionData, ThrowOnError>): RequestResult<OrgComplianceOrgDispatchComplianceSubmissionResponses, OrgComplianceOrgDispatchComplianceSubmissionErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgDispatchComplianceSubmissionResponses, OrgComplianceOrgDispatchComplianceSubmissionErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/submission-authorizations/{authorization_id}/attempts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Revoke Compliance Submission Authorization
 *
 * Revoke an authorization to send, so nothing goes under it.
 *
 * Refused while a send under it is in progress or its outcome is uncertain.
 */
export const orgComplianceOrgRevokeComplianceSubmissionAuthorization = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRevokeComplianceSubmissionAuthorizationData, ThrowOnError>): RequestResult<OrgComplianceOrgRevokeComplianceSubmissionAuthorizationResponses, OrgComplianceOrgRevokeComplianceSubmissionAuthorizationErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgRevokeComplianceSubmissionAuthorizationResponses, OrgComplianceOrgRevokeComplianceSubmissionAuthorizationErrors, ThrowOnError>({ url: '/compliance/{org_ref}/submission-authorizations/{authorization_id}/revoke', ...options });

/**
 * Org List Compliance Submission Follow Through
 *
 * What is known about each filing's latest send, newest first.
 *
 * For each filing case with something sent, by Givmo or recorded by your organization: the
 * day it went, how many of the case's sends went before it, and what is known so far, such as
 * the email service's report of its delivery, a record someone in your organization made of
 * the agency's answer, the filing's confirmation on file, or that Givmo can't tell whether
 * its email went. Reading it sends nothing.
 */
export const orgComplianceOrgListComplianceSubmissionFollowThrough = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceSubmissionFollowThroughData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceSubmissionFollowThroughResponses, OrgComplianceOrgListComplianceSubmissionFollowThroughErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceSubmissionFollowThroughResponses, OrgComplianceOrgListComplianceSubmissionFollowThroughErrors, ThrowOnError>({ url: '/compliance/{org_ref}/submission-follow-through', ...options });

/**
 * Org List Compliance Vendors
 *
 * Recorded registered-agent and foreign-qualification facts, with provenance.
 */
export const orgComplianceOrgListComplianceVendors = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgListComplianceVendorsData, ThrowOnError>): RequestResult<OrgComplianceOrgListComplianceVendorsResponses, OrgComplianceOrgListComplianceVendorsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgListComplianceVendorsResponses, OrgComplianceOrgListComplianceVendorsErrors, ThrowOnError>({ url: '/compliance/{org_ref}/vendor-records', ...options });

/**
 * Org Get Compliance Vendor
 *
 * One factual vendor record and each attributed correction.
 */
export const orgComplianceOrgGetComplianceVendor = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgGetComplianceVendorData, ThrowOnError>): RequestResult<OrgComplianceOrgGetComplianceVendorResponses, OrgComplianceOrgGetComplianceVendorErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceOrgGetComplianceVendorResponses, OrgComplianceOrgGetComplianceVendorErrors, ThrowOnError>({ url: '/compliance/{org_ref}/vendor-records/{vendor_id}', ...options });

/**
 * Org Record Compliance Vendor
 *
 * Record or correct one row. Zero revision creates a new caller-chosen id.
 */
export const orgComplianceOrgRecordComplianceVendor = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgRecordComplianceVendorData, ThrowOnError>): RequestResult<OrgComplianceOrgRecordComplianceVendorResponses, OrgComplianceOrgRecordComplianceVendorErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceOrgRecordComplianceVendorResponses, OrgComplianceOrgRecordComplianceVendorErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/vendor-records/{vendor_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Link Compliance Vendor Filing
 *
 * Link a record to the library filing it is (CCM-MOD5-RECORD-FILING-LINK): the
 * organization's own statement, recorded on both histories with who made it. The filing
 * then shows the record's renewal date where the library has none. The same link again is
 * answered as it stands.
 */
export const orgComplianceOrgLinkComplianceVendorFiling = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgLinkComplianceVendorFilingData, ThrowOnError>): RequestResult<OrgComplianceOrgLinkComplianceVendorFilingResponses, OrgComplianceOrgLinkComplianceVendorFilingErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgLinkComplianceVendorFilingResponses, OrgComplianceOrgLinkComplianceVendorFilingErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/vendor-records/{vendor_id}/filing-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Org Unlink Compliance Vendor Filing
 *
 * Undo the link between a record and a filing (CCM-MOD5-RECORD-FILING-LINK). Both
 * histories keep the link and record the unlink. A pair no longer linked is answered with the
 * link as it was closed; a pair never linked is refused.
 */
export const orgComplianceOrgUnlinkComplianceVendorFiling = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceOrgUnlinkComplianceVendorFilingData, ThrowOnError>): RequestResult<OrgComplianceOrgUnlinkComplianceVendorFilingResponses, OrgComplianceOrgUnlinkComplianceVendorFilingErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceOrgUnlinkComplianceVendorFilingResponses, OrgComplianceOrgUnlinkComplianceVendorFilingErrors, ThrowOnError>({
    url: '/compliance/{org_ref}/vendor-records/{vendor_id}/filing-unlink',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Content Categories
 */
export const contentCategoriesGetContentCategories = <ThrowOnError extends boolean = false>(options?: Options<ContentCategoriesGetContentCategoriesData, ThrowOnError>): RequestResult<ContentCategoriesGetContentCategoriesResponses, ContentCategoriesGetContentCategoriesErrors, ThrowOnError> => (options?.client ?? client).get<ContentCategoriesGetContentCategoriesResponses, ContentCategoriesGetContentCategoriesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/content-categories',
    ...options
});

/**
 * Create Content Category
 */
export const contentCategoriesCreateContentCategory = <ThrowOnError extends boolean = false>(options: Options<ContentCategoriesCreateContentCategoryData, ThrowOnError>): RequestResult<ContentCategoriesCreateContentCategoryResponses, ContentCategoriesCreateContentCategoryErrors, ThrowOnError> => (options.client ?? client).post<ContentCategoriesCreateContentCategoryResponses, ContentCategoriesCreateContentCategoryErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/content-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Cause Tags Curated Content Items
 */
export const contentCategoriesGetCauseTagsCuratedContentItems = <ThrowOnError extends boolean = false>(options?: Options<ContentCategoriesGetCauseTagsCuratedContentItemsData, ThrowOnError>): RequestResult<ContentCategoriesGetCauseTagsCuratedContentItemsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContentCategoriesGetCauseTagsCuratedContentItemsResponses, unknown, ThrowOnError>({ url: '/content-categories/cause-tags', ...options });

/**
 * Get Celebrity Charities Curated Content Items
 */
export const contentCategoriesGetCelebrityCharitiesCuratedContentItems = <ThrowOnError extends boolean = false>(options?: Options<ContentCategoriesGetCelebrityCharitiesCuratedContentItemsData, ThrowOnError>): RequestResult<ContentCategoriesGetCelebrityCharitiesCuratedContentItemsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContentCategoriesGetCelebrityCharitiesCuratedContentItemsResponses, unknown, ThrowOnError>({ url: '/content-categories/celebrity-charities', ...options });

/**
 * Get Charities Curated Content Items
 */
export const contentCategoriesGetCharitiesCuratedContentItems = <ThrowOnError extends boolean = false>(options?: Options<ContentCategoriesGetCharitiesCuratedContentItemsData, ThrowOnError>): RequestResult<ContentCategoriesGetCharitiesCuratedContentItemsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContentCategoriesGetCharitiesCuratedContentItemsResponses, unknown, ThrowOnError>({ url: '/content-categories/charities', ...options });

/**
 * Get Etfs Curated Content Items
 */
export const contentCategoriesGetEtfsCuratedContentItems = <ThrowOnError extends boolean = false>(options?: Options<ContentCategoriesGetEtfsCuratedContentItemsData, ThrowOnError>): RequestResult<ContentCategoriesGetEtfsCuratedContentItemsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContentCategoriesGetEtfsCuratedContentItemsResponses, unknown, ThrowOnError>({ url: '/content-categories/etfs', ...options });

/**
 * Get Featured Content Items
 *
 * Consumer Today-feed featured row. Missing category or zero items
 * returns `{"data": []}` with HTTP 200 (unlike the legacy typed feeds).
 */
export const contentCategoriesGetFeaturedContentItems = <ThrowOnError extends boolean = false>(options?: Options<ContentCategoriesGetFeaturedContentItemsData, ThrowOnError>): RequestResult<ContentCategoriesGetFeaturedContentItemsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContentCategoriesGetFeaturedContentItemsResponses, unknown, ThrowOnError>({ url: '/content-categories/featured', ...options });

/**
 * Get Fundraisers Curated Content Items
 */
export const contentCategoriesGetFundraisersCuratedContentItems = <ThrowOnError extends boolean = false>(options?: Options<ContentCategoriesGetFundraisersCuratedContentItemsData, ThrowOnError>): RequestResult<ContentCategoriesGetFundraisersCuratedContentItemsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContentCategoriesGetFundraisersCuratedContentItemsResponses, unknown, ThrowOnError>({ url: '/content-categories/fundraisers', ...options });

/**
 * Delete Content Category
 *
 * Super-admin only. Deletes a content category outright; the DB-level
 * `ON DELETE CASCADE` on `curated_content_item.content_category_id` and
 * `featured_item_override.content_category_id` removes its items and
 * per-item overrides with it. Deleting the ONLY category of a content type
 * makes that type's consumer feed answer `{"data": []}` (the MIXED
 * `/featured`, `celebrity-charities` and `fundraisers` feeds — see
 * `ContentCategoryService.get_featured_content`) or 404 (the legacy
 * `charities` / `etfs` / `cause-tags` feeds) until a new one is created.
 * This is the operator cure for the repository's duplicate-category
 * warning: delete the EXTRA row, never the one the warning says it serves
 * (the lowest id). Unknown id -> 404.
 */
export const contentCategoriesDeleteContentCategory = <ThrowOnError extends boolean = false>(options: Options<ContentCategoriesDeleteContentCategoryData, ThrowOnError>): RequestResult<ContentCategoriesDeleteContentCategoryResponses, ContentCategoriesDeleteContentCategoryErrors, ThrowOnError> => (options.client ?? client).delete<ContentCategoriesDeleteContentCategoryResponses, ContentCategoriesDeleteContentCategoryErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/content-categories/{category_id}',
    ...options
});

/**
 * Get Content Category Items
 */
export const contentCategoriesGetContentCategoryItems = <ThrowOnError extends boolean = false>(options: Options<ContentCategoriesGetContentCategoryItemsData, ThrowOnError>): RequestResult<ContentCategoriesGetContentCategoryItemsResponses, ContentCategoriesGetContentCategoryItemsErrors, ThrowOnError> => (options.client ?? client).get<ContentCategoriesGetContentCategoryItemsResponses, ContentCategoriesGetContentCategoryItemsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/content-categories/{category_id}/items',
    ...options
});

/**
 * Update Category Items
 */
export const contentCategoriesUpdateCategoryItems = <ThrowOnError extends boolean = false>(options: Options<ContentCategoriesUpdateCategoryItemsData, ThrowOnError>): RequestResult<ContentCategoriesUpdateCategoryItemsResponses, ContentCategoriesUpdateCategoryItemsErrors, ThrowOnError> => (options.client ?? client).put<ContentCategoriesUpdateCategoryItemsResponses, ContentCategoriesUpdateCategoryItemsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/content-categories/{category_id}/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Featured Item Override
 */
export const contentCategoriesDeleteFeaturedItemOverride = <ThrowOnError extends boolean = false>(options: Options<ContentCategoriesDeleteFeaturedItemOverrideData, ThrowOnError>): RequestResult<ContentCategoriesDeleteFeaturedItemOverrideResponses, ContentCategoriesDeleteFeaturedItemOverrideErrors, ThrowOnError> => (options.client ?? client).delete<ContentCategoriesDeleteFeaturedItemOverrideResponses, ContentCategoriesDeleteFeaturedItemOverrideErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/content-categories/{category_id}/items/{content_id}/override',
    ...options
});

/**
 * Upsert Featured Item Override
 */
export const contentCategoriesUpsertFeaturedItemOverride = <ThrowOnError extends boolean = false>(options: Options<ContentCategoriesUpsertFeaturedItemOverrideData, ThrowOnError>): RequestResult<ContentCategoriesUpsertFeaturedItemOverrideResponses, ContentCategoriesUpsertFeaturedItemOverrideErrors, ThrowOnError> => (options.client ?? client).put<ContentCategoriesUpsertFeaturedItemOverrideResponses, ContentCategoriesUpsertFeaturedItemOverrideErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/content-categories/{category_id}/items/{content_id}/override',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Featured Item Image
 */
export const contentCategoriesDeleteFeaturedItemImage = <ThrowOnError extends boolean = false>(options: Options<ContentCategoriesDeleteFeaturedItemImageData, ThrowOnError>): RequestResult<ContentCategoriesDeleteFeaturedItemImageResponses, ContentCategoriesDeleteFeaturedItemImageErrors, ThrowOnError> => (options.client ?? client).delete<ContentCategoriesDeleteFeaturedItemImageResponses, ContentCategoriesDeleteFeaturedItemImageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/content-categories/{category_id}/items/{content_id}/override/image',
    ...options
});

/**
 * Upload Featured Item Image
 */
export const contentCategoriesUploadFeaturedItemImage = <ThrowOnError extends boolean = false>(options: Options<ContentCategoriesUploadFeaturedItemImageData, ThrowOnError>): RequestResult<ContentCategoriesUploadFeaturedItemImageResponses, ContentCategoriesUploadFeaturedItemImageErrors, ThrowOnError> => (options.client ?? client).post<ContentCategoriesUploadFeaturedItemImageResponses, ContentCategoriesUploadFeaturedItemImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/content-categories/{category_id}/items/{content_id}/override/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Bundle Disclaimer
 *
 * Resolve the disclaimer for a surface plus the current T&C so mobile can
 * render the T&C in-app. Conditional GET keys on the disclaimer's
 * content_hash (same semantics as /resolve).
 */
export const disclaimersBundleDisclaimer = <ThrowOnError extends boolean = false>(options: Options<DisclaimersBundleDisclaimerData, ThrowOnError>): RequestResult<DisclaimersBundleDisclaimerResponses, DisclaimersBundleDisclaimerErrors, ThrowOnError> => (options.client ?? client).get<DisclaimersBundleDisclaimerResponses, DisclaimersBundleDisclaimerErrors, ThrowOnError>({ url: '/disclaimers/bundle', ...options });

/**
 * Resolve Disclaimer
 *
 * Resolve the live disclaimer for a surface, optionally for a donation
 * TARGET (LCG-GT19). At most ONE of ``fundraiser_id`` / ``charity_id`` /
 * ``etf_id`` / ``collection_id`` may be supplied: the server rolls the target
 * up to its beneficiary charity set and derives the per-charity AB-488 variant
 * (A_UNCLAIMED vs B_VERIFIED), instead of the client resolving the bare surface
 * (which always yields A_UNCLAIMED). With no target, the bare-surface behaviour
 * is unchanged.
 *
 * PV3-BE8: for a FUNDING-SOURCE-keyed surface (``PLEDGE_CONSENT``, and since
 * RD-BE23 ``RECURRING_CONSENT``), the client instead supplies ``funding``
 * (``card`` / ``wallet``, case-insensitive) to DISPLAY the exact consent body
 * the server will pin at capture. ``funding`` alone is valid ONLY for those
 * surfaces and is MUTUALLY EXCLUSIVE with the four target params (funding is a
 * different key entirely — the funding source chosen, not a charity-consent
 * posture).
 *
 * RD-BE23: ``recurring=true`` selects the RECURRING (e)-block variant on
 * ``DONATE_CONFIRMATION`` / ``CAUSE_ETF``. Those bodies are keyed on BOTH
 * discriminators, so this is the one shape where ``funding`` and a target
 * travel together: ``funding`` is REQUIRED with it (without a rail the server
 * would have to guess which of the tax/fee statements is true), and the target
 * may only be ``charity_id`` or ``etf_id`` — the only two a recurring schedule
 * can have — so a client can never display a body the server would never pin.
 *
 * RD-C9: with ``recurring=true`` the rail vocabulary is ``card`` / ``wallet`` /
 * ``apple_pay``. Apple Pay is accepted ONLY there, because only the (e) block
 * has an Apple-Pay variant: its bodies are the card bodies minus the
 * backup-funding segment, which that rail never offers. The Apple-Pay consent
 * LABEL is still read as ``funding=card`` on ``RECURRING_CONSENT`` — that row
 * is the card/Apple-Pay consent state, and it is the row capture pins.
 *
 * CAM-X3: on the ONE-TIME ``DONATE_CONFIRMATION`` / ``CAUSE_ETF`` bodies,
 * ``funding`` (``card`` / ``wallet``) names the gift's rail and the optional
 * ``payer`` (``person``, the default, or ``company``) who pays, with any one
 * target. A wallet gift is a grant (no new receipt) for anyone, and a company
 * card on ``CAUSE_ETF`` drops the individual-only tax language. ``payer`` on
 * those surfaces requires ``funding`` (the rail decides the body). On
 * ``ADD_FUNDS``, ``payer=company`` alone selects the company deposit body.
 * Apple Pay and Google Pay ask for ``card``.
 *
 * GFU-BE78: ``pledge=true`` selects the AB 488 set's PLEDGE states on
 * ``DONATE_CONFIRMATION``, the set a pledge checkout composes above its consent: by
 * ``fundraiser_id`` (required; a pledge is always made on a fundraiser) and ``funding``
 * (required: ``card`` / ``apple_pay`` / ``wallet``), derived over every charity the pledge
 * would pay, a collection's active members included, hard-pinned to US/en (display equals
 * capture). Nothing published on the key → 404: never the gift body.
 *
 * Absent ``funding``, ``recurring``, ``payer`` and ``pledge``, behaviour is byte-identical
 * to before.
 *
 * Conditional GET: if ``If-None-Match`` equals the resolved content_hash,
 * returns 304; otherwise 200 with the ETag response header set to the
 * content_hash.
 */
export const disclaimersResolveDisclaimer = <ThrowOnError extends boolean = false>(options: Options<DisclaimersResolveDisclaimerData, ThrowOnError>): RequestResult<DisclaimersResolveDisclaimerResponses, DisclaimersResolveDisclaimerErrors, ThrowOnError> => (options.client ?? client).get<DisclaimersResolveDisclaimerResponses, DisclaimersResolveDisclaimerErrors, ThrowOnError>({ url: '/disclaimers/resolve', ...options });

/**
 * Disclaimer Versions
 *
 * Manifest of every current LIVE disclaimer keyed by
 * ``surface|state|jurisdiction|locale`` plus the current T&C entries.
 */
export const disclaimersDisclaimerVersions = <ThrowOnError extends boolean = false>(options?: Options<DisclaimersDisclaimerVersionsData, ThrowOnError>): RequestResult<DisclaimersDisclaimerVersionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DisclaimersDisclaimerVersionsResponses, unknown, ThrowOnError>({ url: '/disclaimers/versions', ...options });

/**
 * Claim Donation
 *
 * Redeem a guest-donation claim token (FWD-BE1 / D4): attach the token's
 * checkout to the authenticated caller — regardless of signup email/method —
 * and backfill a default-Private feed Post. Idempotent: a same-user replay
 * (or a donation already the caller's via email-match) returns success
 * without re-homing or creating a second Post. NET-NEW endpoint consumed only
 * by NEW iOS/Android builds; the response model is additive and small.
 */
export const donationsClaimDonation = <ThrowOnError extends boolean = false>(options: Options<DonationsClaimDonationData, ThrowOnError>): RequestResult<DonationsClaimDonationResponses, DonationsClaimDonationErrors, ThrowOnError> => (options.client ?? client).post<DonationsClaimDonationResponses, DonationsClaimDonationErrors, ThrowOnError>({
    url: '/donations/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Donation Grant Confirmation
 *
 * Return the authenticated owner's wallet grant confirmation.
 *
 * The shared service collapses flag-off, malformed, missing, foreign,
 * company-funded, and non-wallet donations into one constant-detail 404.
 * This handler performs no writes.
 */
export const donationsGetDonationGrantConfirmation = <ThrowOnError extends boolean = false>(options: Options<DonationsGetDonationGrantConfirmationData, ThrowOnError>): RequestResult<DonationsGetDonationGrantConfirmationResponses, DonationsGetDonationGrantConfirmationErrors, ThrowOnError> => (options.client ?? client).get<DonationsGetDonationGrantConfirmationResponses, DonationsGetDonationGrantConfirmationErrors, ThrowOnError>({ url: '/donations/{donation_id}/grant-confirmation', ...options });

/**
 * Resend Donation Grant Confirmation
 *
 * Re-deliver the grant confirmation to the owner's current email.
 */
export const donationsResendDonationGrantConfirmation = <ThrowOnError extends boolean = false>(options: Options<DonationsResendDonationGrantConfirmationData, ThrowOnError>): RequestResult<DonationsResendDonationGrantConfirmationResponses, DonationsResendDonationGrantConfirmationErrors, ThrowOnError> => (options.client ?? client).post<DonationsResendDonationGrantConfirmationResponses, DonationsResendDonationGrantConfirmationErrors, ThrowOnError>({ url: '/donations/{donation_id}/grant-confirmation/resend', ...options });

/**
 * Get Donation Matches
 */
export const donationMatchesGetDonationMatches = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesGetDonationMatchesData, ThrowOnError>): RequestResult<DonationMatchesGetDonationMatchesResponses, DonationMatchesGetDonationMatchesErrors, ThrowOnError> => (options.client ?? client).get<DonationMatchesGetDonationMatchesResponses, DonationMatchesGetDonationMatchesErrors, ThrowOnError>({ url: '/donations/{donation_id}/matches', ...options });

/**
 * Create User Match
 */
export const donationMatchesCreateUserMatch = <ThrowOnError extends boolean = false>(options: Options<DonationMatchesCreateUserMatchData, ThrowOnError>): RequestResult<DonationMatchesCreateUserMatchResponses, DonationMatchesCreateUserMatchErrors, ThrowOnError> => (options.client ?? client).post<DonationMatchesCreateUserMatchResponses, DonationMatchesCreateUserMatchErrors, ThrowOnError>({
    url: '/donations/{donation_id}/matches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Donation Receipt
 *
 * Return the authenticated donor's snapshot-frozen receipt of record.
 *
 * The shared service collapses flag-off, malformed/missing/foreign donations,
 * wallet grants, missing receipts, and company-donor receipts into the same
 * constant-detail 404. This handler performs no writes.
 */
export const donationsGetDonationReceipt = <ThrowOnError extends boolean = false>(options: Options<DonationsGetDonationReceiptData, ThrowOnError>): RequestResult<DonationsGetDonationReceiptResponses, DonationsGetDonationReceiptErrors, ThrowOnError> => (options.client ?? client).get<DonationsGetDonationReceiptResponses, DonationsGetDonationReceiptErrors, ThrowOnError>({ url: '/donations/{donation_id}/receipt', ...options });

/**
 * Resend Donation Receipt
 *
 * Re-deliver the frozen receipt to the authenticated owner's current email.
 */
export const donationsResendDonationReceipt = <ThrowOnError extends boolean = false>(options: Options<DonationsResendDonationReceiptData, ThrowOnError>): RequestResult<DonationsResendDonationReceiptResponses, DonationsResendDonationReceiptErrors, ThrowOnError> => (options.client ?? client).post<DonationsResendDonationReceiptResponses, DonationsResendDonationReceiptErrors, ThrowOnError>({ url: '/donations/{donation_id}/receipt/resend', ...options });

/**
 * Get Etf Posts
 */
export const postsGetEtfPosts = <ThrowOnError extends boolean = false>(options: Options<PostsGetEtfPostsData, ThrowOnError>): RequestResult<PostsGetEtfPostsResponses, PostsGetEtfPostsErrors, ThrowOnError> => (options.client ?? client).get<PostsGetEtfPostsResponses, PostsGetEtfPostsErrors, ThrowOnError>({ url: '/etf/{etf_id}/posts', ...options });

/**
 * Get Etfs
 */
export const etfsGetEtfs = <ThrowOnError extends boolean = false>(options?: Options<EtfsGetEtfsData, ThrowOnError>): RequestResult<EtfsGetEtfsResponses, EtfsGetEtfsErrors, ThrowOnError> => (options?.client ?? client).get<EtfsGetEtfsResponses, EtfsGetEtfsErrors, ThrowOnError>({ url: '/etfs', ...options });

/**
 * Create Etf
 */
export const etfsCreateEtf = <ThrowOnError extends boolean = false>(options: Options<EtfsCreateEtfData, ThrowOnError>): RequestResult<EtfsCreateEtfResponses, EtfsCreateEtfErrors, ThrowOnError> => (options.client ?? client).post<EtfsCreateEtfResponses, EtfsCreateEtfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/etfs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Etf
 */
export const etfsDeleteEtf = <ThrowOnError extends boolean = false>(options: Options<EtfsDeleteEtfData, ThrowOnError>): RequestResult<EtfsDeleteEtfResponses, EtfsDeleteEtfErrors, ThrowOnError> => (options.client ?? client).delete<EtfsDeleteEtfResponses, EtfsDeleteEtfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/etfs/{etf_id}',
    ...options
});

/**
 * Get Etf
 */
export const etfsGetEtf = <ThrowOnError extends boolean = false>(options: Options<EtfsGetEtfData, ThrowOnError>): RequestResult<EtfsGetEtfResponses, EtfsGetEtfErrors, ThrowOnError> => (options.client ?? client).get<EtfsGetEtfResponses, EtfsGetEtfErrors, ThrowOnError>({ url: '/etfs/{etf_id}', ...options });

/**
 * Update Etf
 */
export const etfsUpdateEtf = <ThrowOnError extends boolean = false>(options: Options<EtfsUpdateEtfData, ThrowOnError>): RequestResult<EtfsUpdateEtfResponses, EtfsUpdateEtfErrors, ThrowOnError> => (options.client ?? client).put<EtfsUpdateEtfResponses, EtfsUpdateEtfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/etfs/{etf_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Charity From Etf
 */
export const etfsRemoveCharityFromEtf = <ThrowOnError extends boolean = false>(options: Options<EtfsRemoveCharityFromEtfData, ThrowOnError>): RequestResult<EtfsRemoveCharityFromEtfResponses, EtfsRemoveCharityFromEtfErrors, ThrowOnError> => (options.client ?? client).delete<EtfsRemoveCharityFromEtfResponses, EtfsRemoveCharityFromEtfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/etfs/{etf_id}/charities/{charity_id}',
    ...options
});

/**
 * Add Charity To Etf
 */
export const etfsAddCharityToEtf = <ThrowOnError extends boolean = false>(options: Options<EtfsAddCharityToEtfData, ThrowOnError>): RequestResult<EtfsAddCharityToEtfResponses, EtfsAddCharityToEtfErrors, ThrowOnError> => (options.client ?? client).post<EtfsAddCharityToEtfResponses, EtfsAddCharityToEtfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/etfs/{etf_id}/charities/{charity_id}',
    ...options
});

/**
 * Create Etf Donation
 */
export const donationsCreateEtfDonation = <ThrowOnError extends boolean = false>(options: Options<DonationsCreateEtfDonationData, ThrowOnError>): RequestResult<DonationsCreateEtfDonationResponses, DonationsCreateEtfDonationErrors, ThrowOnError> => (options.client ?? client).post<DonationsCreateEtfDonationResponses, DonationsCreateEtfDonationErrors, ThrowOnError>({
    url: '/etfs/{etf_id}/donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Etf Profile Picture
 */
export const etfsUploadEtfProfilePicture = <ThrowOnError extends boolean = false>(options: Options<EtfsUploadEtfProfilePictureData, ThrowOnError>): RequestResult<EtfsUploadEtfProfilePictureResponses, EtfsUploadEtfProfilePictureErrors, ThrowOnError> => (options.client ?? client).post<EtfsUploadEtfProfilePictureResponses, EtfsUploadEtfProfilePictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/etfs/{etf_id}/profile_picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Create Etf Recurring Donation
 */
export const donationsCreateEtfRecurringDonation = <ThrowOnError extends boolean = false>(options: Options<DonationsCreateEtfRecurringDonationData, ThrowOnError>): RequestResult<DonationsCreateEtfRecurringDonationResponses, DonationsCreateEtfRecurringDonationErrors, ThrowOnError> => (options.client ?? client).post<DonationsCreateEtfRecurringDonationResponses, DonationsCreateEtfRecurringDonationErrors, ThrowOnError>({
    url: '/etfs/{etf_id}/recurring-donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Fees
 */
export const feesGetFees = <ThrowOnError extends boolean = false>(options?: Options<FeesGetFeesData, ThrowOnError>): RequestResult<FeesGetFeesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<FeesGetFeesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/fees',
    ...options
});

/**
 * Get Processor Fees
 */
export const feesGetProcessorFees = <ThrowOnError extends boolean = false>(options?: Options<FeesGetProcessorFeesData, ThrowOnError>): RequestResult<FeesGetProcessorFeesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<FeesGetProcessorFeesResponses, unknown, ThrowOnError>({ url: '/fees/processor', ...options });

/**
 * Update Fee
 */
export const feesUpdateFee = <ThrowOnError extends boolean = false>(options: Options<FeesUpdateFeeData, ThrowOnError>): RequestResult<FeesUpdateFeeResponses, FeesUpdateFeeErrors, ThrowOnError> => (options.client ?? client).put<FeesUpdateFeeResponses, FeesUpdateFeeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/fees/{fee_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Fundraiser Posts
 *
 * Mirror of `/etf/{etf_id}/posts` (swarm MUSTFIX-5). Only authenticated
 * users can list a fundraiser's posts (iOS feed surface). DRAFT and
 * DEACTIVATED fundraisers return 404.
 */
export const postsGetFundraiserPosts = <ThrowOnError extends boolean = false>(options: Options<PostsGetFundraiserPostsData, ThrowOnError>): RequestResult<PostsGetFundraiserPostsResponses, PostsGetFundraiserPostsErrors, ThrowOnError> => (options.client ?? client).get<PostsGetFundraiserPostsResponses, PostsGetFundraiserPostsErrors, ThrowOnError>({ url: '/fundraiser/{fundraiser_id}/posts', ...options });

/**
 * Get Fundraisers
 */
export const fundraisersGetFundraisers = <ThrowOnError extends boolean = false>(options?: Options<FundraisersGetFundraisersData, ThrowOnError>): RequestResult<FundraisersGetFundraisersResponses, FundraisersGetFundraisersErrors, ThrowOnError> => (options?.client ?? client).get<FundraisersGetFundraisersResponses, FundraisersGetFundraisersErrors, ThrowOnError>({ url: '/fundraisers', ...options });

/**
 * Create Fundraiser
 */
export const fundraisersCreateFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersCreateFundraiserData, ThrowOnError>): RequestResult<FundraisersCreateFundraiserResponses, FundraisersCreateFundraiserErrors, ThrowOnError> => (options.client ?? client).post<FundraisersCreateFundraiserResponses, FundraisersCreateFundraiserErrors, ThrowOnError>({
    url: '/fundraisers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Started By Friends
 */
export const fundraisersGetStartedByFriends = <ThrowOnError extends boolean = false>(options?: Options<FundraisersGetStartedByFriendsData, ThrowOnError>): RequestResult<FundraisersGetStartedByFriendsResponses, FundraisersGetStartedByFriendsErrors, ThrowOnError> => (options?.client ?? client).get<FundraisersGetStartedByFriendsResponses, FundraisersGetStartedByFriendsErrors, ThrowOnError>({ url: '/fundraisers/follows/started', ...options });

/**
 * Get Supported By Friends
 */
export const fundraisersGetSupportedByFriends = <ThrowOnError extends boolean = false>(options?: Options<FundraisersGetSupportedByFriendsData, ThrowOnError>): RequestResult<FundraisersGetSupportedByFriendsResponses, FundraisersGetSupportedByFriendsErrors, ThrowOnError> => (options?.client ?? client).get<FundraisersGetSupportedByFriendsResponses, FundraisersGetSupportedByFriendsErrors, ThrowOnError>({ url: '/fundraisers/follows/supported', ...options });

/**
 * Delete Fundraiser
 */
export const fundraisersDeleteFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersDeleteFundraiserData, ThrowOnError>): RequestResult<FundraisersDeleteFundraiserResponses, FundraisersDeleteFundraiserErrors, ThrowOnError> => (options.client ?? client).delete<FundraisersDeleteFundraiserResponses, FundraisersDeleteFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}', ...options });

/**
 * Get Fundraiser
 */
export const fundraisersGetFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersGetFundraiserData, ThrowOnError>): RequestResult<FundraisersGetFundraiserResponses, FundraisersGetFundraiserErrors, ThrowOnError> => (options.client ?? client).get<FundraisersGetFundraiserResponses, FundraisersGetFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}', ...options });

/**
 * Update Fundraiser
 */
export const fundraisersUpdateFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersUpdateFundraiserData, ThrowOnError>): RequestResult<FundraisersUpdateFundraiserResponses, FundraisersUpdateFundraiserErrors, ThrowOnError> => (options.client ?? client).put<FundraisersUpdateFundraiserResponses, FundraisersUpdateFundraiserErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Campaign
 */
export const campaignsUpdateCampaign = <ThrowOnError extends boolean = false>(options: Options<CampaignsUpdateCampaignData, ThrowOnError>): RequestResult<CampaignsUpdateCampaignResponses, CampaignsUpdateCampaignErrors, ThrowOnError> => (options.client ?? client).patch<CampaignsUpdateCampaignResponses, CampaignsUpdateCampaignErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable Campaign
 */
export const campaignsEnableCampaign = <ThrowOnError extends boolean = false>(options: Options<CampaignsEnableCampaignData, ThrowOnError>): RequestResult<CampaignsEnableCampaignResponses, CampaignsEnableCampaignErrors, ThrowOnError> => (options.client ?? client).post<CampaignsEnableCampaignResponses, CampaignsEnableCampaignErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Campaign Join Invites
 *
 * This umbrella's invites, newest first. **OWNER rank, not EDITOR** — it is the
 * one management read carrying invited EMAIL ADDRESSES, which the overview
 * deliberately never exposes. Never carries a token or its hash.
 *
 * Exists so revoke is drivable: `DELETE .../invites/{invite_id}` needs an id, and
 * the mint response alone cannot supply one to a session that did not just mint.
 *
 * Serves the canonical `{data, meta, links}` envelope (R-35) — a new list surface
 * must not mint another per-client unwrap key, so it paginates like the other
 * campaign reads rather than wrapping the rows in a named field.
 */
export const campaignsListCampaignJoinInvites = <ThrowOnError extends boolean = false>(options: Options<CampaignsListCampaignJoinInvitesData, ThrowOnError>): RequestResult<CampaignsListCampaignJoinInvitesResponses, CampaignsListCampaignJoinInvitesErrors, ThrowOnError> => (options.client ?? client).get<CampaignsListCampaignJoinInvitesResponses, CampaignsListCampaignJoinInvitesErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/invites', ...options });

/**
 * Create Campaign Join Invite
 *
 * Mint a single-use, email-bound, expiring invite to JOIN this umbrella
 * (CPB-BE22 PR-7). OWNER rank.
 *
 * The plaintext token is the EMAIL hand-off and is **never returned on the wire**
 * — `P2PJoinInviteOut` omits it, matching `CharityInviteOut`. Re-inviting the same
 * address supersedes the prior live invite rather than stacking a second
 * redeemable token.
 */
export const campaignsCreateCampaignJoinInvite = <ThrowOnError extends boolean = false>(options: Options<CampaignsCreateCampaignJoinInviteData, ThrowOnError>): RequestResult<CampaignsCreateCampaignJoinInviteResponses, CampaignsCreateCampaignJoinInviteErrors, ThrowOnError> => (options.client ?? client).post<CampaignsCreateCampaignJoinInviteResponses, CampaignsCreateCampaignJoinInviteErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Campaign Join Invite
 *
 * Withdraw a pending invite. OWNER rank. Idempotent on an already-terminal
 * invite (204); an unknown id, or one belonging to another umbrella, is 404.
 */
export const campaignsRevokeCampaignJoinInvite = <ThrowOnError extends boolean = false>(options: Options<CampaignsRevokeCampaignJoinInviteData, ThrowOnError>): RequestResult<CampaignsRevokeCampaignJoinInviteResponses, CampaignsRevokeCampaignJoinInviteErrors, ThrowOnError> => (options.client ?? client).delete<CampaignsRevokeCampaignJoinInviteResponses, CampaignsRevokeCampaignJoinInviteErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/invites/{invite_id}', ...options });

/**
 * Preview Campaign Join Parent
 *
 * What this campaign may do about joining the campaign named, before it acts: how that
 * campaign's join setting lets it join, whether it takes campaigns now, when it removed this
 * one, whether the attach would link now, and what it requires. The moderation rank.
 */
export const campaignsPreviewCampaignJoinParent = <ThrowOnError extends boolean = false>(options: Options<CampaignsPreviewCampaignJoinParentData, ThrowOnError>): RequestResult<CampaignsPreviewCampaignJoinParentResponses, CampaignsPreviewCampaignJoinParentErrors, ThrowOnError> => (options.client ?? client).get<CampaignsPreviewCampaignJoinParentResponses, CampaignsPreviewCampaignJoinParentErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/join-parent', ...options });

/**
 * Join Campaign Parent
 *
 * Join another campaign as one of its layers, or ask to, as its join setting allows:
 * 201 ``joined`` (the attach ran), 202 ``asked`` (a request waits for its organizers), or
 * 200 ``asked`` for a repeat, answering the request that already waits. Joining, or
 * asking, is this campaign's consent to the layer terms. The console's door only, never a
 * tool.
 */
export const campaignsJoinCampaignParent = <ThrowOnError extends boolean = false>(options: Options<CampaignsJoinCampaignParentData, ThrowOnError>): RequestResult<CampaignsJoinCampaignParentResponses, CampaignsJoinCampaignParentErrors, ThrowOnError> => (options.client ?? client).post<CampaignsJoinCampaignParentResponses, CampaignsJoinCampaignParentErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign/join-parent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Campaign Join Requests
 *
 * The people asking to start a page under this campaign, those waiting first: the name
 * and team each typed, never their account, email or goal. The read rank.
 */
export const campaignsListCampaignJoinRequests = <ThrowOnError extends boolean = false>(options: Options<CampaignsListCampaignJoinRequestsData, ThrowOnError>): RequestResult<CampaignsListCampaignJoinRequestsResponses, CampaignsListCampaignJoinRequestsErrors, ThrowOnError> => (options.client ?? client).get<CampaignsListCampaignJoinRequestsResponses, CampaignsListCampaignJoinRequestsErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/join-requests', ...options });

/**
 * Approve Campaign Join Request
 *
 * Approve a person's request: their page is made now, by the join, with what they
 * asked, and they are emailed. A refusal at approval is the join's own 4xx, and the request
 * stays waiting. A repeat answers the approved request.
 */
export const campaignsApproveCampaignJoinRequest = <ThrowOnError extends boolean = false>(options: Options<CampaignsApproveCampaignJoinRequestData, ThrowOnError>): RequestResult<CampaignsApproveCampaignJoinRequestResponses, CampaignsApproveCampaignJoinRequestErrors, ThrowOnError> => (options.client ?? client).post<CampaignsApproveCampaignJoinRequestResponses, CampaignsApproveCampaignJoinRequestErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/join-requests/{request_id}/approve', ...options });

/**
 * Decline Campaign Join Request
 *
 * Decline a person's request: final for them and this campaign, with no reason sent;
 * they are emailed that no page was made. A repeat answers the declined request.
 */
export const campaignsDeclineCampaignJoinRequest = <ThrowOnError extends boolean = false>(options: Options<CampaignsDeclineCampaignJoinRequestData, ThrowOnError>): RequestResult<CampaignsDeclineCampaignJoinRequestResponses, CampaignsDeclineCampaignJoinRequestErrors, ThrowOnError> => (options.client ?? client).post<CampaignsDeclineCampaignJoinRequestResponses, CampaignsDeclineCampaignJoinRequestErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/join-requests/{request_id}/decline', ...options });

/**
 * List Campaign Layer Candidates
 *
 * FCM-BE63: "A campaign you run": the organization's open campaigns outside this one's
 * chain and layers, the tops of their own trees first, each with whether it fits below or
 * above this one and why not. The moderation rank. Serves the canonical envelope.
 *
 * With ``move`` (one of this campaign's layers): the ruled Move dialog's list (frame 05),
 * the campaigns that layer's organization runs outside the layer's own subtree, other than
 * this campaign, each with where it sits and no fit: the move decides at submit. The
 * moderation rank on this campaign and on the layer; a layer not under this campaign is
 * the surface's not-found.
 */
export const campaignsListCampaignLayerCandidates = <ThrowOnError extends boolean = false>(options: Options<CampaignsListCampaignLayerCandidatesData, ThrowOnError>): RequestResult<CampaignsListCampaignLayerCandidatesResponses, CampaignsListCampaignLayerCandidatesErrors, ThrowOnError> => (options.client ?? client).get<CampaignsListCampaignLayerCandidatesResponses, CampaignsListCampaignLayerCandidatesErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/layer-candidates', ...options });

/**
 * List Sent Campaign Layer Invites
 *
 * The layer invites this campaign sent, newest first. The read rank.
 */
export const campaignsListSentCampaignLayerInvites = <ThrowOnError extends boolean = false>(options: Options<CampaignsListSentCampaignLayerInvitesData, ThrowOnError>): RequestResult<CampaignsListSentCampaignLayerInvitesResponses, CampaignsListSentCampaignLayerInvitesErrors, ThrowOnError> => (options.client ?? client).get<CampaignsListSentCampaignLayerInvitesResponses, CampaignsListSentCampaignLayerInvitesErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/layer-invites', ...options });

/**
 * Send Campaign Layer Invite
 *
 * Invite another organization's campaign to become a layer of this one. A repeat for
 * the same campaign answers the pending invite, with no second email.
 */
export const campaignsSendCampaignLayerInvite = <ThrowOnError extends boolean = false>(options: Options<CampaignsSendCampaignLayerInviteData, ThrowOnError>): RequestResult<CampaignsSendCampaignLayerInviteResponses, CampaignsSendCampaignLayerInviteErrors, ThrowOnError> => (options.client ?? client).post<CampaignsSendCampaignLayerInviteResponses, CampaignsSendCampaignLayerInviteErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign/layer-invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Campaign Layer Invite
 *
 * Withdraw a pending layer invite this campaign sent. A closed one is a no-op 204.
 */
export const campaignsRevokeCampaignLayerInvite = <ThrowOnError extends boolean = false>(options: Options<CampaignsRevokeCampaignLayerInviteData, ThrowOnError>): RequestResult<CampaignsRevokeCampaignLayerInviteResponses, CampaignsRevokeCampaignLayerInviteErrors, ThrowOnError> => (options.client ?? client).delete<CampaignsRevokeCampaignLayerInviteResponses, CampaignsRevokeCampaignLayerInviteErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/layer-invites/{invite_id}', ...options });

/**
 * Withdraw Campaign Layer Request
 *
 * Withdraw this campaign's waiting request; nothing waiting is a no-op 204. The
 * console's door only.
 */
export const campaignsWithdrawCampaignLayerRequest = <ThrowOnError extends boolean = false>(options: Options<CampaignsWithdrawCampaignLayerRequestData, ThrowOnError>): RequestResult<CampaignsWithdrawCampaignLayerRequestResponses, CampaignsWithdrawCampaignLayerRequestErrors, ThrowOnError> => (options.client ?? client).delete<CampaignsWithdrawCampaignLayerRequestResponses, CampaignsWithdrawCampaignLayerRequestErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/layer-request', ...options });

/**
 * Get Own Campaign Layer Request
 *
 * This campaign's own request to join another: the one waiting, else the latest answer
 * within the last 14 days, else none. The read rank.
 */
export const campaignsGetOwnCampaignLayerRequest = <ThrowOnError extends boolean = false>(options: Options<CampaignsGetOwnCampaignLayerRequestData, ThrowOnError>): RequestResult<CampaignsGetOwnCampaignLayerRequestResponses, CampaignsGetOwnCampaignLayerRequestErrors, ThrowOnError> => (options.client ?? client).get<CampaignsGetOwnCampaignLayerRequestResponses, CampaignsGetOwnCampaignLayerRequestErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/layer-request', ...options });

/**
 * List Campaign Layer Requests
 *
 * The requests other organizations' campaigns sent to become this campaign's layers,
 * those waiting first, each with whether the attach would link now. The read rank; pages
 * by at most 25, as the layer invitations' lists do.
 */
export const campaignsListCampaignLayerRequests = <ThrowOnError extends boolean = false>(options: Options<CampaignsListCampaignLayerRequestsData, ThrowOnError>): RequestResult<CampaignsListCampaignLayerRequestsResponses, CampaignsListCampaignLayerRequestsErrors, ThrowOnError> => (options.client ?? client).get<CampaignsListCampaignLayerRequestsResponses, CampaignsListCampaignLayerRequestsErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/layer-requests', ...options });

/**
 * Approve Campaign Layer Request
 *
 * Approve another campaign's request: it becomes a layer of this one, with every check
 * an attach makes (a failed one is its 409, and the request stays waiting). The console's
 * door only, never a tool.
 */
export const campaignsApproveCampaignLayerRequest = <ThrowOnError extends boolean = false>(options: Options<CampaignsApproveCampaignLayerRequestData, ThrowOnError>): RequestResult<CampaignsApproveCampaignLayerRequestResponses, CampaignsApproveCampaignLayerRequestErrors, ThrowOnError> => (options.client ?? client).post<CampaignsApproveCampaignLayerRequestResponses, CampaignsApproveCampaignLayerRequestErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/layer-requests/{request_id}/approve', ...options });

/**
 * Decline Campaign Layer Request
 *
 * Decline another campaign's request: final for the pair; an invitation still brings it
 * in. The console's door only.
 */
export const campaignsDeclineCampaignLayerRequest = <ThrowOnError extends boolean = false>(options: Options<CampaignsDeclineCampaignLayerRequestData, ThrowOnError>): RequestResult<CampaignsDeclineCampaignLayerRequestResponses, CampaignsDeclineCampaignLayerRequestErrors, ThrowOnError> => (options.client ?? client).post<CampaignsDeclineCampaignLayerRequestResponses, CampaignsDeclineCampaignLayerRequestErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/layer-requests/{request_id}/decline', ...options });

/**
 * List Campaign Layers
 *
 * This campaign's child layers, oldest link first: each one's name and state. The
 * read rank, like the overview. Serves the canonical `{data, meta, links}` envelope.
 */
export const campaignsListCampaignLayers = <ThrowOnError extends boolean = false>(options: Options<CampaignsListCampaignLayersData, ThrowOnError>): RequestResult<CampaignsListCampaignLayersResponses, CampaignsListCampaignLayersErrors, ThrowOnError> => (options.client ?? client).get<CampaignsListCampaignLayersResponses, CampaignsListCampaignLayersErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/layers', ...options });

/**
 * Attach Campaign Layer
 *
 * Attach a campaign the caller also organizes under this one. A repeat answers the
 * same link.
 */
export const campaignsAttachCampaignLayer = <ThrowOnError extends boolean = false>(options: Options<CampaignsAttachCampaignLayerData, ThrowOnError>): RequestResult<CampaignsAttachCampaignLayerResponses, CampaignsAttachCampaignLayerErrors, ThrowOnError> => (options.client ?? client).post<CampaignsAttachCampaignLayerResponses, CampaignsAttachCampaignLayerErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign/layers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Campaign Layer
 *
 * Remove one of this campaign's layers; it becomes a campaign of its own. A layer no
 * longer under this campaign is a no-op 204.
 */
export const campaignsRemoveCampaignLayer = <ThrowOnError extends boolean = false>(options: Options<CampaignsRemoveCampaignLayerData, ThrowOnError>): RequestResult<CampaignsRemoveCampaignLayerResponses, CampaignsRemoveCampaignLayerErrors, ThrowOnError> => (options.client ?? client).delete<CampaignsRemoveCampaignLayerResponses, CampaignsRemoveCampaignLayerErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/layers/{child_campaign_id}', ...options });

/**
 * Leave Campaign Layer
 *
 * Leave the campaign this one is part of: only when no one can bring that campaign
 * back (its group dissolved, or its organizer deleted their account); otherwise only its
 * organizers can remove this one (409). A campaign with no parent is a no-op 204.
 */
export const campaignsLeaveCampaignLayer = <ThrowOnError extends boolean = false>(options: Options<CampaignsLeaveCampaignLayerData, ThrowOnError>): RequestResult<CampaignsLeaveCampaignLayerResponses, CampaignsLeaveCampaignLayerErrors, ThrowOnError> => (options.client ?? client).post<CampaignsLeaveCampaignLayerResponses, CampaignsLeaveCampaignLayerErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/leave', ...options });

/**
 * Move Campaign Layer
 *
 * Move this campaign under another campaign, holding the organizer rank on all three.
 * A repeat answers the same link.
 */
export const campaignsMoveCampaignLayer = <ThrowOnError extends boolean = false>(options: Options<CampaignsMoveCampaignLayerData, ThrowOnError>): RequestResult<CampaignsMoveCampaignLayerResponses, CampaignsMoveCampaignLayerErrors, ThrowOnError> => (options.client ?? client).post<CampaignsMoveCampaignLayerResponses, CampaignsMoveCampaignLayerErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Campaign Overview
 */
export const campaignsGetCampaignOverview = <ThrowOnError extends boolean = false>(options: Options<CampaignsGetCampaignOverviewData, ThrowOnError>): RequestResult<CampaignsGetCampaignOverviewResponses, CampaignsGetCampaignOverviewErrors, ThrowOnError> => (options.client ?? client).get<CampaignsGetCampaignOverviewResponses, CampaignsGetCampaignOverviewErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/overview', ...options });

/**
 * Get Campaign Layer Parent
 *
 * The campaigns this one is part of, top first, and whether its organizers may leave
 * its parent. The read rank.
 */
export const campaignsGetCampaignLayerParent = <ThrowOnError extends boolean = false>(options: Options<CampaignsGetCampaignLayerParentData, ThrowOnError>): RequestResult<CampaignsGetCampaignLayerParentResponses, CampaignsGetCampaignLayerParentErrors, ThrowOnError> => (options.client ?? client).get<CampaignsGetCampaignLayerParentResponses, CampaignsGetCampaignLayerParentErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/parent', ...options });

/**
 * List Received Campaign Layer Invites
 *
 * The layer invites this campaign received, newest first, each with the inviting
 * campaign's charities and whether this campaign could accept it now. The read rank.
 */
export const campaignsListReceivedCampaignLayerInvites = <ThrowOnError extends boolean = false>(options: Options<CampaignsListReceivedCampaignLayerInvitesData, ThrowOnError>): RequestResult<CampaignsListReceivedCampaignLayerInvitesResponses, CampaignsListReceivedCampaignLayerInvitesErrors, ThrowOnError> => (options.client ?? client).get<CampaignsListReceivedCampaignLayerInvitesResponses, CampaignsListReceivedCampaignLayerInvitesErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/received-layer-invites', ...options });

/**
 * Accept Campaign Layer Invite
 *
 * Accept a layer invite this campaign received: it becomes a layer of the inviting
 * campaign, with every check an attach makes (a failed one is its 409, and the invite stays
 * pending). Accepting is the consent (Q3). The console's door only, never a tool.
 */
export const campaignsAcceptCampaignLayerInvite = <ThrowOnError extends boolean = false>(options: Options<CampaignsAcceptCampaignLayerInviteData, ThrowOnError>): RequestResult<CampaignsAcceptCampaignLayerInviteResponses, CampaignsAcceptCampaignLayerInviteErrors, ThrowOnError> => (options.client ?? client).post<CampaignsAcceptCampaignLayerInviteResponses, CampaignsAcceptCampaignLayerInviteErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/received-layer-invites/{invite_id}/accept', ...options });

/**
 * Decline Campaign Layer Invite
 *
 * Decline a layer invite this campaign received. The console's door only.
 */
export const campaignsDeclineCampaignLayerInvite = <ThrowOnError extends boolean = false>(options: Options<CampaignsDeclineCampaignLayerInviteData, ThrowOnError>): RequestResult<CampaignsDeclineCampaignLayerInviteResponses, CampaignsDeclineCampaignLayerInviteErrors, ThrowOnError> => (options.client ?? client).post<CampaignsDeclineCampaignLayerInviteResponses, CampaignsDeclineCampaignLayerInviteErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/received-layer-invites/{invite_id}/decline', ...options });

/**
 * Set Up Campaign Season
 *
 * Make a season's games, one transaction per game. For each game: its page, a campaign
 * under the season named for it, raising for the season's charities where the season picks
 * them (a page whose donors pick theirs where its supporters pick); its nightly pledge
 * fundraiser, a campaign under the game with joining shut, raising for `nightly_recipients`
 * where the season's supporters pick (from the list that binds them; none sent where the
 * season picks); both published; the season's pledge template copied onto the two, dated by
 * the game (the count on the game, the offer on the nightly fundraiser); the opponent's side
 * of the game's scoreboard, a `fan` count of the same unit, when the copy is a count the
 * organizer enters and the game names an `opponent`; and the nightly fundraiser featured on
 * the game's page. On the season's first setup, while nothing is under it yet, the first game
 * made also makes the season the level its games' pages show, in the Schedule look; games
 * added later leave the card as the season's organizers last set it. A game the writes
 * refuse, or one that meets a fault, is made not at all and listed in `refused` with the
 * refusing write's own sentence (null for a fault); the others are made, so sending the
 * refused games again makes the season whole. For the
 * season's organizers at its moderation rank; anyone else, or a missing fundraiser, 404. A
 * fundraiser that is not a campaign, 404. A season with no pledge template, 404; one this
 * server cannot read, one that names no one it counts, or one that counts a total, 400,
 * before any game is made; so is a season whose games could not be its own organizer's.
 * When any game names an opponent on a season that counts, Terms of Use evidence that is not
 * the current Terms answers 409 `PLEDGE_CREATOR_TERMS_CHANGED` (no current Terms, 409
 * `PLEDGE_CREATOR_TERMS_UNAVAILABLE`), before any game is made.
 * `Idempotency-Key` REQUIRED (fail-closed 422).
 *
 * The season's own settings are not this act's: the console saves them first, in this order,
 * its deadline and what its campaigns are called (`PATCH /fundraisers/{fundraiser_id}/
 * campaign`), then its pledge template (`PUT /fundraisers/{fundraiser_id}/pledge-template`),
 * and then sends this act, each game's `opponent` as an object and the nightly picks as
 * `nightly_recipients`. A retry: an answer that was lost is asked again with the same
 * `Idempotency-Key` and the same body, which answers the stored answer (or 409 while the act
 * still runs); the games `refused` names are sent again under a new key, alone or with the
 * whole schedule: a game the season already holds under the same page name and first pitch
 * is answered among `games` as it stands, and none of it is made again (FCM-BE130). The
 * season deleted mid-act ends it: 404 while no game of it was made, else the games left are
 * `refused` with no sentence.
 */
export const campaignsSetUpCampaignSeason = <ThrowOnError extends boolean = false>(options: Options<CampaignsSetUpCampaignSeasonData, ThrowOnError>): RequestResult<CampaignsSetUpCampaignSeasonResponses, CampaignsSetUpCampaignSeasonErrors, ThrowOnError> => (options.client ?? client).post<CampaignsSetUpCampaignSeasonResponses, CampaignsSetUpCampaignSeasonErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign/season',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Campaign Layer Structure
 *
 * FCM-BE63: where this campaign sits and its tree's default expansion. The read rank.
 */
export const campaignsGetCampaignLayerStructure = <ThrowOnError extends boolean = false>(options: Options<CampaignsGetCampaignLayerStructureData, ThrowOnError>): RequestResult<CampaignsGetCampaignLayerStructureResponses, CampaignsGetCampaignLayerStructureErrors, ThrowOnError> => (options.client ?? client).get<CampaignsGetCampaignLayerStructureResponses, CampaignsGetCampaignLayerStructureErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/structure', ...options });

/**
 * List Campaign Structure Layers
 *
 * FCM-BE63: a page of one node's layers in this campaign's tree, oldest link first.
 * Serves the canonical `{data, meta, links}` envelope.
 */
export const campaignsListCampaignStructureLayers = <ThrowOnError extends boolean = false>(options: Options<CampaignsListCampaignStructureLayersData, ThrowOnError>): RequestResult<CampaignsListCampaignStructureLayersResponses, CampaignsListCampaignStructureLayersErrors, ThrowOnError> => (options.client ?? client).get<CampaignsListCampaignStructureLayersResponses, CampaignsListCampaignStructureLayersErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/campaign/structure/{node_id}/layers', ...options });

/**
 * Update Campaign Supporter
 */
export const campaignsUpdateCampaignSupporter = <ThrowOnError extends boolean = false>(options: Options<CampaignsUpdateCampaignSupporterData, ThrowOnError>): RequestResult<CampaignsUpdateCampaignSupporterResponses, CampaignsUpdateCampaignSupporterErrors, ThrowOnError> => (options.client ?? client).patch<CampaignsUpdateCampaignSupporterResponses, CampaignsUpdateCampaignSupporterErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign/supporters/{supporter_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Campaign Team
 */
export const campaignsCreateCampaignTeam = <ThrowOnError extends boolean = false>(options: Options<CampaignsCreateCampaignTeamData, ThrowOnError>): RequestResult<CampaignsCreateCampaignTeamResponses, CampaignsCreateCampaignTeamErrors, ThrowOnError> => (options.client ?? client).post<CampaignsCreateCampaignTeamResponses, CampaignsCreateCampaignTeamErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Campaign Team
 */
export const campaignsUpdateCampaignTeam = <ThrowOnError extends boolean = false>(options: Options<CampaignsUpdateCampaignTeamData, ThrowOnError>): RequestResult<CampaignsUpdateCampaignTeamResponses, CampaignsUpdateCampaignTeamErrors, ThrowOnError> => (options.client ?? client).patch<CampaignsUpdateCampaignTeamResponses, CampaignsUpdateCampaignTeamErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/campaign/teams/{team_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Charity From Fundraiser
 */
export const fundraisersRemoveCharityFromFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersRemoveCharityFromFundraiserData, ThrowOnError>): RequestResult<FundraisersRemoveCharityFromFundraiserResponses, FundraisersRemoveCharityFromFundraiserErrors, ThrowOnError> => (options.client ?? client).delete<FundraisersRemoveCharityFromFundraiserResponses, FundraisersRemoveCharityFromFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/charities/{charity_id}', ...options });

/**
 * Add Charity To Fundraiser
 *
 * Empty 201 body per plan §12 and swarm SHOULDFIX-5 (matches the
 * DELETE sibling, which returns 204 with no body).
 */
export const fundraisersAddCharityToFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersAddCharityToFundraiserData, ThrowOnError>): RequestResult<FundraisersAddCharityToFundraiserResponses, FundraisersAddCharityToFundraiserErrors, ThrowOnError> => (options.client ?? client).post<FundraisersAddCharityToFundraiserResponses, FundraisersAddCharityToFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/charities/{charity_id}', ...options });

/**
 * Remove Collection From Fundraiser
 */
export const fundraisersRemoveCollectionFromFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersRemoveCollectionFromFundraiserData, ThrowOnError>): RequestResult<FundraisersRemoveCollectionFromFundraiserResponses, FundraisersRemoveCollectionFromFundraiserErrors, ThrowOnError> => (options.client ?? client).delete<FundraisersRemoveCollectionFromFundraiserResponses, FundraisersRemoveCollectionFromFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/charity-collections/{collection_id}', ...options });

/**
 * Add Collection To Fundraiser
 *
 * CC-BE7: target a Charity Collection on a fundraiser. Empty 201 body,
 * mirroring the etf sub-resource. Path matches CC-IOS6's
 * `/fundraisers/{id}/charity-collections/{collectionId}`.
 */
export const fundraisersAddCollectionToFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersAddCollectionToFundraiserData, ThrowOnError>): RequestResult<FundraisersAddCollectionToFundraiserResponses, FundraisersAddCollectionToFundraiserErrors, ThrowOnError> => (options.client ?? client).post<FundraisersAddCollectionToFundraiserResponses, FundraisersAddCollectionToFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/charity-collections/{collection_id}', ...options });

/**
 * Close Fundraiser
 *
 * Close a fundraiser: its page stays up with its final total and new donations
 * stop. Reversible with Reopen. A repeated Close is a no-op; a draft or deactivated
 * fundraiser is a conflict.
 */
export const fundraisersCloseFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersCloseFundraiserData, ThrowOnError>): RequestResult<FundraisersCloseFundraiserResponses, FundraisersCloseFundraiserErrors, ThrowOnError> => (options.client ?? client).post<FundraisersCloseFundraiserResponses, FundraisersCloseFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/close', ...options });

/**
 * Create Fundraiser Donation
 */
export const donationsCreateFundraiserDonation = <ThrowOnError extends boolean = false>(options: Options<DonationsCreateFundraiserDonationData, ThrowOnError>): RequestResult<DonationsCreateFundraiserDonationResponses, DonationsCreateFundraiserDonationErrors, ThrowOnError> => (options.client ?? client).post<DonationsCreateFundraiserDonationResponses, DonationsCreateFundraiserDonationErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Etf From Fundraiser
 */
export const fundraisersRemoveEtfFromFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersRemoveEtfFromFundraiserData, ThrowOnError>): RequestResult<FundraisersRemoveEtfFromFundraiserResponses, FundraisersRemoveEtfFromFundraiserErrors, ThrowOnError> => (options.client ?? client).delete<FundraisersRemoveEtfFromFundraiserResponses, FundraisersRemoveEtfFromFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/etfs/{etf_id}', ...options });

/**
 * Add Etf To Fundraiser
 *
 * Empty 201 body per plan §12 and swarm SHOULDFIX-5.
 */
export const fundraisersAddEtfToFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersAddEtfToFundraiserData, ThrowOnError>): RequestResult<FundraisersAddEtfToFundraiserResponses, FundraisersAddEtfToFundraiserErrors, ThrowOnError> => (options.client ?? client).post<FundraisersAddEtfToFundraiserResponses, FundraisersAddEtfToFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/etfs/{etf_id}', ...options });

/**
 * Create Match Offer Request
 */
export const fundraiserMatchOfferRequestsCreateMatchOfferRequest = <ThrowOnError extends boolean = false>(options: Options<FundraiserMatchOfferRequestsCreateMatchOfferRequestData, ThrowOnError>): RequestResult<FundraiserMatchOfferRequestsCreateMatchOfferRequestResponses, FundraiserMatchOfferRequestsCreateMatchOfferRequestErrors, ThrowOnError> => (options.client ?? client).post<FundraiserMatchOfferRequestsCreateMatchOfferRequestResponses, FundraiserMatchOfferRequestsCreateMatchOfferRequestErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/match-offer-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Fundraiser Members
 */
export const fundraisersGetFundraiserMembers = <ThrowOnError extends boolean = false>(options: Options<FundraisersGetFundraiserMembersData, ThrowOnError>): RequestResult<FundraisersGetFundraiserMembersResponses, FundraisersGetFundraiserMembersErrors, ThrowOnError> => (options.client ?? client).get<FundraisersGetFundraiserMembersResponses, FundraisersGetFundraiserMembersErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/members', ...options });

/**
 * Invite Fundraiser Member
 */
export const fundraisersInviteFundraiserMember = <ThrowOnError extends boolean = false>(options: Options<FundraisersInviteFundraiserMemberData, ThrowOnError>): RequestResult<FundraisersInviteFundraiserMemberResponses, FundraisersInviteFundraiserMemberErrors, ThrowOnError> => (options.client ?? client).post<FundraisersInviteFundraiserMemberResponses, FundraisersInviteFundraiserMemberErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Fundraiser Membership
 */
export const fundraisersAcceptFundraiserMembership = <ThrowOnError extends boolean = false>(options: Options<FundraisersAcceptFundraiserMembershipData, ThrowOnError>): RequestResult<FundraisersAcceptFundraiserMembershipResponses, FundraisersAcceptFundraiserMembershipErrors, ThrowOnError> => (options.client ?? client).post<FundraisersAcceptFundraiserMembershipResponses, FundraisersAcceptFundraiserMembershipErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/members/accept', ...options });

/**
 * Decline Or Leave Fundraiser Membership
 */
export const fundraisersDeclineOrLeaveFundraiserMembership = <ThrowOnError extends boolean = false>(options: Options<FundraisersDeclineOrLeaveFundraiserMembershipData, ThrowOnError>): RequestResult<FundraisersDeclineOrLeaveFundraiserMembershipResponses, FundraisersDeclineOrLeaveFundraiserMembershipErrors, ThrowOnError> => (options.client ?? client).delete<FundraisersDeclineOrLeaveFundraiserMembershipResponses, FundraisersDeclineOrLeaveFundraiserMembershipErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/members/me', ...options });

/**
 * Remove Fundraiser Member
 */
export const fundraisersRemoveFundraiserMember = <ThrowOnError extends boolean = false>(options: Options<FundraisersRemoveFundraiserMemberData, ThrowOnError>): RequestResult<FundraisersRemoveFundraiserMemberResponses, FundraisersRemoveFundraiserMemberErrors, ThrowOnError> => (options.client ?? client).delete<FundraisersRemoveFundraiserMemberResponses, FundraisersRemoveFundraiserMemberErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/members/{member_user_id}', ...options });

/**
 * List Fundraiser Pledge Offers
 *
 * A page's pledges (plan §1.2f, §1.9.7): every pledge offer the fundraiser hosts, oldest
 * first, in every status (at most 25: a page carries no more), and every measure it owns or
 * its offers read. An offer with
 * ``measure_shown`` false is not pledgeable here: no measure of it is served, nor its status,
 * window, close or last update, and no pledge button is shown. Live pledged figures are
 * ``GET /pledges/live``'s. A fundraiser that is
 * missing, hidden from the caller, a draft, or not public → 404, except to its own
 * organizers. Anonymous or signed in; dark behind the flag.
 */
export const pledgesListFundraiserPledgeOffers = <ThrowOnError extends boolean = false>(options: Options<PledgesListFundraiserPledgeOffersData, ThrowOnError>): RequestResult<PledgesListFundraiserPledgeOffersResponses, PledgesListFundraiserPledgeOffersErrors, ThrowOnError> => (options.client ?? client).get<PledgesListFundraiserPledgeOffersResponses, PledgesListFundraiserPledgeOffersErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/pledge-offers', ...options });

/**
 * Clear Pledge Template
 *
 * Clear the pledge template a campaign layer carries (plan §1.2b), for an organizer of the
 * layer at its OWNER rank; anyone else, or a fundraiser that is missing, → 404. A layer that
 * carries none answers the same 204. Copies already made never change. ``Idempotency-Key``
 * REQUIRED (fail-closed 422).
 */
export const pledgesClearPledgeTemplate = <ThrowOnError extends boolean = false>(options: Options<PledgesClearPledgeTemplateData, ThrowOnError>): RequestResult<PledgesClearPledgeTemplateResponses, PledgesClearPledgeTemplateErrors, ThrowOnError> => (options.client ?? client).delete<PledgesClearPledgeTemplateResponses, PledgesClearPledgeTemplateErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/pledge-template', ...options });

/**
 * Get Pledge Template
 *
 * The pledge template a campaign layer carries (plan §1.2b), for an organizer of the layer
 * at its OWNER rank: its measure, its offer, where its copies land (``copy_scope``) and when
 * it was last set. Anyone else, or a fundraiser that is missing, → 404, whether or not a
 * template exists; a layer that carries none → 404 to its organizer. Signed in; dark behind
 * the flag.
 */
export const pledgesGetPledgeTemplate = <ThrowOnError extends boolean = false>(options: Options<PledgesGetPledgeTemplateData, ThrowOnError>): RequestResult<PledgesGetPledgeTemplateResponses, PledgesGetPledgeTemplateErrors, ThrowOnError> => (options.client ?? client).get<PledgesGetPledgeTemplateResponses, PledgesGetPledgeTemplateErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/pledge-template', ...options });

/**
 * Set Pledge Template
 *
 * Set the ONE pledge template a campaign layer carries, replacing any it carried (plan
 * §1.2b): a measure and an offer, in ``POST /pledge-offers``' shapes, copied onto each page or
 * layer created beneath the layer (each joiner's page; each game of a season's setup). For an
 * organizer of the layer at its OWNER rank; anyone else, or a fundraiser that is missing, →
 * 404. A fundraiser that is not a campaign → 400. A layer that has ended → 409
 * ``PLEDGING_CLOSED``. An opening offset (``offer.opens_before_start_minutes``) of 0 to 10080
 * minutes → 400 ``PLEDGE_TEMPLATE_OPENING_REFUSED``: pledging on each copy opens when the copy
 * is published (D-GFU-57); one outside them is the request's own 422. What every copy would
 * refuse is refused now (400): a health-type count
 * (``health_data`` true), words naming a health subject or a candidate's election or using a
 * betting word (GFU-BE84), ending at
 * a target it lacks, of zero, or above its most likely count, a yes/no's other settings, a
 * count without its declared maximum, terms that don't fit their count, a rate or a lowest rate
 * above the cap (``PLEDGE_RATE_ABOVE_CAP``), a condition its
 * target alone decides or a rule that would pay nothing even at that target, and for a
 * template carrying its own dates, an end
 * that has passed, a window already closed, or an end past
 * the layer's own deadline. A total (``measure.rollup``) adds up, in each copy, the counts
 * beneath the page or layer that copy lands on (``scope`` ``beneath``), so one naming
 * particular counts or games is refused (400), as is any setting the measure writer refuses a
 * total; a copy onto a fundraiser with nothing beneath it is refused at the copy. Where copies
 * land (``copy_scope``): a template that names its
 * subject (``measure.subject_name``, or for a total the subject of the counts it adds up,
 * ``measure.rollup.subject_name``) is copied ONLY onto fundraisers the layer's own organizer
 * runs, never onto anyone else's page, a supporter's join included; one that leaves it unset
 * takes each copy's own subject. Copies already made never change. ``Idempotency-Key``
 * REQUIRED (fail-closed 422).
 */
export const pledgesSetPledgeTemplate = <ThrowOnError extends boolean = false>(options: Options<PledgesSetPledgeTemplateData, ThrowOnError>): RequestResult<PledgesSetPledgeTemplateResponses, PledgesSetPledgeTemplateErrors, ThrowOnError> => (options.client ?? client).put<PledgesSetPledgeTemplateResponses, PledgesSetPledgeTemplateErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/pledge-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Fundraiser Picture
 */
export const fundraisersUploadFundraiserPicture = <ThrowOnError extends boolean = false>(options: Options<FundraisersUploadFundraiserPictureData, ThrowOnError>): RequestResult<FundraisersUploadFundraiserPictureResponses, FundraisersUploadFundraiserPictureErrors, ThrowOnError> => (options.client ?? client).post<FundraisersUploadFundraiserPictureResponses, FundraisersUploadFundraiserPictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/fundraisers/{fundraiser_id}/profile_picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Publish Fundraiser
 */
export const fundraisersPublishFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersPublishFundraiserData, ThrowOnError>): RequestResult<FundraisersPublishFundraiserResponses, FundraisersPublishFundraiserErrors, ThrowOnError> => (options.client ?? client).post<FundraisersPublishFundraiserResponses, FundraisersPublishFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/publish', ...options });

/**
 * Reactivate Fundraiser
 */
export const fundraisersReactivateFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersReactivateFundraiserData, ThrowOnError>): RequestResult<FundraisersReactivateFundraiserResponses, FundraisersReactivateFundraiserErrors, ThrowOnError> => (options.client ?? client).post<FundraisersReactivateFundraiserResponses, FundraisersReactivateFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/reactivate', ...options });

/**
 * Reopen Fundraiser
 *
 * Reopen a closed fundraiser so it accepts donations again. Reopening an open
 * fundraiser is a no-op; a fundraiser closed by its group's dissolution, or by its
 * organizer's account deletion, cannot be reopened.
 */
export const fundraisersReopenFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersReopenFundraiserData, ThrowOnError>): RequestResult<FundraisersReopenFundraiserResponses, FundraisersReopenFundraiserErrors, ThrowOnError> => (options.client ?? client).post<FundraisersReopenFundraiserResponses, FundraisersReopenFundraiserErrors, ThrowOnError>({ url: '/fundraisers/{fundraiser_id}/reopen', ...options });

/**
 * Transfer Fundraiser Ownership
 */
export const fundraisersTransferFundraiserOwnership = <ThrowOnError extends boolean = false>(options: Options<FundraisersTransferFundraiserOwnershipData, ThrowOnError>): RequestResult<FundraisersTransferFundraiserOwnershipResponses, FundraisersTransferFundraiserOwnershipErrors, ThrowOnError> => (options.client ?? client).post<FundraisersTransferFundraiserOwnershipResponses, FundraisersTransferFundraiserOwnershipErrors, ThrowOnError>({
    url: '/fundraisers/{fundraiser_id}/transfer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Game Catalog
 *
 * The server-authoritative economy + template sheet (plan §2.3/§2.9):
 * building types/prices, earn amounts + caps, mini-game rows, decor/sign
 * SKUs, template copy, `world_seed`, `schema_version`. Constant per deploy
 * (no DB read) — served with `Cache-Control: public, max-age=300`. Values
 * change only via plan-§2.9 updates (`app/domain/game_catalog.py`).
 */
export const gameGetGameCatalog = <ThrowOnError extends boolean = false>(options?: Options<GameGetGameCatalogData, ThrowOnError>): RequestResult<GameGetGameCatalogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GameGetGameCatalogResponses, unknown, ThrowOnError>({ url: '/game/catalog', ...options });

/**
 * Get Game Charity Foundation
 *
 * A charity's game foundation, get-or-create (plan §1.5/§2.3, GME-BE6):
 * template (§2.7 category mapping), world placement (null geo while the
 * charity's centroid is unresolved — plan §4), the template-seeded donor
 * objects with LIVE claim state, the real-charity block (name /
 * deterministic GCS logo URL / Verified badge / status), and the §1.8
 * "Givmo visited" badge. First read materializes the row race-safely;
 * 404s: unknown charity, or caller not yet onboarded (the FTUE gate).
 */
export const gameGetGameCharityFoundation = <ThrowOnError extends boolean = false>(options: Options<GameGetGameCharityFoundationData, ThrowOnError>): RequestResult<GameGetGameCharityFoundationResponses, GameGetGameCharityFoundationErrors, ThrowOnError> => (options.client ?? client).get<GameGetGameCharityFoundationResponses, GameGetGameCharityFoundationErrors, ThrowOnError>({ url: '/game/charities/{charity_id}/foundation', ...options });

/**
 * Remove Charity Foundation Reaction
 *
 * Remove the caller's reaction from a charity foundation (GME-BE15).
 * Convergent — "ensure absent" (`changed: false` when nothing was held);
 * no target validation, 200 with the post-write counts block (the PUT
 * twin's state read).
 */
export const gameRemoveCharityFoundationReaction = <ThrowOnError extends boolean = false>(options: Options<GameRemoveCharityFoundationReactionData, ThrowOnError>): RequestResult<GameRemoveCharityFoundationReactionResponses, GameRemoveCharityFoundationReactionErrors, ThrowOnError> => (options.client ?? client).delete<GameRemoveCharityFoundationReactionResponses, GameRemoveCharityFoundationReactionErrors, ThrowOnError>({ url: '/game/charities/{charity_id}/foundation/reaction', ...options });

/**
 * Set Charity Foundation Reaction
 *
 * Set (insert-or-replace) the caller's single preset-emoji reaction on
 * a charity foundation (GME-BE15 — charity foundations are reaction
 * targets too, the plan-§5 polymorphic pair). Same contract as the player
 * twin, minus the self check (a charity foundation has no in-game owner):
 * unknown emoji → 400 INVALID_REACTION; unknown charity (or caller not
 * onboarded) → 404; foundation never materialized → 400
 * CHARITY_NOT_MATERIALIZED (you react to a scene you visited — the
 * GME-BE7 earn posture); over the daily cap → 429.
 */
export const gameSetCharityFoundationReaction = <ThrowOnError extends boolean = false>(options: Options<GameSetCharityFoundationReactionData, ThrowOnError>): RequestResult<GameSetCharityFoundationReactionResponses, GameSetCharityFoundationReactionErrors, ThrowOnError> => (options.client ?? client).put<GameSetCharityFoundationReactionResponses, GameSetCharityFoundationReactionErrors, ThrowOnError>({
    url: '/game/charities/{charity_id}/foundation/reaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim Game Object
 *
 * Bind a donation to a donor-recognition object (plan §3.2, GME-BE8): the
 * body carries only `{donation_id}`; the server runs the whole §3.2
 * validation chain under the donation-row FOR-UPDATE lock — the donation
 * exists AND belongs to the caller, its charity is THIS charity, its amount
 * clears the object's tier, it is unbound across claims AND treats, and the
 * object is unclaimed — then inserts the (permanent) claim atomically.
 *
 * Typed errors: 404 (unknown charity / OBJECT_NOT_FOUND object_key), 400
 * (CHARITY_NOT_MATERIALIZED / DONATION_NOT_FOUND / DONATION_CHARITY_MISMATCH
 * / DONATION_BELOW_TIER), 409 (DONATION_ALREADY_USED / OBJECT_ALREADY_CLAIMED
 * — plan §4: the donation stays bindable to other objects). The donation is
 * never created/modified/refunded (plan §3, law). Returns the claimed
 * object's post-bind state so the client celebrates the RECOGNITION without
 * a foundation refetch; deliberately 200 (the recognition record, not a
 * fresh addressable resource the client will GET back by id).
 */
export const gameClaimGameObject = <ThrowOnError extends boolean = false>(options: Options<GameClaimGameObjectData, ThrowOnError>): RequestResult<GameClaimGameObjectResponses, GameClaimGameObjectErrors, ThrowOnError> => (options.client ?? client).post<GameClaimGameObjectResponses, GameClaimGameObjectErrors, ThrowOnError>({
    url: '/game/charities/{charity_id}/objects/{object_key}/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Game Cities
 *
 * Onboarding city type-ahead (plan §2.3, D-GME-33): population-ranked
 * prefix search over the Census-places `game_city` table (name, or
 * "name, st"), capped results. With no `q`: the coarse onboarding
 * suggestion list (`suggestion_source` says how it was derived — see the
 * service's IP-geo seam note). Never reads device location.
 */
export const gameSearchGameCities = <ThrowOnError extends boolean = false>(options?: Options<GameSearchGameCitiesData, ThrowOnError>): RequestResult<GameSearchGameCitiesResponses, GameSearchGameCitiesErrors, ThrowOnError> => (options?.client ?? client).get<GameSearchGameCitiesResponses, GameSearchGameCitiesErrors, ThrowOnError>({ url: '/game/cities', ...options });

/**
 * Get Game Coins
 *
 * The caller's coin balance + ledger history (plan §2.3, GME-BE7): the
 * standard paginated `{data, meta, links}` envelope (newest first;
 * `page[limit]`/`page[offset]`) with the additive top-level `balance`
 * (ledger-summed, server-authoritative §3.1). Entries are a projection —
 * `reason` (tolerant OPEN-set string), the HISTORY-projected `subject`
 * (`history_subject`: `foundation_visited` masks to the date only —
 * STORAGE keeps the visitor-day idempotency key; every other reason
 * serves verbatim), signed `amount`, `created_at`. 404 before onboarding;
 * served `private, no-store` (per-user, moving data — the map-read
 * posture).
 */
export const gameGetGameCoins = <ThrowOnError extends boolean = false>(options?: Options<GameGetGameCoinsData, ThrowOnError>): RequestResult<GameGetGameCoinsResponses, GameGetGameCoinsErrors, ThrowOnError> => (options?.client ?? client).get<GameGetGameCoinsResponses, GameGetGameCoinsErrors, ThrowOnError>({ url: '/game/coins', ...options });

/**
 * Earn Game Coins
 *
 * Record a client-reported coin earn (plan §1.4/§2.3/§3.1, GME-BE7;
 * mini-games GME-BE13): `{reason, subject}` → the server re-derives the
 * amount from the §2.9 catalog, enforces the reason's validity rules
 * (typed 400s UNKNOWN_REASON / INVALID_SUBJECT / CHARITY_NOT_MATERIALIZED
 * / NOT_FOLLOWED / TARGET_NOT_IN_GAME / TEMPLATE_MISMATCH /
 * REASON_DISABLED) and daily cap, and appends the idempotent ledger row.
 * A repeat report or a reached cap is a NO-OP SUCCESS (`earned: false` —
 * play never errors), discriminated by the additive `capped` field
 * (true ⟺ the day's cap is exhausted and this report never will credit —
 * the client's "just for fun" card; a replayed already-credited report
 * stays false); deliberately 200, not 201: the endpoint converges, it
 * doesn't create a canonical resource. 404 before onboarding (the FTUE
 * gate).
 */
export const gameEarnGameCoins = <ThrowOnError extends boolean = false>(options: Options<GameEarnGameCoinsData, ThrowOnError>): RequestResult<GameEarnGameCoinsResponses, GameEarnGameCoinsErrors, ThrowOnError> => (options.client ?? client).post<GameEarnGameCoinsResponses, GameEarnGameCoinsErrors, ThrowOnError>({
    url: '/game/coins/earn',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Game Config
 *
 * The client gate (plan §2.3): `{enabled, min_client_version,
 * rollout_percent}` straight from the env flags — cheap, no DB read. Behind
 * the global Firebase/App Check auth like `GET /assistant/config` (the
 * caller must be an authenticated user).
 */
export const gameGetGameConfig = <ThrowOnError extends boolean = false>(options?: Options<GameGetGameConfigData, ThrowOnError>): RequestResult<GameGetGameConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GameGetGameConfigResponses, unknown, ThrowOnError>({ url: '/game/config', ...options });

/**
 * Catch Game Dog
 *
 * Catch the month's Givmo Dog (plan §1.8/§3.3, GME-BE9): atomic
 * first-catch-wins — a single conditional UPDATE on the UNIQUE month row
 * elects exactly one winner, structurally (one event per month + one catch
 * per event = the $100/month cap). NO body: the server derives the month,
 * validates the spawn day, and stamps everything (§3.1 — the client
 * asserts nothing). Catching is FREE — no coin/treat/donation coupling of
 * any kind.
 *
 * Typed errors: 400 NOT_SPAWN_DAY (no dog out today), 409 ALREADY_CAUGHT
 * (the envelope carries the winner's live `caught_by_username` for the
 * "someone caught him!" moment). Success returns the catch + payout state
 * (REQUESTED with the caller's championed charity, or PENDING_CHAMPION →
 * the client prompts the champion picker). Deliberately 200 (a converging
 * action on the month event, not a fresh addressable resource — the
 * earn/claim posture). 404 before onboarding.
 */
export const gameCatchGameDog = <ThrowOnError extends boolean = false>(options?: Options<GameCatchGameDogData, ThrowOnError>): RequestResult<GameCatchGameDogResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GameCatchGameDogResponses, unknown, ThrowOnError>({ url: '/game/dog/catch', ...options });

/**
 * Get Game Dog Status
 *
 * The current month's Givmo Dog view (plan §1.8, GME-BE9): whether he's
 * loose today, where he spawned (revealed on/after the spawn day only),
 * who caught him (live username + follow-window expiry; the catcher also
 * sees their payout state so the client keeps offering the champion picker
 * while PENDING_CHAMPION), and the permanent visited-badge history. A
 * catcher whose championed charity is now set gets their pick reconciled
 * lazily on this read (PENDING_CHAMPION → REQUESTED — the only
 * programmatic payout transition; SENT/CONFIRMED are operator-runbook-only,
 * §3.3). 404 before onboarding (the FTUE gate).
 */
export const gameGetGameDogStatus = <ThrowOnError extends boolean = false>(options?: Options<GameGetGameDogStatusData, ThrowOnError>): RequestResult<GameGetGameDogStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GameGetGameDogStatusResponses, unknown, ThrowOnError>({ url: '/game/dog/status', ...options });

/**
 * Get Game Foundation
 *
 * The caller's own foundation document (plan §2.3, GME-BE5): the stored
 * canonical-v2 spec (served verbatim), the version the next PUT carries as
 * `expected_version`, and the ledger-summed coin balance. 404 before
 * onboarding; the §1.3 starter baseline seeds idempotently on first
 * read — never an empty lot.
 */
export const gameGetGameFoundation = <ThrowOnError extends boolean = false>(options?: Options<GameGetGameFoundationData, ThrowOnError>): RequestResult<GameGetGameFoundationResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GameGetGameFoundationResponses, unknown, ThrowOnError>({ url: '/game/foundations/me', ...options });

/**
 * Put Game Foundation
 *
 * Write the caller's foundation document (plan §2.3/§3.1, GME-BE5 — the
 * economy's spend path): `{spec, expected_version}` → version check first
 * (409 VERSION_CONFLICT), v1-view merge-preserve vs v2 full-document
 * routing, typed validation (INVALID_SPEC / INVALID_PALETTE /
 * INVALID_DECOR_ITEM / DECOR_BUDGET_EXCEEDED / UNSUPPORTED_SCHEMA_VERSION),
 * catalog delta pricing, atomic coin debit (409 INSUFFICIENT_COINS) +
 * document write + version bump — all-or-nothing. Returns the same body as
 * GET, post-edit.
 */
export const gamePutGameFoundation = <ThrowOnError extends boolean = false>(options: Options<GamePutGameFoundationData, ThrowOnError>): RequestResult<GamePutGameFoundationResponses, GamePutGameFoundationErrors, ThrowOnError> => (options.client ?? client).put<GamePutGameFoundationResponses, GamePutGameFoundationErrors, ThrowOnError>({
    url: '/game/foundations/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Game Pending Gifts
 *
 * The caller's claimable donation gifts (GME-BE23, D-GME-36): the standard
 * paginated `{data, meta, links}` envelope of the caller's OWN personal
 * donations at the ≥ $1 bonus tier that have NOT yet earned their
 * `donation_bonus` coins, newest first (`page[limit]`/`page[offset]`), each
 * with the donation id (the CLAIM subject), the charity's honest display name
 * (a DEACTIVATED charity renders its historical name — never crashes), the
 * entered amount, and the date. Server-derived (an anti-join against the
 * coin ledger) — no client-side "celebrated" state; survives reinstall /
 * device switch.
 *
 * Claiming a gift is the EXISTING earn path (`POST /game/coins/earn`
 * reason=donation_bonus subject=donation_id) — the donation row is STRICTLY
 * READ-ONLY here (plan §3, law). 404 before onboarding, or while the
 * `GAME_DONATION_COINS_ENABLED` sub-flag is dark (layered under GAME_ENABLED).
 * Served `private, no-store` (per-user, moving data — the coins/scrapbook
 * posture).
 */
export const gameGetGamePendingGifts = <ThrowOnError extends boolean = false>(options?: Options<GameGetGamePendingGiftsData, ThrowOnError>): RequestResult<GameGetGamePendingGiftsResponses, GameGetGamePendingGiftsErrors, ThrowOnError> => (options?.client ?? client).get<GameGetGamePendingGiftsResponses, GameGetGamePendingGiftsErrors, ThrowOnError>({ url: '/game/gifts', ...options });

/**
 * Get Game Map Entities
 *
 * Map entities in a viewport bbox (plan §2.3, GME-BE6): charity pins
 * (active charities with resolved geo, + materialized-foundation flag) and
 * player plots (self + followed players with game profiles — §1.6). The
 * bbox is validated + area-clamped with typed 400s (INVALID_BBOX /
 * BBOX_TOO_LARGE) and each list is count-capped with `*_truncated` flags
 * (plan §4's abuse posture); a missing/non-numeric coordinate is a plain
 * 422 before the handler runs. Served uncacheable — the payload is
 * per-user (follow-scoped plots) and moving data (the champions-read
 * `private, no-store` precedent).
 */
export const gameGetGameMapEntities = <ThrowOnError extends boolean = false>(options: Options<GameGetGameMapEntitiesData, ThrowOnError>): RequestResult<GameGetGameMapEntitiesResponses, GameGetGameMapEntitiesErrors, ThrowOnError> => (options.client ?? client).get<GameGetGameMapEntitiesResponses, GameGetGameMapEntitiesErrors, ThrowOnError>({ url: '/game/map/entities', ...options });

/**
 * Get Game Profile
 *
 * The caller's own game profile (plan §2.3): city snapshot, plot cell,
 * ledger-summed coin balance, championed charity id (read live from the
 * user row). 404 before onboarding — the client reads it as "run the
 * FTUE".
 */
export const gameGetGameProfile = <ThrowOnError extends boolean = false>(options?: Options<GameGetGameProfileData, ThrowOnError>): RequestResult<GameGetGameProfileResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GameGetGameProfileResponses, unknown, ThrowOnError>({ url: '/game/profile', ...options });

/**
 * Create Game Profile
 *
 * Onboarding (plan §2.3): `{city_key}` → snapshot the city, allocate the
 * plot near its center (GME-BE3 allocator), grant the §2.9 starting coins
 * idempotently. Deliberately 200 (not 201): the endpoint is an idempotent
 * create-or-get — a duplicate call returns the existing profile with the
 * same body as GET (plan §5 GME-BE4 exit criteria).
 */
export const gameCreateGameProfile = <ThrowOnError extends boolean = false>(options: Options<GameCreateGameProfileData, ThrowOnError>): RequestResult<GameCreateGameProfileResponses, GameCreateGameProfileErrors, ThrowOnError> => (options.client ?? client).post<GameCreateGameProfileResponses, GameCreateGameProfileErrors, ThrowOnError>({
    url: '/game/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Game Rescue Visitor
 *
 * Set the caller's Animal Rescue foundation visitor (GME-BE13, the
 * D-GME-23 one-pager §2 persistence hook): `{animal_key}` → the napping
 * animal at the player's foundation, one slot, overwritten by each later
 * round (pure valueless cosmetic; deliberately decoupled from the earn so
 * capped just-for-fun rounds still update it). The key is validated
 * against the closed server-known animal vocabulary (typed 400
 * INVALID_ANIMAL); 404 before onboarding (the FTUE gate). Idempotent
 * last-writer-wins PUT; the visitor serves on the foundation reads
 * (`rescue_visitor`).
 */
export const gameSetGameRescueVisitor = <ThrowOnError extends boolean = false>(options: Options<GameSetGameRescueVisitorData, ThrowOnError>): RequestResult<GameSetGameRescueVisitorResponses, GameSetGameRescueVisitorErrors, ThrowOnError> => (options.client ?? client).put<GameSetGameRescueVisitorResponses, GameSetGameRescueVisitorErrors, ThrowOnError>({
    url: '/game/profile/rescue-visitor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Game Scrapbook
 *
 * The caller's PRIVATE cosmetic scrapbook (GME-BE19 §9): the standard
 * paginated `{data, meta, links}` envelope of cosmetic grants, newest first
 * (`page[limit]`/`page[offset]`), each with its category, source, date, and a
 * cozy where-found place label. A memory book that fills in as life happens —
 * NO completion %, NO counts, NO greyed-out silhouettes of unowned items (§9
 * law: blank pages are just blank). Never visible to visitors (a diary, not
 * the garden). 404 before onboarding; served `private, no-store`.
 */
export const gameGetGameScrapbook = <ThrowOnError extends boolean = false>(options?: Options<GameGetGameScrapbookData, ThrowOnError>): RequestResult<GameGetGameScrapbookResponses, GameGetGameScrapbookErrors, ThrowOnError> => (options?.client ?? client).get<GameGetGameScrapbookResponses, GameGetGameScrapbookErrors, ThrowOnError>({ url: '/game/scrapbook', ...options });

/**
 * Claim Game Surprise
 *
 * Claim one free-action surprise (GME-BE19, D-GME-32): the body carries
 * only the `source` (mystery_spot / critter_visit / balloon / sky_moment).
 * The server re-derives availability as a pure function of (user, date,
 * world_seed) — the client cannot mint a surprise, only claim what the server
 * already decided existed today. The mystery spot grants a FIXED 15 coins + a
 * cosmetic in ONE transaction; the others grant a cosmetic only. A retried
 * claim of an already-claimed surprise is a NO-OP SUCCESS (`granted: false`).
 *
 * Typed errors: 400 (UNKNOWN_SOURCE / SURPRISE_UNAVAILABLE); 404 before
 * onboarding. NOT gated by GAME_LOOT_ENABLED (that flag scopes the donation
 * gift only, one-pager §2/§7) — the free-action sources ride the router-level
 * GAME_ENABLED gate + the per-source catalog `enabled` switch. Deliberately
 * 200 (a converging claim, the earn/treat posture); cosmetics are valueless
 * forever and coins here are FIXED (§4 — never variable).
 */
export const gameClaimGameSurprise = <ThrowOnError extends boolean = false>(options: Options<GameClaimGameSurpriseData, ThrowOnError>): RequestResult<GameClaimGameSurpriseResponses, GameClaimGameSurpriseErrors, ThrowOnError> => (options.client ?? client).post<GameClaimGameSurpriseResponses, GameClaimGameSurpriseErrors, ThrowOnError>({
    url: '/game/surprises/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Game Treats
 *
 * The caller's PRIVATE applying-treat count (GME-BE10, D-GME-10(d)):
 * the still-applying total for the month the next award would bias, and
 * that month — never anyone else's numbers, no visitor-visible surface
 * anywhere. Returns to 0 after spawn-day consumption (no carryover,
 * ever). 404 before onboarding, or while either flag is dark. Served
 * `private, no-store` (per-user, moving data — the coins-read posture).
 */
export const gameGetGameTreats = <ThrowOnError extends boolean = false>(options?: Options<GameGetGameTreatsData, ThrowOnError>): RequestResult<GameGetGameTreatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GameGetGameTreatsResponses, unknown, ThrowOnError>({ url: '/game/treats', ...options });

/**
 * Award Game Treats
 *
 * Award Dog Treats for a donation (GME-BE10, D-GME-10): the body carries
 * only `{donation_id}`; the server runs the whole award chain under the
 * donation-row FOR-UPDATE lock — the donation exists AND belongs to the
 * caller, is not already treat-awarded (a replay is a NO-OP SUCCESS,
 * `awarded: false` — the earn posture, never an error), was made this
 * calendar month (server UTC), and clears the $1 minimum — then inserts
 * the award atomically. COEXISTS with the donation's claim (D-GME-10(e)):
 * the same donation may back one claim AND one treat award.
 *
 * Typed errors: 400 (DONATION_NOT_FOUND / DONATION_OUTSIDE_MONTH /
 * DONATION_BELOW_TIER); 404 before onboarding, or while either flag is
 * dark. The donation is never created/modified/refunded (plan §3, law).
 * Returns this call's `quantity`, the `applies_month` it biases, and the
 * caller's post-award `month_quantity` total. Deliberately 200 (a
 * converging award on the donation, not a fresh addressable resource —
 * the earn/claim posture). Treats bias WHERE Givmo spawns, never who can
 * catch him (§3.3).
 */
export const gameAwardGameTreats = <ThrowOnError extends boolean = false>(options: Options<GameAwardGameTreatsData, ThrowOnError>): RequestResult<GameAwardGameTreatsResponses, GameAwardGameTreatsErrors, ThrowOnError> => (options.client ?? client).post<GameAwardGameTreatsResponses, GameAwardGameTreatsErrors, ThrowOnError>({
    url: '/game/treats',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Game Foundation
 *
 * Another player's foundation, read-only (plan §2.3, GME-BE5): profile
 * city/plot + document + the has-dog flag (§1.8; served False until the
 * GME-BE9 dog lifecycle exists). Any authenticated user; 404 when the
 * target has no game profile. Never writes — a never-edited target serves
 * the starter baseline without seeding it.
 */
export const gameGetUserGameFoundation = <ThrowOnError extends boolean = false>(options: Options<GameGetUserGameFoundationData, ThrowOnError>): RequestResult<GameGetUserGameFoundationResponses, GameGetUserGameFoundationErrors, ThrowOnError> => (options.client ?? client).get<GameGetUserGameFoundationResponses, GameGetUserGameFoundationErrors, ThrowOnError>({ url: '/game/users/{user_id}/foundation', ...options });

/**
 * Remove User Foundation Reaction
 *
 * Remove the caller's reaction from another player's foundation
 * (GME-BE15). Convergent — "ensure absent": nothing held is a no-op
 * success (`changed: false`), and no target validation runs (a reaction
 * whose target left the game stays removable). Deliberately 200 with the
 * post-write counts block, not a bare 204 — the response is the PUT twin's
 * state read, not a resource tombstone.
 */
export const gameRemoveUserFoundationReaction = <ThrowOnError extends boolean = false>(options: Options<GameRemoveUserFoundationReactionData, ThrowOnError>): RequestResult<GameRemoveUserFoundationReactionResponses, GameRemoveUserFoundationReactionErrors, ThrowOnError> => (options.client ?? client).delete<GameRemoveUserFoundationReactionResponses, GameRemoveUserFoundationReactionErrors, ThrowOnError>({ url: '/game/users/{user_id}/foundation/reaction', ...options });

/**
 * Set User Foundation Reaction
 *
 * Set (insert-or-replace) the caller's single preset-emoji reaction on
 * another player's foundation (plan §1.6/§1.14, GME-BE15, D-GME-31 —
 * "Reactions, not chat"). PUT because the caller's reaction on a target is
 * a SINGLETON slot: re-sending the held emoji is a no-op success
 * (`changed: false`), a different emoji replaces it. The body carries only
 * the vocabulary `emoji_key` — unknown key → 400 INVALID_REACTION; own
 * foundation → 400 SELF_REACTION; target not in the game (or caller not
 * onboarded) → 404; over the daily set cap → 429. The response carries the
 * post-write counts block. NEVER notifies the owner (bible §9 — they
 * discover counts on next visit) and never serves reactor identities.
 */
export const gameSetUserFoundationReaction = <ThrowOnError extends boolean = false>(options: Options<GameSetUserFoundationReactionData, ThrowOnError>): RequestResult<GameSetUserFoundationReactionResponses, GameSetUserFoundationReactionErrors, ThrowOnError> => (options.client ?? client).put<GameSetUserFoundationReactionResponses, GameSetUserFoundationReactionErrors, ThrowOnError>({
    url: '/game/users/{user_id}/foundation/reaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim Gift Card
 *
 * Redeem the delivered card without its code: exactly face into the caller's wallet
 * through code entry's own transition. Returns the updated wallet (the redeem
 * precedent). A retry by the same user is idempotent (200, nothing moves); 409
 * ``ALREADY_REDEEMED`` for a card someone else redeemed; 404 (the same uniform body
 * as the preview) for every other case; 429 past the caller's hourly cap (shared with
 * the preview).
 */
export const giftCardsClaimGiftCard = <ThrowOnError extends boolean = false>(options: Options<GiftCardsClaimGiftCardData, ThrowOnError>): RequestResult<GiftCardsClaimGiftCardResponses, GiftCardsClaimGiftCardErrors, ThrowOnError> => (options.client ?? client).post<GiftCardsClaimGiftCardResponses, GiftCardsClaimGiftCardErrors, ThrowOnError>({
    url: '/gift-cards/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Gift Card Claim
 *
 * May the caller redeem this delivered card without its code? 200 with the card
 * the claim would redeem (a support reissue followed forward), its amount and its
 * sender line; 409 ``ALREADY_REDEEMED`` when it is spent; 404 (one uniform body) for
 * every other case; 429 past the caller's hourly cap. Reads only.
 */
export const giftCardsPreviewGiftCardClaim = <ThrowOnError extends boolean = false>(options: Options<GiftCardsPreviewGiftCardClaimData, ThrowOnError>): RequestResult<GiftCardsPreviewGiftCardClaimResponses, GiftCardsPreviewGiftCardClaimErrors, ThrowOnError> => (options.client ?? client).post<GiftCardsPreviewGiftCardClaimResponses, GiftCardsPreviewGiftCardClaimErrors, ThrowOnError>({
    url: '/gift-cards/claim/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Gift Card
 *
 * Resolve a gift-card code to its confirm-screen presentation data.
 *
 * The code travels in the request body, never the URL — server logs must
 * not capture plaintext codes.
 */
export const giftCardsPreviewGiftCard = <ThrowOnError extends boolean = false>(options: Options<GiftCardsPreviewGiftCardData, ThrowOnError>): RequestResult<GiftCardsPreviewGiftCardResponses, GiftCardsPreviewGiftCardErrors, ThrowOnError> => (options.client ?? client).post<GiftCardsPreviewGiftCardResponses, GiftCardsPreviewGiftCardErrors, ThrowOnError>({
    url: '/gift-cards/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Purchase Gift Card Authenticated
 *
 * Authenticated in-app purchase with new money (D-GC-6). A donation-first
 * product: the charge is the gross (mandatory cover-fees gross-up) and the
 * card is funded at exactly face. The payment shape is deposit-flow — a saved
 * Shift4 ``card_id`` against the caller's ``customer_id``, or an Apple/Google
 * Pay token. Terms acceptance is recorded server-side against the session
 * user. The response NEVER carries the plaintext code, so the idempotent
 * replay of a duplicate purchase_request_id is safe.
 */
export const giftCardsPurchaseGiftCardAuthenticated = <ThrowOnError extends boolean = false>(options: Options<GiftCardsPurchaseGiftCardAuthenticatedData, ThrowOnError>): RequestResult<GiftCardsPurchaseGiftCardAuthenticatedResponses, GiftCardsPurchaseGiftCardAuthenticatedErrors, ThrowOnError> => (options.client ?? client).post<GiftCardsPurchaseGiftCardAuthenticatedResponses, GiftCardsPurchaseGiftCardAuthenticatedErrors, ThrowOnError>({
    url: '/gift-cards/purchase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Redeem Gift Card
 *
 * Redeem a gift card into the caller's wallet at exactly printed face
 * value. Returns the updated wallet (the deposit-endpoint precedent —
 * clients refresh their balance from this response).
 */
export const giftCardsRedeemGiftCard = <ThrowOnError extends boolean = false>(options: Options<GiftCardsRedeemGiftCardData, ThrowOnError>): RequestResult<GiftCardsRedeemGiftCardResponses, GiftCardsRedeemGiftCardErrors, ThrowOnError> => (options.client ?? client).post<GiftCardsRedeemGiftCardResponses, GiftCardsRedeemGiftCardErrors, ThrowOnError>({
    url: '/gift-cards/redeem',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Grants
 */
export const grantsGetGrants = <ThrowOnError extends boolean = false>(options?: Options<GrantsGetGrantsData, ThrowOnError>): RequestResult<GrantsGetGrantsResponses, GrantsGetGrantsErrors, ThrowOnError> => (options?.client ?? client).get<GrantsGetGrantsResponses, GrantsGetGrantsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/grants',
    ...options
});

/**
 * Mint Cohort
 *
 * Explicit, idempotent disbursement-time cohort mint step (GD R2 mint-trigger,
 * D-GD-19): mint one charity's FUNDABLE undisbursed recommendations for a
 * receipt_month into MINTED cohort grant(s). The off-box brain orchestrates
 * ``mint -> read disbursable -> disburse -> mark-sent``; this is the mint step.
 *
 * COLLECTION-level (no ``grant_id`` — the mint CREATES the cohort(s)). Under GF-A19
 * a fundable set that overflows the per-cohort ceiling FIFO-splits into N distinct
 * content-hash cohorts; the common under-ceiling set mints as ONE. The mint is
 * idempotent and "nothing fundable" is a valid no-op, so the response is ALWAYS 200
 * across THREE distinct cases: (1) a re-issue AFTER a successful mint returns
 * ``minted=False, grants=[]`` — the first mint already re-pointed the constituents
 * OFF the PENDING accumulator bucket, so the in-month bucket scan now finds nothing.
 * This is the normal **paid-once** no-op, NOT an error: a caller that needs the
 * cohort reads it from the disbursable read / ``GET /grants/{id}``, never from this
 * mint response. (2) The SAME cohort(s) are returned (``minted=True``, same
 * ``grant_id``(s), no duplicate) ONLY for the recs-STILL-on-bucket RETRY shape — a
 * crash before the guarded re-point committed, or an un-mint that re-pointed the
 * constituents back onto the bucket — via the content-hash ``grant_id`` ``get()``
 * short-circuit (the ns-1001 lock + guarded re-point in ``CohortMintService`` own the
 * idempotency, the endpoint adds none). (3) A receipt month with nothing
 * settled/fundable is the same valid ``minted=False, grants=[]`` no-op. ``grants``
 * carries the full set; ``grant`` (singular) is retained as the first cohort for the
 * brain's current ``{minted, grant}`` client.
 *
 * GF-A22 donation-scoped mint (OPTIONAL): supplying ``donation_ids`` + ``reason``
 * isolates an explicit subset of the charity-month's fundable recommendations into
 * their own cohort (``reason`` required iff ``donation_ids`` present — 422 otherwise;
 * the reason is recorded durably on the minted cohort's notes). A named id that is
 * not a fundable-bucket recommendation, or is not currently fundable, is refused
 * fail-closed (400, naming it) rather than silently dropped. INERT — no in-process
 * caller; reachable only by a super-admin / scoped-MCP principal (mirrors how
 * ``mark-sent`` / ``mark-returned`` sit dormant). Super-admin write (mirrors the
 * mark-sent path).
 *
 * GF-A52 operator merge (D-GD-36): with ``donation_ids``, ``receipt_month`` may be
 * omitted, and the named donations of this one charity may then come from several
 * receipt months — one operator payment covered them, and one payment is one grant.
 * They mint into one cohort whose ``receipt_month`` (its §320 anchor) is the earliest
 * donation's month. A merge whose total exceeds the per-cohort ceiling is refused
 * (400, nothing minted) rather than split. Without ``donation_ids`` the month is
 * required (422).
 */
export const grantsMintCohort = <ThrowOnError extends boolean = false>(options: Options<GrantsMintCohortData, ThrowOnError>): RequestResult<GrantsMintCohortResponses, GrantsMintCohortErrors, ThrowOnError> => (options.client ?? client).post<GrantsMintCohortResponses, GrantsMintCohortErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/grants/mint-cohort',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Grant
 */
export const grantsGetGrant = <ThrowOnError extends boolean = false>(options: Options<GrantsGetGrantData, ThrowOnError>): RequestResult<GrantsGetGrantResponses, GrantsGetGrantErrors, ThrowOnError> => (options.client ?? client).get<GrantsGetGrantResponses, GrantsGetGrantErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/grants/{grant_id}',
    ...options
});

/**
 * Update Grant
 */
export const grantsUpdateGrant = <ThrowOnError extends boolean = false>(options: Options<GrantsUpdateGrantData, ThrowOnError>): RequestResult<GrantsUpdateGrantResponses, GrantsUpdateGrantErrors, ThrowOnError> => (options.client ?? client).put<GrantsUpdateGrantResponses, GrantsUpdateGrantErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/grants/{grant_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Grant Returned
 *
 * Record a charity ACH/check RETURN of an already-disbursed (SENT) cohort grant
 * (GD R2): transition SENT -> RETURNED, restore the cohort's settled reservations
 * (donors re-credited), write an ACH_RETURN recovery_owed marker, and record the
 * re-queue decision (RE_OFFER re-points the donations back to the per-charity
 * PENDING bucket; HOLD leaves them). Idempotent + fail-closed: a same-
 * ``return_reference`` re-deliver is a benign no-op; a different/NULL reference on
 * an already-RETURNED grant, or any non-SENT status, is a 409 conflict.
 *
 * INERT — no prod caller; the R3 return detector will call this once built. Wired
 * now (dormant) so R3 only has to point at it. Super-admin write (mirrors the
 * mark-sent path).
 */
export const grantsMarkGrantReturned = <ThrowOnError extends boolean = false>(options: Options<GrantsMarkGrantReturnedData, ThrowOnError>): RequestResult<GrantsMarkGrantReturnedResponses, GrantsMarkGrantReturnedErrors, ThrowOnError> => (options.client ?? client).post<GrantsMarkGrantReturnedResponses, GrantsMarkGrantReturnedErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/grants/{grant_id}/mark-returned',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Grant Sent
 *
 * Record that a CLOSED grant batch was disbursed via Mercury (GD-BB1):
 * transition CLOSED -> SENT, stamp the Mercury txn id / actual disbursed amount /
 * rail / date_sent. Idempotent + fail-closed (paid-once): a same-txn re-POST is a
 * benign 200 no-op; a different/NULL txn id on an already-SENT batch, or a
 * PENDING/COMPLETED/REJECTED batch, is a 409 conflict. Super-admin write (mirrors
 * the grant PUT path; the brain calls it via a scoped MCP at go-live).
 */
export const grantsMarkGrantSent = <ThrowOnError extends boolean = false>(options: Options<GrantsMarkGrantSentData, ThrowOnError>): RequestResult<GrantsMarkGrantSentResponses, GrantsMarkGrantSentErrors, ThrowOnError> => (options.client ?? client).post<GrantsMarkGrantSentResponses, GrantsMarkGrantSentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/grants/{grant_id}/mark-sent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unmint Grant
 *
 * Un-mint a MINTED (disbursement-ready, never-disbursed) cohort grant whose Mercury
 * payment was declined/rejected (GF-A18): transition MINTED -> REJECTED, RELEASE the
 * cohort's settled reservations (donors re-credited), and RE-POINT its constituent
 * recommendations back to the per-charity PENDING accumulator bucket so they retry on a
 * future mint cycle — all atomic under the money-path lock order. This is the ONLY
 * sanctioned MINTED -> REJECTED path; the generic PUT rejects a manual MINTED
 * disposition (it would strand the reservations + orphan the recommendations).
 *
 * Idempotent + fail-closed: a re-call on an already-REJECTED grant is a benign no-op
 * (the release does not run twice); any non-MINTED status is a 409 conflict (only a
 * MINTED cohort can be un-minted). INERT — no prod caller; the disbursement lane's
 * human-approval decline flow calls it once the lane arms. Super-admin write (mirrors
 * the mark-returned path).
 */
export const grantsUnmintGrant = <ThrowOnError extends boolean = false>(options: Options<GrantsUnmintGrantData, ThrowOnError>): RequestResult<GrantsUnmintGrantResponses, GrantsUnmintGrantErrors, ThrowOnError> => (options.client ?? client).post<GrantsUnmintGrantResponses, GrantsUnmintGrantErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/grants/{grant_id}/unmint',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Discover Groups
 *
 * Browse or ``q``-search PUBLIC, ACTIVE, moderation-listed groups.
 */
export const groupsDiscoverGroups = <ThrowOnError extends boolean = false>(options?: Options<GroupsDiscoverGroupsData, ThrowOnError>): RequestResult<GroupsDiscoverGroupsResponses, GroupsDiscoverGroupsErrors, ThrowOnError> => (options?.client ?? client).get<GroupsDiscoverGroupsResponses, GroupsDiscoverGroupsErrors, ThrowOnError>({ url: '/groups', ...options });

/**
 * Create Group
 *
 * Create a group as a DRAFT (creator → sole Owner; explicit visibility,
 * default PUBLIC; NO wallet/Shift4 customer minted yet). The creator is minted
 * as OWNER — an advisory role — so creation is 18+/DOB-gated (GRP-REM3): a
 * minor or NULL-DOB creator gets a 422 with nothing persisted.
 */
export const groupsCreateGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsCreateGroupData, ThrowOnError>): RequestResult<GroupsCreateGroupResponses, GroupsCreateGroupErrors, ThrowOnError> => (options.client ?? client).post<GroupsCreateGroupResponses, GroupsCreateGroupErrors, ThrowOnError>({
    url: '/groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Group By Handle
 *
 * Group profile by `@handle` (case-insensitive). Same visibility/authz +
 * balance-gating as the by-id read.
 */
export const groupsGetGroupByHandle = <ThrowOnError extends boolean = false>(options: Options<GroupsGetGroupByHandleData, ThrowOnError>): RequestResult<GroupsGetGroupByHandleResponses, GroupsGetGroupByHandleErrors, ThrowOnError> => (options.client ?? client).get<GroupsGetGroupByHandleResponses, GroupsGetGroupByHandleErrors, ThrowOnError>({ url: '/groups/@{handle}', ...options });

/**
 * Accept Group Invite By Token
 *
 * GRP-BE14: the unregistered-email invitee redeems the single-use token from
 * their invite-email link (`go.givmo.io/s/group-invite/<token>`), after signing
 * up / signing in with the invited email. The caller's email + verified state
 * come from the Firebase ID token (`request.state.idp_user`), NEVER the body —
 * the redemption requires a VERIFIED email equal to the invite's bound email.
 * Every non-redeemable condition collapses to ONE constant 400 (no oracle).
 * Returns the joined group (the identity-accept response shape).
 */
export const groupsAcceptGroupInviteByToken = <ThrowOnError extends boolean = false>(options: Options<GroupsAcceptGroupInviteByTokenData, ThrowOnError>): RequestResult<GroupsAcceptGroupInviteByTokenResponses, GroupsAcceptGroupInviteByTokenErrors, ThrowOnError> => (options.client ?? client).post<GroupsAcceptGroupInviteByTokenResponses, GroupsAcceptGroupInviteByTokenErrors, ThrowOnError>({
    url: '/groups/invites/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Group
 *
 * Owner-only. A DRAFT hard-deletes; an ACTIVE group soft-dissolves under the
 * wallet-locked zero-balance guard (balance>0 → actionable 400).
 */
export const groupsDeleteGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsDeleteGroupData, ThrowOnError>): RequestResult<GroupsDeleteGroupResponses, GroupsDeleteGroupErrors, ThrowOnError> => (options.client ?? client).delete<GroupsDeleteGroupResponses, GroupsDeleteGroupErrors, ThrowOnError>({ url: '/groups/{group_id}', ...options });

/**
 * Get Group
 *
 * Group profile by id. Balance shown ONLY to Owner/Admin; a non-member of a
 * PRIVATE group / a DRAFT to a non-creator → 404 (existence never leaked).
 */
export const groupsGetGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsGetGroupData, ThrowOnError>): RequestResult<GroupsGetGroupResponses, GroupsGetGroupErrors, ThrowOnError> => (options.client ?? client).get<GroupsGetGroupResponses, GroupsGetGroupErrors, ThrowOnError>({ url: '/groups/{group_id}', ...options });

/**
 * Update Group
 *
 * Owner/Admin edit — name/handle/description/`members_can_donate`/
 * `allowed_member_post_displays` AND the Owner/Admin-only privacy settings
 * `visibility`/`stats_visible`/`default_donation_visibility`.
 */
export const groupsUpdateGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsUpdateGroupData, ThrowOnError>): RequestResult<GroupsUpdateGroupResponses, GroupsUpdateGroupErrors, ThrowOnError> => (options.client ?? client).put<GroupsUpdateGroupResponses, GroupsUpdateGroupErrors, ThrowOnError>({
    url: '/groups/{group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Group Activity
 *
 * The group's PUBLIC activity feed (GRP-BE12): the group's group-attributed
 * posts, paginated. Public per the SAME visibility gate as the roster — a
 * non-member of a PRIVATE/DRAFT group → 404. Each page's group logos are
 * signed-hydrated (`_stamp_group_logos`) so `attributed_owner.logo_url` renders
 * the GROUP's logo, and the body is the SAME `PostOut` envelope the sibling
 * charity/ETF/fundraiser feeds emit.
 */
export const groupsGetGroupActivity = <ThrowOnError extends boolean = false>(options: Options<GroupsGetGroupActivityData, ThrowOnError>): RequestResult<GroupsGetGroupActivityResponses, GroupsGetGroupActivityErrors, ThrowOnError> => (options.client ?? client).get<GroupsGetGroupActivityResponses, GroupsGetGroupActivityErrors, ThrowOnError>({ url: '/groups/{group_id}/activity', ...options });

/**
 * List Group Donation Requests
 *
 * The group's donation proposals, paginated newest-first. **Owner/Admin see
 * every request; any other member sees ONLY their own rows** (R14 own-data
 * discipline — the isolation is the repository SQL predicate). A visible
 * non-member → 403; a group the caller cannot see → 404.
 */
export const groupsListGroupDonationRequests = <ThrowOnError extends boolean = false>(options: Options<GroupsListGroupDonationRequestsData, ThrowOnError>): RequestResult<GroupsListGroupDonationRequestsResponses, GroupsListGroupDonationRequestsErrors, ThrowOnError> => (options.client ?? client).get<GroupsListGroupDonationRequestsResponses, GroupsListGroupDonationRequestsErrors, ThrowOnError>({ url: '/groups/{group_id}/donation-requests', ...options });

/**
 * Create Group Donation Request
 *
 * A full member (Owner/Admin/Member — a **CONTRIBUTOR is blocked**, 403)
 * PROPOSES a donation from the group's pooled wallet to a charity / ETF /
 * group-fundraiser / collection. Requires the group be ACTIVE; the
 * `members_can_donate` switch gates MEMBER proposers only (GRP-WT1 — an
 * Owner/Admin proposes regardless, the v4 four-eyes workflow), and the chosen
 * `post_display` must be within the group's `allowed_member_post_displays`
 * subset. Proposal creation is velocity-capped per (group, member) over a
 * rolling 24h (GRP-WT1; deliberately NO same-target dedup). NOT a money
 * route — nothing
 * moves until an Owner/Admin approves — so there is no `Idempotency-Key`
 * guard here (that is only for the two charge routes; the approve's locked
 * PENDING re-assert is the money-path idempotency fence).
 */
export const groupsCreateGroupDonationRequest = <ThrowOnError extends boolean = false>(options: Options<GroupsCreateGroupDonationRequestData, ThrowOnError>): RequestResult<GroupsCreateGroupDonationRequestResponses, GroupsCreateGroupDonationRequestErrors, ThrowOnError> => (options.client ?? client).post<GroupsCreateGroupDonationRequestResponses, GroupsCreateGroupDonationRequestErrors, ThrowOnError>({
    url: '/groups/{group_id}/donation-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve Group Donation Request
 *
 * **Owner/Admin only**: approve a member's PENDING donation proposal — the
 * approval EXECUTES the proposed wallet grant (fee-free, `domain_type='group'`,
 * riding the existing DAF grant-disbursement pipeline) atomically with the
 * PENDING→APPROVED flip, so an APPROVED request is always a funded one. The
 * money-path idempotency fence is the locked PENDING re-assert (a retry / a
 * concurrent second approve → 409, never a second withdrawal), so — unlike the
 * two charge routes — there is deliberately no `Idempotency-Key` dependency.
 * Wrapped in the group-donation observability (it IS a group-donation money
 * event: `group_donation_success`/`_failure`, wallet-mode empty label set).
 */
export const groupsApproveGroupDonationRequest = <ThrowOnError extends boolean = false>(options: Options<GroupsApproveGroupDonationRequestData, ThrowOnError>): RequestResult<GroupsApproveGroupDonationRequestResponses, GroupsApproveGroupDonationRequestErrors, ThrowOnError> => (options.client ?? client).post<GroupsApproveGroupDonationRequestResponses, GroupsApproveGroupDonationRequestErrors, ThrowOnError>({ url: '/groups/{group_id}/donation-requests/{request_id}/approve', ...options });

/**
 * Reject Group Donation Request
 *
 * **Owner/Admin only**: decline a member's PENDING donation proposal
 * (records decided_by/decided_at). No money moves. A no-longer-PENDING request
 * → 409 (already decided — incl. CLOSED rows a dissolve tombstoned).
 */
export const groupsRejectGroupDonationRequest = <ThrowOnError extends boolean = false>(options: Options<GroupsRejectGroupDonationRequestData, ThrowOnError>): RequestResult<GroupsRejectGroupDonationRequestResponses, GroupsRejectGroupDonationRequestErrors, ThrowOnError> => (options.client ?? client).post<GroupsRejectGroupDonationRequestResponses, GroupsRejectGroupDonationRequestErrors, ThrowOnError>({ url: '/groups/{group_id}/donation-requests/{request_id}/reject', ...options });

/**
 * Donate From Group
 *
 * **Owner/Admin only** (R8): direct a donation OUT to a charity / ETF /
 * group-fundraiser / collection, funded EITHER from the group's pooled (DAF-advised)
 * wallet (GRP-BE7, the default — FEE-FREE, `givmo_fee == 0`, riding the DAF
 * grant-disbursement pipeline) OR from the admin's OWN personal payment method
 * (GRP-BE7b — a REAL personal charge with NORMAL fees, receipted to the admin,
 * matched via the NORMAL personal path, writing NO group-wallet ledger; R9). The
 * funding mode is chosen by `payment_method` (WALLET → the grant; card/Apple/Google
 * → the personal charge). A Member/Contributor who can see the group → 403; a
 * non-member of a PRIVATE group → 404. ``Idempotency-Key`` is REQUIRED (fail-closed
 * 422 if absent).
 */
export const groupsDonateFromGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsDonateFromGroupData, ThrowOnError>): RequestResult<GroupsDonateFromGroupResponses, GroupsDonateFromGroupErrors, ThrowOnError> => (options.client ?? client).post<GroupsDonateFromGroupResponses, GroupsDonateFromGroupErrors, ThrowOnError>({
    url: '/groups/{group_id}/donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unfollow Group
 *
 * The authenticated caller explicitly unfollows (STATE FLIP, never a delete).
 * Records an EXPLICIT UNFOLLOW even with no prior FOLLOW (GRP-BE13 revival guard).
 * Same visibility gate as follow. Returns the resulting state.
 */
export const groupsUnfollowGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsUnfollowGroupData, ThrowOnError>): RequestResult<GroupsUnfollowGroupResponses, GroupsUnfollowGroupErrors, ThrowOnError> => (options.client ?? client).delete<GroupsUnfollowGroupResponses, GroupsUnfollowGroupErrors, ThrowOnError>({ url: '/groups/{group_id}/follow', ...options });

/**
 * Follow Group
 *
 * The authenticated caller explicitly follows a group they can SEE (a
 * non-member of a PRIVATE group → 404). Idempotent create-or-refollow with
 * `source=EXPLICIT`. Returns the resulting follow state.
 */
export const groupsFollowGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsFollowGroupData, ThrowOnError>): RequestResult<GroupsFollowGroupResponses, GroupsFollowGroupErrors, ThrowOnError> => (options.client ?? client).post<GroupsFollowGroupResponses, GroupsFollowGroupErrors, ThrowOnError>({ url: '/groups/{group_id}/follow', ...options });

/**
 * Create Group Fundraiser
 *
 * **Owner/Admin only**: create a fundraiser OWNED by the group (§5). A
 * Member/Contributor who can see the group → 403; a non-member of a PRIVATE
 * group / a DRAFT to a non-Owner → 404 (the shared authz predicate); flag off →
 * 404.
 *
 * This REUSES the existing fundraiser creation lifecycle unmodified — same
 * `FundraiserCreate` body, same DRAFT + item-split + cardinality cap — only
 * stamping `owner_group_id=group_id` so the group is the owner (the acting admin
 * remains the fundraiser's `creator_user_id` / OWNER member of record). The
 * response is the ordinary `FundraiserOut` (a fundraiser is a fundraiser);
 * `owner_group_id` is an internal ownership axis and is NOT on the wire. NOT a
 * money route (fundraiser CRUD touches no wallet).
 */
export const groupsCreateGroupFundraiser = <ThrowOnError extends boolean = false>(options: Options<GroupsCreateGroupFundraiserData, ThrowOnError>): RequestResult<GroupsCreateGroupFundraiserResponses, GroupsCreateGroupFundraiserErrors, ThrowOnError> => (options.client ?? client).post<GroupsCreateGroupFundraiserResponses, GroupsCreateGroupFundraiserErrors, ThrowOnError>({
    url: '/groups/{group_id}/fundraisers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invite Group Member
 *
 * Owner/Admin invites an email at a role. Registered invitees get a pending
 * roster row; unregistered invitees redeem the R-37 token after registration.
 * A guardian-designated minor invite also captures the acting adult's exact
 * terms and attestation evidence. Re-invite is idempotent only for an exact
 * role/designation/evidence match.
 */
export const groupsInviteGroupMember = <ThrowOnError extends boolean = false>(options: Options<GroupsInviteGroupMemberData, ThrowOnError>): RequestResult<GroupsInviteGroupMemberResponses, GroupsInviteGroupMemberErrors, ThrowOnError> => (options.client ?? client).post<GroupsInviteGroupMemberResponses, GroupsInviteGroupMemberErrors, ThrowOnError>({
    url: '/groups/{group_id}/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Group Invite
 *
 * Owner/Admin deletes/revokes a PENDING invite.
 */
export const groupsDeleteGroupInvite = <ThrowOnError extends boolean = false>(options: Options<GroupsDeleteGroupInviteData, ThrowOnError>): RequestResult<GroupsDeleteGroupInviteResponses, GroupsDeleteGroupInviteErrors, ThrowOnError> => (options.client ?? client).delete<GroupsDeleteGroupInviteResponses, GroupsDeleteGroupInviteErrors, ThrowOnError>({ url: '/groups/{group_id}/invites/{invite_id}', ...options });

/**
 * List Group Join Requests
 *
 * **Owner/Admin only**: the group's PENDING join requests (the approval
 * queue), newest first, with each requester's public preview. A
 * Member/Contributor who can see the group → 403; a non-member of a PRIVATE
 * group → 404 (the shared authz predicate).
 */
export const groupsListGroupJoinRequests = <ThrowOnError extends boolean = false>(options: Options<GroupsListGroupJoinRequestsData, ThrowOnError>): RequestResult<GroupsListGroupJoinRequestsResponses, GroupsListGroupJoinRequestsErrors, ThrowOnError> => (options.client ?? client).get<GroupsListGroupJoinRequestsResponses, GroupsListGroupJoinRequestsErrors, ThrowOnError>({ url: '/groups/{group_id}/join-requests', ...options });

/**
 * Request To Join Group
 *
 * An authenticated member-candidate asks to join a PUBLIC ACTIVE group. A
 * PRIVATE/DRAFT group the caller can't see → 404 (the BE3 authz contract); a
 * DISSOLVED group → 410; an ACTIVE member → 409; re-request while PENDING →
 * idempotent (the existing request); re-request after a rejection → a NEW
 * request. No body — the requester's ip/user-agent are captured server-side
 * (they back the consent record on approve).
 */
export const groupsRequestToJoinGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsRequestToJoinGroupData, ThrowOnError>): RequestResult<GroupsRequestToJoinGroupResponses, GroupsRequestToJoinGroupErrors, ThrowOnError> => (options.client ?? client).post<GroupsRequestToJoinGroupResponses, GroupsRequestToJoinGroupErrors, ThrowOnError>({ url: '/groups/{group_id}/join-requests', ...options });

/**
 * Approve Group Join Request
 *
 * **Owner/Admin only**: approve a PENDING join request → membership (MEMBER)
 * + consent row (the REQUESTER's captured ip/ua) in one transaction. Races with
 * a concurrent invite-accept / second approve resolve to ONE membership.
 * Returns the resulting roster row.
 */
export const groupsApproveGroupJoinRequest = <ThrowOnError extends boolean = false>(options: Options<GroupsApproveGroupJoinRequestData, ThrowOnError>): RequestResult<GroupsApproveGroupJoinRequestResponses, GroupsApproveGroupJoinRequestErrors, ThrowOnError> => (options.client ?? client).post<GroupsApproveGroupJoinRequestResponses, GroupsApproveGroupJoinRequestErrors, ThrowOnError>({ url: '/groups/{group_id}/join-requests/{request_id}/approve', ...options });

/**
 * Reject Group Join Request
 *
 * **Owner/Admin only**: decline a PENDING join request (REJECTED — the
 * requester may request again). Returns the resolved request.
 */
export const groupsRejectGroupJoinRequest = <ThrowOnError extends boolean = false>(options: Options<GroupsRejectGroupJoinRequestData, ThrowOnError>): RequestResult<GroupsRejectGroupJoinRequestResponses, GroupsRejectGroupJoinRequestErrors, ThrowOnError> => (options.client ?? client).post<GroupsRejectGroupJoinRequestResponses, GroupsRejectGroupJoinRequestErrors, ThrowOnError>({ url: '/groups/{group_id}/join-requests/{request_id}/reject', ...options });

/**
 * Get My Group Contribution
 *
 * Any **member**: the caller's OWN lifetime contribution to this group (total
 * gross/net + count). R14 — never another member's amount (a non-member who can
 * see the group → 403; a group the caller cannot see → 404).
 */
export const groupsGetMyGroupContribution = <ThrowOnError extends boolean = false>(options: Options<GroupsGetMyGroupContributionData, ThrowOnError>): RequestResult<GroupsGetMyGroupContributionResponses, GroupsGetMyGroupContributionErrors, ThrowOnError> => (options.client ?? client).get<GroupsGetMyGroupContributionResponses, GroupsGetMyGroupContributionErrors, ThrowOnError>({ url: '/groups/{group_id}/me/contribution', ...options });

/**
 * Get My Group Stats
 *
 * Any **member**: the caller's OWN YTD contributed + matched for this group.
 * GRP-BE18 employer batch approvals populate `matched`; it remains surfaced when
 * zero. R14 (own data only; a non-member who can see the group → 403; a group the
 * caller cannot see → 404).
 */
export const groupsGetMyGroupStats = <ThrowOnError extends boolean = false>(options: Options<GroupsGetMyGroupStatsData, ThrowOnError>): RequestResult<GroupsGetMyGroupStatsResponses, GroupsGetMyGroupStatsErrors, ThrowOnError> => (options.client ?? client).get<GroupsGetMyGroupStatsResponses, GroupsGetMyGroupStatsErrors, ThrowOnError>({ url: '/groups/{group_id}/me/stats', ...options });

/**
 * List Group Members
 *
 * The roster (public per visibility; a non-member of a PRIVATE/DRAFT group →
 * 404). Never exposes a per-member contribution amount.
 */
export const groupsListGroupMembers = <ThrowOnError extends boolean = false>(options: Options<GroupsListGroupMembersData, ThrowOnError>): RequestResult<GroupsListGroupMembersResponses, GroupsListGroupMembersErrors, ThrowOnError> => (options.client ?? client).get<GroupsListGroupMembersResponses, GroupsListGroupMembersErrors, ThrowOnError>({ url: '/groups/{group_id}/members', ...options });

/**
 * Accept Group Invite
 *
 * The invitee accepts an invite → member ACTIVE + consent row. Accept into a
 * DRAFT the caller can't see → 404; into a DISSOLVED group → 410.
 */
export const groupsAcceptGroupInvite = <ThrowOnError extends boolean = false>(options: Options<GroupsAcceptGroupInviteData, ThrowOnError>): RequestResult<GroupsAcceptGroupInviteResponses, GroupsAcceptGroupInviteErrors, ThrowOnError> => (options.client ?? client).post<GroupsAcceptGroupInviteResponses, GroupsAcceptGroupInviteErrors, ThrowOnError>({ url: '/groups/{group_id}/members/accept', ...options });

/**
 * Leave Group
 *
 * The caller leaves the group. Last-owner protection: the sole Owner cannot
 * leave until ownership transfers or the group dissolves (409).
 */
export const groupsLeaveGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsLeaveGroupData, ThrowOnError>): RequestResult<GroupsLeaveGroupResponses, GroupsLeaveGroupErrors, ThrowOnError> => (options.client ?? client).delete<GroupsLeaveGroupResponses, GroupsLeaveGroupErrors, ThrowOnError>({ url: '/groups/{group_id}/members/me', ...options });

/**
 * Update Group Match Setting
 *
 * Update the authenticated member's private per-group employer-match
 * preference. Any ACTIVE member role may toggle it, but the caller must have a
 * linked company. This is a setting change, not a money route, so it has no
 * `Idempotency-Key` dependency.
 */
export const groupsUpdateGroupMatchSetting = <ThrowOnError extends boolean = false>(options: Options<GroupsUpdateGroupMatchSettingData, ThrowOnError>): RequestResult<GroupsUpdateGroupMatchSettingResponses, GroupsUpdateGroupMatchSettingErrors, ThrowOnError> => (options.client ?? client).patch<GroupsUpdateGroupMatchSettingResponses, GroupsUpdateGroupMatchSettingErrors, ThrowOnError>({
    url: '/groups/{group_id}/members/me/match-setting',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Group Member
 *
 * Owner/Admin changes a member's role OR removes them (`remove=true`). Enforces
 * the §4 legal role-transition graph (illegal edges → 403/422), the 18+/NULL-DOB
 * gate on promotion to ADMIN, and last-owner protection (409). Returns the updated
 * member (role change) or 204 (remove).
 */
export const groupsUpdateGroupMember = <ThrowOnError extends boolean = false>(options: Options<GroupsUpdateGroupMemberData, ThrowOnError>): RequestResult<GroupsUpdateGroupMemberResponses, GroupsUpdateGroupMemberErrors, ThrowOnError> => (options.client ?? client).patch<GroupsUpdateGroupMemberResponses, GroupsUpdateGroupMemberErrors, ThrowOnError>({
    url: '/groups/{group_id}/members/{member_user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Group Picture
 *
 * Owner/Admin logo upload (signed-on-read; GCS key `group/{id}/logo.png`).
 */
export const groupsUploadGroupPicture = <ThrowOnError extends boolean = false>(options: Options<GroupsUploadGroupPictureData, ThrowOnError>): RequestResult<GroupsUploadGroupPictureResponses, GroupsUploadGroupPictureErrors, ThrowOnError> => (options.client ?? client).post<GroupsUploadGroupPictureResponses, GroupsUploadGroupPictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/groups/{group_id}/profile_picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Publish Group
 *
 * Owner-only: DRAFT → ACTIVE (validate required fields; mint the group wallet
 * + Shift4 customer single-shot).
 */
export const groupsPublishGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsPublishGroupData, ThrowOnError>): RequestResult<GroupsPublishGroupResponses, GroupsPublishGroupErrors, ThrowOnError> => (options.client ?? client).post<GroupsPublishGroupResponses, GroupsPublishGroupErrors, ThrowOnError>({ url: '/groups/{group_id}/publish', ...options });

/**
 * Create Group Recurring Contribution
 *
 * Create the caller's saved-card recurring contribution.
 *
 * WALLET remains represented in the source-tolerant input vocabulary but is
 * rejected with a named D-GRP-21 gate until settled-backing is designed.
 */
export const groupsCreateGroupRecurringContribution = <ThrowOnError extends boolean = false>(options: Options<GroupsCreateGroupRecurringContributionData, ThrowOnError>): RequestResult<GroupsCreateGroupRecurringContributionResponses, GroupsCreateGroupRecurringContributionErrors, ThrowOnError> => (options.client ?? client).post<GroupsCreateGroupRecurringContributionResponses, GroupsCreateGroupRecurringContributionErrors, ThrowOnError>({
    url: '/groups/{group_id}/recurring-contribution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Group Recurring Contribution
 */
export const groupsCancelGroupRecurringContribution = <ThrowOnError extends boolean = false>(options: Options<GroupsCancelGroupRecurringContributionData, ThrowOnError>): RequestResult<GroupsCancelGroupRecurringContributionResponses, GroupsCancelGroupRecurringContributionErrors, ThrowOnError> => (options.client ?? client).delete<GroupsCancelGroupRecurringContributionResponses, GroupsCancelGroupRecurringContributionErrors, ThrowOnError>({ url: '/groups/{group_id}/recurring-contribution/{recurring_donation_id}', ...options });

/**
 * Revoke Group Ownership Transfer
 *
 * Owner-only: withdraw the pending ownership-transfer offer (404 when none
 * is pending). Nothing has swapped yet; a later accept 404s.
 */
export const groupsRevokeGroupOwnershipTransfer = <ThrowOnError extends boolean = false>(options: Options<GroupsRevokeGroupOwnershipTransferData, ThrowOnError>): RequestResult<GroupsRevokeGroupOwnershipTransferResponses, GroupsRevokeGroupOwnershipTransferErrors, ThrowOnError> => (options.client ?? client).delete<GroupsRevokeGroupOwnershipTransferResponses, GroupsRevokeGroupOwnershipTransferErrors, ThrowOnError>({ url: '/groups/{group_id}/transfer-ownership', ...options });

/**
 * Get Group Ownership Transfer
 *
 * The pending ownership-transfer offer — visible to the OWNER (404 when
 * none) and the offer's TARGET only (R14). Any other caller who can see the
 * group gets a constant 403, the same whether or not an offer exists.
 */
export const groupsGetGroupOwnershipTransfer = <ThrowOnError extends boolean = false>(options: Options<GroupsGetGroupOwnershipTransferData, ThrowOnError>): RequestResult<GroupsGetGroupOwnershipTransferResponses, GroupsGetGroupOwnershipTransferErrors, ThrowOnError> => (options.client ?? client).get<GroupsGetGroupOwnershipTransferResponses, GroupsGetGroupOwnershipTransferErrors, ThrowOnError>({ url: '/groups/{group_id}/transfer-ownership', ...options });

/**
 * Offer Group Ownership Transfer
 *
 * Owner-only: offer to transfer group ownership to an ACTIVE full member
 * (`user_id`). Two-step by design — the target must ACCEPT before any role
 * changes (a member is never silently promoted into an advisory role). One
 * live offer per group: a new offer REPLACES the pending one. The target must
 * be 18+ with a known DOB (the §4 advisor gate, re-checked at accept);
 * CONTRIBUTOR targets are rejected (422). Offer creation (replaces included)
 * is velocity-capped per group over a rolling 24h (GRP-WT1 → 429).
 */
export const groupsOfferGroupOwnershipTransfer = <ThrowOnError extends boolean = false>(options: Options<GroupsOfferGroupOwnershipTransferData, ThrowOnError>): RequestResult<GroupsOfferGroupOwnershipTransferResponses, GroupsOfferGroupOwnershipTransferErrors, ThrowOnError> => (options.client ?? client).post<GroupsOfferGroupOwnershipTransferResponses, GroupsOfferGroupOwnershipTransferErrors, ThrowOnError>({
    url: '/groups/{group_id}/transfer-ownership',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Group Ownership Transfer
 *
 * The offer's TARGET accepts: the atomic swap (current Owner → ADMIN,
 * caller → OWNER) + the consent record, one transaction under the group row
 * lock — exactly one OWNER at every observable point. Anyone but the target
 * gets a constant 404 (no offer-existence oracle); a retry by the now-current
 * Owner is a no-op 200. NOT a money route — no Idempotency-Key guard (the
 * locked offer re-read is the fence). Returns the caller's new roster row.
 */
export const groupsAcceptGroupOwnershipTransfer = <ThrowOnError extends boolean = false>(options: Options<GroupsAcceptGroupOwnershipTransferData, ThrowOnError>): RequestResult<GroupsAcceptGroupOwnershipTransferResponses, GroupsAcceptGroupOwnershipTransferErrors, ThrowOnError> => (options.client ?? client).post<GroupsAcceptGroupOwnershipTransferResponses, GroupsAcceptGroupOwnershipTransferErrors, ThrowOnError>({ url: '/groups/{group_id}/transfer-ownership/accept', ...options });

/**
 * Get Group Wallet
 *
 * **Owner/Admin only** (R14): the group's optimistic pooled-wallet balance +
 * a PAGINATED transaction history — contributions IN and wallet-funded grants
 * OUT (`direction="GRANT"`, one row per grant incl. evacuations; amount +
 * timestamp only per D-GRP-17), interleaved newest-first. A Member/Contributor
 * who can see the group → 403; a non-member of a PRIVATE group → 404 (the
 * shared authz predicate). The balance is the donor-honest `wallet.balance` —
 * never any settled/reserved/minted/cohort/mercury vocabulary (grant-vocab
 * quarantine).
 */
export const groupsGetGroupWallet = <ThrowOnError extends boolean = false>(options: Options<GroupsGetGroupWalletData, ThrowOnError>): RequestResult<GroupsGetGroupWalletResponses, GroupsGetGroupWalletErrors, ThrowOnError> => (options.client ?? client).get<GroupsGetGroupWalletResponses, GroupsGetGroupWalletErrors, ThrowOnError>({ url: '/groups/{group_id}/wallet', ...options });

/**
 * Contribute To Group
 *
 * Contribute (a DAF deposit) to a group's pooled wallet — any ACTIVE member.
 * Card / Apple / Google only (gift-card-to-group is coming soon → 422). An
 * irrevocable gift (R11, no refunds); both processor + platform fee apply at
 * top-up. ``Idempotency-Key`` is REQUIRED (fail-closed 422 if absent).
 */
export const groupsContributeToGroup = <ThrowOnError extends boolean = false>(options: Options<GroupsContributeToGroupData, ThrowOnError>): RequestResult<GroupsContributeToGroupResponses, GroupsContributeToGroupErrors, ThrowOnError> => (options.client ?? client).post<GroupsContributeToGroupResponses, GroupsContributeToGroupErrors, ThrowOnError>({
    url: '/groups/{group_id}/wallet/contribute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Org Invite
 *
 * Redeem an invite token → become an administrator of the inviting organization.
 *
 * ⚠ **UN-scoped, and that is the design.** The invitee holds a token and nothing
 * else; resolving WHICH organization invited them is exactly what the token is for,
 * and the invite email never told them an `org_ref`. Requiring one would also let a
 * caller assert the scope their token is judged under.
 *
 * Authenticated, but carries NO org permission — the invitee has none by
 * definition. The accepting identity comes from `request.state.idp_user`, NEVER
 * from the body: the token is email-BOUND, so letting a caller name the email they
 * are redeeming as would defeat the binding entirely.
 *
 * Every non-redeemable condition — unknown, spent, expired, wrong email — answers
 * ONE constant 400, so a leaked link cannot be probed. The single exception is the
 * caller's OWN unverified email, which answers a TYPED refusal because it discloses
 * only their own account state and is otherwise a dead end for a legitimately
 * invited person.
 */
export const orgConsoleAcceptOrgInvite = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleAcceptOrgInviteData, ThrowOnError>): RequestResult<OrgConsoleAcceptOrgInviteResponses, OrgConsoleAcceptOrgInviteErrors, ThrowOnError> => (options.client ?? client).post<OrgConsoleAcceptOrgInviteResponses, OrgConsoleAcceptOrgInviteErrors, ThrowOnError>({
    url: '/org/invites/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Org Access Requests
 *
 * This organization's access requests — PENDING first, then newest — each with
 * the requester's identity, the app, the role asked for, the explanation, and, on a
 * decided row, who decided and the note.
 *
 * TWO admissions (R9): a holder of the org-wide member-access capability (a Global
 * Admin) lists every app; an app's Owner holding its approve string lists exactly
 * the app they name in `?module=` — REQUIRED for such a caller (422 without it),
 * and 403 for an app whose string they lack or whose approval policy is
 * `global_admins_only`. `?status=` narrows to one state.
 *
 * The canonical `{data, meta, links}` envelope, like every `/org` list read.
 */
export const orgConsoleListOrgAccessRequests = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleListOrgAccessRequestsData, ThrowOnError>): RequestResult<OrgConsoleListOrgAccessRequestsResponses, OrgConsoleListOrgAccessRequestsErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleListOrgAccessRequestsResponses, OrgConsoleListOrgAccessRequestsErrors, ThrowOnError>({ url: '/org/{org_ref}/access-requests', ...options });

/**
 * Create Org Access Request
 *
 * Ask for a role in one of this organization's apps (R4, R8).
 *
 * Any admin of the organization may ask — the capability maps to the class's
 * baseline read string. `requested_role` defaults to the app's Member tier;
 * `explanation` is the optional note the approvers see. A module the class does
 * not carry is 422; one the caller ALREADY holds (a Global Admin holds every one)
 * is 409 `ALREADY_HAS_ACCESS`.
 *
 * IDEMPOTENT: an open request for the same app is returned unchanged with 200; a
 * new one is created with 201. The Global Admins and the app's Owners who may
 * approve are mailed post-commit (dark until the template is created).
 */
export const orgConsoleCreateOrgAccessRequest = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleCreateOrgAccessRequestData, ThrowOnError>): RequestResult<OrgConsoleCreateOrgAccessRequestResponses, OrgConsoleCreateOrgAccessRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgConsoleCreateOrgAccessRequestResponses, OrgConsoleCreateOrgAccessRequestErrors, ThrowOnError>({
    url: '/org/{org_ref}/access-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve Org Access Request
 *
 * Approve one request: grant the requested tier — or the approver's override
 * (R6) — through the ONE grant writer, flip the row, and record both the grant and
 * the decision in the access event log, in one unit of work.
 *
 * Same two admissions as the list. Approve NEVER turns the app on for the
 * organization: an app that is off or setting up refuses with 409
 * `MODULE_NOT_ENABLED` and the inbox reads "Turn on <app> first". Already approved
 * is idempotent (200). The requester is mailed post-commit with a link into the
 * app.
 */
export const orgConsoleApproveOrgAccessRequest = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleApproveOrgAccessRequestData, ThrowOnError>): RequestResult<OrgConsoleApproveOrgAccessRequestResponses, OrgConsoleApproveOrgAccessRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgConsoleApproveOrgAccessRequestResponses, OrgConsoleApproveOrgAccessRequestErrors, ThrowOnError>({
    url: '/org/{org_ref}/access-requests/{request_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deny Org Access Request
 *
 * Deny one request, with an optional note the requester sees (R4, D4). Same two
 * admissions as the list. Already denied is idempotent (200; the first note
 * stands). The requester is mailed post-commit with a link to their app list.
 */
export const orgConsoleDenyOrgAccessRequest = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleDenyOrgAccessRequestData, ThrowOnError>): RequestResult<OrgConsoleDenyOrgAccessRequestResponses, OrgConsoleDenyOrgAccessRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgConsoleDenyOrgAccessRequestResponses, OrgConsoleDenyOrgAccessRequestErrors, ThrowOnError>({
    url: '/org/{org_ref}/access-requests/{request_id}/deny',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org Access Catalog
 *
 * The customizable permission catalog, per module, with each key's tier.
 *
 * These are the ONLY strings a per-admin custom set may name; every other
 * permission the organization's class carries is org-level and tier-only.
 * ``default_allow`` tells the console whether a new admin gets the module
 * automatically. No portal URL is served — the web app owns its own routing
 * table.
 */
export const orgConsoleGetOrgAccessCatalog = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleGetOrgAccessCatalogData, ThrowOnError>): RequestResult<OrgConsoleGetOrgAccessCatalogResponses, OrgConsoleGetOrgAccessCatalogErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleGetOrgAccessCatalogResponses, OrgConsoleGetOrgAccessCatalogErrors, ThrowOnError>({ url: '/org/{org_ref}/access/catalog', ...options });

/**
 * List Org Access Events
 *
 * The append-only access event log, newest first. Global-Admin only, matching
 * who may change access in the first place.
 */
export const orgConsoleListOrgAccessEvents = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleListOrgAccessEventsData, ThrowOnError>): RequestResult<OrgConsoleListOrgAccessEventsResponses, OrgConsoleListOrgAccessEventsErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleListOrgAccessEventsResponses, OrgConsoleListOrgAccessEventsErrors, ThrowOnError>({ url: '/org/{org_ref}/access/events', ...options });

/**
 * Get Org Access Settings
 *
 * The org-wide module switches, defaults already applied — every module the
 * organization's class knows is present, and one it has never touched reads
 * ``enabled: true``.
 */
export const orgConsoleGetOrgAccessSettings = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleGetOrgAccessSettingsData, ThrowOnError>): RequestResult<OrgConsoleGetOrgAccessSettingsResponses, OrgConsoleGetOrgAccessSettingsErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleGetOrgAccessSettingsResponses, OrgConsoleGetOrgAccessSettingsErrors, ThrowOnError>({ url: '/org/{org_ref}/access/settings', ...options });

/**
 * Update Org Access Settings
 *
 * Switch modules on/off org-wide. Generic modules require Global Admin.
 *
 * A provisioning-hook module Owner may use this route only for that hook's
 * management act: OFF clears/displaces its attempt; ON receives the typed
 * activation-path refusal. That authority never extends to another module.
 * PARTIAL; every actual change appends one access-event row.
 */
export const orgConsoleUpdateOrgAccessSettings = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleUpdateOrgAccessSettingsData, ThrowOnError>): RequestResult<OrgConsoleUpdateOrgAccessSettingsResponses, OrgConsoleUpdateOrgAccessSettingsErrors, ThrowOnError> => (options.client ?? client).put<OrgConsoleUpdateOrgAccessSettingsResponses, OrgConsoleUpdateOrgAccessSettingsErrors, ThrowOnError>({
    url: '/org/{org_ref}/access/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Org Assistant Consent
 *
 * Revoke the organization's consent — the off switch. Same write capability as
 * accepting: ending the organization's binding is as much an org-binding act as
 * making it.
 *
 * DELETE is the verb because this withdraws a standing grant; the ledger row is
 * APPENDED, never deleted, so what was accepted and when it was withdrawn both
 * survive. It takes effect on the very next turn — the gate reads the ledger's
 * latest event, so nothing is cached between an admin flipping this off and
 * the assistant refusing.
 *
 * Idempotent, and deliberately NOT blocked when no instrument is available:
 * turning the feature OFF must never depend on the state of the copy registry.
 * It is the one operation on this path that answers 200 in the unseeded state.
 */
export const orgConsoleRevokeOrgAssistantConsent = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleRevokeOrgAssistantConsentData, ThrowOnError>): RequestResult<OrgConsoleRevokeOrgAssistantConsentResponses, OrgConsoleRevokeOrgAssistantConsentErrors, ThrowOnError> => (options.client ?? client).delete<OrgConsoleRevokeOrgAssistantConsentResponses, OrgConsoleRevokeOrgAssistantConsentErrors, ThrowOnError>({ url: '/org/{org_ref}/assistant/consent', ...options });

/**
 * Get Org Assistant Consent
 *
 * The CURRENT assistant consent instrument for this organization's class, plus
 * whether the organization has accepted it.
 *
 * Any admin of the organization may read it, for the same reason any admin may
 * read the roster or the connected-AI list: seeing whether the assistant may act
 * on your own organization's data is not privileged, and the per-admin first-use
 * NOTICE needs it. BINDING the organization takes the write capability (below).
 *
 * The same shape rides the send gate's 428 ``context.org_consent``, so one decoder
 * serves both. 404 — the console's own, byte-identical to a route miss — when the
 * class binds no instrument or none is effective.
 */
export const orgConsoleGetOrgAssistantConsent = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleGetOrgAssistantConsentData, ThrowOnError>): RequestResult<OrgConsoleGetOrgAssistantConsentResponses, OrgConsoleGetOrgAssistantConsentErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleGetOrgAssistantConsentResponses, OrgConsoleGetOrgAssistantConsentErrors, ThrowOnError>({ url: '/org/{org_ref}/assistant/consent', ...options });

/**
 * Accept Org Assistant Consent
 *
 * Accept the instrument on the ORGANIZATION's behalf.
 *
 * Owner-tier: the write string sits in `COMPANY_OWNER_PERMISSIONS` and in the
 * employer module's Owner catalog, so a base-role Global Admin and a per-module
 * employer Owner both hold it, and a Global Admin may deliberately delegate it to
 * a Member through a per-admin custom set — the console's uniform delegation
 * semantics, identical to `company:edit_match_policy`. All three are inside the
 * determination's "an Owner/Global Admin acting as the organization's agent";
 * what none of them is, is every admin by default.
 *
 * The acceptance is the organization's, taken ONCE by an authorized
 * representative — not once per admin; there are no per-admin consent rows.
 * The acting user and the instant are server-side; the body carries only the hash
 * of the copy the client displayed, and a stale one is refused (409) so a sheet
 * showing outdated text can never bind the organization. Idempotent at the
 * current version.
 */
export const orgConsoleAcceptOrgAssistantConsent = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleAcceptOrgAssistantConsentData, ThrowOnError>): RequestResult<OrgConsoleAcceptOrgAssistantConsentResponses, OrgConsoleAcceptOrgAssistantConsentErrors, ThrowOnError> => (options.client ?? client).post<OrgConsoleAcceptOrgAssistantConsentResponses, OrgConsoleAcceptOrgAssistantConsentErrors, ThrowOnError>({
    url: '/org/{org_ref}/assistant/consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Org Confirmation Requests
 *
 * The organization's confirmation requests this person may confirm, newest first,
 * in the states asked for (every state when none). An expired or void request is shown
 * as such: the read records the transition, once.
 */
export const orgConfirmationRequestsListOrgConfirmationRequests = <ThrowOnError extends boolean = false>(options: Options<OrgConfirmationRequestsListOrgConfirmationRequestsData, ThrowOnError>): RequestResult<OrgConfirmationRequestsListOrgConfirmationRequestsResponses, OrgConfirmationRequestsListOrgConfirmationRequestsErrors, ThrowOnError> => (options.client ?? client).get<OrgConfirmationRequestsListOrgConfirmationRequestsResponses, OrgConfirmationRequestsListOrgConfirmationRequestsErrors, ThrowOnError>({ url: '/org/{org_ref}/confirmation-requests', ...options });

/**
 * Get Org Confirmation Request
 *
 * One request, rendered by Givmo from the server's record, with the content hash a
 * confirm must carry and the step-up it will ask for.
 */
export const orgConfirmationRequestsGetOrgConfirmationRequest = <ThrowOnError extends boolean = false>(options: Options<OrgConfirmationRequestsGetOrgConfirmationRequestData, ThrowOnError>): RequestResult<OrgConfirmationRequestsGetOrgConfirmationRequestResponses, OrgConfirmationRequestsGetOrgConfirmationRequestErrors, ThrowOnError> => (options.client ?? client).get<OrgConfirmationRequestsGetOrgConfirmationRequestResponses, OrgConfirmationRequestsGetOrgConfirmationRequestErrors, ThrowOnError>({ url: '/org/{org_ref}/confirmation-requests/{confirmation_request_id}', ...options });

/**
 * Confirm Org Confirmation Request
 *
 * Confirm exactly what was shown: the act runs, in this transaction, when this is the
 * last confirmation the request needs. ``step_up_required`` (400) when the sign-in is not
 * recent enough; ``confirmation_request_changed`` (409, with the fresh render and hash)
 * when the request is no longer what was shown.
 */
export const orgConfirmationRequestsConfirmOrgConfirmationRequest = <ThrowOnError extends boolean = false>(options: Options<OrgConfirmationRequestsConfirmOrgConfirmationRequestData, ThrowOnError>): RequestResult<OrgConfirmationRequestsConfirmOrgConfirmationRequestResponses, OrgConfirmationRequestsConfirmOrgConfirmationRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgConfirmationRequestsConfirmOrgConfirmationRequestResponses, OrgConfirmationRequestsConfirmOrgConfirmationRequestErrors, ThrowOnError>({
    url: '/org/{org_ref}/confirmation-requests/{confirmation_request_id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decline Org Confirmation Request
 *
 * Decline the request: it ends and nothing runs.
 */
export const orgConfirmationRequestsDeclineOrgConfirmationRequest = <ThrowOnError extends boolean = false>(options: Options<OrgConfirmationRequestsDeclineOrgConfirmationRequestData, ThrowOnError>): RequestResult<OrgConfirmationRequestsDeclineOrgConfirmationRequestResponses, OrgConfirmationRequestsDeclineOrgConfirmationRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgConfirmationRequestsDeclineOrgConfirmationRequestResponses, OrgConfirmationRequestsDeclineOrgConfirmationRequestErrors, ThrowOnError>({ url: '/org/{org_ref}/confirmation-requests/{confirmation_request_id}/decline', ...options });

/**
 * List Org Connected Ai
 *
 * The AIs currently connected to this organization — one row per consent grant,
 * newest first.
 *
 * A connected AI acts for the organization with the DELEGATING HUMAN's own live
 * authority, re-resolved on every call; the scopes on a row are the consent-time
 * ceiling, not what it may do. That is why each row names the admin it acts as.
 *
 * Any admin of the organization may read this, for the same reason any admin may
 * read the roster: seeing what acts on your own organization's behalf is not
 * privileged. It is also what this route exists to fix — a connector delegated by one
 * admin used to be visible only on THAT person's own account page, and therefore
 * invisible to the organization it acts for. Ending one is Global-Admin only.
 *
 * No token material appears here on any path — no bearer, no hash, no credential id.
 */
export const orgConsoleListOrgConnectedAi = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleListOrgConnectedAiData, ThrowOnError>): RequestResult<OrgConsoleListOrgConnectedAiResponses, OrgConsoleListOrgConnectedAiErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleListOrgConnectedAiResponses, OrgConsoleListOrgConnectedAiErrors, ThrowOnError>({ url: '/org/{org_ref}/connected-ai', ...options });

/**
 * Revoke Org Connected Ai
 *
 * End one connected AI's grant, on the ORGANIZATION's authority. Global-Admin only.
 *
 * Revoking a connector is an access change — it ends an integration acting for the
 * organization — so it takes the same authority as changing who administers it.
 *
 * The kill is immediate and total: every refresh token in the grant's family AND
 * every live access token for that grant's client, in ONE unit of work. Bearers are
 * resolved against the database on each call, so a session in flight stops working on
 * its very next request rather than at its next expiry.
 *
 * It is the SAME family revoke the delegating human can perform from their own
 * account page, with the authorization boundary moved from that person to the
 * organization — one grant, one revocation semantics, two doors. Idempotent on a
 * grant this organization owns; an unknown grant and another organization's grant are
 * the same 404, never a 403, so grant ids stay un-enumerable.
 */
export const orgConsoleRevokeOrgConnectedAi = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleRevokeOrgConnectedAiData, ThrowOnError>): RequestResult<OrgConsoleRevokeOrgConnectedAiResponses, OrgConsoleRevokeOrgConnectedAiErrors, ThrowOnError> => (options.client ?? client).delete<OrgConsoleRevokeOrgConnectedAiResponses, OrgConsoleRevokeOrgConnectedAiErrors, ThrowOnError>({ url: '/org/{org_ref}/connected-ai/{grant_id}', ...options });

/**
 * Deactivate Org
 *
 * End the organization's account — the sole-Owner exit (OM-9, D-CPO-32).
 *
 * `DEACTIVATE_ORG`, the Global-Admin tier in both classes. ONE transaction ends
 * every administrator's standing (both company membership stores; the charity
 * roster), every org-plane grant and custom set, every pending invite and access
 * request, every admin preference and every connected AI, applies the class's
 * declared effects (the for-profit `company.status` dual-write) and writes the
 * deactivation fact plus one `ORG_DEACTIVATED` event — then, after the commit,
 * revokes every former admin's sessions, COUNTED on the wire (`sessions_revoked`
 * / `session_failures`). The caller's own standing ends with everyone else's:
 * after a 200 their next `/org` call answers the console's 404. No body; no
 * undo — a deactivated organization is re-enrolled (charity: re-claim), not
 * restored. Dark under `ORG_DEACTIVATION_ENABLED` as well as the console flag,
 * with the byte-identical route-miss answer.
 */
export const orgConsoleDeactivateOrg = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleDeactivateOrgData, ThrowOnError>): RequestResult<OrgConsoleDeactivateOrgResponses, OrgConsoleDeactivateOrgErrors, ThrowOnError> => (options.client ?? client).post<OrgConsoleDeactivateOrgResponses, OrgConsoleDeactivateOrgErrors, ThrowOnError>({ url: '/org/{org_ref}/deactivate', ...options });

/**
 * List Org Fundraisers
 *
 * The organization's portfolio with owner statistics in the canonical
 * paginated envelope. Both console and module release gates must be open.
 */
export const orgFundraisersListOrgFundraisers = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersListOrgFundraisersData, ThrowOnError>): RequestResult<OrgFundraisersListOrgFundraisersResponses, OrgFundraisersListOrgFundraisersErrors, ThrowOnError> => (options.client ?? client).get<OrgFundraisersListOrgFundraisersResponses, OrgFundraisersListOrgFundraisersErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers', ...options });

/**
 * Create Org Fundraiser
 *
 * Create an organization-owned draft under WRITE_FUNDRAISERS.
 * The service applies the resolved class's standing and recipient rules.
 */
export const orgFundraisersCreateOrgFundraiser = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersCreateOrgFundraiserData, ThrowOnError>): RequestResult<OrgFundraisersCreateOrgFundraiserResponses, OrgFundraisersCreateOrgFundraiserErrors, ThrowOnError> => (options.client ?? client).post<OrgFundraisersCreateOrgFundraiserResponses, OrgFundraisersCreateOrgFundraiserErrors, ThrowOnError>({
    url: '/org/{org_ref}/fundraisers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Org Supporter Fundraisers
 *
 * FCM-BE11: the fundraisers other people started for this organization — directly,
 * through a collection or Cause fund it belongs to, or that already sent it a gift —
 * each as its public page shows it, newest publication first. A class that is never a
 * recipient, the retirement flag off, or a closed Charity Terms gate all answer the
 * family's route miss.
 */
export const orgFundraisersListOrgSupporterFundraisers = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersListOrgSupporterFundraisersData, ThrowOnError>): RequestResult<OrgFundraisersListOrgSupporterFundraisersResponses, OrgFundraisersListOrgSupporterFundraisersErrors, ThrowOnError> => (options.client ?? client).get<OrgFundraisersListOrgSupporterFundraisersResponses, OrgFundraisersListOrgSupporterFundraisersErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/by-supporters', ...options });

/**
 * Delete Org Fundraiser
 *
 * FCM-BE39: delete a draft, or delete forever a deactivated fundraiser no one funded.
 * An active fundraiser is a conflict (deactivate it first); a funded one is never
 * deleted (409 FUNDRAISER_HAS_DONATIONS), and under the take-down lock neither is a
 * Givmo takedown (409 FUNDRAISER_REMOVED_BY_GIVMO).
 */
export const orgFundraisersDeleteOrgFundraiser = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersDeleteOrgFundraiserData, ThrowOnError>): RequestResult<OrgFundraisersDeleteOrgFundraiserResponses, OrgFundraisersDeleteOrgFundraiserErrors, ThrowOnError> => (options.client ?? client).delete<OrgFundraisersDeleteOrgFundraiserResponses, OrgFundraisersDeleteOrgFundraiserErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}', ...options });

/**
 * Get Org Fundraiser
 *
 * Organization-scoped fundraiser details, with one route-miss answer
 * for a missing or foreign resource.
 */
export const orgFundraisersGetOrgFundraiser = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersGetOrgFundraiserData, ThrowOnError>): RequestResult<OrgFundraisersGetOrgFundraiserResponses, OrgFundraisersGetOrgFundraiserErrors, ThrowOnError> => (options.client ?? client).get<OrgFundraisersGetOrgFundraiserResponses, OrgFundraisersGetOrgFundraiserErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}', ...options });

/**
 * Update Org Fundraiser
 *
 * Update name, description, narrative, goal or statistics visibility.
 * Omitted values remain; the supported explicit nulls clear their fields.
 */
export const orgFundraisersUpdateOrgFundraiser = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersUpdateOrgFundraiserData, ThrowOnError>): RequestResult<OrgFundraisersUpdateOrgFundraiserResponses, OrgFundraisersUpdateOrgFundraiserErrors, ThrowOnError> => (options.client ?? client).patch<OrgFundraisersUpdateOrgFundraiserResponses, OrgFundraisersUpdateOrgFundraiserErrors, ThrowOnError>({
    url: '/org/{org_ref}/fundraisers/{fundraiser_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close Org Fundraiser
 *
 * End an active fundraiser without changing the frozen status enum.
 * Closing is reversible with Reopen, and an exact repeated close is a no-op.
 */
export const orgFundraisersCloseOrgFundraiser = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersCloseOrgFundraiserData, ThrowOnError>): RequestResult<OrgFundraisersCloseOrgFundraiserResponses, OrgFundraisersCloseOrgFundraiserErrors, ThrowOnError> => (options.client ?? client).post<OrgFundraisersCloseOrgFundraiserResponses, OrgFundraisersCloseOrgFundraiserErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/close', ...options });

/**
 * Deactivate Org Fundraiser
 *
 * FCM-BE39: take an active fundraiser's page down, by the consumer lifecycle's own
 * rules: under the take-down lock a funded fundraiser is refused (409
 * FUNDRAISER_HAS_DONATIONS; Close is the way to end it) and a Givmo takedown answers
 * 409 FUNDRAISER_REMOVED_BY_GIVMO. Repeating it on a deactivated fundraiser changes
 * nothing; a draft is a conflict (it is deleted, never deactivated).
 */
export const orgFundraisersDeactivateOrgFundraiser = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersDeactivateOrgFundraiserData, ThrowOnError>): RequestResult<OrgFundraisersDeactivateOrgFundraiserResponses, OrgFundraisersDeactivateOrgFundraiserErrors, ThrowOnError> => (options.client ?? client).post<OrgFundraisersDeactivateOrgFundraiserResponses, OrgFundraisersDeactivateOrgFundraiserErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/deactivate', ...options });

/**
 * Put Org Fundraiser Designations
 *
 * Reconcile the complete designation list for a flavor supporting it.
 * Donation-referenced labels are retained; an unsupported flavor is absent.
 */
export const orgFundraisersPutOrgFundraiserDesignations = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersPutOrgFundraiserDesignationsData, ThrowOnError>): RequestResult<OrgFundraisersPutOrgFundraiserDesignationsResponses, OrgFundraisersPutOrgFundraiserDesignationsErrors, ThrowOnError> => (options.client ?? client).put<OrgFundraisersPutOrgFundraiserDesignationsResponses, OrgFundraisersPutOrgFundraiserDesignationsErrors, ThrowOnError>({
    url: '/org/{org_ref}/fundraisers/{fundraiser_id}/designations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Org Fundraiser Donor Messages
 *
 * FCM-BE84 (plan §FC-17.5): an organization's fundraiser's messages to its donors, newest
 * first, for a holder of the module's READ_FUNDRAISERS. Dark under the messages gate as well
 * as the donor list's; every miss is the family's route miss.
 */
export const orgFundraisersListOrgFundraiserDonorMessages = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersListOrgFundraiserDonorMessagesData, ThrowOnError>): RequestResult<OrgFundraisersListOrgFundraiserDonorMessagesResponses, OrgFundraisersListOrgFundraiserDonorMessagesErrors, ThrowOnError> => (options.client ?? client).get<OrgFundraisersListOrgFundraiserDonorMessagesResponses, OrgFundraisersListOrgFundraiserDonorMessagesErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/donor-messages', ...options });

/**
 * Send Org Fundraiser Donor Message
 *
 * FCM-BE84 (plan §FC-17.1, §FC-17.5): an organization's message to its fundraiser's donors,
 * or, with `dry_run`, the server's render of exactly what donors get and how many it would go
 * to. The module's OWNER tier sends (MANAGE_CAMPAIGNS); a charity only to donors who shared
 * with it, while its Charity Terms are in place. Web-only (no AI tool, R-11).
 */
export const orgFundraisersSendOrgFundraiserDonorMessage = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersSendOrgFundraiserDonorMessageData, ThrowOnError>): RequestResult<OrgFundraisersSendOrgFundraiserDonorMessageResponses, OrgFundraisersSendOrgFundraiserDonorMessageErrors, ThrowOnError> => (options.client ?? client).post<OrgFundraisersSendOrgFundraiserDonorMessageResponses, OrgFundraisersSendOrgFundraiserDonorMessageErrors, ThrowOnError>({
    url: '/org/{org_ref}/fundraisers/{fundraiser_id}/donor-messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Org Fundraiser Donors
 *
 * FCM-BE83 (plan §FC-17.3): an organization's fundraiser's private donor list, a row
 * per gift, for a holder of the module's READ_FUNDRAISERS. Dark under
 * FUNDRAISER_DONOR_LIST_ENABLED as well as the family's two flags; every miss is the
 * family's route miss. Paged; no export.
 */
export const orgFundraisersListOrgFundraiserDonors = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersListOrgFundraiserDonorsData, ThrowOnError>): RequestResult<OrgFundraisersListOrgFundraiserDonorsResponses, OrgFundraisersListOrgFundraiserDonorsErrors, ThrowOnError> => (options.client ?? client).get<OrgFundraisersListOrgFundraiserDonorsResponses, OrgFundraisersListOrgFundraiserDonorsErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/donors', ...options });

/**
 * Publish Org Fundraiser
 *
 * Publish a draft after rechecking organization standing and recipients.
 */
export const orgFundraisersPublishOrgFundraiser = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersPublishOrgFundraiserData, ThrowOnError>): RequestResult<OrgFundraisersPublishOrgFundraiserResponses, OrgFundraisersPublishOrgFundraiserErrors, ThrowOnError> => (options.client ?? client).post<OrgFundraisersPublishOrgFundraiserResponses, OrgFundraisersPublishOrgFundraiserErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/publish', ...options });

/**
 * Reactivate Org Fundraiser
 *
 * FCM-BE39: bring a deactivated fundraiser's page back, after the consumer
 * reactivate's checks (a charity's standing, the per-person cap). Under the take-down
 * lock a Givmo takedown is Givmo's to reinstate (409 FUNDRAISER_REMOVED_BY_GIVMO).
 * Repeating it on an active fundraiser changes nothing; a draft is a conflict.
 */
export const orgFundraisersReactivateOrgFundraiser = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersReactivateOrgFundraiserData, ThrowOnError>): RequestResult<OrgFundraisersReactivateOrgFundraiserResponses, OrgFundraisersReactivateOrgFundraiserErrors, ThrowOnError> => (options.client ?? client).post<OrgFundraisersReactivateOrgFundraiserResponses, OrgFundraisersReactivateOrgFundraiserErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/reactivate', ...options });

/**
 * Reopen Org Fundraiser
 *
 * Reopen a closed fundraiser so it accepts donations again, after the same
 * standing and per-person cap checks as the consumer door. Reopening an open
 * fundraiser is a no-op; a draft or deactivated one is a conflict.
 */
export const orgFundraisersReopenOrgFundraiser = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersReopenOrgFundraiserData, ThrowOnError>): RequestResult<OrgFundraisersReopenOrgFundraiserResponses, OrgFundraisersReopenOrgFundraiserErrors, ThrowOnError> => (options.client ?? client).post<OrgFundraisersReopenOrgFundraiserResponses, OrgFundraisersReopenOrgFundraiserErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/reopen', ...options });

/**
 * Get Org Fundraiser Share
 *
 * Read or ensure the organization's canonical short link.
 * A first direct request may insert that redirect record after standing checks.
 */
export const orgFundraisersGetOrgFundraiserShare = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersGetOrgFundraiserShareData, ThrowOnError>): RequestResult<OrgFundraisersGetOrgFundraiserShareResponses, OrgFundraisersGetOrgFundraiserShareErrors, ThrowOnError> => (options.client ?? client).get<OrgFundraisersGetOrgFundraiserShareResponses, OrgFundraisersGetOrgFundraiserShareErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/share', ...options });

/**
 * Get Org Fundraiser Share Kit
 *
 * CPB-BE8: the organization's share kit for one of its fundraisers (the campaign
 * editor's share card): its canonical link (the same record `…/share` reads or ensures),
 * captions in its voice and its library's current graphics. Its QR is `…/share/qr`.
 */
export const orgFundraisersGetOrgFundraiserShareKit = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersGetOrgFundraiserShareKitData, ThrowOnError>): RequestResult<OrgFundraisersGetOrgFundraiserShareKitResponses, OrgFundraisersGetOrgFundraiserShareKitErrors, ThrowOnError> => (options.client ?? client).get<OrgFundraisersGetOrgFundraiserShareKitResponses, OrgFundraisersGetOrgFundraiserShareKitErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/share-kit', ...options });

/**
 * Download Org Fundraiser Share Kit Graphics
 *
 * CPB-BE8: "Download all" on the organization's card. Shares the downloads' per-network
 * budget, fail-closed, before any storage read.
 */
export const orgFundraisersDownloadOrgFundraiserShareKitGraphics = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersDownloadOrgFundraiserShareKitGraphicsData, ThrowOnError>): RequestResult<OrgFundraisersDownloadOrgFundraiserShareKitGraphicsResponses, OrgFundraisersDownloadOrgFundraiserShareKitGraphicsErrors, ThrowOnError> => (options.client ?? client).get<OrgFundraisersDownloadOrgFundraiserShareKitGraphicsResponses, OrgFundraisersDownloadOrgFundraiserShareKitGraphicsErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/share-kit/graphics.zip', ...options });

/**
 * Render Org Fundraiser Share Qr
 *
 * Render the canonical organization link as a styled QR.
 * Its bounded first-use ensure shares the link endpoint's exact semantics.
 */
export const orgFundraisersRenderOrgFundraiserShareQr = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersRenderOrgFundraiserShareQrData, ThrowOnError>): RequestResult<OrgFundraisersRenderOrgFundraiserShareQrResponses, OrgFundraisersRenderOrgFundraiserShareQrErrors, ThrowOnError> => (options.client ?? client).get<OrgFundraisersRenderOrgFundraiserShareQrResponses, OrgFundraisersRenderOrgFundraiserShareQrErrors, ThrowOnError>({ url: '/org/{org_ref}/fundraisers/{fundraiser_id}/share/qr', ...options });

/**
 * Render Supplied Org Fundraiser Share Qr
 *
 * Render this fundraiser's canonical link in a SUPPLIED design — the QR editor's
 * preview and its download-without-saving. Saves no design; the link is the
 * server's own, never the caller's.
 */
export const orgFundraisersRenderSuppliedOrgFundraiserShareQr = <ThrowOnError extends boolean = false>(options: Options<OrgFundraisersRenderSuppliedOrgFundraiserShareQrData, ThrowOnError>): RequestResult<OrgFundraisersRenderSuppliedOrgFundraiserShareQrResponses, OrgFundraisersRenderSuppliedOrgFundraiserShareQrErrors, ThrowOnError> => (options.client ?? client).post<OrgFundraisersRenderSuppliedOrgFundraiserShareQrResponses, OrgFundraisersRenderSuppliedOrgFundraiserShareQrErrors, ThrowOnError>({
    url: '/org/{org_ref}/fundraisers/{fundraiser_id}/share/qr',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Org Integrations
 *
 * The purpose's connections the caller may see: every one with the purpose's manage
 * capability; otherwise one's own personal connection and the organization's account. The
 * canonical `{data, meta, links}` envelope, paginated by `page[limit]` / `page[offset]`.
 */
export const orgIntegrationsListOrgIntegrations = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationsListOrgIntegrationsData, ThrowOnError>): RequestResult<OrgIntegrationsListOrgIntegrationsResponses, OrgIntegrationsListOrgIntegrationsErrors, ThrowOnError> => (options.client ?? client).get<OrgIntegrationsListOrgIntegrationsResponses, OrgIntegrationsListOrgIntegrationsErrors, ThrowOnError>({ url: '/org/{org_ref}/integrations', ...options });

/**
 * Complete Org Integration Oauth
 *
 * Finish a connect the console started: the single-use state must have been minted for
 * this person, this organization and this return address.
 */
export const orgIntegrationsCompleteOrgIntegrationOauth = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationsCompleteOrgIntegrationOauthData, ThrowOnError>): RequestResult<OrgIntegrationsCompleteOrgIntegrationOauthResponses, OrgIntegrationsCompleteOrgIntegrationOauthErrors, ThrowOnError> => (options.client ?? client).post<OrgIntegrationsCompleteOrgIntegrationOauthResponses, OrgIntegrationsCompleteOrgIntegrationOauthErrors, ThrowOnError>({
    url: '/org/{org_ref}/integrations/oauth/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete Org Integration Oauth Accounts
 *
 * Finish a connect whose provider's grant answers candidate accounts (a Facebook Page and
 * its Instagram account, a LinkedIn organization page): one eligible account is connected at
 * once; several answer a pending choice that lives fifteen minutes. Each completion refuses
 * the other's states.
 */
export const orgIntegrationsCompleteOrgIntegrationOauthAccounts = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationsCompleteOrgIntegrationOauthAccountsData, ThrowOnError>): RequestResult<OrgIntegrationsCompleteOrgIntegrationOauthAccountsResponses, OrgIntegrationsCompleteOrgIntegrationOauthAccountsErrors, ThrowOnError> => (options.client ?? client).post<OrgIntegrationsCompleteOrgIntegrationOauthAccountsResponses, OrgIntegrationsCompleteOrgIntegrationOauthAccountsErrors, ThrowOnError>({
    url: '/org/{org_ref}/integrations/oauth/complete-accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Org Integration Oauth
 *
 * Start connecting an external account for one purpose: answers the provider's
 * authorization URL. A personal account is connected only by its own person (the purpose's
 * personal capability); the organization's account needs the purpose's manage capability.
 */
export const orgIntegrationsStartOrgIntegrationOauth = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationsStartOrgIntegrationOauthData, ThrowOnError>): RequestResult<OrgIntegrationsStartOrgIntegrationOauthResponses, OrgIntegrationsStartOrgIntegrationOauthErrors, ThrowOnError> => (options.client ?? client).post<OrgIntegrationsStartOrgIntegrationOauthResponses, OrgIntegrationsStartOrgIntegrationOauthErrors, ThrowOnError>({
    url: '/org/{org_ref}/integrations/oauth/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Org Integration Offered Providers
 *
 * SMM-BE9 (review-minted G-A): the purpose's offered providers, each with its grant family,
 * so the console shows one Connect per offered family. The purpose's read capability; a
 * withheld or switched-off module is the route miss. The canonical `{data, meta, links}`
 * envelope.
 */
export const orgIntegrationsListOrgIntegrationOfferedProviders = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationsListOrgIntegrationOfferedProvidersData, ThrowOnError>): RequestResult<OrgIntegrationsListOrgIntegrationOfferedProvidersResponses, OrgIntegrationsListOrgIntegrationOfferedProvidersErrors, ThrowOnError> => (options.client ?? client).get<OrgIntegrationsListOrgIntegrationOfferedProvidersResponses, OrgIntegrationsListOrgIntegrationOfferedProvidersErrors, ThrowOnError>({ url: '/org/{org_ref}/integrations/offered-providers', ...options });

/**
 * Abandon Org Integration Pending
 *
 * Abandon a pending choice: nothing is connected, and the grant's token is deleted.
 */
export const orgIntegrationsAbandonOrgIntegrationPending = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationsAbandonOrgIntegrationPendingData, ThrowOnError>): RequestResult<OrgIntegrationsAbandonOrgIntegrationPendingResponses, OrgIntegrationsAbandonOrgIntegrationPendingErrors, ThrowOnError> => (options.client ?? client).delete<OrgIntegrationsAbandonOrgIntegrationPendingResponses, OrgIntegrationsAbandonOrgIntegrationPendingErrors, ThrowOnError>({ url: '/org/{org_ref}/integrations/pending/{grant_id}', ...options });

/**
 * Get Org Integration Pending
 *
 * A pending choice's candidate accounts, to the person who connected only.
 */
export const orgIntegrationsGetOrgIntegrationPending = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationsGetOrgIntegrationPendingData, ThrowOnError>): RequestResult<OrgIntegrationsGetOrgIntegrationPendingResponses, OrgIntegrationsGetOrgIntegrationPendingErrors, ThrowOnError> => (options.client ?? client).get<OrgIntegrationsGetOrgIntegrationPendingResponses, OrgIntegrationsGetOrgIntegrationPendingErrors, ThrowOnError>({ url: '/org/{org_ref}/integrations/pending/{grant_id}', ...options });

/**
 * Select Org Integration Pending
 *
 * Choose which of a pending grant's accounts to connect: one connection per chosen
 * account, each with its own credential. The purpose's manage capability, read fresh.
 */
export const orgIntegrationsSelectOrgIntegrationPending = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationsSelectOrgIntegrationPendingData, ThrowOnError>): RequestResult<OrgIntegrationsSelectOrgIntegrationPendingResponses, OrgIntegrationsSelectOrgIntegrationPendingErrors, ThrowOnError> => (options.client ?? client).post<OrgIntegrationsSelectOrgIntegrationPendingResponses, OrgIntegrationsSelectOrgIntegrationPendingErrors, ThrowOnError>({
    url: '/org/{org_ref}/integrations/pending/{grant_id}/select',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disconnect Org Integration
 *
 * Disconnect: the token deleted (and revoked at the provider), the connection kept as
 * history. A person may always disconnect their own; anyone else's needs the purpose's manage
 * capability.
 */
export const orgIntegrationsDisconnectOrgIntegration = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationsDisconnectOrgIntegrationData, ThrowOnError>): RequestResult<OrgIntegrationsDisconnectOrgIntegrationResponses, OrgIntegrationsDisconnectOrgIntegrationErrors, ThrowOnError> => (options.client ?? client).delete<OrgIntegrationsDisconnectOrgIntegrationResponses, OrgIntegrationsDisconnectOrgIntegrationErrors, ThrowOnError>({ url: '/org/{org_ref}/integrations/{connection_id}', ...options });

/**
 * Get Org Integration
 *
 * One connection's status (and, at most once a day, its token kept alive).
 */
export const orgIntegrationsGetOrgIntegration = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationsGetOrgIntegrationData, ThrowOnError>): RequestResult<OrgIntegrationsGetOrgIntegrationResponses, OrgIntegrationsGetOrgIntegrationErrors, ThrowOnError> => (options.client ?? client).get<OrgIntegrationsGetOrgIntegrationResponses, OrgIntegrationsGetOrgIntegrationErrors, ThrowOnError>({ url: '/org/{org_ref}/integrations/{connection_id}', ...options });

/**
 * Get Org Self Access
 *
 * The CALLER's own standing for THIS organization — the one answer to "what may
 * I do here".
 *
 * Flag-gated like the rest, unlike the company console's ``GET /admin/company/me``.
 * That route is deliberately ungated because it is an EXISTING route that merely
 * GAINED additive fields, so gating would hide accurate information a client
 * already had. This route is NEW: there is no accurate information to preserve, so
 * it goes dark with the surface it belongs to.
 */
export const orgConsoleGetOrgSelfAccess = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleGetOrgSelfAccessData, ThrowOnError>): RequestResult<OrgConsoleGetOrgSelfAccessResponses, OrgConsoleGetOrgSelfAccessErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleGetOrgSelfAccessResponses, OrgConsoleGetOrgSelfAccessErrors, ThrowOnError>({ url: '/org/{org_ref}/me', ...options });

/**
 * Get Org Admin Preferences
 *
 * The caller's preferences PAGE: `{definitions, values}` — every definition
 * THIS caller is served (the org group's, plus those of the apps they hold, each
 * filtered by its audience — e.g. the access-request mail toggle only for someone
 * who can approve requests) and the caller's STORED values for those keys. A key
 * absent from `values` means the definition's `default`.
 *
 * ⚠ **Never a landing input.** The chosen landing app rides the ONE standing read
 * (`GET /org/{org_ref}/me` → `default_landing_module`, and the same field on
 * `GET /admin/company/me`), which the root already awaits; this read exists for
 * the preferences page and nothing else consults it.
 */
export const orgConsoleGetOrgAdminPreferences = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleGetOrgAdminPreferencesData, ThrowOnError>): RequestResult<OrgConsoleGetOrgAdminPreferencesResponses, OrgConsoleGetOrgAdminPreferencesErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleGetOrgAdminPreferencesResponses, OrgConsoleGetOrgAdminPreferencesErrors, ThrowOnError>({ url: '/org/{org_ref}/me/preferences', ...options });

/**
 * Update Org Admin Preferences
 *
 * Set the caller's own preferences. Any admin — a person may always edit
 * their own.
 *
 * PARTIAL and THREE-VALUED per key: `{values: {key: value | null}}` — a key not
 * sent is left alone, an explicit `null` RESETS it to the definition's default
 * (the row is deleted), a value is validated against the definition and stored.
 * An unknown key is 422 `UNKNOWN_PREFERENCE_KEY`; a key whose app the caller does
 * not hold, or whose audience does not include them, is 422
 * `PREFERENCE_NOT_SERVED`; a value outside the definition's shape is 422
 * `INVALID_PREFERENCE_VALUE`; an unknown top-level field is 422
 * (`extra="forbid"`). The whole body is validated before any write, and the
 * writes land together. No access-event row: a personal preference is not an
 * access change. Answers the page's read so it can re-render from the body.
 */
export const orgConsoleUpdateOrgAdminPreferences = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleUpdateOrgAdminPreferencesData, ThrowOnError>): RequestResult<OrgConsoleUpdateOrgAdminPreferencesResponses, OrgConsoleUpdateOrgAdminPreferencesErrors, ThrowOnError> => (options.client ?? client).put<OrgConsoleUpdateOrgAdminPreferencesResponses, OrgConsoleUpdateOrgAdminPreferencesErrors, ThrowOnError>({
    url: '/org/{org_ref}/me/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org Measurement Config
 *
 * The organization's measurement configuration — the three vendor ids, plus
 * when and by whom they were last changed.
 *
 * Any admin of the organization may read it, for the same reason any admin may
 * read the module switches: seeing how your own organization's donation surfaces
 * are instrumented is not privileged. CHANGING it is Owner/Global-Admin tier.
 *
 * **200 with every field null for an organization that has never configured
 * anything** — never a resource 404. On this surface a 404 is reserved for the
 * dark gate and the route miss, so answering one here would be indistinguishable
 * from "there is no such route" and would make an empty form look broken.
 */
export const orgConsoleGetOrgMeasurementConfig = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleGetOrgMeasurementConfigData, ThrowOnError>): RequestResult<OrgConsoleGetOrgMeasurementConfigResponses, OrgConsoleGetOrgMeasurementConfigErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleGetOrgMeasurementConfigResponses, OrgConsoleGetOrgMeasurementConfigErrors, ThrowOnError>({ url: '/org/{org_ref}/measurement', ...options });

/**
 * Update Org Measurement Config
 *
 * Set the organization's measurement ids. Owner/Global-Admin tier.
 *
 * PARTIAL and THREE-VALUED per field: an ABSENT field is left alone, an explicit
 * ``null`` CLEARS it, and a string is whitespace-stripped, upper-cased,
 * format-validated and stored. An invalid id answers 422 naming the field; an
 * unknown key answers 422 too (``extra="forbid"``).
 *
 * Idempotent: a field patched to the value it already holds is not a change, so
 * a save of an unedited form writes nothing at all — no row, no stamp, no event.
 * Every field that DOES change appends one ``MEASUREMENT_CONFIG_CHANGED`` access
 * event carrying its before and after, in the same unit of work as the write.
 *
 * The ids are STORED and WELL-FORMED, and nothing more: no call is made to Google
 * or Meta, so a syntactically perfect id for a property that does not exist is
 * accepted like any other. Emission belongs to the surfaces that READ this — the
 * donate pages and the embedded checkout — not to this operation.
 */
export const orgConsoleUpdateOrgMeasurementConfig = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleUpdateOrgMeasurementConfigData, ThrowOnError>): RequestResult<OrgConsoleUpdateOrgMeasurementConfigResponses, OrgConsoleUpdateOrgMeasurementConfigErrors, ThrowOnError> => (options.client ?? client).put<OrgConsoleUpdateOrgMeasurementConfigResponses, OrgConsoleUpdateOrgMeasurementConfigErrors, ThrowOnError>({
    url: '/org/{org_ref}/measurement',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Org Console Members
 *
 * The admin roster, each row carrying that admin's per-module standing (access,
 * tier, whether the organization has the module on, whether they carry a custom
 * permission set, and their effective permissions for it).
 *
 * Any admin of the organization may read the roster — seeing who else administers
 * your own organization is not privileged. CHANGING it is Global-Admin only.
 */
export const orgConsoleListOrgConsoleMembers = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleListOrgConsoleMembersData, ThrowOnError>): RequestResult<OrgConsoleListOrgConsoleMembersResponses, OrgConsoleListOrgConsoleMembersErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleListOrgConsoleMembersResponses, OrgConsoleListOrgConsoleMembersErrors, ThrowOnError>({ url: '/org/{org_ref}/members', ...options });

/**
 * List Org Invites
 *
 * This organization's LIVE invites — PENDING and not past expiry, newest first.
 *
 * Same authority as creating one: seeing who has been offered administration is the
 * same question as offering it. TWO admissions (clause 7, CPA-WEB40 W6-BE): a Global
 * Admin lists every invite and may narrow with `?module=<slug>` to the invites that
 * CARRY that module — issued from inside it, or offering it (the module Team page's
 * view); a module Owner holding its `<module>:invite_admins` string lists exactly the
 * module they name, and `?module=` is REQUIRED for such a caller — 422
 * `INVITE_MODULE_REQUIRED` without it (the access-request family's answer to the
 * same omission), since an unfiltered list is the org-wide read. A module the class
 * does not carry is 422 by name.
 *
 * The canonical `{data, meta, links}` envelope, like every other `/org` list read —
 * NOT the predecessor's `{invites: [...]}` named wrapper, which is a grandfathered
 * frozen shape on `/charity-admin`. `/org` is deliberately absent from
 * `lint_untyped_operations`'s informational-prefix list, so a non-canonical list
 * read here blocks the fail-closed contract gate on a staging or main promote.
 *
 * NEVER carries a token or its hash.
 */
export const orgConsoleListOrgInvites = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleListOrgInvitesData, ThrowOnError>): RequestResult<OrgConsoleListOrgInvitesResponses, OrgConsoleListOrgInvitesErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleListOrgInvitesResponses, OrgConsoleListOrgInvitesErrors, ThrowOnError>({ url: '/org/{org_ref}/members/invites', ...options });

/**
 * Create Org Invite
 *
 * Offer someone administration of this organization.
 *
 * `role='Owner'` invites a GLOBAL ADMIN and must carry no `module_grants`;
 * `role='Member'` invites a non-GA whose access is EXACTLY the offered grants
 * (D-CPO-24 — under the invitation model there is no fan-out, so the list IS the
 * access). `issued_module`'s presence makes the invite MODULE-issued and binds it to
 * clause 7's scope: that one module, a tier no higher than the issuer's own, never
 * Global Admin.
 *
 * TWO admissions (clause 7, CPA-WEB40 W6-BE): a Global Admin (the org-wide invite
 * capability) may make any offer; a module Owner holding that module's
 * `<module>:invite_admins` string may make a MODULE-ISSUED one — `issued_module`
 * set to their module — and nothing else: without `issued_module` they are refused
 * (an org-issued invite stays a Global Admin's), and an offer outside clause 7's
 * scope is refused by name with 400.
 *
 * Re-inviting an address SUPERSEDES its live invite rather than stacking a second
 * token — and a supersede is a revoke, so a module Owner may supersede only an invite
 * they could revoke (module-issued for their module); a Global Admin's org-issued
 * offer, or another module's, is refused by name (400) and stays pending. Inviting someone who ALREADY administers this organization mints nothing —
 * giving an existing admin more modules is a direct grant, not something to accept —
 * and answers 201 with `{already_admin: true, invite: null}`, so a composer that
 * asks the wrong question gets an honest answer, and the signal it needs to switch
 * to the direct-grant path, rather than a duplicate membership.
 *
 * ⚠ The response is DISCRIMINATED, not a bare nullable invite: a handler annotated
 * `-> OrgInviteOut` returning `None` answers 500, not a null body (FastAPI validates
 * the return against the declared model). See `OrgInviteCreatedOut`.
 *
 * ⚠ **The response NEVER carries the token.** The plaintext exists only in the
 * emailed accept link; the database stores only its SHA-256 hash.
 */
export const orgConsoleCreateOrgInvite = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleCreateOrgInviteData, ThrowOnError>): RequestResult<OrgConsoleCreateOrgInviteResponses, OrgConsoleCreateOrgInviteErrors, ThrowOnError> => (options.client ?? client).post<OrgConsoleCreateOrgInviteResponses, OrgConsoleCreateOrgInviteErrors, ThrowOnError>({
    url: '/org/{org_ref}/members/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Org Invite
 *
 * Rescind a live invite before it is redeemed.
 *
 * TWO admissions (clause 7, CPA-WEB40 W6-BE): a Global Admin may revoke any live
 * invite of the organization; a module Owner holding its `<module>:invite_admins`
 * string may revoke only an invite that was MODULE-ISSUED for that module — an
 * org-issued offer stays a Global Admin's to rescind (403).
 *
 * The invite must belong to THIS organization and class; a cross-org id answers the
 * same not-found as an unknown one, so ids are not enumerable across organizations
 * — and since `org_ref` carries no foreign key, that scoping is the only thing
 * keeping the id spaces apart. An already-terminal invite is likewise a not-found:
 * only a live invite is revocable.
 */
export const orgConsoleRevokeOrgInvite = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleRevokeOrgInviteData, ThrowOnError>): RequestResult<OrgConsoleRevokeOrgInviteResponses, OrgConsoleRevokeOrgInviteErrors, ThrowOnError> => (options.client ?? client).delete<OrgConsoleRevokeOrgInviteResponses, OrgConsoleRevokeOrgInviteErrors, ThrowOnError>({ url: '/org/{org_ref}/members/invites/{invite_id}', ...options });

/**
 * Remove Org Member
 *
 * Take someone off this organization's admin team entirely. Global-Admin only.
 *
 * The REMOVE half of the invite family's ADD: who administers an organization is the
 * organization's own question, so it is answered here rather than in a class module
 * the other class will never open.
 *
 * The class's own removal writer does the membership work — this door and the
 * class's door are ONE writer — and the org console additionally tears down the
 * org-plane records (module grants and custom permission sets) in the same unit of
 * work, so a re-added person starts clean.
 *
 * **The last-Global-Admin guard binds**: you may remove yourself, but not the last
 * Global Admin. A person who is not an admin of this organization — unknown, or an
 * admin of a different one — answers the family's one constant 400, which is also
 * what a repeated removal answers; nothing is audited twice.
 *
 * Pending INVITES are untouched: an invite is addressed to an email, is TTL-bounded,
 * and re-validates its issuer's standing at accept. Sessions, lock claims and
 * employment rows are untouched too, exactly as the class doors leave them.
 */
export const orgConsoleRemoveOrgMember = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleRemoveOrgMemberData, ThrowOnError>): RequestResult<OrgConsoleRemoveOrgMemberResponses, OrgConsoleRemoveOrgMemberErrors, ThrowOnError> => (options.client ?? client).delete<OrgConsoleRemoveOrgMemberResponses, OrgConsoleRemoveOrgMemberErrors, ThrowOnError>({ url: '/org/{org_ref}/members/{member_id}', ...options });

/**
 * Remove Org Member Module Access
 *
 * Revoke ONE module's grant from ONE admin — the access-update family's scoped
 * member, over the SAME writer as `PUT …/access` (`has_access: false`).
 *
 * Idempotent, and it deletes any custom permission set with the grant, exactly as the
 * PUT does. Every change appends the same `MODULE_ACCESS_REVOKED` row the PUT
 * appends — this route mints no audit vocabulary of its own.
 *
 * ⚠ **Revoking an admin's LAST stored module is refused (422)**, on this route for
 * the same reason as on the PUT: zero stored facts read back as "never enrolled" and
 * resolve DEFAULT access through the legacy fallback, which is wider than what was
 * just revoked. The honest acts are removing them from the organization, or waiting
 * for OM-4's choreography, which deletes the refusal from both doors together.
 *
 * ⚠ **A Global Admin target is refused (422).** They hold every module by tier and
 * the resolver ignores their grant rows, so deleting one would change nothing while
 * recording that it did. Removing the Global-Admin flag is the PUT's job.
 *
 * `module` is validated against the addressed organization's CLASS catalog — the
 * module vocabulary is per-class data, so an unknown slug answers the PUT's own 422
 * rather than a route miss.
 */
export const orgConsoleRemoveOrgMemberModuleAccess = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleRemoveOrgMemberModuleAccessData, ThrowOnError>): RequestResult<OrgConsoleRemoveOrgMemberModuleAccessResponses, OrgConsoleRemoveOrgMemberModuleAccessErrors, ThrowOnError> => (options.client ?? client).delete<OrgConsoleRemoveOrgMemberModuleAccessResponses, OrgConsoleRemoveOrgMemberModuleAccessErrors, ThrowOnError>({ url: '/org/{org_ref}/members/{member_id}/access/{module}', ...options });

/**
 * Update Org Member Access
 *
 * Patch ONE admin's access. Global-Admin only.
 *
 * PARTIAL and idempotent: an absent field is left alone. ``permissions`` is
 * three-valued — absent leaves the custom set, ``null`` CLEARS it (back to tier
 * defaults), a list sets it. An unknown key 422s with the offending keys and writes
 * nothing. Every change appends one access-event row.
 *
 * ``is_global_admin`` rides the organization's EXISTING role-change path, so the
 * last-Global-Admin guard still binds: you may demote yourself, but not the last
 * one. Revoking an admin's LAST module is refused (422) — see
 * ``OrgLastModuleRevokeException``.
 */
export const orgConsoleUpdateOrgMemberAccess = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleUpdateOrgMemberAccessData, ThrowOnError>): RequestResult<OrgConsoleUpdateOrgMemberAccessResponses, OrgConsoleUpdateOrgMemberAccessErrors, ThrowOnError> => (options.client ?? client).put<OrgConsoleUpdateOrgMemberAccessResponses, OrgConsoleUpdateOrgMemberAccessErrors, ThrowOnError>({
    url: '/org/{org_ref}/members/{target_user_id}/access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Org Member Role
 *
 * OM-57 (D-CPO-64) — change ONE admin's role with a choice, nothing pre-checked:
 * `{"role": "Owner"}` makes them a Global Admin (no `modules`); `{"role": "Member",
 * "modules": [{"module", "role"}]}` makes a Global Admin a regular admin holding exactly
 * those apps, at least one, with nothing kept implicitly. Refused with `ROLE_CHANGE_*` 422s
 * before any write; a target already a regular admin is a 409 unless this is a retry.
 *
 * Global-Admin only. The access PUT's `is_global_admin` keeps today's behaviour through the
 * window; a screen that sends a choice calls THIS route, which an old backend answers with
 * the route miss, so it changes nothing. Employer Portal's
 * `POST /admin/company/admins/{target_user_id}/role-change` is the same writer.
 */
export const orgConsoleChangeOrgMemberRole = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleChangeOrgMemberRoleData, ThrowOnError>): RequestResult<OrgConsoleChangeOrgMemberRoleResponses, OrgConsoleChangeOrgMemberRoleErrors, ThrowOnError> => (options.client ?? client).post<OrgConsoleChangeOrgMemberRoleResponses, OrgConsoleChangeOrgMemberRoleErrors, ThrowOnError>({
    url: '/org/{org_ref}/members/{target_user_id}/role-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org Module Terms
 *
 * The CURRENT instrument one module carries for this organization's class,
 * plus whether the organization has accepted it — the Turn On modal's read.
 *
 * `accepted` is a standing acceptance of ANY version, which is exactly the
 * switch's predicate: a newer effective version never re-arms it and never turns
 * a live module off (OQ5) — versions ride the main Terms' publish-and-notice
 * rail, so there is nothing here to nag about. 404 — the console's own,
 * byte-identical to a route miss — when the pair binds no instrument (every
 * pair at birth) or none is effective.
 */
export const orgConsoleGetOrgModuleTerms = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleGetOrgModuleTermsData, ThrowOnError>): RequestResult<OrgConsoleGetOrgModuleTermsResponses, OrgConsoleGetOrgModuleTermsErrors, ThrowOnError> => (options.client ?? client).get<OrgConsoleGetOrgModuleTermsResponses, OrgConsoleGetOrgModuleTermsErrors, ThrowOnError>({ url: '/org/{org_ref}/modules/{module}/terms', ...options });

/**
 * Accept Org Module Terms
 *
 * Accept the module's instrument on the ORGANIZATION's behalf — the step
 * between Turn On and the switch write.
 *
 * `WRITE_SETTINGS`, the switch's tier: only a Global Admin turns a module on, so
 * only a Global Admin accepts, as the organization's agent — ONCE; admins added
 * to the module later do not re-accept, and there are no per-person rows. The
 * acting user and the instant are server-side; the body carries only the hash of
 * the copy the modal displayed, and a stale one is refused (409) so outdated
 * text can never bind the organization. Idempotent at the current version.
 * After a 200 the settings write's `enabled: true` (or the hook's start) is
 * admitted for this module.
 */
export const orgConsoleAcceptOrgModuleTerms = <ThrowOnError extends boolean = false>(options: Options<OrgConsoleAcceptOrgModuleTermsData, ThrowOnError>): RequestResult<OrgConsoleAcceptOrgModuleTermsResponses, OrgConsoleAcceptOrgModuleTermsErrors, ThrowOnError> => (options.client ?? client).post<OrgConsoleAcceptOrgModuleTermsResponses, OrgConsoleAcceptOrgModuleTermsErrors, ThrowOnError>({
    url: '/org/{org_ref}/modules/{module}/terms/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org Money Floors
 *
 * The organization's floors on one money surface: what it set, what binds now, and
 * what its agents used of each period floor. For a person who may set them.
 */
export const orgConfirmationRequestsGetOrgMoneyFloors = <ThrowOnError extends boolean = false>(options: Options<OrgConfirmationRequestsGetOrgMoneyFloorsData, ThrowOnError>): RequestResult<OrgConfirmationRequestsGetOrgMoneyFloorsResponses, OrgConfirmationRequestsGetOrgMoneyFloorsErrors, ThrowOnError> => (options.client ?? client).get<OrgConfirmationRequestsGetOrgMoneyFloorsResponses, OrgConfirmationRequestsGetOrgMoneyFloorsErrors, ThrowOnError>({ url: '/org/{org_ref}/money-floors/{surface}', ...options });

/**
 * Save Org Money Floor
 *
 * A person's direct save of one floor. A save that loosens it needs a sign-in within
 * the floor-loosening window (``step_up_required``); one that only narrows needs none; a
 * stale ``expected_version`` is the 409.
 */
export const orgConfirmationRequestsSaveOrgMoneyFloor = <ThrowOnError extends boolean = false>(options: Options<OrgConfirmationRequestsSaveOrgMoneyFloorData, ThrowOnError>): RequestResult<OrgConfirmationRequestsSaveOrgMoneyFloorResponses, OrgConfirmationRequestsSaveOrgMoneyFloorErrors, ThrowOnError> => (options.client ?? client).put<OrgConfirmationRequestsSaveOrgMoneyFloorResponses, OrgConfirmationRequestsSaveOrgMoneyFloorErrors, ThrowOnError>({
    url: '/org/{org_ref}/money-floors/{surface}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Use Org Collateral Item As Social Image
 *
 * Make a Collateral image a Social post's image, copied server-side through Social's own
 * upload (Social available, the person's publish string, the image's checks); answers the
 * image as the composer's own upload does.
 */
export const orgBrandUseOrgCollateralItemAsSocialImage = <ThrowOnError extends boolean = false>(options: Options<OrgBrandUseOrgCollateralItemAsSocialImageData, ThrowOnError>): RequestResult<OrgBrandUseOrgCollateralItemAsSocialImageResponses, OrgBrandUseOrgCollateralItemAsSocialImageErrors, ThrowOnError> => (options.client ?? client).post<OrgBrandUseOrgCollateralItemAsSocialImageResponses, OrgBrandUseOrgCollateralItemAsSocialImageErrors, ThrowOnError>({ url: '/org/{org_ref}/profile/collateral/{item_id}/social-image', ...options });

/**
 * Get Org Qr Design
 *
 * The organization's default QR design — the one design every QR it generates
 * renders in — with whether the organization has a stored logo a design may
 * choose. Any administrator may read it.
 */
export const orgQrDesignGetOrgQrDesign = <ThrowOnError extends boolean = false>(options: Options<OrgQrDesignGetOrgQrDesignData, ThrowOnError>): RequestResult<OrgQrDesignGetOrgQrDesignResponses, OrgQrDesignGetOrgQrDesignErrors, ThrowOnError> => (options.client ?? client).get<OrgQrDesignGetOrgQrDesignResponses, OrgQrDesignGetOrgQrDesignErrors, ThrowOnError>({ url: '/org/{org_ref}/qr-design', ...options });

/**
 * Update Org Qr Design
 *
 * Save the organization's ONE default QR design (the body is the design). An
 * unscannable design is the validator's 422. For a company this is the same design
 * the Givmo apps edit for it.
 */
export const orgQrDesignUpdateOrgQrDesign = <ThrowOnError extends boolean = false>(options: Options<OrgQrDesignUpdateOrgQrDesignData, ThrowOnError>): RequestResult<OrgQrDesignUpdateOrgQrDesignResponses, OrgQrDesignUpdateOrgQrDesignErrors, ThrowOnError> => (options.client ?? client).put<OrgQrDesignUpdateOrgQrDesignResponses, OrgQrDesignUpdateOrgQrDesignErrors, ThrowOnError>({
    url: '/org/{org_ref}/qr-design',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Render Org Public Qr
 *
 * The organization's public QR in its saved default design. A charity's encodes
 * its canonical link to its public page; a company's is its giving-link QR. This
 * GET is write-class: the first render may allocate that one target (the redirect
 * record, or the company's giving link), a bounded and idempotent write.
 */
export const orgQrDesignRenderOrgPublicQr = <ThrowOnError extends boolean = false>(options: Options<OrgQrDesignRenderOrgPublicQrData, ThrowOnError>): RequestResult<OrgQrDesignRenderOrgPublicQrResponses, OrgQrDesignRenderOrgPublicQrErrors, ThrowOnError> => (options.client ?? client).get<OrgQrDesignRenderOrgPublicQrResponses, OrgQrDesignRenderOrgPublicQrErrors, ThrowOnError>({ url: '/org/{org_ref}/qr-design/public-qr', ...options });

/**
 * Render Supplied Org Public Qr
 *
 * The organization's public QR in a SUPPLIED design — the editor's preview and
 * its download-without-saving. Saves no design, but is write-class like the saved
 * render: it may make the same bounded, idempotent allocation.
 */
export const orgQrDesignRenderSuppliedOrgPublicQr = <ThrowOnError extends boolean = false>(options: Options<OrgQrDesignRenderSuppliedOrgPublicQrData, ThrowOnError>): RequestResult<OrgQrDesignRenderSuppliedOrgPublicQrResponses, OrgQrDesignRenderSuppliedOrgPublicQrErrors, ThrowOnError> => (options.client ?? client).post<OrgQrDesignRenderSuppliedOrgPublicQrResponses, OrgQrDesignRenderSuppliedOrgPublicQrErrors, ThrowOnError>({
    url: '/org/{org_ref}/qr-design/public-qr',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Org Social Image
 *
 * One image (JPEG, PNG or WebP, up to 8 MB), made the post's canonical JPEG.
 */
export const orgSocialUploadOrgSocialImage = <ThrowOnError extends boolean = false>(options: Options<OrgSocialUploadOrgSocialImageData, ThrowOnError>): RequestResult<OrgSocialUploadOrgSocialImageResponses, OrgSocialUploadOrgSocialImageErrors, ThrowOnError> => (options.client ?? client).post<OrgSocialUploadOrgSocialImageResponses, OrgSocialUploadOrgSocialImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/org/{org_ref}/social/media',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Org Social Posts
 *
 * The organization's Social posts, newest first, in the canonical `{data, meta, links}`
 * envelope (`page[limit]` / `page[offset]`). Members read.
 */
export const orgSocialListOrgSocialPosts = <ThrowOnError extends boolean = false>(options: Options<OrgSocialListOrgSocialPostsData, ThrowOnError>): RequestResult<OrgSocialListOrgSocialPostsResponses, OrgSocialListOrgSocialPostsErrors, ThrowOnError> => (options.client ?? client).get<OrgSocialListOrgSocialPostsResponses, OrgSocialListOrgSocialPostsErrors, ThrowOnError>({ url: '/org/{org_ref}/social/posts', ...options });

/**
 * Create Org Social Post
 *
 * A new draft: one variant per chosen account, each with its platform's text.
 */
export const orgSocialCreateOrgSocialPost = <ThrowOnError extends boolean = false>(options: Options<OrgSocialCreateOrgSocialPostData, ThrowOnError>): RequestResult<OrgSocialCreateOrgSocialPostResponses, OrgSocialCreateOrgSocialPostErrors, ThrowOnError> => (options.client ?? client).post<OrgSocialCreateOrgSocialPostResponses, OrgSocialCreateOrgSocialPostErrors, ThrowOnError>({
    url: '/org/{org_ref}/social/posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Org Social Post
 *
 * A post nothing of which went out.
 */
export const orgSocialDeleteOrgSocialPost = <ThrowOnError extends boolean = false>(options: Options<OrgSocialDeleteOrgSocialPostData, ThrowOnError>): RequestResult<OrgSocialDeleteOrgSocialPostResponses, OrgSocialDeleteOrgSocialPostErrors, ThrowOnError> => (options.client ?? client).delete<OrgSocialDeleteOrgSocialPostResponses, OrgSocialDeleteOrgSocialPostErrors, ThrowOnError>({ url: '/org/{org_ref}/social/posts/{post_id}', ...options });

/**
 * Get Org Social Post
 */
export const orgSocialGetOrgSocialPost = <ThrowOnError extends boolean = false>(options: Options<OrgSocialGetOrgSocialPostData, ThrowOnError>): RequestResult<OrgSocialGetOrgSocialPostResponses, OrgSocialGetOrgSocialPostErrors, ThrowOnError> => (options.client ?? client).get<OrgSocialGetOrgSocialPostResponses, OrgSocialGetOrgSocialPostErrors, ThrowOnError>({ url: '/org/{org_ref}/social/posts/{post_id}', ...options });

/**
 * Update Org Social Post
 *
 * A draft, rewritten as a whole (only while every variant is a draft).
 */
export const orgSocialUpdateOrgSocialPost = <ThrowOnError extends boolean = false>(options: Options<OrgSocialUpdateOrgSocialPostData, ThrowOnError>): RequestResult<OrgSocialUpdateOrgSocialPostResponses, OrgSocialUpdateOrgSocialPostErrors, ThrowOnError> => (options.client ?? client).put<OrgSocialUpdateOrgSocialPostResponses, OrgSocialUpdateOrgSocialPostErrors, ThrowOnError>({
    url: '/org/{org_ref}/social/posts/{post_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Org Social Post
 *
 * Every still-queued variant back to draft; what is already going or gone stays.
 */
export const orgSocialCancelOrgSocialPost = <ThrowOnError extends boolean = false>(options: Options<OrgSocialCancelOrgSocialPostData, ThrowOnError>): RequestResult<OrgSocialCancelOrgSocialPostResponses, OrgSocialCancelOrgSocialPostErrors, ThrowOnError> => (options.client ?? client).post<OrgSocialCancelOrgSocialPostResponses, OrgSocialCancelOrgSocialPostErrors, ThrowOnError>({ url: '/org/{org_ref}/social/posts/{post_id}/cancel', ...options });

/**
 * Publish Org Social Post
 *
 * Queue every draft variant: now, or at ``scheduled_at``.
 */
export const orgSocialPublishOrgSocialPost = <ThrowOnError extends boolean = false>(options: Options<OrgSocialPublishOrgSocialPostData, ThrowOnError>): RequestResult<OrgSocialPublishOrgSocialPostResponses, OrgSocialPublishOrgSocialPostErrors, ThrowOnError> => (options.client ?? client).post<OrgSocialPublishOrgSocialPostResponses, OrgSocialPublishOrgSocialPostErrors, ThrowOnError>({
    url: '/org/{org_ref}/social/posts/{post_id}/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retry Org Social Variant
 *
 * Send a failed variant again, now (the only path that does).
 */
export const orgSocialRetryOrgSocialVariant = <ThrowOnError extends boolean = false>(options: Options<OrgSocialRetryOrgSocialVariantData, ThrowOnError>): RequestResult<OrgSocialRetryOrgSocialVariantResponses, OrgSocialRetryOrgSocialVariantErrors, ThrowOnError> => (options.client ?? client).post<OrgSocialRetryOrgSocialVariantResponses, OrgSocialRetryOrgSocialVariantErrors, ThrowOnError>({ url: '/org/{org_ref}/social/variants/{variant_id}/retry', ...options });

/**
 * Create Pledge Campaign
 *
 * Create a pledge-per-unit campaign on a fundraiser the caller organizes (02 §4.1):
 * its owner-agnostic organizer rank, whoever owns it (a person, a group, a company or
 * a charity). ``attested`` mode only at v1 (oracle is Phase 4). One campaign per
 * fundraiser. A fundraiser the caller does not organize, or an absent one → 404
 * (non-enumeration); a duplicate campaign or an oracle-mode request → 400.
 */
export const pledgesCreatePledgeCampaign = <ThrowOnError extends boolean = false>(options: Options<PledgesCreatePledgeCampaignData, ThrowOnError>): RequestResult<PledgesCreatePledgeCampaignResponses, PledgesCreatePledgeCampaignErrors, ThrowOnError> => (options.client ?? client).post<PledgesCreatePledgeCampaignResponses, PledgesCreatePledgeCampaignErrors, ThrowOnError>({
    url: '/pledge-campaigns',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Pledge Campaign
 *
 * Public campaign-page read (02 §4.1 — the campaign page is public). The
 * presented user, if any, decides only whether a members-only group's campaign
 * shows: to a non-member or an anonymous caller it is the same 404 as a missing
 * campaign. A miss → 404. Dark behind the flag.
 */
export const pledgesGetPledgeCampaign = <ThrowOnError extends boolean = false>(options: Options<PledgesGetPledgeCampaignData, ThrowOnError>): RequestResult<PledgesGetPledgeCampaignResponses, PledgesGetPledgeCampaignErrors, ThrowOnError> => (options.client ?? client).get<PledgesGetPledgeCampaignResponses, PledgesGetPledgeCampaignErrors, ThrowOnError>({ url: '/pledge-campaigns/{campaign_id}', ...options });

/**
 * Submit Attestation
 *
 * Submit a result value for a campaign (02 §4.4). The organizer (or a
 * participant self-entry) records ``submitted_units``; the value lands on an
 * append-only audit row and moves the campaign OPEN → PROVISIONAL (or →
 * NEEDS_REVIEW on a tripped outlier). It NEVER locks or charges — organizer
 * ACCEPTANCE is the write-once lock trigger. Organizer-only (the fundraiser's
 * owner-agnostic organizer rank); a campaign the caller does not organize, or an
 * absent one → 404; a wrong-state campaign → 409.
 * ``Idempotency-Key`` REQUIRED (fail-closed 422).
 */
export const pledgesSubmitAttestation = <ThrowOnError extends boolean = false>(options: Options<PledgesSubmitAttestationData, ThrowOnError>): RequestResult<PledgesSubmitAttestationResponses, PledgesSubmitAttestationErrors, ThrowOnError> => (options.client ?? client).post<PledgesSubmitAttestationResponses, PledgesSubmitAttestationErrors, ThrowOnError>({
    url: '/pledge-campaigns/{campaign_id}/attestation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Attestation
 *
 * Organizer ACCEPTANCE — the write-once permanent lock (02 §4.4 / D-PV-1
 * §3.3 c.6). The organizer accepts ``submitted_units`` as the final result: zero
 * tripped outlier flags → LOCKED (``final_units`` + ``locked_at`` +
 * ``attestor_user_id`` stamped write-once; the 48h notice/objection clock
 * starts); any trip → NEEDS_REVIEW (the lock is BLOCKED — only the audited
 * adjudication exits it → 409). Organizer-only; a campaign the caller does not
 * organize, or an absent one → 404; an already-locked / wrong-state campaign → 409. ``Idempotency-Key``
 * REQUIRED (fail-closed 422).
 */
export const pledgesAcceptAttestation = <ThrowOnError extends boolean = false>(options: Options<PledgesAcceptAttestationData, ThrowOnError>): RequestResult<PledgesAcceptAttestationResponses, PledgesAcceptAttestationErrors, ThrowOnError> => (options.client ?? client).post<PledgesAcceptAttestationResponses, PledgesAcceptAttestationErrors, ThrowOnError>({
    url: '/pledge-campaigns/{campaign_id}/attestation/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Pledge
 *
 * Create a unit pledge WITH atomic consent capture (02 §4.2 / the signed
 * consent artifact). A pledge is STRUCTURALLY impossible without a pinned consent
 * record: the SAME UoW writes ``pledge_consent_record`` + the ``unit_pledge``
 * (``consent_record_id`` FK). Card funding establishes the stored credential via
 * the existing card-save tokenization (NO charge at card-save); wallet funding
 * (sub-flag-gated) mints the cap-amount hold. A consent copy not-yet-LIVE → 409
 * ``CONSENT_UNAVAILABLE``; wallet funding while the sub-flag is off → 409
 * ``WALLET_FUNDING_DISABLED``; pledging closed here (the campaign, its window or its
 * fundraiser takes no new pledge) → 409 ``PLEDGING_CLOSED``; the fundraiser's
 * recipients changed since the client read them, or differ from the optional
 * ``displayed_recipients`` it showed the pledgor → 409 ``PLEDGE_RECIPIENTS_CHANGED``
 * (refetch, show them again, then retry). ``Idempotency-Key`` REQUIRED (fail-closed
 * 422).
 *
 * GFU-BE24 (dark behind ``PLEDGE_APPLE_PAY_ENABLED``): ``card_kind`` ``apple_pay`` with
 * the token from Apple's deferred sheet at $0 today
 * (``alternative_payment_method_token``) funds a card pledge by Apple Pay. A request
 * whose parts disagree → 400; the sub-flag off → 409 ``APPLE_PAY_FUNDING_DISABLED``; a
 * card not from a $0 deferred sheet with a merchant token → 400
 * ``APPLE_PAY_CARD_UNSUPPORTED``; a card that fails its $0 check → 409
 * ``PLEDGE_ESTABLISHMENT_FAILED``. The answer's ``card_kind`` says which kind of card
 * funds the pledge.
 */
export const pledgesCreatePledge = <ThrowOnError extends boolean = false>(options: Options<PledgesCreatePledgeData, ThrowOnError>): RequestResult<PledgesCreatePledgeResponses, PledgesCreatePledgeErrors, ThrowOnError> => (options.client ?? client).post<PledgesCreatePledgeResponses, PledgesCreatePledgeErrors, ThrowOnError>({
    url: '/pledge-campaigns/{campaign_id}/pledges',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Pledge Projected Total
 *
 * ORGANIZER-ONLY projected-total read for the mandatory pre-lock review
 * screen (PV3-BE10 / UX review #5): "locking at N units charges M pledgors up to
 * $X total". Given a hypothetical ``units`` result the organizer is about to
 * lock, returns the campaign-wide charge projection — ``pledge_count``
 * settle-eligible (``active``/``failed``) pledges, ``projected_total_cents`` =
 * ``Σ min(units × rate, cap)``, and ``cap_total_cents`` = ``Σ cap`` — all EXACT
 * integer cents from a pure SQL SUM. ``units`` is a REQUIRED, non-negative query
 * param (mirroring the attestation ``submitted_units`` bound; missing / negative
 * → 422).
 *
 * Organizer ONLY (the SAME 404-collapsing rail the attestation accept endpoint
 * uses): a pledgor / guest / any non-organizer gets 404, and there is NO
 * public route — a campaign-wide dollar projection is the "betting-board"
 * artifact the no-betting posture forbids on any public/pledgor surface (UX
 * review #2). Dark behind the flag (the route-level ``_require_pledges_enabled``
 * dependency 404s a flag-off call before the ``units`` validation can leak the
 * route).
 */
export const pledgesGetPledgeProjectedTotal = <ThrowOnError extends boolean = false>(options: Options<PledgesGetPledgeProjectedTotalData, ThrowOnError>): RequestResult<PledgesGetPledgeProjectedTotalResponses, PledgesGetPledgeProjectedTotalErrors, ThrowOnError> => (options.client ?? client).get<PledgesGetPledgeProjectedTotalResponses, PledgesGetPledgeProjectedTotalErrors, ThrowOnError>({ url: '/pledge-campaigns/{campaign_id}/projected-total', ...options });

/**
 * Preview Pledge Offer Rule
 *
 * Preview the sentence a pledge would be shown (plan §1.5a; D-GFU-46): for the body ``POST
 * /pledge-offers`` would take, the rule sentence (composed at ``rate_cents``, else the offer's
 * suggested or fixed rate; null with neither, when ``rule_sentence_rate_free`` carries its
 * rate-free form instead, GFU-BE103), the precision line and the unit's plural, exactly
 * as the offer would serve them and every pledge on it would pin them. Nothing is written. The
 * caller organizes the fundraisers at their OWNER rank, and the body is asked what the create
 * asks of it: a new measure's settings and words (a betting, health or candidate word, a
 * phrase naming an amount, health-type data, a fundraiser that already has a measure → 400;
 * a ``stat_key`` → 400 ``PLEDGE_STAT_KEY_REFUSED``), an existing measure the fundraiser may
 * read (404, 409, 400 as on the create), and terms that settle (400), a rate no more than the
 * cap among them (400 ``PLEDGE_RATE_ABOVE_CAP``, as on the create). Also the source line a
 * pledge on it would be shown and pin, for every kind of measure (``source_line``, null where
 * none can be composed), and on a total of other counts how many it adds up now
 * (``rollup_part_count``); a new total is asked what its create asks. Signed in; dark behind
 * the flag.
 */
export const pledgesPreviewPledgeOfferRule = <ThrowOnError extends boolean = false>(options: Options<PledgesPreviewPledgeOfferRuleData, ThrowOnError>): RequestResult<PledgesPreviewPledgeOfferRuleResponses, PledgesPreviewPledgeOfferRuleErrors, ThrowOnError> => (options.client ?? client).post<PledgesPreviewPledgeOfferRuleResponses, PledgesPreviewPledgeOfferRuleErrors, ThrowOnError>({
    url: '/pledge-offers/rule-sentence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Pledge Offer
 *
 * One pledge offer, public (plan §1.5): its terms, its window and status, the measures it
 * reads, and ``viewer_is_organizer``. ``measure_shown`` false means it is not pledgeable
 * here: no measure of it is served, nor its status, window, close or last update, its rule
 * sentence or precision line, and no pledge button is shown. ``rule_sentence`` is composed at
 * ``rate_cents`` when given (the pledgor's own rate, which the checkout shows and the pledge
 * create echoes), else at the offer's suggested or fixed rate (null with neither). An offer
 * whose fundraiser is missing, hidden from the caller, a draft, or not public → 404, except to
 * that fundraiser's own organizers. Anonymous or signed in; dark behind the flag.
 */
export const pledgesGetPledgeOffer = <ThrowOnError extends boolean = false>(options: Options<PledgesGetPledgeOfferData, ThrowOnError>): RequestResult<PledgesGetPledgeOfferResponses, PledgesGetPledgeOfferErrors, ThrowOnError> => (options.client ?? client).get<PledgesGetPledgeOfferResponses, PledgesGetPledgeOfferErrors, ThrowOnError>({ url: '/pledge-offers/{offer_id}', ...options });

/**
 * Get Pledges Live
 *
 * The public live read (GFU-BE19, plan §1.4): for each fundraiser named (1 to 25; a page
 * and the pages on its board), its pledge offers' live PLEDGED figures — what their pledges
 * would be charged at the count they read, each capped, never money raised — and the counts
 * of the measures they read, unofficial until locked. A measure the page owns (a game's
 * scoreboard) also carries its crowd: every offer counting on it across the pages its public
 * total counts. A condition not yet decided shows what its pledges give if it holds, and
 * joins no sum. A fundraiser that is missing, not public, or not visible to the caller is
 * absent from ``data``; one whose "Show dollars raised" is off shows no dollar figure. Served
 * from a short-lived cache, a few seconds old at most. Anonymous or signed in; dark behind
 * the flag.
 */
export const pledgesGetPledgesLive = <ThrowOnError extends boolean = false>(options: Options<PledgesGetPledgesLiveData, ThrowOnError>): RequestResult<PledgesGetPledgesLiveResponses, PledgesGetPledgesLiveErrors, ThrowOnError> => (options.client ?? client).get<PledgesGetPledgesLiveResponses, PledgesGetPledgesLiveErrors, ThrowOnError>({ url: '/pledges/live', ...options });

/**
 * Get Post
 *
 * A single post by id — the self-sufficient PostDetail load path.
 *
 * PostDetail is normally handed its post object through navigation (the feed
 * passes the already-loaded `DonationActivity`/`PostOut`). But a `post_liked`/
 * `post_commented` push tap on a COLD START routes to PostDetail keyed by id
 * alone, before any feed has seeded the client's post cache — so both clients
 * need a fetch-by-id fallback, and there was no endpoint to serve it (a blank
 * PostDetail screen). This is that endpoint.
 *
 * Authenticated (like the fundraiser/follows feeds). Owner-or-PUBLIC
 * visibility via the shared `_require_visible_post` gate (in the service): the
 * push recipient IS the owner, so they always get their own post (even
 * PRIVATE); a non-owner on a non-PUBLIC post gets the uniform missing-post 400
 * so a private post's existence never leaks (see `_require_visible_post` — do
 * NOT turn that into a 404).
 *
 * FOP-BE1: the wire is one feed row widened to `MyPostOut`. For the post's
 * OWNER (plain user-attributed posts only), the owner-only fields (donation_id /
 * amount / instructions / request_match / match_status / hide_name /
 * cover_fees) are stamped via the same `_stamp_owner_post_fields` hydration `GET
 * /users/me/posts` uses, so the feed's own-post tap can open the
 * donation-management view without a second endpoint. For every OTHER reader
 * the fields serialize as null — additive, information-free keys that frozen
 * feed-row decoders ignore.
 */
export const postsGetPost = <ThrowOnError extends boolean = false>(options: Options<PostsGetPostData, ThrowOnError>): RequestResult<PostsGetPostResponses, PostsGetPostErrors, ThrowOnError> => (options.client ?? client).get<PostsGetPostResponses, PostsGetPostErrors, ThrowOnError>({ url: '/posts/{post_id}', ...options });

/**
 * Comment Post
 */
export const postsCommentPost = <ThrowOnError extends boolean = false>(options: Options<PostsCommentPostData, ThrowOnError>): RequestResult<PostsCommentPostResponses, PostsCommentPostErrors, ThrowOnError> => (options.client ?? client).post<PostsCommentPostResponses, PostsCommentPostErrors, ThrowOnError>({
    url: '/posts/{post_id}/comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Post Comments
 */
export const postsGetPostComments = <ThrowOnError extends boolean = false>(options: Options<PostsGetPostCommentsData, ThrowOnError>): RequestResult<PostsGetPostCommentsResponses, PostsGetPostCommentsErrors, ThrowOnError> => (options.client ?? client).get<PostsGetPostCommentsResponses, PostsGetPostCommentsErrors, ThrowOnError>({ url: '/posts/{post_id}/comments', ...options });

/**
 * Delete Comment
 *
 * Author-delete of one's own comment (GF-BE8 / D-GF-11) → 204. Author-only:
 * a comment owned by another user → 403; a missing comment (or one not on this
 * post) → 404 with a constant detail. Post-owner deletion of OTHERS' comments
 * is deferred. Dark until the clients ship the delete-own-comment affordance.
 */
export const postsDeleteComment = <ThrowOnError extends boolean = false>(options: Options<PostsDeleteCommentData, ThrowOnError>): RequestResult<PostsDeleteCommentResponses, PostsDeleteCommentErrors, ThrowOnError> => (options.client ?? client).delete<PostsDeleteCommentResponses, PostsDeleteCommentErrors, ThrowOnError>({ url: '/posts/{post_id}/comments/{comment_id}', ...options });

/**
 * Like Comment
 */
export const postsLikeComment = <ThrowOnError extends boolean = false>(options: Options<PostsLikeCommentData, ThrowOnError>): RequestResult<PostsLikeCommentResponses, PostsLikeCommentErrors, ThrowOnError> => (options.client ?? client).post<PostsLikeCommentResponses, PostsLikeCommentErrors, ThrowOnError>({ url: '/posts/{post_id}/comments/{comment_id}/like', ...options });

/**
 * Get Comment Likes
 */
export const postsGetCommentLikes = <ThrowOnError extends boolean = false>(options: Options<PostsGetCommentLikesData, ThrowOnError>): RequestResult<PostsGetCommentLikesResponses, PostsGetCommentLikesErrors, ThrowOnError> => (options.client ?? client).get<PostsGetCommentLikesResponses, PostsGetCommentLikesErrors, ThrowOnError>({ url: '/posts/{post_id}/comments/{comment_id}/likes', ...options });

/**
 * Unlike Comment
 */
export const postsUnlikeComment = <ThrowOnError extends boolean = false>(options: Options<PostsUnlikeCommentData, ThrowOnError>): RequestResult<PostsUnlikeCommentResponses, PostsUnlikeCommentErrors, ThrowOnError> => (options.client ?? client).post<PostsUnlikeCommentResponses, PostsUnlikeCommentErrors, ThrowOnError>({ url: '/posts/{post_id}/comments/{comment_id}/unlike', ...options });

/**
 * Like Post
 */
export const postsLikePost = <ThrowOnError extends boolean = false>(options: Options<PostsLikePostData, ThrowOnError>): RequestResult<PostsLikePostResponses, PostsLikePostErrors, ThrowOnError> => (options.client ?? client).post<PostsLikePostResponses, PostsLikePostErrors, ThrowOnError>({ url: '/posts/{post_id}/like', ...options });

/**
 * Get Post Likes
 */
export const postsGetPostLikes = <ThrowOnError extends boolean = false>(options: Options<PostsGetPostLikesData, ThrowOnError>): RequestResult<PostsGetPostLikesResponses, PostsGetPostLikesErrors, ThrowOnError> => (options.client ?? client).get<PostsGetPostLikesResponses, PostsGetPostLikesErrors, ThrowOnError>({ url: '/posts/{post_id}/likes', ...options });

/**
 * Update Post Message
 */
export const postsUpdatePostMessage = <ThrowOnError extends boolean = false>(options: Options<PostsUpdatePostMessageData, ThrowOnError>): RequestResult<PostsUpdatePostMessageResponses, PostsUpdatePostMessageErrors, ThrowOnError> => (options.client ?? client).put<PostsUpdatePostMessageResponses, PostsUpdatePostMessageErrors, ThrowOnError>({
    url: '/posts/{post_id}/message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Report Post
 *
 * Report a post (GF-BE6 / D-GF-9 — the in-app "Report post" control required
 * by Apple Guideline 1.2, mirroring the assistant AI-content report endpoint).
 * Auth required; append-only (a repeat report inserts another row). Body
 * `{category, comment?}`: an off-set `category` / a `comment` over 500 chars /
 * an unknown field → 422 at the schema layer (`PostReportIn`). A missing post →
 * 404 with a constant detail (`ReportPostNotFoundException`, no id echo). Dark
 * until the clients ship the Report action.
 */
export const postsReportPost = <ThrowOnError extends boolean = false>(options: Options<PostsReportPostData, ThrowOnError>): RequestResult<PostsReportPostResponses, PostsReportPostErrors, ThrowOnError> => (options.client ?? client).post<PostsReportPostResponses, PostsReportPostErrors, ThrowOnError>({
    url: '/posts/{post_id}/report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unlike Post
 */
export const postsUnlikePost = <ThrowOnError extends boolean = false>(options: Options<PostsUnlikePostData, ThrowOnError>): RequestResult<PostsUnlikePostResponses, PostsUnlikePostErrors, ThrowOnError> => (options.client ?? client).post<PostsUnlikePostResponses, PostsUnlikePostErrors, ThrowOnError>({ url: '/posts/{post_id}/unlike', ...options });

/**
 * Update Post Visibility
 */
export const postsUpdatePostVisibility = <ThrowOnError extends boolean = false>(options: Options<PostsUpdatePostVisibilityData, ThrowOnError>): RequestResult<PostsUpdatePostVisibilityResponses, PostsUpdatePostVisibilityErrors, ThrowOnError> => (options.client ?? client).put<PostsUpdatePostVisibilityResponses, PostsUpdatePostVisibilityErrors, ThrowOnError>({
    url: '/posts/{post_id}/visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Report Profile Block
 *
 * Report one page block (the ``profile_block`` subject type). Auth required;
 * append-only. Body ``{category, comment?}`` validated at the schema layer; a
 * missing block → 404 with a constant detail.
 */
export const profileReportsReportProfileBlock = <ThrowOnError extends boolean = false>(options: Options<ProfileReportsReportProfileBlockData, ThrowOnError>): RequestResult<ProfileReportsReportProfileBlockResponses, ProfileReportsReportProfileBlockErrors, ThrowOnError> => (options.client ?? client).post<ProfileReportsReportProfileBlockResponses, ProfileReportsReportProfileBlockErrors, ThrowOnError>({
    url: '/profile-blocks/{block_id}/report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Consumer Page
 *
 * The OWNER view of a user's (self) or a group's (OWNER/ADMIN) page.
 */
export const profilePagesGetConsumerPage = <ThrowOnError extends boolean = false>(options: Options<ProfilePagesGetConsumerPageData, ThrowOnError>): RequestResult<ProfilePagesGetConsumerPageResponses, ProfilePagesGetConsumerPageErrors, ThrowOnError> => (options.client ?? client).get<ProfilePagesGetConsumerPageResponses, ProfilePagesGetConsumerPageErrors, ThrowOnError>({ url: '/profiles/{entity_type}/{entity_id}/page', ...options });

/**
 * Replace Consumer Page
 *
 * The id-preserving full-list replace for a user (self) or a group (OWNER/ADMIN).
 */
export const profilePagesReplaceConsumerPage = <ThrowOnError extends boolean = false>(options: Options<ProfilePagesReplaceConsumerPageData, ThrowOnError>): RequestResult<ProfilePagesReplaceConsumerPageResponses, ProfilePagesReplaceConsumerPageErrors, ThrowOnError> => (options.client ?? client).put<ProfilePagesReplaceConsumerPageResponses, ProfilePagesReplaceConsumerPageErrors, ThrowOnError>({
    url: '/profiles/{entity_type}/{entity_id}/page',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Consumer Page Image
 *
 * Upload one page image under ``user/{id}/page/…`` / ``group/{id}/page/…``.
 */
export const profilePagesUploadConsumerPageImage = <ThrowOnError extends boolean = false>(options: Options<ProfilePagesUploadConsumerPageImageData, ThrowOnError>): RequestResult<ProfilePagesUploadConsumerPageImageResponses, ProfilePagesUploadConsumerPageImageErrors, ThrowOnError> => (options.client ?? client).post<ProfilePagesUploadConsumerPageImageResponses, ProfilePagesUploadConsumerPageImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/profiles/{entity_type}/{entity_id}/page/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Create Unauthenticated Donation
 */
export const donationsCreateUnauthenticatedDonation = <ThrowOnError extends boolean = false>(options: Options<DonationsCreateUnauthenticatedDonationData, ThrowOnError>): RequestResult<DonationsCreateUnauthenticatedDonationResponses, DonationsCreateUnauthenticatedDonationErrors, ThrowOnError> => (options.client ?? client).post<DonationsCreateUnauthenticatedDonationResponses, DonationsCreateUnauthenticatedDonationErrors, ThrowOnError>({
    url: '/public/charities/{charity_id}/donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Unauthenticated Charity Collection Donation
 *
 * Public/anonymous Collection donation (App Check still applies; per-IP
 * rate-limited in the service). The collection must be PUBLIC/UNLISTED +
 * ACTIVE (the service 404s otherwise). Same mandatory grant-dispatch loop as
 * the authed route, WITHOUT `user`.
 */
export const charityCollectionsCreateUnauthenticatedCharityCollectionDonation = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsCreateUnauthenticatedCharityCollectionDonationData, ThrowOnError>): RequestResult<CharityCollectionsCreateUnauthenticatedCharityCollectionDonationResponses, CharityCollectionsCreateUnauthenticatedCharityCollectionDonationErrors, ThrowOnError> => (options.client ?? client).post<CharityCollectionsCreateUnauthenticatedCharityCollectionDonationResponses, CharityCollectionsCreateUnauthenticatedCharityCollectionDonationErrors, ThrowOnError>({
    url: '/public/charity-collections/{collection_id}/donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve Donation Link
 *
 * What the donate site's landing shows for an AI's donation link (MCP-A29b, Route
 * A, D-MCP-51), WITHOUT consuming it: the target, the amount the intent fixed, when the
 * link stops working, and "Giving as First L." with the account's photo. Never an
 * email, a full last name, an account id or a profile link.
 *
 * ANONYMOUS and App-Check-gated (``/public`` is a Firebase-path prefix, so
 * ``handler_middleware`` verifies App Check in staging and prod), per-IP limited, and a
 * consumer-serving surface, so the charity read applies the Hawaii name rule and the
 * terminal-removal exclusion. Every failure is the ONE 404
 * (``DonationLinkUnavailableException``): an unknown, used or expired token, a token not
 * minted for a consumer MCP intent (a partner widget's never resolves here), a closed
 * intent, a gone account, or a target this request may not show or pay.
 */
export const donationsResolveDonationLink = <ThrowOnError extends boolean = false>(options: Options<DonationsResolveDonationLinkData, ThrowOnError>): RequestResult<DonationsResolveDonationLinkResponses, DonationsResolveDonationLinkErrors, ThrowOnError> => (options.client ?? client).post<DonationsResolveDonationLinkResponses, DonationsResolveDonationLinkErrors, ThrowOnError>({
    url: '/public/donation-links/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Unauthenticated Etf Donation
 */
export const donationsCreateUnauthenticatedEtfDonation = <ThrowOnError extends boolean = false>(options: Options<DonationsCreateUnauthenticatedEtfDonationData, ThrowOnError>): RequestResult<DonationsCreateUnauthenticatedEtfDonationResponses, DonationsCreateUnauthenticatedEtfDonationErrors, ThrowOnError> => (options.client ?? client).post<DonationsCreateUnauthenticatedEtfDonationResponses, DonationsCreateUnauthenticatedEtfDonationErrors, ThrowOnError>({
    url: '/public/etfs/{etf_id}/donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Telemetry Event
 */
export const telemetryEventsRecordTelemetryEvent = <ThrowOnError extends boolean = false>(options: Options<TelemetryEventsRecordTelemetryEventData, ThrowOnError>): RequestResult<TelemetryEventsRecordTelemetryEventResponses, TelemetryEventsRecordTelemetryEventErrors, ThrowOnError> => (options.client ?? client).post<TelemetryEventsRecordTelemetryEventResponses, TelemetryEventsRecordTelemetryEventErrors, ThrowOnError>({
    url: '/public/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Unauthenticated Fundraiser Donation
 */
export const donationsCreateUnauthenticatedFundraiserDonation = <ThrowOnError extends boolean = false>(options: Options<DonationsCreateUnauthenticatedFundraiserDonationData, ThrowOnError>): RequestResult<DonationsCreateUnauthenticatedFundraiserDonationResponses, DonationsCreateUnauthenticatedFundraiserDonationErrors, ThrowOnError> => (options.client ?? client).post<DonationsCreateUnauthenticatedFundraiserDonationResponses, DonationsCreateUnauthenticatedFundraiserDonationErrors, ThrowOnError>({
    url: '/public/fundraisers/{fundraiser_id}/donations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Purchase Gift Card
 *
 * Public purchase with new money — no account required; App Check is
 * the trust boundary (staging/prod). The charge is the gross (face +
 * mandatory cover-fees gross-up); the response NEVER carries the
 * plaintext code, so the idempotent replay of a duplicate
 * purchase_request_id is safe.
 */
export const giftCardsPurchaseGiftCard = <ThrowOnError extends boolean = false>(options: Options<GiftCardsPurchaseGiftCardData, ThrowOnError>): RequestResult<GiftCardsPurchaseGiftCardResponses, GiftCardsPurchaseGiftCardErrors, ThrowOnError> => (options.client ?? client).post<GiftCardsPurchaseGiftCardResponses, GiftCardsPurchaseGiftCardErrors, ThrowOnError>({
    url: '/public/gift-cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Organizer Message Unsubscribe
 *
 * The unsubscribe page's data: the fundraiser's name, and which stops hold.
 */
export const organizerMessagesGetOrganizerMessageUnsubscribe = <ThrowOnError extends boolean = false>(options: Options<OrganizerMessagesGetOrganizerMessageUnsubscribeData, ThrowOnError>): RequestResult<OrganizerMessagesGetOrganizerMessageUnsubscribeResponses, OrganizerMessagesGetOrganizerMessageUnsubscribeErrors, ThrowOnError> => (options.client ?? client).get<OrganizerMessagesGetOrganizerMessageUnsubscribeResponses, OrganizerMessagesGetOrganizerMessageUnsubscribeErrors, ThrowOnError>({ url: '/public/organizer-messages/unsubscribe/{token}', ...options });

/**
 * Post Organizer Message Unsubscribe
 *
 * Apply one stop. JSON from the page names it; a mail provider's one-click form POST
 * applies "Stop messages from this fundraiser".
 */
export const organizerMessagesPostOrganizerMessageUnsubscribe = <ThrowOnError extends boolean = false>(options: Options<OrganizerMessagesPostOrganizerMessageUnsubscribeData, ThrowOnError>): RequestResult<OrganizerMessagesPostOrganizerMessageUnsubscribeResponses, OrganizerMessagesPostOrganizerMessageUnsubscribeErrors, ThrowOnError> => (options.client ?? client).post<OrganizerMessagesPostOrganizerMessageUnsubscribeResponses, OrganizerMessagesPostOrganizerMessageUnsubscribeErrors, ThrowOnError>({ url: '/public/organizer-messages/unsubscribe/{token}', ...options });

/**
 * Get Payments Config
 *
 * Public, App-Check-gated payments config for client wallet rendering (F5).
 *
 * Returns the active processor + the PUBLIC Shift4 publishable key + the
 * Apple/Google Pay ids every client needs to render the wallet buttons.
 * Deliberately PUBLIC: the payload is non-secret and per-environment (not
 * per-user), so it carries NO Firebase auth — donate-web sends no ID token at
 * all. It still runs through ``handler_middleware`` (mounted as a plain
 * ``/public*`` route, not in ``_NON_FIREBASE_PREFIXES``), so App Check still
 * applies in staging/prod. The handler never reads ``request.state.user``,
 * which is what keeps it public (cf. ``GET /assistant/config``, which does and
 * is therefore auth-required).
 *
 * The secret server key (``SHIFT4_API_KEY`` / ``sk_…``) is NEVER returned.
 * ``gateway_merchant_id`` is derived from the publishable key — Shift4 couples
 * the two — rather than stored separately, so they cannot drift.
 *
 * ``pages`` is the surface-keyed map of hosted-page URLs (card form / wallet
 * pages) resolved for the current ``GIVMO_ENV`` (``config.PAYMENT_PAGES``);
 * each client reads only its own surface key. All public frontend URLs.
 */
export const paymentsGetPaymentsConfig = <ThrowOnError extends boolean = false>(options?: Options<PaymentsGetPaymentsConfigData, ThrowOnError>): RequestResult<PaymentsGetPaymentsConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PaymentsGetPaymentsConfigResponses, unknown, ThrowOnError>({ url: '/public/payments/config', ...options });

/**
 * Create Guest Pledge
 *
 * Create a GUEST pledge (02 §4.2, PV3-BE5) — a pledgor with NO account (email +
 * name + card token) on the SHIPPED claim-token substrate (never a third guest
 * identity). UNAUTHENTICATED. The FULL authed safety stack is composed: atomic
 * version-pinned consent capture, $0-CIT establishment, the mandatory cap,
 * idempotency, a per-IP anti-abuse floor. CARD funding only (wallet needs a
 * signed-in user). The pledge is claimable into an account later via the emailed
 * bearer link. A registered email → 409 ``GUEST_EMAIL_REGISTERED`` (sign in
 * instead); a consent copy not-yet-LIVE → 409 ``CONSENT_UNAVAILABLE``; a card that
 * won't verify → 409 ``PLEDGE_ESTABLISHMENT_FAILED``; pledging closed here → 409
 * ``PLEDGING_CLOSED``; recipients changed, or other than the optional
 * ``displayed_recipients`` the page showed → 409 ``PLEDGE_RECIPIENTS_CHANGED``; too many
 * attempts → 429. ``Idempotency-Key`` REQUIRED (fail-closed 422).
 */
export const pledgesCreateGuestPledge = <ThrowOnError extends boolean = false>(options: Options<PledgesCreateGuestPledgeData, ThrowOnError>): RequestResult<PledgesCreateGuestPledgeResponses, PledgesCreateGuestPledgeErrors, ThrowOnError> => (options.client ?? client).post<PledgesCreateGuestPledgeResponses, PledgesCreateGuestPledgeErrors, ThrowOnError>({
    url: '/public/pledge-campaigns/{campaign_id}/pledges',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Guest Offer Pledge
 *
 * Create a GUEST pledge on THIS offer: ``POST /public/pledge-campaigns/{campaign_id}/
 * pledges``' guest pledge (no account; card only; the per-IP floor; the emailed bearer link)
 * on the offer the path names, with its answers. The disclosure echoes are REQUIRED here
 * (``displayed_recipients``, ``displayed_source_line``, ``displayed_rule_sentence``,
 * ``displayed_precision_line``: others → 409 ``PLEDGE_RECIPIENTS_CHANGED`` /
 * ``PLEDGE_SOURCE_CHANGED`` / ``PLEDGE_RULE_CHANGED``; GFU-BE77's ``displayed_dates``,
 * ``shown_consent_*``, ``shown_disclaimer_*`` and ``presentation``, as on the signed-in offer
 * create); a flat pledge's cap is its
 * amount (409 ``PLEDGE_CAP_OUT_OF_RANGE``). An offer that is missing, or whose fundraiser the
 * offer read hides from a guest (a draft, a Deactivated page, a charity's page behind its
 * gate, a members-only group's page) → 404, the offer read's own. UNAUTHENTICATED.
 * ``Idempotency-Key`` REQUIRED (fail-closed 422).
 */
export const pledgesCreateGuestOfferPledge = <ThrowOnError extends boolean = false>(options: Options<PledgesCreateGuestOfferPledgeData, ThrowOnError>): RequestResult<PledgesCreateGuestOfferPledgeResponses, PledgesCreateGuestOfferPledgeErrors, ThrowOnError> => (options.client ?? client).post<PledgesCreateGuestOfferPledgeResponses, PledgesCreateGuestOfferPledgeErrors, ThrowOnError>({
    url: '/public/pledge-offers/{offer_id}/pledges',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Guest Pledge
 *
 * A GUEST reads the ONE pledge the link their 48-hour notice carries names, to see
 * its three choices (D-GFU-30): pay the amount due, pay a lower amount from $1 up to
 * it, or cancel, until ``charge_eligible_at``. UNAUTHENTICATED — the ``token`` (the
 * notice link's plaintext) IS the authorization. Every refusal — a forged, expired or
 * spent link, a pledge an account now owns — collapses to the guest cancel's constant
 * 400 ``INVALID_PLEDGE_CLAIM_TOKEN`` (anti-enumeration). The path sits under the guest
 * cancel's bearer root, so the token is scrubbed from the app's logs and dropped from
 * Cloud Run's request log by the existing ``pledge-cancel`` exclusion.
 */
export const pledgesGetGuestPledge = <ThrowOnError extends boolean = false>(options: Options<PledgesGetGuestPledgeData, ThrowOnError>): RequestResult<PledgesGetGuestPledgeResponses, PledgesGetGuestPledgeErrors, ThrowOnError> => (options.client ?? client).get<PledgesGetGuestPledgeResponses, PledgesGetGuestPledgeErrors, ThrowOnError>({ url: '/public/pledges/claim/{token}', ...options });

/**
 * Choose Guest Pledge Amount
 *
 * A GUEST chooses what their pledge pays through the link their 48-hour notice
 * carries (D-GFU-30), until its charge gate: exactly the amount due, or a lower amount
 * from $1 up to it; the third choice is the link's cancel. UNAUTHENTICATED — the
 * ``token`` IS the authorization, and the link stays live for another choice or the
 * cancel. Every refusal of the link — forged, expired or spent, a pledge an account now
 * owns or no longer active, the window closed — collapses to the guest cancel's
 * constant 400 ``INVALID_PLEDGE_CLAIM_TOKEN`` (anti-enumeration); an amount outside the
 * range is the 409 ``PLEDGE_AMOUNT_OUT_OF_RANGE``. Choosing the same amount again
 * changes nothing. NO idempotency-key required (the bearer and the choice's idempotence
 * are the safety). Answers the pledge as the read does.
 */
export const pledgesChooseGuestPledgeAmount = <ThrowOnError extends boolean = false>(options: Options<PledgesChooseGuestPledgeAmountData, ThrowOnError>): RequestResult<PledgesChooseGuestPledgeAmountResponses, PledgesChooseGuestPledgeAmountErrors, ThrowOnError> => (options.client ?? client).post<PledgesChooseGuestPledgeAmountResponses, PledgesChooseGuestPledgeAmountErrors, ThrowOnError>({
    url: '/public/pledges/claim/{token}/amount',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Guest Pledge
 *
 * Cancel a GUEST pledge via the single-use BEARER link, free pre-charge (02
 * §4.2.3, PV3-BE5). UNAUTHENTICATED — the ``token`` (the emailed claim link's
 * plaintext) IS the authorization; it cancels EVERY still-cancellable pledge it
 * covers. A bad/expired/claimed token, or one covering no cancellable pledge,
 * collapses to a constant 400 ``INVALID_PLEDGE_CLAIM_TOKEN`` (anti-enumeration —
 * never reveals whether a token exists). Idempotent (a re-cancel is a no-op
 * success). NO idempotency-key required (the bearer + the idempotent cancel are
 * the safety).
 *
 * GFU-BE27: the ``token`` may instead be the short-lived link a guest's 48-hour
 * notice carries. It cancels the ONE pledge it names, until the charge gate, and is
 * spent by it: a second use is the same constant 400.
 */
export const pledgesCancelGuestPledge = <ThrowOnError extends boolean = false>(options: Options<PledgesCancelGuestPledgeData, ThrowOnError>): RequestResult<PledgesCancelGuestPledgeResponses, PledgesCancelGuestPledgeErrors, ThrowOnError> => (options.client ?? client).post<PledgesCancelGuestPledgeResponses, PledgesCancelGuestPledgeErrors, ThrowOnError>({ url: '/public/pledges/claim/{token}/cancel', ...options });

/**
 * Object To Guest Pledge
 *
 * Retired (GFU-BE45, D-GFU-30): a guest who disagrees with the amount no longer
 * sends it to a review. Through the link their 48-hour notice carries, they pay a
 * lower amount they choose (``POST /public/pledges/claim/{token}/amount``) or cancel
 * (``POST /public/pledges/claim/{token}/cancel``), until their pledge's charge gate.
 * The path stays while the surface is dark and always answers 409
 * ``PLEDGE_OBJECTION_RETIRED``, whatever the link, reading and changing nothing.
 */
export const pledgesObjectToGuestPledge = <ThrowOnError extends boolean = false>(options: Options<PledgesObjectToGuestPledgeData, ThrowOnError>): RequestResult<PledgesObjectToGuestPledgeResponses, PledgesObjectToGuestPledgeErrors, ThrowOnError> => (options.client ?? client).post<PledgesObjectToGuestPledgeResponses, PledgesObjectToGuestPledgeErrors, ThrowOnError>({ url: '/public/pledges/claim/{token}/object', ...options });

/**
 * Get Public Profile Page
 *
 * The public composition of an entity's page: ``facts`` (the catalog projection
 * — a company's bio / signed cover / website; ``null`` for the other classes),
 * the LISTED blocks in owner order (image URLs signed per request), and the
 * updates rail (empty until the Social rail lands). Anonymous for a charity, a
 * user or a group; a company page needs a signed-in caller. A suppressed or
 * nonexistent page is one constant 404.
 */
export const profilePagesPublicGetPublicProfilePage = <ThrowOnError extends boolean = false>(options: Options<ProfilePagesPublicGetPublicProfilePageData, ThrowOnError>): RequestResult<ProfilePagesPublicGetPublicProfilePageResponses, ProfilePagesPublicGetPublicProfilePageErrors, ThrowOnError> => (options.client ?? client).get<ProfilePagesPublicGetPublicProfilePageResponses, ProfilePagesPublicGetPublicProfilePageErrors, ThrowOnError>({ url: '/public/profiles/{entity_type}/{entity_id}/page', ...options });

/**
 * Get Search Feed
 */
export const searchGetSearchFeed = <ThrowOnError extends boolean = false>(options?: Options<SearchGetSearchFeedData, ThrowOnError>): RequestResult<SearchGetSearchFeedResponses, SearchGetSearchFeedErrors, ThrowOnError> => (options?.client ?? client).get<SearchGetSearchFeedResponses, SearchGetSearchFeedErrors, ThrowOnError>({ url: '/search', ...options });

/**
 * List Steps Competitions
 *
 * My linked company's competitions + my entry summary (§2.4). Token-permissive
 * at the route level, but a signed-in user is required to have a company scope —
 * a user linked to no company simply gets an empty page.
 */
export const stepsCompetitionsListStepsCompetitions = <ThrowOnError extends boolean = false>(options?: Options<StepsCompetitionsListStepsCompetitionsData, ThrowOnError>): RequestResult<StepsCompetitionsListStepsCompetitionsResponses, StepsCompetitionsListStepsCompetitionsErrors, ThrowOnError> => (options?.client ?? client).get<StepsCompetitionsListStepsCompetitionsResponses, StepsCompetitionsListStepsCompetitionsErrors, ThrowOnError>({ url: '/steps-competitions', ...options });

/**
 * Get Steps Competition
 *
 * Detail + my entry (§2.4). Audience per the competition's visibility axis;
 * byte-identical 404 for a viewer not entitled (existence never leaked).
 */
export const stepsCompetitionsGetStepsCompetition = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsGetStepsCompetitionData, ThrowOnError>): RequestResult<StepsCompetitionsGetStepsCompetitionResponses, StepsCompetitionsGetStepsCompetitionErrors, ThrowOnError> => (options.client ?? client).get<StepsCompetitionsGetStepsCompetitionResponses, StepsCompetitionsGetStepsCompetitionErrors, ThrowOnError>({ url: '/steps-competitions/{steps_competition_id}', ...options });

/**
 * Join Steps Competition
 *
 * Join (§1.3): ``{charity_id, visibility}`` → 201. Consent is recorded
 * server-side; one-entry-per-user → 409.
 */
export const stepsCompetitionsJoinStepsCompetition = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsJoinStepsCompetitionData, ThrowOnError>): RequestResult<StepsCompetitionsJoinStepsCompetitionResponses, StepsCompetitionsJoinStepsCompetitionErrors, ThrowOnError> => (options.client ?? client).post<StepsCompetitionsJoinStepsCompetitionResponses, StepsCompetitionsJoinStepsCompetitionErrors, ThrowOnError>({
    url: '/steps-competitions/{steps_competition_id}/entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw From Steps Competition
 *
 * Withdraw (§2.4): status → WITHDRAWN, hidden from the leaderboard
 * immediately; day data retained while the competition is live (§3.1 #5).
 */
export const stepsCompetitionsWithdrawFromStepsCompetition = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsWithdrawFromStepsCompetitionData, ThrowOnError>): RequestResult<StepsCompetitionsWithdrawFromStepsCompetitionResponses, StepsCompetitionsWithdrawFromStepsCompetitionErrors, ThrowOnError> => (options.client ?? client).delete<StepsCompetitionsWithdrawFromStepsCompetitionResponses, StepsCompetitionsWithdrawFromStepsCompetitionErrors, ThrowOnError>({ url: '/steps-competitions/{steps_competition_id}/entries/me', ...options });

/**
 * Update My Steps Entry
 *
 * Change charity (PUBLISHED/ACTIVE) and/or visibility (until finalize), §2.4.
 * Entry-ownership scoped (the caller's own entry only). A request with neither
 * field is a no-op that echoes the current entry.
 */
export const stepsCompetitionsUpdateMyStepsEntry = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsUpdateMyStepsEntryData, ThrowOnError>): RequestResult<StepsCompetitionsUpdateMyStepsEntryResponses, StepsCompetitionsUpdateMyStepsEntryErrors, ThrowOnError> => (options.client ?? client).put<StepsCompetitionsUpdateMyStepsEntryResponses, StepsCompetitionsUpdateMyStepsEntryErrors, ThrowOnError>({
    url: '/steps-competitions/{steps_competition_id}/entries/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restate My Steps
 *
 * Restate the full window (§2.5): ``[{local_date, steps}]`` →
 * ``{accepted_days, total_steps, rank}`` with per-day ``rejected`` reasons. Never
 * a whole-batch failure for a single bad day.
 */
export const stepsCompetitionsRestateMySteps = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsRestateMyStepsData, ThrowOnError>): RequestResult<StepsCompetitionsRestateMyStepsResponses, StepsCompetitionsRestateMyStepsErrors, ThrowOnError> => (options.client ?? client).put<StepsCompetitionsRestateMyStepsResponses, StepsCompetitionsRestateMyStepsErrors, ThrowOnError>({
    url: '/steps-competitions/{steps_competition_id}/entries/me/days',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Steps Competition Leaderboard
 *
 * Paginated leaderboard (§1.4/§2.4). Rows carry rank + steps; PRIVATE rows are
 * anonymized SERVER-SIDE for non-admin viewers (identity fields never leave the
 * server). ``meta`` carries ``my_rank``/``my_total`` + ``provisional``.
 */
export const stepsCompetitionsGetStepsCompetitionLeaderboard = <ThrowOnError extends boolean = false>(options: Options<StepsCompetitionsGetStepsCompetitionLeaderboardData, ThrowOnError>): RequestResult<StepsCompetitionsGetStepsCompetitionLeaderboardResponses, StepsCompetitionsGetStepsCompetitionLeaderboardErrors, ThrowOnError> => (options.client ?? client).get<StepsCompetitionsGetStepsCompetitionLeaderboardResponses, StepsCompetitionsGetStepsCompetitionLeaderboardErrors, ThrowOnError>({ url: '/steps-competitions/{steps_competition_id}/leaderboard', ...options });

/**
 * Export Gcf Accounting
 */
export const accountingExportExportGcfAccounting = <ThrowOnError extends boolean = false>(options: Options<AccountingExportExportGcfAccountingData, ThrowOnError>): RequestResult<AccountingExportExportGcfAccountingResponses, AccountingExportExportGcfAccountingErrors, ThrowOnError> => (options.client ?? client).post<AccountingExportExportGcfAccountingResponses, AccountingExportExportGcfAccountingErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/accounting/gcf/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Assistant Superadmin Config
 *
 * Read the raw stored `assistant_config` row for the edit UI (02 §C2).
 * Returns the dark defaults when no row exists yet. Super-admin only.
 */
export const assistantGetAssistantSuperadminConfig = <ThrowOnError extends boolean = false>(options?: Options<AssistantGetAssistantSuperadminConfigData, ThrowOnError>): RequestResult<AssistantGetAssistantSuperadminConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AssistantGetAssistantSuperadminConfigResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/assistant/config',
    ...options
});

/**
 * Update Assistant Superadmin Config
 *
 * Partial upsert of the `assistant_config` singleton — the runtime kill
 * switch edit (02 §C2). Only the fields present in the body are applied
 * (absent = unchanged, explicit null clears); creates the row from dark
 * defaults on first write. Super-admin only.
 */
export const assistantUpdateAssistantSuperadminConfig = <ThrowOnError extends boolean = false>(options: Options<AssistantUpdateAssistantSuperadminConfigData, ThrowOnError>): RequestResult<AssistantUpdateAssistantSuperadminConfigResponses, AssistantUpdateAssistantSuperadminConfigErrors, ThrowOnError> => (options.client ?? client).put<AssistantUpdateAssistantSuperadminConfigResponses, AssistantUpdateAssistantSuperadminConfigErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/assistant/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Assistant Turns Admin
 *
 * Paginated turn list for a conversation (D6-3a), newest first. Metadata-only
 * projection (content-free). `page[limit]` hard-capped at 200 (over-cap → 422).
 * An unknown conversation id returns an empty page. Super-admin only.
 */
export const assistantListAssistantTurnsAdmin = <ThrowOnError extends boolean = false>(options: Options<AssistantListAssistantTurnsAdminData, ThrowOnError>): RequestResult<AssistantListAssistantTurnsAdminResponses, AssistantListAssistantTurnsAdminErrors, ThrowOnError> => (options.client ?? client).get<AssistantListAssistantTurnsAdminResponses, AssistantListAssistantTurnsAdminErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/assistant/conversations/{conversation_id}/turns',
    ...options
});

/**
 * List Assistant Escalations Admin
 *
 * Paginated escalation list for the ops view (D6-1), newest first. Optional
 * `status` filter (an `AssistantEscalationStatus` value, or `awaiting_human` —
 * confirmed, sent or failed: the operator-queue class's predicate, SAPD-AH1;
 * off-set → 422). Each row names the requesting user (name + email) and, once
 * resolved, the resolver. `page[limit]` is hard-capped at 200 (over-cap → 422).
 * Super-admin only.
 */
export const assistantListAssistantEscalationsAdmin = <ThrowOnError extends boolean = false>(options?: Options<AssistantListAssistantEscalationsAdminData, ThrowOnError>): RequestResult<AssistantListAssistantEscalationsAdminResponses, AssistantListAssistantEscalationsAdminErrors, ThrowOnError> => (options?.client ?? client).get<AssistantListAssistantEscalationsAdminResponses, AssistantListAssistantEscalationsAdminErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/assistant/escalations',
    ...options
});

/**
 * Get Assistant Escalation Admin
 *
 * Single-escalation detail for the ops view (D6-1). 404 when missing.
 * Super-admin only.
 */
export const assistantGetAssistantEscalationAdmin = <ThrowOnError extends boolean = false>(options: Options<AssistantGetAssistantEscalationAdminData, ThrowOnError>): RequestResult<AssistantGetAssistantEscalationAdminResponses, AssistantGetAssistantEscalationAdminErrors, ThrowOnError> => (options.client ?? client).get<AssistantGetAssistantEscalationAdminResponses, AssistantGetAssistantEscalationAdminErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/assistant/escalations/{escalation_id}',
    ...options
});

/**
 * Resolve Assistant Escalation Admin
 *
 * Mark resolved (SAPD-AH1, D-SAPD-6): the operator handled this handoff, so it
 * leaves the operator queue. Super-admin only; non-money, so NOT enrolled in the
 * money-action guard. Idempotent: an already-resolved row is a 200 no-op that keeps
 * the first resolver and time. Records who resolved it and when; sends nothing to
 * the user or anyone else. 404 when missing; 409 (`ESCALATION_NOT_CONFIRMED`) for a
 * `proposed` row the user never confirmed. Answers the escalation as the detail
 * read does, so the portal re-renders from the response.
 */
export const assistantResolveAssistantEscalationAdmin = <ThrowOnError extends boolean = false>(options: Options<AssistantResolveAssistantEscalationAdminData, ThrowOnError>): RequestResult<AssistantResolveAssistantEscalationAdminResponses, AssistantResolveAssistantEscalationAdminErrors, ThrowOnError> => (options.client ?? client).post<AssistantResolveAssistantEscalationAdminResponses, AssistantResolveAssistantEscalationAdminErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/assistant/escalations/{escalation_id}/resolve',
    ...options
});

/**
 * List Assistant Feedback Admin
 *
 * Paginated feedback/report review queue for the ops view (D6-1), newest
 * first. `rating` narrows to a single thumbs value (off-set → 422);
 * `reports_only=true` keeps only rows carrying a `report_category` (the
 * actionable AI-content reports). The two filters compose. `page[limit]` is
 * hard-capped at 200 (over-cap → 422). Super-admin only.
 */
export const assistantListAssistantFeedbackAdmin = <ThrowOnError extends boolean = false>(options?: Options<AssistantListAssistantFeedbackAdminData, ThrowOnError>): RequestResult<AssistantListAssistantFeedbackAdminResponses, AssistantListAssistantFeedbackAdminErrors, ThrowOnError> => (options?.client ?? client).get<AssistantListAssistantFeedbackAdminResponses, AssistantListAssistantFeedbackAdminErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/assistant/feedback',
    ...options
});

/**
 * List Assistant Turn Events Admin
 *
 * Content-free event trace for a turn (D6-3a), ordered by `(attempt, seq)`,
 * paginated/bounded (the same bounded posture as the turn list — `page[limit]`
 * hard-capped, over-cap → 422 — so an admin read never pulls an unbounded event
 * stream). Projection drops the raw event `payload` (the message/reply text). An
 * unknown turn id returns an empty page. Super-admin only.
 */
export const assistantListAssistantTurnEventsAdmin = <ThrowOnError extends boolean = false>(options: Options<AssistantListAssistantTurnEventsAdminData, ThrowOnError>): RequestResult<AssistantListAssistantTurnEventsAdminResponses, AssistantListAssistantTurnEventsAdminErrors, ThrowOnError> => (options.client ?? client).get<AssistantListAssistantTurnEventsAdminResponses, AssistantListAssistantTurnEventsAdminErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/assistant/turns/{turn_id}/events',
    ...options
});

/**
 * List Assistant Turn Tool Calls Admin
 *
 * Content-free tool-call trace for a turn (D6-3a), oldest first,
 * paginated/bounded (`page[limit]` hard-capped, over-cap → 422). Projection omits
 * the raw tool `input`; `result_digest` is the upstream-redacted structural digest.
 * An unknown turn id returns an empty page. Super-admin only.
 */
export const assistantListAssistantTurnToolCallsAdmin = <ThrowOnError extends boolean = false>(options: Options<AssistantListAssistantTurnToolCallsAdminData, ThrowOnError>): RequestResult<AssistantListAssistantTurnToolCallsAdminResponses, AssistantListAssistantTurnToolCallsAdminErrors, ThrowOnError> => (options.client ?? client).get<AssistantListAssistantTurnToolCallsAdminResponses, AssistantListAssistantTurnToolCallsAdminErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/assistant/turns/{turn_id}/tool-calls',
    ...options
});

/**
 * Get Assistant Usage Admin
 *
 * ORG usage/spend per day over `[start, end]` (D6-4a), ascending — one row per
 * day that has usage (sparse). `start`/`end` are `YYYY-MM-DD`; both omitted →
 * last 30 days (ET). `start>end` or a span over the cap → 422. Includes a range
 * `summary` (each metric summed over the window). Super-admin only.
 */
export const assistantGetAssistantUsageAdmin = <ThrowOnError extends boolean = false>(options?: Options<AssistantGetAssistantUsageAdminData, ThrowOnError>): RequestResult<AssistantGetAssistantUsageAdminResponses, AssistantGetAssistantUsageAdminErrors, ThrowOnError> => (options?.client ?? client).get<AssistantGetAssistantUsageAdminResponses, AssistantGetAssistantUsageAdminErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/assistant/usage',
    ...options
});

/**
 * List Champions
 *
 * The super-admin champion list — newest first, optionally filtered by
 * ``owner_type``, each row carrying its current live handle and the target the
 * link is CONFIGURED to point at. Paginated.
 */
export const superAdminChampionOpsListChampions = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminChampionOpsListChampionsData, ThrowOnError>): RequestResult<SuperAdminChampionOpsListChampionsResponses, SuperAdminChampionOpsListChampionsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminChampionOpsListChampionsResponses, SuperAdminChampionOpsListChampionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/champions',
    ...options
});

/**
 * Inspect Champion By Handle
 *
 * Inspect the champion that owns ``handle`` (normalized on the way in — a
 * mixed-case/whitespace handle still resolves the stored lowercase row), matching
 * the whole handle history so a retired or disabled handle still inspects. 404
 * when the handle is unknown or its owning champion is gone.
 */
export const superAdminChampionOpsInspectChampionByHandle = <ThrowOnError extends boolean = false>(options: Options<SuperAdminChampionOpsInspectChampionByHandleData, ThrowOnError>): RequestResult<SuperAdminChampionOpsInspectChampionByHandleResponses, SuperAdminChampionOpsInspectChampionByHandleErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminChampionOpsInspectChampionByHandleResponses, SuperAdminChampionOpsInspectChampionByHandleErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/champions/by-handle/{handle}',
    ...options
});

/**
 * Reclaim Champion Handle
 *
 * DISABLE (reclaim) an abusive/squatted handle — the core SA1 anti-abuse
 * lever. Reclaim sets ``disabled_at`` + clears ``is_current`` (D-CQ-10:
 * reclaim = disable, never-recycle, NOT freed — the string is not returned to the
 * open pool), so a printed QR for that handle falls through to the safe fallback
 * landing rather than the abuser's target; printed media never dead-ends.
 * Reuses ``ChampionService.reclaim_handle``, which NORMALIZES the handle (so
 * ``"RedCross"`` / ``" redcross "`` reclaim the stored ``redcross`` row) and is
 * IDEMPOTENT (re-reclaiming a disabled handle is a no-op). A handle-not-found is
 * a uniform 404. Returns the reclaimed handle row's state.
 */
export const superAdminChampionOpsReclaimChampionHandle = <ThrowOnError extends boolean = false>(options: Options<SuperAdminChampionOpsReclaimChampionHandleData, ThrowOnError>): RequestResult<SuperAdminChampionOpsReclaimChampionHandleResponses, SuperAdminChampionOpsReclaimChampionHandleErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminChampionOpsReclaimChampionHandleResponses, SuperAdminChampionOpsReclaimChampionHandleErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/champions/handles/{handle}/reclaim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * File Champion Report
 *
 * Record an out-of-band champion abuse complaint (impersonation, squatting, a
 * takedown demand) against a handle and/or champion.
 *
 * The record lands on the CROSS-SURFACE ``content_report`` aggregate, not a
 * champion-private table (the UGC-BE1/BE2 mandated-adoption contract), so it
 * inherits the shared ``pending → reviewing → actioned → dismissed`` lifecycle
 * and appears in ``GET /super-admin/content-reports`` alongside every other
 * reported surface with no extra wiring. Filing DISABLES NOTHING — the
 * anti-abuse lever is the reclaim route below.
 *
 * NB the ``report_count``/``last_reported_at`` fields on the CREATE response are
 * aggregate-read transients stamped only by the queue read — this response
 * always says ``report_count: 1`` even for a champion's third report. Read
 * ``GET /super-admin/content-reports`` for the true aggregate.
 */
export const superAdminChampionOpsFileChampionReport = <ThrowOnError extends boolean = false>(options: Options<SuperAdminChampionOpsFileChampionReportData, ThrowOnError>): RequestResult<SuperAdminChampionOpsFileChampionReportResponses, SuperAdminChampionOpsFileChampionReportErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminChampionOpsFileChampionReportResponses, SuperAdminChampionOpsFileChampionReportErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/champions/reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Inspect Champion
 *
 * One champion's full inspect view: identity + owner + configured target + the
 * ENTIRE handle history (current, retired, disabled). 404 when the champion does
 * not exist.
 */
export const superAdminChampionOpsInspectChampion = <ThrowOnError extends boolean = false>(options: Options<SuperAdminChampionOpsInspectChampionData, ThrowOnError>): RequestResult<SuperAdminChampionOpsInspectChampionResponses, SuperAdminChampionOpsInspectChampionErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminChampionOpsInspectChampionResponses, SuperAdminChampionOpsInspectChampionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/champions/{champion_id}',
    ...options
});

/**
 * Get Charity Domain Coverage
 *
 * Superadmin observability: how many charities have organization_domain
 * populated (total + ACTIVE) — distinguishes a 'lookup column empty' state from
 * 'healthy but sparsely populated' as the enrichment import fills domains in.
 */
export const charitiesGetCharityDomainCoverage = <ThrowOnError extends boolean = false>(options?: Options<CharitiesGetCharityDomainCoverageData, ThrowOnError>): RequestResult<CharitiesGetCharityDomainCoverageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CharitiesGetCharityDomainCoverageResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charities/domain-coverage',
    ...options
});

/**
 * End Charity Display Name
 *
 * End a charity's live display name (``ended_by_operator``) and withdraw a request
 * waiting for review; ``charity.name`` returns to the catalog name. The ``reason`` is kept
 * on the ended row and never shown to the charity. Idempotent. Served whatever
 * ``CHARITY_DISPLAY_NAME_ENABLED`` says. A super-admin's own ``PUT /charities/{id}``
 * refuses a name change while a display name is live: end it here first.
 */
export const superAdminCharityDisplayNamesEndCharityDisplayName = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityDisplayNamesEndCharityDisplayNameData, ThrowOnError>): RequestResult<SuperAdminCharityDisplayNamesEndCharityDisplayNameResponses, SuperAdminCharityDisplayNamesEndCharityDisplayNameErrors, ThrowOnError> => (options.client ?? client).delete<SuperAdminCharityDisplayNamesEndCharityDisplayNameResponses, SuperAdminCharityDisplayNamesEndCharityDisplayNameErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charities/{charity_id}/display-name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Platform Grant Facts
 */
export const superAdminPlatformGrantFactsGetPlatformGrantFacts = <ThrowOnError extends boolean = false>(options: Options<SuperAdminPlatformGrantFactsGetPlatformGrantFactsData, ThrowOnError>): RequestResult<SuperAdminPlatformGrantFactsGetPlatformGrantFactsResponses, SuperAdminPlatformGrantFactsGetPlatformGrantFactsErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminPlatformGrantFactsGetPlatformGrantFactsResponses, SuperAdminPlatformGrantFactsGetPlatformGrantFactsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charities/{charity_id}/platform-grant-facts',
    ...options
});

/**
 * List Pending Charity Claims
 *
 * The Charity Claims list, newest first, with the claimant + charity identity,
 * submission age (the 1–3-day SLA), and an evidence count. By default the Tier-2
 * review queue: every PENDING_REVIEW claim. CPA-SA4: ``?status=APPROVED|REJECTED``
 * lists the decided claims in that status, ``?status=ALL`` every claim, and
 * ``?tier=TIER_1|TIER_2`` narrows to one tier (APPROVED + TIER_1 is the
 * auto-verified claims, APPROVED + TIER_2 the ones a reviewer approved). A decided
 * view is capped, keeping the newest claims, and sets ``truncated`` when it held
 * more than it returns; the queue is never capped. A decided row carries
 * ``resolved_at`` and reads ``is_takeover`` False.
 */
export const superAdminCharityClaimsListPendingCharityClaims = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminCharityClaimsListPendingCharityClaimsData, ThrowOnError>): RequestResult<SuperAdminCharityClaimsListPendingCharityClaimsResponses, SuperAdminCharityClaimsListPendingCharityClaimsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminCharityClaimsListPendingCharityClaimsResponses, SuperAdminCharityClaimsListPendingCharityClaimsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-claims',
    ...options
});

/**
 * Get Charity Claim Detail
 *
 * One claim's review detail, including SHORT-LIVED signed READ URLs for its
 * uploaded verification documents. The read URLs are minted per-request and
 * never persisted.
 */
export const superAdminCharityClaimsGetCharityClaimDetail = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityClaimsGetCharityClaimDetailData, ThrowOnError>): RequestResult<SuperAdminCharityClaimsGetCharityClaimDetailResponses, SuperAdminCharityClaimsGetCharityClaimDetailErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminCharityClaimsGetCharityClaimDetailResponses, SuperAdminCharityClaimsGetCharityClaimDetailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-claims/{claim_request_id}',
    ...options
});

/**
 * Approve Charity Claim
 *
 * APPROVE a pending claim → reuse slice-1's ``approve_claim``: write the
 * ``charity_claim`` overlay CLAIMED (NEVER CONSENTED — D-CP-8) + an Owner
 * membership for the claimant + audit, atomically. Returns the APPROVED
 * request.
 */
export const superAdminCharityClaimsApproveCharityClaim = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityClaimsApproveCharityClaimData, ThrowOnError>): RequestResult<SuperAdminCharityClaimsApproveCharityClaimResponses, SuperAdminCharityClaimsApproveCharityClaimErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityClaimsApproveCharityClaimResponses, SuperAdminCharityClaimsApproveCharityClaimErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-claims/{claim_request_id}/approve',
    ...options
});

/**
 * Approve Charity Claim Transfer
 *
 * APPROVE-WITH-OWNERSHIP-TRANSFER — the DELIBERATE takeover adjudication for
 * an already-claimed charity: install the claimant as the new Owner AND
 * atomically REVOKE the prior Owner membership(s), fully audited (who removed,
 * who added, reviewer). Distinct from the ordinary approve (which never removes
 * an existing Owner). Atomic: the new Owner is installed before the old ones are
 * removed, so the charity is never left with zero Owners. Still writes CLAIMED,
 * NEVER CONSENTED (D-CP-8). Returns the APPROVED request.
 */
export const superAdminCharityClaimsApproveCharityClaimTransfer = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityClaimsApproveCharityClaimTransferData, ThrowOnError>): RequestResult<SuperAdminCharityClaimsApproveCharityClaimTransferResponses, SuperAdminCharityClaimsApproveCharityClaimTransferErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityClaimsApproveCharityClaimTransferResponses, SuperAdminCharityClaimsApproveCharityClaimTransferErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-claims/{claim_request_id}/approve-transfer',
    ...options
});

/**
 * Reject Charity Claim
 *
 * REJECT a pending claim with a required reason → status REJECTED + audit.
 * NEVER writes a ``charity_claim`` overlay row and NEVER creates a membership —
 * a rejected claim confers no access.
 */
export const superAdminCharityClaimsRejectCharityClaim = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityClaimsRejectCharityClaimData, ThrowOnError>): RequestResult<SuperAdminCharityClaimsRejectCharityClaimResponses, SuperAdminCharityClaimsRejectCharityClaimErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityClaimsRejectCharityClaimResponses, SuperAdminCharityClaimsRejectCharityClaimErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-claims/{claim_request_id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Super Admin Recent Collections
 *
 * Super-admin moderation list (CC-BE6): recent collections newest-first,
 * INCLUDING super-admin-unlisted ones (with the `unlisted_at`/
 * `unlisted_by_user_id`/`unlisted_reason` audit fields) so an admin can review
 * the surface and unlist/relist.
 *
 * `q` is a case-insensitive substring match across the collection name, owner
 * (creator) name, collection id, and any member-charity name, applied
 * server-side (with `page[limit]`/`page[offset]`) so the moderation client can
 * search + page the whole corpus instead of loading everything and searching
 * in-memory.
 */
export const charityCollectionsGetSuperAdminRecentCollections = <ThrowOnError extends boolean = false>(options?: Options<CharityCollectionsGetSuperAdminRecentCollectionsData, ThrowOnError>): RequestResult<CharityCollectionsGetSuperAdminRecentCollectionsResponses, CharityCollectionsGetSuperAdminRecentCollectionsErrors, ThrowOnError> => (options?.client ?? client).get<CharityCollectionsGetSuperAdminRecentCollectionsResponses, CharityCollectionsGetSuperAdminRecentCollectionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-collections',
    ...options
});

/**
 * Relist Charity Collection
 *
 * Super-admin relist (CC-BE6): clear the moderation trio so a previously
 * unlisted collection is served/discoverable/donatable again.
 */
export const charityCollectionsRelistCharityCollection = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsRelistCharityCollectionData, ThrowOnError>): RequestResult<CharityCollectionsRelistCharityCollectionResponses, CharityCollectionsRelistCharityCollectionErrors, ThrowOnError> => (options.client ?? client).post<CharityCollectionsRelistCharityCollectionResponses, CharityCollectionsRelistCharityCollectionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-collections/{collection_id}/relist',
    ...options
});

/**
 * Unlist Charity Collection
 *
 * Super-admin unlist (CC-BE6): drop a collection from every consumer/
 * discovery read and hard-block new gifts. Idempotent. Never touches a settled
 * donation. An OPTIONAL `{"reason": "..."}` body stamps the audit
 * `unlisted_reason`; a request with no body still unlists with `reason=None`
 * (backward-compatible).
 */
export const charityCollectionsUnlistCharityCollection = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsUnlistCharityCollectionData, ThrowOnError>): RequestResult<CharityCollectionsUnlistCharityCollectionResponses, CharityCollectionsUnlistCharityCollectionErrors, ThrowOnError> => (options.client ?? client).post<CharityCollectionsUnlistCharityCollectionResponses, CharityCollectionsUnlistCharityCollectionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-collections/{collection_id}/unlist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Charity Consent States
 *
 * The consent-state list — every claimed charity + its overlay consent state,
 * newest first, paginated (``page[limit]``/``page[offset]``). Optionally narrow to
 * one state with ``?consent_status=CLAIMED|CONSENTED|REMOVED``. A compliance-ops
 * view of who has / hasn't signed the §318(a) Terms; consent is read VERBATIM off
 * the overlay.
 *
 * ``q`` is a case-insensitive substring match across the charity name, charity
 * id, claimant email, and claimant user id, applied server-side (composing with
 * ``consent_status``) so the client can search + page the whole corpus instead
 * of loading everything and searching in-memory.
 */
export const superAdminCharityConsentOpsListCharityConsentStates = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminCharityConsentOpsListCharityConsentStatesData, ThrowOnError>): RequestResult<SuperAdminCharityConsentOpsListCharityConsentStatesResponses, SuperAdminCharityConsentOpsListCharityConsentStatesErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminCharityConsentOpsListCharityConsentStatesResponses, SuperAdminCharityConsentOpsListCharityConsentStatesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-consents',
    ...options
});

/**
 * Get Claim Velocity Report
 *
 * The global rolling 1-hour / 24-hour claim-velocity report, grouped by EIN,
 * claimant email domain, and audited client IP. Counts and alert booleans are
 * read-only operator signals; this endpoint never changes claim admission.
 */
export const superAdminCharityConsentOpsGetClaimVelocityReport = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminCharityConsentOpsGetClaimVelocityReportData, ThrowOnError>): RequestResult<SuperAdminCharityConsentOpsGetClaimVelocityReportResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuperAdminCharityConsentOpsGetClaimVelocityReportResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-consents/claim-velocity',
    ...options
});

/**
 * Get Charity Audit Trail
 *
 * The merged claim + removal audit trail for one charity, oldest event first —
 * every ``charity_claim_event`` (CPA-BE2) and ``charity_removal_event`` (CPA-BE4)
 * transition for the charity, each tagged with its ``kind``, actor, timestamp, and
 * from/to status. A charity with no claim/removal history returns an empty trail.
 */
export const superAdminCharityConsentOpsGetCharityAuditTrail = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityConsentOpsGetCharityAuditTrailData, ThrowOnError>): RequestResult<SuperAdminCharityConsentOpsGetCharityAuditTrailResponses, SuperAdminCharityConsentOpsGetCharityAuditTrailErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminCharityConsentOpsGetCharityAuditTrailResponses, SuperAdminCharityConsentOpsGetCharityAuditTrailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-consents/{charity_id}/audit-trail',
    ...options
});

/**
 * List Charity Display Names
 *
 * Display-name rows newest first, narrowed by ``status`` (``pending_review`` is the
 * review queue) and ``charity_id`` (one charity's history), with the exact total. Each
 * row carries the request, what the look-alike check said (``check_detail``: the rules
 * that fired, the names and EINs they matched, and a chapter network's entry with the
 * website to check membership at), the decision, and the charity's three names.
 */
export const superAdminCharityDisplayNamesListCharityDisplayNames = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminCharityDisplayNamesListCharityDisplayNamesData, ThrowOnError>): RequestResult<SuperAdminCharityDisplayNamesListCharityDisplayNamesResponses, SuperAdminCharityDisplayNamesListCharityDisplayNamesErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminCharityDisplayNamesListCharityDisplayNamesResponses, SuperAdminCharityDisplayNamesListCharityDisplayNamesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-display-names',
    ...options
});

/**
 * Approve Charity Display Name
 *
 * Approve a held display name: it goes live as a clear one would. 409
 * ``CHARITY_DISPLAY_NAME_NOT_AVAILABLE`` when the request is no longer pending, when the
 * charity can no longer carry a display name (the request is withdrawn), or when the
 * check now refuses the name (the request stays pending: reject it with a note). Dark
 * behind ``CHARITY_DISPLAY_NAME_ENABLED`` (the absent-route 404).
 */
export const superAdminCharityDisplayNamesApproveCharityDisplayName = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityDisplayNamesApproveCharityDisplayNameData, ThrowOnError>): RequestResult<SuperAdminCharityDisplayNamesApproveCharityDisplayNameResponses, SuperAdminCharityDisplayNamesApproveCharityDisplayNameErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityDisplayNamesApproveCharityDisplayNameResponses, SuperAdminCharityDisplayNamesApproveCharityDisplayNameErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-display-names/{display_name_id}/approve',
    ...options
});

/**
 * Reject Charity Display Name
 *
 * Reject a held display name with a ``note`` the charity reads in its console. 409
 * ``CHARITY_DISPLAY_NAME_NOT_AVAILABLE`` when the request is no longer pending.
 */
export const superAdminCharityDisplayNamesRejectCharityDisplayName = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityDisplayNamesRejectCharityDisplayNameData, ThrowOnError>): RequestResult<SuperAdminCharityDisplayNamesRejectCharityDisplayNameResponses, SuperAdminCharityDisplayNamesRejectCharityDisplayNameErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityDisplayNamesRejectCharityDisplayNameResponses, SuperAdminCharityDisplayNamesRejectCharityDisplayNameErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-display-names/{display_name_id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Charity Instant Claim Allowances
 *
 * One charity's instant-claim allowances, newest first, live and revoked; with no
 * ``charity_id``, every live allowance across charities, newest first. Each says whether
 * it is in effect: live, and vetted for the website on file now.
 */
export const superAdminCharityInstantClaimListCharityInstantClaimAllowances = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesData, ThrowOnError>): RequestResult<SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesResponses, SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesResponses, SuperAdminCharityInstantClaimListCharityInstantClaimAllowancesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-instant-claim-allowances',
    ...options
});

/**
 * Allow Charity Instant Claim
 *
 * Allow instant claim for a charity after vetting its website: a verified email at
 * that website then becomes the charity's Owner on claiming, with no review. The
 * ``domain`` must be the charity's website on file (409 otherwise, and 409 for a charity
 * with no website or that is not active); an allowance already in effect is returned
 * unchanged. Returns the allowance.
 */
export const superAdminCharityInstantClaimAllowCharityInstantClaim = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityInstantClaimAllowCharityInstantClaimData, ThrowOnError>): RequestResult<SuperAdminCharityInstantClaimAllowCharityInstantClaimResponses, SuperAdminCharityInstantClaimAllowCharityInstantClaimErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityInstantClaimAllowCharityInstantClaimResponses, SuperAdminCharityInstantClaimAllowCharityInstantClaimErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-instant-claim-allowances',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Charity Instant Claim
 *
 * Revoke instant claim for the allowance's charity, with the reason: its claims go
 * to review again. Claims already approved are untouched. 409 when it was already
 * revoked. Returns the revoked allowance.
 */
export const superAdminCharityInstantClaimRevokeCharityInstantClaim = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityInstantClaimRevokeCharityInstantClaimData, ThrowOnError>): RequestResult<SuperAdminCharityInstantClaimRevokeCharityInstantClaimResponses, SuperAdminCharityInstantClaimRevokeCharityInstantClaimErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityInstantClaimRevokeCharityInstantClaimResponses, SuperAdminCharityInstantClaimRevokeCharityInstantClaimErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-instant-claim-allowances/{allowance_id}/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Charity Onboarding Test
 */
export const superAdminCharityOnboardingTestGetCharityOnboardingTest = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminCharityOnboardingTestGetCharityOnboardingTestData, ThrowOnError>): RequestResult<SuperAdminCharityOnboardingTestGetCharityOnboardingTestResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuperAdminCharityOnboardingTestGetCharityOnboardingTestResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-onboarding-test',
    ...options
});

/**
 * Reset Charity Onboarding Test
 */
export const superAdminCharityOnboardingTestResetCharityOnboardingTest = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityOnboardingTestResetCharityOnboardingTestData, ThrowOnError>): RequestResult<SuperAdminCharityOnboardingTestResetCharityOnboardingTestResponses, SuperAdminCharityOnboardingTestResetCharityOnboardingTestErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityOnboardingTestResetCharityOnboardingTestResponses, SuperAdminCharityOnboardingTestResetCharityOnboardingTestErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-onboarding-test/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Charity Payee Flags
 *
 * The OPEN payee-flag queue — every unresolved anomaly (name mismatch / screening
 * / ineligible / ambiguous EIN), oldest first (FIFO), with the charity identity, the
 * vault-MASKED payment context, and the current binding status.
 */
export const superAdminCharityPayeeFlagsListCharityPayeeFlags = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminCharityPayeeFlagsListCharityPayeeFlagsData, ThrowOnError>): RequestResult<SuperAdminCharityPayeeFlagsListCharityPayeeFlagsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuperAdminCharityPayeeFlagsListCharityPayeeFlagsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-payee-flags',
    ...options
});

/**
 * Get Charity Payee Flag Detail
 *
 * One payee flag's full detail (queue-row fields + resolution fields).
 */
export const superAdminCharityPayeeFlagsGetCharityPayeeFlagDetail = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailData, ThrowOnError>): RequestResult<SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailResponses, SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailResponses, SuperAdminCharityPayeeFlagsGetCharityPayeeFlagDetailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-payee-flags/{flag_id}',
    ...options
});

/**
 * Approve Charity Payee Flag
 *
 * APPROVE a flagged payee (D-CP-19): record the human clearance, then re-evaluate
 * the deterministic floor with ONLY that reason cleared — a bind follows IFF every
 * OTHER conjunct still passes. Only a NAME_MISMATCH flag is approvable (else 400); a
 * missing flag 404s; an already-resolved flag 400s. The response's ``bind_outcome``
 * reports BOUND / STILL_BLOCKED / PENDING / GATE_OFF.
 */
export const superAdminCharityPayeeFlagsApproveCharityPayeeFlag = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagData, ThrowOnError>): RequestResult<SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagResponses, SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagResponses, SuperAdminCharityPayeeFlagsApproveCharityPayeeFlagErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-payee-flags/{flag_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject Charity Payee Flag
 *
 * REJECT a flagged payee with a required reason → RESOLVED/REJECTED + audit; NO
 * bind. A missing flag 404s; an already-resolved flag 400s.
 */
export const superAdminCharityPayeeFlagsRejectCharityPayeeFlag = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagData, ThrowOnError>): RequestResult<SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagResponses, SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagResponses, SuperAdminCharityPayeeFlagsRejectCharityPayeeFlagErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-payee-flags/{flag_id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Charity Removal Queue
 *
 * The OPEN removal queue — every REQUESTED / IDENTITY_VERIFIED removal request,
 * oldest first (most SLA-pressured), with the requester + charity identity and the
 * SLA timers (age / deadlines / past-due).
 */
export const superAdminCharityRemovalsListCharityRemovalQueue = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminCharityRemovalsListCharityRemovalQueueData, ThrowOnError>): RequestResult<SuperAdminCharityRemovalsListCharityRemovalQueueResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuperAdminCharityRemovalsListCharityRemovalQueueResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-removals',
    ...options
});

/**
 * Get Charity Removal Detail
 *
 * One removal request's full detail (queue-row fields + resolution fields).
 */
export const superAdminCharityRemovalsGetCharityRemovalDetail = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityRemovalsGetCharityRemovalDetailData, ThrowOnError>): RequestResult<SuperAdminCharityRemovalsGetCharityRemovalDetailResponses, SuperAdminCharityRemovalsGetCharityRemovalDetailErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminCharityRemovalsGetCharityRemovalDetailResponses, SuperAdminCharityRemovalsGetCharityRemovalDetailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-removals/{request_id}',
    ...options
});

/**
 * Cancel Charity Removal
 *
 * CANCEL an OPEN removal request with a required reason → status CANCELLED +
 * audit. NO overlay change (``consent_status`` untouched; the charity is NOT
 * removed). A terminal request cannot be cancelled (else 400).
 */
export const superAdminCharityRemovalsCancelCharityRemoval = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityRemovalsCancelCharityRemovalData, ThrowOnError>): RequestResult<SuperAdminCharityRemovalsCancelCharityRemovalResponses, SuperAdminCharityRemovalsCancelCharityRemovalErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityRemovalsCancelCharityRemovalResponses, SuperAdminCharityRemovalsCancelCharityRemovalErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-removals/{request_id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Process Charity Removal
 *
 * PROCESS: IDENTITY_VERIFIED → REMOVED. Flips the ``charity_claim`` overlay to
 * REMOVED (suppresses the unconsented solicitation state; the org reverts to its
 * unclaimed disclosure posture) + stamps ``removed_at``. Removal affects ONLY the
 * disclosure/§318 state — it NEVER blocks payout of money already owed (D-CP-11).
 * Only an IDENTITY_VERIFIED request can be processed (else 400). Returns the REMOVED
 * request.
 */
export const superAdminCharityRemovalsProcessCharityRemoval = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityRemovalsProcessCharityRemovalData, ThrowOnError>): RequestResult<SuperAdminCharityRemovalsProcessCharityRemovalResponses, SuperAdminCharityRemovalsProcessCharityRemovalErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityRemovalsProcessCharityRemovalResponses, SuperAdminCharityRemovalsProcessCharityRemovalErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-removals/{request_id}/process',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Charity Removal Identity
 *
 * VERIFY-IDENTITY: REQUESTED → IDENTITY_VERIFIED. Confirms the requester's
 * authority and starts the 3-business-day process SLA. Only a REQUESTED request can
 * be verified (else 400). Returns the updated request.
 */
export const superAdminCharityRemovalsVerifyCharityRemovalIdentity = <ThrowOnError extends boolean = false>(options: Options<SuperAdminCharityRemovalsVerifyCharityRemovalIdentityData, ThrowOnError>): RequestResult<SuperAdminCharityRemovalsVerifyCharityRemovalIdentityResponses, SuperAdminCharityRemovalsVerifyCharityRemovalIdentityErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminCharityRemovalsVerifyCharityRemovalIdentityResponses, SuperAdminCharityRemovalsVerifyCharityRemovalIdentityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/charity-removals/{request_id}/verify-identity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hide Comment
 *
 * Super-admin hide (GF-BE8 / D-GF-11): drop a comment from every consumer
 * comment payload. SAA double-guard — the router `require_superadmin` dependency
 * (403 for a non-super-admin) AND the service `@has_superadmin_permission`.
 * A missing comment → 404. Dark: the drop is a no-op until a comment is hidden.
 */
export const postsHideComment = <ThrowOnError extends boolean = false>(options: Options<PostsHideCommentData, ThrowOnError>): RequestResult<PostsHideCommentResponses, PostsHideCommentErrors, ThrowOnError> => (options.client ?? client).post<PostsHideCommentResponses, PostsHideCommentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/comments/{comment_id}/hide',
    ...options
});

/**
 * Unhide Comment
 *
 * Super-admin unhide (GF-BE8 / D-GF-11): restore a previously hidden comment
 * to consumer payloads. SAA double-guard (router dependency + service decorator).
 * A missing comment → 404.
 */
export const postsUnhideComment = <ThrowOnError extends boolean = false>(options: Options<PostsUnhideCommentData, ThrowOnError>): RequestResult<PostsUnhideCommentResponses, PostsUnhideCommentErrors, ThrowOnError> => (options.client ?? client).post<PostsUnhideCommentResponses, PostsUnhideCommentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/comments/{comment_id}/unhide',
    ...options
});

/**
 * List Charity Partner Category Exclusions
 */
export const connectPartnerCategoryExclusionsListCharityPartnerCategoryExclusions = <ThrowOnError extends boolean = false>(options?: Options<ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsData, ThrowOnError>): RequestResult<ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsResponses, ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsErrors, ThrowOnError> => (options?.client ?? client).get<ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsResponses, ConnectPartnerCategoryExclusionsListCharityPartnerCategoryExclusionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/charity-category-exclusions',
    ...options
});

/**
 * Create Charity Partner Category Exclusion
 */
export const connectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusion = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionData, ThrowOnError>): RequestResult<ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionResponses, ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionErrors, ThrowOnError> => (options.client ?? client).post<ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionResponses, ConnectPartnerCategoryExclusionsCreateCharityPartnerCategoryExclusionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/charity-category-exclusions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Charity Partner Category Exclusion
 */
export const connectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusion = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionData, ThrowOnError>): RequestResult<ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionResponses, ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionErrors, ThrowOnError> => (options.client ?? client).delete<ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionResponses, ConnectPartnerCategoryExclusionsClearCharityPartnerCategoryExclusionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/charity-category-exclusions/{partner_category_key}/{charity_id}',
    ...options
});

/**
 * Re Advise Connect Donation Intent
 *
 * Support-only wrong-charity correction for an already-charged direct
 * Connect intent. The router-wide super-admin marker, the service-level
 * ``@has_superadmin_permission()`` gate, the money-action guard, and the
 * mandatory idempotency key all bind before any grant routing changes.
 */
export const superAdminDonationOpsReAdviseConnectDonationIntent = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsReAdviseConnectDonationIntentData, ThrowOnError>): RequestResult<SuperAdminDonationOpsReAdviseConnectDonationIntentResponses, SuperAdminDonationOpsReAdviseConnectDonationIntentErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDonationOpsReAdviseConnectDonationIntentResponses, SuperAdminDonationOpsReAdviseConnectDonationIntentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/donation-intents/{dn_id}/re-advise',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Partner Applications
 */
export const connectPartnerApplicationsListPartnerApplications = <ThrowOnError extends boolean = false>(options?: Options<ConnectPartnerApplicationsListPartnerApplicationsData, ThrowOnError>): RequestResult<ConnectPartnerApplicationsListPartnerApplicationsResponses, ConnectPartnerApplicationsListPartnerApplicationsErrors, ThrowOnError> => (options?.client ?? client).get<ConnectPartnerApplicationsListPartnerApplicationsResponses, ConnectPartnerApplicationsListPartnerApplicationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/partner-applications',
    ...options
});

/**
 * Create Partner Application
 */
export const connectPartnerApplicationsCreatePartnerApplication = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerApplicationsCreatePartnerApplicationData, ThrowOnError>): RequestResult<ConnectPartnerApplicationsCreatePartnerApplicationResponses, ConnectPartnerApplicationsCreatePartnerApplicationErrors, ThrowOnError> => (options.client ?? client).post<ConnectPartnerApplicationsCreatePartnerApplicationResponses, ConnectPartnerApplicationsCreatePartnerApplicationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/partner-applications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Partner Application
 */
export const connectPartnerApplicationsGetPartnerApplication = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerApplicationsGetPartnerApplicationData, ThrowOnError>): RequestResult<ConnectPartnerApplicationsGetPartnerApplicationResponses, ConnectPartnerApplicationsGetPartnerApplicationErrors, ThrowOnError> => (options.client ?? client).get<ConnectPartnerApplicationsGetPartnerApplicationResponses, ConnectPartnerApplicationsGetPartnerApplicationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/partner-applications/{application_id}',
    ...options
});

/**
 * Update Partner Application
 */
export const connectPartnerApplicationsUpdatePartnerApplication = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerApplicationsUpdatePartnerApplicationData, ThrowOnError>): RequestResult<ConnectPartnerApplicationsUpdatePartnerApplicationResponses, ConnectPartnerApplicationsUpdatePartnerApplicationErrors, ThrowOnError> => (options.client ?? client).patch<ConnectPartnerApplicationsUpdatePartnerApplicationResponses, ConnectPartnerApplicationsUpdatePartnerApplicationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/partner-applications/{application_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decide Partner Application
 */
export const connectPartnerApplicationsDecidePartnerApplication = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerApplicationsDecidePartnerApplicationData, ThrowOnError>): RequestResult<ConnectPartnerApplicationsDecidePartnerApplicationResponses, ConnectPartnerApplicationsDecidePartnerApplicationErrors, ThrowOnError> => (options.client ?? client).post<ConnectPartnerApplicationsDecidePartnerApplicationResponses, ConnectPartnerApplicationsDecidePartnerApplicationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/partner-applications/{application_id}/decide',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Provision Partner Application
 */
export const connectPartnerApplicationsProvisionPartnerApplication = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerApplicationsProvisionPartnerApplicationData, ThrowOnError>): RequestResult<ConnectPartnerApplicationsProvisionPartnerApplicationResponses, ConnectPartnerApplicationsProvisionPartnerApplicationErrors, ThrowOnError> => (options.client ?? client).post<ConnectPartnerApplicationsProvisionPartnerApplicationResponses, ConnectPartnerApplicationsProvisionPartnerApplicationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/partner-applications/{application_id}/provision',
    ...options
});

/**
 * Create Dashboard Invite
 */
export const connectDashboardInvitesCreateDashboardInvite = <ThrowOnError extends boolean = false>(options: Options<ConnectDashboardInvitesCreateDashboardInviteData, ThrowOnError>): RequestResult<ConnectDashboardInvitesCreateDashboardInviteResponses, ConnectDashboardInvitesCreateDashboardInviteErrors, ThrowOnError> => (options.client ?? client).post<ConnectDashboardInvitesCreateDashboardInviteResponses, ConnectDashboardInvitesCreateDashboardInviteErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/partners/{partner_id}/dashboard-invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Partner Promotion Reviews
 */
export const connectPartnerPromotionsListPartnerPromotionReviews = <ThrowOnError extends boolean = false>(options?: Options<ConnectPartnerPromotionsListPartnerPromotionReviewsData, ThrowOnError>): RequestResult<ConnectPartnerPromotionsListPartnerPromotionReviewsResponses, ConnectPartnerPromotionsListPartnerPromotionReviewsErrors, ThrowOnError> => (options?.client ?? client).get<ConnectPartnerPromotionsListPartnerPromotionReviewsResponses, ConnectPartnerPromotionsListPartnerPromotionReviewsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/promotion-reviews',
    ...options
});

/**
 * Open Partner Promotion Review
 */
export const connectPartnerPromotionsOpenPartnerPromotionReview = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerPromotionsOpenPartnerPromotionReviewData, ThrowOnError>): RequestResult<ConnectPartnerPromotionsOpenPartnerPromotionReviewResponses, ConnectPartnerPromotionsOpenPartnerPromotionReviewErrors, ThrowOnError> => (options.client ?? client).post<ConnectPartnerPromotionsOpenPartnerPromotionReviewResponses, ConnectPartnerPromotionsOpenPartnerPromotionReviewErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/promotion-reviews',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Partner Promotion Review
 */
export const connectPartnerPromotionsGetPartnerPromotionReview = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerPromotionsGetPartnerPromotionReviewData, ThrowOnError>): RequestResult<ConnectPartnerPromotionsGetPartnerPromotionReviewResponses, ConnectPartnerPromotionsGetPartnerPromotionReviewErrors, ThrowOnError> => (options.client ?? client).get<ConnectPartnerPromotionsGetPartnerPromotionReviewResponses, ConnectPartnerPromotionsGetPartnerPromotionReviewErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/promotion-reviews/{review_id}',
    ...options
});

/**
 * Decide Partner Promotion Review
 */
export const connectPartnerPromotionsDecidePartnerPromotionReview = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerPromotionsDecidePartnerPromotionReviewData, ThrowOnError>): RequestResult<ConnectPartnerPromotionsDecidePartnerPromotionReviewResponses, ConnectPartnerPromotionsDecidePartnerPromotionReviewErrors, ThrowOnError> => (options.client ?? client).post<ConnectPartnerPromotionsDecidePartnerPromotionReviewResponses, ConnectPartnerPromotionsDecidePartnerPromotionReviewErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/promotion-reviews/{review_id}/decide',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Partner Promotion Review Item
 */
export const connectPartnerPromotionsUpdatePartnerPromotionReviewItem = <ThrowOnError extends boolean = false>(options: Options<ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemData, ThrowOnError>): RequestResult<ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemResponses, ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemErrors, ThrowOnError> => (options.client ?? client).patch<ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemResponses, ConnectPartnerPromotionsUpdatePartnerPromotionReviewItemErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/connect/promotion-reviews/{review_id}/items/{criterion_key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Content Reports
 *
 * Newest-first surface-agnostic content-report moderation queue.
 *
 * Filters (all optional, composing): ``subject_type``, ``category``, ``status``,
 * ``subject_id`` (every report on ONE subject). Pagination ``page[limit]``
 * (hard-capped at 200 — over-cap → 422) / ``page[offset]``. Sorted ``created_at``
 * desc with an ``-id`` tiebreaker. Each row carries the per-subject aggregate
 * ``report_count`` — the TOTAL reports on that ``(subject_type, subject_id)``,
 * independent of the active filters (a ``status`` / ``category`` filter narrows the
 * listed rows, not the per-subject total), mirroring the SA post queue — plus
 * ``last_reported_at``.
 *
 * ``q`` is a case-insensitive substring match over ``comment`` +
 * ``subject_id``::text + ``reporter_user_id``::text. LIMITATION: unlike the
 * post-specific ``GET /super-admin/posts`` ``q`` (which joins post text / author /
 * target names), this generalized queue CANNOT search the subject's CONTENT — the
 * ``content_report`` aggregate stores only the subject REFERENCE, not its text.
 * Cross-surface content search (per-``subject_type`` content joins) is a future
 * enhancement the aggregate deliberately does not carry.
 *
 * Empty aggregate ⇒ empty list (never an error): the aggregate is dark until the
 * dual-write flag flips + reads cut over (UGC-BE1c). Super-admin only.
 */
export const superAdminContentReportsListContentReports = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminContentReportsListContentReportsData, ThrowOnError>): RequestResult<SuperAdminContentReportsListContentReportsResponses, SuperAdminContentReportsListContentReportsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminContentReportsListContentReportsResponses, SuperAdminContentReportsListContentReportsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/content-reports',
    ...options
});

/**
 * List Daf Transfer Arrivals
 */
export const superAdminDafTransfersListDafTransferArrivals = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminDafTransfersListDafTransferArrivalsData, ThrowOnError>): RequestResult<SuperAdminDafTransfersListDafTransferArrivalsResponses, SuperAdminDafTransfersListDafTransferArrivalsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminDafTransfersListDafTransferArrivalsResponses, SuperAdminDafTransfersListDafTransferArrivalsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/arrivals',
    ...options
});

/**
 * Register Daf Transfer Arrival
 */
export const superAdminDafTransfersRegisterDafTransferArrival = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersRegisterDafTransferArrivalData, ThrowOnError>): RequestResult<SuperAdminDafTransfersRegisterDafTransferArrivalResponses, SuperAdminDafTransfersRegisterDafTransferArrivalErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDafTransfersRegisterDafTransferArrivalResponses, SuperAdminDafTransfersRegisterDafTransferArrivalErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/arrivals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Daf Transfer Arrival Aging
 */
export const superAdminDafTransfersListDafTransferArrivalAging = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminDafTransfersListDafTransferArrivalAgingData, ThrowOnError>): RequestResult<SuperAdminDafTransfersListDafTransferArrivalAgingResponses, SuperAdminDafTransfersListDafTransferArrivalAgingErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminDafTransfersListDafTransferArrivalAgingResponses, SuperAdminDafTransfersListDafTransferArrivalAgingErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/arrivals/aging',
    ...options
});

/**
 * Get Daf Transfer Arrival
 */
export const superAdminDafTransfersGetDafTransferArrival = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersGetDafTransferArrivalData, ThrowOnError>): RequestResult<SuperAdminDafTransfersGetDafTransferArrivalResponses, SuperAdminDafTransfersGetDafTransferArrivalErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminDafTransfersGetDafTransferArrivalResponses, SuperAdminDafTransfersGetDafTransferArrivalErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/arrivals/{arrival_id}',
    ...options
});

/**
 * List Daf Transfer Arrival Candidates
 */
export const superAdminDafTransfersListDafTransferArrivalCandidates = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersListDafTransferArrivalCandidatesData, ThrowOnError>): RequestResult<SuperAdminDafTransfersListDafTransferArrivalCandidatesResponses, SuperAdminDafTransfersListDafTransferArrivalCandidatesErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminDafTransfersListDafTransferArrivalCandidatesResponses, SuperAdminDafTransfersListDafTransferArrivalCandidatesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/arrivals/{arrival_id}/candidates',
    ...options
});

/**
 * Credit Daf Transfer Arrival
 */
export const superAdminDafTransfersCreditDafTransferArrival = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersCreditDafTransferArrivalData, ThrowOnError>): RequestResult<SuperAdminDafTransfersCreditDafTransferArrivalResponses, SuperAdminDafTransfersCreditDafTransferArrivalErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDafTransfersCreditDafTransferArrivalResponses, SuperAdminDafTransfersCreditDafTransferArrivalErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/arrivals/{arrival_id}/credit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link Daf Transfer Arrival
 *
 * IDT-BE16: record a GCF officer's attested link between a paper arrival and a
 * donor's transfer intent (decision D-IDT-24).
 *
 * The officer states, in one act, that they read the instrument once, that its
 * designation is precatory, the amount it states, and the account intent it names.
 * That recorded reading is what lets the automated lane execute the credit at
 * settlement on evidence rather than on a named residual — and it is why the two
 * assertions are required True at the wire: a False is not a weaker attestation, it is
 * the absence of one.
 *
 * Outcomes: `201` on BOTH the first link (`created=true`) and an identical repeat
 * (`created=false`) — the vertical's `created` convention, matching its sibling
 * `POST /daf-transfers/arrivals`, which also answers 201 to an idempotent duplicate.
 * Branch on the `created` field, never on the status code. `409` when the arrival is
 * no longer pre-credit, or when a
 * different live attestation already stands; `400` when the intent is missing,
 * malformed, or not OPEN; `422` with `attestation_memo_restriction_language` when the
 * memo carries mandatory or restrictive language — surface that one verbatim, because
 * the operator is holding the letter and the next step is a clean re-issue from the
 * sponsor, not a retry.
 *
 * Does NOT transition the intent. The intent closes at CREDIT, via `mark_matched`, and
 * closing it here would strand the donor's tracker on an attribution that has not been
 * paid yet.
 */
export const superAdminDafTransfersLinkDafTransferArrival = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersLinkDafTransferArrivalData, ThrowOnError>): RequestResult<SuperAdminDafTransfersLinkDafTransferArrivalResponses, SuperAdminDafTransfersLinkDafTransferArrivalErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDafTransfersLinkDafTransferArrivalResponses, SuperAdminDafTransfersLinkDafTransferArrivalErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/arrivals/{arrival_id}/link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Daf Transfer Arrival Link
 *
 * IDT-BE17: withdraw a GCF officer's attested link — the mis-link correction.
 *
 * In ONE unit of work: the attestation is revoked and kept as history; the arrival
 * returns to `SUSPENSE` with `intent_id` cleared and `deposited_date` KEPT; this
 * instrument's `RECEIVED`/`DEPOSITED` on the wrongly-linked intent are voided
 * (first-wins) so that donor's tracker, the aging queue and the learned median stop
 * seeing them; the REQUIRED, donor-visible `donor_note` lands on that intent as an
 * `OPS_NOTE` — write it to the donor, never naming the other donor, sponsor or amount;
 * and the REQUIRED, internal `internal_note` (the real cause) lands on the ARRIVAL's
 * operator-only outreach log, never on a donor surface.
 *
 * Outcomes: `200` with the attestation as it now stands (`revoked_at` set) plus
 * `events_voided`; `409` `arrival_already_credited` when money already moved; `409`
 * `arrival_not_linked` when no live link stands — never linked, or already revoked
 * (a second revoke is a conflict, not a silent success); `404` (no oracle) on an
 * unknown or malformed arrival id; `422` on a missing or blank note of either kind.
 * Re-linking afterwards — to the right intent, or the same one — is the ordinary link
 * route.
 */
export const superAdminDafTransfersRevokeDafTransferArrivalLink = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersRevokeDafTransferArrivalLinkData, ThrowOnError>): RequestResult<SuperAdminDafTransfersRevokeDafTransferArrivalLinkResponses, SuperAdminDafTransfersRevokeDafTransferArrivalLinkErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDafTransfersRevokeDafTransferArrivalLinkResponses, SuperAdminDafTransfersRevokeDafTransferArrivalLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/arrivals/{arrival_id}/link/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Daf Transfer Arrival Notes
 */
export const superAdminDafTransfersListDafTransferArrivalNotes = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersListDafTransferArrivalNotesData, ThrowOnError>): RequestResult<SuperAdminDafTransfersListDafTransferArrivalNotesResponses, SuperAdminDafTransfersListDafTransferArrivalNotesErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminDafTransfersListDafTransferArrivalNotesResponses, SuperAdminDafTransfersListDafTransferArrivalNotesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/arrivals/{arrival_id}/notes',
    ...options
});

/**
 * Append Daf Transfer Arrival Note
 */
export const superAdminDafTransfersAppendDafTransferArrivalNote = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersAppendDafTransferArrivalNoteData, ThrowOnError>): RequestResult<SuperAdminDafTransfersAppendDafTransferArrivalNoteResponses, SuperAdminDafTransfersAppendDafTransferArrivalNoteErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDafTransfersAppendDafTransferArrivalNoteResponses, SuperAdminDafTransfersAppendDafTransferArrivalNoteErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/arrivals/{arrival_id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register Daf Transfer Intent
 */
export const superAdminDafTransfersRegisterDafTransferIntent = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersRegisterDafTransferIntentData, ThrowOnError>): RequestResult<SuperAdminDafTransfersRegisterDafTransferIntentResponses, SuperAdminDafTransfersRegisterDafTransferIntentErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDafTransfersRegisterDafTransferIntentResponses, SuperAdminDafTransfersRegisterDafTransferIntentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/intents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Daf Transfer Intent Aging
 *
 * PII-minimal, cross-user OPEN-intent aging queue, oldest clock first.
 */
export const superAdminDafTransfersListDafTransferIntentAging = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminDafTransfersListDafTransferIntentAgingData, ThrowOnError>): RequestResult<SuperAdminDafTransfersListDafTransferIntentAgingResponses, SuperAdminDafTransfersListDafTransferIntentAgingErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminDafTransfersListDafTransferIntentAgingResponses, SuperAdminDafTransfersListDafTransferIntentAgingErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/intents/aging',
    ...options
});

/**
 * Close Daf Transfer Intent
 *
 * IDT-BE15: close an OPEN intent no chokepoint will ever close by itself.
 *
 * Every other terminal transition needs something this intent does not have: the
 * consumer `DELETE .../intents/{id}` cancel is the OWNER's, and BE5's
 * `mark_matched` fires only when a credit carries the `intent_id` linkage. The
 * console credit flow does not send one (IDT-WEB3), so a console-credited case
 * strands its intent OPEN forever — it keeps aging on the super-admin intent
 * queue, keeps minting operator-review rows, and keeps its owner in the BE4
 * candidate pool for later arrivals from the same sponsor. This is the operator's
 * way out, and closing removes the intent from all three at once because every one
 * of them reads the same OPEN-only repository predicate.
 *
 * Disposition semantics: `MATCHED` = fulfilled out of band; `EXPIRED` = the
 * transfer never arrived / abandoned after the aging window; `CANCELLED` =
 * registered in error, or the donor withdrew the notice through support.
 *
 * ⚠ `note` is REQUIRED and **donor-visible** — see `DafTransferIntentCloseRequest`.
 * Closing freezes the donor's tracker where it stood, and this note is the only
 * thing that explains why; write it to the donor.
 *
 * Closing is NOT idempotent: a second close returns 409, like any other attempt
 * against a terminal status.
 */
export const superAdminDafTransfersCloseDafTransferIntent = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersCloseDafTransferIntentData, ThrowOnError>): RequestResult<SuperAdminDafTransfersCloseDafTransferIntentResponses, SuperAdminDafTransfersCloseDafTransferIntentErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDafTransfersCloseDafTransferIntentResponses, SuperAdminDafTransfersCloseDafTransferIntentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/intents/{intent_id}/close',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Append Daf Transfer Event
 */
export const superAdminDafTransfersAppendDafTransferEvent = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersAppendDafTransferEventData, ThrowOnError>): RequestResult<SuperAdminDafTransfersAppendDafTransferEventResponses, SuperAdminDafTransfersAppendDafTransferEventErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDafTransfersAppendDafTransferEventResponses, SuperAdminDafTransfersAppendDafTransferEventErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/intents/{intent_id}/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Daf Transfer User Candidates By Name
 *
 * IDT-BE11: the users a name off DAF grant paperwork could refer to.
 *
 * Hosted on the DAF `super_admin_router` — not beside the other super-admin
 * user surfaces in `super_admin_donation_ops.py` — for two reasons. (1) It
 * inherits this router's STRUCTURAL dark gate: while `DAF_TRANSFER_INTAKE_
 * ENABLED` is off the path 404s before super-admin auth can reveal it exists,
 * so the operator surface and the internal MCP tool are gated identically
 * rather than one being live in prod while the other is dark. (2) A name
 * search over the user directory is a broader PII read than the exact-email
 * lookup (which requires already knowing the address), and this is the DAF
 * triage use case that justifies it — keeping it here keeps that scope visible.
 *
 * Read-only and money-free: candidates only. It resolves nothing, and the
 * credit chokepoint is elsewhere and unchanged.
 *
 * ⚠ `total_matched == 0` means "no stored name normalizes to exactly this",
 * NOT "this person has no Givmo account". Matching is exact, so a married,
 * hyphenated or suffixed surname, or a nickname on the paperwork, reads as
 * zero. Search `last_name` alone first — it is the selective and more stable
 * term — and add `first_name` only to narrow a multi-hit.
 */
export const superAdminDafTransfersSearchDafTransferUserCandidatesByName = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameData, ThrowOnError>): RequestResult<SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameResponses, SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameResponses, SuperAdminDafTransfersSearchDafTransferUserCandidatesByNameErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/daf-transfers/users/search-by-name',
    ...options
});

/**
 * List Disclaimers
 */
export const disclaimersListDisclaimers = <ThrowOnError extends boolean = false>(options?: Options<DisclaimersListDisclaimersData, ThrowOnError>): RequestResult<DisclaimersListDisclaimersResponses, DisclaimersListDisclaimersErrors, ThrowOnError> => (options?.client ?? client).get<DisclaimersListDisclaimersResponses, DisclaimersListDisclaimersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/disclaimers',
    ...options
});

/**
 * Publish Disclaimer At Super Admin
 *
 * Create a DRAFT disclaimer. Publisher-gated (TERMS_PUBLISHERS_WHITE_LIST,
 * enforced at the service layer).
 */
export const disclaimersPublishDisclaimerAtSuperAdmin = <ThrowOnError extends boolean = false>(options: Options<DisclaimersPublishDisclaimerAtSuperAdminData, ThrowOnError>): RequestResult<DisclaimersPublishDisclaimerAtSuperAdminResponses, DisclaimersPublishDisclaimerAtSuperAdminErrors, ThrowOnError> => (options.client ?? client).post<DisclaimersPublishDisclaimerAtSuperAdminResponses, DisclaimersPublishDisclaimerAtSuperAdminErrors, ThrowOnError>({
    url: '/super-admin/disclaimers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Disclaimer Detail
 */
export const disclaimersGetDisclaimerDetail = <ThrowOnError extends boolean = false>(options: Options<DisclaimersGetDisclaimerDetailData, ThrowOnError>): RequestResult<DisclaimersGetDisclaimerDetailResponses, DisclaimersGetDisclaimerDetailErrors, ThrowOnError> => (options.client ?? client).get<DisclaimersGetDisclaimerDetailResponses, DisclaimersGetDisclaimerDetailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/disclaimers/{document_id}',
    ...options
});

/**
 * Patch Disclaimer Draft At Super Admin
 *
 * Update a DRAFT document's content. Immutable once LIVE (409).
 */
export const disclaimersPatchDisclaimerDraftAtSuperAdmin = <ThrowOnError extends boolean = false>(options: Options<DisclaimersPatchDisclaimerDraftAtSuperAdminData, ThrowOnError>): RequestResult<DisclaimersPatchDisclaimerDraftAtSuperAdminResponses, DisclaimersPatchDisclaimerDraftAtSuperAdminErrors, ThrowOnError> => (options.client ?? client).patch<DisclaimersPatchDisclaimerDraftAtSuperAdminResponses, DisclaimersPatchDisclaimerDraftAtSuperAdminErrors, ThrowOnError>({
    url: '/super-admin/disclaimers/{document_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Disclaimer Effective At Super Admin
 *
 * Flip a DRAFT document LIVE. Requires a non-empty sign-off.
 */
export const disclaimersSetDisclaimerEffectiveAtSuperAdmin = <ThrowOnError extends boolean = false>(options: Options<DisclaimersSetDisclaimerEffectiveAtSuperAdminData, ThrowOnError>): RequestResult<DisclaimersSetDisclaimerEffectiveAtSuperAdminResponses, DisclaimersSetDisclaimerEffectiveAtSuperAdminErrors, ThrowOnError> => (options.client ?? client).post<DisclaimersSetDisclaimerEffectiveAtSuperAdminResponses, DisclaimersSetDisclaimerEffectiveAtSuperAdminErrors, ThrowOnError>({
    url: '/super-admin/disclaimers/{document_id}/set-effective',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Payment Method Report
 *
 * ER-BE54: the donations and the wallet deposits booked in a window, each counted
 * and summed by payment method and counted by amount band.
 *
 * The window is ``from_date`` through ``to_date``, whole days in ``tz``, read on each
 * row's ``created_at``. A donation payment is one gift's legs on one payment (a gift
 * split across charities counts once; ``row_count`` counts its rows), and a wallet
 * deposit is one row. ``amount_charged`` is what the payment method was charged,
 * ``amount_entered`` the amount chosen, and a payment's band is read from its
 * ``amount_entered``. An EXTERNAL donation, a gift made off Givmo and only recorded on
 * it, is no payment: Givmo charged nothing for it, so it is counted apart in
 * ``external_donations`` (with no charged figure) and is in none of ``donations``'
 * figures. Every row booked in the window counts, a test account's included; a later
 * refund is not subtracted. The two payment sections are never added together: a
 * wallet donation spends a balance a wallet deposit funded.
 */
export const superAdminDonationOpsGetPaymentMethodReport = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsGetPaymentMethodReportData, ThrowOnError>): RequestResult<SuperAdminDonationOpsGetPaymentMethodReportResponses, SuperAdminDonationOpsGetPaymentMethodReportErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminDonationOpsGetPaymentMethodReportResponses, SuperAdminDonationOpsGetPaymentMethodReportErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/donations/by-payment-method',
    ...options
});

/**
 * Get Claim Conversion
 *
 * GCR-READ1: guest→account conversion rate over ``donation_claim_token``.
 * ``from_date`` / ``to_date`` (ISO ``YYYY-MM-DD``) bound an inclusive-day
 * ``created_at`` window; both optional → no lower / upper bound respectively.
 */
export const superAdminDonationOpsGetClaimConversion = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminDonationOpsGetClaimConversionData, ThrowOnError>): RequestResult<SuperAdminDonationOpsGetClaimConversionResponses, SuperAdminDonationOpsGetClaimConversionErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminDonationOpsGetClaimConversionResponses, SuperAdminDonationOpsGetClaimConversionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/donations/claim-conversion',
    ...options
});

/**
 * Clear Donation Disbursement Hold
 *
 * Clear all disbursement-hold fields; already-clear rows are unchanged.
 */
export const superAdminDonationOpsClearDonationDisbursementHold = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsClearDonationDisbursementHoldData, ThrowOnError>): RequestResult<SuperAdminDonationOpsClearDonationDisbursementHoldResponses, SuperAdminDonationOpsClearDonationDisbursementHoldErrors, ThrowOnError> => (options.client ?? client).delete<SuperAdminDonationOpsClearDonationDisbursementHoldResponses, SuperAdminDonationOpsClearDonationDisbursementHoldErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/donations/{donation_id}/disbursement-hold',
    ...options
});

/**
 * Set Donation Disbursement Hold
 *
 * Set or replace the structured hold on automatic cohort admission.
 */
export const superAdminDonationOpsSetDonationDisbursementHold = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsSetDonationDisbursementHoldData, ThrowOnError>): RequestResult<SuperAdminDonationOpsSetDonationDisbursementHoldResponses, SuperAdminDonationOpsSetDonationDisbursementHoldErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDonationOpsSetDonationDisbursementHoldResponses, SuperAdminDonationOpsSetDonationDisbursementHoldErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/donations/{donation_id}/disbursement-hold',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Operator List Enrollments
 *
 * Every enrollment record, newest first.
 *
 * `store_copy_pending=true` is the COPY BACKLOG: provisioned records whose second
 * home is unwritten. Neither filter defaults to a subset — an unfiltered read is
 * every record, so an operator who asks for nothing in particular is not shown a
 * silently narrowed view.
 */
export const superAdminEntityEnrollmentsOperatorListEnrollments = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminEntityEnrollmentsOperatorListEnrollmentsData, ThrowOnError>): RequestResult<SuperAdminEntityEnrollmentsOperatorListEnrollmentsResponses, SuperAdminEntityEnrollmentsOperatorListEnrollmentsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminEntityEnrollmentsOperatorListEnrollmentsResponses, SuperAdminEntityEnrollmentsOperatorListEnrollmentsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/entity-enrollments',
    ...options
});

/**
 * Operator Create For Profit Enrollment
 *
 * Create a for_profit enrollment. Creation IS the approval act.
 *
 * Both halves land in one unit of work, so a creation that cannot be approved leaves
 * no record at all — while the rule-pack provider is unfilled this answers 503 and
 * writes nothing, rather than leaving behind an unapproved record holding a permanent
 * ledger identity nothing can use.
 *
 * ⚠ `fiscal_year_end_month` is passed through, and it is worth stating why the line
 * matters: this handler used to accept, document and range-check it and then DROP it.
 * On the charity path the same defect had a cure — the field settles at submission and
 * a PATCH can supply it — but this record is born past `draft`, there is no submission
 * and there is no operator PATCH route, so a dropped answer silently became the
 * calendar-year default with no way back. The books fold a period into a fiscal year
 * with it, and after they are opened it can no longer be changed.
 */
export const superAdminEntityEnrollmentsOperatorCreateForProfitEnrollment = <ThrowOnError extends boolean = false>(options: Options<SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentData, ThrowOnError>): RequestResult<SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentResponses, SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentResponses, SuperAdminEntityEnrollmentsOperatorCreateForProfitEnrollmentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/entity-enrollments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Operator Get Enrollment
 *
 * One record with its full event log and the platform facts behind it.
 */
export const superAdminEntityEnrollmentsOperatorGetEnrollment = <ThrowOnError extends boolean = false>(options: Options<SuperAdminEntityEnrollmentsOperatorGetEnrollmentData, ThrowOnError>): RequestResult<SuperAdminEntityEnrollmentsOperatorGetEnrollmentResponses, SuperAdminEntityEnrollmentsOperatorGetEnrollmentErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminEntityEnrollmentsOperatorGetEnrollmentResponses, SuperAdminEntityEnrollmentsOperatorGetEnrollmentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/entity-enrollments/{enrollment_id}',
    ...options
});

/**
 * Operator Start Import Run
 *
 * Bring history in for a record with no charity membership behind it (CBO-IN4).
 *
 * The for_profit class's door onto the same run the charity surface drives — GivFi's,
 * in practice. It exists because that class has no charity membership, so its caller
 * cannot reach the charity-scoped function at all; the operator's provisioning re-drive
 * beside it has exactly the same shape for exactly the same reason.
 *
 * `idempotency_key` is required here too. The operator is not exempt from the guard that
 * stops a second run posting a second copy of a window's history.
 */
export const superAdminEntityEnrollmentsOperatorStartImportRun = <ThrowOnError extends boolean = false>(options: Options<SuperAdminEntityEnrollmentsOperatorStartImportRunData, ThrowOnError>): RequestResult<SuperAdminEntityEnrollmentsOperatorStartImportRunResponses, SuperAdminEntityEnrollmentsOperatorStartImportRunErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminEntityEnrollmentsOperatorStartImportRunResponses, SuperAdminEntityEnrollmentsOperatorStartImportRunErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/entity-enrollments/{enrollment_id}/import-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Operator Redrive Provision
 *
 * Re-run the provisioning protocol from the record's approved anchor.
 *
 * The cure for every crash window the protocol has: a first drive that never reached
 * the store, a store leg that committed with nothing bound on this side, or books that
 * want re-folding. The same act as a first drive rather than a special one — the store
 * leg settles idempotently and re-folds the whole chain on the way.
 *
 * No body: everything the act needs is already on the record and its approval row, and
 * a body would be a place for a caller to supply something the approval did not pin.
 */
export const superAdminEntityEnrollmentsOperatorRedriveProvision = <ThrowOnError extends boolean = false>(options: Options<SuperAdminEntityEnrollmentsOperatorRedriveProvisionData, ThrowOnError>): RequestResult<SuperAdminEntityEnrollmentsOperatorRedriveProvisionResponses, SuperAdminEntityEnrollmentsOperatorRedriveProvisionErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminEntityEnrollmentsOperatorRedriveProvisionResponses, SuperAdminEntityEnrollmentsOperatorRedriveProvisionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/entity-enrollments/{enrollment_id}/provision-redrive',
    ...options
});

/**
 * Operator Reject Enrollment
 *
 * Reject a submitted record, with the recorded reason.
 *
 * From `submitted` and nowhere else: a rejection disposes of a request that was
 * actually made, so there is no path from a draft nobody has submitted and none from
 * an approved record whose ledger identity may already be in the store.
 */
export const superAdminEntityEnrollmentsOperatorRejectEnrollment = <ThrowOnError extends boolean = false>(options: Options<SuperAdminEntityEnrollmentsOperatorRejectEnrollmentData, ThrowOnError>): RequestResult<SuperAdminEntityEnrollmentsOperatorRejectEnrollmentResponses, SuperAdminEntityEnrollmentsOperatorRejectEnrollmentErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminEntityEnrollmentsOperatorRejectEnrollmentResponses, SuperAdminEntityEnrollmentsOperatorRejectEnrollmentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/entity-enrollments/{enrollment_id}/rejection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Operator Redrive Store Copy
 *
 * Write the second home for a provisioned record whose done-flag is still NULL.
 *
 * The act the `store_copy_pending=true` listing exists to make reachable. Separate from
 * the provision re-drive above because the record is already bound and canonical: the
 * only thing missing is the entity's own copy.
 */
export const superAdminEntityEnrollmentsOperatorRedriveStoreCopy = <ThrowOnError extends boolean = false>(options: Options<SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyData, ThrowOnError>): RequestResult<SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyResponses, SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyResponses, SuperAdminEntityEnrollmentsOperatorRedriveStoreCopyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/entity-enrollments/{enrollment_id}/store-copy-redrive',
    ...options
});

/**
 * Get Super Admin Fundraisers
 */
export const fundraisersGetSuperAdminFundraisers = <ThrowOnError extends boolean = false>(options?: Options<FundraisersGetSuperAdminFundraisersData, ThrowOnError>): RequestResult<FundraisersGetSuperAdminFundraisersResponses, FundraisersGetSuperAdminFundraisersErrors, ThrowOnError> => (options?.client ?? client).get<FundraisersGetSuperAdminFundraisersResponses, FundraisersGetSuperAdminFundraisersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/fundraisers',
    ...options
});

/**
 * List Fundraiser Message Objections
 *
 * The objection review queue (FCA-BE9), narrowed by ``status`` (default OPEN),
 * oldest first (most-aged = most SLA-pressured), each row carrying the objecting
 * charity id, the fundraiser name, the intake reason, and the queue age. An unknown
 * ``status`` value 422s.
 */
export const superAdminFundraiserMessageObjectionsListFundraiserMessageObjections = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsData, ThrowOnError>): RequestResult<SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsResponses, SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsResponses, SuperAdminFundraiserMessageObjectionsListFundraiserMessageObjectionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/fundraisers/message-objections',
    ...options
});

/**
 * Admin Deactivate Fundraiser
 */
export const fundraisersAdminDeactivateFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersAdminDeactivateFundraiserData, ThrowOnError>): RequestResult<FundraisersAdminDeactivateFundraiserResponses, FundraisersAdminDeactivateFundraiserErrors, ThrowOnError> => (options.client ?? client).post<FundraisersAdminDeactivateFundraiserResponses, FundraisersAdminDeactivateFundraiserErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/fundraisers/{fundraiser_id}/deactivate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Super Admin Fundraiser Donations
 */
export const fundraisersGetSuperAdminFundraiserDonations = <ThrowOnError extends boolean = false>(options: Options<FundraisersGetSuperAdminFundraiserDonationsData, ThrowOnError>): RequestResult<FundraisersGetSuperAdminFundraiserDonationsResponses, FundraisersGetSuperAdminFundraiserDonationsErrors, ThrowOnError> => (options.client ?? client).get<FundraisersGetSuperAdminFundraiserDonationsResponses, FundraisersGetSuperAdminFundraiserDonationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/fundraisers/{fundraiser_id}/donations',
    ...options
});

/**
 * Resolve Fundraiser Message Objection
 *
 * RESOLVE an objection (FCA-BE9): ``takedown`` keeps the message dark (status
 * TAKEN_DOWN, still suppresses); ``reinstate`` restores it (status REINSTATED, no
 * longer suppresses). ``objection_id`` MUST belong to ``fundraiser_id`` (else 404,
 * no cross-fundraiser oracle). ``note`` is optional audit context. Suppression is
 * ``EXISTS(OPEN or TAKEN_DOWN)`` across a fundraiser's objections, so reinstating
 * one lifts suppression only when no other OPEN/TAKEN_DOWN objection remains.
 */
export const superAdminFundraiserMessageObjectionsResolveFundraiserMessageObjection = <ThrowOnError extends boolean = false>(options: Options<SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionData, ThrowOnError>): RequestResult<SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionResponses, SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionResponses, SuperAdminFundraiserMessageObjectionsResolveFundraiserMessageObjectionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/fundraisers/{fundraiser_id}/message-objections/{objection_id}/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Reinstate Fundraiser
 *
 * Undo Givmo's takedown of a fundraiser: it returns to the state it had before the
 * takedown (a closed one stays closed, a never-published one a draft), and its
 * organizers are emailed. The pending invites the takedown revoked do not come back,
 * and neither does a cover the admin deleted with the takedown's `delete_cover_image`.
 */
export const fundraisersAdminReinstateFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersAdminReinstateFundraiserData, ThrowOnError>): RequestResult<FundraisersAdminReinstateFundraiserResponses, FundraisersAdminReinstateFundraiserErrors, ThrowOnError> => (options.client ?? client).post<FundraisersAdminReinstateFundraiserResponses, FundraisersAdminReinstateFundraiserErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/fundraisers/{fundraiser_id}/reinstate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Gift Cards Super Admin
 *
 * Paginated list of gift cards for the super-admin portal, with optional
 * status / channel / funding / batch_id filters. The response never carries
 * a plaintext code or code_hash (GiftCardAdminOut exposes code_last4 only).
 *
 * `q` is a case-insensitive substring match across code_last4, purchaser name,
 * purchaser email, recipient name, recipient email, and id, applied server-side
 * (composing with the status/channel/funding/batch filters) so the client can
 * search + page the whole corpus instead of loading everything and searching
 * in-memory.
 */
export const giftCardsListGiftCardsSuperAdmin = <ThrowOnError extends boolean = false>(options?: Options<GiftCardsListGiftCardsSuperAdminData, ThrowOnError>): RequestResult<GiftCardsListGiftCardsSuperAdminResponses, GiftCardsListGiftCardsSuperAdminErrors, ThrowOnError> => (options?.client ?? client).get<GiftCardsListGiftCardsSuperAdminResponses, GiftCardsListGiftCardsSuperAdminErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/gift-cards',
    ...options
});

/**
 * Manual Issue Gift Card
 *
 * Manually issue an ADMIN_ISSUED card (soft-launch / B2B / promo). No
 * charge, no receipt, no velocity window; a delivery email carries the
 * code.
 */
export const giftCardsManualIssueGiftCard = <ThrowOnError extends boolean = false>(options: Options<GiftCardsManualIssueGiftCardData, ThrowOnError>): RequestResult<GiftCardsManualIssueGiftCardResponses, GiftCardsManualIssueGiftCardErrors, ThrowOnError> => (options.client ?? client).post<GiftCardsManualIssueGiftCardResponses, GiftCardsManualIssueGiftCardErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/gift-cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reissue Failed Batch Deliveries
 *
 * EP-BE4 bulk recovery: void + reissue every card in this employer batch whose
 * async delivery is terminally FAILED and which is still ACTIVE, re-delivering the
 * replacements through the SAME async Cloud Tasks path the original bulk send used
 * (never N synchronous sends). 202 with the per-stage counts + the replacement ids.
 *
 * Modeled on `POST /super-admin/terms/{id}/notify/retry-failed-batches`: 202,
 * failed units only, in-flight units untouched. `Idempotency-Key` is REQUIRED (a
 * missing header 422s) and `claim_idempotency` replays the original 202 for a
 * retried call, so a lost response never re-mints a second set of codes.
 *
 * Recovery is void+reissue rather than a re-drive because a gift card's plaintext
 * code is request-scoped and never stored — no sweep can ever re-deliver the code
 * a failed card was carrying, so the only honest repair is a fresh one.
 *
 * NO money moves: no charge, no wallet debit, no receipt, no velocity check. A
 * re-run is safe by construction (the ACTIVE half of the selector drops
 * already-recovered cards), and per-card transactionality means one bad row never
 * strands the rest of the batch's recipients. Deliberately NOT gated on
 * `COMPANY_GIFT_CARDS_ENABLED`: it is the bulk form of the un-gated per-card
 * `PUT .../void` + `POST .../reissue` recovery pair, and an operator flipping the
 * employer kill switch during an incident must not thereby lose the remediation
 * tool. With no batches in an environment it simply 404s.
 */
export const giftCardsReissueFailedBatchDeliveries = <ThrowOnError extends boolean = false>(options: Options<GiftCardsReissueFailedBatchDeliveriesData, ThrowOnError>): RequestResult<GiftCardsReissueFailedBatchDeliveriesResponses, GiftCardsReissueFailedBatchDeliveriesErrors, ThrowOnError> => (options.client ?? client).post<GiftCardsReissueFailedBatchDeliveriesResponses, GiftCardsReissueFailedBatchDeliveriesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/gift-cards/batches/{batch_id}/reissue-failed',
    ...options
});

/**
 * Reissue Gift Card
 *
 * Void the original and mint a fresh ACTIVE card with a new code,
 * redelivering it. Returns the new card.
 *
 * GC-FU7: the optional body corrects the replacement's recipient (support's remedy
 * for a mistyped address, D-GC-8). Each field given replaces the original's; absent
 * or null keeps it, so no body (or ``{}``) reissues exactly as before, and a field equal
 * to the card's own value counts as absent. An unknown key is a 422. The voided
 * original keeps its old address, the purchaser never changes, and no money moves.
 * A code-less scheduled card, refused without a correction, takes one: its
 * replacement stays scheduled for the same date, at the corrected address.
 *
 * Honors the ``Idempotency-Key`` header (presence-triggered, 02·F2): a
 * retried reissue carrying the same key replays the original 201 rather than
 * re-voiding/re-minting and re-sending the delivery email, so a lost response
 * is safe to retry. The fingerprint covers the body, so the same key with a
 * different correction is a 409 ``IDEMPOTENCY_KEY_REUSED`` that runs nothing;
 * the super-admin client mints one key per intent (the card and its correction),
 * so a changed address is a new key. The response is ``GiftCardAdminOut``, which
 * never carries the plaintext code, so the cached replay is safe. An unkeyed
 * request passes through unprotected (its retry still 400s on the already-voided
 * original — the void state machine remains the floor).
 */
export const giftCardsReissueGiftCard = <ThrowOnError extends boolean = false>(options: Options<GiftCardsReissueGiftCardData, ThrowOnError>): RequestResult<GiftCardsReissueGiftCardResponses, GiftCardsReissueGiftCardErrors, ThrowOnError> => (options.client ?? client).post<GiftCardsReissueGiftCardResponses, GiftCardsReissueGiftCardErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/gift-cards/{gift_card_id}/reissue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Void Gift Card
 *
 * Void an INACTIVE/ACTIVE card. A REDEEMED card cannot be voided (400).
 */
export const giftCardsVoidGiftCard = <ThrowOnError extends boolean = false>(options: Options<GiftCardsVoidGiftCardData, ThrowOnError>): RequestResult<GiftCardsVoidGiftCardResponses, GiftCardsVoidGiftCardErrors, ThrowOnError> => (options.client ?? client).put<GiftCardsVoidGiftCardResponses, GiftCardsVoidGiftCardErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/gift-cards/{gift_card_id}/void',
    ...options
});

/**
 * Get Super Admin Grants
 */
export const grantsGetSuperAdminGrants = <ThrowOnError extends boolean = false>(options?: Options<GrantsGetSuperAdminGrantsData, ThrowOnError>): RequestResult<GrantsGetSuperAdminGrantsResponses, GrantsGetSuperAdminGrantsErrors, ThrowOnError> => (options?.client ?? client).get<GrantsGetSuperAdminGrantsResponses, GrantsGetSuperAdminGrantsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants',
    ...options
});

/**
 * List Group Exemption Cures
 *
 * GD-A9: the charity's attestations (newest first, each with its revocation), its
 * current cure as it stands now, and the letters on record for its GEN.
 */
export const superAdminGrantsOpsListGroupExemptionCures = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsListGroupExemptionCuresData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsListGroupExemptionCuresResponses, SuperAdminGrantsOpsListGroupExemptionCuresErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminGrantsOpsListGroupExemptionCuresResponses, SuperAdminGrantsOpsListGroupExemptionCuresErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/charities/{charity_id}/group-exemption-cures',
    ...options
});

/**
 * Attest Group Exemption Cure
 *
 * GD-A9: record the President's attestation of one charity's cure packet.
 *
 * Only an attester's own signed-in session completes it (``@human_only(2)`` and the
 * committed attester list; another super-admin is refused 403). ``201`` on both a new
 * attestation (``created=true``) and an identical repeat (``created=false``) — branch
 * on ``created``. ``409`` when the charity's verdict is not
 * ``SUBORDINATE_RELIANCE_UNAVAILABLE``, the EIN, GEN or foundation code differs from
 * the IRS file, a later letter of the central is on record, a § 320(a)(3) cascade is
 * active, or ``supersedes_id`` does not name the current attestation. After it commits,
 * the charity's FULL payee floor re-runs (a bank account it already entered may now
 * bind), never a direct bind.
 */
export const superAdminGrantsOpsAttestGroupExemptionCure = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsAttestGroupExemptionCureData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsAttestGroupExemptionCureResponses, SuperAdminGrantsOpsAttestGroupExemptionCureErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGrantsOpsAttestGroupExemptionCureResponses, SuperAdminGrantsOpsAttestGroupExemptionCureErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/charities/{charity_id}/group-exemption-cures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Charity Buckets
 *
 * View 2 list: charities with a live PENDING accumulator bucket, each with its
 * settled-and-fundable-tonight, settled-but-held and unsettled (awaiting payout)
 * money, earliest §320 deadline + eligibility + payee-linked flags. Detail:
 * ``/charity-buckets/{id}``.
 */
export const superAdminGrantsOpsListCharityBuckets = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminGrantsOpsListCharityBucketsData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsListCharityBucketsResponses, SuperAdminGrantsOpsListCharityBucketsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminGrantsOpsListCharityBucketsResponses, SuperAdminGrantsOpsListCharityBucketsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/charity-buckets',
    ...options
});

/**
 * Get Charity Bucket
 *
 * View 2 detail: one charity's undisbursed pool — fundable tonight, settled but
 * held, and unsettled; FIFO-ordered constituents, each with its money state and its
 * hold; deadline-risk list, payee status (Mercury recipient /
 * IRS-address fallback / open flags), eligibility snapshot, cumulative disbursed.
 */
export const superAdminGrantsOpsGetCharityBucket = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsGetCharityBucketData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsGetCharityBucketResponses, SuperAdminGrantsOpsGetCharityBucketErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminGrantsOpsGetCharityBucketResponses, SuperAdminGrantsOpsGetCharityBucketErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/charity-buckets/{charity_id}',
    ...options
});

/**
 * List Cohorts
 *
 * View 3 list: the cohort & disbursement ledger — MINTED (awaiting payment),
 * SENT/COMPLETED history (keyed by Mercury txn), and disposed RETURNED/REJECTED
 * husks. Filter with ``status``. Detail (chunk lineage, constituents→donors,
 * reservation coverage, evidence, successor chain): ``/cohorts/{grant_id}``.
 */
export const superAdminGrantsOpsListCohorts = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminGrantsOpsListCohortsData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsListCohortsResponses, SuperAdminGrantsOpsListCohortsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminGrantsOpsListCohortsResponses, SuperAdminGrantsOpsListCohortsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/cohorts',
    ...options
});

/**
 * Get Cohort
 *
 * View 3 detail: one cohort grant — chunk lineage, constituents expandable to
 * donors, reservation coverage, the Mercury sent record-back + eligibility
 * evidence, recovery markers, and (for a disposed husk) the content-hash successor
 * chain.
 */
export const superAdminGrantsOpsGetCohort = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsGetCohortData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsGetCohortResponses, SuperAdminGrantsOpsGetCohortErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminGrantsOpsGetCohortResponses, SuperAdminGrantsOpsGetCohortErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/cohorts/{grant_id}',
    ...options
});

/**
 * List Disbursement Approvals
 *
 * The §5.2 portal read (SAPD-WEB5/BE1 rendering): newest-first, paginated
 * ``{data, meta, links}`` envelope, ``status`` served as the EFFECTIVE status
 * (a stored-approved row past its 7-day TTL reads ``expired``). Read-only,
 * superadmin-gated, deliberately NOT money-guarded.
 */
export const superAdminDisbursementApprovalsListDisbursementApprovals = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminDisbursementApprovalsListDisbursementApprovalsData, ThrowOnError>): RequestResult<SuperAdminDisbursementApprovalsListDisbursementApprovalsResponses, SuperAdminDisbursementApprovalsListDisbursementApprovalsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminDisbursementApprovalsListDisbursementApprovalsResponses, SuperAdminDisbursementApprovalsListDisbursementApprovalsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/disbursement-approvals',
    ...options
});

/**
 * Record Disbursement Approval
 *
 * Record a ``disburse`` approval (SAPD-S1 §5.4): verify the referenced
 * escalation row + the REQUIRED stored-hash equality + the live cohort, then
 * record the write-once hash-bound row. 201 created; 200 idempotent repeat;
 * typed 409/422 refusals record NOTHING.
 */
export const superAdminDisbursementApprovalsRecordDisbursementApproval = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDisbursementApprovalsRecordDisbursementApprovalData, ThrowOnError>): RequestResult<SuperAdminDisbursementApprovalsRecordDisbursementApprovalResponses, SuperAdminDisbursementApprovalsRecordDisbursementApprovalErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDisbursementApprovalsRecordDisbursementApprovalResponses, SuperAdminDisbursementApprovalsRecordDisbursementApprovalErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/disbursement-approvals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Manual Payment Confirmation
 *
 * Record a ``manual_payment_confirmation`` (SAPD-S1 §7.4): the operator
 * confirms an outbound Mercury transaction as his own payment for the
 * proposal. The lane's existing fail-closed ``mark_operator_payment_sent``
 * verification runs before any record-back; this records state only.
 */
export const superAdminDisbursementApprovalsRecordManualPaymentConfirmation = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationData, ThrowOnError>): RequestResult<SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationResponses, SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationResponses, SuperAdminDisbursementApprovalsRecordManualPaymentConfirmationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/disbursement-approvals/manual-payment-confirmation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Disbursement Approval
 *
 * Revoke a standing approval (operator changed his mind before the lane
 * ran): ``approved`` → ``revoked``. Idempotent on repeat; a consumed /
 * superseded row refuses 409 ``approval_not_revocable``.
 */
export const superAdminDisbursementApprovalsRevokeDisbursementApproval = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDisbursementApprovalsRevokeDisbursementApprovalData, ThrowOnError>): RequestResult<SuperAdminDisbursementApprovalsRevokeDisbursementApprovalResponses, SuperAdminDisbursementApprovalsRevokeDisbursementApprovalErrors, ThrowOnError> => (options.client ?? client).delete<SuperAdminDisbursementApprovalsRevokeDisbursementApprovalResponses, SuperAdminDisbursementApprovalsRevokeDisbursementApprovalErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/disbursement-approvals/{approval_id}',
    ...options
});

/**
 * Search Donations
 *
 * View 1 entry point: search donations by donor email/name, donation id, or
 * charge id (the ``q`` query param). An absent/blank ``q`` browses recent donations,
 * newest first. Flat, paginated hits; the full per-leg trail is
 * ``GET /donations/{id}/trail``.
 */
export const superAdminGrantsOpsSearchDonations = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminGrantsOpsSearchDonationsData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsSearchDonationsResponses, SuperAdminGrantsOpsSearchDonationsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminGrantsOpsSearchDonationsResponses, SuperAdminGrantsOpsSearchDonationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/donations/search',
    ...options
});

/**
 * Get Donation Trail
 *
 * View 1 detail: the full money-trail for a donation's whole gift — one trail
 * per charity leg (basket/ETF/collection splits fan the charge to N legs), each a
 * charged → contribution → settlement → bucket/cohort → sent → terminal timeline
 * with every record id.
 */
export const superAdminGrantsOpsGetDonationTrail = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsGetDonationTrailData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsGetDonationTrailResponses, SuperAdminGrantsOpsGetDonationTrailErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminGrantsOpsGetDonationTrailResponses, SuperAdminGrantsOpsGetDonationTrailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/donations/{donation_id}/trail',
    ...options
});

/**
 * Get Eligibility Evidence
 *
 * The immutable eligibility-evidence rows soft-correlated to a grant/cohort id
 * (the IRS-signal snapshot the money lane records at disbursement time).
 */
export const superAdminGrantsOpsGetEligibilityEvidence = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsGetEligibilityEvidenceData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsGetEligibilityEvidenceResponses, SuperAdminGrantsOpsGetEligibilityEvidenceErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminGrantsOpsGetEligibilityEvidenceResponses, SuperAdminGrantsOpsGetEligibilityEvidenceErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/eligibility-evidence',
    ...options
});

/**
 * Revoke Group Exemption Cure
 *
 * GD-A9: withdraw the charity's current attestation (a trigger fired, or it was made
 * in error). In the same act the charity's BOUND payee binding pauses. ``409`` when it
 * was already revoked or is not the current attestation; ``SUPERSEDED`` is recorded by
 * a new attestation, never here (422).
 */
export const superAdminGrantsOpsRevokeGroupExemptionCure = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsRevokeGroupExemptionCureData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsRevokeGroupExemptionCureResponses, SuperAdminGrantsOpsRevokeGroupExemptionCureErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGrantsOpsRevokeGroupExemptionCureResponses, SuperAdminGrantsOpsRevokeGroupExemptionCureErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/group-exemption-cures/{cure_id}/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Group Ruling Letter
 *
 * GD-A9: record that a central's IRS group-ruling letter has issued. Every cure on
 * its GEN read against an older letter lapses at once, and each such charity's BOUND
 * payee binding pauses in the same act.
 */
export const superAdminGrantsOpsRecordGroupRulingLetter = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsRecordGroupRulingLetterData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsRecordGroupRulingLetterResponses, SuperAdminGrantsOpsRecordGroupRulingLetterErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGrantsOpsRecordGroupRulingLetterResponses, SuperAdminGrantsOpsRecordGroupRulingLetterErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/group-ruling-letters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw Group Ruling Letter
 *
 * GD-A9: withdraw a letter record made in error. Cures it lapsed may stand again, so
 * only a person completes it (``@human_only(2)``), and each such charity's FULL payee
 * floor re-runs after it commits.
 */
export const superAdminGrantsOpsWithdrawGroupRulingLetter = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsWithdrawGroupRulingLetterData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsWithdrawGroupRulingLetterResponses, SuperAdminGrantsOpsWithdrawGroupRulingLetterErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGrantsOpsWithdrawGroupRulingLetterResponses, SuperAdminGrantsOpsWithdrawGroupRulingLetterErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/group-ruling-letters/{letter_id}/withdraw',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Ineligibility Determination
 *
 * Explicitly record held-funds determinations; never blocks or moves funds.
 */
export const superAdminGrantsOpsRecordIneligibilityDetermination = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsRecordIneligibilityDeterminationData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsRecordIneligibilityDeterminationResponses, SuperAdminGrantsOpsRecordIneligibilityDeterminationErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGrantsOpsRecordIneligibilityDeterminationResponses, SuperAdminGrantsOpsRecordIneligibilityDeterminationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/ineligibility-cascades',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Ineligibility Alternate
 *
 * Book a donor's alternate; does not re-point, select, or execute funds.
 */
export const superAdminGrantsOpsRecordIneligibilityAlternate = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsRecordIneligibilityAlternateData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsRecordIneligibilityAlternateResponses, SuperAdminGrantsOpsRecordIneligibilityAlternateErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGrantsOpsRecordIneligibilityAlternateResponses, SuperAdminGrantsOpsRecordIneligibilityAlternateErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/ineligibility-cascades/{cascade_id}/alternate-recommendation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Ineligibility Notice
 *
 * Record the actual written-notice t0; this endpoint does not send it.
 */
export const superAdminGrantsOpsRecordIneligibilityNotice = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGrantsOpsRecordIneligibilityNoticeData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsRecordIneligibilityNoticeResponses, SuperAdminGrantsOpsRecordIneligibilityNoticeErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGrantsOpsRecordIneligibilityNoticeResponses, SuperAdminGrantsOpsRecordIneligibilityNoticeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/ineligibility-cascades/{cascade_id}/notice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Ops Strip
 *
 * View 4: the "what will happen tonight" header — BACKEND-DERIVABLE aggregates
 * only (MINTED-awaiting-payment count+amount, deadline-risk buckets, the fundable-
 * tonight, settled-but-held and unsettled pool totals, per-status breakdown).
 * Brain-only state (kill switch,
 * sweep/low-water markers, Mercury pending-approval count, cap config) is OUT of
 * backend v1 and not mirrored here.
 */
export const superAdminGrantsOpsGetOpsStrip = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminGrantsOpsGetOpsStripData, ThrowOnError>): RequestResult<SuperAdminGrantsOpsGetOpsStripResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SuperAdminGrantsOpsGetOpsStripResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants-ops/ops-strip',
    ...options
});

/**
 * Get Super Admin Grant Donations
 */
export const grantsGetSuperAdminGrantDonations = <ThrowOnError extends boolean = false>(options: Options<GrantsGetSuperAdminGrantDonationsData, ThrowOnError>): RequestResult<GrantsGetSuperAdminGrantDonationsResponses, GrantsGetSuperAdminGrantDonationsErrors, ThrowOnError> => (options.client ?? client).get<GrantsGetSuperAdminGrantDonationsResponses, GrantsGetSuperAdminGrantDonationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/grants/{grant_id}/donations',
    ...options
});

/**
 * Get Groups For Moderation
 *
 * List/search DRAFT, ACTIVE, DISSOLVED, listed, and unlisted groups.
 *
 * ``q`` is a case-insensitive substring over handle/name/id. This operator
 * endpoint is deliberately usable while ``GROUPS_ENABLED`` is off.
 */
export const superAdminGroupOpsGetGroupsForModeration = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminGroupOpsGetGroupsForModerationData, ThrowOnError>): RequestResult<SuperAdminGroupOpsGetGroupsForModerationResponses, SuperAdminGroupOpsGetGroupsForModerationErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminGroupOpsGetGroupsForModerationResponses, SuperAdminGroupOpsGetGroupsForModerationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/groups',
    ...options
});

/**
 * Evacuate Group Funds
 *
 * GRP-BE20c break-glass: grant OUT the group's pooled-wallet balance to
 * ``target_charity_id`` (a fee-free wallet grant riding the existing GD pipeline)
 * so the group can then be normally dissolved. Omit ``amount`` to evacuate the FULL
 * available balance (zero the wallet). UN-flagged (works while ``GROUPS_ENABLED`` is
 * off); super-admin-gated. Moves no Shift4 charge.
 */
export const superAdminGroupOpsEvacuateGroupFunds = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGroupOpsEvacuateGroupFundsData, ThrowOnError>): RequestResult<SuperAdminGroupOpsEvacuateGroupFundsResponses, SuperAdminGroupOpsEvacuateGroupFundsErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGroupOpsEvacuateGroupFundsResponses, SuperAdminGroupOpsEvacuateGroupFundsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/groups/{group_id}/evacuate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Moderate Group
 *
 * Reset one group identity field: name, neutral handle, or stored image.
 */
export const superAdminGroupOpsModerateGroup = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGroupOpsModerateGroupData, ThrowOnError>): RequestResult<SuperAdminGroupOpsModerateGroupResponses, SuperAdminGroupOpsModerateGroupErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGroupOpsModerateGroupResponses, SuperAdminGroupOpsModerateGroupErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/groups/{group_id}/moderate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Relist Group
 *
 * Clear the moderation trio and restore normal public reach.
 */
export const superAdminGroupOpsRelistGroup = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGroupOpsRelistGroupData, ThrowOnError>): RequestResult<SuperAdminGroupOpsRelistGroupResponses, SuperAdminGroupOpsRelistGroupErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGroupOpsRelistGroupResponses, SuperAdminGroupOpsRelistGroupErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/groups/{group_id}/relist',
    ...options
});

/**
 * Unlist Group
 *
 * Hide a group from discovery/non-member direct reads without dissolving it.
 */
export const superAdminGroupOpsUnlistGroup = <ThrowOnError extends boolean = false>(options: Options<SuperAdminGroupOpsUnlistGroupData, ThrowOnError>): RequestResult<SuperAdminGroupOpsUnlistGroupResponses, SuperAdminGroupOpsUnlistGroupErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminGroupOpsUnlistGroupResponses, SuperAdminGroupOpsUnlistGroupErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/groups/{group_id}/unlist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Match Offers
 *
 * The CROSS-USER offer list (03 §6), newest-first, all statuses, paginated —
 * the whole point of the super-admin surface (any offeror's offer appears, not
 * just the caller's). Each item carries its legs + display consent-status.
 * Optionally narrow with ``?status=`` and/or ``?offeror_user_id=``. Domain-scoped,
 * no wallet-history breakout.
 */
export const superAdminMatchOffersListMatchOffers = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminMatchOffersListMatchOffersData, ThrowOnError>): RequestResult<SuperAdminMatchOffersListMatchOffersResponses, SuperAdminMatchOffersListMatchOffersErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminMatchOffersListMatchOffersResponses, SuperAdminMatchOffersListMatchOffersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/match-offers',
    ...options
});

/**
 * Get Match Offer Detail
 *
 * One offer + its legs (03 §6), NO ownership filter (a super-admin reads any
 * offer). An absent id → 404. The claims list is a SEPARATE paginated drill-down
 * (``/claims``) — an offer can carry unbounded claim counts.
 */
export const superAdminMatchOffersGetMatchOfferDetail = <ThrowOnError extends boolean = false>(options: Options<SuperAdminMatchOffersGetMatchOfferDetailData, ThrowOnError>): RequestResult<SuperAdminMatchOffersGetMatchOfferDetailResponses, SuperAdminMatchOffersGetMatchOfferDetailErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminMatchOffersGetMatchOfferDetailResponses, SuperAdminMatchOffersGetMatchOfferDetailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/match-offers/{offer_id}',
    ...options
});

/**
 * List Match Offer Claims
 *
 * The paginated claims drill-down for one offer (03 §6), newest-claim-first.
 * Each claim carries a resolved + MASKED claimer identity (resolved via
 * donation→domain→user, BATCHED; the mask is a backend-computed "First L." plus the
 * raw ``claimer_user_id`` for a full-record drill-in) + ``amount`` +
 * ``settlement_status``. A SEPARATE route from detail — an offer can accrue
 * unbounded claim counts.
 */
export const superAdminMatchOffersListMatchOfferClaims = <ThrowOnError extends boolean = false>(options: Options<SuperAdminMatchOffersListMatchOfferClaimsData, ThrowOnError>): RequestResult<SuperAdminMatchOffersListMatchOfferClaimsResponses, SuperAdminMatchOffersListMatchOfferClaimsErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminMatchOffersListMatchOfferClaimsResponses, SuperAdminMatchOffersListMatchOfferClaimsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/match-offers/{offer_id}/claims',
    ...options
});

/**
 * Redirect Match Claim Admin
 *
 * The X.3 GCF-SELECTS fallback (PV2-BE8 — "if you do not, Givmo Charitable may
 * select an eligible alternate charity consistent with your charitable intent"):
 * redirect any offeror's DECLINED (needs_review) claim to the admin-chosen
 * eligible alternate. NOT ownership-scoped; allowed on a SUSPENDED/VOIDED offer
 * (the admin IS the review). Same execution primitive + screens + machine-coded
 * conflicts as the consumer redirect; idempotent/replay-safe (re-submitting the
 * granted alternate returns the recorded success; anything else on a settled
 * claim → 409 ``CLAIM_NOT_REDIRECTABLE``). Audited: acting admin + ``reason``
 * stamp the claim row and the ``match_offer_claim_redirected`` structured log;
 * the offeror is notified via the non-receipt grant confirmation.
 */
export const superAdminMatchOffersRedirectMatchClaimAdmin = <ThrowOnError extends boolean = false>(options: Options<SuperAdminMatchOffersRedirectMatchClaimAdminData, ThrowOnError>): RequestResult<SuperAdminMatchOffersRedirectMatchClaimAdminResponses, SuperAdminMatchOffersRedirectMatchClaimAdminErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminMatchOffersRedirectMatchClaimAdminResponses, SuperAdminMatchOffersRedirectMatchClaimAdminErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/match-offers/{offer_id}/claims/{claim_id}/redirect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resume Match Offer Leg
 *
 * RESUME a suspended LEG (03 §6): SUSPENDED→ACTIVE. Idempotent. Missing
 * offer/leg → 404; a non-SUSPENDED (ENDED/ACTIVE) leg → 409/no-op.
 */
export const superAdminMatchOffersResumeMatchOfferLeg = <ThrowOnError extends boolean = false>(options: Options<SuperAdminMatchOffersResumeMatchOfferLegData, ThrowOnError>): RequestResult<SuperAdminMatchOffersResumeMatchOfferLegResponses, SuperAdminMatchOffersResumeMatchOfferLegErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminMatchOffersResumeMatchOfferLegResponses, SuperAdminMatchOffersResumeMatchOfferLegErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/match-offers/{offer_id}/legs/{leg_id}/resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suspend Match Offer Leg
 *
 * SUSPEND a single LEG on an eligibility event (03 §6 / 02 §1.7): the leg stops
 * taking claims; the pool + the other legs are unaffected. Idempotent. Missing
 * offer/leg → 404; an ENDED leg → 409. Returns the offer (the module re-reads
 * the offer's legs from it).
 */
export const superAdminMatchOffersSuspendMatchOfferLeg = <ThrowOnError extends boolean = false>(options: Options<SuperAdminMatchOffersSuspendMatchOfferLegData, ThrowOnError>): RequestResult<SuperAdminMatchOffersSuspendMatchOfferLegResponses, SuperAdminMatchOffersSuspendMatchOfferLegErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminMatchOffersSuspendMatchOfferLegResponses, SuperAdminMatchOffersSuspendMatchOfferLegErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/match-offers/{offer_id}/legs/{leg_id}/suspend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resume Match Offer
 *
 * RESUME a suspended offer (03 §6): SUSPENDED→ACTIVE, restore solicitation.
 * Idempotent. Missing offer → 404; non-SUSPENDED → 409.
 */
export const superAdminMatchOffersResumeMatchOffer = <ThrowOnError extends boolean = false>(options: Options<SuperAdminMatchOffersResumeMatchOfferData, ThrowOnError>): RequestResult<SuperAdminMatchOffersResumeMatchOfferResponses, SuperAdminMatchOffersResumeMatchOfferErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminMatchOffersResumeMatchOfferResponses, SuperAdminMatchOffersResumeMatchOfferErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/match-offers/{offer_id}/resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suspend Match Offer
 *
 * PAUSE an offer's solicitation WITHOUT releasing the hold (03 §6): stop taking
 * claims, keep the reservation. Idempotent. Missing offer → 404; non-ACTIVE → 409.
 */
export const superAdminMatchOffersSuspendMatchOffer = <ThrowOnError extends boolean = false>(options: Options<SuperAdminMatchOffersSuspendMatchOfferData, ThrowOnError>): RequestResult<SuperAdminMatchOffersSuspendMatchOfferResponses, SuperAdminMatchOffersSuspendMatchOfferErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminMatchOffersSuspendMatchOfferResponses, SuperAdminMatchOffersSuspendMatchOfferErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/match-offers/{offer_id}/suspend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Void Match Offer
 *
 * FORCE-TERMINATE an offer (03 §6): release ONLY the unclaimed remainder (a
 * claimed dollar is never un-held — irrevocability), end every leg, set VOIDED.
 * Idempotent. A missing offer → 404; a claim-terminal offer → 409.
 */
export const superAdminMatchOffersVoidMatchOffer = <ThrowOnError extends boolean = false>(options: Options<SuperAdminMatchOffersVoidMatchOfferData, ThrowOnError>): RequestResult<SuperAdminMatchOffersVoidMatchOfferResponses, SuperAdminMatchOffersVoidMatchOfferErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminMatchOffersVoidMatchOfferResponses, SuperAdminMatchOffersVoidMatchOfferErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/match-offers/{offer_id}/void',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Telemetry Event Summary
 */
export const superAdminOperatorDashboardGetTelemetryEventSummary = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminOperatorDashboardGetTelemetryEventSummaryData, ThrowOnError>): RequestResult<SuperAdminOperatorDashboardGetTelemetryEventSummaryResponses, SuperAdminOperatorDashboardGetTelemetryEventSummaryErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminOperatorDashboardGetTelemetryEventSummaryResponses, SuperAdminOperatorDashboardGetTelemetryEventSummaryErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/operator-dashboard/events',
    ...options
});

/**
 * Acknowledge Machine Credit Alarm
 *
 * Acknowledge the dashboard's machine-credit alarm for one arrival.
 *
 * The automated lane credits under the President's standing authorization, so the
 * operator is TOLD rather than asked — and the queue class holds each credit until
 * he says he has seen it. This is that act, and nothing else: it stamps
 * ``acknowledged_at``/``acknowledged_by`` on the evidence row and removes it from the
 * class. It moves no money, changes no credit, no arrival and no wallet.
 *
 * ⚠ ``require_money_action_guard`` deliberately does NOT apply, and the reasoning is
 * the guard's own scope rather than convenience: the guard is for money-MOVING
 * super-admin mutations (step-up auth, per-actor rate limit, single-use App Check),
 * and acknowledging a notice moves nothing. The money already moved, at the credit
 * chokepoint, under the guard the console credit carries. Putting a step-up ceremony
 * in front of "I saw this" would train the operator to click through step-up, which
 * is how the guard stops meaning anything where it does matter.
 *
 * Auth is the surface's usual triple gate: router-level ``require_superadmin``, the
 * inline ``_require_user``, and the service method's own
 * ``@has_superadmin_permission``.
 *
 * Idempotent forward-only: acknowledging an already-acknowledged alarm returns
 * ``acknowledged: False`` and leaves the FIRST operator's name on the row, rather
 * than re-stamping and losing who actually saw it.
 */
export const superAdminOperatorDashboardAcknowledgeMachineCreditAlarm = <ThrowOnError extends boolean = false>(options: Options<SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmData, ThrowOnError>): RequestResult<SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmResponses, SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmResponses, SuperAdminOperatorDashboardAcknowledgeMachineCreditAlarmErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/operator-dashboard/machine-credit-alarms/{arrival_id}/acknowledge',
    ...options
});

/**
 * Get Operator Queue
 *
 * The operator action queue over every application-DB operator-pending class.
 *
 * Complete by construction: every registered class is attempted on every call,
 * with no admitted-type allowlist and no cap that hides work. Each class reports
 * ``ok``/``empty``/``dark``/``error``/``unsupported`` independently, so a
 * flag-dark feature or a failed sub-query can never render as a zero and one
 * class failing cannot zero the page.
 */
export const superAdminOperatorDashboardGetOperatorQueue = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminOperatorDashboardGetOperatorQueueData, ThrowOnError>): RequestResult<SuperAdminOperatorDashboardGetOperatorQueueResponses, SuperAdminOperatorDashboardGetOperatorQueueErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminOperatorDashboardGetOperatorQueueResponses, SuperAdminOperatorDashboardGetOperatorQueueErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/operator-dashboard/queue',
    ...options
});

/**
 * Get Operator Stats
 *
 * The operator dashboard's stuck-money alarms and operator statistics.
 *
 * Sibling of ``/queue`` and governed by the same contract: every alarm and every
 * statistic reports ``ok``/``empty``/``dark``/``error``/``unsupported``
 * independently, so a flag-dark feature or a failed sub-query can never render as
 * a zero — or as ``$0.00`` — and one failing read cannot zero the page. Composed
 * money figures are stricter still: a headline appears only when every component
 * behind it established a figure.
 *
 * The three window parameters are additive and defaulted: a caller that sends
 * none gets exactly the month-to-date response this route has always returned.
 * ``period=day`` resolves through the same ``day_periods`` helper the unattended
 * ``metrics_daily_read`` tool uses, so the day Jonathan eyeballs here and the day
 * the nightly record writes are the same day.
 */
export const superAdminOperatorDashboardGetOperatorStats = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminOperatorDashboardGetOperatorStatsData, ThrowOnError>): RequestResult<SuperAdminOperatorDashboardGetOperatorStatsResponses, SuperAdminOperatorDashboardGetOperatorStatsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminOperatorDashboardGetOperatorStatsResponses, SuperAdminOperatorDashboardGetOperatorStatsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/operator-dashboard/stats',
    ...options
});

/**
 * Get Payment Reconciliation
 *
 * Super-admin reconciliation view: runs the diff for a window on demand and
 * returns the full report (counts + discrepancy details).
 */
export const paymentsGetPaymentReconciliation = <ThrowOnError extends boolean = false>(options?: Options<PaymentsGetPaymentReconciliationData, ThrowOnError>): RequestResult<PaymentsGetPaymentReconciliationResponses, PaymentsGetPaymentReconciliationErrors, ThrowOnError> => (options?.client ?? client).get<PaymentsGetPaymentReconciliationResponses, PaymentsGetPaymentReconciliationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/payments/reconciliation',
    ...options
});

/**
 * List Held Pledges
 *
 * GFU-BE55: every pledge charge held for an operator, oldest first, paginated: sent more
 * than a day ago, its answer never recorded, so past Shift4's replay of its key. Each item
 * names the charge record (key, attempt, amount, when written and last sent) and its pledge
 * and campaign, with the pledgor masked. Cross-user, READ-ONLY.
 */
export const superAdminPledgesListHeldPledges = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminPledgesListHeldPledgesData, ThrowOnError>): RequestResult<SuperAdminPledgesListHeldPledgesResponses, SuperAdminPledgesListHeldPledgesErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminPledgesListHeldPledgesResponses, SuperAdminPledgesListHeldPledgesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/held-pledges',
    ...options
});

/**
 * List Publish Review Campaigns
 *
 * Retired blanket preapproval queue, returning an empty paginated response.
 * Targeted detail/VOID and attestation/objection review remain available.
 */
export const superAdminPledgesListPublishReviewCampaigns = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminPledgesListPublishReviewCampaignsData, ThrowOnError>): RequestResult<SuperAdminPledgesListPublishReviewCampaignsResponses, SuperAdminPledgesListPublishReviewCampaignsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminPledgesListPublishReviewCampaignsResponses, SuperAdminPledgesListPublishReviewCampaignsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/publish-review',
    ...options
});

/**
 * List Review Campaigns
 *
 * The adjudication REVIEW QUEUE (03 §6), newest-first, paginated: campaigns in
 * ``needs_review`` (the BE3 outlier block) UNION campaigns with objected pledges.
 * Each item carries the campaign + its outlier ``pledge_attestation_audit`` flags
 * + a ``review_reason`` (outlier / objection / both). Cross-user, READ-ONLY.
 */
export const superAdminPledgesListReviewCampaigns = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminPledgesListReviewCampaignsData, ThrowOnError>): RequestResult<SuperAdminPledgesListReviewCampaignsResponses, SuperAdminPledgesListReviewCampaignsErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminPledgesListReviewCampaignsResponses, SuperAdminPledgesListReviewCampaignsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/review',
    ...options
});

/**
 * Accept Campaign
 *
 * ACCEPT (D-PV-1 §3.3#6 exit (a)): ``needs_review → locked`` through the SAME
 * write-once ``lock()`` seam BE3 uses, at the value the result's source submitted
 * (GFU-BE80): ``final_units`` echoes it, and any other number is a 409
 * ``PLEDGE_RESULT_NOT_FROM_SOURCE`` naming the source's value. NEVER an edit of a locked
 * value (a non-``needs_review`` campaign → 409). An absent campaign → 404. Writes an
 * ``adjudicated`` audit row in the same UoW.
 */
export const superAdminPledgesAcceptCampaign = <ThrowOnError extends boolean = false>(options: Options<SuperAdminPledgesAcceptCampaignData, ThrowOnError>): RequestResult<SuperAdminPledgesAcceptCampaignResponses, SuperAdminPledgesAcceptCampaignErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminPledgesAcceptCampaignResponses, SuperAdminPledgesAcceptCampaignErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/{campaign_id}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Pledge
 *
 * CANCEL an objected pledge (D-PV-1 §3.3#7): ``needs_review → cancelled``,
 * wallet hold released, NEVER charged. Idempotent. A cross-campaign / absent
 * pledge → 404; a non-review pledge → 409. Writes an ``adjudicated`` audit row in
 * the same UoW.
 */
export const superAdminPledgesCancelPledge = <ThrowOnError extends boolean = false>(options: Options<SuperAdminPledgesCancelPledgeData, ThrowOnError>): RequestResult<SuperAdminPledgesCancelPledgeResponses, SuperAdminPledgesCancelPledgeErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminPledgesCancelPledgeResponses, SuperAdminPledgesCancelPledgeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/{campaign_id}/pledges/{pledge_id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Dismiss Objection
 *
 * DISMISS an objection (D-PV-1 §3.3#7): an objected pledge ``needs_review →
 * active`` (chargeable again — the sweep re-selects it, gated by the SAME
 * notice+clock fences). Idempotent. A cross-campaign / absent pledge → 404; a
 * non-review pledge → 409. Writes an ``adjudicated`` audit row in the same UoW.
 */
export const superAdminPledgesDismissObjection = <ThrowOnError extends boolean = false>(options: Options<SuperAdminPledgesDismissObjectionData, ThrowOnError>): RequestResult<SuperAdminPledgesDismissObjectionResponses, SuperAdminPledgesDismissObjectionErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminPledgesDismissObjectionResponses, SuperAdminPledgesDismissObjectionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/{campaign_id}/pledges/{pledge_id}/dismiss-objection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Partial Settle Pledge
 *
 * PARTIAL-SETTLE (D-PV-1 §3.3#6, the audited disposition): settle an objected
 * pledge at an ADJUDICATED amount (≤ cap) that REPLACES the formula amount for
 * that pledge, booked through the BE4 collection settle primitives (REUSED — all
 * five artifacts stay correct). A cross-campaign / absent pledge → 404; a
 * non-review pledge or an over-cap amount → 409; a declined charge /
 * unavailable-beneficiary → 409 ``PLEDGE_ADJUDICATION_FAILED`` (nothing moved).
 * Writes an ``adjudicated`` audit row recording the before/after amounts.
 */
export const superAdminPledgesPartialSettlePledge = <ThrowOnError extends boolean = false>(options: Options<SuperAdminPledgesPartialSettlePledgeData, ThrowOnError>): RequestResult<SuperAdminPledgesPartialSettlePledgeResponses, SuperAdminPledgesPartialSettlePledgeErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminPledgesPartialSettlePledgeResponses, SuperAdminPledgesPartialSettlePledgeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/{campaign_id}/pledges/{pledge_id}/partial-settle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve Held Pledge
 *
 * GFU-BE55: resolve a held pledge charge after checking Shift4. ``capture`` books the
 * capture named, verified against a fresh read of Shift4 as the one capture under the key
 * (a disputed one only while its dispute is open or won); ``no_capture`` records that none
 * exists, which a complete read of Shift4 must bear out; ``returned`` records that the
 * capture named went back to the donor, refunded in full or lost to a chargeback as a fresh
 * read of Shift4 shows, and ends the pledge with nothing booked, its pledgor told which.
 * A cross-campaign / absent pledge → 404; refused → 409 ``PLEDGE_HOLD_NOT_RESOLVED``,
 * nothing moved (a refusal after the decision row adds a ``resolve_hold_refused`` row).
 * Writes an ``adjudicated`` audit row before the charge record moves. Returns the
 * pledge.
 */
export const superAdminPledgesResolveHeldPledge = <ThrowOnError extends boolean = false>(options: Options<SuperAdminPledgesResolveHeldPledgeData, ThrowOnError>): RequestResult<SuperAdminPledgesResolveHeldPledgeResponses, SuperAdminPledgesResolveHeldPledgeErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminPledgesResolveHeldPledgeResponses, SuperAdminPledgesResolveHeldPledgeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/{campaign_id}/pledges/{pledge_id}/resolve-hold',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve Publish Review
 *
 * Legacy raw pending → approved decision, idempotent if already approved.
 * Historical rejected cannot reopen. Routine FAN eligibility needs no call here.
 */
export const superAdminPledgesApprovePublishReview = <ThrowOnError extends boolean = false>(options: Options<SuperAdminPledgesApprovePublishReviewData, ThrowOnError>): RequestResult<SuperAdminPledgesApprovePublishReviewResponses, SuperAdminPledgesApprovePublishReviewErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminPledgesApprovePublishReviewResponses, SuperAdminPledgesApprovePublishReviewErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/{campaign_id}/publish-review/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject Publish Review
 *
 * Legacy raw pending → rejected decision, idempotent if already rejected.
 * Approved campaigns cannot transition here. Existing pledges are untouched;
 * targeted campaign disposition uses VOID. Public GET remains available.
 */
export const superAdminPledgesRejectPublishReview = <ThrowOnError extends boolean = false>(options: Options<SuperAdminPledgesRejectPublishReviewData, ThrowOnError>): RequestResult<SuperAdminPledgesRejectPublishReviewResponses, SuperAdminPledgesRejectPublishReviewErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminPledgesRejectPublishReviewResponses, SuperAdminPledgesRejectPublishReviewErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/{campaign_id}/publish-review/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Review Campaign Detail
 *
 * One campaign's adjudication DETAIL (03 §6): the campaign + its pledges (with
 * MASKED pledgor identity + dunning visibility + notice state) + the full
 * append-only attestation audit trail. NO ownership filter (a super-admin reads
 * any campaign). An absent id → 404.
 *
 * GFU-WEB4: beside the trail, the value an accept would confirm, the source's own
 * (GFU-BE80): ``source_submission`` ``{audit_id, count}`` (the count a decimal string at
 * the measure's precision; an accept sends it as ``final_count``, its whole-unit floor as
 * ``final_units``), or null with ``source_submission_missing``: ``none_entered`` or
 * ``entered_before_organizer_change``.
 */
export const superAdminPledgesGetReviewCampaignDetail = <ThrowOnError extends boolean = false>(options: Options<SuperAdminPledgesGetReviewCampaignDetailData, ThrowOnError>): RequestResult<SuperAdminPledgesGetReviewCampaignDetailResponses, SuperAdminPledgesGetReviewCampaignDetailErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminPledgesGetReviewCampaignDetailResponses, SuperAdminPledgesGetReviewCampaignDetailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/{campaign_id}/review',
    ...options
});

/**
 * Void Campaign
 *
 * VOID (D-PV-1 §3.3#6 exit (b)): ``needs_review|open|provisional|locked →
 * voided`` (audited). Disposes the campaign's pledges money-safely (holds
 * released, nothing charged). Idempotent. A mid-CHARGING / terminal campaign →
 * 409; an absent campaign → 404. Writes an ``adjudicated`` (voided) audit row in
 * the same UoW.
 */
export const superAdminPledgesVoidCampaign = <ThrowOnError extends boolean = false>(options: Options<SuperAdminPledgesVoidCampaignData, ThrowOnError>): RequestResult<SuperAdminPledgesVoidCampaignResponses, SuperAdminPledgesVoidCampaignErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminPledgesVoidCampaignResponses, SuperAdminPledgesVoidCampaignErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/pledge-campaigns/{campaign_id}/void',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Super Admin Recent Public Posts
 *
 * Super-admin moderation list (D-GF-4): recent PUBLIC posts, newest first,
 * INCLUDING hidden ones (with the `hidden_at`/`hidden_by_user_id` audit
 * fields) so an admin can review the public surface and hide/unhide.
 *
 * GF-BE6 (D-GF-9): each row additionally carries `report_count` +
 * `last_reported_at`; `filter[reported]=true` narrows to posts with ≥1 report
 * (the SA reported queue).
 *
 * `q` is a case-insensitive substring match across post text, donor (author)
 * name, target (charity/ETF/fundraiser) name, and post id, applied server-side
 * (with `page[limit]`/`page[offset]`) so the moderation client can search +
 * page the whole corpus instead of loading everything and searching
 * in-memory.
 */
export const postsGetSuperAdminRecentPublicPosts = <ThrowOnError extends boolean = false>(options?: Options<PostsGetSuperAdminRecentPublicPostsData, ThrowOnError>): RequestResult<PostsGetSuperAdminRecentPublicPostsResponses, PostsGetSuperAdminRecentPublicPostsErrors, ThrowOnError> => (options?.client ?? client).get<PostsGetSuperAdminRecentPublicPostsResponses, PostsGetSuperAdminRecentPublicPostsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/posts',
    ...options
});

/**
 * Hide Post
 *
 * Super-admin hide (D-GF-4): suppress a post from every shared feed.
 */
export const postsHidePost = <ThrowOnError extends boolean = false>(options: Options<PostsHidePostData, ThrowOnError>): RequestResult<PostsHidePostResponses, PostsHidePostErrors, ThrowOnError> => (options.client ?? client).post<PostsHidePostResponses, PostsHidePostErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/posts/{post_id}/hide',
    ...options
});

/**
 * Unhide Post
 *
 * Super-admin unhide (D-GF-4): restore a previously hidden post.
 */
export const postsUnhidePost = <ThrowOnError extends boolean = false>(options: Options<PostsUnhidePostData, ThrowOnError>): RequestResult<PostsUnhidePostResponses, PostsUnhidePostErrors, ThrowOnError> => (options.client ?? client).post<PostsUnhidePostResponses, PostsUnhidePostErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/posts/{post_id}/unhide',
    ...options
});

/**
 * List Profile Blocks For Moderation
 *
 * The moderation review list — unlisted rows INCLUDED, with the whole
 * moderation trio; image rows carry a signed read URL so a reviewer can look.
 */
export const superAdminProfileBlocksListProfileBlocksForModeration = <ThrowOnError extends boolean = false>(options?: Options<SuperAdminProfileBlocksListProfileBlocksForModerationData, ThrowOnError>): RequestResult<SuperAdminProfileBlocksListProfileBlocksForModerationResponses, SuperAdminProfileBlocksListProfileBlocksForModerationErrors, ThrowOnError> => (options?.client ?? client).get<SuperAdminProfileBlocksListProfileBlocksForModerationResponses, SuperAdminProfileBlocksListProfileBlocksForModerationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/profile-blocks',
    ...options
});

/**
 * Relist Profile Block
 *
 * Clear the moderation trio so the block serves publicly again exactly as it
 * was. Idempotent.
 */
export const superAdminProfileBlocksRelistProfileBlock = <ThrowOnError extends boolean = false>(options: Options<SuperAdminProfileBlocksRelistProfileBlockData, ThrowOnError>): RequestResult<SuperAdminProfileBlocksRelistProfileBlockResponses, SuperAdminProfileBlocksRelistProfileBlockErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminProfileBlocksRelistProfileBlockResponses, SuperAdminProfileBlocksRelistProfileBlockErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/profile-blocks/{block_id}/relist',
    ...options
});

/**
 * Unlist Profile Block
 *
 * Take one block down: it drops from every public read on the next request,
 * the owner sees the takedown state, the object (if an image) keeps having no
 * stable public URL. Idempotent (re-unlisting refreshes actor / time / reason).
 */
export const superAdminProfileBlocksUnlistProfileBlock = <ThrowOnError extends boolean = false>(options: Options<SuperAdminProfileBlocksUnlistProfileBlockData, ThrowOnError>): RequestResult<SuperAdminProfileBlocksUnlistProfileBlockResponses, SuperAdminProfileBlocksUnlistProfileBlockErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminProfileBlocksUnlistProfileBlockResponses, SuperAdminProfileBlocksUnlistProfileBlockErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/profile-blocks/{block_id}/unlist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Receipt Fine Print
 *
 * List every receipt-fine-print document — all kinds, all versions, DRAFT
 * and LIVE — newest first. Super-admin gated.
 */
export const receiptFinePrintListReceiptFinePrint = <ThrowOnError extends boolean = false>(options?: Options<ReceiptFinePrintListReceiptFinePrintData, ThrowOnError>): RequestResult<ReceiptFinePrintListReceiptFinePrintResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ReceiptFinePrintListReceiptFinePrintResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/receipt-fine-print',
    ...options
});

/**
 * Get Receipt Fine Print Detail
 *
 * A single receipt-fine-print document by id. Super-admin gated.
 */
export const receiptFinePrintGetReceiptFinePrintDetail = <ThrowOnError extends boolean = false>(options: Options<ReceiptFinePrintGetReceiptFinePrintDetailData, ThrowOnError>): RequestResult<ReceiptFinePrintGetReceiptFinePrintDetailResponses, ReceiptFinePrintGetReceiptFinePrintDetailErrors, ThrowOnError> => (options.client ?? client).get<ReceiptFinePrintGetReceiptFinePrintDetailResponses, ReceiptFinePrintGetReceiptFinePrintDetailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/receipt-fine-print/{document_id}',
    ...options
});

/**
 * Retry Failed Report Generations
 *
 * Plan §6 task 13 / D7. Re-enqueue stuck annual-report rows (FAILED,
 * orphaned PENDING, stale IN_PROGRESS). Superadmin-gated (inline check in the
 * service). Powers the one-time D7 post-launch make-good and the
 * enqueue-failure recovery path. Mirrors the user-deletion
 * ``/super-admin/users/deletions/retry-failed`` endpoint.
 */
export const donationsRetryFailedReportGenerations = <ThrowOnError extends boolean = false>(options?: Options<DonationsRetryFailedReportGenerationsData, ThrowOnError>): RequestResult<DonationsRetryFailedReportGenerationsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<DonationsRetryFailedReportGenerationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/reports/retry-failed',
    ...options
});

/**
 * List Terms
 */
export const termsListTerms = <ThrowOnError extends boolean = false>(options?: Options<TermsListTermsData, ThrowOnError>): RequestResult<TermsListTermsResponses, TermsListTermsErrors, ThrowOnError> => (options?.client ?? client).get<TermsListTermsResponses, TermsListTermsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/terms',
    ...options
});

/**
 * Publish Terms At Super Admin
 */
export const termsPublishTermsAtSuperAdmin = <ThrowOnError extends boolean = false>(options: Options<TermsPublishTermsAtSuperAdminData, ThrowOnError>): RequestResult<TermsPublishTermsAtSuperAdminResponses, TermsPublishTermsAtSuperAdminErrors, ThrowOnError> => (options.client ?? client).post<TermsPublishTermsAtSuperAdminResponses, TermsPublishTermsAtSuperAdminErrors, ThrowOnError>({
    url: '/super-admin/terms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Recent Notifications
 *
 * Plan §6.6. Recent-notifications panel data. Auth enforced inline
 * (lightweight read-only endpoint, no command required).
 */
export const termsGetRecentNotifications = <ThrowOnError extends boolean = false>(options?: Options<TermsGetRecentNotificationsData, ThrowOnError>): RequestResult<TermsGetRecentNotificationsResponses, TermsGetRecentNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<TermsGetRecentNotificationsResponses, TermsGetRecentNotificationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/terms/recent-notifications',
    ...options
});

/**
 * Get Terms Detail
 */
export const termsGetTermsDetail = <ThrowOnError extends boolean = false>(options: Options<TermsGetTermsDetailData, ThrowOnError>): RequestResult<TermsGetTermsDetailResponses, TermsGetTermsDetailErrors, ThrowOnError> => (options.client ?? client).get<TermsGetTermsDetailResponses, TermsGetTermsDetailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/terms/{document_id}',
    ...options
});

/**
 * Notify Terms At Super Admin
 *
 * Plan §3.5. Cloud Tasks fan-out notify. Requires Idempotency-Key
 * header (UUIDv4). Auth, rate-limit, env gate, and kill switch are all
 * enforced at the service layer.
 */
export const termsNotifyTermsAtSuperAdmin = <ThrowOnError extends boolean = false>(options: Options<TermsNotifyTermsAtSuperAdminData, ThrowOnError>): RequestResult<TermsNotifyTermsAtSuperAdminResponses, TermsNotifyTermsAtSuperAdminErrors, ThrowOnError> => (options.client ?? client).post<TermsNotifyTermsAtSuperAdminResponses, TermsNotifyTermsAtSuperAdminErrors, ThrowOnError>({ url: '/super-admin/terms/{document_id}/notify', ...options });

/**
 * Get Terms Notify Audience Count
 *
 * Plan §3.3. Returns recipient count + skip breakdown + suppression
 * availability flag. Auth enforced at the service layer.
 */
export const termsGetTermsNotifyAudienceCount = <ThrowOnError extends boolean = false>(options: Options<TermsGetTermsNotifyAudienceCountData, ThrowOnError>): RequestResult<TermsGetTermsNotifyAudienceCountResponses, TermsGetTermsNotifyAudienceCountErrors, ThrowOnError> => (options.client ?? client).get<TermsGetTermsNotifyAudienceCountResponses, TermsGetTermsNotifyAudienceCountErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/terms/{document_id}/notify/audience-count',
    ...options
});

/**
 * Get Terms Notify Preview
 *
 * Plan §3.2. Returns rendered email HTML (text/html) with the preview
 * banner prepended. Auth enforced at the service layer.
 */
export const termsGetTermsNotifyPreview = <ThrowOnError extends boolean = false>(options: Options<TermsGetTermsNotifyPreviewData, ThrowOnError>): RequestResult<TermsGetTermsNotifyPreviewResponses, TermsGetTermsNotifyPreviewErrors, ThrowOnError> => (options.client ?? client).get<TermsGetTermsNotifyPreviewResponses, TermsGetTermsNotifyPreviewErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/terms/{document_id}/notify/preview',
    ...options
});

/**
 * Retry Failed Batches At Super Admin
 *
 * Plan §3.10 (v7). Re-enqueue all status='failed' batches for this
 * document. In-flight (pending/in_progress) batches are untouched.
 */
export const termsRetryFailedBatchesAtSuperAdmin = <ThrowOnError extends boolean = false>(options: Options<TermsRetryFailedBatchesAtSuperAdminData, ThrowOnError>): RequestResult<TermsRetryFailedBatchesAtSuperAdminResponses, TermsRetryFailedBatchesAtSuperAdminErrors, ThrowOnError> => (options.client ?? client).post<TermsRetryFailedBatchesAtSuperAdminResponses, TermsRetryFailedBatchesAtSuperAdminErrors, ThrowOnError>({ url: '/super-admin/terms/{document_id}/notify/retry-failed-batches', ...options });

/**
 * Get Notification Status
 *
 * Plan §3.10. Dedicated status endpoint for frontend polling.
 */
export const termsGetNotificationStatus = <ThrowOnError extends boolean = false>(options: Options<TermsGetNotificationStatusData, ThrowOnError>): RequestResult<TermsGetNotificationStatusResponses, TermsGetNotificationStatusErrors, ThrowOnError> => (options.client ?? client).get<TermsGetNotificationStatusResponses, TermsGetNotificationStatusErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/terms/{document_id}/notify/status',
    ...options
});

/**
 * Post Terms Notify Test At Super Admin
 *
 * Plan §3.11. Send the rendered email to the caller's own email only.
 */
export const termsPostTermsNotifyTestAtSuperAdmin = <ThrowOnError extends boolean = false>(options: Options<TermsPostTermsNotifyTestAtSuperAdminData, ThrowOnError>): RequestResult<TermsPostTermsNotifyTestAtSuperAdminResponses, TermsPostTermsNotifyTestAtSuperAdminErrors, ThrowOnError> => (options.client ?? client).post<TermsPostTermsNotifyTestAtSuperAdminResponses, TermsPostTermsNotifyTestAtSuperAdminErrors, ThrowOnError>({ url: '/super-admin/terms/{document_id}/notify/test', ...options });

/**
 * Patch Terms Summary At Super Admin
 *
 * Plan §3.1. Update summary_of_changes and/or effective_at on a
 * not-yet-notified document. Auth, 14-day gate, bleach sanitization, and
 * post-notify lock are all enforced at the service layer.
 */
export const termsPatchTermsSummaryAtSuperAdmin = <ThrowOnError extends boolean = false>(options: Options<TermsPatchTermsSummaryAtSuperAdminData, ThrowOnError>): RequestResult<TermsPatchTermsSummaryAtSuperAdminResponses, TermsPatchTermsSummaryAtSuperAdminErrors, ThrowOnError> => (options.client ?? client).patch<TermsPatchTermsSummaryAtSuperAdminResponses, TermsPatchTermsSummaryAtSuperAdminErrors, ThrowOnError>({
    url: '/super-admin/terms/{document_id}/summary',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retry Failed User Deletions
 *
 * Plan §6.10. Re-enqueue failed and stale-in-progress user-deletion
 * outbox rows. Superadmin-gated.
 */
export const usersRetryFailedUserDeletions = <ThrowOnError extends boolean = false>(options?: Options<UsersRetryFailedUserDeletionsData, ThrowOnError>): RequestResult<UsersRetryFailedUserDeletionsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<UsersRetryFailedUserDeletionsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/users/deletions/retry-failed',
    ...options
});

/**
 * List Stuck User Deletions
 *
 * Plan §6.10b. Inspect endpoint — non-terminal outbox rows for ops
 * triage. Superadmin-gated.
 */
export const usersListStuckUserDeletions = <ThrowOnError extends boolean = false>(options?: Options<UsersListStuckUserDeletionsData, ThrowOnError>): RequestResult<UsersListStuckUserDeletionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersListStuckUserDeletionsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/users/deletions/status',
    ...options
});

/**
 * Search User By Email
 *
 * CDO-BE2 (a): resolve a user by signup email OR employer-link work email.
 * 404 when neither matches (the COO decision-tree "not found" branch).
 */
export const superAdminDonationOpsSearchUserByEmail = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsSearchUserByEmailData, ThrowOnError>): RequestResult<SuperAdminDonationOpsSearchUserByEmailResponses, SuperAdminDonationOpsSearchUserByEmailErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminDonationOpsSearchUserByEmailResponses, SuperAdminDonationOpsSearchUserByEmailErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/users/search',
    ...options
});

/**
 * Search Users By Name
 *
 * SAPD-USR1 (f): the users a name could refer to, for the user page's lookup.
 *
 * IDT-BE11's search (exact normalized equality, an exact uncapped
 * ``total_matched``, at most 25 candidates newest first), served here outside the
 * DAF intake flag so the lookup works whatever that flag says. The DAF corroborator
 * is not evaluated, so ``has_open_daf_transfer_intent`` is always null. Matching is
 * exact: a married, hyphenated or suffixed surname reads as zero.
 */
export const superAdminDonationOpsSearchUsersByName = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsSearchUsersByNameData, ThrowOnError>): RequestResult<SuperAdminDonationOpsSearchUsersByNameResponses, SuperAdminDonationOpsSearchUsersByNameErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminDonationOpsSearchUsersByNameResponses, SuperAdminDonationOpsSearchUsersByNameErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/users/search-by-name',
    ...options
});

/**
 * Get User Profile
 *
 * SAPD-USR1 (g): the user page's identity block — name, email, account status,
 * created date and the last app seen. 404 (``error_code=USER_NOT_FOUND``) when the
 * id names no user.
 */
export const superAdminDonationOpsGetUserProfile = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsGetUserProfileData, ThrowOnError>): RequestResult<SuperAdminDonationOpsGetUserProfileResponses, SuperAdminDonationOpsGetUserProfileErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminDonationOpsGetUserProfileResponses, SuperAdminDonationOpsGetUserProfileErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/users/{user_id}',
    ...options
});

/**
 * Correct User Birth Date
 *
 * Correct an established DOB with super-admin auth and a durable audit.
 */
export const superAdminDonationOpsCorrectUserBirthDate = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsCorrectUserBirthDateData, ThrowOnError>): RequestResult<SuperAdminDonationOpsCorrectUserBirthDateResponses, SuperAdminDonationOpsCorrectUserBirthDateErrors, ThrowOnError> => (options.client ?? client).patch<SuperAdminDonationOpsCorrectUserBirthDateResponses, SuperAdminDonationOpsCorrectUserBirthDateErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/users/{user_id}/birth-date',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link Company Attested
 *
 * GF-A27: link a user to the ACTIVE company derived from their signup
 * email domain after an operator records external verification evidence.
 */
export const superAdminDonationOpsLinkCompanyAttested = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsLinkCompanyAttestedData, ThrowOnError>): RequestResult<SuperAdminDonationOpsLinkCompanyAttestedResponses, SuperAdminDonationOpsLinkCompanyAttestedErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDonationOpsLinkCompanyAttestedResponses, SuperAdminDonationOpsLinkCompanyAttestedErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/users/{user_id}/company-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List User Donations
 *
 * SAPD-USR1 (h): one page of the user's donations, newest first, each with
 * every match row on it. ``page[limit]`` defaults to 25 and is capped at 100;
 * ``meta.total_items`` is the exact count of the user's donations. 404
 * (``error_code=USER_NOT_FOUND``) when the id names no user.
 */
export const superAdminDonationOpsListUserDonations = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsListUserDonationsData, ThrowOnError>): RequestResult<SuperAdminDonationOpsListUserDonationsResponses, SuperAdminDonationOpsListUserDonationsErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminDonationOpsListUserDonationsResponses, SuperAdminDonationOpsListUserDonationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/users/{user_id}/donations',
    ...options
});

/**
 * Create External Donation On Behalf
 *
 * CDO-BE2 (d): book an external donation on a user's behalf. EXTERNAL,
 * zero fees, moves no money; ``request_match`` registers a pending company
 * match routed to the employer's own approval. No grant assignment is
 * scheduled — an EXTERNAL booking has no charge/grant of its own; the grant
 * is created only when the employer approves the resulting match.
 *
 * CAM-R149: the answer says whether a match request was recorded and, when none was,
 * why (`AdminExternalDonationOut`): while ``COMPANY_MATCH_REQUEST_BUDGET_ENABLED`` is
 * on, nothing left to match records none (CAM-R147). ``Idempotency-Key`` is honoured:
 * a same-key replay answers the first booking, byte for byte.
 */
export const superAdminDonationOpsCreateExternalDonationOnBehalf = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsCreateExternalDonationOnBehalfData, ThrowOnError>): RequestResult<SuperAdminDonationOpsCreateExternalDonationOnBehalfResponses, SuperAdminDonationOpsCreateExternalDonationOnBehalfErrors, ThrowOnError> => (options.client ?? client).post<SuperAdminDonationOpsCreateExternalDonationOnBehalfResponses, SuperAdminDonationOpsCreateExternalDonationOnBehalfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/users/{user_id}/donations/external',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Employer Linkage
 *
 * CDO-BE2 (b)+(c): a user's employer linkage + per-employee match budget.
 */
export const superAdminDonationOpsGetEmployerLinkage = <ThrowOnError extends boolean = false>(options: Options<SuperAdminDonationOpsGetEmployerLinkageData, ThrowOnError>): RequestResult<SuperAdminDonationOpsGetEmployerLinkageResponses, SuperAdminDonationOpsGetEmployerLinkageErrors, ThrowOnError> => (options.client ?? client).get<SuperAdminDonationOpsGetEmployerLinkageResponses, SuperAdminDonationOpsGetEmployerLinkageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/super-admin/users/{user_id}/employer-linkage',
    ...options
});

/**
 * Submit Survey Answer
 */
export const surveysSubmitSurveyAnswer = <ThrowOnError extends boolean = false>(options: Options<SurveysSubmitSurveyAnswerData, ThrowOnError>): RequestResult<SurveysSubmitSurveyAnswerResponses, SurveysSubmitSurveyAnswerErrors, ThrowOnError> => (options.client ?? client).post<SurveysSubmitSurveyAnswerResponses, SurveysSubmitSurveyAnswerErrors, ThrowOnError>({
    url: '/surveys/answer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Charity Recommendations
 */
export const surveysGetCharityRecommendations = <ThrowOnError extends boolean = false>(options?: Options<SurveysGetCharityRecommendationsData, ThrowOnError>): RequestResult<SurveysGetCharityRecommendationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SurveysGetCharityRecommendationsResponses, unknown, ThrowOnError>({ url: '/surveys/charity-recommendations', ...options });

/**
 * Get Saved Recommendations
 */
export const surveysGetSavedRecommendations = <ThrowOnError extends boolean = false>(options?: Options<SurveysGetSavedRecommendationsData, ThrowOnError>): RequestResult<SurveysGetSavedRecommendationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SurveysGetSavedRecommendationsResponses, unknown, ThrowOnError>({ url: '/surveys/saved-recommendations', ...options });

/**
 * Get Current Terms
 */
export const termsGetCurrentTerms = <ThrowOnError extends boolean = false>(options?: Options<TermsGetCurrentTermsData, ThrowOnError>): RequestResult<TermsGetCurrentTermsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TermsGetCurrentTermsResponses, unknown, ThrowOnError>({ url: '/terms/current', ...options });

/**
 * Get Latest Terms
 */
export const termsGetLatestTerms = <ThrowOnError extends boolean = false>(options: Options<TermsGetLatestTermsData, ThrowOnError>): RequestResult<TermsGetLatestTermsResponses, TermsGetLatestTermsErrors, ThrowOnError> => (options.client ?? client).get<TermsGetLatestTermsResponses, TermsGetLatestTermsErrors, ThrowOnError>({ url: '/terms/{document_type}/latest', ...options });

/**
 * Get Terms Version
 */
export const termsGetTermsVersion = <ThrowOnError extends boolean = false>(options: Options<TermsGetTermsVersionData, ThrowOnError>): RequestResult<TermsGetTermsVersionResponses, TermsGetTermsVersionErrors, ThrowOnError> => (options.client ?? client).get<TermsGetTermsVersionResponses, TermsGetTermsVersionErrors, ThrowOnError>({ url: '/terms/{document_type}/{version_number}', ...options });

/**
 * Get Users
 */
export const usersGetUsers = <ThrowOnError extends boolean = false>(options?: Options<UsersGetUsersData, ThrowOnError>): RequestResult<UsersGetUsersResponses, UsersGetUsersErrors, ThrowOnError> => (options?.client ?? client).get<UsersGetUsersResponses, UsersGetUsersErrors, ThrowOnError>({ url: '/users', ...options });

/**
 * Create User
 */
export const usersCreateUser = <ThrowOnError extends boolean = false>(options: Options<UsersCreateUserData, ThrowOnError>): RequestResult<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError> => (options.client ?? client).post<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError>({
    url: '/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Email Available
 */
export const usersCheckEmailAvailable = <ThrowOnError extends boolean = false>(options: Options<UsersCheckEmailAvailableData, ThrowOnError>): RequestResult<UsersCheckEmailAvailableResponses, UsersCheckEmailAvailableErrors, ThrowOnError> => (options.client ?? client).get<UsersCheckEmailAvailableResponses, UsersCheckEmailAvailableErrors, ThrowOnError>({ url: '/users/email_available', ...options });

/**
 * Delete User
 */
export const usersDeleteUser = <ThrowOnError extends boolean = false>(options: Options<UsersDeleteUserData, ThrowOnError>): RequestResult<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError> => (options.client ?? client).delete<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError>({
    url: '/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Me
 */
export const usersGetMe = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMeData, ThrowOnError>): RequestResult<UsersGetMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetMeResponses, unknown, ThrowOnError>({ url: '/users/me', ...options });

/**
 * Update User
 */
export const usersUpdateUser = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserData, ThrowOnError>): RequestResult<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError> => (options.client ?? client).put<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError>({
    url: '/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Ai Giving Limit
 */
export const aiGivingGetMyAiGivingLimit = <ThrowOnError extends boolean = false>(options?: Options<AiGivingGetMyAiGivingLimitData, ThrowOnError>): RequestResult<AiGivingGetMyAiGivingLimitResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AiGivingGetMyAiGivingLimitResponses, unknown, ThrowOnError>({ url: '/users/me/ai-giving-limit', ...options });

/**
 * Set My Ai Giving Limit
 */
export const aiGivingSetMyAiGivingLimit = <ThrowOnError extends boolean = false>(options: Options<AiGivingSetMyAiGivingLimitData, ThrowOnError>): RequestResult<AiGivingSetMyAiGivingLimitResponses, AiGivingSetMyAiGivingLimitErrors, ThrowOnError> => (options.client ?? client).put<AiGivingSetMyAiGivingLimitResponses, AiGivingSetMyAiGivingLimitErrors, ThrowOnError>({
    url: '/users/me/ai-giving-limit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Birthday Gifts
 */
export const birthdayGiftsListBirthdayGifts = <ThrowOnError extends boolean = false>(options?: Options<BirthdayGiftsListBirthdayGiftsData, ThrowOnError>): RequestResult<BirthdayGiftsListBirthdayGiftsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<BirthdayGiftsListBirthdayGiftsResponses, unknown, ThrowOnError>({ url: '/users/me/birthday-gifts', ...options });

/**
 * Create Birthday Gift
 */
export const birthdayGiftsCreateBirthdayGift = <ThrowOnError extends boolean = false>(options: Options<BirthdayGiftsCreateBirthdayGiftData, ThrowOnError>): RequestResult<BirthdayGiftsCreateBirthdayGiftResponses, BirthdayGiftsCreateBirthdayGiftErrors, ThrowOnError> => (options.client ?? client).post<BirthdayGiftsCreateBirthdayGiftResponses, BirthdayGiftsCreateBirthdayGiftErrors, ThrowOnError>({
    url: '/users/me/birthday-gifts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Birthday Gift
 */
export const birthdayGiftsGetBirthdayGift = <ThrowOnError extends boolean = false>(options: Options<BirthdayGiftsGetBirthdayGiftData, ThrowOnError>): RequestResult<BirthdayGiftsGetBirthdayGiftResponses, BirthdayGiftsGetBirthdayGiftErrors, ThrowOnError> => (options.client ?? client).get<BirthdayGiftsGetBirthdayGiftResponses, BirthdayGiftsGetBirthdayGiftErrors, ThrowOnError>({ url: '/users/me/birthday-gifts/{birthday_gift_id}', ...options });

/**
 * Update Birthday Gift
 */
export const birthdayGiftsUpdateBirthdayGift = <ThrowOnError extends boolean = false>(options: Options<BirthdayGiftsUpdateBirthdayGiftData, ThrowOnError>): RequestResult<BirthdayGiftsUpdateBirthdayGiftResponses, BirthdayGiftsUpdateBirthdayGiftErrors, ThrowOnError> => (options.client ?? client).patch<BirthdayGiftsUpdateBirthdayGiftResponses, BirthdayGiftsUpdateBirthdayGiftErrors, ThrowOnError>({
    url: '/users/me/birthday-gifts/{birthday_gift_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Birthday Gift
 */
export const birthdayGiftsCancelBirthdayGift = <ThrowOnError extends boolean = false>(options: Options<BirthdayGiftsCancelBirthdayGiftData, ThrowOnError>): RequestResult<BirthdayGiftsCancelBirthdayGiftResponses, BirthdayGiftsCancelBirthdayGiftErrors, ThrowOnError> => (options.client ?? client).patch<BirthdayGiftsCancelBirthdayGiftResponses, BirthdayGiftsCancelBirthdayGiftErrors, ThrowOnError>({ url: '/users/me/birthday-gifts/{birthday_gift_id}/cancel', ...options });

/**
 * Update Birthday Visibility
 */
export const usersUpdateBirthdayVisibility = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateBirthdayVisibilityData, ThrowOnError>): RequestResult<UsersUpdateBirthdayVisibilityResponses, UsersUpdateBirthdayVisibilityErrors, ThrowOnError> => (options.client ?? client).patch<UsersUpdateBirthdayVisibilityResponses, UsersUpdateBirthdayVisibilityErrors, ThrowOnError>({
    url: '/users/me/birthday-visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Upcoming Birthdays
 */
export const usersGetUpcomingBirthdays = <ThrowOnError extends boolean = false>(options?: Options<UsersGetUpcomingBirthdaysData, ThrowOnError>): RequestResult<UsersGetUpcomingBirthdaysResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetUpcomingBirthdaysResponses, unknown, ThrowOnError>({ url: '/users/me/birthdays', ...options });

/**
 * List Blocked Users
 *
 * The caller's blocked users, paginated, as PUBLIC projections (name/logo —
 * no PII). Logos are hydrated per page through the cached wrapper (one read per
 * distinct user, bounded page), then narrowed via `PublicUserOut` and returned
 * as an ORJSONResponse so FastAPI does not re-coerce PII back through
 * `UserOut` (same posture as the public path of `GET /users`).
 */
export const usersListBlockedUsers = <ThrowOnError extends boolean = false>(options?: Options<UsersListBlockedUsersData, ThrowOnError>): RequestResult<UsersListBlockedUsersResponses, UsersListBlockedUsersErrors, ThrowOnError> => (options?.client ?? client).get<UsersListBlockedUsersResponses, UsersListBlockedUsersErrors, ThrowOnError>({ url: '/users/me/blocks', ...options });

/**
 * Unblock User
 */
export const usersUnblockUser = <ThrowOnError extends boolean = false>(options: Options<UsersUnblockUserData, ThrowOnError>): RequestResult<UsersUnblockUserResponses, UsersUnblockUserErrors, ThrowOnError> => (options.client ?? client).delete<UsersUnblockUserResponses, UsersUnblockUserErrors, ThrowOnError>({ url: '/users/me/blocks/{user_id}', ...options });

/**
 * Block User
 */
export const usersBlockUser = <ThrowOnError extends boolean = false>(options: Options<UsersBlockUserData, ThrowOnError>): RequestResult<UsersBlockUserResponses, UsersBlockUserErrors, ThrowOnError> => (options.client ?? client).post<UsersBlockUserResponses, UsersBlockUserErrors, ThrowOnError>({ url: '/users/me/blocks/{user_id}', ...options });

/**
 * Get My Champion
 *
 * CQ2-BE1: the caller's champion (get-or-create) — the immutable slug + the
 * current live handle. Minting is idempotent; a repeat call returns the same
 * champion.
 */
export const usersGetMyChampion = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMyChampionData, ThrowOnError>): RequestResult<UsersGetMyChampionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetMyChampionResponses, unknown, ThrowOnError>({ url: '/users/me/champion', ...options });

/**
 * Set My Champion Target
 *
 * PV1-BE2 (D-PV-5): set the caller's CURRENT champion target — POLYMORPHIC
 * over charity | cause_etf | collection | fundraiser (ensures the champion is
 * minted). Validates the target exists AND is live/shareable with the SHARED
 * share-ref rules; keeps the wire-frozen `user.championed_charity_id` alias in
 * sync (`= champion_id` for a charity target, NULL otherwise) so old readers
 * never break; stamps `championed_since` only when the target actually
 * changes. Shares ONE retarget rate limit with the legacy champion-surface
 * charity setter above (both funnel into the same service path).
 */
export const usersSetMyChampionTarget = <ThrowOnError extends boolean = false>(options: Options<UsersSetMyChampionTargetData, ThrowOnError>): RequestResult<UsersSetMyChampionTargetResponses, UsersSetMyChampionTargetErrors, ThrowOnError> => (options.client ?? client).put<UsersSetMyChampionTargetResponses, UsersSetMyChampionTargetErrors, ThrowOnError>({
    url: '/users/me/champion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set My Champion Charity
 *
 * CQ2-BE1: set the caller's CURRENT championed charity through the champion
 * surface (ensures the champion is minted). The current target lives on the
 * existing `user.championed_charity_id` column the resolver reads — this route
 * is the NEW champion-surface setter and does NOT replace
 * PUT /users/me/championed_charity (which is frozen + returns UseDetailedOut).
 */
export const usersSetMyChampionCharity = <ThrowOnError extends boolean = false>(options: Options<UsersSetMyChampionCharityData, ThrowOnError>): RequestResult<UsersSetMyChampionCharityResponses, UsersSetMyChampionCharityErrors, ThrowOnError> => (options.client ?? client).put<UsersSetMyChampionCharityResponses, UsersSetMyChampionCharityErrors, ThrowOnError>({
    url: '/users/me/champion/championed_charity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download My Champion Qr
 *
 * CQ2-BE2b: render + download the caller's OWN champion QR in
 * `{format}` ∈ {svg, png, pdf}. All three formats derive from the one
 * hand-built SVG (PNG == SVG == PDF). Gated dark by `CHAMPION_GIVE_HOST_ENABLED`
 * (404 off). The QR encodes the caller's immutable slug on the LITERAL prod give
 * host (`GIVE.GIVMO.IO` in every env — a printed QR must resolve against
 * production; D-CQ-18/20); the design is the caller's saved spec or
 * `DEFAULT_GIVMO_PRESET`. Per-IP rate
 * limit FAILS CLOSED (the inverse of the public resolver) and is enforced BEFORE
 * the expensive render. No client-supplied size param (render-DoS guard).
 */
export const usersDownloadMyChampionQr = <ThrowOnError extends boolean = false>(options: Options<UsersDownloadMyChampionQrData, ThrowOnError>): RequestResult<UsersDownloadMyChampionQrResponses, UsersDownloadMyChampionQrErrors, ThrowOnError> => (options.client ?? client).get<UsersDownloadMyChampionQrResponses, UsersDownloadMyChampionQrErrors, ThrowOnError>({ url: '/users/me/champion/qr.{format}', ...options });

/**
 * Update User Championed Charity
 */
export const usersUpdateUserChampionedCharity = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserChampionedCharityData, ThrowOnError>): RequestResult<UsersUpdateUserChampionedCharityResponses, UsersUpdateUserChampionedCharityErrors, ThrowOnError> => (options.client ?? client).put<UsersUpdateUserChampionedCharityResponses, UsersUpdateUserChampionedCharityErrors, ThrowOnError>({
    url: '/users/me/championed_charity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Championed Charity Donated Amount
 */
export const usersGetUserChampionedCharityDonatedAmount = <ThrowOnError extends boolean = false>(options?: Options<UsersGetUserChampionedCharityDonatedAmountData, ThrowOnError>): RequestResult<UsersGetUserChampionedCharityDonatedAmountResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetUserChampionedCharityDonatedAmountResponses, unknown, ThrowOnError>({ url: '/users/me/championed_charity_donated_amount', ...options });

/**
 * Create Charity Alternative Recommendation
 *
 * Record only; selection/execution of the recommendation is out of scope.
 */
export const charityAlternativesCreateCharityAlternativeRecommendation = <ThrowOnError extends boolean = false>(options: Options<CharityAlternativesCreateCharityAlternativeRecommendationData, ThrowOnError>): RequestResult<CharityAlternativesCreateCharityAlternativeRecommendationResponses, CharityAlternativesCreateCharityAlternativeRecommendationErrors, ThrowOnError> => (options.client ?? client).post<CharityAlternativesCreateCharityAlternativeRecommendationResponses, CharityAlternativesCreateCharityAlternativeRecommendationErrors, ThrowOnError>({
    url: '/users/me/charity-alternatives/{reference_id}/recommendation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Own Charity Collection
 *
 * Owner's own Collection at ANY visibility; 404 if not owned. Mirrors
 * `get_own_fundraiser`.
 */
export const charityCollectionsGetOwnCharityCollection = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsGetOwnCharityCollectionData, ThrowOnError>): RequestResult<CharityCollectionsGetOwnCharityCollectionResponses, CharityCollectionsGetOwnCharityCollectionErrors, ThrowOnError> => (options.client ?? client).get<CharityCollectionsGetOwnCharityCollectionResponses, CharityCollectionsGetOwnCharityCollectionErrors, ThrowOnError>({ url: '/users/me/charity-collections/{collection_id}', ...options });

/**
 * Get Followed Charities
 */
export const followsGetFollowedCharities = <ThrowOnError extends boolean = false>(options?: Options<FollowsGetFollowedCharitiesData, ThrowOnError>): RequestResult<FollowsGetFollowedCharitiesResponses, FollowsGetFollowedCharitiesErrors, ThrowOnError> => (options?.client ?? client).get<FollowsGetFollowedCharitiesResponses, FollowsGetFollowedCharitiesErrors, ThrowOnError>({ url: '/users/me/charity-follows', ...options });

/**
 * Follow Charity
 */
export const followsFollowCharity = <ThrowOnError extends boolean = false>(options: Options<FollowsFollowCharityData, ThrowOnError>): RequestResult<FollowsFollowCharityResponses, FollowsFollowCharityErrors, ThrowOnError> => (options.client ?? client).post<FollowsFollowCharityResponses, FollowsFollowCharityErrors, ThrowOnError>({ url: '/users/me/charity-follows/{charity_id}', ...options });

/**
 * Unfollow Charity
 */
export const followsUnfollowCharity = <ThrowOnError extends boolean = false>(options: Options<FollowsUnfollowCharityData, ThrowOnError>): RequestResult<FollowsUnfollowCharityResponses, FollowsUnfollowCharityErrors, ThrowOnError> => (options.client ?? client).post<FollowsUnfollowCharityResponses, FollowsUnfollowCharityErrors, ThrowOnError>({ url: '/users/me/charity-unfollows/{charity_id}', ...options });

/**
 * Unlink Company
 */
export const usersUnlinkCompany = <ThrowOnError extends boolean = false>(options?: Options<UsersUnlinkCompanyData, ThrowOnError>): RequestResult<UsersUnlinkCompanyResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<UsersUnlinkCompanyResponses, unknown, ThrowOnError>({ url: '/users/me/company', ...options });

/**
 * Get My Company
 */
export const companiesGetMyCompany = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetMyCompanyData, ThrowOnError>): RequestResult<CompaniesGetMyCompanyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetMyCompanyResponses, unknown, ThrowOnError>({ url: '/users/me/company', ...options });

/**
 * Link Company
 */
export const usersLinkCompany = <ThrowOnError extends boolean = false>(options: Options<UsersLinkCompanyData, ThrowOnError>): RequestResult<UsersLinkCompanyResponses, UsersLinkCompanyErrors, ThrowOnError> => (options.client ?? client).post<UsersLinkCompanyResponses, UsersLinkCompanyErrors, ThrowOnError>({
    url: '/users/me/company',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Company Donations
 */
export const donationsGetUserCompanyDonations = <ThrowOnError extends boolean = false>(options?: Options<DonationsGetUserCompanyDonationsData, ThrowOnError>): RequestResult<DonationsGetUserCompanyDonationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DonationsGetUserCompanyDonationsResponses, unknown, ThrowOnError>({ url: '/users/me/company/donations', ...options });

/**
 * List Company Stats Reports
 *
 * List the reports for the requesting admin's company (plan §3.6).
 */
export const donationsListCompanyStatsReports = <ThrowOnError extends boolean = false>(options?: Options<DonationsListCompanyStatsReportsData, ThrowOnError>): RequestResult<DonationsListCompanyStatsReportsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DonationsListCompanyStatsReportsResponses, unknown, ThrowOnError>({ url: '/users/me/company/donations/reports', ...options });

/**
 * Generate Company Stats Report
 */
export const donationsGenerateCompanyStatsReport = <ThrowOnError extends boolean = false>(options: Options<DonationsGenerateCompanyStatsReportData, ThrowOnError>): RequestResult<DonationsGenerateCompanyStatsReportResponses, DonationsGenerateCompanyStatsReportErrors, ThrowOnError> => (options.client ?? client).post<DonationsGenerateCompanyStatsReportResponses, DonationsGenerateCompanyStatsReportErrors, ThrowOnError>({
    url: '/users/me/company/donations/reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Follow Company Employees
 */
export const followsFollowCompanyEmployees = <ThrowOnError extends boolean = false>(options?: Options<FollowsFollowCompanyEmployeesData, ThrowOnError>): RequestResult<FollowsFollowCompanyEmployeesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<FollowsFollowCompanyEmployeesResponses, unknown, ThrowOnError>({ url: '/users/me/company/employees/follow', ...options });

/**
 * Confirm User Email
 */
export const usersConfirmUserEmail = <ThrowOnError extends boolean = false>(options: Options<UsersConfirmUserEmailData, ThrowOnError>): RequestResult<UsersConfirmUserEmailResponses, UsersConfirmUserEmailErrors, ThrowOnError> => (options.client ?? client).post<UsersConfirmUserEmailResponses, UsersConfirmUserEmailErrors, ThrowOnError>({ url: '/users/me/confirm_email', ...options });

/**
 * Get My Connected Apps
 *
 * The caller's ACTIVE linked agent grants (one item per consent grant),
 * ordered by linked_at DESC. Wrapped in the standard ``{"data": [...]}``
 * envelope.
 *
 * Annotated ``-> ConnectedAppsListResponse`` so the Tier-1 contract-diff gate
 * sees this frozen consumer surface in the OpenAPI schema, but returns an
 * ``ORJSONResponse`` built from ``asdict()`` at runtime so the wire bytes stay
 * byte-identical to the golden (mirrors ``get_users -> UserPaginatedResponse``).
 */
export const usersGetMyConnectedApps = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMyConnectedAppsData, ThrowOnError>): RequestResult<UsersGetMyConnectedAppsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetMyConnectedAppsResponses, unknown, ThrowOnError>({ url: '/users/me/connected-apps', ...options });

/**
 * Delete My Connected App
 *
 * Disconnect (family-revoke) one of the caller's grants: every refresh token
 * in the family AND every live access token for that grant's client are revoked
 * so the grant is dead server-side immediately. 404 (not 403) when the grant is
 * unknown or owned by another donor — no grant enumeration. Idempotent on an
 * owned grant → 204.
 */
export const usersDeleteMyConnectedApp = <ThrowOnError extends boolean = false>(options: Options<UsersDeleteMyConnectedAppData, ThrowOnError>): RequestResult<UsersDeleteMyConnectedAppResponses, UsersDeleteMyConnectedAppErrors, ThrowOnError> => (options.client ?? client).delete<UsersDeleteMyConnectedAppResponses, UsersDeleteMyConnectedAppErrors, ThrowOnError>({ url: '/users/me/connected-apps/{grant_id}', ...options });

/**
 * Sync User Facebook Contacts
 */
export const followsSyncUserFacebookContacts = <ThrowOnError extends boolean = false>(options: Options<FollowsSyncUserFacebookContactsData, ThrowOnError>): RequestResult<FollowsSyncUserFacebookContactsResponses, FollowsSyncUserFacebookContactsErrors, ThrowOnError> => (options.client ?? client).post<FollowsSyncUserFacebookContactsResponses, FollowsSyncUserFacebookContactsErrors, ThrowOnError>({
    url: '/users/me/connections/facebook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync User Phone Contacts
 */
export const followsSyncUserPhoneContacts = <ThrowOnError extends boolean = false>(options: Options<FollowsSyncUserPhoneContactsData, ThrowOnError>): RequestResult<FollowsSyncUserPhoneContactsResponses, FollowsSyncUserPhoneContactsErrors, ThrowOnError> => (options.client ?? client).post<FollowsSyncUserPhoneContactsResponses, FollowsSyncUserPhoneContactsErrors, ThrowOnError>({
    url: '/users/me/connections/phone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update User Customer Id
 */
export const usersUpdateUserCustomerId = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserCustomerIdData, ThrowOnError>): RequestResult<UsersUpdateUserCustomerIdResponses, UsersUpdateUserCustomerIdErrors, ThrowOnError> => (options.client ?? client).put<UsersUpdateUserCustomerIdResponses, UsersUpdateUserCustomerIdErrors, ThrowOnError>({
    url: '/users/me/customer_id',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Daf Transfer Intents
 */
export const dafTransfersListDafTransferIntents = <ThrowOnError extends boolean = false>(options?: Options<DafTransfersListDafTransferIntentsData, ThrowOnError>): RequestResult<DafTransfersListDafTransferIntentsResponses, DafTransfersListDafTransferIntentsErrors, ThrowOnError> => (options?.client ?? client).get<DafTransfersListDafTransferIntentsResponses, DafTransfersListDafTransferIntentsErrors, ThrowOnError>({ url: '/users/me/daf-transfers/intents', ...options });

/**
 * Create Daf Transfer Intent
 */
export const dafTransfersCreateDafTransferIntent = <ThrowOnError extends boolean = false>(options: Options<DafTransfersCreateDafTransferIntentData, ThrowOnError>): RequestResult<DafTransfersCreateDafTransferIntentResponses, DafTransfersCreateDafTransferIntentErrors, ThrowOnError> => (options.client ?? client).post<DafTransfersCreateDafTransferIntentResponses, DafTransfersCreateDafTransferIntentErrors, ThrowOnError>({
    url: '/users/me/daf-transfers/intents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Daf Transfer Intent
 */
export const dafTransfersCancelDafTransferIntent = <ThrowOnError extends boolean = false>(options: Options<DafTransfersCancelDafTransferIntentData, ThrowOnError>): RequestResult<DafTransfersCancelDafTransferIntentResponses, DafTransfersCancelDafTransferIntentErrors, ThrowOnError> => (options.client ?? client).delete<DafTransfersCancelDafTransferIntentResponses, DafTransfersCancelDafTransferIntentErrors, ThrowOnError>({ url: '/users/me/daf-transfers/intents/{intent_id}', ...options });

/**
 * Get Daf Transfer Tracker
 */
export const dafTransfersGetDafTransferTracker = <ThrowOnError extends boolean = false>(options: Options<DafTransfersGetDafTransferTrackerData, ThrowOnError>): RequestResult<DafTransfersGetDafTransferTrackerResponses, DafTransfersGetDafTransferTrackerErrors, ThrowOnError> => (options.client ?? client).get<DafTransfersGetDafTransferTrackerResponses, DafTransfersGetDafTransferTrackerErrors, ThrowOnError>({ url: '/users/me/daf-transfers/intents/{intent_id}/tracker', ...options });

/**
 * Register Device Token
 */
export const notificationsRegisterDeviceToken = <ThrowOnError extends boolean = false>(options: Options<NotificationsRegisterDeviceTokenData, ThrowOnError>): RequestResult<NotificationsRegisterDeviceTokenResponses, NotificationsRegisterDeviceTokenErrors, ThrowOnError> => (options.client ?? client).post<NotificationsRegisterDeviceTokenResponses, NotificationsRegisterDeviceTokenErrors, ThrowOnError>({
    url: '/users/me/devices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unregister Device Token
 */
export const notificationsUnregisterDeviceToken = <ThrowOnError extends boolean = false>(options: Options<NotificationsUnregisterDeviceTokenData, ThrowOnError>): RequestResult<NotificationsUnregisterDeviceTokenResponses, NotificationsUnregisterDeviceTokenErrors, ThrowOnError> => (options.client ?? client).delete<NotificationsUnregisterDeviceTokenResponses, NotificationsUnregisterDeviceTokenErrors, ThrowOnError>({ url: '/users/me/devices/{token}', ...options });

/**
 * Get User Donations
 */
export const donationsGetUserDonations = <ThrowOnError extends boolean = false>(options?: Options<DonationsGetUserDonationsData, ThrowOnError>): RequestResult<DonationsGetUserDonationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DonationsGetUserDonationsResponses, unknown, ThrowOnError>({ url: '/users/me/donations', ...options });

/**
 * List User Stats Reports
 *
 * List the requester's own annual reports (plan §3.6). Inherently owner-
 * scoped — only the authenticated user's user-reports are returned.
 */
export const donationsListUserStatsReports = <ThrowOnError extends boolean = false>(options?: Options<DonationsListUserStatsReportsData, ThrowOnError>): RequestResult<DonationsListUserStatsReportsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DonationsListUserStatsReportsResponses, unknown, ThrowOnError>({ url: '/users/me/donations/reports', ...options });

/**
 * Generate User Stats Report
 */
export const donationsGenerateUserStatsReport = <ThrowOnError extends boolean = false>(options: Options<DonationsGenerateUserStatsReportData, ThrowOnError>): RequestResult<DonationsGenerateUserStatsReportResponses, DonationsGenerateUserStatsReportErrors, ThrowOnError> => (options.client ?? client).post<DonationsGenerateUserStatsReportResponses, DonationsGenerateUserStatsReportErrors, ThrowOnError>({
    url: '/users/me/donations/reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Stats Report
 *
 * Stream a completed report's PDF (plan §3.6). 404 unless the requester
 * owns it (or admins the report's company) AND it is COMPLETED — the service
 * collapses all three into a 404 so existence is never revealed. Handles both
 * user and company reports.
 */
export const donationsDownloadStatsReport = <ThrowOnError extends boolean = false>(options: Options<DonationsDownloadStatsReportData, ThrowOnError>): RequestResult<DonationsDownloadStatsReportResponses, DonationsDownloadStatsReportErrors, ThrowOnError> => (options.client ?? client).get<DonationsDownloadStatsReportResponses, DonationsDownloadStatsReportErrors, ThrowOnError>({ url: '/users/me/donations/reports/{report_id}/download', ...options });

/**
 * Get Donation Journey
 *
 * Return the authenticated donor's persisted per-charity journey status.
 */
export const donationsGetDonationJourney = <ThrowOnError extends boolean = false>(options: Options<DonationsGetDonationJourneyData, ThrowOnError>): RequestResult<DonationsGetDonationJourneyResponses, DonationsGetDonationJourneyErrors, ThrowOnError> => (options.client ?? client).get<DonationsGetDonationJourneyResponses, DonationsGetDonationJourneyErrors, ThrowOnError>({ url: '/users/me/donations/{donation_id}/journey', ...options });

/**
 * Send Email Verification
 */
export const usersSendEmailVerification = <ThrowOnError extends boolean = false>(options?: Options<UsersSendEmailVerificationData, ThrowOnError>): RequestResult<UsersSendEmailVerificationResponses, UsersSendEmailVerificationErrors, ThrowOnError> => (options?.client ?? client).post<UsersSendEmailVerificationResponses, UsersSendEmailVerificationErrors, ThrowOnError>({ url: '/users/me/email_verification', ...options });

/**
 * Update User Facebook Id
 */
export const usersUpdateUserFacebookId = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserFacebookIdData, ThrowOnError>): RequestResult<UsersUpdateUserFacebookIdResponses, UsersUpdateUserFacebookIdErrors, ThrowOnError> => (options.client ?? client).put<UsersUpdateUserFacebookIdResponses, UsersUpdateUserFacebookIdErrors, ThrowOnError>({ url: '/users/me/facebook_id', ...options });

/**
 * Get User Follows
 */
export const followsGetUserFollows = <ThrowOnError extends boolean = false>(options?: Options<FollowsGetUserFollowsData, ThrowOnError>): RequestResult<FollowsGetUserFollowsResponses, FollowsGetUserFollowsErrors, ThrowOnError> => (options?.client ?? client).get<FollowsGetUserFollowsResponses, FollowsGetUserFollowsErrors, ThrowOnError>({ url: '/users/me/follows', ...options });

/**
 * Get Follows Posts
 */
export const postsGetFollowsPosts = <ThrowOnError extends boolean = false>(options?: Options<PostsGetFollowsPostsData, ThrowOnError>): RequestResult<PostsGetFollowsPostsResponses, PostsGetFollowsPostsErrors, ThrowOnError> => (options?.client ?? client).get<PostsGetFollowsPostsResponses, PostsGetFollowsPostsErrors, ThrowOnError>({ url: '/users/me/follows/posts', ...options });

/**
 * Follow User
 */
export const followsFollowUser = <ThrowOnError extends boolean = false>(options: Options<FollowsFollowUserData, ThrowOnError>): RequestResult<FollowsFollowUserResponses, FollowsFollowUserErrors, ThrowOnError> => (options.client ?? client).post<FollowsFollowUserResponses, FollowsFollowUserErrors, ThrowOnError>({ url: '/users/me/follows/{followed_user_id}', ...options });

/**
 * Get Fundraiser Invitations
 */
export const fundraisersGetFundraiserInvitations = <ThrowOnError extends boolean = false>(options?: Options<FundraisersGetFundraiserInvitationsData, ThrowOnError>): RequestResult<FundraisersGetFundraiserInvitationsResponses, FundraisersGetFundraiserInvitationsErrors, ThrowOnError> => (options?.client ?? client).get<FundraisersGetFundraiserInvitationsResponses, FundraisersGetFundraiserInvitationsErrors, ThrowOnError>({ url: '/users/me/fundraiser-invitations', ...options });

/**
 * Get Fundraiser Invitation
 */
export const fundraisersGetFundraiserInvitation = <ThrowOnError extends boolean = false>(options: Options<FundraisersGetFundraiserInvitationData, ThrowOnError>): RequestResult<FundraisersGetFundraiserInvitationResponses, FundraisersGetFundraiserInvitationErrors, ThrowOnError> => (options.client ?? client).get<FundraisersGetFundraiserInvitationResponses, FundraisersGetFundraiserInvitationErrors, ThrowOnError>({ url: '/users/me/fundraiser-invitations/{invite_id}', ...options });

/**
 * Get Own Fundraisers
 */
export const fundraisersGetOwnFundraisers = <ThrowOnError extends boolean = false>(options?: Options<FundraisersGetOwnFundraisersData, ThrowOnError>): RequestResult<FundraisersGetOwnFundraisersResponses, FundraisersGetOwnFundraisersErrors, ThrowOnError> => (options?.client ?? client).get<FundraisersGetOwnFundraisersResponses, FundraisersGetOwnFundraisersErrors, ThrowOnError>({ url: '/users/me/fundraisers', ...options });

/**
 * Get Own Fundraiser
 */
export const fundraisersGetOwnFundraiser = <ThrowOnError extends boolean = false>(options: Options<FundraisersGetOwnFundraiserData, ThrowOnError>): RequestResult<FundraisersGetOwnFundraiserResponses, FundraisersGetOwnFundraiserErrors, ThrowOnError> => (options.client ?? client).get<FundraisersGetOwnFundraiserResponses, FundraisersGetOwnFundraiserErrors, ThrowOnError>({ url: '/users/me/fundraisers/{fundraiser_id}', ...options });

/**
 * List Fundraiser Match Offer Requests
 */
export const fundraiserMatchOfferRequestsListFundraiserMatchOfferRequests = <ThrowOnError extends boolean = false>(options: Options<FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsData, ThrowOnError>): RequestResult<FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsResponses, FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsErrors, ThrowOnError> => (options.client ?? client).get<FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsResponses, FundraiserMatchOfferRequestsListFundraiserMatchOfferRequestsErrors, ThrowOnError>({ url: '/users/me/fundraisers/{fundraiser_id}/match-offer-requests', ...options });

/**
 * Accept Match Offer Request
 */
export const fundraiserMatchOfferRequestsAcceptMatchOfferRequest = <ThrowOnError extends boolean = false>(options: Options<FundraiserMatchOfferRequestsAcceptMatchOfferRequestData, ThrowOnError>): RequestResult<FundraiserMatchOfferRequestsAcceptMatchOfferRequestResponses, FundraiserMatchOfferRequestsAcceptMatchOfferRequestErrors, ThrowOnError> => (options.client ?? client).post<FundraiserMatchOfferRequestsAcceptMatchOfferRequestResponses, FundraiserMatchOfferRequestsAcceptMatchOfferRequestErrors, ThrowOnError>({ url: '/users/me/fundraisers/{fundraiser_id}/match-offer-requests/{request_id}/accept', ...options });

/**
 * Decline Match Offer Request
 */
export const fundraiserMatchOfferRequestsDeclineMatchOfferRequest = <ThrowOnError extends boolean = false>(options: Options<FundraiserMatchOfferRequestsDeclineMatchOfferRequestData, ThrowOnError>): RequestResult<FundraiserMatchOfferRequestsDeclineMatchOfferRequestResponses, FundraiserMatchOfferRequestsDeclineMatchOfferRequestErrors, ThrowOnError> => (options.client ?? client).post<FundraiserMatchOfferRequestsDeclineMatchOfferRequestResponses, FundraiserMatchOfferRequestsDeclineMatchOfferRequestErrors, ThrowOnError>({ url: '/users/me/fundraisers/{fundraiser_id}/match-offer-requests/{request_id}/decline', ...options });

/**
 * Create Fundraiser Match Offer
 */
export const fundraiserMatchOfferRequestsCreateFundraiserMatchOffer = <ThrowOnError extends boolean = false>(options: Options<FundraiserMatchOfferRequestsCreateFundraiserMatchOfferData, ThrowOnError>): RequestResult<FundraiserMatchOfferRequestsCreateFundraiserMatchOfferResponses, FundraiserMatchOfferRequestsCreateFundraiserMatchOfferErrors, ThrowOnError> => (options.client ?? client).post<FundraiserMatchOfferRequestsCreateFundraiserMatchOfferResponses, FundraiserMatchOfferRequestsCreateFundraiserMatchOfferErrors, ThrowOnError>({
    url: '/users/me/fundraisers/{fundraiser_id}/match-offers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List My Gift Cards
 *
 * Paginated list of the gift cards the caller ISSUED/sent (GC2-BE3).
 *
 * Consumer (sender-facing) read: shows EVERY gift card the caller issued
 * regardless of funding source — wallet-funded sends AND card-funded
 * purchases both appear (funding is an implementation detail, not a
 * user-visible filter). Scoped server-side to ``purchaser_user_id ==
 * <caller>``; newest-first by default. The response maps each card to
 * ``GiftCardSentOut`` and NEVER carries a plaintext code / ``code_hash`` /
 * the recipient's ``redeemed_by_user_id``.
 */
export const giftCardsListMyGiftCards = <ThrowOnError extends boolean = false>(options?: Options<GiftCardsListMyGiftCardsData, ThrowOnError>): RequestResult<GiftCardsListMyGiftCardsResponses, GiftCardsListMyGiftCardsErrors, ThrowOnError> => (options?.client ?? client).get<GiftCardsListMyGiftCardsResponses, GiftCardsListMyGiftCardsErrors, ThrowOnError>({ url: '/users/me/gift-cards', ...options });

/**
 * List Giving Packet Reports
 *
 * The caller's giving-packet rows (wire contract §2.11): the house
 * paginated envelope of `giving_packet_report` (= StatisticsReportOut with
 * the additive `report_type`), ONLY report_type='giving_packet' rows — the
 * AR list stays annual-scoped, neither leaks into the other.
 */
export const givingPacketListGivingPacketReports = <ThrowOnError extends boolean = false>(options?: Options<GivingPacketListGivingPacketReportsData, ThrowOnError>): RequestResult<GivingPacketListGivingPacketReportsResponses, GivingPacketListGivingPacketReportsErrors, ThrowOnError> => (options?.client ?? client).get<GivingPacketListGivingPacketReportsResponses, GivingPacketListGivingPacketReportsErrors, ThrowOnError>({ url: '/users/me/giving-packet', ...options });

/**
 * Request Giving Packet
 *
 * Request one tax-year Giving Packet (wire contract §2.10): 204, creates
 * the `report_type='giving_packet'` statistics_report row for the calendar
 * year and enqueues the existing report queue (AR-style 24h dedupe per
 * (user, year, TYPE) — an active AR request never blocks a packet, nor the
 * reverse). 400 {40004} outside 2020..current ET year. The worker's packet
 * branch is ER-BE13; until then the worker short-circuits the row.
 */
export const givingPacketRequestGivingPacket = <ThrowOnError extends boolean = false>(options: Options<GivingPacketRequestGivingPacketData, ThrowOnError>): RequestResult<GivingPacketRequestGivingPacketResponses, GivingPacketRequestGivingPacketErrors, ThrowOnError> => (options.client ?? client).post<GivingPacketRequestGivingPacketResponses, GivingPacketRequestGivingPacketErrors, ThrowOnError>({
    url: '/users/me/giving-packet',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Giving Profile
 *
 * CW-BE4: the caller's own giving-profile curation — share flags, module
 * toggles, amount display policy, and the pin/hide/collection selections.
 *
 * GET-OR-DEFAULT: a user who has never saved reads the canonical default-off
 * profile (sharing off, all modules on, bucketed amounts, empty curation), NOT
 * a 404 — so the editor renders identically before and after the first save and
 * the client needs no absent-profile branch.
 */
export const usersGetMyGivingProfile = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMyGivingProfileData, ThrowOnError>): RequestResult<UsersGetMyGivingProfileResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetMyGivingProfileResponses, unknown, ThrowOnError>({ url: '/users/me/giving-profile', ...options });

/**
 * Update My Giving Profile
 *
 * CW-BE4: partial update of the caller's giving profile, returning the
 * stored profile.
 *
 * Only the keys the client SENT are applied (`exclude_unset`), so omitted !=
 * cleared — a client flipping `sharing_enabled` off never disturbs the pins.
 * The owner is `user.id`, router-injected; `extra="forbid"` on the body means
 * nothing server-owned can be spread in, and an unknown `modules` key is a 400
 * rather than a silently-ignored toggle.
 */
export const usersUpdateMyGivingProfile = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateMyGivingProfileData, ThrowOnError>): RequestResult<UsersUpdateMyGivingProfileResponses, UsersUpdateMyGivingProfileErrors, ThrowOnError> => (options.client ?? client).put<UsersUpdateMyGivingProfileResponses, UsersUpdateMyGivingProfileErrors, ThrowOnError>({
    url: '/users/me/giving-profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Graduate User
 *
 * Explicit authenticated age-of-majority terms re-acceptance ceremony.
 */
export const usersGraduateUser = <ThrowOnError extends boolean = false>(options: Options<UsersGraduateUserData, ThrowOnError>): RequestResult<UsersGraduateUserResponses, UsersGraduateUserErrors, ThrowOnError> => (options.client ?? client).post<UsersGraduateUserResponses, UsersGraduateUserErrors, ThrowOnError>({
    url: '/users/me/graduate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List My Group Invitations
 *
 * My pending group invitations (analog `GET /users/me/fundraiser-invitations`).
 */
export const groupsListMyGroupInvitations = <ThrowOnError extends boolean = false>(options?: Options<GroupsListMyGroupInvitationsData, ThrowOnError>): RequestResult<GroupsListMyGroupInvitationsResponses, GroupsListMyGroupInvitationsErrors, ThrowOnError> => (options?.client ?? client).get<GroupsListMyGroupInvitationsResponses, GroupsListMyGroupInvitationsErrors, ThrowOnError>({ url: '/users/me/group-invitations', ...options });

/**
 * List My Groups
 *
 * A single paginated list of the caller's groups INCLUDING DRAFT rows (each
 * with an explicit `status`; never a separate undocumented draft array).
 */
export const groupsListMyGroups = <ThrowOnError extends boolean = false>(options?: Options<GroupsListMyGroupsData, ThrowOnError>): RequestResult<GroupsListMyGroupsResponses, GroupsListMyGroupsErrors, ThrowOnError> => (options?.client ?? client).get<GroupsListMyGroupsResponses, GroupsListMyGroupsErrors, ThrowOnError>({ url: '/users/me/groups', ...options });

/**
 * List Guardian Approvals
 */
export const groupsListGuardianApprovals = <ThrowOnError extends boolean = false>(options?: Options<GroupsListGuardianApprovalsData, ThrowOnError>): RequestResult<GroupsListGuardianApprovalsResponses, GroupsListGuardianApprovalsErrors, ThrowOnError> => (options?.client ?? client).get<GroupsListGuardianApprovalsResponses, GroupsListGuardianApprovalsErrors, ThrowOnError>({ url: '/users/me/guardian/approvals', ...options });

/**
 * Approve Guardian Membership
 */
export const groupsApproveGuardianMembership = <ThrowOnError extends boolean = false>(options: Options<GroupsApproveGuardianMembershipData, ThrowOnError>): RequestResult<GroupsApproveGuardianMembershipResponses, GroupsApproveGuardianMembershipErrors, ThrowOnError> => (options.client ?? client).post<GroupsApproveGuardianMembershipResponses, GroupsApproveGuardianMembershipErrors, ThrowOnError>({ url: '/users/me/guardian/approvals/{approval_id}/approve', ...options });

/**
 * Reject Guardian Membership
 */
export const groupsRejectGuardianMembership = <ThrowOnError extends boolean = false>(options: Options<GroupsRejectGuardianMembershipData, ThrowOnError>): RequestResult<GroupsRejectGuardianMembershipResponses, GroupsRejectGuardianMembershipErrors, ThrowOnError> => (options.client ?? client).post<GroupsRejectGuardianMembershipResponses, GroupsRejectGuardianMembershipErrors, ThrowOnError>({ url: '/users/me/guardian/approvals/{approval_id}/reject', ...options });

/**
 * List Guardian Minors
 */
export const groupsListGuardianMinors = <ThrowOnError extends boolean = false>(options?: Options<GroupsListGuardianMinorsData, ThrowOnError>): RequestResult<GroupsListGuardianMinorsResponses, GroupsListGuardianMinorsErrors, ThrowOnError> => (options?.client ?? client).get<GroupsListGuardianMinorsResponses, GroupsListGuardianMinorsErrors, ThrowOnError>({ url: '/users/me/guardian/minors', ...options });

/**
 * Update Guardian Minor Settings
 */
export const groupsUpdateGuardianMinorSettings = <ThrowOnError extends boolean = false>(options: Options<GroupsUpdateGuardianMinorSettingsData, ThrowOnError>): RequestResult<GroupsUpdateGuardianMinorSettingsResponses, GroupsUpdateGuardianMinorSettingsErrors, ThrowOnError> => (options.client ?? client).patch<GroupsUpdateGuardianMinorSettingsResponses, GroupsUpdateGuardianMinorSettingsErrors, ThrowOnError>({
    url: '/users/me/guardian/minors/{minor_user_id}/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Impact
 *
 * The self-only expanded Impact statistic (Pledges & Impact v2 — PV1-BE4 /
 * 02 §2.1 / 03 §3.4): the three buckets (Donated / Matched / Mobilized), each
 * ALL-time + YTD dollars + gift-event counts, plus the server-summed private
 * headline. Computed by SQL aggregation (never loading donation rows into
 * Python); ``GET /users/me/statistics`` is a SEPARATE, unchanged endpoint for
 * old clients. A brand-new additive endpoint — frozen-client-safe by
 * construction, ships dark (no client calls it yet). An ENGAGEMENT statistic,
 * never a tax/receipt artifact (tax firewall 02 §2.4 / 04 §3).
 */
export const usersGetUserImpact = <ThrowOnError extends boolean = false>(options?: Options<UsersGetUserImpactData, ThrowOnError>): RequestResult<UsersGetUserImpactResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetUserImpactResponses, unknown, ThrowOnError>({ url: '/users/me/impact', ...options });

/**
 * Get User Impact Methodology
 *
 * Versioned, backend-served methodology copy for the Impact statistic ("How
 * is this calculated?", PV1-BE4 / 03 §3.4). Served as a versioned CONSTANT (not
 * a DB registry — display copy, not a legal-consent artifact) so labeling /
 * methodology wording changes ship with a deploy and need NO app release. The
 * copy never implies tax deductibility and is never an "Impact Statement" (tax
 * firewall 02 §2.4 / 04 §3). App-Check-gated but ANONYMOUS-TOLERANT: despite
 * the ``/users/me`` mount, the handler deliberately never checks
 * ``request.state.user`` — the copy is public display text, per-environment
 * not per-user, so there is nothing caller-specific to protect. Do NOT add an
 * auth check (a shipped client fetching it pre-auth must keep working).
 */
export const usersGetUserImpactMethodology = <ThrowOnError extends boolean = false>(options?: Options<UsersGetUserImpactMethodologyData, ThrowOnError>): RequestResult<UsersGetUserImpactMethodologyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetUserImpactMethodologyResponses, unknown, ThrowOnError>({ url: '/users/me/impact/methodology', ...options });

/**
 * List Imported Donations
 *
 * The confirmed-entries timeline feed (wire contract §2.6): the house
 * paginated envelope of §1 ``imported_donation`` rows, newest donation-date
 * first, optional ``filter[tax_year]``.
 */
export const importedReceiptsListImportedDonations = <ThrowOnError extends boolean = false>(options?: Options<ImportedReceiptsListImportedDonationsData, ThrowOnError>): RequestResult<ImportedReceiptsListImportedDonationsResponses, ImportedReceiptsListImportedDonationsErrors, ThrowOnError> => (options?.client ?? client).get<ImportedReceiptsListImportedDonationsResponses, ImportedReceiptsListImportedDonationsErrors, ThrowOnError>({ url: '/users/me/imported-donations', ...options });

/**
 * Export Imported Donations Csv
 *
 * The giving-rows CSV (wire contract §2.9 / plan §1.6): row 1 = the fixed
 * header note, row 2 = the exact column list, then ``source=givmo`` platform
 * rows + ``source=imported`` entries — as stated, RFC-4180, streamed. No
 * totals row, no deductible column, ever. Optional ``filter[tax_year]``
 * scopes the rows and names the file. Declared BEFORE any `{id}` sibling path
 * so `export.csv` can never be captured as a path param (today the only one
 * is the ER-BE9 entry DELETE — a different method).
 */
export const importedReceiptsExportImportedDonationsCsv = <ThrowOnError extends boolean = false>(options?: Options<ImportedReceiptsExportImportedDonationsCsvData, ThrowOnError>): RequestResult<ImportedReceiptsExportImportedDonationsCsvResponses, ImportedReceiptsExportImportedDonationsCsvErrors, ThrowOnError> => (options?.client ?? client).get<ImportedReceiptsExportImportedDonationsCsvResponses, ImportedReceiptsExportImportedDonationsCsvErrors, ThrowOnError>({ url: '/users/me/imported-donations/export.csv', ...options });

/**
 * Delete Imported Donation
 *
 * Delete one confirmed entry (wire contract §2.7): 204. The entry only —
 * its document stays in the vault with ``imported_donation_id`` null again and
 * can be confirmed again.
 */
export const importedReceiptsDeleteImportedDonation = <ThrowOnError extends boolean = false>(options: Options<ImportedReceiptsDeleteImportedDonationData, ThrowOnError>): RequestResult<ImportedReceiptsDeleteImportedDonationResponses, ImportedReceiptsDeleteImportedDonationErrors, ThrowOnError> => (options.client ?? client).delete<ImportedReceiptsDeleteImportedDonationResponses, ImportedReceiptsDeleteImportedDonationErrors, ThrowOnError>({ url: '/users/me/imported-donations/{imported_donation_id}', ...options });

/**
 * List Imported Receipts
 *
 * The caller's vault, newest-first (wire contract §2.3): the house
 * paginated envelope of §1 documents in the LIST projection (no
 * ``document_url``/``derivative_urls`` keys), optional ``filter[status]``.
 * Match display is re-resolved for THIS request (F1b — the Hawaii rail is
 * viewer-conditional and never trusted from the bake).
 */
export const importedReceiptsListImportedReceipts = <ThrowOnError extends boolean = false>(options?: Options<ImportedReceiptsListImportedReceiptsData, ThrowOnError>): RequestResult<ImportedReceiptsListImportedReceiptsResponses, ImportedReceiptsListImportedReceiptsErrors, ThrowOnError> => (options?.client ?? client).get<ImportedReceiptsListImportedReceiptsResponses, ImportedReceiptsListImportedReceiptsErrors, ThrowOnError>({ url: '/users/me/imported-receipts', ...options });

/**
 * Request Imported Receipt Upload Url
 *
 * Mint a short-lived signed PUT into the restricted imported-receipts
 * bucket + the ``awaiting_upload`` document row. The signed URL is bound to
 * the declared content type, carries ``Content-Disposition: attachment``, and
 * bakes the 1..max_bytes ``x-goog-content-length-range`` condition into the
 * signature, so GCS itself refuses an oversize body. Per-user quotas
 * (rolling-24h + vault total) 429 here; the caller's expired orphan mints are
 * lazily GC'd first so they never eat quota.
 */
export const importedReceiptsRequestImportedReceiptUploadUrl = <ThrowOnError extends boolean = false>(options: Options<ImportedReceiptsRequestImportedReceiptUploadUrlData, ThrowOnError>): RequestResult<ImportedReceiptsRequestImportedReceiptUploadUrlResponses, ImportedReceiptsRequestImportedReceiptUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<ImportedReceiptsRequestImportedReceiptUploadUrlResponses, ImportedReceiptsRequestImportedReceiptUploadUrlErrors, ThrowOnError>({
    url: '/users/me/imported-receipts/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Imported Receipt
 *
 * Delete one document (wire contract §2.8): 204. The row, any linked entry
 * (CASCADE), and every stored generation of the original and its page rasters
 * on the versioned bucket (removed after the row's commit, best-effort).
 */
export const importedReceiptsDeleteImportedReceipt = <ThrowOnError extends boolean = false>(options: Options<ImportedReceiptsDeleteImportedReceiptData, ThrowOnError>): RequestResult<ImportedReceiptsDeleteImportedReceiptResponses, ImportedReceiptsDeleteImportedReceiptErrors, ThrowOnError> => (options.client ?? client).delete<ImportedReceiptsDeleteImportedReceiptResponses, ImportedReceiptsDeleteImportedReceiptErrors, ThrowOnError>({ url: '/users/me/imported-receipts/{document_id}', ...options });

/**
 * Get Imported Receipt
 *
 * The owner's document detail (wire contract §2.4): the §1 document WITH
 * the per-request ~15-min signed GETs (``document_url`` +
 * ``derivative_urls``) — minted per request, never persisted, owner-only
 * (another user's id 404s indistinguishably).
 */
export const importedReceiptsGetImportedReceipt = <ThrowOnError extends boolean = false>(options: Options<ImportedReceiptsGetImportedReceiptData, ThrowOnError>): RequestResult<ImportedReceiptsGetImportedReceiptResponses, ImportedReceiptsGetImportedReceiptErrors, ThrowOnError> => (options.client ?? client).get<ImportedReceiptsGetImportedReceiptResponses, ImportedReceiptsGetImportedReceiptErrors, ThrowOnError>({ url: '/users/me/imported-receipts/{document_id}', ...options });

/**
 * Confirm Imported Receipt
 *
 * Confirm the reviewed document into an imported donation (wire contract
 * §2.5): 201 with the entry + non-blocking warnings. The tier is
 * server-computed (a client-sent tier field 400s); the
 * ``RECEIPT_IMPORT_CONFIRM`` impression records in the same UoW (fail-closed
 * 409 40903 without a LIVE disclosure); GCF's own receipt 422s (absorb).
 */
export const importedReceiptsConfirmImportedReceipt = <ThrowOnError extends boolean = false>(options: Options<ImportedReceiptsConfirmImportedReceiptData, ThrowOnError>): RequestResult<ImportedReceiptsConfirmImportedReceiptResponses, ImportedReceiptsConfirmImportedReceiptErrors, ThrowOnError> => (options.client ?? client).post<ImportedReceiptsConfirmImportedReceiptResponses, ImportedReceiptsConfirmImportedReceiptErrors, ThrowOnError>({
    url: '/users/me/imported-receipts/{document_id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register Imported Receipt
 *
 * Register a completed upload on the caller's OWN ``awaiting_upload`` row:
 * blob exists-check, libmagic sniff of the STORED bytes (must be allow-listed
 * AND match the bound type's family), sha256, per-user dedup (409 with the
 * existing document id), signed-PUT-window expiry (410, row GC'd). 202 with
 * the ``registered`` document; the fresh path enqueues the ER-BE6 extraction
 * worker post-commit (the idempotent replay never re-enqueues).
 */
export const importedReceiptsRegisterImportedReceipt = <ThrowOnError extends boolean = false>(options: Options<ImportedReceiptsRegisterImportedReceiptData, ThrowOnError>): RequestResult<ImportedReceiptsRegisterImportedReceiptResponses, ImportedReceiptsRegisterImportedReceiptErrors, ThrowOnError> => (options.client ?? client).post<ImportedReceiptsRegisterImportedReceiptResponses, ImportedReceiptsRegisterImportedReceiptErrors, ThrowOnError>({
    url: '/users/me/imported-receipts/{document_id}/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Own Match Offer Requests
 */
export const fundraiserMatchOfferRequestsListOwnMatchOfferRequests = <ThrowOnError extends boolean = false>(options?: Options<FundraiserMatchOfferRequestsListOwnMatchOfferRequestsData, ThrowOnError>): RequestResult<FundraiserMatchOfferRequestsListOwnMatchOfferRequestsResponses, FundraiserMatchOfferRequestsListOwnMatchOfferRequestsErrors, ThrowOnError> => (options?.client ?? client).get<FundraiserMatchOfferRequestsListOwnMatchOfferRequestsResponses, FundraiserMatchOfferRequestsListOwnMatchOfferRequestsErrors, ThrowOnError>({ url: '/users/me/match-offer-requests', ...options });

/**
 * Withdraw Match Offer Request
 */
export const fundraiserMatchOfferRequestsWithdrawMatchOfferRequest = <ThrowOnError extends boolean = false>(options: Options<FundraiserMatchOfferRequestsWithdrawMatchOfferRequestData, ThrowOnError>): RequestResult<FundraiserMatchOfferRequestsWithdrawMatchOfferRequestResponses, FundraiserMatchOfferRequestsWithdrawMatchOfferRequestErrors, ThrowOnError> => (options.client ?? client).post<FundraiserMatchOfferRequestsWithdrawMatchOfferRequestResponses, FundraiserMatchOfferRequestsWithdrawMatchOfferRequestErrors, ThrowOnError>({ url: '/users/me/match-offer-requests/{request_id}/withdraw', ...options });

/**
 * List My Match Offers
 *
 * The offeror's own offers (03 §2.4), newest-first, all statuses — each item
 * carries its legs (per-leg claimed totals + display consent-status). Domain-
 * scoped, no wallet-history breakout.
 */
export const matchOffersListMyMatchOffers = <ThrowOnError extends boolean = false>(options?: Options<MatchOffersListMyMatchOffersData, ThrowOnError>): RequestResult<MatchOffersListMyMatchOffersResponses, MatchOffersListMyMatchOffersErrors, ThrowOnError> => (options?.client ?? client).get<MatchOffersListMyMatchOffersResponses, MatchOffersListMyMatchOffersErrors, ThrowOnError>({ url: '/users/me/match-offers', ...options });

/**
 * Create Match Offer
 *
 * Create a match offer + its backing HARD wallet-hold reservation (02 §1.2).
 * Atomic: the offer + legs + the ``match_offer`` wallet_hold commit together or
 * not at all. A short ``available_balance`` → 409 ``DEPOSIT_FUNDS_REQUIRED`` with
 * nothing persisted. ``Idempotency-Key`` is REQUIRED (fail-closed 422 if absent).
 */
export const matchOffersCreateMatchOffer = <ThrowOnError extends boolean = false>(options: Options<MatchOffersCreateMatchOfferData, ThrowOnError>): RequestResult<MatchOffersCreateMatchOfferResponses, MatchOffersCreateMatchOfferErrors, ThrowOnError> => (options.client ?? client).post<MatchOffersCreateMatchOfferResponses, MatchOffersCreateMatchOfferErrors, ThrowOnError>({
    url: '/users/me/match-offers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Match Offer
 *
 * One owned offer with per-leg claimed totals + the claims list (03 §2.4).
 * A non-owned/absent id → 404 (non-enumeration).
 */
export const matchOffersGetMyMatchOffer = <ThrowOnError extends boolean = false>(options: Options<MatchOffersGetMyMatchOfferData, ThrowOnError>): RequestResult<MatchOffersGetMyMatchOfferResponses, MatchOffersGetMyMatchOfferErrors, ThrowOnError> => (options.client ?? client).get<MatchOffersGetMyMatchOfferResponses, MatchOffersGetMyMatchOfferErrors, ThrowOnError>({ url: '/users/me/match-offers/{offer_id}', ...options });

/**
 * Cancel Match Offer
 *
 * Cancel a match offer (02 §1.3). Offeror-only. Releases ONLY the unclaimed
 * remainder (claimed amounts stay reserved — irrevocable), sets the offer
 * ``cancelled`` + every leg ``ended``. A non-owned/absent id → 404; an already-
 * exhausted/expired offer → 409. Idempotent (a re-cancel is a no-op).
 */
export const matchOffersCancelMatchOffer = <ThrowOnError extends boolean = false>(options: Options<MatchOffersCancelMatchOfferData, ThrowOnError>): RequestResult<MatchOffersCancelMatchOfferResponses, MatchOffersCancelMatchOfferErrors, ThrowOnError> => (options.client ?? client).post<MatchOffersCancelMatchOfferResponses, MatchOffersCancelMatchOfferErrors, ThrowOnError>({ url: '/users/me/match-offers/{offer_id}/cancel', ...options });

/**
 * Redirect Match Claim
 *
 * Redirect a DECLINED match claim to an alternate eligible charity (PV2-BE8 —
 * the Terms X.3 ask's answer; the D-PV-9 decline/redirect path). Offeror-only
 * (non-owned/absent offer or claim → 404, non-enumeration). The alternate must
 * differ from the declined charity and pass the SAME settlement-time screens;
 * on success the held claim amount is consumed into a wallet-funded grant leg
 * to the alternate and the claim settles with a durable audit trail. A claim
 * not awaiting an alternate → 409 ``CLAIM_NOT_REDIRECTABLE`` (a replay naming
 * the already-granted alternate returns the recorded success); an offer under
 * admin review → 409 ``OFFER_UNDER_ADMIN_REVIEW``. ``Idempotency-Key`` is
 * REQUIRED (fail-closed 422 if absent).
 */
export const matchOffersRedirectMatchClaim = <ThrowOnError extends boolean = false>(options: Options<MatchOffersRedirectMatchClaimData, ThrowOnError>): RequestResult<MatchOffersRedirectMatchClaimResponses, MatchOffersRedirectMatchClaimErrors, ThrowOnError> => (options.client ?? client).post<MatchOffersRedirectMatchClaimResponses, MatchOffersRedirectMatchClaimErrors, ThrowOnError>({
    url: '/users/me/match-offers/{offer_id}/claims/{claim_id}/redirect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Matches
 */
export const donationMatchesGetMyMatches = <ThrowOnError extends boolean = false>(options?: Options<DonationMatchesGetMyMatchesData, ThrowOnError>): RequestResult<DonationMatchesGetMyMatchesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DonationMatchesGetMyMatchesResponses, unknown, ThrowOnError>({ url: '/users/me/matches', ...options });

/**
 * Get My Memberships
 *
 * CAM-BE2: the caller's entity memberships. v1 returns the single
 * company-admin membership as a one-element list, or [] for a non-admin.
 */
export const usersGetMyMemberships = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMyMembershipsData, ThrowOnError>): RequestResult<UsersGetMyMembershipsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetMyMembershipsResponses, unknown, ThrowOnError>({ url: '/users/me/memberships', ...options });

/**
 * Get Notifications
 */
export const notificationsGetNotifications = <ThrowOnError extends boolean = false>(options?: Options<NotificationsGetNotificationsData, ThrowOnError>): RequestResult<NotificationsGetNotificationsResponses, NotificationsGetNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<NotificationsGetNotificationsResponses, NotificationsGetNotificationsErrors, ThrowOnError>({ url: '/users/me/notifications', ...options });

/**
 * Mark All Notifications Read
 */
export const notificationsMarkAllNotificationsRead = <ThrowOnError extends boolean = false>(options?: Options<NotificationsMarkAllNotificationsReadData, ThrowOnError>): RequestResult<NotificationsMarkAllNotificationsReadResponses, unknown, ThrowOnError> => (options?.client ?? client).patch<NotificationsMarkAllNotificationsReadResponses, unknown, ThrowOnError>({ url: '/users/me/notifications/read-all', ...options });

/**
 * Get Unread Count
 */
export const notificationsGetUnreadCount = <ThrowOnError extends boolean = false>(options?: Options<NotificationsGetUnreadCountData, ThrowOnError>): RequestResult<NotificationsGetUnreadCountResponses, unknown, ThrowOnError> => (options?.client ?? client).get<NotificationsGetUnreadCountResponses, unknown, ThrowOnError>({ url: '/users/me/notifications/unread-count', ...options });

/**
 * Mark Notification Read
 */
export const notificationsMarkNotificationRead = <ThrowOnError extends boolean = false>(options: Options<NotificationsMarkNotificationReadData, ThrowOnError>): RequestResult<NotificationsMarkNotificationReadResponses, NotificationsMarkNotificationReadErrors, ThrowOnError> => (options.client ?? client).patch<NotificationsMarkNotificationReadResponses, NotificationsMarkNotificationReadErrors, ThrowOnError>({ url: '/users/me/notifications/{notification_id}/read', ...options });

/**
 * List My Passkeys
 *
 * The caller's registered passkeys.
 *
 * Deliberately omits `credential_id` and `public_key`. Neither is secret, but
 * neither is useful to a client either, and the credential id is the one handle
 * an attacker holding a stolen response would want.
 */
export const passkeysListMyPasskeys = <ThrowOnError extends boolean = false>(options?: Options<PasskeysListMyPasskeysData, ThrowOnError>): RequestResult<PasskeysListMyPasskeysResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PasskeysListMyPasskeysResponses, unknown, ThrowOnError>({ url: '/users/me/passkeys', ...options });

/**
 * Finish Passkey Reauthentication
 *
 * Complete the re-confirmation: a Firebase custom token for the SAME account,
 * carrying `gvm_amr: ["passkey_uv"]` (CBG-SEC2 SEC2-AS).
 *
 * A credential this account does not own fails exactly like an unknown one
 * (`PASSKEY_CEREMONY_FAILED`), and the token is minted for the caller's own
 * identity whatever credential was presented, so this route cannot switch
 * accounts. The client checks the account did not change, calls
 * `signInWithCustomToken`, and re-runs the suite session login.
 */
export const passkeysFinishPasskeyReauthentication = <ThrowOnError extends boolean = false>(options: Options<PasskeysFinishPasskeyReauthenticationData, ThrowOnError>): RequestResult<PasskeysFinishPasskeyReauthenticationResponses, PasskeysFinishPasskeyReauthenticationErrors, ThrowOnError> => (options.client ?? client).post<PasskeysFinishPasskeyReauthenticationResponses, PasskeysFinishPasskeyReauthenticationErrors, ThrowOnError>({
    url: '/users/me/passkeys/reauthentication',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Passkey Reauthentication
 *
 * Begin an account-bound passkey re-confirmation (CBG-SEC2 SEC2-AS).
 *
 * The challenge is bound to the signed-in account and `allowCredentials` lists
 * exactly its passkeys, so the platform offers only those — unlike the signed-out
 * assertion, which offers every account's. `PASSKEY_NONE_REGISTERED` (400) when
 * the account holds none; `COMPANY_SSO_REQUIRED` (400) for an employee under the
 * L4 sign-in lock. Not step-up gated: it IS the re-proof.
 */
export const passkeysStartPasskeyReauthentication = <ThrowOnError extends boolean = false>(options?: Options<PasskeysStartPasskeyReauthenticationData, ThrowOnError>): RequestResult<PasskeysStartPasskeyReauthenticationResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PasskeysStartPasskeyReauthenticationResponses, unknown, ThrowOnError>({ url: '/users/me/passkeys/reauthentication/options', ...options });

/**
 * Finish Passkey Registration
 *
 * Complete registration — verify the attestation and store the credential.
 *
 * Requires user verification: a credential that cannot user-verify could never
 * mint a session on the assertion path, so registering one would hand the user
 * a passkey they believe protects them and which this backend always refuses.
 *
 * AS-BE50: when this sign-in still owes an employer's two-factor confirmation
 * (D-AS-28), the body also carries `custom_token`, the sign-in re-issued for the
 * same account exactly as the bound re-confirmation re-issues it; absent otherwise.
 *
 * The passkey-added email, and the Firebase read that words it (AS-BE62 #14), run
 * AFTER this 201 is sent (`BackgroundTasks`), so a slow Identity Toolkit read never
 * holds the registration's answer.
 */
export const passkeysFinishPasskeyRegistration = <ThrowOnError extends boolean = false>(options: Options<PasskeysFinishPasskeyRegistrationData, ThrowOnError>): RequestResult<PasskeysFinishPasskeyRegistrationResponses, PasskeysFinishPasskeyRegistrationErrors, ThrowOnError> => (options.client ?? client).post<PasskeysFinishPasskeyRegistrationResponses, PasskeysFinishPasskeyRegistrationErrors, ThrowOnError>({
    url: '/users/me/passkeys/registration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Passkey Registration
 *
 * Begin registration — mint a challenge and return the creation options.
 *
 * The `options` payload is py_webauthn's own serialization, passed through
 * verbatim for the client to hand straight to the platform API. Not
 * re-modelled field by field: it is a spec structure we do not own, and any
 * transcription of ours is a chance to corrupt it.
 *
 * Rule 1 of the signing-grade factor rules (CBG-SEC2 SEC2-AS) runs here first: an
 * account that holds a passkey adds another only on a sign-in that confirmed a
 * passkey ≤ 10 minutes ago (`passkey_confirmation_required` otherwise), and an
 * account with none adds its first only ≤ 10 minutes after a sign-in that answered
 * its authenticator if it has one (`step_up_required`, action `add_passkey`,
 * otherwise). SEC2-AS2 H1-C: a phone or employer sign-in adds an account's first
 * passkey only when it is the account's only way to sign in
 * (`first_passkey_other_sign_in_required`, action `add_passkey`, otherwise; its
 * `detail` says to sign in another way).
 */
export const passkeysStartPasskeyRegistration = <ThrowOnError extends boolean = false>(options?: Options<PasskeysStartPasskeyRegistrationData, ThrowOnError>): RequestResult<PasskeysStartPasskeyRegistrationResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PasskeysStartPasskeyRegistrationResponses, unknown, ThrowOnError>({ url: '/users/me/passkeys/registration/options', ...options });

/**
 * Delete My Passkey
 *
 * Remove a passkey.
 *
 * Not gated on keeping at least one: a user who wants a credential gone — a
 * lost laptop, a resold phone — must be able to remove it immediately, and
 * refusing would be lock-in dressed as a safety rail.
 *
 * STEP-UP GATED (AS-BE9), at the SERVICE layer: `PasskeyService.delete_passkey`
 * carries `@require_recent_auth("delete_passkey")` beneath its
 * `@has_self_permission`. Factor removal is on the D-AS-5 set because it is the
 * move an attacker on a live session makes before taking the account, and it is
 * silent — the owner finds out when a key they still have stops working.
 *
 * The gate is DARK until `STEP_UP_AUTH_ENABLED` flips (the decorator is a pure
 * pass-through while the flag is off), so this route's behaviour is unchanged
 * today. Dark is not absent: on the flip, a stale session hitting this route
 * starts receiving a typed `step_up_required` 400 rather than a 204, and a
 * client that treats any non-204 here as a failed delete will report the wrong
 * thing to the user.
 *
 * The LAST passkey (CBG-SEC2 SEC2-AS, rule 2) goes only on a sign-in that
 * confirmed a passkey ≤ 10 minutes ago; otherwise a typed
 * `passkey_confirmation_required` 400 (action `delete_passkey`), whose cure is
 * the re-confirmation below or, for a lost passkey, the 24-hour factor reset.
 */
export const passkeysDeleteMyPasskey = <ThrowOnError extends boolean = false>(options: Options<PasskeysDeleteMyPasskeyData, ThrowOnError>): RequestResult<PasskeysDeleteMyPasskeyResponses, PasskeysDeleteMyPasskeyErrors, ThrowOnError> => (options.client ?? client).delete<PasskeysDeleteMyPasskeyResponses, PasskeysDeleteMyPasskeyErrors, ThrowOnError>({ url: '/users/me/passkeys/{passkey_id}', ...options });

/**
 * Rename My Passkey
 *
 * Relabel a passkey. 404s for an unknown id AND for one belonging to another
 * user — a 403 would confirm the id exists.
 */
export const passkeysRenameMyPasskey = <ThrowOnError extends boolean = false>(options: Options<PasskeysRenameMyPasskeyData, ThrowOnError>): RequestResult<PasskeysRenameMyPasskeyResponses, PasskeysRenameMyPasskeyErrors, ThrowOnError> => (options.client ?? client).patch<PasskeysRenameMyPasskeyResponses, PasskeysRenameMyPasskeyErrors, ThrowOnError>({
    url: '/users/me/passkeys/{passkey_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update User Payment Method
 */
export const usersUpdateUserPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserPaymentMethodData, ThrowOnError>): RequestResult<UsersUpdateUserPaymentMethodResponses, UsersUpdateUserPaymentMethodErrors, ThrowOnError> => (options.client ?? client).put<UsersUpdateUserPaymentMethodResponses, UsersUpdateUserPaymentMethodErrors, ThrowOnError>({
    url: '/users/me/payment_method',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Own Pledges
 *
 * The caller's own pledges (02 §4 "my pledges"), newest-first. Dark behind the
 * flag; authed-only.
 */
export const pledgesListOwnPledges = <ThrowOnError extends boolean = false>(options?: Options<PledgesListOwnPledgesData, ThrowOnError>): RequestResult<PledgesListOwnPledgesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PledgesListOwnPledgesResponses, unknown, ThrowOnError>({ url: '/users/me/pledges', ...options });

/**
 * Choose Pledge Amount
 *
 * Choose what your pledge pays (D-GFU-30), until its charge gate: exactly the
 * amount due (``amount_due_cents``: the locked result times your rate, at most your
 * cap), or a lower amount from $1 up to it. The third choice is the free cancel. The
 * pledge is charged the amount chosen, once, at its gate. Pledgor-only. Outside the
 * window (before the result locks, or at or after ``charge_eligible_at``) → 409
 * ``PLEDGE_CHOICE_WINDOW_CLOSED``; an amount outside the range (or any lower amount
 * when the amount due is $1 or less) → 409 ``PLEDGE_AMOUNT_OUT_OF_RANGE``; a pledge
 * no longer active → 409; a non-owned/absent id → 404. Choosing the same amount again
 * changes nothing. ``Idempotency-Key`` REQUIRED (fail-closed 422).
 */
export const pledgesChoosePledgeAmount = <ThrowOnError extends boolean = false>(options: Options<PledgesChoosePledgeAmountData, ThrowOnError>): RequestResult<PledgesChoosePledgeAmountResponses, PledgesChoosePledgeAmountErrors, ThrowOnError> => (options.client ?? client).post<PledgesChoosePledgeAmountResponses, PledgesChoosePledgeAmountErrors, ThrowOnError>({
    url: '/users/me/pledges/{pledge_id}/amount',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Pledge
 *
 * Cancel a pledge, free pre-charge (02 §4.2.3 "you control it until you're
 * charged"). Pledgor-only. Flips ACTIVE|NEEDS_REVIEW → CANCELLED; a wallet pledge
 * additionally RELEASES its hold. A non-owned/absent id → 404; an
 * already-CHARGED/FAILED/WRITTEN_OFF pledge → 409. Idempotent (a re-cancel is a
 * no-op).
 */
export const pledgesCancelPledge = <ThrowOnError extends boolean = false>(options: Options<PledgesCancelPledgeData, ThrowOnError>): RequestResult<PledgesCancelPledgeResponses, PledgesCancelPledgeErrors, ThrowOnError> => (options.client ?? client).post<PledgesCancelPledgeResponses, PledgesCancelPledgeErrors, ThrowOnError>({ url: '/users/me/pledges/{pledge_id}/cancel', ...options });

/**
 * Object To Pledge
 *
 * Retired (GFU-BE45, D-GFU-30): a pledgor who disagrees with the amount no longer
 * sends it to a review. They pay a lower amount they choose
 * (``POST /users/me/pledges/{pledge_id}/amount``) or cancel
 * (``POST /users/me/pledges/{pledge_id}/cancel``), until their pledge's charge gate.
 * The path stays while the surface is dark and always answers 409
 * ``PLEDGE_OBJECTION_RETIRED``, changing nothing. ``Idempotency-Key`` REQUIRED
 * (fail-closed 422).
 */
export const pledgesObjectToPledge = <ThrowOnError extends boolean = false>(options: Options<PledgesObjectToPledgeData, ThrowOnError>): RequestResult<PledgesObjectToPledgeResponses, PledgesObjectToPledgeErrors, ThrowOnError> => (options.client ?? client).post<PledgesObjectToPledgeResponses, PledgesObjectToPledgeErrors, ThrowOnError>({ url: '/users/me/pledges/{pledge_id}/object', ...options });

/**
 * Get My Posts
 */
export const postsGetMyPosts = <ThrowOnError extends boolean = false>(options?: Options<PostsGetMyPostsData, ThrowOnError>): RequestResult<PostsGetMyPostsResponses, PostsGetMyPostsErrors, ThrowOnError> => (options?.client ?? client).get<PostsGetMyPostsResponses, PostsGetMyPostsErrors, ThrowOnError>({ url: '/users/me/posts', ...options });

/**
 * Update User Preferences
 */
export const usersUpdateUserPreferences = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserPreferencesData, ThrowOnError>): RequestResult<UsersUpdateUserPreferencesResponses, UsersUpdateUserPreferencesErrors, ThrowOnError> => (options.client ?? client).put<UsersUpdateUserPreferencesResponses, UsersUpdateUserPreferencesErrors, ThrowOnError>({
    url: '/users/me/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload User Profile Picture
 */
export const usersUploadUserProfilePicture = <ThrowOnError extends boolean = false>(options: Options<UsersUploadUserProfilePictureData, ThrowOnError>): RequestResult<UsersUploadUserProfilePictureResponses, UsersUploadUserProfilePictureErrors, ThrowOnError> => (options.client ?? client).post<UsersUploadUserProfilePictureResponses, UsersUploadUserProfilePictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/users/me/profile_picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get My Qr Design
 *
 * CQ1-BE1: the caller's saved QR design spec, or DEFAULT_GIVMO_PRESET when
 * none is saved. The response is the spec object only (snake_case) — no
 * created_at/updated_at, so the wire is fully deterministic.
 */
export const usersGetMyQrDesign = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMyQrDesignData, ThrowOnError>): RequestResult<UsersGetMyQrDesignResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetMyQrDesignResponses, unknown, ThrowOnError>({ url: '/users/me/qr-design', ...options });

/**
 * Save My Qr Design
 *
 * CQ1-BE1: upsert the caller's QR design spec (validated by `QrDesignSpec`)
 * and return the stored spec. owner = (user, user.id), router-injected — never
 * spread from the body.
 */
export const usersSaveMyQrDesign = <ThrowOnError extends boolean = false>(options: Options<UsersSaveMyQrDesignData, ThrowOnError>): RequestResult<UsersSaveMyQrDesignResponses, UsersSaveMyQrDesignErrors, ThrowOnError> => (options.client ?? client).post<UsersSaveMyQrDesignResponses, UsersSaveMyQrDesignErrors, ThrowOnError>({
    url: '/users/me/qr-design',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Recurring Donations
 */
export const usersGetMyRecurringDonations = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMyRecurringDonationsData, ThrowOnError>): RequestResult<UsersGetMyRecurringDonationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetMyRecurringDonationsResponses, unknown, ThrowOnError>({ url: '/users/me/recurring-donations', ...options });

/**
 * Update My Recurring Donation
 */
export const usersUpdateMyRecurringDonation = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateMyRecurringDonationData, ThrowOnError>): RequestResult<UsersUpdateMyRecurringDonationResponses, UsersUpdateMyRecurringDonationErrors, ThrowOnError> => (options.client ?? client).patch<UsersUpdateMyRecurringDonationResponses, UsersUpdateMyRecurringDonationErrors, ThrowOnError>({
    url: '/users/me/recurring-donations/{recurring_donation_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate My Recurring Donation
 */
export const usersActivateMyRecurringDonation = <ThrowOnError extends boolean = false>(options: Options<UsersActivateMyRecurringDonationData, ThrowOnError>): RequestResult<UsersActivateMyRecurringDonationResponses, UsersActivateMyRecurringDonationErrors, ThrowOnError> => (options.client ?? client).patch<UsersActivateMyRecurringDonationResponses, UsersActivateMyRecurringDonationErrors, ThrowOnError>({ url: '/users/me/recurring-donations/{recurring_donation_id}/activate', ...options });

/**
 * Cancel My Recurring Donation
 */
export const usersCancelMyRecurringDonation = <ThrowOnError extends boolean = false>(options: Options<UsersCancelMyRecurringDonationData, ThrowOnError>): RequestResult<UsersCancelMyRecurringDonationResponses, UsersCancelMyRecurringDonationErrors, ThrowOnError> => (options.client ?? client).patch<UsersCancelMyRecurringDonationResponses, UsersCancelMyRecurringDonationErrors, ThrowOnError>({ url: '/users/me/recurring-donations/{recurring_donation_id}/cancel', ...options });

/**
 * Get My Security
 *
 * The caller's factor state + per-capability client gating (AS-BE5).
 *
 * Lazily reconciles the Postgres mirror from Firebase before answering, so the
 * state reflects an enrollment the client completed without ever calling sync
 * (or that it completed and then crashed before it could).
 *
 * The response is nested (`mfa`, `capabilities`) rather than flat so P3 can add
 * an `employer_policy` block as a new sibling key. Adding a key is additive for
 * every shipped decoder; promoting a flat field into an object is not.
 */
export const userSecurityGetMySecurity = <ThrowOnError extends boolean = false>(options?: Options<UserSecurityGetMySecurityData, ThrowOnError>): RequestResult<UserSecurityGetMySecurityResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UserSecurityGetMySecurityResponses, unknown, ThrowOnError>({ url: '/users/me/security', ...options });

/**
 * Cancel My Factor Reset
 *
 * Cancel a pending email-verified factor reset (AS-BE7b).
 *
 * The in-app half of the delayed reset's safety design: the request-time
 * security email tells the owner to come here and stop it. Without this the
 * notification could only tell them what was about to happen.
 *
 * Idempotent — cancelling with nothing pending returns the current state rather
 * than an error, so a double tap or a stale screen is not a failure.
 */
export const userSecurityCancelMyFactorReset = <ThrowOnError extends boolean = false>(options?: Options<UserSecurityCancelMyFactorResetData, ThrowOnError>): RequestResult<UserSecurityCancelMyFactorResetResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<UserSecurityCancelMyFactorResetResponses, unknown, ThrowOnError>({ url: '/users/me/security/factor-reset', ...options });

/**
 * Sync My Factors
 *
 * Reconcile this user's factor mirror from Firebase now (AS-BE5).
 *
 * Called by the client right after it enrolls or unenrolls a factor, so the
 * mirror is right within milliseconds rather than at the next read. It cannot
 * change the user's factors — it only updates our record of them — so it is
 * safe to call at will and safe to retry.
 *
 * Returns the same body as `GET /users/me/security`, so a client can enroll →
 * sync → render without a second call.
 */
export const userSecuritySyncMyFactors = <ThrowOnError extends boolean = false>(options?: Options<UserSecuritySyncMyFactorsData, ThrowOnError>): RequestResult<UserSecuritySyncMyFactorsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<UserSecuritySyncMyFactorsResponses, unknown, ThrowOnError>({ url: '/users/me/security/factors/sync', ...options });

/**
 * Mint My Recovery Codes
 *
 * Issue this account's recovery codes, once, at enrollment (AS-BE7a).
 *
 * **This response is the only time the plaintext codes exist.** They are stored
 * hashed and cannot be re-read — a client that loses this response must rotate,
 * not re-fetch. The client is expected to display them with a "I've saved
 * these" gate before leaving the screen.
 *
 * 409 (`MFA_RECOVERY_CODES_ALREADY_ISSUED`) when unused codes already exist: a
 * retried enrollment must never silently invalidate a list the user already
 * wrote down. Use the regenerate route to rotate deliberately.
 */
export const userSecurityMintMyRecoveryCodes = <ThrowOnError extends boolean = false>(options?: Options<UserSecurityMintMyRecoveryCodesData, ThrowOnError>): RequestResult<UserSecurityMintMyRecoveryCodesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<UserSecurityMintMyRecoveryCodesResponses, unknown, ThrowOnError>({ url: '/users/me/security/recovery-codes', ...options });

/**
 * Regenerate My Recovery Codes
 *
 * Replace this account's recovery codes (AS-BE7a).
 *
 * Invalidates every previously-issued code, used or not — which is the point:
 * a user who thinks their list leaked must be able to kill it.
 *
 * STEP-UP GATED (AS-BE9), at the SERVICE layer:
 * `UserSecurityService.regenerate_recovery_codes` carries
 * `@require_recent_auth("regenerate_recovery_codes")`. Recovery codes are a
 * standing bypass of the second factor, so minting a fresh set is exactly as
 * sensitive as removing the factor.
 *
 * The gate is DARK until `STEP_UP_AUTH_ENABLED` flips (the decorator is a pure
 * pass-through while the flag is off), so this route's behaviour is unchanged
 * today — but on the flip a stale session gets a typed `step_up_required` 400
 * here instead of a fresh code list.
 */
export const userSecurityRegenerateMyRecoveryCodes = <ThrowOnError extends boolean = false>(options?: Options<UserSecurityRegenerateMyRecoveryCodesData, ThrowOnError>): RequestResult<UserSecurityRegenerateMyRecoveryCodesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<UserSecurityRegenerateMyRecoveryCodesResponses, unknown, ThrowOnError>({ url: '/users/me/security/recovery-codes/regenerate', ...options });

/**
 * Sign Out Everywhere
 *
 * End every session of the caller's account — THIS one included — and every AI
 * connection and Connect partner link it holds (AS-PWL-2, R9 D-AS-27; D-AS-32; D-AS-37).
 *
 * Every notice the emailed code sends offers it. Open to every session, an emailed-code
 * one included: it is the panic button. `completed`, or `partial` when an AI-connection
 * or partner-link sweep failed (every session still ended; retry is safe); a typed,
 * retryable 503 when the session revoke itself failed and nothing was ended. After a
 * success this session's next request answers 401: signing out IS the intent.
 */
export const userSecuritySignOutEverywhere = <ThrowOnError extends boolean = false>(options?: Options<UserSecuritySignOutEverywhereData, ThrowOnError>): RequestResult<UserSecuritySignOutEverywhereResponses, unknown, ThrowOnError> => (options?.client ?? client).post<UserSecuritySignOutEverywhereResponses, unknown, ThrowOnError>({ url: '/users/me/security/sign-out-everywhere', ...options });

/**
 * Opt In To My Sms Notices
 *
 * Turn on account-security alert texts for this account's number (AS-BE24).
 *
 * The affirmative, unbundled, default-OFF election the §6C extension requires.
 * **It conditions nothing** — 2FA enrollment, account creation and every other
 * flow complete identically whether or not this is ever called — and there is
 * no companion endpoint that makes it mandatory.
 *
 * Takes NO phone number: the number is whatever is on the account, so there is
 * nothing for a caller to supply and nothing to point at a handset that is not
 * theirs.
 *
 * `disclosure_version` must echo the `sms_notices.disclosure.version` the
 * server served, and `surface` must name the consent experience that was
 * rendered. Both land on the consent record, which is the proof of consent
 * Twilio can demand in writing.
 *
 * **409 (`sms_opt_in_disclosure_stale`)** when the echoed version is not the
 * one currently served: the client is holding stale copy, and the cure is to
 * refetch `GET /users/me/security` and re-render the disclosure — never to
 * retry with a value it did not display.
 *
 * **429 (`sms_opt_in_throttled`)** when a confirmation text was already sent to
 * this number inside the last hour. Nothing is recorded in that case: neither
 * the consent nor the send happened, which is the only outcome that does not
 * misreport one of them.
 *
 * Returns the same body as `GET /users/me/security`. **Read the returned
 * `sms_notices` rather than treating 200 as "texts are on"** — an opt-in on a
 * number that is not OTP-verified is recorded honestly and still sends nothing
 * (`number_not_verified`), and a confirmation that could not be sent reports
 * `confirmation_failed`. Only `active` means a security text would arrive.
 */
export const userSecurityOptInToMySmsNotices = <ThrowOnError extends boolean = false>(options: Options<UserSecurityOptInToMySmsNoticesData, ThrowOnError>): RequestResult<UserSecurityOptInToMySmsNoticesResponses, UserSecurityOptInToMySmsNoticesErrors, ThrowOnError> => (options.client ?? client).post<UserSecurityOptInToMySmsNoticesResponses, UserSecurityOptInToMySmsNoticesErrors, ThrowOnError>({
    url: '/users/me/security/sms-notices/opt-in',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Opt Out Of My Sms Notices
 *
 * Turn off account-security alert texts for this account (AS-BE24).
 *
 * **Sends nothing.** The permitted message set is closed at exactly two types
 * by the amended §6C — the opt-in confirmation and the factor-reset alert — so
 * an acknowledgement text would be a third type and would void the
 * determination's holdings. The holder sees the toggle move; that is the
 * confirmation.
 *
 * Takes no body: consent must be withdrawable in one tap on the same surface
 * that took it, and there is nothing to parameterise.
 *
 * Does NOT touch the suppression store. A suppression records what the HANDSET
 * said; this records what the ACCOUNT HOLDER decided. They are different facts
 * with different cures, and conflating them would make a later in-app opt-in
 * look like it had lifted a carrier STOP that only START can lift.
 *
 * Idempotent — withdrawing with nothing on file returns the current state
 * rather than an error.
 */
export const userSecurityOptOutOfMySmsNotices = <ThrowOnError extends boolean = false>(options?: Options<UserSecurityOptOutOfMySmsNoticesData, ThrowOnError>): RequestResult<UserSecurityOptOutOfMySmsNoticesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<UserSecurityOptOutOfMySmsNoticesResponses, unknown, ThrowOnError>({ url: '/users/me/security/sms-notices/opt-out', ...options });

/**
 * Re Enable My Sms Notices
 *
 * Turn security-notice texts back on for this account's current number
 * (AS-BE23).
 *
 * The user-facing half of the suppression design. A STOP — or any reply the
 * inbound handler could not read as HELP, or a permanent delivery failure —
 * suppresses the number immediately and permanently; without this route the
 * only way back would be to change the number.
 *
 * Returns the same body as `GET /users/me/security`, so the client re-renders
 * the security card from one response. Read `sms_notices.status` on the way
 * back rather than assuming success: a re-enable on a number that is not
 * OTP-verified lifts nothing that matters, and the block says so
 * (`number_not_verified`) instead of implying texts will now arrive.
 *
 * Idempotent — re-enabling with nothing suppressed returns the current state
 * rather than an error, and still records the consent. Takes no body: the
 * number is whatever is on the account, so there is nothing for a caller to
 * supply and nothing for one to point at someone else's phone.
 */
export const userSecurityReEnableMySmsNotices = <ThrowOnError extends boolean = false>(options?: Options<UserSecurityReEnableMySmsNoticesData, ThrowOnError>): RequestResult<UserSecurityReEnableMySmsNoticesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<UserSecurityReEnableMySmsNoticesResponses, unknown, ThrowOnError>({ url: '/users/me/security/sms-notices/re-enable', ...options });

/**
 * Confirm My Sso Link
 *
 * Complete the ceremony: bind the asserted identity to this employment.
 *
 * **The explicit confirm of plan §5 AS-BE13** — a separate authenticated act,
 * taken after the browser ceremony returned, by the same person who started it.
 *
 * Takes no subject. The identity being bound comes from the flow row the callback
 * wrote after verifying the assertion; a body-supplied subject would let an
 * authenticated caller bind any identity they could name, which is the auto-link
 * the program forbids with a ceremony wrapped around it.
 *
 * Mints nothing. A link ceremony ends in a database row, never a credential.
 *
 * Two variants, both landing here: an existing employee binds their identity to
 * their current employment, and a new employee's assertion substitutes for the
 * 6-digit work-email code (the link itself still goes through the single
 * post-verification link writer, so `work_email` uniqueness, domain resolution,
 * the grace clock and the invite flip behave exactly as on the OTP path).
 *
 * Read `subject_matches_work_email` on the way back: FALSE is a warning to
 * surface, never a failure (plan §4). A UPN that differs from the mail alias
 * inside the same verified domain is an ordinary Entra configuration, and the
 * subject is the identity either way.
 */
export const userSecurityConfirmMySsoLink = <ThrowOnError extends boolean = false>(options: Options<UserSecurityConfirmMySsoLinkData, ThrowOnError>): RequestResult<UserSecurityConfirmMySsoLinkResponses, UserSecurityConfirmMySsoLinkErrors, ThrowOnError> => (options.client ?? client).post<UserSecurityConfirmMySsoLinkResponses, UserSecurityConfirmMySsoLinkErrors, ThrowOnError>({
    url: '/users/me/security/sso/link/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start My Sso Link
 *
 * Begin the ceremony: returns the URL to open in a system browser.
 *
 * **Step-up gated** (`@require_recent_auth("link_sso_identity")` on the service
 * method), and it is the ceremony's only step-up — deliberately. Step-up grants
 * are single-use AND scoped to one named action, so gating the confirm call under
 * a second action name would demand two separate re-proofs for one user-visible
 * gesture. The confirm step inherits this gate through two things a caller cannot
 * forge: the PKCE verifier that never left this device, and the check that the
 * flow's initiator is the authenticated caller.
 *
 * Takes no company id. An already-linked employee's employer is read from their
 * employment and `work_email` is ignored — a body-supplied company would let a
 * linked employee aim the ceremony at somebody else's identity provider.
 *
 * `work_email` is read ONLY by the new-employee variant, where there is no
 * employment for the employer to come from. It decides which identity provider
 * the browser is sent to and nothing else: it proves nothing and links nothing,
 * and the binding that eventually happens uses the SUBJECT the IdP asserts.
 */
export const userSecurityStartMySsoLink = <ThrowOnError extends boolean = false>(options: Options<UserSecurityStartMySsoLinkData, ThrowOnError>): RequestResult<UserSecurityStartMySsoLinkResponses, UserSecurityStartMySsoLinkErrors, ThrowOnError> => (options.client ?? client).post<UserSecurityStartMySsoLinkResponses, UserSecurityStartMySsoLinkErrors, ThrowOnError>({
    url: '/users/me/security/sso/link/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Share Kit
 *
 * The caller's share kit for a page. The first call may mint the caller's link (the
 * share-ref family's get-or-create).
 */
export const shareKitGetMyShareKit = <ThrowOnError extends boolean = false>(options: Options<ShareKitGetMyShareKitData, ThrowOnError>): RequestResult<ShareKitGetMyShareKitResponses, ShareKitGetMyShareKitErrors, ThrowOnError> => (options.client ?? client).get<ShareKitGetMyShareKitResponses, ShareKitGetMyShareKitErrors, ThrowOnError>({ url: '/users/me/share-kit', ...options });

/**
 * Download My Share Kit Graphics
 *
 * The kit's graphics as one zip: the items the kit shows for the same parameters. Shares
 * the downloads' per-network budget, fail-closed, before any storage read.
 */
export const shareKitDownloadMyShareKitGraphics = <ThrowOnError extends boolean = false>(options: Options<ShareKitDownloadMyShareKitGraphicsData, ThrowOnError>): RequestResult<ShareKitDownloadMyShareKitGraphicsResponses, ShareKitDownloadMyShareKitGraphicsErrors, ThrowOnError> => (options.client ?? client).get<ShareKitDownloadMyShareKitGraphicsResponses, ShareKitDownloadMyShareKitGraphicsErrors, ThrowOnError>({ url: '/users/me/share-kit/graphics.zip', ...options });

/**
 * Render My Share Kit Qr
 *
 * The caller's link as a QR in the organization's saved design (Givmo's preset for a page
 * no organization owns). The render limit runs first: svg per person, png and pdf per
 * network, fail-closed (the org QR's).
 */
export const shareKitRenderMyShareKitQr = <ThrowOnError extends boolean = false>(options: Options<ShareKitRenderMyShareKitQrData, ThrowOnError>): RequestResult<ShareKitRenderMyShareKitQrResponses, ShareKitRenderMyShareKitQrErrors, ThrowOnError> => (options.client ?? client).get<ShareKitRenderMyShareKitQrResponses, ShareKitRenderMyShareKitQrErrors, ThrowOnError>({ url: '/users/me/share-kit/qr', ...options });

/**
 * Mint My Share Ref
 *
 * PV1-BE3: mint (get-or-create) the caller's personal share-ref for an entity
 * (charity / cause_etf / collection / fundraiser). The share/QR sheet calls this
 * to embed the caller's attribution ref in every link/QR they generate — a
 * repeat call for the same entity returns the SAME slug (dedupe). Returns
 * ``{slug, url}`` where ``url`` is the first-party ``go.givmo.io/s/<slug>``
 * (D-PV-4). Validates the entity exists + is shareable server-side.
 */
export const usersMintMyShareRef = <ThrowOnError extends boolean = false>(options: Options<UsersMintMyShareRefData, ThrowOnError>): RequestResult<UsersMintMyShareRefResponses, UsersMintMyShareRefErrors, ThrowOnError> => (options.client ?? client).post<UsersMintMyShareRefResponses, UsersMintMyShareRefErrors, ThrowOnError>({
    url: '/users/me/share-refs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Private Statistics
 */
export const usersGetUserPrivateStatistics = <ThrowOnError extends boolean = false>(options?: Options<UsersGetUserPrivateStatisticsData, ThrowOnError>): RequestResult<UsersGetUserPrivateStatisticsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetUserPrivateStatisticsResponses, unknown, ThrowOnError>({ url: '/users/me/statistics', ...options });

/**
 * Mint Step Up From Reauth
 *
 * Convert a freshly re-authenticated session into a step-up grant.
 *
 * Takes NO PROOF in the body, deliberately. The proof is the caller's OWN ID
 * token: the service re-reads its `auth_time` from the request's assurance and
 * refuses if the session is not actually fresh. Accepting a client-supplied
 * claim here would be a step-up bypass wearing the gate's clothes — the client
 * would simply assert freshness.
 *
 * What the body DOES carry (AS-BE22) is the `action` the grant is for, and the
 * body is optional in both directions — absent entirely, or present with no
 * `action`. That is not laxity: the route shipped taking no body, so a call
 * without one must keep working, and what it mints is an UNSCOPED grant that
 * satisfies no gate. A client that omits the scope therefore gets a refusal at
 * the action it retries, never a grant that opens everything.
 *
 * So the client flow is: hit a gated action → receive `step_up_required` with
 * its `action` → re-authenticate with Firebase (which mints a token with a new
 * `auth_time`) → call this with that token, echoing that same `action` → retry
 * the original action.
 *
 * Returns no token: the grant is server-side state keyed to the user, so there
 * is nothing for a client to hold, replay, or leak.
 */
export const stepUpMintStepUpFromReauth = <ThrowOnError extends boolean = false>(options?: Options<StepUpMintStepUpFromReauthData, ThrowOnError>): RequestResult<StepUpMintStepUpFromReauthResponses, StepUpMintStepUpFromReauthErrors, ThrowOnError> => (options?.client ?? client).post<StepUpMintStepUpFromReauthResponses, StepUpMintStepUpFromReauthErrors, ThrowOnError>({
    url: '/users/me/step-up/reauth',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Unfollow User
 */
export const followsUnfollowUser = <ThrowOnError extends boolean = false>(options: Options<FollowsUnfollowUserData, ThrowOnError>): RequestResult<FollowsUnfollowUserResponses, FollowsUnfollowUserErrors, ThrowOnError> => (options.client ?? client).post<FollowsUnfollowUserResponses, FollowsUnfollowUserErrors, ThrowOnError>({ url: '/users/me/unfollows/{unfollowed_user_id}', ...options });

/**
 * Get User Wallet
 */
export const usersGetUserWallet = <ThrowOnError extends boolean = false>(options?: Options<UsersGetUserWalletData, ThrowOnError>): RequestResult<UsersGetUserWalletResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetUserWalletResponses, unknown, ThrowOnError>({ url: '/users/me/wallet', ...options });

/**
 * Get User Cards
 */
export const usersGetUserCards = <ThrowOnError extends boolean = false>(options?: Options<UsersGetUserCardsData, ThrowOnError>): RequestResult<UsersGetUserCardsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetUserCardsResponses, unknown, ThrowOnError>({ url: '/users/me/wallet/cards', ...options });

/**
 * Create User Card
 */
export const usersCreateUserCard = <ThrowOnError extends boolean = false>(options?: Options<UsersCreateUserCardData, ThrowOnError>): RequestResult<UsersCreateUserCardResponses, UsersCreateUserCardErrors, ThrowOnError> => (options?.client ?? client).post<UsersCreateUserCardResponses, UsersCreateUserCardErrors, ThrowOnError>({
    url: '/users/me/wallet/cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete User Card
 */
export const usersDeleteUserCard = <ThrowOnError extends boolean = false>(options: Options<UsersDeleteUserCardData, ThrowOnError>): RequestResult<UsersDeleteUserCardResponses, UsersDeleteUserCardErrors, ThrowOnError> => (options.client ?? client).delete<UsersDeleteUserCardResponses, UsersDeleteUserCardErrors, ThrowOnError>({ url: '/users/me/wallet/cards/{card_id}', ...options });

/**
 * Deposit Funds
 */
export const usersDepositFunds = <ThrowOnError extends boolean = false>(options: Options<UsersDepositFundsData, ThrowOnError>): RequestResult<UsersDepositFundsResponses, UsersDepositFundsErrors, ThrowOnError> => (options.client ?? client).post<UsersDepositFundsResponses, UsersDepositFundsErrors, ThrowOnError>({
    url: '/users/me/wallet/deposit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Gift Card From Wallet
 *
 * Send a gift card funded from the caller's EXISTING wallet balance
 * (GC2-BE1 / Phase 2). An internal value transfer, NOT a new contribution:
 * the wallet is debited by exactly face (``wallet.withdraw`` through the
 * wallet-hold chokepoint), with NO Shift4 charge, NO fees, and NO tax
 * receipt. Returns the updated wallet (the redeem/deposit precedent —
 * clients refresh their balance from this response). The response NEVER
 * carries the plaintext code, so the idempotent replay of a duplicate
 * purchase_request_id is safe (no double-debit).
 */
export const giftCardsSendGiftCardFromWallet = <ThrowOnError extends boolean = false>(options: Options<GiftCardsSendGiftCardFromWalletData, ThrowOnError>): RequestResult<GiftCardsSendGiftCardFromWalletResponses, GiftCardsSendGiftCardFromWalletErrors, ThrowOnError> => (options.client ?? client).post<GiftCardsSendGiftCardFromWalletResponses, GiftCardsSendGiftCardFromWalletErrors, ThrowOnError>({
    url: '/users/me/wallet/gift-cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Work Email
 */
export const usersVerifyWorkEmail = <ThrowOnError extends boolean = false>(options: Options<UsersVerifyWorkEmailData, ThrowOnError>): RequestResult<UsersVerifyWorkEmailResponses, UsersVerifyWorkEmailErrors, ThrowOnError> => (options.client ?? client).post<UsersVerifyWorkEmailResponses, UsersVerifyWorkEmailErrors, ThrowOnError>({ url: '/users/me/work_email', ...options });

/**
 * Check Phone Available
 */
export const usersCheckPhoneAvailable = <ThrowOnError extends boolean = false>(options: Options<UsersCheckPhoneAvailableData, ThrowOnError>): RequestResult<UsersCheckPhoneAvailableResponses, UsersCheckPhoneAvailableErrors, ThrowOnError> => (options.client ?? client).get<UsersCheckPhoneAvailableResponses, UsersCheckPhoneAvailableErrors, ThrowOnError>({ url: '/users/phone_available', ...options });

/**
 * Check Username Available
 *
 * Username availability under the champion-handle grammar (CQ3-TIE1,
 * D-CQ-27: the username IS the champion handle). OPTIONAL auth: this path is
 * not auth-exempt, so `handler_middleware` sets `request.state.user` for a
 * valid bearer, None for a tokenless request (an invalid token still 401s).
 * The caller, when known, lets the check answer `caller_has_champion` (without
 * minting) and treat their own un-disabled RETIRED handle as available (the
 * rename-back); their own current username reads "already in use".
 */
export const usersCheckUsernameAvailable = <ThrowOnError extends boolean = false>(options: Options<UsersCheckUsernameAvailableData, ThrowOnError>): RequestResult<UsersCheckUsernameAvailableResponses, UsersCheckUsernameAvailableErrors, ThrowOnError> => (options.client ?? client).get<UsersCheckUsernameAvailableResponses, UsersCheckUsernameAvailableErrors, ThrowOnError>({ url: '/users/username_available', ...options });

/**
 * Verify Access
 */
export const usersVerifyAccess = <ThrowOnError extends boolean = false>(options?: Options<UsersVerifyAccessData, ThrowOnError>): RequestResult<UsersVerifyAccessResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersVerifyAccessResponses, unknown, ThrowOnError>({ url: '/users/verify-access', ...options });

/**
 * Check Work Email
 */
export const usersCheckWorkEmail = <ThrowOnError extends boolean = false>(options: Options<UsersCheckWorkEmailData, ThrowOnError>): RequestResult<UsersCheckWorkEmailResponses, UsersCheckWorkEmailErrors, ThrowOnError> => (options.client ?? client).get<UsersCheckWorkEmailResponses, UsersCheckWorkEmailErrors, ThrowOnError>({ url: '/users/work_email_available', ...options });

/**
 * Get User
 */
export const usersGetUser = <ThrowOnError extends boolean = false>(options: Options<UsersGetUserData, ThrowOnError>): RequestResult<UsersGetUserResponses, UsersGetUserErrors, ThrowOnError> => (options.client ?? client).get<UsersGetUserResponses, UsersGetUserErrors, ThrowOnError>({ url: '/users/{user_id}', ...options });

/**
 * Update User By Id
 */
export const usersUpdateUserById = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateUserByIdData, ThrowOnError>): RequestResult<UsersUpdateUserByIdResponses, UsersUpdateUserByIdErrors, ThrowOnError> => (options.client ?? client).put<UsersUpdateUserByIdResponses, UsersUpdateUserByIdErrors, ThrowOnError>({
    url: '/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List User Charity Collections
 *
 * Server-side visibility-filtered list for `user_id`'s Collections — the
 * PUBLIC PROFILE ROW. The repository filters (owner sees all; a non-owner/anon
 * sees PUBLIC + ACTIVE + on-profile only — `show_on_profile == False` is dropped
 * for non-owners per D-CC-6). Token-permissive — a logged-in requester narrows
 * ownership.
 */
export const charityCollectionsListUserCharityCollections = <ThrowOnError extends boolean = false>(options: Options<CharityCollectionsListUserCharityCollectionsData, ThrowOnError>): RequestResult<CharityCollectionsListUserCharityCollectionsResponses, CharityCollectionsListUserCharityCollectionsErrors, ThrowOnError> => (options.client ?? client).get<CharityCollectionsListUserCharityCollectionsResponses, CharityCollectionsListUserCharityCollectionsErrors, ThrowOnError>({ url: '/users/{user_id}/charity-collections', ...options });

/**
 * Get Users Public Posts
 */
export const postsGetUsersPublicPosts = <ThrowOnError extends boolean = false>(options: Options<PostsGetUsersPublicPostsData, ThrowOnError>): RequestResult<PostsGetUsersPublicPostsResponses, PostsGetUsersPublicPostsErrors, ThrowOnError> => (options.client ?? client).get<PostsGetUsersPublicPostsResponses, PostsGetUsersPublicPostsErrors, ThrowOnError>({ url: '/users/{user_id}/posts', ...options });

/**
 * Report User Profile
 *
 * Report a user's page at the ACCOUNT grain (the ``user_profile`` subject type
 * — the one that carries ``impersonation``). Auth required; append-only; a
 * missing or deleted user → 404 with a constant detail.
 */
export const profileReportsReportUserProfile = <ThrowOnError extends boolean = false>(options: Options<ProfileReportsReportUserProfileData, ThrowOnError>): RequestResult<ProfileReportsReportUserProfileResponses, ProfileReportsReportUserProfileErrors, ThrowOnError> => (options.client ?? client).post<ProfileReportsReportUserProfileResponses, ProfileReportsReportUserProfileErrors, ThrowOnError>({
    url: '/users/{user_id}/profile/report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Statistics
 */
export const usersGetUserStatistics = <ThrowOnError extends boolean = false>(options: Options<UsersGetUserStatisticsData, ThrowOnError>): RequestResult<UsersGetUserStatisticsResponses, UsersGetUserStatisticsErrors, ThrowOnError> => (options.client ?? client).get<UsersGetUserStatisticsResponses, UsersGetUserStatisticsErrors, ThrowOnError>({ url: '/users/{user_id}/statistics', ...options });

/**
 * Get Company Cards V2
 */
export const companiesGetCompanyCardsV2 = <ThrowOnError extends boolean = false>(options?: Options<CompaniesGetCompanyCardsV2Data, ThrowOnError>): RequestResult<CompaniesGetCompanyCardsV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<CompaniesGetCompanyCardsV2Responses, unknown, ThrowOnError>({ url: '/v2/admin/company/wallet/cards', ...options });

/**
 * Create Company Card V2
 */
export const companiesCreateCompanyCardV2 = <ThrowOnError extends boolean = false>(options: Options<CompaniesCreateCompanyCardV2Data, ThrowOnError>): RequestResult<CompaniesCreateCompanyCardV2Responses, CompaniesCreateCompanyCardV2Errors, ThrowOnError> => (options.client ?? client).post<CompaniesCreateCompanyCardV2Responses, CompaniesCreateCompanyCardV2Errors, ThrowOnError>({
    url: '/v2/admin/company/wallet/cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User Cards V2
 */
export const usersGetUserCardsV2 = <ThrowOnError extends boolean = false>(options?: Options<UsersGetUserCardsV2Data, ThrowOnError>): RequestResult<UsersGetUserCardsV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetUserCardsV2Responses, unknown, ThrowOnError>({ url: '/v2/users/me/wallet/cards', ...options });

/**
 * Create User Card V2
 */
export const usersCreateUserCardV2 = <ThrowOnError extends boolean = false>(options: Options<UsersCreateUserCardV2Data, ThrowOnError>): RequestResult<UsersCreateUserCardV2Responses, UsersCreateUserCardV2Errors, ThrowOnError> => (options.client ?? client).post<UsersCreateUserCardV2Responses, UsersCreateUserCardV2Errors, ThrowOnError>({
    url: '/v2/users/me/wallet/cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
